import React, { forwardRef, useMemo } from "react";
import styled, { useTheme } from "styled-components";
import FireFilled from "@ant-design/icons/FireFilled";
import Icon, { StyledIcon } from "common/Icons/Icon";
import { v4 as uuidv4 } from "uuid";

export const BTC = (props: any) => (
  <Icon
    {...props}
    viewBox={"0 0 14 18"}
    d={
      "M13.9633 7.23645C14.255 5.34523 12.7716 4.32834 10.7447 3.64981L11.4023 1.08727L9.79719 0.699283L9.15624 3.19414C8.74331 3.09343 8.3197 2.99963 7.89673 2.90598L7.8967 2.90597L7.86971 2.9L8.5153 0.388892L6.91014 0L6.25248 2.56163L6.18231 2.54605C5.85718 2.47385 5.53722 2.4028 5.22696 2.32703L5.22882 2.31891L3.01431 1.78204L2.58701 3.44769C2.58701 3.44769 3.7788 3.71297 3.75372 3.72921C4.40395 3.88711 4.52099 4.30488 4.50149 4.63692L3.75279 7.55587C3.79737 7.5667 3.85497 7.58294 3.91999 7.6073L3.75 7.5667L2.70033 11.6559C2.62045 11.8472 2.41888 12.135 1.96371 12.0259C1.98043 12.0484 0.797003 11.7434 0.797003 11.7434L0 13.5282L2.09004 14.0344C2.31451 14.0892 2.5365 14.1454 2.75619 14.2011L2.75631 14.2012C2.91658 14.2418 3.07563 14.2821 3.23353 14.3213L2.56936 16.9127L4.17358 17.3007L4.83125 14.7382C5.26969 14.8528 5.69513 14.9592 6.11128 15.0603L5.45548 17.612L7.06063 18L7.7248 15.414C10.4632 15.9175 12.5217 15.7145 13.3883 13.3089C14.0869 11.3726 13.354 10.2546 11.9132 9.52649C12.9629 9.29189 13.7525 8.62148 13.9633 7.23645ZM10.2942 12.2334C9.83997 14.0105 6.97659 13.2758 5.66593 12.9396L5.66587 12.9395C5.5478 12.9093 5.44233 12.8822 5.35237 12.8605L6.23483 9.42724C6.34459 9.45389 6.47875 9.48317 6.63075 9.51634C7.98644 9.81217 10.7611 10.4176 10.2942 12.2334ZM6.90299 7.92262C7.99514 8.20585 10.3765 8.82344 10.7911 7.20848C11.2152 5.55669 8.90018 5.05924 7.7694 4.81625C7.64193 4.78886 7.52952 4.76471 7.43776 4.74249L6.6389 7.85543C6.71457 7.87375 6.80343 7.89679 6.90299 7.92262Z"
    }
  />
);

export const ChangeArrowUp = (props: any) => (
  <Icon
    {...props}
    viewBox={"0 0 7 7"}
    d={
      "M6.00009 0.199951H2.0002C1.55837 0.199951 1.2002 0.558123 1.2002 0.999951C1.2002 1.44178 1.55837 1.79995 2.0002 1.79995H4.06882L0.43451 5.43427C0.12209 5.74669 0.12209 6.25322 0.43451 6.56564C0.746929 6.87806 1.25346 6.87806 1.56588 6.56564L5.2002 2.93132V4.99995C5.2002 5.44178 5.55837 5.79995 6.0002 5.79995C6.44202 5.79995 6.8002 5.44178 6.8002 4.99995V1.00039V0.999951C6.8002 0.999151 6.80019 0.998351 6.80019 0.997552C6.79958 0.793615 6.72148 0.589865 6.56588 0.434266C6.48918 0.357565 6.40078 0.299694 6.30642 0.260654C6.2121 0.22154 6.10867 0.199951 6.0002 0.199951H6.00009Z"
    }
  />
);

export const InfinityIcon = (props: any) => (
  <Icon
    {...props}
    viewBox={"0 0 17 17"}
    d={
      "M16.4691 8.50003C16.4692 9.23556 16.2511 9.9546 15.8425 10.5662C15.4339 11.1778 14.853 11.6545 14.1735 11.936C13.494 12.2174 12.7462 12.2911 12.0248 12.1476C11.3034 12.0041 10.6407 11.6498 10.1207 11.1297L10.0988 11.1065L6.1177 6.61077C5.74499 6.24241 5.27164 5.99252 4.75724 5.89256C4.24284 5.79259 3.71036 5.84701 3.22681 6.04897C2.74326 6.25093 2.33026 6.5914 2.03976 7.02754C1.74927 7.46368 1.59427 7.976 1.59427 8.50003C1.59427 9.02405 1.74927 9.53637 2.03976 9.97251C2.33026 10.4087 2.74326 10.7491 3.22681 10.9511C3.71036 11.153 4.24284 11.2075 4.75724 11.1075C5.27164 11.0075 5.74499 10.7576 6.1177 10.3893L6.55099 9.90005C6.62418 9.81741 6.75049 9.8097 6.83319 9.88282L7.33038 10.3224C7.41319 10.3956 7.42091 10.5221 7.34762 10.6049L6.90329 11.1065L6.88137 11.1297C6.36128 11.6498 5.69866 12.0039 4.97731 12.1473C4.25595 12.2908 3.50825 12.2171 2.82876 11.9357C2.14927 11.6542 1.5685 11.1776 1.1599 10.566C0.751295 9.95448 0.533203 9.23551 0.533203 8.50003C0.533203 7.76454 0.751295 7.04558 1.1599 6.43404C1.5685 5.8225 2.14927 5.34586 2.82876 5.06438C3.50825 4.78291 4.25595 4.70924 4.97731 4.8527C5.69866 4.99616 6.36128 5.3503 6.88137 5.87034L6.90329 5.89358L10.8843 10.3893C11.2571 10.7576 11.7304 11.0075 12.2448 11.1075C12.7592 11.2075 13.2917 11.153 13.7752 10.9511C14.2588 10.7491 14.6718 10.4087 14.9623 9.97251C15.2528 9.53637 15.4078 9.02405 15.4078 8.50003C15.4078 7.976 15.2528 7.46368 14.9623 7.02754C14.6718 6.5914 14.2588 6.25093 13.7752 6.04897C13.2917 5.84701 12.7592 5.79259 12.2448 5.89256C11.7304 5.99252 11.2571 6.24241 10.8843 6.61077L10.4511 7.1C10.3779 7.18264 10.2516 7.19035 10.1689 7.11723L9.67166 6.67763C9.58885 6.60441 9.58113 6.47791 9.65443 6.39518L10.0988 5.89358L10.1207 5.87034C10.6407 5.35021 11.3034 4.99599 12.0248 4.85248C12.7462 4.70897 13.494 4.78261 14.1735 5.0641C14.853 5.34558 15.4339 5.82226 15.8425 6.43386C16.2511 7.04545 16.4692 7.76449 16.4691 8.50003Z"
    }
  />
);

export const ChangeArrowDown = (props: any) => (
  <Icon
    {...props}
    viewBox={"0 0 7 7"}
    d={
      "M5.99984 6.80005H1.99995C1.55812 6.80005 1.19995 6.44188 1.19995 6.00005C1.19995 5.55822 1.55812 5.20005 1.99995 5.20005H4.06858L0.434266 1.56573C0.121846 1.25331 0.121846 0.746783 0.434266 0.434363C0.746685 0.121944 1.25322 0.121944 1.56564 0.434363L5.19995 4.06868V2.00005C5.19995 1.55822 5.55812 1.20005 5.99995 1.20005C6.44178 1.20005 6.79995 1.55822 6.79995 2.00005V5.99961V6.00005C6.79995 6.00085 6.79995 6.00165 6.79995 6.00245C6.79934 6.20639 6.72124 6.41013 6.56564 6.56573C6.48894 6.64244 6.40053 6.70031 6.30618 6.73935C6.21185 6.77846 6.10842 6.80005 5.99995 6.80005H5.99984Z"
    }
  />
);

export const Trades = (props: any) => (
  <Icon
    {...props}
    viewBox={"0 0 14 18"}
    d={"M0 3.99L4 0L8 3.99H5V11H3V3.99H0ZM11 7V14.01H14L10 18L6 14.01H9V7H11Z"}
  />
);

export const Bell = (props: any) => (
  <Icon
    {...props}
    viewBox={"0 0 17 20"}
    d={
      "M13 15H4V8.5C4 6 6 4 8.5 4C11 4 13 6 13 8.5V15ZM15 14V8.5C15 5.43 12.86 2.86 10 2.18V1.5C10 1.10218 9.84196 0.720644 9.56066 0.43934C9.27936 0.158035 8.89782 0 8.5 0C8.10218 0 7.72064 0.158035 7.43934 0.43934C7.15804 0.720644 7 1.10218 7 1.5V2.18C4.13 2.86 2 5.43 2 8.5V14L0 16V17H17V16L15 14ZM8.5 20C9.03043 20 9.53914 19.7893 9.91421 19.4142C10.2893 19.0391 10.5 18.5304 10.5 18H6.5C6.5 18.5304 6.71071 19.0391 7.08579 19.4142C7.46086 19.7893 7.96957 20 8.5 20Z"
    }
  />
);

export const Ellipsis = (props: any) => (
  <Icon
    {...props}
    viewBox={"0 0 16 4"}
    d={
      "M12 2C12 1.46957 12.2107 0.96086 12.5858 0.585787C12.9609 0.210714 13.4696 0 14 0C14.5304 0 15.0391 0.210714 15.4142 0.585787C15.7893 0.96086 16 1.46957 16 2C16 2.53043 15.7893 3.03914 15.4142 3.41421C15.0391 3.78929 14.5304 4 14 4C13.4696 4 12.9609 3.78929 12.5858 3.41421C12.2107 3.03914 12 2.53043 12 2ZM6 2C6 1.46957 6.21071 0.96086 6.58579 0.585787C6.96086 0.210714 7.46957 0 8 0C8.53043 0 9.03914 0.210714 9.41421 0.585787C9.78929 0.96086 10 1.46957 10 2C10 2.53043 9.78929 3.03914 9.41421 3.41421C9.03914 3.78929 8.53043 4 8 4C7.46957 4 6.96086 3.78929 6.58579 3.41421C6.21071 3.03914 6 2.53043 6 2ZM0 2C0 1.46957 0.210714 0.96086 0.585786 0.585787C0.960859 0.210714 1.46957 0 2 0C2.53043 0 3.03914 0.210714 3.41421 0.585787C3.78929 0.96086 4 1.46957 4 2C4 2.53043 3.78929 3.03914 3.41421 3.41421C3.03914 3.78929 2.53043 4 2 4C1.46957 4 0.960859 3.78929 0.585786 3.41421C0.210714 3.03914 0 2.53043 0 2Z"
    }
  />
);

export const Close = (props: any) => (
  <Icon
    {...props}
    viewBox={"0 0 14 14"}
    d={
      "M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
    }
  />
);

export const Check = (props: any) => (
  <Icon
    {...props}
    viewBox={"0 0 15 12"}
    d={"M5 9L1.5 5.5L0 7L5 12L15 2L13.5 0.5L5 9Z"}
  />
);

export const WarningSign = (props: any) => (
  <Icon
    {...props}
    viewBox={"0 0 25 24"}
    d={[
      "M9.59843 5L5.5 9.09843V14.9016L9.59843 19H15.4016L19.5 14.9016V9.09843L15.4016 5H9.59843ZM16.23 3H8.77L3.5 8.27V15.73L8.77 21H16.23L21.5 15.73V8.27L16.23 3Z",
      "M12.5 17.3C11.78 17.3 11.2 16.72 11.2 16C11.2 15.28 11.78 14.7 12.5 14.7C13.22 14.7 13.8 15.28 13.8 16C13.8 16.72 13.22 17.3 12.5 17.3ZM13.5 13H11.5V7H13.5V13Z",
    ]}
  />
);

export const AppStore = forwardRef((props, ref: any) => (
  <svg
    {...props}
    width="111"
    height="32"
    viewBox="0 0 111 32"
    stroke="inherit"
    ref={ref}
  >
    <rect
      x="0.5"
      y="0.5"
      width="110"
      height="31"
      rx="3.5"
      stroke="inherit"
      fill="none"
    />
    <g>
      <path
        d="M27.94 8.19C28.3181 7.75428 28.6063 7.24817 28.7882 6.70074C28.9701 6.1533 29.0421 5.57533 29 5C27.8394 5.09369 26.762 5.63956 26 6.52C25.6351 6.94198 25.3586 7.43288 25.1868 7.96364C25.0151 8.49441 24.9516 9.05424 25 9.61C25.5662 9.61472 26.1258 9.4891 26.6356 9.24286C27.1454 8.99662 27.5918 8.63637 27.94 8.19ZM30.46 15.63C30.4667 14.8637 30.6686 14.1118 31.0465 13.4452C31.4244 12.7786 31.966 12.2193 32.62 11.82C32.2073 11.2252 31.6616 10.7348 31.0263 10.3877C30.391 10.0405 29.6835 9.84615 28.96 9.82C27.4 9.66 25.96 10.73 25.13 10.73C24.3 10.73 23.13 9.84 21.83 9.86C20.9802 9.888 20.1521 10.1358 19.4265 10.5792C18.7009 11.0226 18.1026 11.6465 17.69 12.39C15.93 15.45 17.24 20 19 22.47C19.8 23.68 20.8 25.05 22.12 25C23.44 24.95 23.87 24.18 25.4 24.18C26.93 24.18 27.4 25 28.7 24.97C30 24.94 30.92 23.73 31.76 22.52C32.3551 21.6415 32.8199 20.6816 33.14 19.67C32.3475 19.332 31.6714 18.7693 31.1951 18.0513C30.7188 17.3333 30.4633 16.4916 30.46 15.63Z"
        fill="inherit"
        stroke="none"
      />
    </g>
    <path
      d="M44.7529 12L44.2642 10.6123H42.3535L41.8647 12H41L42.8594 6.98242H43.7686L45.6245 12H44.7529ZM44.0522 9.9082L43.5771 8.54102C43.5589 8.48177 43.5327 8.3986 43.4985 8.2915C43.4644 8.18213 43.4302 8.07161 43.396 7.95996C43.3618 7.84603 43.3333 7.75033 43.3105 7.67285C43.2878 7.76628 43.2593 7.87109 43.2251 7.9873C43.1932 8.10124 43.1613 8.20833 43.1294 8.30859C43.0998 8.40885 43.077 8.48633 43.061 8.54102L42.5825 9.9082H44.0522ZM47.0669 12L45.6279 8.21631H46.479L47.2583 10.438C47.3084 10.5793 47.354 10.7319 47.395 10.896C47.436 11.0601 47.4645 11.1979 47.4805 11.3096H47.5078C47.5238 11.1934 47.5545 11.0544 47.6001 10.8926C47.6457 10.7285 47.6924 10.577 47.7402 10.438L48.5195 8.21631H49.3672L47.9282 12H47.0669ZM51.4248 8.14453C51.9033 8.14453 52.2645 8.25049 52.5083 8.4624C52.7544 8.67432 52.8774 9.00472 52.8774 9.45361V12H52.3066L52.1528 11.4634H52.1255C52.0184 11.6001 51.9079 11.7129 51.7939 11.8018C51.68 11.8906 51.5479 11.9567 51.3975 12C51.2493 12.0456 51.0682 12.0684 50.854 12.0684C50.6284 12.0684 50.4268 12.0273 50.249 11.9453C50.0713 11.861 49.9312 11.7334 49.8286 11.5625C49.7261 11.3916 49.6748 11.1751 49.6748 10.9131C49.6748 10.5234 49.8195 10.2306 50.1089 10.0347C50.4006 9.8387 50.8403 9.73047 51.4282 9.70996L52.0845 9.68604V9.48779C52.0845 9.22575 52.0229 9.0389 51.8999 8.92725C51.7791 8.81559 51.6082 8.75977 51.3872 8.75977C51.1981 8.75977 51.0146 8.78711 50.8369 8.8418C50.6592 8.89648 50.486 8.9637 50.3174 9.04346L50.0576 8.47607C50.2422 8.37809 50.4518 8.29834 50.6865 8.23682C50.9235 8.17529 51.1696 8.14453 51.4248 8.14453ZM52.0811 10.1919L51.5923 10.209C51.1912 10.2227 50.9098 10.291 50.748 10.4141C50.5863 10.5371 50.5054 10.7057 50.5054 10.9199C50.5054 11.1068 50.5612 11.2435 50.6729 11.3301C50.7845 11.4144 50.9315 11.4565 51.1138 11.4565C51.3918 11.4565 51.6219 11.3779 51.8042 11.2207C51.9888 11.0612 52.0811 10.8276 52.0811 10.52V10.1919ZM54.8052 8.21631V12H54.002V8.21631H54.8052ZM54.4087 6.76709C54.5317 6.76709 54.6377 6.80013 54.7266 6.86621C54.8177 6.93229 54.8633 7.04622 54.8633 7.20801C54.8633 7.36751 54.8177 7.48145 54.7266 7.5498C54.6377 7.61589 54.5317 7.64893 54.4087 7.64893C54.2811 7.64893 54.1729 7.61589 54.084 7.5498C53.9974 7.48145 53.9541 7.36751 53.9541 7.20801C53.9541 7.04622 53.9974 6.93229 54.084 6.86621C54.1729 6.80013 54.2811 6.76709 54.4087 6.76709ZM56.7637 12H55.957V6.68164H56.7637V12ZM59.3955 8.14453C59.874 8.14453 60.2352 8.25049 60.479 8.4624C60.7251 8.67432 60.8481 9.00472 60.8481 9.45361V12H60.2773L60.1235 11.4634H60.0962C59.9891 11.6001 59.8786 11.7129 59.7646 11.8018C59.6507 11.8906 59.5186 11.9567 59.3682 12C59.2201 12.0456 59.0389 12.0684 58.8247 12.0684C58.5991 12.0684 58.3975 12.0273 58.2197 11.9453C58.042 11.861 57.9019 11.7334 57.7993 11.5625C57.6968 11.3916 57.6455 11.1751 57.6455 10.9131C57.6455 10.5234 57.7902 10.2306 58.0796 10.0347C58.3713 9.8387 58.811 9.73047 59.3989 9.70996L60.0552 9.68604V9.48779C60.0552 9.22575 59.9937 9.0389 59.8706 8.92725C59.7498 8.81559 59.5789 8.75977 59.3579 8.75977C59.1688 8.75977 58.9854 8.78711 58.8076 8.8418C58.6299 8.89648 58.4567 8.9637 58.2881 9.04346L58.0283 8.47607C58.2129 8.37809 58.4225 8.29834 58.6572 8.23682C58.8942 8.17529 59.1403 8.14453 59.3955 8.14453ZM60.0518 10.1919L59.563 10.209C59.1619 10.2227 58.8805 10.291 58.7188 10.4141C58.557 10.5371 58.4761 10.7057 58.4761 10.9199C58.4761 11.1068 58.5319 11.2435 58.6436 11.3301C58.7552 11.4144 58.9022 11.4565 59.0845 11.4565C59.3625 11.4565 59.5926 11.3779 59.7749 11.2207C59.9595 11.0612 60.0518 10.8276 60.0518 10.52V10.1919ZM62.7759 6.68164V7.96338C62.7759 8.11149 62.7713 8.25732 62.7622 8.40088C62.7554 8.54215 62.7485 8.65267 62.7417 8.73242H62.7759C62.8784 8.56836 63.0208 8.4305 63.2031 8.31885C63.3877 8.20492 63.6235 8.14795 63.9106 8.14795C64.3595 8.14795 64.7207 8.31315 64.9941 8.64355C65.2676 8.97168 65.4043 9.45817 65.4043 10.103C65.4043 10.5314 65.3416 10.8914 65.2163 11.1831C65.091 11.4748 64.9144 11.6958 64.6865 11.8462C64.4609 11.9943 64.1955 12.0684 63.8901 12.0684C63.603 12.0684 63.3706 12.016 63.1929 11.9111C63.0174 11.804 62.8796 11.6799 62.7793 11.5386H62.7212L62.5742 12H61.9727V6.68164H62.7759ZM63.6987 8.80078C63.4709 8.80078 63.2897 8.84635 63.1553 8.9375C63.0231 9.02865 62.9274 9.16536 62.8682 9.34766C62.8089 9.52767 62.7782 9.75667 62.7759 10.0347V10.1064C62.7759 10.528 62.842 10.8504 62.9741 11.0737C63.1086 11.297 63.3524 11.4087 63.7056 11.4087C63.9858 11.4087 64.2012 11.2959 64.3516 11.0703C64.502 10.8424 64.5771 10.5166 64.5771 10.0928C64.5771 9.66439 64.502 9.34196 64.3516 9.12549C64.2035 8.90902 63.9858 8.80078 63.6987 8.80078ZM67.1406 12H66.334V6.68164H67.1406V12ZM69.7964 8.14453C70.1336 8.14453 70.423 8.21403 70.6646 8.35303C70.9061 8.49202 71.0918 8.68913 71.2217 8.94434C71.3516 9.19954 71.4165 9.50488 71.4165 9.86035V10.291H68.8906C68.8997 10.6579 68.9977 10.9404 69.1846 11.1387C69.3737 11.3369 69.638 11.436 69.9775 11.436C70.2191 11.436 70.4355 11.4132 70.627 11.3677C70.8206 11.3198 71.02 11.2503 71.2251 11.1592V11.812C71.036 11.9009 70.8434 11.9658 70.6475 12.0068C70.4515 12.0479 70.2168 12.0684 69.9434 12.0684C69.5719 12.0684 69.245 11.9966 68.9624 11.853C68.6821 11.7072 68.4622 11.4907 68.3027 11.2036C68.1455 10.9165 68.0669 10.5599 68.0669 10.1338C68.0669 9.70996 68.1387 9.34993 68.2822 9.05371C68.4258 8.75749 68.6274 8.5319 68.8872 8.37695C69.147 8.22201 69.45 8.14453 69.7964 8.14453ZM69.7964 8.74951C69.5435 8.74951 69.3384 8.83154 69.1812 8.99561C69.0262 9.15967 68.9351 9.40007 68.9077 9.7168H70.6304C70.6281 9.52767 70.5962 9.36019 70.5347 9.21436C70.4754 9.06852 70.3843 8.95459 70.2612 8.87256C70.1405 8.79053 69.9855 8.74951 69.7964 8.74951ZM77.4902 10.0996C77.4902 10.4141 77.4492 10.6932 77.3672 10.937C77.2852 11.1808 77.1655 11.387 77.0083 11.5557C76.8511 11.722 76.6619 11.8496 76.4409 11.9385C76.2199 12.0251 75.9704 12.0684 75.6924 12.0684C75.4326 12.0684 75.1945 12.0251 74.978 11.9385C74.7616 11.8496 74.5736 11.722 74.4141 11.5557C74.2568 11.387 74.1349 11.1808 74.0483 10.937C73.9618 10.6932 73.9185 10.4141 73.9185 10.0996C73.9185 9.68262 73.9902 9.32943 74.1338 9.04004C74.2796 8.74837 74.487 8.5262 74.7559 8.37354C75.0247 8.22087 75.3449 8.14453 75.7163 8.14453C76.0649 8.14453 76.3726 8.22087 76.6392 8.37354C76.9058 8.5262 77.1143 8.74837 77.2646 9.04004C77.415 9.33171 77.4902 9.6849 77.4902 10.0996ZM74.7456 10.0996C74.7456 10.3753 74.7786 10.6112 74.8447 10.8071C74.9131 11.0031 75.0179 11.1535 75.1592 11.2583C75.3005 11.3608 75.4827 11.4121 75.7061 11.4121C75.9294 11.4121 76.1117 11.3608 76.2529 11.2583C76.3942 11.1535 76.4979 11.0031 76.564 10.8071C76.63 10.6112 76.6631 10.3753 76.6631 10.0996C76.6631 9.82389 76.63 9.59033 76.564 9.39893C76.4979 9.20524 76.3942 9.05827 76.2529 8.95801C76.1117 8.85547 75.9282 8.8042 75.7026 8.8042C75.37 8.8042 75.1273 8.91585 74.9746 9.13916C74.8219 9.36247 74.7456 9.68262 74.7456 10.0996ZM80.3853 8.14453C80.8114 8.14453 81.1429 8.25505 81.3799 8.47607C81.6191 8.69482 81.7388 9.04688 81.7388 9.53223V12H80.9355V9.68262C80.9355 9.38867 80.8752 9.16878 80.7544 9.02295C80.6336 8.87484 80.4468 8.80078 80.1938 8.80078C79.827 8.80078 79.5718 8.91357 79.4282 9.13916C79.2869 9.36475 79.2163 9.69173 79.2163 10.1201V12H78.4131V8.21631H79.0386L79.1514 8.729H79.1958C79.2778 8.59684 79.3792 8.48861 79.5 8.4043C79.623 8.31771 79.7598 8.25277 79.9102 8.20947C80.0628 8.16618 80.2212 8.14453 80.3853 8.14453ZM86.0898 11.4189C86.1947 11.4189 86.2983 11.4098 86.4009 11.3916C86.5034 11.3711 86.5968 11.3472 86.6812 11.3198V11.9282C86.5923 11.967 86.4772 12 86.3359 12.0273C86.1947 12.0547 86.0477 12.0684 85.895 12.0684C85.6808 12.0684 85.4883 12.033 85.3174 11.9624C85.1465 11.8895 85.0109 11.7653 84.9106 11.5898C84.8104 11.4144 84.7603 11.1717 84.7603 10.8618V8.82812H84.2441V8.46924L84.7979 8.18555L85.061 7.37549H85.5669V8.21631H86.6504V8.82812H85.5669V10.8516C85.5669 11.043 85.6147 11.1854 85.7104 11.2788C85.8062 11.3722 85.9326 11.4189 86.0898 11.4189ZM88.2534 6.68164V8.01807C88.2534 8.15706 88.2489 8.29264 88.2397 8.4248C88.2329 8.55697 88.2249 8.65951 88.2158 8.73242H88.2603C88.34 8.60026 88.438 8.49202 88.5542 8.40771C88.6704 8.32113 88.8003 8.25618 88.9438 8.21289C89.0897 8.1696 89.2446 8.14795 89.4087 8.14795C89.6981 8.14795 89.9442 8.19694 90.147 8.29492C90.3498 8.39062 90.5047 8.53988 90.6118 8.74268C90.7212 8.94548 90.7759 9.20866 90.7759 9.53223V12H89.9727V9.68262C89.9727 9.38867 89.9123 9.16878 89.7915 9.02295C89.6707 8.87484 89.4839 8.80078 89.231 8.80078C88.9871 8.80078 88.7935 8.85205 88.6499 8.95459C88.5086 9.05485 88.4072 9.2041 88.3457 9.40234C88.2842 9.59831 88.2534 9.83757 88.2534 10.1201V12H87.4502V6.68164H88.2534ZM93.4077 8.14453C93.745 8.14453 94.0343 8.21403 94.2759 8.35303C94.5174 8.49202 94.7031 8.68913 94.833 8.94434C94.9629 9.19954 95.0278 9.50488 95.0278 9.86035V10.291H92.502C92.5111 10.6579 92.609 10.9404 92.7959 11.1387C92.985 11.3369 93.2493 11.436 93.5889 11.436C93.8304 11.436 94.0469 11.4132 94.2383 11.3677C94.432 11.3198 94.6313 11.2503 94.8364 11.1592V11.812C94.6473 11.9009 94.4548 11.9658 94.2588 12.0068C94.0628 12.0479 93.8281 12.0684 93.5547 12.0684C93.1833 12.0684 92.8563 11.9966 92.5737 11.853C92.2935 11.7072 92.0736 11.4907 91.9141 11.2036C91.7568 10.9165 91.6782 10.5599 91.6782 10.1338C91.6782 9.70996 91.75 9.34993 91.8936 9.05371C92.0371 8.75749 92.2388 8.5319 92.4985 8.37695C92.7583 8.22201 93.0614 8.14453 93.4077 8.14453ZM93.4077 8.74951C93.1548 8.74951 92.9497 8.83154 92.7925 8.99561C92.6375 9.15967 92.5464 9.40007 92.519 9.7168H94.2417C94.2394 9.52767 94.2075 9.36019 94.146 9.21436C94.0868 9.06852 93.9956 8.95459 93.8726 8.87256C93.7518 8.79053 93.5968 8.74951 93.4077 8.74951Z"
      fill="inherit"
      stroke="none"
    />
    <path
      d="M46.8975 25L46.1294 22.8193H43.127L42.3589 25H41L43.9219 17.1152H45.3506L48.2671 25H46.8975ZM45.7964 21.7129L45.0498 19.5645C45.0212 19.4714 44.98 19.3407 44.9263 19.1724C44.8726 19.0005 44.8188 18.8268 44.7651 18.6514C44.7114 18.4723 44.6667 18.3219 44.6309 18.2002C44.5951 18.347 44.5503 18.5117 44.4966 18.6943C44.4465 18.8734 44.3963 19.0417 44.3462 19.1992C44.2996 19.3568 44.2638 19.4785 44.2388 19.5645L43.4868 21.7129H45.7964ZM52.2256 18.9414C52.931 18.9414 53.4967 19.1992 53.9229 19.7148C54.3525 20.2305 54.5674 20.9967 54.5674 22.0137C54.5674 22.6868 54.4671 23.2544 54.2666 23.7163C54.0697 24.1746 53.7922 24.522 53.4341 24.7583C53.0796 24.991 52.666 25.1074 52.1934 25.1074C51.8926 25.1074 51.6312 25.068 51.4092 24.9893C51.1872 24.9105 50.9974 24.8084 50.8398 24.6831C50.6823 24.5542 50.5498 24.4146 50.4424 24.2642H50.3672C50.3851 24.4074 50.4012 24.5667 50.4155 24.7422C50.4334 24.9141 50.4424 25.0716 50.4424 25.2148V27.6372H49.1748V19.0542H50.2061L50.3833 19.876H50.4424C50.5534 19.7077 50.6877 19.5519 50.8452 19.4087C51.0063 19.2655 51.1997 19.1527 51.4253 19.0703C51.6545 18.9844 51.9212 18.9414 52.2256 18.9414ZM51.8872 19.9727C51.5399 19.9727 51.2606 20.0425 51.0493 20.1821C50.8416 20.3182 50.6895 20.5241 50.5928 20.7998C50.4997 21.0755 50.4495 21.4211 50.4424 21.8364V22.0137C50.4424 22.4541 50.4871 22.8283 50.5767 23.1362C50.6698 23.4406 50.8219 23.6733 51.0332 23.8345C51.248 23.992 51.5381 24.0708 51.9033 24.0708C52.2113 24.0708 52.4655 23.9867 52.666 23.8184C52.8701 23.6501 53.0223 23.4102 53.1226 23.0986C53.2228 22.7871 53.2729 22.4201 53.2729 21.9976C53.2729 21.3566 53.1584 20.8589 52.9292 20.5044C52.7036 20.1499 52.3563 19.9727 51.8872 19.9727ZM59.0791 18.9414C59.7845 18.9414 60.3503 19.1992 60.7764 19.7148C61.2061 20.2305 61.4209 20.9967 61.4209 22.0137C61.4209 22.6868 61.3206 23.2544 61.1201 23.7163C60.9232 24.1746 60.6457 24.522 60.2876 24.7583C59.9331 24.991 59.5195 25.1074 59.0469 25.1074C58.7461 25.1074 58.4847 25.068 58.2627 24.9893C58.0407 24.9105 57.8509 24.8084 57.6934 24.6831C57.5358 24.5542 57.4033 24.4146 57.2959 24.2642H57.2207C57.2386 24.4074 57.2547 24.5667 57.269 24.7422C57.2869 24.9141 57.2959 25.0716 57.2959 25.2148V27.6372H56.0283V19.0542H57.0596L57.2368 19.876H57.2959C57.4069 19.7077 57.5412 19.5519 57.6987 19.4087C57.8599 19.2655 58.0532 19.1527 58.2788 19.0703C58.508 18.9844 58.7747 18.9414 59.0791 18.9414ZM58.7407 19.9727C58.3934 19.9727 58.1141 20.0425 57.9028 20.1821C57.6951 20.3182 57.543 20.5241 57.4463 20.7998C57.3532 21.0755 57.3031 21.4211 57.2959 21.8364V22.0137C57.2959 22.4541 57.3407 22.8283 57.4302 23.1362C57.5233 23.4406 57.6755 23.6733 57.8867 23.8345C58.1016 23.992 58.3916 24.0708 58.7568 24.0708C59.0648 24.0708 59.319 23.9867 59.5195 23.8184C59.7236 23.6501 59.8758 23.4102 59.9761 23.0986C60.0763 22.7871 60.1265 22.4201 60.1265 21.9976C60.1265 21.3566 60.0119 20.8589 59.7827 20.5044C59.5571 20.1499 59.2098 19.9727 58.7407 19.9727ZM70.4014 22.8623C70.4014 23.3278 70.2868 23.7288 70.0576 24.0654C69.832 24.402 69.5062 24.6598 69.0801 24.8389C68.6576 25.0179 68.1527 25.1074 67.5654 25.1074C67.279 25.1074 67.005 25.0913 66.7437 25.0591C66.4823 25.0269 66.2352 24.9803 66.0024 24.9194C65.7733 24.855 65.5638 24.778 65.374 24.6885V23.4746C65.6927 23.6143 66.049 23.7414 66.4429 23.856C66.8368 23.967 67.2378 24.0225 67.646 24.0225C67.979 24.0225 68.2547 23.9795 68.4731 23.8936C68.6951 23.804 68.8599 23.6787 68.9673 23.5176C69.0747 23.3529 69.1284 23.1613 69.1284 22.9429C69.1284 22.7101 69.0658 22.5132 68.9404 22.3521C68.8151 22.1909 68.6253 22.0441 68.3711 21.9116C68.1204 21.7756 67.8053 21.6305 67.4258 21.4766C67.168 21.3727 66.9209 21.2546 66.6846 21.1221C66.4518 20.9896 66.2441 20.8338 66.0615 20.6548C65.8789 20.4757 65.7339 20.2645 65.6265 20.021C65.5226 19.7739 65.4707 19.4839 65.4707 19.1509C65.4707 18.7069 65.5763 18.3273 65.7876 18.0122C66.0024 17.6971 66.3032 17.4554 66.6899 17.2871C67.0802 17.1188 67.535 17.0347 68.0542 17.0347C68.466 17.0347 68.8527 17.0776 69.2144 17.1636C69.5796 17.2495 69.9377 17.3713 70.2886 17.5288L69.8804 18.5654C69.5581 18.4329 69.2448 18.3273 68.9404 18.2485C68.6396 18.1698 68.3317 18.1304 68.0166 18.1304C67.7445 18.1304 67.5135 18.1715 67.3237 18.2539C67.134 18.3363 66.9889 18.4526 66.8887 18.603C66.792 18.7498 66.7437 18.9253 66.7437 19.1294C66.7437 19.3586 66.7992 19.5519 66.9102 19.7095C67.0247 19.8634 67.2002 20.0049 67.4365 20.1338C67.6764 20.2627 67.9844 20.4059 68.3604 20.5635C68.7936 20.7425 69.1606 20.9305 69.4614 21.1274C69.7658 21.3244 69.9985 21.5607 70.1597 21.8364C70.3208 22.1086 70.4014 22.4505 70.4014 22.8623ZM74 24.0869C74.1647 24.0869 74.3276 24.0726 74.4888 24.0439C74.6499 24.0117 74.7967 23.9741 74.9292 23.9312V24.8872C74.7896 24.9481 74.6087 25 74.3867 25.043C74.1647 25.0859 73.9338 25.1074 73.6938 25.1074C73.3573 25.1074 73.0547 25.0519 72.7861 24.9409C72.5176 24.8263 72.3045 24.6312 72.147 24.3555C71.9894 24.0798 71.9106 23.6984 71.9106 23.2114V20.0156H71.0996V19.4517L71.9697 19.0059L72.3833 17.7329H73.1782V19.0542H74.8809V20.0156H73.1782V23.1953C73.1782 23.4961 73.2534 23.7199 73.4038 23.8667C73.5542 24.0135 73.7529 24.0869 74 24.0869ZM81.4014 22.0137C81.4014 22.5078 81.3369 22.9465 81.208 23.3296C81.0791 23.7127 80.8911 24.0368 80.644 24.3018C80.397 24.5632 80.0998 24.7637 79.7524 24.9033C79.4051 25.0394 79.013 25.1074 78.5762 25.1074C78.168 25.1074 77.7938 25.0394 77.4536 24.9033C77.1134 24.7637 76.818 24.5632 76.5674 24.3018C76.3203 24.0368 76.1287 23.7127 75.9927 23.3296C75.8566 22.9465 75.7886 22.5078 75.7886 22.0137C75.7886 21.3584 75.9014 20.8034 76.127 20.3486C76.3561 19.8903 76.682 19.5412 77.1045 19.3013C77.527 19.0614 78.0301 18.9414 78.6138 18.9414C79.1616 18.9414 79.645 19.0614 80.064 19.3013C80.4829 19.5412 80.8105 19.8903 81.0469 20.3486C81.2832 20.807 81.4014 21.362 81.4014 22.0137ZM77.0884 22.0137C77.0884 22.4469 77.1403 22.8175 77.2441 23.1255C77.3516 23.4334 77.5163 23.6698 77.7383 23.8345C77.9603 23.9956 78.2467 24.0762 78.5977 24.0762C78.9486 24.0762 79.235 23.9956 79.457 23.8345C79.679 23.6698 79.842 23.4334 79.9458 23.1255C80.0496 22.8175 80.1016 22.4469 80.1016 22.0137C80.1016 21.5804 80.0496 21.2134 79.9458 20.9126C79.842 20.6082 79.679 20.3773 79.457 20.2197C79.235 20.0586 78.9468 19.978 78.5923 19.978C78.0695 19.978 77.6882 20.1535 77.4482 20.5044C77.2083 20.8553 77.0884 21.3584 77.0884 22.0137ZM85.8647 18.9414C85.965 18.9414 86.0742 18.9468 86.1924 18.9575C86.3105 18.9683 86.4126 18.9826 86.4985 19.0005L86.3804 20.1821C86.3052 20.1606 86.2121 20.1445 86.1011 20.1338C85.9937 20.123 85.897 20.1177 85.811 20.1177C85.5854 20.1177 85.3706 20.1553 85.1665 20.2305C84.9624 20.3021 84.7816 20.4131 84.624 20.5635C84.4665 20.7103 84.3429 20.8947 84.2534 21.1167C84.1639 21.3387 84.1191 21.5965 84.1191 21.8901V25H82.8516V19.0542H83.8398L84.0117 20.1016H84.0708C84.189 19.8903 84.3358 19.6969 84.5112 19.5215C84.6867 19.346 84.8872 19.2064 85.1128 19.1025C85.342 18.9951 85.5926 18.9414 85.8647 18.9414ZM89.9683 18.9414C90.4982 18.9414 90.953 19.0506 91.3325 19.269C91.7121 19.4875 92.0039 19.7972 92.208 20.1982C92.4121 20.5993 92.5142 21.0791 92.5142 21.6377V22.3145H88.5449C88.5592 22.891 88.7132 23.335 89.0068 23.6465C89.304 23.958 89.7194 24.1138 90.2529 24.1138C90.6325 24.1138 90.9727 24.078 91.2734 24.0063C91.5778 23.9312 91.8911 23.8219 92.2134 23.6787V24.7046C91.9162 24.8442 91.6136 24.9463 91.3057 25.0107C90.9977 25.0752 90.6289 25.1074 90.1992 25.1074C89.6156 25.1074 89.1017 24.9946 88.6577 24.769C88.2173 24.5399 87.8717 24.1997 87.6211 23.7485C87.374 23.2974 87.2505 22.737 87.2505 22.0674C87.2505 21.4014 87.3633 20.8356 87.5889 20.3701C87.8145 19.9046 88.1313 19.5501 88.5396 19.3066C88.9478 19.0632 89.424 18.9414 89.9683 18.9414ZM89.9683 19.8921C89.5708 19.8921 89.2485 20.021 89.0015 20.2788C88.758 20.5366 88.6147 20.9144 88.5718 21.4121H91.2788C91.2752 21.1149 91.2251 20.8517 91.1284 20.6226C91.0353 20.3934 90.8921 20.2144 90.6987 20.0854C90.509 19.9565 90.2655 19.8921 89.9683 19.8921Z"
      fill="inherit"
      stroke="none"
    />
  </svg>
));

export const GooglePlay = forwardRef((props, ref: any) => (
  <svg
    {...props}
    width="111"
    height="32"
    viewBox="0 0 111 32"
    stroke="inherit"
    ref={ref}
  >
    <rect
      x="0.5"
      y="0.5"
      width="110"
      height="31"
      rx="3.5"
      stroke="inherit"
      fill="none"
    />
    <g>
      <path
        d="M16 8.50847L23.7817 15.6928L27.3965 12.356L18.7348 7.25565C17.615 6.5954 16.2387 7.28534 16 8.50847Z"
        fill="#34A853"
        stroke="none"
      />
      <path
        d="M31.7349 18.1407C32.9663 17.4163 32.9663 15.603 31.7349 14.8774L28.5357 12.9941L24.7262 16.5091L28.5345 20.0241L31.7337 18.1407H31.7349Z"
        fill="#FBBC04"
        stroke="none"
      />
      <path
        d="M16 22.8196V10.0029L22.9421 16.4119L16 22.8196Z"
        fill="#4285F4"
        stroke="none"
      />
      <path
        d="M27.3965 20.613L23.7818 17.2761L16.0001 24.4605C16.2388 25.6824 17.6151 26.3723 18.7349 25.7133L27.3965 20.613Z"
        fill="#EA4335"
        stroke="none"
      />
    </g>
    <path
      d="M43.0046 9.0174C42.9566 8.8666 42.8919 8.73153 42.8107 8.61222C42.7312 8.49124 42.6359 8.38849 42.5249 8.30398C42.4138 8.2178 42.2871 8.15234 42.1445 8.1076C42.0037 8.06286 41.8487 8.04048 41.6797 8.04048C41.393 8.04048 41.1345 8.11423 40.9041 8.26172C40.6738 8.40921 40.4915 8.62547 40.3572 8.91051C40.2247 9.19389 40.1584 9.54107 40.1584 9.95206C40.1584 10.3647 40.2255 10.7135 40.3597 10.9986C40.494 11.2836 40.6779 11.4999 40.9116 11.6474C41.1452 11.7949 41.4112 11.8686 41.7095 11.8686C41.9863 11.8686 42.2274 11.8123 42.4329 11.6996C42.64 11.5869 42.8 11.4278 42.9126 11.2223C43.027 11.0152 43.0842 10.7715 43.0842 10.4915L43.283 10.5288H41.8263V9.89489H43.8274V10.4741C43.8274 10.9016 43.7363 11.2728 43.554 11.5877C43.3733 11.9009 43.1231 12.1429 42.8033 12.3136C42.4851 12.4843 42.1205 12.5696 41.7095 12.5696C41.2488 12.5696 40.8445 12.4635 40.4964 12.2514C40.1501 12.0393 39.88 11.7385 39.6861 11.3491C39.4922 10.958 39.3952 10.494 39.3952 9.95703C39.3952 9.55102 39.4516 9.18643 39.5643 8.86328C39.677 8.54013 39.8352 8.26586 40.0391 8.04048C40.2446 7.81345 40.4857 7.64027 40.7624 7.52095C41.0408 7.39998 41.3449 7.33949 41.6747 7.33949C41.9498 7.33949 42.2058 7.38009 42.4428 7.46129C42.6815 7.5425 42.8936 7.65767 43.0792 7.80682C43.2665 7.95597 43.4214 8.13329 43.544 8.33878C43.6667 8.54261 43.7495 8.76882 43.7926 9.0174H43.0046ZM44.8025 12.5V7.40909H47.9942V8.07031H45.5706V9.62145H47.8277V10.2802H45.5706V11.8388H48.0241V12.5H44.8025ZM48.7692 8.07031V7.40909H52.7092V8.07031H51.1207V12.5H50.3551V8.07031H48.7692ZM56.2005 7.40909V12.5H55.4324V7.40909H56.2005ZM57.068 8.07031V7.40909H61.008V8.07031H59.4196V12.5H58.6539V8.07031H57.068ZM68.1534 9.95455C68.1534 10.4981 68.054 10.9654 67.8551 11.3565C67.6563 11.746 67.3836 12.0459 67.0373 12.2564C66.6926 12.4652 66.3007 12.5696 65.8615 12.5696C65.4207 12.5696 65.0271 12.4652 64.6808 12.2564C64.3361 12.0459 64.0643 11.7451 63.8654 11.354C63.6665 10.9629 63.5671 10.4964 63.5671 9.95455C63.5671 9.41098 63.6665 8.94448 63.8654 8.55504C64.0643 8.16394 64.3361 7.86399 64.6808 7.65518C65.0271 7.44472 65.4207 7.33949 65.8615 7.33949C66.3007 7.33949 66.6926 7.44472 67.0373 7.65518C67.3836 7.86399 67.6563 8.16394 67.8551 8.55504C68.054 8.94448 68.1534 9.41098 68.1534 9.95455ZM67.3928 9.95455C67.3928 9.54025 67.3256 9.19141 67.1914 8.90803C67.0588 8.62299 66.8765 8.40755 66.6445 8.26172C66.4142 8.11423 66.1532 8.04048 65.8615 8.04048C65.5682 8.04048 65.3063 8.11423 65.076 8.26172C64.8456 8.40755 64.6634 8.62299 64.5291 8.90803C64.3965 9.19141 64.3303 9.54025 64.3303 9.95455C64.3303 10.3688 64.3965 10.7185 64.5291 11.0036C64.6634 11.2869 64.8456 11.5024 65.076 11.6499C65.3063 11.7957 65.5682 11.8686 65.8615 11.8686C66.1532 11.8686 66.4142 11.7957 66.6445 11.6499C66.8765 11.5024 67.0588 11.2869 67.1914 11.0036C67.3256 10.7185 67.3928 10.3688 67.3928 9.95455ZM73.2201 7.40909V12.5H72.5141L69.9264 8.76634H69.8792V12.5H69.1111V7.40909H69.822L72.4122 11.1477H72.4594V7.40909H73.2201Z"
      fill="inherit"
      stroke="none"
    />
    <path
      d="M96.5816 19.9805L95.1344 23.8002H95.0909L93.581 19.9805H92.2158L94.4783 25.32L93.1855 28.2899H94.5121L98 19.9805H96.5816ZM86.3544 16.8108H85.0905V25.6201H86.3544V16.8108ZM81.5977 16.8108H78.5585V25.6201H79.8321V22.2853H81.6025C81.9594 22.298 82.3153 22.237 82.6493 22.106C82.9833 21.975 83.2889 21.7765 83.5483 21.5221C83.8078 21.2676 84.0158 20.9623 84.1605 20.6239C84.3051 20.2854 84.3834 19.9206 84.3909 19.5505C84.3834 19.1798 84.305 18.8143 84.1601 18.4752C84.0153 18.1362 83.8069 17.8303 83.547 17.5754C83.2872 17.3205 82.981 17.1216 82.6464 16.9903C82.3118 16.859 81.9553 16.7981 81.5977 16.8108ZM81.6314 21.0553H79.8321V18.0555H81.6363C82.0201 18.0555 82.3882 18.2135 82.6596 18.4948C82.9311 18.7761 83.0835 19.1576 83.0835 19.5554C83.0835 19.9532 82.9311 20.3347 82.6596 20.616C82.3882 20.8973 82.0201 21.0553 81.6363 21.0553H81.6315H81.6314ZM89.4709 19.7905C89.0079 19.7629 88.5472 19.8759 88.1453 20.1157C87.7434 20.3555 87.4177 20.7115 87.2082 21.1403L88.3371 21.6403C88.4489 21.4283 88.6181 21.2548 88.8238 21.1411C89.0295 21.0274 89.2628 20.9785 89.495 21.0003C89.6544 20.9838 89.8154 21.0001 89.9687 21.0483C90.122 21.0964 90.2646 21.1755 90.3883 21.281C90.5121 21.3864 90.6144 21.5162 90.6896 21.6628C90.7648 21.8094 90.8113 21.97 90.8264 22.1353V22.2253C90.4219 21.9985 89.9692 21.8799 89.5094 21.8803C88.2985 21.8803 87.0635 22.5703 87.0635 23.8802C87.0635 25.0601 88.0525 25.8201 89.1717 25.8201C89.4902 25.841 89.8082 25.7721 90.0919 25.6207C90.3756 25.4692 90.6144 25.241 90.7829 24.9601H90.8313V25.64H92.0663V22.2503C92.0663 20.6854 90.9374 19.8155 89.4803 19.8155L89.4709 19.7905ZM89.3213 24.6202C88.9064 24.6202 88.3274 24.4002 88.3274 23.8702C88.3274 23.1903 89.0462 22.9304 89.6735 22.9304C90.078 22.919 90.4779 23.0209 90.8311 23.2252C90.7845 23.6075 90.606 23.9594 90.3284 24.2159C90.0509 24.4723 89.6931 24.6159 89.3213 24.6202ZM43.5782 25.8101C41.0801 25.8186 39.0396 23.7441 39 21.1553C39.0398 18.5666 41.0801 16.4921 43.5782 16.5006C44.1502 16.4908 44.7184 16.5993 45.2494 16.82C45.7804 17.0407 46.2635 17.3689 46.6705 17.7856L45.7973 18.6806C45.2051 18.0792 44.4074 17.7448 43.5782 17.7506C41.7745 17.7506 40.3122 19.266 40.3122 21.1354C40.3122 23.0047 41.7745 24.5202 43.5782 24.5202C43.9998 24.5381 44.4202 24.4641 44.8125 24.303C45.2047 24.142 45.56 23.8974 45.8553 23.5851C46.2479 23.1464 46.4844 22.5821 46.5258 21.9853H43.5782V20.7504H47.727C47.7723 21.0127 47.7933 21.2788 47.7897 21.5454C47.8314 22.6521 47.448 23.7309 46.7236 24.5452C46.3145 24.9733 45.823 25.3073 45.281 25.5252C44.7391 25.7431 44.1588 25.8403 43.5782 25.8101ZM54.2059 22.8103C54.2219 23.2103 54.1597 23.6095 54.023 23.9839C53.8863 24.3583 53.6779 24.7003 53.4105 24.9891C53.1431 25.278 52.822 25.5079 52.4667 25.6649C52.1113 25.8219 51.729 25.9028 51.3428 25.9028C50.9565 25.9028 50.5742 25.8219 50.2188 25.6649C49.8635 25.5079 49.5425 25.278 49.275 24.9891C49.0076 24.7003 48.7992 24.3583 48.6625 23.9839C48.5259 23.6095 48.4636 23.2103 48.4796 22.8103C48.4636 22.4103 48.5259 22.011 48.6625 21.6366C48.7992 21.2622 49.0076 20.9203 49.275 20.6314C49.5425 20.3425 49.8635 20.1127 50.2188 19.9556C50.5742 19.7986 50.9565 19.7177 51.3428 19.7177C51.729 19.7177 52.1113 19.7986 52.4667 19.9556C52.822 20.1127 53.1431 20.3425 53.4105 20.6314C53.6779 20.9203 53.8863 21.2622 54.023 21.6366C54.1597 22.011 54.2219 22.4103 54.2059 22.8103ZM52.9517 22.8103C52.9729 22.578 52.947 22.3438 52.8758 22.1225C52.8046 21.9013 52.6896 21.6978 52.5381 21.5253C52.3867 21.3528 52.2021 21.2149 51.9963 21.1206C51.7904 21.0263 51.5678 20.9776 51.3428 20.9776C51.1177 20.9776 50.8951 21.0263 50.6893 21.1206C50.4834 21.2149 50.2989 21.3528 50.1474 21.5253C49.9959 21.6978 49.8809 21.9013 49.8097 22.1225C49.7385 22.3438 49.7126 22.578 49.7338 22.8103C49.7126 23.0425 49.7385 23.2767 49.8097 23.498C49.8809 23.7193 49.9959 23.9227 50.1474 24.0952C50.2989 24.2677 50.4834 24.4056 50.6893 24.4999C50.8951 24.5942 51.1177 24.6429 51.3428 24.6429C51.5678 24.6429 51.7904 24.5942 51.9963 24.4999C52.2021 24.4056 52.3867 24.2677 52.5381 24.0952C52.6896 23.9227 52.8046 23.7193 52.8758 23.498C52.947 23.2767 52.9729 23.0425 52.9517 22.8103ZM60.6222 22.8103C60.6222 24.4477 59.3413 25.7751 57.7614 25.7751C56.1814 25.7751 54.9005 24.4477 54.9005 22.8103C54.9005 21.1728 56.1814 19.8455 57.7614 19.8455C59.3413 19.8455 60.6222 21.1728 60.6222 22.8103ZM59.3728 22.8103C59.394 22.578 59.3681 22.3438 59.2969 22.1225C59.2257 21.9013 59.1107 21.6978 58.9592 21.5253C58.8078 21.3528 58.6232 21.2149 58.4174 21.1206C58.2115 21.0263 57.9889 20.9776 57.7639 20.9776C57.5388 20.9776 57.3162 21.0263 57.1104 21.1206C56.9045 21.2149 56.72 21.3528 56.5685 21.5253C56.417 21.6978 56.302 21.9013 56.2308 22.1225C56.1596 22.3438 56.1337 22.578 56.155 22.8103C56.1336 23.0425 56.1594 23.2769 56.2305 23.4982C56.3017 23.7196 56.4167 23.9231 56.5681 24.0957C56.7196 24.2683 56.9042 24.4063 57.1101 24.5006C57.316 24.595 57.5386 24.6438 57.7638 24.6438C57.9889 24.6438 58.2116 24.595 58.4175 24.5006C58.6234 24.4063 58.808 24.2683 58.9594 24.0957C59.1109 23.9231 59.2259 23.7196 59.297 23.4982C59.3682 23.2769 59.3941 23.0425 59.3728 22.8103ZM66.8839 19.9955V25.3801C66.8839 27.5899 65.6151 28.4999 64.1197 28.4999C63.5715 28.5047 63.0342 28.341 62.5757 28.0296C62.1172 27.7181 61.758 27.2729 61.5435 26.7501L62.6386 26.25C62.7522 26.5553 62.95 26.8191 63.2074 27.0085C63.4648 27.1979 63.7703 27.3045 64.0859 27.3151C65.0508 27.3151 65.6393 26.7001 65.6393 25.5551V25.1251H65.5911C65.4019 25.3439 65.1696 25.5183 64.91 25.6364C64.6504 25.7546 64.3694 25.8138 64.0859 25.8101C62.4872 25.8101 61.1913 24.4671 61.1913 22.8103C61.1913 21.1534 62.4872 19.8104 64.0859 19.8104C64.3713 19.8039 64.6547 19.8602 64.9175 19.9757C65.1803 20.0912 65.4165 20.2632 65.6104 20.4804H65.6585V19.9805H66.8839V19.9955ZM65.7599 22.8253C65.7776 22.599 65.7513 22.3714 65.6825 22.1558C65.6137 21.9403 65.5038 21.7413 65.3594 21.5706C65.2149 21.3999 65.0389 21.2611 64.8416 21.1623C64.6444 21.0635 64.43 21.0067 64.2113 20.9954C63.9882 21.0031 63.7689 21.0567 63.566 21.1533C63.3632 21.2498 63.181 21.3873 63.0301 21.5577C62.8792 21.7281 62.7625 21.9279 62.687 22.1456C62.6115 22.3633 62.5786 22.5943 62.5903 22.8253C62.5799 23.0547 62.6139 23.284 62.6902 23.4996C62.7665 23.7152 62.8836 23.9129 63.0346 24.081C63.1856 24.2491 63.3674 24.3843 63.5695 24.4786C63.7715 24.5729 63.9897 24.6244 64.2113 24.6301C64.4287 24.6214 64.6423 24.5673 64.8391 24.4709C65.0358 24.3746 65.2118 24.2381 65.3564 24.0695C65.5011 23.901 65.6114 23.7039 65.6807 23.4901C65.75 23.2763 65.777 23.0502 65.7599 22.8253ZM69.1175 16.8206V25.6251H67.844V16.8206H69.1175ZM74.1346 23.8003L75.1285 24.4802C74.8631 24.8905 74.5041 25.2266 74.0833 25.4586C73.6626 25.6905 73.193 25.8112 72.7164 25.8099C72.3373 25.8155 71.961 25.7414 71.6103 25.5919C71.2596 25.4424 70.9418 25.2208 70.6762 24.9404C70.4106 24.6599 70.2026 24.3266 70.0649 23.9604C69.9271 23.5943 69.8625 23.203 69.8749 22.8103C69.758 21.4124 70.6717 20.1461 71.9987 19.8672C73.3255 19.5882 74.6431 20.3856 75.0609 21.7203L75.1912 22.0654L71.3318 23.7201C71.4521 24.0003 71.6505 24.2367 71.9016 24.3989C72.1526 24.561 72.4448 24.6416 72.7404 24.6301C73.0216 24.6256 73.2971 24.547 73.541 24.4018C73.7849 24.2566 73.9891 24.0498 74.1346 23.8003ZM71.0907 22.7202L73.6861 21.6104C73.5856 21.4066 73.4297 21.2378 73.2376 21.1249C73.0455 21.012 72.8257 20.96 72.6054 20.9753C72.3947 20.9849 72.1881 21.0378 71.9974 21.1311C71.8067 21.2244 71.6359 21.3561 71.4949 21.5185C71.3539 21.6809 71.2455 21.8709 71.1761 22.0772C71.1067 22.2835 71.0777 22.5021 71.0907 22.7202Z"
      fill="inherit"
      stroke="none"
    />
  </svg>
));

export const Telegram = (props: any) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    {...props}
    d={[
      "m20.665 3.717-17.73 6.837c-1.21.486-1.203 1.161-.222 1.462l4.552 1.42 10.532-6.645c.498-.303.953-.14.579.192l-8.533 7.701h-.002l.002.001-.314 4.692c.46 0 .663-.211.921-.46l2.211-2.15 4.599 3.397c.848.467 1.457.227 1.668-.785l3.019-14.228c.309-1.239-.473-1.8-1.282-1.434z",
    ]}
  />
);

export const OriginalTelegram = (props: any) => (
  <Telegram {...props} fillColor="#0088CC" />
);

export const ExpandCollapse = ({ id, ...props }) => (
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id={`mask${id}0`}
      maskUnits="userSpaceOnUse"
      x="2"
      y="9"
      width="8"
      height="5"
    >
      <path
        d="M2.71259 13.5C2.43648 13.5 2.28998 13.1738 2.47342 12.9674L5.88041 9.13453C5.94406 9.06293 6.05594 9.06293 6.11959 9.13453L9.52658 12.9674C9.71002 13.1738 9.56352 13.5 9.28741 13.5H2.71259Z"
        fill="white"
      />
    </mask>
    <g mask={`url(#mask${id}0)`}>
      <rect
        width="24"
        height="24"
        transform="matrix(1 0 0 -1 -6 24)"
        fill="#8992A3"
      />
    </g>
    <mask
      id={`mask${id}1`}
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="8"
      height="5"
    >
      <path
        d="M2.71259 0.5C2.43648 0.5 2.28998 0.826228 2.47342 1.0326L5.88041 4.86547C5.94406 4.93707 6.05594 4.93707 6.11959 4.86547L9.52658 1.0326C9.71002 0.826228 9.56352 0.5 9.28741 0.5H2.71259Z"
        fill="white"
      />
    </mask>
    <g mask={`url(#mask${id}1)`}>
      <rect x="-6" y="-10" width="24" height="24" fill="#8992A3" />
    </g>
    <rect y="6" width="12" height="2" fill="#8992A3" />
  </svg>
);

export const AnimatedCheck = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    aria-hidden="true"
    {...props}
  >
    <circle className="circle" fill="currentColor" cx="24" cy="24" r="22" />
    <path
      className="tick"
      fill="none"
      stroke="#FFF"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M14 27l5.917 4.917L34 17"
    />
  </svg>
);

export const Descending = (props: any) => {
  return (
    <Icon
      {...props}
      viewBox={"0 0 576 512"}
      d={[
        "M416 288h-95.1c-17.67 0-32 14.33-32 32s14.33 32 32 32H416c17.67 0 32-14.33 32-32S433.7 288 416 288zM544 32h-223.1c-17.67 0-32 14.33-32 32s14.33 32 32 32H544c17.67 0 32-14.33 32-32S561.7 32 544 32zM352 416h-32c-17.67 0-32 14.33-32 32s14.33 32 32 32h32c17.67 0 31.1-14.33 31.1-32S369.7 416 352 416zM480 160h-159.1c-17.67 0-32 14.33-32 32s14.33 32 32 32H480c17.67 0 32-14.33 32-32S497.7 160 480 160zM192.4 330.7L160 366.1V64.03C160 46.33 145.7 32 128 32S96 46.33 96 64.03v302L63.6 330.7c-6.312-6.883-14.94-10.38-23.61-10.38c-7.719 0-15.47 2.781-21.61 8.414c-13.03 11.95-13.9 32.22-1.969 45.27l87.1 96.09c12.12 13.26 35.06 13.26 47.19 0l87.1-96.09c11.94-13.05 11.06-33.31-1.969-45.27C224.6 316.8 204.4 317.7 192.4 330.7z",
      ]}
    />
  );
};

export const Ascending = (props: any) => {
  return (
    <Icon
      {...props}
      viewBox={"0 0 576 512"}
      d={[
        "M320 224H416c17.67 0 32-14.33 32-32s-14.33-32-32-32h-95.1c-17.67 0-32 14.33-32 32S302.3 224 320 224zM320 352H480c17.67 0 32-14.33 32-32s-14.33-32-32-32h-159.1c-17.67 0-32 14.33-32 32S302.3 352 320 352zM320 96h32c17.67 0 31.1-14.33 31.1-32s-14.33-32-31.1-32h-32c-17.67 0-32 14.33-32 32S302.3 96 320 96zM544 416h-223.1c-17.67 0-32 14.33-32 32s14.33 32 32 32H544c17.67 0 32-14.33 32-32S561.7 416 544 416zM192.4 330.7L160 366.1V64.03C160 46.33 145.7 32 128 32S96 46.33 96 64.03v302L63.6 330.7c-6.312-6.883-14.94-10.38-23.61-10.38c-7.719 0-15.47 2.781-21.61 8.414c-13.03 11.95-13.9 32.22-1.969 45.27l87.1 96.09c12.12 13.26 35.06 13.26 47.19 0l87.1-96.09c11.94-13.05 11.06-33.31-1.969-45.27C224.6 316.8 204.4 317.7 192.4 330.7z",
      ]}
    />
  );
};

export const Sliders = (props: any) => {
  return (
    <Icon
      {...props}
      viewBox={"0 0 16 17"}
      d={[
        "M7.46066 13.9648V15.6638C7.46066 15.7498 7.53369 15.8201 7.62295 15.8201H8.59672C8.68598 15.8201 8.75902 15.7498 8.75902 15.6638V13.9648C8.55412 14.0293 8.33705 14.0625 8.10984 14.0625C7.88262 14.0625 7.66555 14.0273 7.46066 13.9648ZM8.75902 10.0977V1.66385C8.75902 1.57792 8.68306 1.5 8.5938 1.5H7.63918C7.54992 1.5 7.46066 1.57792 7.46066 1.66385V10.0977C7.66555 10.0332 7.88262 10 8.10984 10C8.33705 10 8.55412 10.0352 8.75902 10.0977ZM7.46066 13.9648C7.66555 14.0293 7.88262 14.0625 8.10984 14.0625C8.33705 14.0625 8.55412 14.0273 8.75902 13.9648C9.60701 13.7012 10.2197 12.9355 10.2197 12.0312C10.2197 11.1269 9.60701 10.3613 8.75902 10.0977C8.55412 10.0332 8.33705 10 8.10984 10C7.88262 10 7.66555 10.0352 7.46066 10.0977C6.61266 10.3613 6 11.1269 6 12.0312C6 12.9355 6.61266 13.7012 7.46066 13.9648ZM7.46268 11.7051C7.46877 11.6934 7.47688 11.6816 7.48297 11.6699V11.668L7.50732 11.6328C7.50934 11.6289 7.51137 11.6269 7.5134 11.623C7.51949 11.6133 7.5276 11.6055 7.53369 11.5957C7.53572 11.5937 7.53775 11.5898 7.53977 11.5879C7.54992 11.5762 7.55803 11.5664 7.56818 11.5566L7.57426 11.5508L7.59861 11.5273L7.60672 11.5195C7.61686 11.5098 7.62701 11.5019 7.63918 11.4922C7.65135 11.4824 7.6615 11.4746 7.67367 11.4668C7.67773 11.4648 7.67975 11.4629 7.68381 11.4609C7.69395 11.4551 7.70207 11.4473 7.71221 11.4414C7.71424 11.4394 7.7183 11.4375 7.72033 11.4355C7.7325 11.4277 7.74467 11.4219 7.75887 11.4141C7.7609 11.4121 7.76496 11.4121 7.76699 11.4102C7.77713 11.4043 7.78727 11.4004 7.79945 11.3945L7.81162 11.3887C7.82582 11.3828 7.83799 11.3769 7.85219 11.373C7.86639 11.3672 7.88059 11.3633 7.89479 11.3594C7.89885 11.3574 7.90291 11.3574 7.90697 11.3555C7.91914 11.3516 7.92928 11.3496 7.94145 11.3477C7.94551 11.3477 7.94754 11.3457 7.9516 11.3457C7.9658 11.3418 7.98203 11.3398 7.99623 11.3379C8.00029 11.3379 8.00232 11.3379 8.00637 11.3359C8.01854 11.334 8.03072 11.334 8.04289 11.332H8.05506C8.07129 11.332 8.08549 11.3301 8.10172 11.3301C8.11795 11.3301 8.13215 11.3301 8.14838 11.332H8.16055C8.17272 11.332 8.1849 11.334 8.19707 11.3359C8.20113 11.3359 8.20315 11.3359 8.20721 11.3379C8.22141 11.3398 8.23764 11.3418 8.25184 11.3457C8.2559 11.3457 8.25793 11.3477 8.26199 11.3477C8.27416 11.3496 8.28633 11.3535 8.29648 11.3555C8.30053 11.3574 8.30459 11.3574 8.30865 11.3594C8.32285 11.3633 8.33705 11.3672 8.35125 11.373C8.36545 11.3769 8.37762 11.3828 8.39182 11.3887L8.404 11.3945C8.41414 11.3984 8.42631 11.4043 8.43645 11.4102C8.43848 11.4121 8.44254 11.4121 8.44457 11.4141C8.45674 11.4199 8.47094 11.4277 8.48311 11.4355C8.48514 11.4375 8.4892 11.4394 8.49123 11.4414C8.50137 11.4473 8.51152 11.4531 8.51963 11.4609C8.52369 11.4629 8.52572 11.4648 8.52977 11.4668C8.54195 11.4746 8.55412 11.4844 8.56426 11.4922C8.5744 11.5 8.58658 11.5098 8.59672 11.5195L8.60484 11.5273L8.62918 11.5508L8.63527 11.5566C8.64541 11.5664 8.65555 11.5781 8.66367 11.5879C8.6657 11.5898 8.66772 11.5937 8.66975 11.5957C8.67787 11.6035 8.68395 11.6133 8.69004 11.623C8.69207 11.6269 8.6941 11.6289 8.69613 11.6328L8.72047 11.668L8.7225 11.6699C8.79014 11.7792 8.82589 11.904 8.82596 12.0312C8.82596 12.1484 8.79553 12.2598 8.74279 12.3574C8.7367 12.3691 8.72859 12.3809 8.7225 12.3926L8.72047 12.3945L8.69613 12.4297C8.6941 12.4336 8.69207 12.4355 8.69004 12.4394C8.68395 12.4492 8.67584 12.457 8.66975 12.4668C8.66772 12.4687 8.6657 12.4726 8.66367 12.4746C8.65352 12.4863 8.64541 12.4961 8.63527 12.5059L8.62918 12.5117L8.60484 12.5351L8.59672 12.543C8.58658 12.5527 8.57643 12.5605 8.56426 12.5703C8.55209 12.5801 8.54195 12.5879 8.52977 12.5957C8.52572 12.5977 8.52369 12.5996 8.51963 12.6016C8.50949 12.6074 8.50137 12.6152 8.49123 12.6211C8.4892 12.623 8.48514 12.625 8.48311 12.6269C8.47094 12.6348 8.45877 12.6406 8.44457 12.6484C8.44254 12.6504 8.43848 12.6504 8.43645 12.6523C8.42631 12.6582 8.41617 12.6621 8.404 12.668L8.39182 12.6738C8.37762 12.6797 8.36545 12.6855 8.35125 12.6894C8.33705 12.6953 8.32285 12.6992 8.30865 12.7031C8.30459 12.7051 8.30053 12.7051 8.29648 12.707C8.2843 12.7109 8.27416 12.7129 8.26199 12.7148C8.25793 12.7148 8.2559 12.7168 8.25184 12.7168C8.23764 12.7207 8.22141 12.7226 8.20721 12.7246C8.20315 12.7246 8.20113 12.7246 8.19707 12.7266C8.1849 12.7285 8.17272 12.7285 8.16055 12.7305H8.14838C8.13215 12.7305 8.11795 12.7324 8.10172 12.7324C8.08549 12.7324 8.07129 12.7324 8.05506 12.7305H8.04289C8.03072 12.7305 8.01854 12.7285 8.00637 12.7266C8.00232 12.7266 8.00029 12.7266 7.99623 12.7246C7.98203 12.7226 7.9658 12.7207 7.9516 12.7168C7.94754 12.7168 7.94551 12.7148 7.94145 12.7148C7.92928 12.7129 7.91711 12.709 7.90697 12.707C7.90291 12.7051 7.89885 12.7051 7.89479 12.7031C7.88059 12.6992 7.86639 12.6953 7.85219 12.6894C7.83799 12.6855 7.82582 12.6797 7.81162 12.6738L7.79945 12.668C7.7893 12.6641 7.77713 12.6582 7.76699 12.6523C7.76496 12.6504 7.7609 12.6504 7.75887 12.6484C7.7467 12.6426 7.7325 12.6348 7.72033 12.6269C7.7183 12.625 7.71424 12.623 7.71221 12.6211C7.70207 12.6152 7.69193 12.6094 7.68381 12.6016C7.67975 12.5996 7.67773 12.5977 7.67367 12.5957C7.6615 12.5879 7.64932 12.5781 7.63918 12.5703C7.62904 12.5625 7.61686 12.5527 7.60672 12.543L7.59861 12.5351L7.57426 12.5117L7.56818 12.5059C7.55803 12.4961 7.54789 12.4844 7.53977 12.4746C7.53775 12.4726 7.53572 12.4687 7.53369 12.4668C7.52557 12.459 7.51949 12.4492 7.5134 12.4394C7.51137 12.4355 7.50934 12.4336 7.50732 12.4297L7.48297 12.3945V12.3926C7.47486 12.3809 7.46877 12.3691 7.46268 12.3574C7.40994 12.2598 7.37951 12.1484 7.37951 12.0312C7.37951 11.9141 7.40994 11.8027 7.46268 11.7051ZM12.241 9.69119V15.6638C12.241 15.7498 12.314 15.8201 12.4033 15.8201H13.377C13.4663 15.8201 13.5393 15.7498 13.5393 15.6638V9.69119C13.3344 9.75564 13.1174 9.78884 12.8902 9.78884C12.663 9.78884 12.4459 9.75369 12.241 9.69119ZM13.5393 5.824V1.65802C13.5393 1.57208 13.4657 1.5 13.3764 1.5H12.4062C12.3169 1.5 12.241 1.57208 12.241 1.65802V5.824C12.4459 5.75955 12.663 5.72635 12.8902 5.72635C13.1174 5.72635 13.3344 5.7615 13.5393 5.824ZM12.241 9.69119C12.4459 9.75564 12.663 9.78884 12.8902 9.78884C13.1174 9.78884 13.3344 9.75369 13.5393 9.69119C14.3873 9.42752 15 8.66189 15 7.7576C15 6.8533 14.3873 6.08768 13.5393 5.824C13.3344 5.75955 13.1174 5.72635 12.8902 5.72635C12.663 5.72635 12.4459 5.7615 12.241 5.824C11.393 6.08768 10.7803 6.8533 10.7803 7.7576C10.7803 8.66189 11.393 9.42752 12.241 9.69119ZM12.243 7.43142C12.2491 7.41971 12.2572 7.40799 12.2633 7.39627V7.39432L12.2876 7.35916C12.2897 7.35525 12.2917 7.3533 12.2937 7.34939C12.2998 7.33963 12.3079 7.33182 12.314 7.32205C12.316 7.3201 12.3181 7.31619 12.3201 7.31424C12.3302 7.30252 12.3384 7.29275 12.3485 7.28299L12.3546 7.27713L12.3789 7.25369L12.387 7.24588C12.3972 7.23611 12.4073 7.2283 12.4195 7.21853C12.4317 7.20877 12.4418 7.20096 12.454 7.19314C12.4581 7.19119 12.4601 7.18924 12.4641 7.18728C12.4743 7.18143 12.4824 7.17361 12.4925 7.16775C12.4946 7.1658 12.4986 7.16385 12.5007 7.16189C12.5128 7.15408 12.525 7.14822 12.5392 7.14041C12.5412 7.13846 12.5453 7.13846 12.5473 7.1365C12.5575 7.13064 12.5676 7.12674 12.5798 7.12088L12.5919 7.11502C12.6061 7.10916 12.6183 7.1033 12.6325 7.09939C12.6467 7.09353 12.6609 7.08963 12.6751 7.08572C12.6792 7.08377 12.6832 7.08377 12.6873 7.08182C12.6995 7.07791 12.7096 7.07596 12.7218 7.074C12.7258 7.074 12.7279 7.07205 12.7319 7.07205C12.7461 7.06814 12.7624 7.06619 12.7766 7.06424C12.7806 7.06424 12.7826 7.06424 12.7867 7.06228C12.7989 7.06033 12.811 7.06033 12.8232 7.05838H12.8354C12.8516 7.05838 12.8658 7.05643 12.882 7.05643C12.8983 7.05643 12.9125 7.05643 12.9287 7.05838H12.9409C12.9531 7.05838 12.9652 7.06033 12.9774 7.06228C12.9815 7.06228 12.9835 7.06228 12.9875 7.06424C13.0017 7.06619 13.018 7.06814 13.0322 7.07205C13.0362 7.07205 13.0383 7.074 13.0423 7.074C13.0545 7.07596 13.0667 7.07986 13.0768 7.08182C13.0809 7.08377 13.0849 7.08377 13.089 7.08572C13.1032 7.08963 13.1174 7.09353 13.1316 7.09939C13.1458 7.1033 13.158 7.10916 13.1722 7.11502L13.1843 7.12088C13.1945 7.12478 13.2066 7.13064 13.2168 7.1365C13.2188 7.13846 13.2229 7.13846 13.2249 7.14041C13.2371 7.14627 13.2513 7.15408 13.2634 7.16189C13.2655 7.16385 13.2695 7.1658 13.2716 7.16775C13.2817 7.17361 13.2918 7.17947 13.3 7.18728C13.304 7.18924 13.306 7.19119 13.3101 7.19314C13.3223 7.20096 13.3344 7.21072 13.3446 7.21853C13.3547 7.22635 13.3669 7.23611 13.377 7.24588L13.3852 7.25369L13.4095 7.27713L13.4156 7.28299C13.4257 7.29275 13.4359 7.30447 13.444 7.31424C13.446 7.31619 13.4481 7.3201 13.4501 7.32205C13.4582 7.32986 13.4643 7.33963 13.4704 7.34939C13.4724 7.3533 13.4744 7.35525 13.4765 7.35916L13.5008 7.39432V7.39627C13.5684 7.50555 13.6042 7.63038 13.6043 7.7576C13.6043 7.87478 13.5738 7.98611 13.5211 8.08377C13.515 8.09549 13.5069 8.10721 13.5008 8.11892V8.12088L13.4765 8.15603C13.4744 8.15994 13.4724 8.16189 13.4704 8.1658C13.4643 8.17557 13.4562 8.18338 13.4501 8.19314C13.4481 8.1951 13.446 8.199 13.444 8.20096C13.4339 8.21267 13.4257 8.22244 13.4156 8.23221L13.4095 8.23807L13.3852 8.2615L13.377 8.26932C13.3669 8.27908 13.3568 8.28689 13.3446 8.29666C13.3324 8.30642 13.3223 8.31424 13.3101 8.32205C13.306 8.324 13.304 8.32596 13.3 8.32791C13.2898 8.33377 13.2817 8.34158 13.2716 8.34744C13.2695 8.34939 13.2655 8.35135 13.2634 8.3533C13.2513 8.36111 13.2391 8.36697 13.2249 8.37478C13.2229 8.37674 13.2188 8.37674 13.2168 8.37869C13.2066 8.38455 13.1965 8.38846 13.1843 8.39432L13.1722 8.40017C13.158 8.40603 13.1458 8.41189 13.1316 8.4158C13.1174 8.42166 13.1032 8.42557 13.089 8.42947C13.0849 8.43142 13.0809 8.43142 13.0768 8.43338C13.0646 8.43728 13.0545 8.43924 13.0423 8.44119C13.0383 8.44119 13.0362 8.44314 13.0322 8.44314C13.018 8.44705 13.0017 8.449 12.9875 8.45096C12.9835 8.45096 12.9815 8.45096 12.9774 8.45291C12.9652 8.45486 12.9531 8.45486 12.9409 8.45681H12.9287C12.9125 8.45681 12.8983 8.45877 12.882 8.45877C12.8658 8.45877 12.8516 8.45877 12.8354 8.45681H12.8232C12.811 8.45681 12.7989 8.45486 12.7867 8.45291C12.7826 8.45291 12.7806 8.45291 12.7766 8.45096C12.7624 8.449 12.7461 8.44705 12.7319 8.44314C12.7279 8.44314 12.7258 8.44119 12.7218 8.44119C12.7096 8.43924 12.6974 8.43533 12.6873 8.43338C12.6832 8.43142 12.6792 8.43142 12.6751 8.42947C12.6609 8.42557 12.6467 8.42166 12.6325 8.4158C12.6183 8.41189 12.6061 8.40603 12.5919 8.40017L12.5798 8.39432C12.5696 8.39041 12.5575 8.38455 12.5473 8.37869C12.5453 8.37674 12.5412 8.37674 12.5392 8.37478C12.527 8.36893 12.5128 8.36111 12.5007 8.3533C12.4986 8.35135 12.4946 8.34939 12.4925 8.34744C12.4824 8.34158 12.4723 8.33572 12.4641 8.32791C12.4601 8.32596 12.4581 8.324 12.454 8.32205C12.4418 8.31424 12.4297 8.30447 12.4195 8.29666C12.4094 8.28885 12.3972 8.27908 12.387 8.26932L12.3789 8.2615L12.3546 8.23807L12.3485 8.23221C12.3384 8.22244 12.3282 8.21072 12.3201 8.20096C12.3181 8.199 12.316 8.1951 12.314 8.19314C12.3059 8.18533 12.2998 8.17557 12.2937 8.1658C12.2917 8.16189 12.2897 8.15994 12.2876 8.15603L12.2633 8.12088V8.11892C12.2552 8.10721 12.2491 8.09549 12.243 8.08377C12.1903 7.98611 12.1598 7.87478 12.1598 7.7576C12.1598 7.64041 12.1903 7.52908 12.243 7.43142Z",
        "M2.38462 6.96496V15.6639C2.38462 15.7499 2.45385 15.8202 2.53846 15.8202H3.46154C3.54615 15.8202 3.61538 15.7499 3.61538 15.6639V6.96496C3.42115 7.02942 3.21538 7.06262 3 7.06262C2.78461 7.06262 2.57885 7.02746 2.38462 6.96496ZM3.61538 3.09778V1.66388C3.61538 1.57794 3.54554 1.50586 3.46092 1.50586H2.54123C2.45662 1.50586 2.38462 1.57794 2.38462 1.66388V3.09778C2.57885 3.03333 2.78461 3.00012 3 3.00012C3.21538 3.00012 3.42115 3.03528 3.61538 3.09778ZM2.38462 6.96496C2.57885 7.02942 2.78461 7.06262 3 7.06262C3.21538 7.06262 3.42115 7.02746 3.61538 6.96496C4.41923 6.70129 5 5.93567 5 5.03137C5 4.12707 4.41923 3.36145 3.61538 3.09778C3.42115 3.03333 3.21538 3.00012 3 3.00012C2.78461 3.00012 2.57885 3.03528 2.38462 3.09778C1.58077 3.36145 1 4.12707 1 5.03137C1 5.93567 1.58077 6.70129 2.38462 6.96496ZM2.38654 4.7052C2.39231 4.69348 2.4 4.68176 2.40577 4.67004V4.66809L2.42885 4.63293C2.43077 4.62903 2.43269 4.62708 2.43461 4.62317C2.44038 4.6134 2.44808 4.60559 2.45385 4.59583C2.45577 4.59387 2.45769 4.58997 2.45962 4.58801C2.46923 4.57629 2.47692 4.56653 2.48654 4.55676L2.49231 4.5509L2.51538 4.52747L2.52308 4.51965C2.53269 4.50989 2.54231 4.50208 2.55385 4.49231C2.56538 4.48254 2.575 4.47473 2.58654 4.46692C2.59038 4.46497 2.59231 4.46301 2.59615 4.46106C2.60577 4.4552 2.61346 4.44739 2.62308 4.44153C2.625 4.43958 2.62885 4.43762 2.63077 4.43567C2.64231 4.42786 2.65385 4.422 2.66731 4.41418C2.66923 4.41223 2.67308 4.41223 2.675 4.41028C2.68461 4.40442 2.69423 4.40051 2.70577 4.39465L2.71731 4.38879C2.73077 4.38293 2.74231 4.37708 2.75577 4.37317C2.76923 4.36731 2.78269 4.3634 2.79615 4.3595C2.8 4.35754 2.80385 4.35754 2.80769 4.35559C2.81923 4.35168 2.82885 4.34973 2.84038 4.34778C2.84423 4.34778 2.84615 4.34583 2.85 4.34583C2.86346 4.34192 2.87885 4.33997 2.89231 4.33801C2.89615 4.33801 2.89808 4.33801 2.90192 4.33606C2.91346 4.33411 2.925 4.33411 2.93654 4.33215H2.94808C2.96346 4.33215 2.97692 4.3302 2.99231 4.3302C3.00769 4.3302 3.02115 4.3302 3.03654 4.33215H3.04808C3.05962 4.33215 3.07115 4.33411 3.08269 4.33606C3.08654 4.33606 3.08846 4.33606 3.09231 4.33801C3.10577 4.33997 3.12115 4.34192 3.13462 4.34583C3.13846 4.34583 3.14038 4.34778 3.14423 4.34778C3.15577 4.34973 3.16731 4.35364 3.17692 4.35559C3.18077 4.35754 3.18462 4.35754 3.18846 4.3595C3.20192 4.3634 3.21539 4.36731 3.22885 4.37317C3.24231 4.37708 3.25385 4.38293 3.26731 4.38879L3.27885 4.39465C3.28846 4.39856 3.3 4.40442 3.30962 4.41028C3.31154 4.41223 3.31538 4.41223 3.31731 4.41418C3.32885 4.42004 3.34231 4.42786 3.35385 4.43567C3.35577 4.43762 3.35962 4.43958 3.36154 4.44153C3.37115 4.44739 3.38077 4.45325 3.38846 4.46106C3.39231 4.46301 3.39423 4.46497 3.39808 4.46692C3.40962 4.47473 3.42115 4.4845 3.43077 4.49231C3.44039 4.50012 3.45192 4.50989 3.46154 4.51965L3.46923 4.52747L3.49231 4.5509L3.49808 4.55676C3.50769 4.56653 3.51731 4.57825 3.525 4.58801C3.52692 4.58997 3.52885 4.59387 3.53077 4.59583C3.53846 4.60364 3.54423 4.6134 3.55 4.62317C3.55192 4.62708 3.55385 4.62903 3.55577 4.63293L3.57885 4.66809V4.67004C3.64297 4.77932 3.67685 4.90416 3.67692 5.03137C3.67692 5.14856 3.64808 5.25989 3.59808 5.35754C3.59231 5.36926 3.58462 5.38098 3.57885 5.3927V5.39465L3.55577 5.42981C3.55385 5.43372 3.55192 5.43567 3.55 5.43957C3.54423 5.44934 3.53654 5.45715 3.53077 5.46692C3.52885 5.46887 3.52692 5.47278 3.525 5.47473C3.51538 5.48645 3.50769 5.49621 3.49808 5.50598L3.49231 5.51184L3.46923 5.53528L3.46154 5.54309C3.45192 5.55286 3.44231 5.56067 3.43077 5.57043C3.41923 5.5802 3.40962 5.58801 3.39808 5.59582C3.39423 5.59778 3.39231 5.59973 3.38846 5.60168C3.37885 5.60754 3.37115 5.61536 3.36154 5.62122C3.35962 5.62317 3.35577 5.62512 3.35385 5.62707C3.34231 5.63489 3.33077 5.64075 3.31731 5.64856C3.31538 5.65051 3.31154 5.65051 3.30962 5.65246C3.3 5.65832 3.29038 5.66223 3.27885 5.66809L3.26731 5.67395C3.25385 5.67981 3.24231 5.68567 3.22885 5.68957C3.21539 5.69543 3.20192 5.69934 3.18846 5.70325C3.18462 5.7052 3.18077 5.7052 3.17692 5.70715C3.16538 5.71106 3.15577 5.71301 3.14423 5.71497C3.14038 5.71497 3.13846 5.71692 3.13462 5.71692C3.12115 5.72082 3.10577 5.72278 3.09231 5.72473C3.08846 5.72473 3.08654 5.72473 3.08269 5.72668C3.07115 5.72864 3.05962 5.72864 3.04808 5.73059H3.03654C3.02115 5.73059 3.00769 5.73254 2.99231 5.73254C2.97692 5.73254 2.96346 5.73254 2.94808 5.73059H2.93654C2.925 5.73059 2.91346 5.72864 2.90192 5.72668C2.89808 5.72668 2.89615 5.72668 2.89231 5.72473C2.87885 5.72278 2.86346 5.72082 2.85 5.71692C2.84615 5.71692 2.84423 5.71497 2.84038 5.71497C2.82885 5.71301 2.81731 5.70911 2.80769 5.70715C2.80385 5.7052 2.8 5.7052 2.79615 5.70325C2.78269 5.69934 2.76923 5.69543 2.75577 5.68957C2.74231 5.68567 2.73077 5.67981 2.71731 5.67395L2.70577 5.66809C2.69615 5.66418 2.68461 5.65832 2.675 5.65246C2.67308 5.65051 2.66923 5.65051 2.66731 5.64856C2.65577 5.6427 2.64231 5.63489 2.63077 5.62707C2.62885 5.62512 2.625 5.62317 2.62308 5.62122C2.61346 5.61536 2.60385 5.6095 2.59615 5.60168C2.59231 5.59973 2.59038 5.59778 2.58654 5.59582C2.575 5.58801 2.56346 5.57825 2.55385 5.57043C2.54423 5.56262 2.53269 5.55286 2.52308 5.54309L2.51538 5.53528L2.49231 5.51184L2.48654 5.50598C2.47692 5.49621 2.46731 5.4845 2.45962 5.47473C2.45769 5.47278 2.45577 5.46887 2.45385 5.46692C2.44615 5.45911 2.44038 5.44934 2.43461 5.43957C2.43269 5.43567 2.43077 5.43372 2.42885 5.42981L2.40577 5.39465V5.3927C2.39808 5.38098 2.39231 5.36926 2.38654 5.35754C2.33654 5.25989 2.30769 5.14856 2.30769 5.03137C2.30769 4.91418 2.33654 4.80286 2.38654 4.7052Z",
      ]}
    />
  );
};

export const PayPal = (props: any) => (
  <Icon {...props} viewBox={"0 0 24 24"}>
    <path
      fill="#263B80"
      d="M19.148 1.81C18.037.543 16.028 0 13.458 0H5.999c-.525 0-.973.382-1.055.901L1.84 20.598a.64.64 0 0 0 .633.74h4.605l1.156-7.335-.036.23c.081-.518.527-.9 1.051-.901h2.188c4.299 0 7.664-1.746 8.647-6.797.029-.149.054-.295.076-.437.292-1.867-.002-3.137-1.012-4.288z"
    />
    <path
      fill="#263B80"
      d="M19.148 1.81C18.037.543 16.028 0 13.458 0H5.999c-.525 0-.973.382-1.055.901L1.84 20.598a.64.64 0 0 0 .633.74h4.605l1.156-7.335-.036.23c.081-.518.527-.9 1.051-.901h2.188c4.299 0 7.664-1.746 8.647-6.797.029-.149.054-.295.076-.437.292-1.867-.002-3.137-1.012-4.288z"
    />
    <path
      fill="#263B80"
      d="M9.475 6.123a.934.934 0 0 1 .922-.788h5.847c.692 0 1.338.045 1.929.139a8 8 0 0 1 .956.214c.357.1.702.238 1.03.41.293-1.867-.001-3.137-1.011-4.289C18.036.543 16.028 0 13.458 0H5.999c-.525 0-.972.382-1.054.901L1.839 20.597a.64.64 0 0 0 .632.74h4.605l1.156-7.336 1.243-7.878z"
    />
    <path
      fill="#139AD6"
      d="M20.16 6.098c-.023.146-.048.292-.076.437-.983 5.05-4.349 6.797-8.647 6.797h-2.19c-.524 0-.97.383-1.05.901l-1.121 7.105-.319 2.015a.56.56 0 0 0 .554.647h3.882c.459 0 .85-.335.922-.788l.038-.198.732-4.636.046-.256a.934.934 0 0 1 .923-.788h.581c3.76 0 6.704-1.527 7.565-5.946.358-1.846.173-3.388-.777-4.47a3.707 3.707 0 0 0-1.063-.82z"
    />
    <path
      fill="#232C65"
      d="M19.13 5.688a6.984 6.984 0 0 0-.464-.119 8.636 8.636 0 0 0-.493-.093 12.088 12.088 0 0 0-1.929-.141h-5.847a.931.931 0 0 0-.922.789l-1.243 7.88-.036.229c.08-.518.526-.9 1.05-.901h2.189c4.299 0 7.664-1.746 8.647-6.797.029-.149.054-.294.076-.437-.26-.136-.53-.25-.809-.341a4.027 4.027 0 0 0-.219-.069z"
    />
  </Icon>
);

export const PayPalFullLogo = (props: any) => (
  <Icon {...props} viewBox={"0 20 64 20"}>
    <path
      fill="#139AD6"
      d="M49.2 28.2h-3.4c-.2 0-.4.2-.5.4l-1.4 8.8c0 .2.1.3.3.3H46c.2 0 .3-.1.3-.3l.4-2.5c0-.2.2-.4.5-.4h1.1c2.3 0 3.6-1.1 3.9-3.3.2-.9 0-1.7-.4-2.2-.6-.5-1.5-.8-2.6-.8m.4 3.3c-.2 1.2-1.1 1.2-2 1.2H47l.4-2.3c0-.1.1-.2.3-.2h.2c.6 0 1.2 0 1.5.4.2.1.2.4.2.9"
    />
    <path
      fill="#263B80"
      d="M24.7 28.2h-3.4c-.2 0-.4.2-.5.4l-1.4 8.8c0 .2.1.3.3.3h1.6c.2 0 .4-.2.5-.4l.4-2.4c0-.2.2-.4.5-.4h1.1c2.3 0 3.6-1.1 3.9-3.3.2-.9 0-1.7-.4-2.2-.6-.5-1.4-.8-2.6-.8m.4 3.3c-.2 1.2-1.1 1.2-2 1.2h-.5l.4-2.3c0-.1.1-.2.3-.2h.2c.6 0 1.2 0 1.5.4.1.1.2.4.1.9M35 31.4h-1.6c-.1 0-.3.1-.3.2l-.1.5-.1-.2c-.4-.5-1.1-.7-1.9-.7-1.8 0-3.4 1.4-3.7 3.3-.2 1 .1 1.9.6 2.5.5.6 1.2.8 2.1.8 1.5 0 2.3-.9 2.3-.9l-.1.5c0 .2.1.3.3.3H34c.2 0 .4-.2.5-.4l.9-5.6c-.1-.1-.3-.3-.4-.3m-2.3 3.2c-.2.9-.9 1.6-1.9 1.6-.5 0-.9-.2-1.1-.4-.2-.3-.3-.7-.3-1.2.1-.9.9-1.6 1.8-1.6.5 0 .8.2 1.1.4.3.3.4.8.4 1.2"
    />
    <path
      fill="#139AD6"
      d="M59.4 31.4h-1.6c-.1 0-.3.1-.3.2l-.1.5-.1-.2c-.4-.5-1.1-.7-1.9-.7-1.8 0-3.4 1.4-3.7 3.3-.2 1 .1 1.9.6 2.5.5.6 1.2.8 2.1.8 1.5 0 2.3-.9 2.3-.9l-.1.5c0 .2.1.3.3.3h1.5c.2 0 .4-.2.5-.4l.9-5.6c-.1-.1-.2-.3-.4-.3m-2.3 3.2c-.2.9-.9 1.6-1.9 1.6-.5 0-.9-.2-1.1-.4-.2-.3-.3-.7-.3-1.2.1-.9.9-1.6 1.8-1.6.5 0 .8.2 1.1.4.4.3.5.8.4 1.2"
    />
    <path
      fill="#263B80"
      d="M43.7 31.4H42c-.2 0-.3.1-.4.2L39.4 35l-1-3.2c-.1-.2-.2-.3-.5-.3h-1.6c-.2 0-.3.2-.3.4l1.8 5.3-1.7 2.4c-.1.2 0 .5.2.5h1.6c.2 0 .3-.1.4-.2l5.5-7.9c.3-.3.1-.6-.1-.6"
    />
    <path
      fill="#139AD6"
      d="m61.3 28.5-1.4 9c0 .2.1.3.3.3h1.4c.2 0 .4-.2.5-.4l1.4-8.8c0-.2-.1-.3-.3-.3h-1.6c-.1-.1-.2 0-.3.2"
    />
    <path
      fill="#263B80"
      d="M12 25.2c-.7-.8-2-1.2-3.8-1.2h-5c-.3 0-.6.3-.7.6l-2 13.1c0 .3.2.5.4.5H4l.8-4.9v.2c.1-.3.4-.6.7-.6H7c2.9 0 5.1-1.2 5.8-4.5v-.3c-.1 0-.1 0 0 0 .1-1.3-.1-2.1-.8-2.9"
    />
    <path
      fill="#139AD6"
      d="M12.7 28.1v.3c-.7 3.4-2.9 4.5-5.8 4.5H5.4c-.3 0-.6.3-.7.6l-1 6.1c0 .2.1.4.4.4h2.6c.3 0 .6-.2.6-.5v-.1l.5-3.1v-.2c0-.3.3-.5.6-.5h.4c2.5 0 4.5-1 5-4 .2-1.2.1-2.3-.5-3-.1-.2-.3-.4-.6-.5"
    />
    <path
      fill="#232C65"
      d="M12 27.8c-.1 0-.2-.1-.3-.1-.1 0-.2 0-.3-.1-.4-.1-.8-.1-1.3-.1H6.2c-.1 0-.2 0-.3.1-.2.1-.3.3-.3.5l-.8 5.2v.2c.1-.3.4-.6.7-.6H7c2.9 0 5.1-1.2 5.8-4.5 0-.1 0-.2.1-.3-.2-.1-.3-.2-.5-.2-.3-.1-.3-.1-.4-.1"
    />
  </Icon>
);

export const FireIcon = styled(FireFilled)`
  color: ${(p) => p.theme.colors.red};
  font-size: ${(p) => p.theme.typography.fontSizes.XL};
`;

export const CellTowerIcon = (props: any) => (
  <Icon
    {...props}
    viewBox={"0 0 16 17"}
    d={[
      "M1.93302 2.62847C2.01929 2.45774 2.11289 2.29038 2.21368 2.12688C2.22965 2.10098 2.2437 2.0743 2.25587 2.04705C2.37621 1.77741 2.31093 1.45175 2.0696 1.27182C1.80388 1.07371 1.42574 1.12744 1.2481 1.40726C1.22917 1.43707 1.21045 1.467 1.19194 1.49703C1.0759 1.68526 0.967959 1.87785 0.868282 2.07423C0.284733 3.22393 -0.0155061 4.50408 0.00253803 5.80675C0.0205828 7.10943 0.356165 8.38077 0.971334 9.51387C1.07641 9.70741 1.18965 9.89693 1.31085 10.0819C1.33019 10.1114 1.34974 10.1408 1.36948 10.1701C1.55481 10.4448 1.93428 10.4881 2.19442 10.2827C2.43068 10.0962 2.48691 9.7688 2.35914 9.5026C2.34623 9.4757 2.33144 9.44942 2.31476 9.42398C2.20948 9.26333 2.11127 9.09862 2.02031 8.93035C1.50115 7.96995 1.21798 6.89326 1.2027 5.79013C1.1881 4.73588 1.41875 3.69898 1.86899 2.75862C1.88986 2.71502 1.91121 2.67164 1.93302 2.62847Z",
      "M11.656 7.84493C11.8629 7.49354 12.0175 7.11486 12.1159 6.72088C12.1227 6.69378 12.1292 6.6666 12.1354 6.63935C12.2053 6.33426 12.2415 6.02058 12.2423 5.70381C12.2432 5.35876 12.202 5.01715 12.1211 4.68612C12.0247 4.29165 11.8719 3.91219 11.6669 3.55975C11.6488 3.52867 11.6335 3.4964 11.6212 3.46339C11.5326 3.22756 11.5896 2.95341 11.7938 2.79755C12.0265 2.61987 12.3618 2.66334 12.5154 2.9127C12.5386 2.95034 12.5613 2.98826 12.5835 3.02642C12.8159 3.42587 12.9946 3.85311 13.1157 4.29691C13.2403 4.75331 13.304 5.22724 13.3028 5.7065C13.3016 6.18577 13.2354 6.65936 13.1086 7.11513C12.9852 7.55831 12.8043 7.98463 12.5699 8.3829C12.5475 8.42095 12.5246 8.45875 12.5012 8.49628C12.3464 8.74485 12.0109 8.78663 11.779 8.60777C11.5756 8.45087 11.5201 8.17644 11.6098 7.94106C11.6224 7.90811 11.6378 7.87592 11.656 7.84493Z",
      "M3.86306 4.76782C3.95182 4.37156 4.09722 3.98922 4.29544 3.63289C4.31293 3.60147 4.32754 3.56891 4.33929 3.53566C4.42323 3.29817 4.36102 3.02517 4.15386 2.87328C3.91769 2.70013 3.5833 2.75006 3.43458 3.00234C3.41213 3.04043 3.39017 3.07877 3.3687 3.11736C3.14404 3.52122 2.97365 3.95182 2.86111 4.39788C2.74537 4.85661 2.6908 5.33167 2.70127 5.81082C2.71173 6.28997 2.78699 6.7622 2.92266 7.21544C3.05457 7.65615 3.2436 8.07891 3.48568 8.47257C3.50881 8.51019 3.53243 8.54754 3.55652 8.58461C3.71611 8.83015 4.05236 8.86543 4.28074 8.68213C4.48108 8.52134 4.53131 8.24589 4.43708 8.01228C4.42389 7.97958 4.40787 7.9477 4.38903 7.91706C4.17544 7.56973 4.01348 7.1941 3.90749 6.8021C3.81855 6.47314 3.76903 6.13264 3.7615 5.78766C3.75458 5.47097 3.78318 5.1565 3.84554 4.8498C3.85111 4.82241 3.85695 4.79508 3.86306 4.76782Z",
      "M9.59711 7.75296C10.179 7.30947 10.5546 6.60907 10.5546 5.82096C10.5546 4.48019 9.46766 3.39329 8.1269 3.39329C6.78614 3.39329 5.69923 4.48019 5.69923 5.82096C5.69923 6.60727 6.03214 7.30627 6.61177 7.74992L5.81843 14.8412C5.8102 14.9111 5.80691 14.9804 5.80824 15.0486C5.2037 15.0915 4.72658 15.5955 4.72658 16.2109C4.72658 16.3718 4.85701 16.5022 5.0179 16.5022H7.09998C7.16793 16.5116 7.23742 16.5165 7.30816 16.5165H8.52179C8.59238 16.5165 8.66179 16.5116 8.7297 16.5022H10.7472C10.9081 16.5022 11.0385 16.3718 11.0385 16.2109C11.0385 15.6175 10.595 15.1278 10.0214 15.055C10.0224 15.0132 10.0217 14.9709 10.0192 14.9284L9.59711 7.75296ZM9.55456 5.82096C9.55456 6.60943 8.91538 7.24862 8.1269 7.24862C7.33842 7.24862 6.69923 6.60943 6.69923 5.82096C6.69923 5.03248 7.33842 4.39329 8.1269 4.39329C8.91538 4.39329 9.55456 5.03248 9.55456 5.82096ZM9.02093 14.9871C9.02209 15.0069 9.02209 15.0264 9.02099 15.0456H6.80889C6.80726 15.017 6.80809 14.9877 6.81158 14.9581L7.55177 8.26243H8.62535L9.02093 14.9871Z",
      "M13.6386 9.49406C13.7459 9.33477 13.8462 9.17134 13.9393 9.00424C13.9629 8.96199 13.9859 8.9195 14.0086 8.87679C14.4965 7.95543 14.769 6.92872 14.7971 5.87474C14.8265 4.7719 14.5871 3.68463 14.1073 2.70399C14.0232 2.53217 13.9317 2.36363 13.833 2.19885C13.8174 2.17275 13.8037 2.1459 13.7919 2.11849C13.675 1.84734 13.7444 1.52253 13.9881 1.3457C14.2563 1.15101 14.6337 1.20958 14.8078 1.49165C14.8263 1.5217 14.8446 1.55187 14.8628 1.58213C14.9764 1.77184 15.0819 1.96579 15.179 2.16343C15.7478 3.3205 16.0316 4.60439 15.9969 5.90673C15.9622 7.20906 15.6104 8.47601 14.9807 9.60114C14.8732 9.79332 14.7575 9.98138 14.634 10.1648C14.6143 10.194 14.5944 10.2232 14.5742 10.2522C14.3854 10.5246 14.0054 10.563 13.7479 10.3542C13.5141 10.1647 13.462 9.83665 13.5932 9.57211C13.6065 9.54537 13.6216 9.51929 13.6386 9.49406Z",
    ]}
  />
);

export const Email = (props: any) => {
  return (
    <Icon
      {...props}
      $size={212}
      width="212"
      height="183"
      viewBox="0 0 212 183"
      fill="none"
    >
      <path
        d="M105.624 182.816C163.959 182.816 211.248 171.121 211.248 156.694C211.248 142.268 163.959 130.572 105.624 130.572C47.2895 130.572 0 142.268 0 156.694C0 171.121 47.2895 182.816 105.624 182.816Z"
        fill="url(#paint0_linear_439_576)"
      />
      <path
        d="M25.9999 59.7255L97.6109 2.618C101.945 -0.83868 108.084 -0.875985 112.46 2.52777L186 59.7255V122.725H25.9999V59.7255Z"
        fill="url(#paint1_linear_439_576)"
      />
      <rect
        x="51.9999"
        y="21.7256"
        width="107"
        height="99"
        rx="3"
        fill="url(#paint2_linear_439_576)"
      />
      <path
        d="M110.507 112.656C107.164 114.823 102.852 114.798 99.5337 112.593L25.9999 63.7256V151.682H186V63.7256L110.507 112.656Z"
        fill="url(#paint3_linear_439_576)"
      />
      <path
        d="M112.975 94.0497C109.752 91.5045 105.216 91.4633 101.947 93.9496L25.9999 151.726H186L112.975 94.0497Z"
        fill="url(#paint4_linear_439_576)"
      />
      <mask
        id="mask0_439_576"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="86"
        y="42"
        width="45"
        height="36"
      >
        <path
          d="M101 68.2256L90.5 57.7256L86 62.2256L101 77.2256L131 47.2256L126.5 42.7256L101 68.2256Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_439_576)">
        <rect x="71" y="23.2256" width="72" height="72" fill="white" />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_439_576"
          x1="115.278"
          y1="203.26"
          x2="124.932"
          y2="74.9209"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDEAFF" />
          <stop offset="1" stopColor="#F0F6FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_439_576"
          x1="106"
          y1="-13.3334"
          x2="140.734"
          y2="114.074"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E6F0FF" />
          <stop offset="1" stopColor="#CEE2FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_439_576"
          x1="122.793"
          y1="120.726"
          x2="107.83"
          y2="15.3542"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7CB0FF" />
          <stop offset="1" stopColor="#4A91FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_439_576"
          x1="116.5"
          y1="160.726"
          x2="106"
          y2="-86.2744"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_439_576"
          x1="123.5"
          y1="234.042"
          x2="185.897"
          y2="50.8229"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const DarkEmail = (props: any) => {
  return (
    <Icon
      {...props}
      $size={212}
      width="212"
      height="183"
      viewBox="0 0 212 183"
      fill="none"
    >
      <path
        d="M105.624 182.444C163.959 182.444 211.248 170.748 211.248 156.322C211.248 141.895 163.959 130.199 105.624 130.199C47.2895 130.199 0 141.895 0 156.322C0 170.748 47.2895 182.444 105.624 182.444Z"
        fill="url(#paint0_linear_3251_96833)"
      />
      <path
        d="M26 59.7255L97.611 2.618C101.946 -0.83868 108.084 -0.875985 112.46 2.52777L186 59.7255V122.725H26V59.7255Z"
        fill="url(#paint1_linear_3251_96833)"
      />
      <rect
        x="52"
        y="21.7255"
        width="107"
        height="99"
        rx="3"
        fill="url(#paint2_linear_3251_96833)"
      />
      <path
        d="M110.508 112.656C107.164 114.823 102.852 114.798 99.5338 112.593L26 63.7256V151.682H186V63.7256L110.508 112.656Z"
        fill="url(#paint3_linear_3251_96833)"
      />
      <path
        d="M112.975 94.0496C109.752 91.5044 105.216 91.4632 101.948 93.9494L26 151.725H186L112.975 94.0496Z"
        fill="url(#paint4_linear_3251_96833)"
      />
      <mask
        id="mask0_3251_96833"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="86"
        y="42"
        width="45"
        height="36"
      >
        <path
          d="M101 68.2255L90.5 57.7255L86 62.2255L101 77.2255L131 47.2255L126.5 42.7255L101 68.2255Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_3251_96833)">
        <rect x="71" y="23.2255" width="72" height="72" fill="white" />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_3251_96833"
          x1="117.5"
          y1="270.289"
          x2="115"
          y2="86.7891"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0CFFF" />
          <stop offset="1" stopColor="#70A8FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3251_96833"
          x1="106"
          y1="-13.3334"
          x2="140.734"
          y2="114.074"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B8D4FF" />
          <stop offset="1" stopColor="#C2DBFF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3251_96833"
          x1="122.793"
          y1="120.725"
          x2="107.83"
          y2="15.3541"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7CB0FF" />
          <stop offset="1" stopColor="#3982F3" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3251_96833"
          x1="116.5"
          y1="160.726"
          x2="110.5"
          y2="-0.500006"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#79ACF6" />
          <stop offset="0.9999" stopColor="#C5DDFF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3251_96833"
          x1="106"
          y1="152"
          x2="106"
          y2="75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A0C6FE" />
          <stop offset="0.9999" stopColor="#E1EDFF" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const Discord = (props: any) => (
  <Icon
    {...props}
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    d={[
      "M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z",
    ]}
  />
);

export const OriginalDiscord = (props: any) => (
  <Discord {...props} fillColor="#5865F2" />
);

export const Security = (props: any) => {
  const prefix = useMemo(() => uuidv4(), []);

  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
    >
      <path
        d="M60.0007 105.817C88.0166 105.817 110.728 100.201 110.728 93.272C110.728 86.3434 88.0166 80.7266 60.0007 80.7266C31.9848 80.7266 9.27344 86.3434 9.27344 93.272C9.27344 100.201 31.9848 105.817 60.0007 105.817Z"
        fill={`url(#${prefix}paint0_linear_2793_15222)`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 27.1222V50.9187C30 67.5163 42.25 87.2336 60 96.0004C77.75 87.2336 90 67.5163 90 50.9187V27.1222C88.6895 27.286 87.3555 27.3718 86 27.3718C75.2031 27.3718 65.6758 21.9316 60 13.6367C54.3242 21.9316 44.7969 27.3718 34 27.3718C32.6445 27.3718 31.3105 27.286 30 27.1222ZM64 49.8268C64 51.4725 63.0625 52.8998 61.6914 53.6018L63 64.0532H56.5L57.8086 53.6018C56.8281 53.0987 56.0684 52.2252 55.7168 51.1644C55.5762 50.7433 55.5 50.2948 55.5 49.8268C55.5 47.483 57.4023 45.5838 59.75 45.5838C62.0977 45.5838 64 47.483 64 49.8268Z"
        fill={`url(#${prefix}paint1_linear_2793_15222)`}
      />
      <path
        d="M30 50.9187V27.1222C31.3105 27.286 32.6445 27.3718 34 27.3718C44.7969 27.3718 54.3242 21.9316 60 13.6367V45.5916C59.918 45.5916 59.834 45.5838 59.75 45.5838C57.4023 45.5838 55.5 47.483 55.5 49.8268C55.5 50.2948 55.5762 50.7433 55.7168 51.1644C56.0684 52.2252 56.8281 53.0987 57.8086 53.6018L56.5 64.0532H60V96.0004C42.25 87.2336 30 67.5163 30 50.9187Z"
        fill={`url(#${prefix}paint2_linear_2793_15222)`}
      />
      <defs>
        <linearGradient
          id={`${prefix}paint0_linear_2793_15222`}
          x1="64.6371"
          y1="115.636"
          x2="69.2734"
          y2="53.9993"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDEAFF" />
          <stop offset="1" stopColor="#F0F6FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint1_linear_2793_15222`}
          x1="60"
          y1="10.0913"
          x2="96"
          y2="76.6367"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DCEAFF" />
          <stop offset="1" stopColor="#9BC4FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint2_linear_2793_15222`}
          x1="68.4545"
          y1="3.54581"
          x2="24.2727"
          y2="89.1822"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6DBFA" />
          <stop offset="1" stopColor="#87B8FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const ConnectEmptyState = (props: any) => {
  const prefix = useMemo(() => uuidv4(), []);

  return (
    <Icon
      {...props}
      $size={308}
      width="308"
      height="188"
      viewBox="0 0 308 188"
      fill="none"
    >
      <path
        d="M148.502 179.644C206.837 179.644 254.126 167.949 254.126 153.522C254.126 139.095 206.837 127.4 148.502 127.4C90.1675 127.4 42.8781 139.095 42.8781 153.522C42.8781 167.949 90.1675 179.644 148.502 179.644Z"
        fill={`url(#${prefix}paint0_linear_439_1022)`}
      />
      <rect
        x="299.016"
        y="83.8506"
        width="17.7441"
        height="70.8911"
        rx="8.87206"
        transform="rotate(90 299.016 83.8506)"
        fill={`url(#${prefix}paint1_linear_439_1022)`}
      />
      <path
        d="M197.965 136.702H229.392C239.929 136.702 248.477 117.564 248.477 93.9486C248.477 70.3333 239.929 51.1875 229.392 51.1875H197.965C204.485 51.1875 210.24 58.5108 213.678 69.718C215.934 77.2417 217.088 85.5578 217.046 93.9782C217.088 102.396 215.934 110.71 213.678 118.231C210.24 129.379 204.485 136.702 197.965 136.702Z"
        fill={`url(#${prefix}paint2_linear_439_1022)`}
      />
      <path
        d="M225.455 67.4793C220.692 54.8556 212.729 46.5898 203.713 46.5898H194.977C180.398 46.5898 168.576 68.2068 168.576 94.8643C168.576 121.522 180.398 143.131 194.977 143.139H203.713C212.729 143.139 220.703 134.888 225.455 122.249C228.569 113.754 230.163 104.368 230.108 94.8643C230.163 85.3604 228.569 75.9745 225.455 67.4793Z"
        fill={`url(#${prefix}paint3_linear_439_1022)`}
      />
      <path
        d="M212.117 68.2018C207.813 55.7197 200.62 47.5395 192.464 47.5098C179.269 47.5098 168.576 68.9374 168.576 95.3282C168.576 121.719 179.269 143.117 192.464 143.139C200.62 143.139 207.813 134.966 212.117 122.454C214.938 114.04 216.382 104.742 216.332 95.3282C216.382 85.9141 214.938 76.6168 212.117 68.2018Z"
        fill={`url(#${prefix}paint4_linear_439_1022)`}
      />
      <path
        d="M195.326 82.886C195.324 82.8868 195.322 82.8884 195.321 82.8905C194.048 85.043 191.919 86.4521 189.509 86.4521H187.179C183.279 86.4521 180.117 82.7631 180.117 78.2138C180.117 73.6645 183.279 69.9768 187.179 69.9755H189.516C191.928 69.9755 194.061 71.3835 195.33 73.5404C196.149 74.9942 196.574 76.5926 196.574 78.2125C196.574 79.8312 196.149 81.4283 195.332 82.8812C195.331 82.8835 195.329 82.8851 195.326 82.886Z"
        fill={`url(#${prefix}paint5_linear_439_1022)`}
      />
      <path
        d="M191.658 82.8872C190.519 85.0377 188.611 86.447 186.45 86.4521C182.952 86.4521 180.117 82.7605 180.117 78.2138C180.117 73.6671 182.952 69.9806 186.45 69.9755C188.611 69.9755 190.519 71.3835 191.658 73.5404C192.394 74.994 192.776 76.5924 192.776 78.2125C192.776 79.8326 192.394 81.4311 191.658 82.8847V82.8872Z"
        fill="#94BEFF"
      />
      <rect
        x="149.559"
        y="72.5117"
        width="39.2433"
        height="11.4069"
        rx="5.70347"
        fill={`url(#${prefix}paint6_linear_439_1022)`}
      />
      <path
        d="M196.326 114.886C196.324 114.887 196.322 114.888 196.321 114.891C195.048 117.043 192.919 118.452 190.509 118.452H188.179C184.279 118.452 181.117 114.763 181.117 110.214C181.117 105.665 184.279 101.977 188.179 101.975H190.516C192.928 101.975 195.061 103.384 196.33 105.54C197.149 106.994 197.574 108.593 197.574 110.213C197.574 111.831 197.149 113.428 196.332 114.881C196.331 114.883 196.329 114.885 196.326 114.886Z"
        fill={`url(#${prefix}paint7_linear_439_1022)`}
      />
      <path
        d="M192.658 114.887C191.519 117.038 189.611 118.447 187.45 118.452C183.952 118.452 181.117 114.761 181.117 110.214C181.117 105.667 183.952 101.981 187.45 101.975C189.611 101.975 191.519 103.384 192.658 105.54C193.394 106.994 193.776 108.592 193.776 110.213C193.776 111.833 193.394 113.431 192.658 114.885V114.887Z"
        fill="#94BEFF"
      />
      <rect
        x="150.559"
        y="104.512"
        width="39.2433"
        height="11.4069"
        rx="5.70347"
        fill={`url(#${prefix}paint8_linear_439_1022)`}
      />
      <rect
        x="72.9728"
        y="83.3564"
        width="18.2652"
        height="72.9728"
        rx="9.13258"
        transform="rotate(90 72.9728 83.3564)"
        fill={`url(#${prefix}paint9_linear_439_1022)`}
      />
      <path
        d="M106.758 136.047H74.4091C63.5622 136.047 54.7628 116.346 54.7628 92.0377C54.7628 67.7289 63.5622 48.021 74.4091 48.021L106.758 48.021C100.047 48.021 94.1236 55.5593 90.5838 67.0957C88.2623 74.8402 87.0738 83.4005 87.1168 92.0682C87.0737 100.734 88.2621 109.291 90.5838 117.033C94.1236 128.508 100.047 136.047 106.758 136.047Z"
        fill={`url(#${prefix}paint10_linear_439_1022)`}
      />
      <path
        d="M78.4615 64.7914C83.3641 51.797 91.5614 43.2886 100.842 43.2886L109.835 43.2886C124.841 43.2886 137.01 65.5403 137.01 92.9805C137.01 120.421 124.841 142.665 109.835 142.673H100.842C91.5614 142.673 83.3528 134.179 78.4615 121.17C75.2562 112.425 73.6146 102.763 73.6717 92.9805C73.6146 83.1976 75.2562 73.5361 78.4615 64.7914Z"
        fill={`url(#${prefix}paint11_linear_439_1022)`}
      />
      <path
        d="M92.1905 65.535C96.6209 52.6864 104.025 44.2659 112.421 44.2354C126.003 44.2354 137.01 66.2922 137.01 93.4579C137.01 120.624 126.003 142.65 112.421 142.673C104.025 142.673 96.6209 134.26 92.1905 121.381C89.2873 112.719 87.8004 103.148 87.8521 93.4579C87.8004 83.7674 89.2873 74.1971 92.1905 65.535Z"
        fill={`url(#${prefix}paint12_linear_439_1022)`}
      />
      <path
        d="M113.376 83.0414C117.031 83.0414 119.994 79.0156 119.994 74.0495C119.994 69.0834 117.031 65.0576 113.376 65.0576C109.721 65.0576 106.758 69.0834 106.758 74.0495C106.758 79.0156 109.721 83.0414 113.376 83.0414Z"
        fill="#82B3FF"
      />
      <path
        d="M113.376 120.903C117.031 120.903 119.994 116.877 119.994 111.911C119.994 106.945 117.031 102.919 113.376 102.919C109.721 102.919 106.758 106.945 106.758 111.911C106.758 116.877 109.721 120.903 113.376 120.903Z"
        fill="#82B3FF"
      />
      <path
        d="M112.903 81.1486C115.775 81.1486 118.103 77.7585 118.103 73.5765C118.103 69.3945 115.775 66.0044 112.903 66.0044C110.032 66.0044 107.704 69.3945 107.704 73.5765C107.704 77.7585 110.032 81.1486 112.903 81.1486Z"
        fill={`url(#${prefix}paint13_linear_439_1022)`}
      />
      <path
        d="M112.903 119.009C115.775 119.009 118.103 115.619 118.103 111.437C118.103 107.255 115.775 103.865 112.903 103.865C110.032 103.865 107.704 107.255 107.704 111.437C107.704 115.619 110.032 119.009 112.903 119.009Z"
        fill={`url(#${prefix}paint14_linear_439_1022)`}
      />
      <defs>
        <linearGradient
          id={`${prefix}paint0_linear_439_1022`}
          x1="158.156"
          y1="200.087"
          x2="167.81"
          y2="71.7485"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDEAFF" />
          <stop offset="1" stopColor="#F0F6FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint1_linear_439_1022`}
          x1="341.499"
          y1="86.1758"
          x2="270.779"
          y2="93.5914"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#98C0FF" />
          <stop offset="0.567708" stopColor="#D5E5FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint2_linear_439_1022`}
          x1="172.646"
          y1="157.317"
          x2="263.746"
          y2="130.926"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6FA7F8" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint3_linear_439_1022`}
          x1="168.576"
          y1="77.079"
          x2="214.423"
          y2="130.098"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D5E5FF" />
          <stop offset="1" stopColor="#98C0FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint4_linear_439_1022`}
          x1="158.531"
          y1="136.869"
          x2="272.453"
          y2="108.412"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6DDFF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint5_linear_439_1022`}
          x1="196.574"
          y1="81.249"
          x2="189.885"
          y2="69.1261"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint6_linear_439_1022`}
          x1="188.802"
          y1="76.1139"
          x2="187.092"
          y2="86.788"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D5E5FF" />
          <stop offset="1" stopColor="#98C0FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint7_linear_439_1022`}
          x1="197.574"
          y1="113.249"
          x2="190.885"
          y2="101.126"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint8_linear_439_1022`}
          x1="189.802"
          y1="108.114"
          x2="188.092"
          y2="118.788"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D5E5FF" />
          <stop offset="1" stopColor="#98C0FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint9_linear_439_1022`}
          x1="116.703"
          y1="85.75"
          x2="43.9063"
          y2="93.3833"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#98C0FF" />
          <stop offset="0.567708" stopColor="#D5E5FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint10_linear_439_1022`}
          x1="132.821"
          y1="157.266"
          x2="39.0454"
          y2="130.101"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6FA7F8" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint11_linear_439_1022`}
          x1="137.01"
          y1="74.673"
          x2="89.8171"
          y2="129.249"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D5E5FF" />
          <stop offset="1" stopColor="#98C0FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint12_linear_439_1022`}
          x1="147.35"
          y1="136.218"
          x2="30.0834"
          y2="106.926"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6DDFF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint13_linear_439_1022`}
          x1="118.103"
          y1="70.7868"
          x2="111.008"
          y2="79.6272"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5597FD" />
          <stop offset="1" stopColor="#BCD6FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint14_linear_439_1022`}
          x1="118.103"
          y1="108.648"
          x2="111.008"
          y2="117.488"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5597FD" />
          <stop offset="1" stopColor="#BCD6FF" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const SearchEmptyState = (props: any) => {
  return (
    <Icon
      {...props}
      $size={212}
      width="212"
      height="181"
      viewBox="0 0 212 181"
      fill="none"
    >
      <path
        d="M105.624 180.644C163.959 180.644 211.248 168.948 211.248 154.521C211.248 140.095 163.959 128.399 105.624 128.399C47.2895 128.399 0 140.095 0 154.521C0 168.948 47.2895 180.644 105.624 180.644Z"
        fill="url(#paint0_linear_439_1125)"
      />
      <path
        d="M104.313 92.6509L110.147 98.9188L109.6 99.6785C108.506 101.008 108.506 103.097 109.6 104.427L140.591 141.275C141.868 142.794 143.326 144.124 145.149 145.074C146.972 146.023 148.795 146.593 150.8 146.023C152.988 145.453 154.993 143.934 155.176 140.705C155.358 138.426 154.629 136.336 153.17 134.627L121.996 95.6899C120.538 93.9804 118.35 93.6006 116.892 94.7402L110.693 86.9528C110.693 86.5729 105.953 88.2823 104.313 92.6509Z"
        fill="url(#paint1_linear_439_1125)"
      />
      <foreignObject x="28.2905" y="3.68848" width="98.0703" height="100.833">
        <div
          style={{
            backdropFilter: "blur(1px)",
            clipPath: "url(#bgblur_0_439_1125_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <g filter="url(#filter0_i_439_1125)" data-figma-bg-blur-radius="2">
        <path
          d="M77.3257 102.521C103.303 102.521 124.361 80.8446 124.361 54.1049C124.361 27.3653 103.303 5.68848 77.3257 5.68848C51.3489 5.68848 30.2905 27.3653 30.2905 54.1049C30.2905 80.8446 51.3489 102.521 77.3257 102.521Z"
          fill="url(#paint2_radial_439_1125)"
          fillOpacity="0.33"
        />
      </g>
      <rect
        width="84.4969"
        height="78.3695"
        rx="25.117"
        transform="matrix(0.953634 0.30097 -0.294091 0.955777 53.1863 0)"
        fill="url(#paint3_linear_439_1125)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M77.3258 12.5718C54.344 12.5718 35.7136 31.1665 35.7136 54.1043C35.7136 77.0422 54.344 95.637 77.3258 95.637C100.308 95.637 118.938 77.0422 118.938 54.1043C118.938 31.1665 100.308 12.5718 77.3258 12.5718ZM24.1221 54.1043C24.1221 24.777 47.9422 1.00244 77.3258 1.00244C106.709 1.00244 130.53 24.777 130.53 54.1043C130.53 83.4317 106.709 107.206 77.3258 107.206C47.9422 107.206 24.1221 83.4317 24.1221 54.1043Z"
        fill="url(#paint4_linear_439_1125)"
      />
      <defs>
        <filter
          id="filter0_i_439_1125"
          x="28.2905"
          y="3.68848"
          width="98.0703"
          height="100.833"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.85204" />
          <feGaussianBlur stdDeviation="11.5753" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.560784 0 0 0 0 0.607843 0 0 0 0 1 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_439_1125"
          />
        </filter>
        <clipPath
          id="bgblur_0_439_1125_clip_path"
          transform="translate(-28.2905 -3.68848)"
        >
          <path d="M77.3257 102.521C103.303 102.521 124.361 80.8446 124.361 54.1049C124.361 27.3653 103.303 5.68848 77.3257 5.68848C51.3489 5.68848 30.2905 27.3653 30.2905 54.1049C30.2905 80.8446 51.3489 102.521 77.3257 102.521Z" />
        </clipPath>
        <linearGradient
          id="paint0_linear_439_1125"
          x1="115.278"
          y1="201.087"
          x2="124.932"
          y2="72.748"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDEAFF" />
          <stop offset="1" stopColor="#F0F6FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_439_1125"
          x1="155.203"
          y1="105.643"
          x2="129.295"
          y2="145.953"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <radialGradient
          id="paint2_radial_439_1125"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(77.3257 54.1049) rotate(90) scale(48.4165 47.0352)"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#EEF5FF" />
        </radialGradient>
        <linearGradient
          id="paint3_linear_439_1125"
          x1="42.2484"
          y1="0"
          x2="42.2484"
          y2="78.3695"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_439_1125"
          x1="112.024"
          y1="-30.234"
          x2="96.4375"
          y2="109.341"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#7FB0FB" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const PublicIcon = (props: any) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <circle cx="10" cy="10" r="10" fill="#4371F5" />
    <g clipPath="url(#clip0_2922_44006)">
      <path
        d="M16.1109 13.3333C16.1109 13.4807 16.0524 13.622 15.9482 13.7262C15.844 13.8304 15.7027 13.8889 15.5553 13.8889H8.88867C8.74133 13.8889 8.60002 13.8304 8.49584 13.7262C8.39165 13.622 8.33312 13.4807 8.33312 13.3333C8.33312 12.4493 8.68431 11.6014 9.30943 10.9763C9.93455 10.3512 10.7824 10 11.6665 10H12.7776C13.6616 10 14.5095 10.3512 15.1346 10.9763C15.7597 11.6014 16.1109 12.4493 16.1109 13.3333ZM12.222 5C11.7825 5 11.3528 5.13033 10.9874 5.37451C10.622 5.61869 10.3371 5.96576 10.1689 6.37181C10.0007 6.77787 9.95674 7.22469 10.0425 7.65576C10.1282 8.08683 10.3399 8.48279 10.6507 8.79357C10.9614 9.10435 11.3574 9.316 11.7885 9.40175C12.2195 9.48749 12.6664 9.44348 13.0724 9.27529C13.4785 9.10709 13.8255 8.82227 14.0697 8.45682C14.3139 8.09138 14.4442 7.66174 14.4442 7.22222C14.4442 6.63285 14.2101 6.06762 13.7934 5.65087C13.3766 5.23413 12.8114 5 12.222 5ZM7.22201 5C6.78249 5 6.35285 5.13033 5.9874 5.37451C5.62196 5.61869 5.33713 5.96576 5.16894 6.37181C5.00074 6.77787 4.95674 7.22469 5.04248 7.65576C5.12823 8.08683 5.33987 8.48279 5.65066 8.79357C5.96144 9.10435 6.3574 9.316 6.78847 9.40175C7.21954 9.48749 7.66636 9.44348 8.07241 9.27529C8.47847 9.10709 8.82553 8.82227 9.06972 8.45682C9.3139 8.09138 9.44423 7.66174 9.44423 7.22222C9.44423 6.63285 9.2101 6.06762 8.79335 5.65087C8.37661 5.23413 7.81138 5 7.22201 5ZM7.22201 13.3333C7.22118 12.7498 7.33615 12.1719 7.56025 11.6331C7.78436 11.0943 8.11314 10.6053 8.52756 10.1944C8.18841 10.0664 7.82896 10.0005 7.46645 10H6.97756C6.15879 10.0015 5.37397 10.3274 4.79501 10.9063C4.21605 11.4853 3.89014 12.2701 3.88867 13.0889V13.3333C3.88867 13.4807 3.9472 13.622 4.05139 13.7262C4.15558 13.8304 4.29688 13.8889 4.44423 13.8889H7.32201C7.25733 13.7107 7.22351 13.5229 7.22201 13.3333Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2922_44006">
        <rect
          width="13.3333"
          height="13.3333"
          fill="white"
          transform="translate(3.33301 2.77734)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const PrivateIcon = (props: any) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <circle cx="10" cy="10" r="10" fill="#4371F5" />
    <g clipPath="url(#clip0_2922_43962)">
      <path
        d="M14.5068 9.70437C14.3532 9.55085 14.1669 9.47414 13.9475 9.47414H13.6845V7.89511C13.6845 6.88635 13.3227 6.0202 12.599 5.29651C11.8754 4.5728 11.0093 4.21094 10.0004 4.21094C8.99153 4.21094 8.1253 4.5728 7.4017 5.29648C6.67798 6.0202 6.31624 6.88632 6.31624 7.89511V9.47414H6.05312C5.83389 9.47414 5.64745 9.55085 5.49393 9.70437C5.3404 9.85778 5.26367 10.0442 5.26367 10.2636V15.0004C5.26367 15.2197 5.34043 15.4062 5.49393 15.5597C5.64745 15.7131 5.83389 15.7899 6.05312 15.7899H13.9477C14.1671 15.7899 14.3534 15.7132 14.507 15.5597C14.6603 15.4062 14.7372 15.2197 14.7372 15.0004V10.2636C14.7373 10.0443 14.6604 9.85789 14.5068 9.70437ZM12.1056 9.47414H7.89519V7.89511C7.89519 7.314 8.10082 6.8178 8.51199 6.40669C8.92321 5.99552 9.41932 5.78997 10.0005 5.78997C10.5817 5.78997 11.0777 5.99549 11.489 6.40669C11.9 6.81777 12.1056 7.314 12.1056 7.89511V9.47414Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2922_43962">
        <rect
          width="11.5789"
          height="11.5789"
          fill="white"
          transform="translate(4.21094 4.21094)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const Google = (props: any) => (
  <Icon {...props} viewBox={"0 0 48 48"}>
    <path
      fill="#EA4335"
      d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
    />
    <path
      fill="#4285F4"
      d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
    />
    <path
      fill="#FBBC05"
      d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
    />
    <path
      fill="#34A853"
      d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
    />
  </Icon>
);

export const Apple = (props: any) => (
  <Icon viewBox={"0 0 18 18"} {...props}>
    <path
      fill="black"
      d="M13.4975 9.66702C13.5146 8.34391 14.2082 7.12175 15.3355 6.42874C14.6211 5.40852 13.4675 4.78487 12.2227 4.74592C10.913 4.60845 9.64332 5.52961 8.97592 5.52961C8.29562 5.52961 7.26807 4.75957 6.16157 4.78233C4.70571 4.82937 3.38135 5.63705 2.67304 6.90986C1.16471 9.52136 2.28979 13.3594 3.73468 15.4704C4.45759 16.504 5.30245 17.6587 6.40796 17.6177C7.48976 17.5728 7.89379 16.9279 9.19961 16.9279C10.4933 16.9279 10.8724 17.6177 12.0003 17.5917C13.1611 17.5728 13.8925 16.5534 14.5901 15.51C15.1095 14.7734 15.5092 13.9594 15.7743 13.098C14.3956 12.5149 13.4991 11.164 13.4975 9.66702Z"
    />
    <path
      fill="black"
      d="M11.3671 3.35761C12 2.5978 12.3118 1.6212 12.2363 0.635193C11.2694 0.736754 10.3761 1.1989 9.73467 1.92956C9.10124 2.65045 8.78034 3.59356 8.84266 4.55118C9.8226 4.56127 10.753 4.12135 11.3671 3.35761Z"
    />
  </Icon>
);

export const Facebook = (props: any) => (
  <Icon viewBox={"0 0 18 18"} {...props}>
    <path
      fill="#4167B2"
      d="M3 1a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H3Zm6.55 16v-6.2H7.46V8.4h2.09V6.61c0-2.07 1.26-3.2 3.1-3.2.88 0 1.64.07 1.87.1v2.16h-1.29c-1 0-1.19.48-1.19 1.18V8.4h2.39l-.31 2.42h-2.08V17h-2.5Z"
    />
  </Icon>
);

export const GearsEmptyState = (props: any) => (
  <StyledIcon
    width="254"
    height="168"
    viewBox="0 0 254 168"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M127 167.045C197.04 167.045 253.818 153.003 253.818 135.682C253.818 118.36 197.04 104.318 127 104.318C56.9601 104.318 0.181641 118.36 0.181641 135.682C0.181641 153.003 56.9601 167.045 127 167.045Z"
      fill="url(#paint0_linear_3490_31315)"
    />
    <path
      d="M231.784 32.9385L229.328 33.348C228.073 33.5585 227.025 34.3997 226.524 35.6006L226.518 35.6171C226.505 35.6476 226.492 35.6784 226.478 35.7089C225.973 36.9134 226.116 38.2545 226.863 39.2998L228.258 41.2562C228.671 41.8353 228.606 42.6278 228.103 43.1308L223.995 47.2402C223.491 47.7433 222.698 47.8089 222.119 47.3955L220.093 45.9489C219.056 45.2092 217.726 45.0607 216.529 45.5541L216.435 45.5925C215.21 46.0891 214.353 47.1437 214.141 48.4138L213.745 50.784C213.627 51.4858 213.02 52 212.309 52H206.497C205.786 52 205.178 51.4854 205.061 50.7837L204.652 48.3292C204.441 47.0731 203.6 46.0246 202.398 45.524L202.381 45.5168C202.351 45.5043 202.321 45.4914 202.291 45.4785C201.087 44.9729 199.746 45.1163 198.7 45.8625L196.743 47.2581C196.164 47.6712 195.372 47.6052 194.869 47.1025L190.76 42.9942C190.256 42.4911 190.191 41.698 190.604 41.1188L192.051 39.0929C192.79 38.0558 192.939 36.7255 192.445 35.5278L192.407 35.4346C191.91 34.2101 190.856 33.3523 189.586 33.1404L187.216 32.7442C186.514 32.6273 186 32.0198 186 31.3084V25.4972C186 24.7855 186.514 24.1784 187.216 24.0611L189.671 23.652C190.927 23.4415 191.975 22.6003 192.476 21.399L192.482 21.3829C192.495 21.3524 192.508 21.3212 192.522 21.2907C193.027 20.0862 192.883 18.7451 192.137 17.7002L190.742 15.7435C190.328 15.1647 190.394 14.3719 190.897 13.8688L195.005 9.75981C195.508 9.25672 196.302 9.19074 196.881 9.60419L198.906 11.0507C199.944 11.7905 201.274 11.9389 202.471 11.4455L202.565 11.4071C203.789 10.9109 204.647 9.85627 204.859 8.58582L205.255 6.21595C205.372 5.51421 205.979 5 206.691 5H212.502C213.214 5 213.822 5.51421 213.939 6.21631L214.348 8.6708C214.558 9.92691 215.399 10.975 216.601 11.476L216.619 11.4832C216.648 11.4957 216.678 11.5083 216.708 11.5215C217.913 12.0268 219.254 11.8837 220.3 11.1375L222.256 9.74188C222.835 9.3288 223.628 9.39442 224.131 9.89751L228.24 14.0054C228.743 14.5089 228.809 15.302 228.395 15.8812L226.949 17.9068C226.209 18.9438 226.061 20.2741 226.554 21.4722L226.593 21.565C227.089 22.7899 228.144 23.6473 229.414 23.8596L231.784 24.2555C232.486 24.3727 233 24.9798 233 25.6912V31.5028C233 32.2142 232.486 32.8216 231.784 32.9385V32.9385ZM206.013 25.0128C204.088 26.9384 204.088 30.0616 206.013 31.9868C207.938 33.9124 211.062 33.9124 212.987 31.9868C214.912 30.0616 214.912 26.9384 212.987 25.0128C211.062 23.0872 207.938 23.0872 206.013 25.0128Z"
      fill="#98BFFD"
    />
    <path
      d="M229.784 30.9385L227.328 31.348C226.073 31.5585 225.025 32.3997 224.524 33.6006L224.518 33.6171C224.505 33.6476 224.492 33.6784 224.478 33.7089C223.973 34.9134 224.116 36.2545 224.863 37.2998L226.258 39.2562C226.671 39.8353 226.606 40.6278 226.103 41.1308L221.995 45.2402C221.491 45.7433 220.698 45.8089 220.119 45.3955L218.093 43.9489C217.056 43.2092 215.726 43.0607 214.529 43.5541L214.435 43.5925C213.21 44.0891 212.353 45.1437 212.141 46.4138L211.745 48.784C211.627 49.4858 211.02 50 210.309 50H204.497C203.786 50 203.178 49.4854 203.061 48.7837L202.652 46.3292C202.441 45.0731 201.6 44.0246 200.398 43.524L200.381 43.5168C200.351 43.5043 200.321 43.4914 200.291 43.4785C199.087 42.9729 197.746 43.1163 196.7 43.8625L194.743 45.2581C194.164 45.6712 193.372 45.6052 192.869 45.1025L188.76 40.9942C188.256 40.4911 188.191 39.698 188.604 39.1188L190.051 37.0929C190.79 36.0558 190.939 34.7255 190.445 33.5278L190.407 33.4346C189.91 32.2101 188.856 31.3523 187.586 31.1404L185.216 30.7442C184.514 30.6273 184 30.0198 184 29.3084V23.4972C184 22.7855 184.514 22.1784 185.216 22.0611L187.671 21.652C188.927 21.4415 189.975 20.6003 190.476 19.399L190.482 19.3829C190.495 19.3524 190.508 19.3212 190.522 19.2907C191.027 18.0862 190.883 16.7451 190.137 15.7002L188.742 13.7435C188.328 13.1647 188.394 12.3719 188.897 11.8688L193.005 7.75981C193.508 7.25672 194.302 7.19074 194.881 7.60419L196.906 9.0507C197.944 9.79046 199.274 9.93891 200.471 9.4455L200.565 9.40714C201.789 8.91086 202.647 7.85627 202.859 6.58582L203.255 4.21595C203.372 3.51421 203.979 3 204.691 3H210.502C211.214 3 211.822 3.51421 211.939 4.21631L212.348 6.6708C212.558 7.92691 213.399 8.97504 214.601 9.47598L214.619 9.48315C214.648 9.4957 214.678 9.50826 214.708 9.52152C215.913 10.0268 217.254 9.88369 218.3 9.13748L220.256 7.74188C220.835 7.3288 221.628 7.39442 222.131 7.89751L226.24 12.0054C226.743 12.5089 226.809 13.302 226.395 13.8812L224.949 15.9068C224.209 16.9438 224.061 18.2741 224.554 19.4722L224.593 19.565C225.089 20.7899 226.144 21.6473 227.414 21.8596L229.784 22.2555C230.486 22.3727 231 22.9798 231 23.6912V29.5028C231 30.2142 230.486 30.8216 229.784 30.9385V30.9385ZM204.013 23.0128C202.088 24.9384 202.088 28.0616 204.013 29.9868C205.938 31.9124 209.062 31.9124 210.987 29.9868C212.912 28.0616 212.912 24.9384 210.987 23.0128C209.062 21.0872 205.938 21.0872 204.013 23.0128Z"
      fill="url(#paint1_linear_3490_31315)"
    />
    <path
      d="M64.8613 115.155L62.5628 115.539C61.3872 115.736 60.4063 116.523 59.9377 117.647L59.9313 117.663C59.9193 117.691 59.9072 117.72 59.8944 117.749C59.4218 118.876 59.5557 120.132 60.2546 121.11L61.5611 122.942C61.9475 123.484 61.8861 124.226 61.4154 124.697L57.5694 128.544C57.0984 129.015 56.3555 129.076 55.8137 128.689L53.9171 127.335C52.9462 126.643 51.7011 126.504 50.5803 126.966L50.4923 127.001C49.3459 127.466 48.5429 128.454 48.3445 129.643L47.9739 131.862C47.8638 132.519 47.2955 133 46.6295 133H41.1889C40.5229 133 39.9542 132.518 39.8445 131.861L39.4614 129.564C39.2644 128.388 38.4768 127.406 37.3516 126.937L37.3358 126.931C37.3076 126.919 37.2794 126.907 37.2516 126.895C36.124 126.421 34.8681 126.556 33.8893 127.254L32.0577 128.561C31.5156 128.948 30.7737 128.886 30.3027 128.415L26.456 124.569C25.9847 124.098 25.9232 123.356 26.3103 122.813L27.6645 120.917C28.357 119.946 28.496 118.7 28.0338 117.579L27.9982 117.492C27.5332 116.346 26.546 115.543 25.3569 115.344L23.138 114.973C22.4814 114.864 22 114.295 22 113.629V108.189C22 107.523 22.4814 106.954 23.1387 106.844L25.4365 106.461C26.6124 106.264 27.5937 105.477 28.0623 104.352L28.0687 104.337C28.0804 104.309 28.0928 104.279 28.1053 104.251C28.5782 103.123 28.444 101.868 27.7454 100.89L26.4389 99.0577C26.0522 98.5159 26.1139 97.7737 26.5846 97.3027L30.4306 93.456C30.9012 92.985 31.6441 92.9232 32.1863 93.3103L34.0826 94.6645C35.0538 95.357 36.2989 95.496 37.4197 95.0341L37.5077 94.9982C38.6537 94.5336 39.4571 93.5463 39.6555 92.3569L40.0261 90.1383C40.1358 89.4814 40.7042 89 41.3702 89H46.8108C47.4771 89 48.0458 89.4814 48.1552 90.1387L48.5386 92.4365C48.7353 93.6124 49.5228 94.5937 50.6481 95.0626L50.6642 95.0693C50.692 95.0811 50.7202 95.0928 50.7481 95.1053C51.876 95.5782 53.1319 95.4443 54.1104 94.7457L55.942 93.4392C56.4841 93.0525 57.2263 93.1139 57.697 93.5849L61.544 97.4306C62.015 97.9019 62.0764 98.6445 61.6894 99.1866L60.3352 101.083C59.6426 102.054 59.5037 103.299 59.9659 104.421L60.0018 104.508C60.4664 105.654 61.4537 106.457 62.6431 106.656L64.8617 107.026C65.5186 107.136 66 107.704 66 108.371V113.811C66 114.477 65.5186 115.046 64.8613 115.155V115.155ZM40.7354 107.735C38.933 109.538 38.933 112.462 40.7354 114.264C42.5381 116.067 45.4619 116.067 47.2646 114.264C49.067 112.462 49.067 109.538 47.2646 107.735C45.4619 105.933 42.5381 105.933 40.7354 107.735Z"
      fill="#98BFFD"
    />
    <path
      d="M63.8613 114.155L61.5628 114.539C60.3872 114.736 59.4063 115.523 58.9377 116.647L58.9313 116.663C58.9193 116.691 58.9072 116.72 58.8944 116.749C58.4218 117.876 58.5557 119.132 59.2546 120.11L60.5611 121.942C60.9475 122.484 60.8861 123.226 60.4154 123.697L56.5694 127.544C56.0984 128.015 55.3555 128.076 54.8137 127.689L52.9171 126.335C51.9462 125.643 50.7011 125.504 49.5803 125.966L49.4923 126.001C48.3459 126.466 47.5429 127.454 47.3445 128.643L46.9739 130.862C46.8638 131.519 46.2955 132 45.6295 132H40.1889C39.5229 132 38.9542 131.518 38.8445 130.861L38.4614 128.564C38.2644 127.388 37.4768 126.406 36.3516 125.937L36.3358 125.931C36.3076 125.919 36.2794 125.907 36.2516 125.895C35.124 125.421 33.8681 125.556 32.8893 126.254L31.0577 127.561C30.5156 127.948 29.7737 127.886 29.3027 127.415L25.456 123.569C24.9847 123.098 24.9232 122.356 25.3103 121.813L26.6645 119.917C27.357 118.946 27.496 117.7 27.0338 116.579L26.9982 116.492C26.5332 115.346 25.546 114.543 24.3569 114.344L22.138 113.973C21.4814 113.864 21 113.295 21 112.629V107.189C21 106.523 21.4814 105.954 22.1387 105.844L24.4365 105.461C25.6124 105.264 26.5937 104.477 27.0623 103.352L27.0687 103.337C27.0804 103.309 27.0928 103.279 27.1053 103.251C27.5782 102.123 27.444 100.868 26.7454 99.8896L25.4389 98.0577C25.0522 97.5159 25.1139 96.7737 25.5846 96.3027L29.4306 92.456C29.9012 91.985 30.6441 91.9232 31.1863 92.3103L33.0826 93.6645C34.0538 94.357 35.2989 94.496 36.4197 94.0341L36.5077 93.9982C37.6537 93.5336 38.4571 92.5463 38.6555 91.3569L39.0261 89.1383C39.1358 88.4814 39.7042 88 40.3702 88H45.8108C46.4771 88 47.0458 88.4814 47.1552 89.1387L47.5386 91.4365C47.7353 92.6124 48.5228 93.5937 49.6481 94.0626L49.6642 94.0693C49.692 94.0811 49.7202 94.0928 49.7481 94.1053C50.876 94.5782 52.1319 94.4443 53.1104 93.7457L54.942 92.4392C55.4841 92.0525 56.2263 92.1139 56.697 92.5849L60.544 96.4306C61.015 96.9019 61.0764 97.6445 60.6894 98.1866L59.3352 100.083C58.6426 101.054 58.5037 102.299 58.9659 103.421L59.0018 103.508C59.4664 104.654 60.4537 105.457 61.6431 105.656L63.8617 106.026C64.5186 106.136 65 106.704 65 107.371V112.811C65 113.477 64.5186 114.046 63.8613 114.155V114.155ZM39.7354 106.735C37.933 108.538 37.933 111.462 39.7354 113.264C41.5381 115.067 44.4619 115.067 46.2646 113.264C48.067 111.462 48.067 108.538 46.2646 106.735C44.4619 104.933 41.5381 104.933 39.7354 106.735Z"
      fill="url(#paint2_linear_3490_31315)"
    />
    <path
      d="M183.791 76.7101L177.313 77.7905C174 78.3459 171.236 80.5653 169.915 83.7336L169.897 83.7771C169.863 83.8575 169.829 83.9389 169.793 84.0193C168.461 87.1971 168.839 90.7353 170.808 93.493L174.49 98.6546C175.579 100.182 175.406 102.273 174.08 103.601L163.241 114.442C161.914 115.77 159.82 115.943 158.293 114.852L152.948 111.035C150.212 109.084 146.703 108.692 143.544 109.994L143.297 110.095C140.066 111.405 137.803 114.188 137.244 117.539L136.199 123.792C135.889 125.643 134.287 127 132.41 127H117.078C115.201 127 113.598 125.642 113.289 123.791L112.209 117.315C111.654 114.001 109.435 111.235 106.264 109.914L106.219 109.896C106.14 109.862 106.06 109.828 105.982 109.794C102.804 108.46 99.2647 108.839 96.5061 110.807L91.3445 114.49C89.8166 115.579 87.7258 115.405 86.3985 114.079L75.5578 103.24C74.2296 101.913 74.0564 99.8201 75.1472 98.2923L78.9636 92.9471C80.9153 90.2112 81.3069 86.7013 80.0042 83.5415L79.9039 83.2956C78.5937 80.0648 75.8113 77.8019 72.4604 77.2428L66.2071 76.1974C64.3566 75.889 63 74.2864 63 72.4094V57.0778C63 55.1999 64.3566 53.5983 66.209 53.2889L72.6847 52.2095C75.9987 51.6541 78.7639 49.4347 80.0846 46.2655L80.1026 46.2229C80.1357 46.1425 80.1707 46.0602 80.2057 45.9798C81.5387 42.802 81.1603 39.2638 79.1916 36.507L75.5096 31.3445C74.4197 29.8175 74.5938 27.7258 75.9201 26.3985L86.759 15.5578C88.0853 14.2305 90.1789 14.0564 91.7068 15.1472L97.051 18.9636C99.7879 20.9153 103.297 21.3069 106.456 20.0052L106.703 19.9039C109.933 18.5946 112.197 15.8123 112.756 12.4604L113.801 6.20804C114.11 4.35663 115.712 3 117.589 3H132.921C134.799 3 136.402 4.35663 136.71 6.20898L137.791 12.6847C138.345 15.9987 140.564 18.7639 143.735 20.0856L143.781 20.1045C143.859 20.1376 143.939 20.1707 144.017 20.2057C147.196 21.5387 150.735 21.1612 153.493 19.1925L158.655 15.5105C160.182 14.4207 162.274 14.5938 163.601 15.9211L174.442 26.759C175.77 28.0872 175.943 30.1799 174.852 31.7077L171.035 37.0519C169.084 39.7879 168.692 43.2977 169.995 46.4585L170.096 46.7035C171.405 49.9352 174.188 52.1972 177.54 52.7572L183.792 53.8017C185.643 54.111 187 55.7127 187 57.5896V72.9222C187 74.7991 185.643 76.4017 183.791 76.7101V76.7101ZM115.8 55.7997C110.72 60.88 110.72 69.12 115.8 74.1993C120.88 79.2796 129.12 79.2796 134.2 74.1993C139.28 69.12 139.28 60.88 134.2 55.7997C129.12 50.7195 120.88 50.7195 115.8 55.7997Z"
      fill="#98BFFD"
    />
    <path
      d="M180.791 73.7101L174.313 74.7905C171 75.3459 168.236 77.5653 166.915 80.7336L166.897 80.7771C166.863 80.8575 166.829 80.9389 166.793 81.0193C165.461 84.1971 165.839 87.7353 167.808 90.493L171.49 95.6546C172.579 97.1825 172.406 99.2732 171.08 100.601L160.241 111.442C158.914 112.77 156.82 112.943 155.293 111.852L149.948 108.035C147.212 106.084 143.703 105.692 140.544 106.994L140.297 107.095C137.066 108.405 134.803 111.188 134.244 114.539L133.199 120.792C132.889 122.643 131.287 124 129.41 124H114.078C112.201 124 110.598 122.642 110.289 120.791L109.209 114.315C108.654 111.001 106.435 108.235 103.264 106.914L103.219 106.896C103.14 106.862 103.06 106.828 102.982 106.794C99.8039 105.46 96.2647 105.839 93.5061 107.807L88.3445 111.49C86.8166 112.579 84.7258 112.405 83.3985 111.079L72.5578 100.24C71.2296 98.9128 71.0564 96.8201 72.1472 95.2923L75.9636 89.9471C77.9153 87.2112 78.3069 83.7013 77.0042 80.5415L76.9039 80.2956C75.5937 77.0648 72.8113 74.8019 69.4604 74.2428L63.2071 73.1974C61.3566 72.889 60 71.2864 60 69.4094V54.0778C60 52.1999 61.3566 50.5983 63.209 50.2889L69.6847 49.2095C72.9987 48.6541 75.7639 46.4347 77.0846 43.2655L77.1026 43.2229C77.1357 43.1425 77.1707 43.0602 77.2057 42.9798C78.5387 39.802 78.1603 36.2638 76.1916 33.507L72.5096 28.3445C71.4197 26.8175 71.5938 24.7258 72.9201 23.3985L83.759 12.5578C85.0853 11.2305 87.1789 11.0564 88.7068 12.1472L94.051 15.9636C96.7879 17.9153 100.297 18.3069 103.456 17.0052L103.703 16.9039C106.933 15.5946 109.197 12.8123 109.756 9.46045L110.801 3.20804C111.11 1.35663 112.712 0 114.589 0H129.921C131.799 0 133.402 1.35663 133.71 3.20898L134.791 9.68466C135.345 12.9987 137.564 15.7639 140.735 17.0856L140.781 17.1045C140.859 17.1376 140.939 17.1707 141.017 17.2057C144.196 18.5387 147.735 18.1612 150.493 16.1925L155.655 12.5105C157.182 11.4207 159.274 11.5938 160.601 12.9211L171.442 23.759C172.77 25.0872 172.943 27.1799 171.852 28.7077L168.035 34.0519C166.084 36.7879 165.692 40.2977 166.995 43.4585L167.096 43.7035C168.405 46.9352 171.188 49.1972 174.54 49.7572L180.792 50.8017C182.643 51.111 184 52.7127 184 54.5896V69.9222C184 71.7991 182.643 73.4017 180.791 73.7101V73.7101ZM112.8 52.7997C107.72 57.88 107.72 66.12 112.8 71.1993C117.88 76.2796 126.12 76.2796 131.2 71.1993C136.28 66.12 136.28 57.88 131.2 52.7997C126.12 47.7195 117.88 47.7195 112.8 52.7997Z"
      fill="url(#paint3_linear_3490_31315)"
    />
    <circle
      cx="122"
      cy="62"
      r="18"
      stroke="url(#paint4_linear_3490_31315)"
      strokeWidth="10"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3490_31315"
        x1="138.591"
        y1="191.591"
        x2="150.182"
        y2="37.4999"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DDEAFF" />
        <stop offset="1" stopColor="#F0F6FF" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3490_31315"
        x1="207.5"
        y1="50.0001"
        x2="224.703"
        y2="-30.2568"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DBE9FF" />
        <stop offset="1" stopColor="#B9D4FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3490_31315"
        x1="43"
        y1="135"
        x2="40.2179"
        y2="78.6437"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BDD7FF" />
        <stop offset="1" stopColor="#E7F0FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3490_31315"
        x1="146.911"
        y1="47.0535"
        x2="-13.336"
        y2="157.173"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D6E6FF" />
        <stop offset="0.982184" stopColor="#9AC2FF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3490_31315"
        x1="149.625"
        y1="21.375"
        x2="103.124"
        y2="136.206"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C8DDFF" />
        <stop offset="1" stopColor="#9CC3FF" />
      </linearGradient>
    </defs>
  </StyledIcon>
);

export const DashboardIcon = (props: any) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <rect width="16" height="16" fill="transparent" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.28739 2.28544V13.714H13.716V2.28544H2.28739ZM1.60167 1.14258C1.3492 1.14258 1.14453 1.34725 1.14453 1.59972V14.3997C1.14453 14.6522 1.3492 14.8569 1.60167 14.8569H14.4017C14.6541 14.8569 14.8588 14.6522 14.8588 14.3997V1.59972C14.8588 1.34725 14.6541 1.14258 14.4017 1.14258H1.60167Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7137 6.28544L2.28516 6.28544L2.28516 5.14258L13.7137 5.14258V6.28544Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.8577 2.28613V5.14328H5.71484V2.28613H6.8577Z"
      fill="currentColor"
    />
    <path
      d="M5.7154 7.99986C6.16747 7.99986 6.60939 8.13391 6.98528 8.38507C7.36116 8.63623 7.65413 8.99321 7.82713 9.41087C8.00013 9.82853 8.04539 10.2881 7.9572 10.7315C7.869 11.1749 7.65131 11.5822 7.33165 11.9018C7.01198 12.2215 6.60471 12.4392 6.16132 12.5274C5.71794 12.6156 5.25836 12.5703 4.8407 12.3973C4.42304 12.2243 4.06606 11.9313 3.8149 11.5554C3.56374 11.1796 3.42969 10.7376 3.42969 10.2856L4.60497 10.2856C4.60497 10.5052 4.6701 10.7199 4.79211 10.9025C4.91413 11.0851 5.08755 11.2274 5.29046 11.3115C5.49336 11.3955 5.71663 11.4175 5.93203 11.3747C6.14744 11.3318 6.3453 11.2261 6.50059 11.0708C6.65589 10.9155 6.76165 10.7176 6.80449 10.5022C6.84734 10.2868 6.82535 10.0635 6.7413 9.86063C6.65726 9.65773 6.51493 9.4843 6.33232 9.36229C6.14971 9.24027 5.93502 9.17515 5.7154 9.17515L5.7154 7.99986Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8577 8V12.5714H9.71484V8H10.8577Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5725 9.14258L12.5725 12.5711L11.4297 12.5711L11.4297 9.14258L12.5725 9.14258Z"
      fill="currentColor"
    />
  </Icon>
);

export const BotsIcon = (props: any) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <g clipPath="url(#clip0_4214_45451)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.716 4.68585H2.28739V14.743H13.716V4.68585ZM1.14453 3.42871V16.0001H14.8588V3.42871H1.14453Z"
        fill="currentColor"
      />
      <path d="M0 6.85742H1.14286V11.4289H0V6.85742Z" fill="currentColor" />
      <path
        d="M14.8555 6.85742H15.9983V11.4289H14.8555V6.85742Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.57254 1.14258V3.99972H7.42969V1.14258H8.57254Z"
        fill="currentColor"
      />
      <path
        d="M6.85547 1.14286C6.85547 0.511675 7.36714 0 7.99833 0C8.62951 0 9.14118 0.511675 9.14118 1.14286C9.14118 1.77404 8.62951 2.28571 7.99833 2.28571C7.36714 2.28571 6.85547 1.77404 6.85547 1.14286Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5725 5.71387H3.42969V11.4282H12.5725V5.71387ZM8.56967 9.14886L6.85539 7.43457L5.42969 8.86027L5.99537 9.42596L6.85539 8.56594L8.56967 10.2802L10.5668 8.2831L10.0011 7.71741L8.56967 9.14886Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_4214_45451">
        <rect width="16" height="16" fill="transparent" />
      </clipPath>
    </defs>
  </Icon>
);

export const SimpleHedgingBotIcon = (props: any) => (
  <Icon
    {...props}
    viewBox="2 1 20 20"
    d="M10.5711 2.42859C10.5711 1.6396 11.2107 1 11.9997 1C12.7886 1 13.4282 1.6396 13.4282 2.42859C13.4282 2.95727 13.1411 3.41888 12.7142 3.66592V5.28553H20.5721V9.57188H21.9998V15.2862H20.5721V21H3.42905V5.28553H11.2856V3.66619C10.8585 3.41921 10.5711 2.95746 10.5711 2.42859ZM4.85764 6.85698H19.1435V19.4286H4.85764V6.85698ZM3.42859 9.57188H2V15.2862H3.42859V9.57188ZM12.0001 8.21436C12.5524 8.21436 13.0001 8.66207 13.0001 9.21436C13.0001 9.55202 12.8326 9.85055 12.5763 10.0317V10.5715H16.2858L17.8572 14.0001C17.8572 15.1047 16.8978 16.0001 15.7144 16.0001C14.531 16.0001 13.5715 15.1047 13.5715 14.0001L14.8572 11.2858H12.5763V16.7144H14.2858V17.8573H9.71437V16.7144H11.4287V11.2858H9.143L10.4287 14.0001C10.4287 15.1047 9.46932 16.0001 8.28588 16.0001C7.10244 16.0001 6.143 15.1047 6.143 14.0001L7.71442 10.5715H11.4287V10.0317C11.1725 9.85055 11.0001 9.55202 11.0001 9.21436C11.0001 8.66207 11.4478 8.21436 12.0001 8.21436ZM7.30811 13.7144H9.26366L8.28588 11.5715L7.30811 13.7144ZM14.7366 13.7144H16.6921L15.7144 11.5715L14.7366 13.7144Z"
  />
);

export const ColoredHedgingBotIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} width="38" height="38" viewBox="0 0 38 38" fill="none">
    <path
      d="M8 13C8 11.8954 8.89543 11 10 11H28C29.1046 11 30 11.8954 30 13V31C30 32.1046 29.1046 33 28 33H10C8.89543 33 8 32.1046 8 31V13Z"
      fill="#A8C3FF"
    />
    <path
      d="M4 17C4 16.4477 4.44772 16 5 16H8V26H5C4.44772 26 4 25.5523 4 25V17Z"
      fill="#3272FE"
    />
    <path
      d="M34 25C34 25.5523 33.5523 26 33 26H30V16H33C33.5523 16 34 16.4477 34 17V25Z"
      fill="#3272FE"
    />
    <path d="M18 7H20V12H18V7Z" fill="#3272FE" />
    <circle cx="19" cy="6" r="3" fill="#FEB932" />
    <path d="M12 15H26V29H12V15Z" fill="#3272FE" />
    <path
      d="M19 17V27M15 27H23M19 17L15 19M19 17L23 19M15 19L13.5 23M15 19L16.5 23M13 23H17M23 19L21.5 23M23 19L24.5 23M21 23H25"
      stroke="white"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TvBotsIcon = (props: any) => {
  return (
    <Icon viewBox="0 0 14 15" {...props}>
      <g clipPath="url(#clip0_229_16833)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 4.6H2V13.4H12V4.6ZM1 3.5V14.5H13V3.5H1Z"
          fill="currentColor"
        />
        <path d="M0 6.5H1V10.5H0V6.5Z" fill="currentColor" />
        <path d="M13 6.5H14V10.5H13V6.5Z" fill="currentColor" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.5 1.5V4H6.5V1.5H7.5Z"
          fill="currentColor"
        />
        <path
          d="M6 1.5C6 0.947715 6.44772 0.5 7 0.5C7.55229 0.5 8 0.947715 8 1.5C8 2.05229 7.55229 2.5 7 2.5C6.44772 2.5 6 2.05229 6 1.5Z"
          fill="currentColor"
        />
        <path
          d="M5.97702 5.75H2.91675V7.42086H4.48247V9.83181H5.97702V5.75Z"
          fill="currentColor"
        />
        <path
          d="M8.3968 6.79429C8.3968 7.37103 7.91884 7.83857 7.32926 7.83857C6.73967 7.83857 6.26172 7.37103 6.26172 6.79429C6.26172 6.21754 6.73967 5.75 7.32926 5.75C7.91884 5.75 8.3968 6.21754 8.3968 6.79429Z"
          fill="currentColor"
        />
        <path
          d="M8.3968 6.79429C8.3968 7.37103 7.91884 7.83857 7.32926 7.83857C6.73967 7.83857 6.26172 7.37103 6.26172 6.79429C6.26172 6.21754 6.73967 5.75 7.32926 5.75C7.91884 5.75 8.3968 6.21754 8.3968 6.79429Z"
          fill="currentColor"
        />
        <path
          d="M11.0835 5.75H9.2776L7.47168 9.83333H9.2865L11.0835 5.75Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_229_16833">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </Icon>
  );
};

export const GridBotsIcon = (props: any) => {
  return (
    <Icon
      {...props}
      viewBox={"0 0 24 24"}
      d={[
        "M20.5715 7.02829H3.42864V22.114H20.5715V7.02829ZM1.71436 5.14258V23.9997H22.2858V5.14258H1.71436Z",
        "M0 10.2861H1.71429V17.1433H0V10.2861Z",
        "M22.2856 10.2861H23.9999V17.1433H22.2856V10.2861Z",
        "M12.8571 1.71387V5.99958H11.1428V1.71387H12.8571Z",
        "M10.2856 1.71429C10.2856 0.767512 11.0532 0 11.9999 0C12.9467 0 13.7142 0.767512 13.7142 1.71429C13.7142 2.66106 12.9467 3.42857 11.9999 3.42857C11.0532 3.42857 10.2856 2.66106 10.2856 1.71429Z",
        "M19 11.5V10H15.5V8.5H14V10H10V8.5H8.5V10H5V11.5H8.5V13.5H5V15H8.5V17H10V15H14V17H15.5V15H19V13.5H15.5V11.5H19ZM14 13.5H10V11.5H14V13.5Z",
      ]}
    />
  );
};

export const SimpleGridBotsIcon = (props: any) => {
  return (
    <Icon
      {...props}
      viewBox={"0 0 24 24"}
      d={[
        "M21 9.75V7.5H16.5V3H14.25V7.5H9.75V3H7.5V7.5H3V9.75H7.5V14.25H3V16.5H7.5V21H9.75V16.5H14.25V21H16.5V16.5H21V14.25H16.5V9.75H21ZM14.25 14.25H9.75V9.75H14.25V14.25Z",
      ]}
    />
  );
};

export const SimpleTradingViewBotsIcon = (props: any) => {
  return (
    <Icon
      {...props}
      viewBox={"0 0 24 24"}
      d={[
        "M1.2793 11.0185V6.63965H9.78223V17.3314H5.40337V11.0185H1.2793ZM17.9805 6.63965L13.4315 17.3314H18.5685L23.1176 6.63965H17.9805ZM15.4187 8.82908C15.4187 10.0383 14.4385 11.0185 13.2293 11.0185C12.0201 11.0185 11.0399 10.0383 11.0399 8.82908C11.0399 7.61989 12.0201 6.63965 13.2293 6.63965C14.4385 6.63965 15.4187 7.61989 15.4187 8.82908Z",
      ]}
    />
  );
};

export const SignalBotsIcon = (props: any) => {
  return (
    <Icon
      {...props}
      viewBox={"0 0 24 24"}
      d={[
        "M20.5715 7.02829H3.42864V22.114H20.5715V7.02829ZM1.71436 5.14258V23.9997H22.2858V5.14258H1.71436Z",
        "M0 10.2861H1.71429V17.1433H0V10.2861Z",
        "M22.2856 10.2861H23.9999V17.1433H22.2856V10.2861Z",
        "M12.8571 1.71387V5.99958H11.1428V1.71387H12.8571Z",
        "M10.2856 1.71429C10.2856 0.767512 11.0532 0 11.9999 0C12.9467 0 13.7142 0.767512 13.7142 1.71429C13.7142 2.66106 12.9467 3.42857 11.9999 3.42857C11.0532 3.42857 10.2856 2.66106 10.2856 1.71429Z",
        "M6.58297 10.1862C6.66 10.0338 6.74358 9.88437 6.83357 9.73839C6.84782 9.71527 6.86037 9.69145 6.87123 9.66712C6.97868 9.42637 6.9204 9.13559 6.70492 8.97494C6.46767 8.79806 6.13005 8.84604 5.97144 9.09587C5.95454 9.12249 5.93782 9.14921 5.92129 9.17603C5.81769 9.34409 5.72131 9.51604 5.63231 9.69138C5.11129 10.7179 4.84322 11.8609 4.85933 13.024C4.87544 14.1871 5.17507 15.3222 5.72433 16.3339C5.81815 16.5067 5.91925 16.6759 6.02747 16.8411C6.04474 16.8674 6.06218 16.8937 6.07981 16.9198C6.24528 17.1652 6.5841 17.2038 6.81637 17.0204C7.02731 16.8538 7.07752 16.5615 6.96344 16.3239C6.95191 16.2998 6.9387 16.2764 6.92381 16.2537C6.82981 16.1102 6.74213 15.9632 6.66091 15.8129C6.19738 14.9554 5.94454 13.9941 5.9309 13.0092C5.91786 12.0679 6.1238 11.1421 6.5258 10.3024C6.54444 10.2635 6.5635 10.2248 6.58297 10.1862Z",
        "M15.2642 14.8438C15.4489 14.5301 15.587 14.1919 15.6749 13.8402C15.6809 13.816 15.6867 13.7917 15.6923 13.7674C15.7546 13.495 15.787 13.2149 15.7877 12.9321C15.7885 12.624 15.7517 12.319 15.6795 12.0234C15.5934 11.6712 15.457 11.3324 15.2739 11.0177C15.2578 10.99 15.2442 10.9612 15.2331 10.9317C15.1541 10.7211 15.2049 10.4764 15.3872 10.3372C15.5951 10.1786 15.8944 10.2174 16.0315 10.44C16.0522 10.4736 16.0725 10.5075 16.0923 10.5416C16.2998 10.8982 16.4594 11.2797 16.5675 11.6759C16.6787 12.0834 16.7356 12.5066 16.7346 12.9345C16.7335 13.3624 16.6744 13.7853 16.5611 14.1922C16.451 14.5879 16.2895 14.9685 16.0802 15.3241C16.0602 15.3581 16.0398 15.3918 16.0189 15.4254C15.8807 15.6473 15.5811 15.6846 15.3741 15.5249C15.1925 15.3848 15.1429 15.1398 15.223 14.9296C15.2342 14.9002 15.2479 14.8715 15.2642 14.8438Z",
        "M8.30622 12.0964C8.38548 11.7426 8.5153 11.4012 8.69228 11.083C8.70789 11.055 8.72094 11.0259 8.73143 10.9962C8.80638 10.7842 8.75083 10.5404 8.56586 10.4048C8.355 10.2502 8.05644 10.2948 7.92366 10.52C7.90361 10.5541 7.884 10.5883 7.86483 10.6227C7.66424 10.9833 7.51211 11.3678 7.41163 11.7661C7.30829 12.1756 7.25956 12.5998 7.26891 13.0276C7.27825 13.4554 7.34545 13.8771 7.46658 14.2817C7.58436 14.6752 7.75313 15.0527 7.96928 15.4042C7.98993 15.4378 8.01102 15.4711 8.03253 15.5042C8.17502 15.7235 8.47525 15.755 8.67916 15.5913C8.85803 15.4477 8.90287 15.2018 8.81874 14.9932C8.80696 14.964 8.79266 14.9356 8.77584 14.9082C8.58513 14.5981 8.44053 14.2627 8.3459 13.9127C8.26649 13.619 8.22227 13.315 8.21554 13.0069C8.20937 12.7242 8.2349 12.4434 8.29059 12.1696C8.29556 12.1451 8.30077 12.1207 8.30622 12.0964Z",
        "M13.4259 14.7617C13.9827 14.3373 14.2808 13.7403 14.2808 13.0367C14.2808 11.8396 13.3103 10.8691 12.1132 10.8691C10.9161 10.8691 9.94567 11.8396 9.94567 13.0367C9.94567 13.7387 10.2429 14.3628 10.7604 14.759L12 15.5913L13.4259 14.7617ZM12 15.5913L10.7604 14.759C11.2451 15.0756 11.5197 15.1949 12.1132 15.1949C12.6775 15.1949 13.008 15.0802 13.4259 14.7617L12 15.5913Z",
        "M17.0344 16.3162C17.1302 16.174 17.2198 16.0281 17.3029 15.8789C17.3239 15.8412 17.3445 15.8032 17.3647 15.7651C17.8004 14.9425 18.0436 14.0258 18.0687 13.0847C18.095 12.1 17.8813 11.1292 17.4528 10.2537C17.3778 10.1003 17.2961 9.94977 17.208 9.80265C17.194 9.77935 17.1818 9.75537 17.1713 9.7309C17.0669 9.4888 17.1289 9.19879 17.3464 9.04091C17.5859 8.86708 17.9229 8.91938 18.0783 9.17122C18.0948 9.19805 18.1112 9.22498 18.1274 9.25201C18.2288 9.42139 18.323 9.59456 18.4098 9.77102C18.9176 10.8041 19.171 11.9505 19.14 13.1133C19.109 14.2761 18.7949 15.4073 18.2327 16.4118C18.1367 16.5834 18.0334 16.7513 17.9231 16.9151C17.9055 16.9412 17.8877 16.9672 17.8698 16.9931C17.7012 17.2363 17.3619 17.2706 17.132 17.0843C16.9232 16.915 16.8767 16.6221 16.9939 16.3859C17.0057 16.362 17.0192 16.3388 17.0344 16.3162Z",
      ]}
    />
  );
};

export const GroupManagementIcon = (props: any) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.0313 5.02295C14.0204 5.00076 14.0093 4.97862 13.998 4.95654L14.6788 3.89758C14.8004 3.70837 14.7737 3.45996 14.6147 3.30102L12.699 1.38525C12.54 1.2262 12.2916 1.19958 12.1024 1.32117L11.0435 2.00195C10.7358 1.84558 10.4165 1.71313 10.0891 1.6062L9.82178 0.376464C9.77405 0.156738 9.57947 0 9.35461 0H6.64539C6.42053 0 6.22595 0.156738 6.17822 0.376464L5.91089 1.6062C5.5835 1.71313 5.26416 1.84558 4.95654 2.00195L3.89758 1.32117C3.70837 1.19958 3.45996 1.22632 3.30103 1.38525L1.38525 3.30102C1.22632 3.45996 1.19958 3.70837 1.32117 3.89758L2.00195 4.95654C1.84558 5.26416 1.71313 5.5835 1.6062 5.91089L0.376465 6.17822C0.156738 6.22607 0 6.42053 0 6.64539V9.35461C0 9.57947 0.156738 9.77393 0.376465 9.82178L1.6062 10.0891C1.71313 10.4165 1.84558 10.7358 2.00195 11.0435L1.32117 12.1024C1.19958 12.2916 1.22632 12.54 1.38525 12.699L3.17615 14.4899C3.26223 14.1461 3.37914 13.8105 3.52526 13.4868L2.33386 12.2953L2.95825 11.3241C3.0542 11.1749 3.05957 10.985 2.97241 10.8306C2.74487 10.4274 2.56665 9.99756 2.44275 9.5531C2.39514 9.38245 2.25696 9.25208 2.08374 9.21436L0.956177 8.96924V7.03076L2.08386 6.78564C2.25708 6.74792 2.39514 6.61755 2.44275 6.4469C2.56677 6.00244 2.745 5.57263 2.97253 5.16943C3.05969 5.01501 3.0542 4.82507 2.95825 4.6759L2.33398 3.70471L3.70471 2.33386L4.6759 2.95825C4.82507 3.05408 5.01501 3.05957 5.16943 2.97241C5.57263 2.74487 6.00244 2.56665 6.4469 2.44275C6.61755 2.39514 6.74793 2.25696 6.78565 2.08374L7.03076 0.956176H8.96924L9.21436 2.08374C9.25208 2.25696 9.38245 2.39514 9.5531 2.44275C9.99756 2.56665 10.4274 2.74487 10.8307 2.97241C10.985 3.05957 11.1749 3.0542 11.3241 2.95825L12.2954 2.33386L13.6661 3.70471L13.0417 4.6759C12.9458 4.82507 12.9404 5.01501 13.0276 5.16943C13.1455 5.37845 13.2502 5.59461 13.341 5.81626C13.5359 5.52268 13.7683 5.25603 14.0313 5.02295Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.7454 11.3026C4.6923 10.5814 4 9.37004 4 8.00012C4 5.91379 5.60572 4.1953 7.64619 4.01562C7.17385 4.39791 6.77625 4.873 6.48006 5.41441C5.59502 5.93666 5 6.90023 5 8.00012C5 9.10775 5.60344 10.0771 6.49881 10.5968C6.29209 10.7619 6.09427 10.9404 5.9067 11.1319C5.85185 11.1879 5.79808 11.2448 5.7454 11.3026Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2314 9.45361C11.4101 9.45361 12.3657 8.49803 12.3657 7.31927C12.3657 6.1405 11.4101 5.18492 10.2314 5.18492C9.05261 5.18492 8.09703 6.1405 8.09703 7.31927C8.09703 8.49803 9.05261 9.45361 10.2314 9.45361ZM10.2314 10.703C12.1002 10.703 13.6151 9.18804 13.6151 7.31927C13.6151 5.45049 12.1002 3.93555 10.2314 3.93555C8.3626 3.93555 6.84766 5.45049 6.84766 7.31927C6.84766 9.18804 8.3626 10.703 10.2314 10.703Z"
      fill="currentColor"
    />
    <path
      d="M15.4588 15.0722C15.4588 13.6852 14.9078 12.3551 13.9271 11.3744C12.9464 10.3937 11.6163 9.84277 10.2294 9.84277C8.84247 9.84277 7.51235 10.3937 6.53165 11.3744C5.55095 12.3551 5 13.6852 5 15.0722L6.35204 15.0722C6.35204 14.0438 6.76055 13.0576 7.48769 12.3305C8.21483 11.6033 9.20105 11.1948 10.2294 11.1948C11.2577 11.1948 12.2439 11.6033 12.9711 12.3305C13.6982 13.0576 14.1067 14.0438 14.1067 15.0722H15.4588Z"
      fill="currentColor"
    />
  </svg>
);

export const SignalsIcon = (props: any) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g clipPath="url(#clip0_3989_41777)">
      <path
        d="M1.93125 2.12847C2.01752 1.95774 2.11112 1.79038 2.21191 1.62688C2.22788 1.60098 2.24193 1.5743 2.2541 1.54705C2.37444 1.27741 2.30916 0.951745 2.06783 0.771817C1.80211 0.573707 1.42397 0.627442 1.24633 0.907262C1.2274 0.937073 1.20868 0.966997 1.19017 0.997031C1.07413 1.18526 0.966189 1.37785 0.866512 1.57423C0.282963 2.72393 -0.0172761 4.00408 0.000768015 5.30675C0.0188128 6.60943 0.354395 7.88077 0.969564 9.01387C1.07464 9.20741 1.18788 9.39693 1.30908 9.58188C1.32842 9.61139 1.34797 9.64078 1.36771 9.67006C1.55304 9.94485 1.93251 9.98809 2.19265 9.7827C2.42891 9.59615 2.48514 9.2688 2.35737 9.0026C2.34446 8.9757 2.32967 8.94942 2.31299 8.92398C2.20771 8.76333 2.1095 8.59862 2.01854 8.43035C1.49938 7.46995 1.21621 6.39326 1.20093 5.29013C1.18633 4.23588 1.41698 3.19898 1.86722 2.25862C1.88809 2.21502 1.90944 2.17164 1.93125 2.12847Z"
        fill="currentColor"
      />
      <path
        d="M11.6542 7.34493C11.8611 6.99354 12.0158 6.61486 12.1142 6.22088C12.1209 6.19378 12.1274 6.1666 12.1337 6.13935C12.2035 5.83426 12.2397 5.52058 12.2405 5.20381C12.2414 4.85876 12.2002 4.51715 12.1193 4.18612C12.0229 3.79165 11.8702 3.41219 11.6651 3.05975C11.647 3.02867 11.6318 2.9964 11.6194 2.96339C11.5309 2.72756 11.5878 2.45341 11.792 2.29755C12.0248 2.11987 12.3601 2.16334 12.5136 2.4127C12.5368 2.45034 12.5595 2.48826 12.5817 2.52642C12.8141 2.92587 12.9928 3.35311 13.1139 3.79691C13.2385 4.25331 13.3022 4.72724 13.301 5.2065C13.2998 5.68577 13.2337 6.15936 13.1068 6.61513C12.9834 7.05831 12.8026 7.48463 12.5681 7.8829C12.5457 7.92095 12.5229 7.95875 12.4995 7.99628C12.3447 8.24485 12.0091 8.28663 11.7773 8.10777C11.5739 7.95087 11.5183 7.67644 11.608 7.44106C11.6206 7.40811 11.636 7.37592 11.6542 7.34493Z"
        fill="currentColor"
      />
      <path
        d="M3.86129 4.26782C3.95005 3.87156 4.09545 3.48922 4.29367 3.13289C4.31116 3.10147 4.32577 3.06891 4.33752 3.03566C4.42146 2.79817 4.35925 2.52517 4.15209 2.37328C3.91592 2.20013 3.58153 2.25006 3.43281 2.50234C3.41036 2.54043 3.3884 2.57877 3.36693 2.61736C3.14227 3.02122 2.97188 3.45182 2.85934 3.89788C2.7436 4.35661 2.68903 4.83167 2.6995 5.31082C2.70996 5.78997 2.78522 6.2622 2.92089 6.71544C3.0528 7.15615 3.24183 7.57891 3.48391 7.97257C3.50704 8.01019 3.53066 8.04754 3.55475 8.08461C3.71434 8.33015 4.05059 8.36543 4.27897 8.18213C4.47931 8.02134 4.52954 7.74589 4.43531 7.51228C4.42212 7.47958 4.4061 7.4477 4.38726 7.41706C4.17367 7.06973 4.01171 6.6941 3.90572 6.3021C3.81678 5.97314 3.76726 5.63264 3.75973 5.28766C3.75281 4.97097 3.78141 4.6565 3.84377 4.3498C3.84934 4.32241 3.85518 4.29508 3.86129 4.26782Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.59534 7.25296C10.1772 6.80947 10.5528 6.10907 10.5528 5.32096C10.5528 3.98019 9.46589 2.89329 8.12513 2.89329C6.78437 2.89329 5.69746 3.98019 5.69746 5.32096C5.69746 6.10727 6.0713 6.80627 6.65093 7.24992L5.81666 14.3412C5.80843 14.4111 5.80514 14.4804 5.80647 14.5486C5.20193 14.5915 4.72481 15.0955 4.72481 15.7109C4.72481 15.8718 4.85524 16.0022 5.01613 16.0022H7.09821C7.16616 16.0116 7.23565 16.0165 7.30639 16.0165H8.52002C8.59061 16.0165 8.66002 16.0116 8.72793 16.0022H10.7454C10.9063 16.0022 11.0367 15.8718 11.0367 15.7109C11.0367 15.1175 10.5932 14.6278 10.0196 14.555C10.0206 14.5132 10.0199 14.4709 10.0174 14.4284L9.59534 7.25296ZM9.55279 5.32096C9.55279 6.10943 8.91361 6.74862 8.12513 6.74862C7.33665 6.74862 6.69746 6.10943 6.69746 5.32096C6.69746 4.53248 7.33665 3.89329 8.12513 3.89329C8.91361 3.89329 9.55279 4.53248 9.55279 5.32096ZM9.01916 14.4871C9.02032 14.5069 9.02032 14.5264 9.01922 14.5456H6.80712C6.80549 14.517 6.80632 14.4877 6.80981 14.4581L7.59753 7.76243H8.62358L9.01916 14.4871Z"
        fill="currentColor"
      />
      <path
        d="M13.6368 8.99406C13.7441 8.83477 13.8444 8.67134 13.9376 8.50424C13.9611 8.46199 13.9842 8.4195 14.0068 8.37679C14.4947 7.45543 14.7672 6.42872 14.7953 5.37474C14.8247 4.2719 14.5853 3.18463 14.1055 2.20399C14.0214 2.03217 13.93 1.86363 13.8313 1.69885C13.8156 1.67275 13.8019 1.6459 13.7901 1.61849C13.6732 1.34734 13.7427 1.02253 13.9863 0.845705C14.2545 0.651012 14.6319 0.709583 14.806 0.991654C14.8245 1.0217 14.8429 1.05187 14.861 1.08213C14.9746 1.27184 15.0801 1.46579 15.1772 1.66343C15.746 2.8205 16.0299 4.10439 15.9951 5.40673C15.9604 6.70906 15.6086 7.97601 14.979 9.10114C14.8714 9.29332 14.7558 9.48138 14.6322 9.66476C14.6125 9.69402 14.5926 9.72316 14.5725 9.75218C14.3836 10.0246 14.0036 10.063 13.7462 9.85425C13.5123 9.6647 13.4603 9.33665 13.5914 9.07211C13.6047 9.04537 13.6198 9.01929 13.6368 8.99406Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3989_41777">
        <rect width="16" height="16" fill="transparent" />
      </clipPath>
    </defs>
  </svg>
);

export const ManualIcon = (props: any) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="18"
    viewBox="0 0 14 18"
  >
    <path
      d="M4.9 4C4.9 3.73478 5.00536 3.48043 5.19289 3.29289C5.38043 3.10535 5.63478 3 5.9 3C6.16522 3 6.41957 3.10535 6.60711 3.29289C6.79464 3.48043 6.9 3.73478 6.9 4V8.46999L8.11 8.59999L13.05 10.79C13.58 11.03 13.9 11.56 13.9 12.14V16.5C13.87 17.32 13.22 17.97 12.4 18H5.9C5.52 18 5.16 17.85 4.9 17.57L0 13.37L0.74 12.6C0.93 12.39 1.2 12.28 1.48 12.28H1.7L4.9 14V4ZM5.9 0C6.96087 0 7.97828 0.421424 8.72843 1.17157C9.47857 1.92172 9.9 2.93913 9.9 4C9.9 5.5 9.1 6.76999 7.9 7.45999V6.23999C8.51 5.68999 8.9 4.89 8.9 4C8.9 3.20435 8.58393 2.44129 8.02132 1.87868C7.45871 1.31607 6.69565 1 5.9 1C5.10435 1 4.34129 1.31607 3.77868 1.87868C3.21607 2.44129 2.9 3.20435 2.9 4C2.9 4.89 3.29 5.68999 3.9 6.23999V7.45999C2.7 6.76999 1.9 5.5 1.9 4C1.9 2.93913 2.32143 1.92172 3.07157 1.17157C3.82172 0.421424 4.83913 0 5.9 0Z"
      fill="inherit"
    />
  </svg>
);

export const SignalsEmptyState = (props: any) => {
  const prefix = useMemo(() => uuidv4(), []);
  return (
    <Icon
      {...props}
      $size={212}
      width="212"
      height="175"
      viewBox="0 0 212 175"
      fill="none"
    >
      <path
        d="M105.624 174.655C163.959 174.655 211.248 162.96 211.248 148.533C211.248 134.106 163.959 122.411 105.624 122.411C47.2895 122.411 0 134.106 0 148.533C0 162.96 47.2895 174.655 105.624 174.655Z"
        fill={`url(#${prefix}paint0_linear_439_537)`}
      />
      <path
        d="M96.1083 63.4941H115.84L122.766 147.148H88.2344L96.1083 63.4941Z"
        fill={`url(#${prefix}paint1_linear_439_537)`}
      />
      <path
        d="M73.625 151.795C73.625 143.728 80.1644 137.189 88.2312 137.189H122.769C130.836 137.189 137.375 143.728 137.375 151.795H73.625Z"
        fill={`url(#${prefix}paint2_linear_439_537)`}
      />
      <ellipse
        cx="105.832"
        cy="43.5763"
        rx="22.2461"
        ry="21.9093"
        fill={`url(#${prefix}paint3_linear_439_537)`}
      />
      <path
        d="M141.148 17.1675C143.285 15.5369 146.362 15.9359 147.772 18.2243C152.503 25.9046 155.022 34.7794 154.999 43.8629C154.976 52.9466 152.412 61.8086 147.642 69.4649C146.221 71.746 143.141 72.1293 141.013 70.4879C138.884 68.8465 138.52 65.8033 139.883 63.4874C143.375 57.5565 145.248 50.7783 145.265 43.8383C145.283 36.8983 143.445 30.1108 139.983 24.1623C138.631 21.8394 139.011 18.7981 141.148 17.1675Z"
        fill={`url(#${prefix}paint4_linear_439_537)`}
      />
      <path
        d="M71.5102 17.1675C69.3735 15.5369 66.2958 15.9359 64.8863 18.2243C60.1556 25.9046 57.6358 34.7794 57.6589 43.8629C57.6819 52.9466 60.2467 61.8086 65.0164 69.4649C66.4374 71.746 69.517 72.1293 71.6453 70.4879C73.7737 68.8465 74.1383 65.8033 72.7747 63.4874C69.2827 57.5565 67.4106 50.7783 67.393 43.8383C67.3754 36.8983 69.2131 30.1108 72.6749 24.1623C74.0268 21.8394 73.6469 18.7981 71.5102 17.1675Z"
        fill={`url(#${prefix}paint5_linear_439_537)`}
      />
      <path
        d="M161.313 3.83893C163.775 2.05222 167.239 2.5898 168.837 5.17847C176.319 17.301 180.134 31.3768 179.752 45.6954C179.37 60.0143 174.811 73.867 166.693 85.5739C164.96 88.0735 161.472 88.4257 159.109 86.5104C156.745 84.5951 156.405 81.1389 158.105 78.6165C164.713 68.8116 168.422 57.296 168.739 45.4019C169.056 33.508 165.966 21.8112 159.89 11.6684C158.327 9.0588 158.851 5.62563 161.313 3.83893Z"
        fill={`url(#${prefix}paint6_linear_439_537)`}
      />
      <path
        d="M51.3462 3.83893C48.8841 2.05222 45.4197 2.5898 43.8221 5.17847C36.3403 17.301 32.5252 31.3768 32.907 45.6954C33.2888 60.0143 37.8486 73.867 45.9659 85.5739C47.6991 88.0735 51.187 88.4257 53.5504 86.5104C55.9139 84.5951 56.2541 81.1389 54.5542 78.6165C47.9462 68.8116 44.2375 57.296 43.9204 45.4019C43.6033 33.508 46.693 21.8112 52.769 11.6684C54.3322 9.0588 53.8084 5.62563 51.3462 3.83893Z"
        fill={`url(#${prefix}paint7_linear_439_537)`}
      />
      <defs>
        <linearGradient
          id={`${prefix}paint0_linear_439_537`}
          x1="115.278"
          y1="195.098"
          x2="124.932"
          y2="66.7593"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDEAFF" />
          <stop offset="1" stopColor="#F0F6FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint1_linear_439_537`}
          x1="113.783"
          y1="203.701"
          x2="151.099"
          y2="63.0342"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint2_linear_439_537`}
          x1="207.434"
          y1="84.4074"
          x2="156.814"
          y2="15.4185"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CADFFF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint3_linear_439_537`}
          x1="116.504"
          y1="95.1088"
          x2="124.912"
          y2="17.1474"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint4_linear_439_537`}
          x1="153.742"
          y1="-42.2106"
          x2="21.983"
          y2="96.9875"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CADFFF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint5_linear_439_537`}
          x1="58.9159"
          y1="-42.2106"
          x2="190.675"
          y2="96.9875"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CADFFF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint6_linear_439_537`}
          x1="274.895"
          y1="-187.986"
          x2="25.8341"
          y2="297.72"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#98C0FF" />
          <stop offset="0.567708" stopColor="#D5E5FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint7_linear_439_537`}
          x1="-62.2354"
          y1="-187.986"
          x2="186.825"
          y2="297.72"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#98C0FF" />
          <stop offset="0.567708" stopColor="#D5E5FF" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const MarketplaceEmptyState = (props: any) => {
  return (
    <Icon
      {...props}
      $size={212}
      width="212"
      height="170"
      viewBox="0 0 212 170"
      fill="none"
    >
      <path
        d="M105.624 169.655C163.959 169.655 211.248 157.96 211.248 143.533C211.248 129.106 163.959 117.411 105.624 117.411C47.2895 117.411 0 129.106 0 143.533C0 157.96 47.2895 169.655 105.624 169.655Z"
        fill="url(#paint0_linear_439_684)"
      />
      <path
        d="M36.8571 34.6387C36.8571 33.5341 37.7525 32.6387 38.8571 32.6387H173.143C174.247 32.6387 175.143 33.5341 175.143 34.6387V137.862C175.143 138.966 174.247 139.862 173.143 139.862H38.8571C37.7525 139.862 36.8571 138.966 36.8571 137.862V34.6387Z"
        fill="url(#paint1_linear_439_684)"
      />
      <path
        d="M95.1818 0.560059H116.818L123 51.5601H89L95.1818 0.560059Z"
        fill="url(#paint2_linear_439_684)"
      />
      <path
        d="M116 0.560059H138.615L158 51.5601H122.462L116 0.560059Z"
        fill="url(#paint3_linear_439_684)"
      />
      <path
        d="M137 0.560059H159.392C160.065 0.560059 160.693 0.898791 161.063 1.46136L194 51.5601H157.118L137 0.560059Z"
        fill="url(#paint4_linear_439_684)"
      />
      <path
        d="M50.9369 1.46136C51.3067 0.898793 51.9348 0.560059 52.608 0.560059H75L54.8824 51.5601H18L50.9369 1.46136Z"
        fill="url(#paint5_linear_439_684)"
      />
      <path
        d="M18 51.5605H53.619V56.8776C53.619 66.7135 45.6454 74.6871 35.8095 74.6871V74.6871C25.9736 74.6871 18 66.7135 18 56.8776V51.5605Z"
        fill="url(#paint6_linear_439_684)"
      />
      <path
        d="M53.619 51.5605H89.2381V56.8776C89.2381 66.7135 81.2645 74.6871 71.4285 74.6871V74.6871C61.5926 74.6871 53.619 66.7135 53.619 56.8776V51.5605Z"
        fill="url(#paint7_linear_439_684)"
      />
      <path
        d="M89.2382 51.5605H122.762V57.9252C122.762 67.1825 115.257 74.6871 106 74.6871V74.6871C96.7427 74.6871 89.2382 67.1825 89.2382 57.9252V51.5605Z"
        fill="url(#paint8_linear_439_684)"
      />
      <path
        d="M122.762 51.5605H158.381V56.8776C158.381 66.7135 150.407 74.6871 140.571 74.6871V74.6871C130.736 74.6871 122.762 66.7135 122.762 56.8776V51.5605Z"
        fill="url(#paint9_linear_439_684)"
      />
      <path
        d="M158.381 51.5605H194V56.8776C194 66.7135 186.026 74.6871 176.191 74.6871V74.6871C166.355 74.6871 158.381 66.7135 158.381 56.8776V51.5605Z"
        fill="url(#paint10_linear_439_684)"
      />
      <path
        d="M87.1428 85.0967C87.1428 83.9921 88.0383 83.0967 89.1428 83.0967H124.952C126.057 83.0967 126.952 83.9921 126.952 85.0967V139.862H87.1428V85.0967Z"
        fill="url(#paint11_linear_439_684)"
      />
      <path
        d="M128.273 83.0967L128.273 87.3015L86.3679 87.3015L86.3679 83.0967L128.273 83.0967Z"
        fill="#BAD6FF"
      />
      <path
        d="M128.281 82.8828L124.281 87.105V139.883H128.281V82.8828Z"
        fill="#E2EEFF"
      />
      <path
        d="M86.2806 82.8828L90.2806 87.105V139.883H86.2806V82.8828Z"
        fill="#E2EEFF"
      />
      <path
        d="M73.3846 0.560059H96L89.5385 51.5601H54L73.3846 0.560059Z"
        fill="url(#paint12_linear_439_684)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_439_684"
          x1="115.278"
          y1="190.098"
          x2="124.932"
          y2="61.7593"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDEAFF" />
          <stop offset="1" stopColor="#F0F6FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_439_684"
          x1="139.169"
          y1="212.349"
          x2="155.438"
          y2="20.7419"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_439_684"
          x1="61.9545"
          y1="26.0601"
          x2="155.392"
          y2="23.6456"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D4E5FD" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_439_684"
          x1="147.074"
          y1="86.0381"
          x2="132.34"
          y2="-34.8994"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_439_684"
          x1="90.8971"
          y1="38.0132"
          x2="234.731"
          y2="32.4143"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D4E5FD" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_439_684"
          x1="7.94118"
          y1="9.32569"
          x2="112.756"
          y2="31.4377"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D4E5FD" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_439_684"
          x1="35.8095"
          y1="96.9877"
          x2="61.8471"
          y2="37.8561"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D4E5FD" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_439_684"
          x1="63.2088"
          y1="91.6707"
          x2="75.3176"
          y2="31.4181"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_439_684"
          x1="99.9048"
          y1="96.9877"
          x2="128.198"
          y2="37.5681"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D4E5FD" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_439_684"
          x1="149.115"
          y1="90.3216"
          x2="145.505"
          y2="34.9022"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_439_684"
          x1="170.524"
          y1="96.1617"
          x2="196.729"
          y2="42.9941"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D4E5FD" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_439_684"
          x1="108.095"
          y1="160.886"
          x2="118.01"
          y2="34.4676"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#98C0FA" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_439_684"
          x1="65.3077"
          y1="89.0132"
          x2="110.834"
          y2="-32.1145"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const GraphDataEmptyState = (props: any) => {
  const prefix = useMemo(() => uuidv4(), []);
  return (
    <Icon
      {...props}
      $size={212}
      width="212"
      height="165"
      viewBox="0 0 212 165"
      fill="none"
    >
      <path
        d="M105.624 164.654C163.959 164.654 211.248 152.959 211.248 138.532C211.248 124.105 163.959 112.41 105.624 112.41C47.2895 112.41 0 124.105 0 138.532C0 152.959 47.2895 164.654 105.624 164.654Z"
        fill={`url(#${prefix}paint0_linear_439_967)`}
      />
      <rect
        x="15"
        y="43.6802"
        width="36.4"
        height="100.707"
        rx="6"
        fill={`url(#${prefix}paint1_linear_439_967)`}
      />
      <rect
        x="112.067"
        y="43.6802"
        width="36.4"
        height="100.707"
        rx="6"
        fill={`url(#${prefix}paint2_linear_439_967)`}
      />
      <rect
        x="63.5333"
        width="36.4"
        height="144.387"
        rx="6"
        fill={`url(#${prefix}paint3_linear_439_967)`}
      />
      <rect
        x="160.6"
        y="18.2002"
        width="36.4"
        height="126.187"
        rx="6"
        fill={`url(#${prefix}paint4_linear_439_967)`}
      />
      <defs>
        <linearGradient
          id={`${prefix}paint0_linear_439_967`}
          x1="115.278"
          y1="185.098"
          x2="124.932"
          y2="56.7588"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDEAFF" />
          <stop offset="1" stopColor="#F0F6FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint1_linear_439_967`}
          x1="34.0273"
          y1="196.01"
          x2="64.6803"
          y2="43.6425"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint2_linear_439_967`}
          x1="131.094"
          y1="196.01"
          x2="161.747"
          y2="43.6425"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint3_linear_439_967`}
          x1="80.928"
          y1="9.1"
          x2="85.0631"
          y2="202.456"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint4_linear_439_967`}
          x1="177.995"
          y1="26.1531"
          x2="181.153"
          y2="195.154"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const TradesEmptyState = (props: any) => {
  const prefix = useMemo(() => uuidv4(), []);

  return (
    <Icon
      {...props}
      $size={212}
      width="212"
      height="212"
      viewBox="0 0 212 212"
      fill="none"
    >
      <path
        d="M105.624 192.563C163.959 192.563 211.248 180.812 211.248 166.317C211.248 151.822 163.959 140.071 105.624 140.071C47.2895 140.071 0 151.822 0 166.317C0 180.812 47.2895 192.563 105.624 192.563Z"
        fill={`url(#${prefix}paint0_linear_439_529)`}
      />
      <path
        d="M66.849 72.9069L66.8489 166.061L44.0122 166.061C42.9899 166.061 42.0982 166.433 41.337 167.198C40.5758 167.964 40.206 168.861 40.206 169.889C40.206 171.005 40.554 171.924 41.2717 172.646L79.3331 210.928C80.0508 211.65 80.9643 212 82.0735 212C83.1827 212 84.0962 211.65 84.8139 210.928L122.745 172.755C123.549 171.792 123.941 170.83 123.941 169.889C123.941 168.774 123.593 167.855 122.875 167.133C122.157 166.411 121.244 166.061 120.135 166.061L97.298 166.061L97.298 72.9069C97.298 71.8787 96.9283 70.9818 96.167 70.2161C95.4058 69.4505 94.5141 69.0786 93.4919 69.0786L70.6551 69.0786C69.6329 69.0786 68.7411 69.4505 67.9799 70.2161C67.2187 70.9818 66.849 71.8787 66.849 72.9069Z"
        fill={`url(#${prefix}paint1_linear_439_529)`}
      />
      <path
        d="M142.863 139.093L142.863 45.939L167.657 45.939C168.767 45.939 169.735 45.5672 170.562 44.8015C171.388 44.0359 171.79 43.139 171.79 42.1108C171.79 40.9951 171.412 40.0764 170.633 39.3545L129.309 1.07196C128.53 0.350068 127.538 4.63304e-05 126.334 4.63161e-05C125.129 4.63018e-05 124.137 0.350068 123.358 1.07196L82.1762 39.2451C81.3025 40.2076 80.8774 41.1701 80.8774 42.1108C80.8774 43.2265 81.2553 44.1452 82.0345 44.8671C82.8138 45.589 83.8055 45.939 85.0098 45.939L109.804 45.939L109.804 139.093C109.804 140.121 110.205 141.018 111.032 141.784C111.858 142.549 112.827 142.921 113.936 142.921L138.731 142.921C139.84 142.921 140.809 142.549 141.635 141.784C142.462 141.018 142.863 140.121 142.863 139.093Z"
        fill={`url(#${prefix}paint2_linear_439_529)`}
      />
      <defs>
        <linearGradient
          id={`${prefix}paint0_linear_439_529`}
          x1="115.278"
          y1="213.103"
          x2="125.023"
          y2="84.1631"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDEAFF" />
          <stop offset="1" stopColor="#F0F6FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint1_linear_439_529`}
          x1="148.569"
          y1="187.144"
          x2="37.6277"
          y2="179.872"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#7FB0FB" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint2_linear_439_529`}
          x1="146.669"
          y1="-89.3258"
          x2="51.114"
          y2="152.713"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const CoinsEmptyState = (props: any) => {
  const prefix = useMemo(() => uuidv4(), []);
  return (
    <Icon
      {...props}
      $size={224}
      width="224"
      height="198"
      viewBox="0 0 224 198"
      fill="none"
    >
      <path
        d="M105.624 197.655C163.959 197.655 211.248 185.96 211.248 171.533C211.248 157.106 163.959 145.411 105.624 145.411C47.2895 145.411 0 157.106 0 171.533C0 185.96 47.2895 197.655 105.624 197.655Z"
        fill={`url(#${prefix}paint0_linear_439_600)`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.3489 19.2666C31.9896 28.9261 29.1597 41.5696 29.3807 54.8683C29.6017 68.1669 32.8491 80.6406 38.5243 89.9917C44.4127 99.6943 52.2092 104.91 60.4773 104.679L72.5019 104.343C80.7607 104.113 88.3378 98.4635 93.8372 88.4368C99.1195 78.806 101.907 66.1668 101.686 52.8477C101.464 39.5286 98.2595 27.0568 92.662 17.7301C86.8345 8.01993 79.0767 2.79933 70.8181 3.03012L58.7935 3.36615C50.5254 3.59742 42.9095 9.24408 37.3489 19.2666ZM33.8083 54.7447C34.0168 67.286 37.0414 78.987 42.3247 87.6926C47.366 95.9992 53.7869 100.472 60.4043 100.287C66.9844 100.103 73.1654 95.2847 77.809 86.7196C82.6583 77.7754 85.2135 65.9122 85.0041 53.3143C84.7947 40.7164 81.8476 29.0065 76.7058 20.3415C71.7819 12.0437 65.4464 7.57527 58.8665 7.75915C52.2489 7.94408 45.9828 12.7712 41.2222 21.3517C36.2328 30.3442 33.5999 42.2035 33.8083 54.7447Z"
        fill={`url(#${prefix}paint1_linear_439_600)`}
      />
      <path
        data-figma-bg-blur-radius="1.27803"
        d="M59.2831 2.53222C67.1784 2.32836 74.8632 7.19857 80.8881 16.4325C87.1765 26.0705 90.7962 39.1286 91.0495 53.2086C91.3027 67.2885 88.1558 80.522 82.2182 90.4778C76.5292 100.017 69.0241 105.281 61.1269 105.486C53.1828 105.691 45.391 100.813 39.2211 91.5677C32.7593 81.8841 29.0462 68.8378 28.7941 54.8248C28.5422 40.8116 31.7826 27.5833 37.892 17.5731C43.7255 8.01473 51.337 2.73745 59.2831 2.53222Z"
        stroke={`url(#${prefix}paint2_linear_439_600)`}
      />
      <mask
        id="mask0_439_600"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="31"
        y="6"
        width="55"
        height="97"
      >
        <path
          data-figma-bg-blur-radius="1.27803"
          d="M40.1824 89.4148C34.6048 80.3711 31.4137 68.2139 31.1971 55.1822C30.9805 42.1505 33.7645 29.826 39.0367 20.4794C44.0671 11.5609 50.6864 6.54198 57.6756 6.34667C64.6251 6.15246 71.3151 10.7927 76.5131 19.4127C81.9411 28.4142 85.0505 40.5807 85.268 53.6713C85.4856 66.7619 82.7836 79.0904 77.6594 88.3868C72.7526 97.2892 66.2232 102.299 59.2736 102.493C52.2845 102.688 45.5044 98.0439 40.1824 89.4148Z"
          fill="#797BF6"
        />
      </mask>
      <g mask="url(#mask0_439_600)">
        <g filter="url(#filter0_i_439_600)" data-figma-bg-blur-radius="3.44504">
          <path
            d="M43.3875 97.4978C34.3069 89.1786 27.8022 76.8616 25.0719 62.8155C22.3416 48.7694 23.7169 34.6989 28.9447 23.1963C33.9328 12.2207 41.7558 5.04704 50.9732 2.99621C60.138 0.957076 69.8658 4.21814 78.3644 12.1788C87.2391 20.4919 93.6372 32.8403 96.3798 46.95C99.1225 61.0596 97.8566 75.1128 92.8153 86.5221C87.9878 97.4478 80.282 104.588 71.117 106.627C61.8999 108.678 52.052 105.436 43.3875 97.4978Z"
            fill={`url(#${prefix}paint3_linear_439_600)`}
          />
        </g>
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.1346 45.4734C69.06 44.6605 67.5361 44.5308 65.563 45.0848C67.8988 42.3925 68.7739 39.5081 68.1893 36.4307C67.9857 35.3103 67.5944 34.4564 67.0147 33.8679C66.4345 33.2794 65.6936 32.9562 64.7892 32.8992C63.8854 32.8411 62.9177 32.9495 61.8881 33.2219C60.8583 33.4945 59.6864 33.9238 58.3731 34.5097L57.7744 27.7832L53.9671 29.8601L54.5491 36.3997C53.8898 36.7593 52.8859 37.3255 51.5376 38.0984L50.9509 31.5054L47.143 33.5825L47.7416 40.309C47.1991 40.6237 46.4006 41.0688 45.3457 41.6442L40.1017 44.4765L40.4913 48.8541L43.2356 47.3571C44.4883 46.6738 45.2757 46.8788 45.5976 47.9718L46.2794 55.6326C46.4445 55.5426 46.577 55.4799 46.6776 55.4437L46.2818 55.6595L47.2368 66.3894C47.1858 67.3686 46.7482 68.0834 45.924 68.533L43.1798 70.0299L42.848 75.3328L47.7931 72.6354C48.1063 72.4645 48.5597 72.2219 49.1541 71.9061C49.7482 71.5914 50.1935 71.3532 50.4903 71.1913L51.096 77.9978L54.9045 75.9203L54.3058 69.1939C54.9996 68.8346 56.0058 68.2948 57.3245 67.5755L57.9207 74.275L61.7281 72.1981L61.1224 65.3917C62.468 64.5832 63.6553 63.7963 64.684 63.0292C65.7133 62.2618 66.6876 61.4089 67.6062 60.4691C68.5248 59.5299 69.2777 58.573 69.8651 57.5996C70.4528 56.6265 70.9134 55.5445 71.2489 54.3537C71.583 53.1637 71.7523 51.9053 71.7548 50.5788C71.7499 47.9886 71.2094 46.2868 70.1346 45.4734ZM52.039 42.8628L52.7683 51.0571C52.8509 51.0121 53.1353 50.8618 53.6226 50.6052C54.1098 50.3487 54.4929 50.1397 54.7725 49.978C55.0518 49.8164 55.4624 49.5734 56.0041 49.2501C56.5458 48.9268 56.9946 48.6305 57.3509 48.3614C57.707 48.0926 58.1228 47.7632 58.5977 47.3735C59.0727 46.9839 59.4581 46.6009 59.7528 46.2258C60.0479 45.8505 60.332 45.4433 60.6039 45.0057C60.8757 44.5683 61.0683 44.104 61.1798 43.6141C61.2915 43.1237 61.3252 42.6295 61.2808 42.1312C61.2286 41.544 61.0792 41.0798 60.8325 40.7386C60.5865 40.397 60.3019 40.1602 59.9788 40.0286C59.6563 39.8967 59.2388 39.8631 58.7257 39.9286C58.2134 39.9935 57.7466 40.0941 57.3267 40.23C56.9069 40.3659 56.3937 40.571 55.7874 40.8458C55.1807 41.1207 54.7007 41.3593 54.347 41.5614C53.9935 41.7637 53.5494 42.0151 53.0142 42.3167C52.4797 42.6176 52.1547 42.7997 52.039 42.8628ZM63.5439 56.7643C63.764 56.3268 63.9339 55.8607 64.0545 55.3656C64.1749 54.8704 64.2128 54.3747 64.1685 53.8759C64.1114 53.2351 63.9372 52.733 63.6451 52.37C63.3536 52.0064 63.0124 51.764 62.6212 51.641C62.2299 51.5186 61.7316 51.5059 61.1269 51.6027C60.5214 51.6994 59.9674 51.8293 59.4635 51.992C58.9591 52.1552 58.3421 52.4082 57.6125 52.7506C56.8822 53.0926 56.3109 53.3767 55.8989 53.6014C55.4868 53.8262 54.9562 54.1244 54.3065 54.4976C53.6568 54.871 53.2661 55.0933 53.1344 55.1651L53.9373 64.1874C54.0693 64.1154 54.3744 63.9537 54.8534 63.7012C55.3322 63.4491 55.7283 63.2381 56.0416 63.0672C56.3546 62.8965 56.7905 62.6445 57.3484 62.3127C57.9067 61.98 58.3855 61.6817 58.7851 61.4169C59.1854 61.1516 59.6482 60.8203 60.1751 60.4209C60.7007 60.0218 61.1473 59.6483 61.5139 59.2984C61.88 58.9494 62.2553 58.5491 62.6382 58.0973C63.0213 57.6461 63.3233 57.2013 63.5439 56.7643Z"
        fill={`url(#${prefix}paint4_linear_439_600)`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M141.254 56.9732C128.328 63.1116 115.762 74.2681 105.871 88.388C95.9806 102.508 89.8655 118.02 88.6523 132.066C87.3934 146.64 91.5336 157.93 100.31 163.855L113.074 172.472C121.84 178.391 134.021 178.115 147.372 171.696C160.196 165.53 172.714 154.347 182.621 140.205C192.527 126.064 198.685 110.586 199.96 96.623C201.288 82.0864 197.192 70.821 188.425 64.9025L175.662 56.2851C166.885 50.36 154.666 50.6041 141.254 56.9732ZM110.571 91.5613C101.244 104.877 95.4849 119.412 94.3553 132.488C93.2776 144.966 96.5527 154.449 103.577 159.191C110.561 163.907 120.658 163.461 132.006 157.938C143.858 152.169 155.544 141.627 164.913 128.251C174.283 114.875 180.129 100.389 181.375 87.4604C182.568 75.08 179.379 65.6648 172.394 60.9494C165.37 56.2068 155.178 56.5979 143.696 62.0506C131.663 67.765 119.899 78.2456 110.571 91.5613Z"
        fill={`url(#${prefix}paint5_linear_439_600)`}
      />
      <path
        data-figma-bg-blur-radius="1.27803"
        d="M176.235 56.5595C184.656 62.2752 189.001 73.1061 188.334 87.1878C187.638 101.887 181.588 118.128 171.269 132.909C160.95 147.69 147.724 159.061 134.045 164.95C120.94 170.592 109.126 170.455 100.704 164.738C92.2322 158.988 87.7814 148.072 88.3057 133.87C88.8551 118.994 94.7984 102.693 105.069 87.9817C115.339 73.2705 128.66 61.9759 142.559 56.1591C155.828 50.6056 167.762 50.808 176.235 56.5595Z"
        stroke={`url(#${prefix}paint6_linear_439_600)`}
      />
      <mask
        id="mask1_439_600"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="90"
        y="55"
        width="93"
        height="110"
      >
        <path
          data-figma-bg-blur-radius="1.27803"
          d="M90.8133 132.701C91.8941 119.05 97.8268 103.912 107.519 90.0758C117.211 76.2393 129.487 65.3834 142.084 59.5083C154.104 53.9022 164.809 53.5734 172.228 58.5823C179.604 63.5626 183.032 73.4224 181.879 86.3455C180.674 99.8404 174.65 114.927 164.913 128.826C155.177 142.725 142.984 153.646 130.579 159.579C118.7 165.26 108.096 165.647 100.719 160.666C93.3002 155.657 89.7821 145.726 90.8133 132.701Z"
          fill="#797BF6"
        />
      </mask>
      <g mask="url(#mask1_439_600)">
        <g filter="url(#filter1_i_439_600)" data-figma-bg-blur-radius="3.44504">
          <path
            d="M89.4178 142.125C87.4392 126.747 90.9439 109.261 99.2869 92.8866C107.63 76.5125 119.798 63.2382 133.551 55.5096C146.673 48.1348 159.48 46.7872 169.614 51.7148C179.69 56.6143 186.185 67.3369 187.902 81.9072C189.695 97.1223 186.067 114.56 177.686 131.008C169.305 147.456 157.252 160.796 143.744 168.572C130.81 176.018 118.137 177.42 108.061 172.521C97.9269 167.593 91.3059 156.799 89.4178 142.125Z"
            fill={`url(#${prefix}paint7_linear_439_600)`}
          />
        </g>
      </g>
      <path
        d="M146.261 80.1167L152.092 71.3732L158.98 75.9155L153.149 84.6589L146.261 80.1167ZM107.439 138.331L113.369 129.439L120.257 133.981L114.327 142.874L107.439 138.331ZM115.495 134.283C112.679 132.427 110.781 130.027 109.799 127.085C108.818 124.142 108.754 120.836 109.608 117.168C110.462 113.499 112.235 109.647 114.926 105.611L122.116 110.352C119.823 113.79 118.599 116.784 118.442 119.335C118.319 121.907 119.33 123.901 121.475 125.316C123.185 126.443 124.908 126.79 126.644 126.357C128.447 125.897 130.047 124.62 131.442 122.528C132.439 121.033 132.901 119.616 132.829 118.277C132.756 116.939 132.333 115.619 131.559 114.32C130.851 112.993 129.994 111.638 128.985 110.256C128.01 108.895 127.085 107.424 126.209 105.843C125.333 104.261 124.691 102.547 124.283 100.699C123.907 98.8736 123.983 96.8431 124.508 94.6075C125.067 92.3221 126.277 89.7844 128.138 86.9945C130.064 84.1049 132.312 81.8569 134.879 80.2504C137.513 78.6161 140.234 77.7564 143.042 77.6711C145.849 77.5858 148.543 78.3942 151.124 80.0961C153.504 81.6655 155.234 83.7747 156.315 86.424C157.429 89.0953 157.759 92.1103 157.305 95.4689C156.851 98.8276 155.444 102.347 153.086 106.029L145.745 101.188C146.908 99.3723 147.586 97.6677 147.78 96.0742C148.008 94.5027 147.868 93.1197 147.362 91.9251C146.923 90.7027 146.183 89.749 145.144 89.0638C143.636 88.0691 142.03 87.7634 140.327 88.1465C138.657 88.5517 137.174 89.7258 135.879 91.6688C134.948 93.0638 134.536 94.4057 134.641 95.6947C134.747 96.9838 135.17 98.267 135.911 99.5444C136.718 100.794 137.626 102.11 138.635 103.492C139.676 104.825 140.618 106.271 141.46 107.83C142.369 109.362 142.978 111.091 143.287 113.016C143.662 114.913 143.537 117.054 142.912 119.439C142.287 121.824 140.977 124.512 138.984 127.501C136.957 130.54 134.593 132.854 131.892 134.444C129.191 136.034 126.42 136.825 123.578 136.816C120.737 136.808 118.042 135.963 115.495 134.283Z"
        fill={`url(#${prefix}paint8_linear_439_600)`}
      />
      <defs>
        <clipPath id="bgblur_0_439_600_clip_path" transform="translate(0 0)">
          <path d="M59.2831 2.53222C67.1784 2.32836 74.8632 7.19857 80.8881 16.4325C87.1765 26.0705 90.7962 39.1286 91.0495 53.2086C91.3027 67.2885 88.1558 80.522 82.2182 90.4778C76.5292 100.017 69.0241 105.281 61.1269 105.486C53.1828 105.691 45.391 100.813 39.2211 91.5677C32.7593 81.8841 29.0462 68.8378 28.7941 54.8248C28.5422 40.8116 31.7826 27.5833 37.892 17.5731C43.7255 8.01473 51.337 2.73745 59.2831 2.53222Z" />
        </clipPath>
        <clipPath id="bgblur_1_439_600_clip_path" transform="translate(0 0)">
          <path d="M40.1824 89.4148C34.6048 80.3711 31.4137 68.2139 31.1971 55.1822C30.9805 42.1505 33.7645 29.826 39.0367 20.4794C44.0671 11.5609 50.6864 6.54198 57.6756 6.34667C64.6251 6.15246 71.3151 10.7927 76.5131 19.4127C81.9411 28.4142 85.0505 40.5807 85.268 53.6713C85.4856 66.7619 82.7836 79.0904 77.6594 88.3868C72.7526 97.2892 66.2232 102.299 59.2736 102.493C52.2845 102.688 45.5044 98.0439 40.1824 89.4148Z" />
        </clipPath>
        <filter
          id="filter0_i_439_600"
          x="20.2556"
          y="-1.04172"
          width="80.9861"
          height="111.792"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.52284" />
          <feGaussianBlur stdDeviation="23.4856" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.560784 0 0 0 0 0.607843 0 0 0 0 1 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_439_600"
          />
        </filter>
        <clipPath
          id="bgblur_2_439_600_clip_path"
          transform="translate(-20.2556 1.04172)"
        >
          <path d="M43.3875 97.4978C34.3069 89.1786 27.8022 76.8616 25.0719 62.8155C22.3416 48.7694 23.7169 34.6989 28.9447 23.1963C33.9328 12.2207 41.7558 5.04704 50.9732 2.99621C60.138 0.957076 69.8658 4.21814 78.3644 12.1788C87.2391 20.4919 93.6372 32.8403 96.3798 46.95C99.1225 61.0596 97.8566 75.1128 92.8153 86.5221C87.9878 97.4478 80.282 104.588 71.117 106.627C61.8999 108.678 52.052 105.436 43.3875 97.4978Z" />
        </clipPath>
        <clipPath
          id="bgblur_3_439_600_clip_path"
          transform="translate(-20.2556 1.04172)"
        >
          <path d="M176.235 56.5595C184.656 62.2752 189.001 73.1061 188.334 87.1878C187.638 101.887 181.588 118.128 171.269 132.909C160.95 147.69 147.724 159.061 134.045 164.95C120.94 170.592 109.126 170.455 100.704 164.738C92.2322 158.988 87.7814 148.072 88.3057 133.87C88.8551 118.994 94.7984 102.693 105.069 87.9817C115.339 73.2705 128.66 61.9759 142.559 56.1591C155.828 50.6056 167.762 50.808 176.235 56.5595Z" />
        </clipPath>
        <clipPath
          id="bgblur_4_439_600_clip_path"
          transform="translate(-20.2556 1.04172)"
        >
          <path d="M90.8133 132.701C91.8941 119.05 97.8268 103.912 107.519 90.0758C117.211 76.2393 129.487 65.3834 142.084 59.5083C154.104 53.9022 164.809 53.5734 172.228 58.5823C179.604 63.5626 183.032 73.4224 181.879 86.3455C180.674 99.8404 174.65 114.927 164.913 128.826C155.177 142.725 142.984 153.646 130.579 159.579C118.7 165.26 108.096 165.647 100.719 160.666C93.3002 155.657 89.7821 145.726 90.8133 132.701Z" />
        </clipPath>
        <filter
          id="filter1_i_439_600"
          x="85.4335"
          y="45.3523"
          width="106.361"
          height="133.564"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.52284" />
          <feGaussianBlur stdDeviation="23.4856" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.560784 0 0 0 0 0.607843 0 0 0 0 1 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_439_600"
          />
        </filter>
        <clipPath
          id="bgblur_5_439_600_clip_path"
          transform="translate(-85.4335 -45.3523)"
        >
          <path d="M89.4178 142.125C87.4392 126.747 90.9439 109.261 99.2869 92.8866C107.63 76.5125 119.798 63.2382 133.551 55.5096C146.673 48.1348 159.48 46.7872 169.614 51.7148C179.69 56.6143 186.185 67.3369 187.902 81.9072C189.695 97.1223 186.067 114.56 177.686 131.008C169.305 147.456 157.252 160.796 143.744 168.572C130.81 176.018 118.137 177.42 108.061 172.521C97.9269 167.593 91.3059 156.799 89.4178 142.125Z" />
        </clipPath>
        <linearGradient
          id={`${prefix}paint0_linear_439_600`}
          x1="115.278"
          y1="218.098"
          x2="124.932"
          y2="89.7593"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDEAFF" />
          <stop offset="1" stopColor="#F0F6FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint1_linear_439_600`}
          x1="51.3719"
          y1="3.57355"
          x2="111.673"
          y2="26.042"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint2_linear_439_600`}
          x1="123.283"
          y1="131.054"
          x2="9.69534"
          y2="97.1466"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint3_linear_439_600`}
          x1="93.4007"
          y1="-60.6343"
          x2="25.9738"
          y2="95.9629"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint4_linear_439_600`}
          x1="39.5436"
          y1="-46.7207"
          x2="105.805"
          y2="28.0977"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint5_linear_439_600`}
          x1="167.784"
          y1="50.9664"
          x2="213.699"
          y2="119.333"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint6_linear_439_600`}
          x1="146.242"
          y1="237.459"
          x2="54.1463"
          y2="117.164"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint7_linear_439_600`}
          x1="258.215"
          y1="19.2414"
          x2="67.6678"
          y2="113.592"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint8_linear_439_600`}
          x1="154.884"
          y1="103.658"
          x2="109.468"
          y2="105.521"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6FA5F9" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const WideCoinsEmptyState = (props: any) => {
  return (
    <Icon
      {...props}
      $size={356}
      width="356"
      height="176"
      viewBox="0 0 356 176"
      fill="none"
    >
      <path
        d="M178 162.329C276.307 162.329 356 150.633 356 136.207C356 121.78 276.307 110.084 178 110.084C79.6933 110.084 0 121.78 0 136.207C0 150.633 79.6933 162.329 178 162.329Z"
        fill="url(#paint0_linear_439_779)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.492 96.8822C100.697 93.0277 91.7582 90.909 82.3212 90.9167C72.8842 90.9243 63.9994 93.0574 57.3035 96.9229C50.356 100.934 46.5705 106.328 46.6444 112.113L46.7518 120.525C46.8256 126.303 50.7509 131.665 57.8044 135.621C64.5793 139.422 73.5158 141.51 82.9673 141.503C92.4189 141.495 101.302 139.392 107.98 135.581C114.932 131.612 118.72 126.245 118.646 120.467L118.539 112.054C118.465 106.27 114.542 100.882 107.492 96.8822ZM82.3606 94.0143C73.4611 94.0216 65.1269 96.0075 58.8933 99.606C52.9453 103.04 49.7023 107.48 49.7615 112.11C49.8203 116.714 53.1712 121.089 59.1971 124.431C65.4897 127.921 73.8782 129.839 82.818 129.832C91.7577 129.825 100.097 127.893 106.301 124.393C112.241 121.042 115.48 116.66 115.421 112.057C115.362 107.427 112.006 102.992 105.97 99.5678C99.645 95.9793 91.2602 94.0071 82.3606 94.0143Z"
        fill="url(#paint1_linear_439_779)"
      />
      <ellipse
        cx="82.5701"
        cy="111.908"
        rx="33.2666"
        ry="18.1568"
        transform="rotate(0.586894 82.5701 111.908)"
        fill="#D7E8FF"
      />
      <foreignObject x="0" y="0" width="0" height="0">
        <div
          style={{
            backdropFilter: "blur(0.64px)",
            clipPath: "url(#bgblur_0_439_779_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <path
        data-figma-bg-blur-radius="1.27803"
        d="M108.611 97.4101L108.611 97.4101C115.306 101.581 118.92 106.922 118.979 112.408C119.037 117.858 115.545 123.136 108.953 127.233C102.074 131.507 92.7976 133.889 82.8259 133.911C72.8544 133.932 63.5271 131.59 56.5556 127.345C49.8731 123.275 46.2675 118.008 46.2096 112.556C46.1513 107.072 49.6497 101.719 56.2527 97.5216C63.1658 93.1269 72.4345 90.6791 82.358 90.6577C92.2813 90.6363 101.603 93.0439 108.611 97.4101Z"
        stroke="url(#paint2_linear_439_779)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M88.5417 119.52C89.1301 118.778 89.2388 117.713 88.8672 116.327C90.7518 117.991 92.7886 118.634 94.9782 118.26C95.7753 118.13 96.3854 117.865 96.8091 117.466C97.2329 117.067 97.4704 116.553 97.5207 115.921C97.5717 115.289 97.5053 114.611 97.3232 113.888C97.1411 113.165 96.8493 112.341 96.4479 111.416L101.226 111.072L99.7945 108.386L95.1487 108.721C94.9008 108.256 94.51 107.548 93.9764 106.596L98.6601 106.259L97.228 103.573L92.4494 103.917C92.2321 103.534 91.925 102.971 91.5283 102.227L89.576 98.5285L86.4661 98.7526L87.4982 100.688C87.9694 101.572 87.8154 102.12 87.0365 102.333L81.5941 102.725C81.6562 102.842 81.6992 102.935 81.7238 103.006L81.575 102.727L73.9524 103.276C73.2583 103.23 72.7559 102.916 72.4459 102.334L71.4138 100.399L67.6553 100.108L69.5152 103.596C69.633 103.817 69.8002 104.137 70.0177 104.556C70.2345 104.975 70.3986 105.289 70.5102 105.498L65.6749 105.847L67.1073 108.533L71.8858 108.189C72.1331 108.678 72.5051 109.387 73.001 110.318L68.2417 110.66L69.6736 113.346L74.509 112.998C75.0679 113.948 75.6132 114.786 76.1463 115.514C76.6795 116.243 77.2739 116.933 77.9307 117.586C78.587 118.239 79.2576 118.776 79.9419 119.198C80.6258 119.619 81.3884 119.953 82.2295 120.201C83.0701 120.448 83.9611 120.58 84.9021 120.597C86.7398 120.622 87.953 120.263 88.5417 119.52ZM90.5909 106.894L84.7695 107.314C84.8006 107.372 84.9041 107.573 85.0808 107.916C85.2575 108.26 85.4016 108.53 85.5133 108.727C85.6248 108.924 85.7928 109.214 86.0163 109.597C86.2397 109.979 86.4451 110.296 86.6321 110.548C86.8189 110.8 87.048 111.095 87.3194 111.431C87.5906 111.768 87.8581 112.041 88.121 112.252C88.3841 112.462 88.6698 112.665 88.9773 112.86C89.2847 113.055 89.612 113.195 89.9583 113.278C90.305 113.362 90.6553 113.391 91.0093 113.365C91.4264 113.335 91.7574 113.236 92.0021 113.067C92.2471 112.899 92.4182 112.703 92.5151 112.478C92.6122 112.254 92.6406 111.962 92.5997 111.603C92.5592 111.244 92.4929 110.916 92.4011 110.621C92.3092 110.326 92.1693 109.965 91.981 109.538C91.7925 109.111 91.6285 108.772 91.489 108.523C91.3493 108.273 91.1758 107.96 90.9677 107.582C90.76 107.205 90.6344 106.976 90.5909 106.894ZM80.6033 114.786C80.9113 114.945 81.2401 115.069 81.59 115.159C81.94 115.248 82.2912 115.28 82.6456 115.255C83.1008 115.222 83.459 115.106 83.7197 114.906C83.9808 114.706 84.1565 114.47 84.248 114.198C84.3391 113.925 84.3535 113.577 84.2914 113.153C84.2294 112.729 84.1433 112.34 84.0333 111.986C83.923 111.631 83.7503 111.197 83.5153 110.683C83.2807 110.168 83.0854 109.766 82.9304 109.475C82.7754 109.184 82.5696 108.81 82.3119 108.351C82.0541 107.893 81.9007 107.617 81.8511 107.524L75.4416 107.986C75.4912 108.079 75.6026 108.294 75.7766 108.632C75.9502 108.97 76.0956 109.249 76.2134 109.47C76.3311 109.691 76.5051 109.999 76.7344 110.392C76.9644 110.786 77.1708 111.125 77.3543 111.407C77.5382 111.69 77.7682 112.017 78.0458 112.39C78.3232 112.762 78.5833 113.078 78.8275 113.339C79.0712 113.599 79.351 113.865 79.6674 114.138C79.9833 114.411 80.2957 114.627 80.6033 114.786Z"
        fill="url(#paint3_linear_439_779)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M275.775 91.8405C268.8 87.1596 259.385 84.1674 249.264 83.4153C239.144 82.6631 229.444 84.2348 221.952 87.8405C214.179 91.5816 209.685 97.0616 209.298 103.271L208.735 112.301C208.349 118.503 212.126 124.568 219.371 129.379C226.33 134.001 235.745 136.961 245.881 137.714C256.017 138.467 265.713 136.927 273.181 133.378C280.956 129.683 285.45 124.233 285.837 118.031L286.399 109.001C286.786 102.792 283.013 96.6972 275.775 91.8405ZM249.057 86.7403C239.513 86.031 230.415 87.4891 223.441 90.8458C216.786 94.0488 212.95 98.5496 212.641 103.519C212.333 108.461 215.574 113.423 221.766 117.492C228.233 121.742 237.074 124.474 246.661 125.187C256.249 125.899 265.347 124.5 272.282 121.246C278.922 118.131 282.748 113.693 283.056 108.752C283.366 103.783 280.124 98.7559 273.927 94.5979C267.434 90.2401 258.601 87.4496 249.057 86.7403Z"
        fill="url(#paint4_linear_439_779)"
      />
      <ellipse
        cx="248.063"
        cy="106.201"
        rx="36.084"
        ry="19.1836"
        transform="rotate(4.3815 248.063 106.201)"
        fill="#D7E8FF"
      />
      <foreignObject x="0" y="0" width="0" height="0">
        <div
          style={{
            backdropFilter: "blur(0.64px)",
            clipPath: "url(#bgblur_1_439_779_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <path
        data-figma-bg-blur-radius="1.27803"
        d="M276.955 92.4676L276.955 92.4676C283.804 97.484 287.26 103.513 286.88 109.419C286.502 115.286 282.32 120.675 274.914 124.54C267.185 128.573 257.039 130.381 246.338 129.6C235.638 128.819 225.817 125.555 218.677 120.435C211.833 115.528 208.38 109.579 208.758 103.71C209.138 97.8067 213.333 92.3388 220.759 88.3659C228.534 84.2062 238.678 82.3272 249.327 83.1042C259.975 83.8813 269.785 87.216 276.955 92.4676Z"
        stroke="url(#paint5_linear_439_779)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M277.133 72.1784C270.157 67.4975 260.742 64.5053 250.622 63.7532C240.501 63.001 230.801 64.5727 223.31 68.1784C215.536 71.9195 211.042 77.3995 210.655 83.6085L210.093 92.6387C209.706 98.8408 213.484 104.906 220.729 109.717C227.688 114.339 237.103 117.299 247.239 118.052C257.375 118.805 267.07 117.265 274.538 113.716C282.313 110.021 286.808 104.571 287.194 98.3686L287.757 89.3385C288.143 83.1294 284.371 77.0351 277.133 72.1784ZM250.414 67.0782C240.87 66.3689 231.773 67.827 224.798 71.1837C218.143 74.3867 214.308 78.8875 213.998 83.857C213.69 88.7984 216.931 93.7607 223.124 97.83C229.591 102.08 238.432 104.812 248.019 105.525C257.606 106.237 266.705 104.838 273.639 101.584C280.279 98.4686 284.106 94.0314 284.414 89.0901C284.723 84.1204 281.481 79.0938 275.285 74.9358C268.791 70.5779 259.958 67.7875 250.414 67.0782Z"
        fill="url(#paint6_linear_439_779)"
      />
      <foreignObject x="0" y="0" width="0" height="0">
        <div
          style={{
            backdropFilter: "blur(0.64px)",
            clipPath: "url(#bgblur_2_439_779_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <path
        data-figma-bg-blur-radius="1.27803"
        d="M278.313 72.8055L278.313 72.8055C285.162 77.8218 288.618 83.8512 288.237 89.7571C287.859 95.6235 283.678 101.012 276.271 104.878C268.543 108.911 258.396 110.719 247.696 109.938C236.996 109.157 227.175 105.893 220.034 100.773C213.19 95.8662 209.737 89.9169 210.116 84.0482C210.496 78.1446 214.691 72.6767 222.117 68.7038C229.891 64.5441 240.035 62.6651 250.684 63.4421C261.333 64.2191 271.143 67.5538 278.313 72.8055Z"
        stroke="url(#paint7_linear_439_779)"
      />
      <ellipse
        cx="249.86"
        cy="86.4445"
        rx="36.04"
        ry="20.0205"
        transform="rotate(2.74381 249.86 86.4445)"
        fill="#D7E8FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M277.703 48.3019C270.727 43.621 261.312 40.6288 251.192 39.8767C241.071 39.1246 231.372 40.6962 223.88 44.3019C216.106 48.0431 211.612 53.523 211.225 59.7321L210.663 68.7622C210.276 74.9643 214.054 81.0297 221.299 85.8408C228.258 90.4621 237.673 93.4222 247.809 94.1754C257.945 94.9287 267.64 93.3889 275.108 89.8398C282.883 86.1447 287.378 80.6941 287.764 74.4922L288.327 65.462C288.713 59.253 284.941 53.1586 277.703 48.3019ZM250.984 43.2017C241.44 42.4924 232.343 43.9506 225.368 47.3073C218.713 50.5102 214.878 55.011 214.568 59.9805C214.26 64.922 217.501 69.8843 223.694 73.9536C230.161 78.2031 239.002 80.9357 248.589 81.6482C258.176 82.3607 267.275 80.9612 274.209 77.7077C280.849 74.5921 284.676 70.1549 284.984 65.2136C285.293 60.244 282.051 55.2173 275.855 51.0593C269.361 46.7015 260.528 43.911 250.984 43.2017Z"
        fill="url(#paint8_linear_439_779)"
      />
      <foreignObject x="0" y="0" width="0" height="0">
        <div
          style={{
            backdropFilter: "blur(0.64px)",
            clipPath: "url(#bgblur_3_439_779_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <path
        data-figma-bg-blur-radius="1.27803"
        d="M278.883 48.9291L278.883 48.9291C285.732 53.9454 289.188 59.9748 288.808 65.8806C288.43 71.7471 284.248 77.136 276.841 81.0013C269.113 85.0344 258.967 86.8423 248.266 86.0615C237.566 85.2807 227.745 82.0162 220.605 76.8966C213.761 71.9897 210.308 66.0404 210.686 60.1718C211.066 54.2681 215.261 48.8002 222.687 44.8273C230.462 40.6676 240.606 38.7887 251.255 39.5657C261.903 40.3427 271.713 43.6774 278.883 48.9291Z"
        stroke="url(#paint9_linear_439_779)"
      />
      <ellipse
        cx="249.842"
        cy="62.4243"
        rx="35.3329"
        ry="19.3293"
        transform="rotate(4.3815 249.842 62.4243)"
        fill="#D7E8FF"
      />
      <path
        d="M267.448 57.7792L273.627 58.0966L273.379 62.9373L267.199 62.6199L267.448 57.7792ZM226.307 55.666L232.591 55.9888L232.343 60.8295L226.058 60.5067L226.307 55.666ZM230.767 58.5167C230.869 56.538 231.52 54.8592 232.72 53.4802C233.921 52.1011 235.58 51.0763 237.697 50.4057C239.814 49.735 242.299 49.473 245.151 49.6195L244.891 54.6721C242.462 54.5474 240.576 54.8284 239.235 55.5153C237.892 56.2257 237.182 57.3347 237.105 58.8422C237.043 60.0436 237.381 61.0175 238.12 61.7639C238.892 62.5358 240.017 62.9596 241.496 63.0356C242.552 63.0898 243.409 62.8977 244.067 62.4591C244.725 62.0206 245.269 61.4108 245.697 60.6298C246.159 59.8742 246.591 59.0343 246.991 58.1101C247.391 57.2095 247.861 56.3008 248.402 55.3839C248.944 54.467 249.622 53.628 250.438 52.8669C251.252 52.1293 252.306 51.5575 253.597 51.1515C254.924 50.7473 256.573 50.5959 258.545 50.6971C260.587 50.802 262.399 51.2612 263.981 52.0746C265.598 52.9134 266.846 54.0285 267.728 55.42C268.61 56.8115 269.004 58.4142 268.911 60.228C268.825 61.9004 268.271 63.4071 267.249 64.7481C266.226 66.1126 264.794 67.1845 262.954 67.9638C261.113 68.7431 258.907 69.0904 256.334 69.0055L256.599 63.8468C257.868 63.8883 258.935 63.7188 259.802 63.3382C260.668 62.9811 261.328 62.4955 261.783 61.8812C262.272 61.2922 262.536 60.6327 262.573 59.9024C262.628 58.8424 262.303 57.9401 261.6 57.1955C260.896 56.4744 259.857 56.0785 258.484 56.008C257.498 55.9574 256.694 56.1522 256.071 56.5926C255.449 57.033 254.924 57.6319 254.496 58.3893C254.103 59.1721 253.706 60.0256 253.306 60.9498C252.94 61.8757 252.488 62.7854 251.948 63.6787C251.442 64.5974 250.746 65.4238 249.861 66.1577C249.01 66.917 247.886 67.4969 246.489 67.8975C245.091 68.2981 243.336 68.4441 241.224 68.3356C239.076 68.2253 237.195 67.7272 235.582 66.8413C233.968 65.9554 232.739 64.7941 231.895 63.3573C231.051 61.9205 230.675 60.3069 230.767 58.5167Z"
        fill="url(#paint10_linear_439_779)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M177.214 63.4518C170.577 69.0981 164.939 77.6553 161.339 87.5473C157.739 97.4393 156.578 107.565 158.068 116.06C159.615 124.873 163.821 130.903 169.911 133.037L178.767 136.141C184.85 138.272 191.969 136.209 198.812 130.33C205.385 124.684 210.99 116.118 214.596 106.21C218.201 96.3032 219.393 86.1907 217.952 77.7359C216.452 68.9335 212.276 62.9118 206.193 60.7801L197.336 57.6763C191.246 55.5423 184.1 57.5932 177.214 63.4518ZM164.6 88.6903C161.206 98.0189 160.1 107.512 161.488 115.42C162.812 122.965 166.226 128.061 171.1 129.769C175.946 131.468 181.813 129.629 187.619 124.592C193.682 119.333 198.899 111.276 202.309 101.905C205.719 92.5342 206.883 83.0567 205.587 75.2181C204.346 67.7117 200.994 62.6424 196.147 60.944C191.273 59.2359 185.342 61.0573 179.447 66.0729C173.268 71.3292 167.995 79.3617 164.6 88.6903Z"
        fill="url(#paint11_linear_439_779)"
      />
      <ellipse
        cx="183.491"
        cy="95.2347"
        rx="19.9762"
        ry="36.8352"
        transform="rotate(20.1707 183.491 95.2347)"
        fill="#D7E8FF"
      />
      <foreignObject x="0" y="0" width="0" height="0">
        <div
          style={{
            backdropFilter: "blur(0.64px)",
            clipPath: "url(#bgblur_4_439_779_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <path
        data-figma-bg-blur-radius="1.27803"
        d="M178.16 62.4353L178.16 62.4353C185.099 57.0075 192.098 55.251 197.895 57.2965C203.654 59.3284 207.86 65.0271 209.634 73.5133C211.486 82.3684 210.434 93.0106 206.641 103.476C202.848 113.941 196.823 122.83 189.698 128.52C182.87 133.973 175.952 135.75 170.191 133.717C164.396 131.672 160.115 125.938 158.239 117.402C156.274 108.465 157.254 97.8056 161.029 87.3904C164.803 76.9754 170.896 68.1178 178.16 62.4353Z"
        stroke="url(#paint12_linear_439_779)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M193.69 91.9646C193.137 91.0642 192.063 90.5435 190.469 90.4029C192.932 89.0639 194.386 87.1757 194.83 84.738C194.999 83.8529 194.955 83.1127 194.699 82.516C194.443 81.9193 193.994 81.4738 193.351 81.1795C192.709 80.8847 191.974 80.695 191.146 80.6094C190.319 80.5238 189.344 80.5144 188.221 80.5814L189.687 75.4423L186.325 75.9161L184.9 80.9125C184.318 80.9945 183.426 81.1332 182.225 81.3286L183.662 76.2915L180.3 76.7654L178.834 81.9045C178.35 81.9859 177.642 82.0923 176.711 82.2235L172.089 82.8553L171.135 86.1998L173.558 85.8583C174.664 85.7024 175.179 86.0735 175.105 86.9712L173.435 92.8241C173.581 92.8036 173.695 92.7942 173.779 92.7955L173.429 92.8447L171.09 101.042C170.776 101.752 170.255 102.158 169.528 102.261L167.105 102.603L165.363 106.43L169.729 105.815C170.006 105.776 170.405 105.723 170.927 105.655C171.449 105.588 171.841 105.536 172.103 105.499L170.62 110.699L173.982 110.225L175.448 105.086C176.055 105.014 176.941 104.896 178.105 104.731L176.645 109.85L180.007 109.376L181.49 104.176C182.7 103.953 183.787 103.703 184.754 103.422C185.721 103.142 186.672 102.783 187.607 102.345C188.542 101.906 189.361 101.409 190.064 100.853C190.768 100.298 191.409 99.6263 191.991 98.8396C192.571 98.0531 193.05 97.1701 193.427 96.1902C194.156 94.2742 194.243 92.8655 193.69 91.9646ZM181.243 84.9902L179.457 91.2508C179.53 91.2406 179.78 91.2088 180.207 91.155C180.635 91.1011 180.973 91.0535 181.223 91.0119C181.472 90.9703 181.84 90.9051 182.326 90.8171C182.812 90.7291 183.223 90.6352 183.559 90.5357C183.894 90.4363 184.29 90.3087 184.747 90.153C185.203 89.9974 185.592 89.8218 185.913 89.6266C186.234 89.4314 186.556 89.2097 186.878 88.962C187.2 88.7144 187.471 88.4249 187.691 88.0938C187.911 87.7625 188.076 87.4065 188.184 87.0258C188.312 86.5772 188.335 86.1924 188.251 85.8715C188.169 85.5503 188.028 85.296 187.83 85.1086C187.632 84.9212 187.338 84.78 186.945 84.6854C186.554 84.5905 186.185 84.5348 185.841 84.5182C185.496 84.5016 185.064 84.5102 184.545 84.5443C184.025 84.5784 183.608 84.6209 183.293 84.6717C182.978 84.7227 182.583 84.7847 182.108 84.8584C181.634 84.9319 181.345 84.9758 181.243 84.9902ZM185.695 98.4736C185.979 98.2115 186.234 97.9144 186.462 97.582C186.69 97.2495 186.858 96.8937 186.967 96.5126C187.106 96.023 187.121 95.6032 187.011 95.2535C186.902 94.9035 186.722 94.6292 186.471 94.4292C186.221 94.2296 185.861 94.0813 185.393 93.9843C184.925 93.887 184.484 93.8286 184.071 93.8084C183.658 93.7884 183.136 93.8034 182.508 93.8531C181.879 93.9023 181.383 93.9531 181.019 94.0043C180.655 94.0556 180.184 94.1281 179.605 94.2229C179.026 94.3178 178.678 94.3731 178.562 94.3895L176.596 101.283C176.712 101.266 176.98 101.232 177.401 101.179C177.821 101.126 178.169 101.08 178.446 101.041C178.722 101.002 179.111 100.938 179.611 100.848C180.112 100.757 180.545 100.67 180.911 100.586C181.278 100.502 181.709 100.386 182.206 100.237C182.702 100.089 183.133 99.9373 183.499 99.7809C183.864 99.625 184.251 99.4337 184.658 99.2065C185.065 98.9798 185.41 98.7351 185.695 98.4736Z"
        fill="url(#paint13_linear_439_779)"
      />
      <defs>
        <clipPath id="bgblur_0_439_779_clip_path" transform="translate(0 0)">
          <path d="M108.611 97.4101L108.611 97.4101C115.306 101.581 118.92 106.922 118.979 112.408C119.037 117.858 115.545 123.136 108.953 127.233C102.074 131.507 92.7976 133.889 82.8259 133.911C72.8544 133.932 63.5271 131.59 56.5556 127.345C49.8731 123.275 46.2675 118.008 46.2096 112.556C46.1513 107.072 49.6497 101.719 56.2527 97.5216C63.1658 93.1269 72.4345 90.6791 82.358 90.6577C92.2813 90.6363 101.603 93.0439 108.611 97.4101Z" />
        </clipPath>
        <clipPath id="bgblur_1_439_779_clip_path" transform="translate(0 0)">
          <path d="M276.955 92.4676L276.955 92.4676C283.804 97.484 287.26 103.513 286.88 109.419C286.502 115.286 282.32 120.675 274.914 124.54C267.185 128.573 257.039 130.381 246.338 129.6C235.638 128.819 225.817 125.555 218.677 120.435C211.833 115.528 208.38 109.579 208.758 103.71C209.138 97.8067 213.333 92.3388 220.759 88.3659C228.534 84.2062 238.678 82.3272 249.327 83.1042C259.975 83.8813 269.785 87.216 276.955 92.4676Z" />
        </clipPath>
        <clipPath id="bgblur_2_439_779_clip_path" transform="translate(0 0)">
          <path d="M278.313 72.8055L278.313 72.8055C285.162 77.8218 288.618 83.8512 288.237 89.7571C287.859 95.6235 283.678 101.012 276.271 104.878C268.543 108.911 258.396 110.719 247.696 109.938C236.996 109.157 227.175 105.893 220.034 100.773C213.19 95.8662 209.737 89.9169 210.116 84.0482C210.496 78.1446 214.691 72.6767 222.117 68.7038C229.891 64.5441 240.035 62.6651 250.684 63.4421C261.333 64.2191 271.143 67.5538 278.313 72.8055Z" />
        </clipPath>
        <clipPath id="bgblur_3_439_779_clip_path" transform="translate(0 0)">
          <path d="M278.883 48.9291L278.883 48.9291C285.732 53.9454 289.188 59.9748 288.808 65.8806C288.43 71.7471 284.248 77.136 276.841 81.0013C269.113 85.0344 258.967 86.8423 248.266 86.0615C237.566 85.2807 227.745 82.0162 220.605 76.8966C213.761 71.9897 210.308 66.0404 210.686 60.1718C211.066 54.2681 215.261 48.8002 222.687 44.8273C230.462 40.6676 240.606 38.7887 251.255 39.5657C261.903 40.3427 271.713 43.6774 278.883 48.9291Z" />
        </clipPath>
        <clipPath id="bgblur_4_439_779_clip_path" transform="translate(0 0)">
          <path d="M178.16 62.4353L178.16 62.4353C185.099 57.0075 192.098 55.251 197.895 57.2965C203.654 59.3284 207.86 65.0271 209.634 73.5133C211.486 82.3684 210.434 93.0106 206.641 103.476C202.848 113.941 196.823 122.83 189.698 128.52C182.87 133.973 175.952 135.75 170.191 133.717C164.396 131.672 160.115 125.938 158.239 117.402C156.274 108.465 157.254 97.8056 161.029 87.3904C164.803 76.9754 170.896 68.1178 178.16 62.4353Z" />
        </clipPath>
        <linearGradient
          id="paint0_linear_439_779"
          x1="192"
          y1="182.5"
          x2="194.208"
          y2="34.0327"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDEAFF" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_439_779"
          x1="118.472"
          y1="106.862"
          x2="102.272"
          y2="148.936"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_439_779"
          x1="27.2482"
          y1="155.743"
          x2="51.9159"
          y2="76.4894"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_439_779"
          x1="154.281"
          y1="99.1457"
          x2="101.141"
          y2="145.415"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_439_779"
          x1="286.747"
          y1="103.427"
          x2="265.984"
          y2="147.24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_439_779"
          x1="184.982"
          y1="148.497"
          x2="217.821"
          y2="65.4956"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_439_779"
          x1="288.104"
          y1="83.7651"
          x2="267.341"
          y2="127.578"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_439_779"
          x1="186.34"
          y1="128.834"
          x2="219.178"
          y2="45.8335"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_439_779"
          x1="288.674"
          y1="59.8887"
          x2="267.911"
          y2="103.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_439_779"
          x1="186.91"
          y1="104.958"
          x2="219.749"
          y2="21.957"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_439_779"
          x1="258.074"
          y1="69.2011"
          x2="243.577"
          y2="46.8308"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6FA5F9" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_439_779"
          x1="191.87"
          y1="55.7607"
          x2="229.765"
          y2="88.8234"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_439_779"
          x1="208.216"
          y1="170.043"
          x2="134.597"
          y2="113.894"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_439_779"
          x1="197.474"
          y1="15.2865"
          x2="225.643"
          y2="88.6624"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const BotsEmptyState = (props: any) => {
  const prefix = useMemo(() => uuidv4(), []);
  return (
    <Icon
      {...props}
      $size={356}
      width="356"
      height="233"
      viewBox="0 0 356 233"
      fill="none"
    >
      <path
        d="M178 232.329C276.307 232.329 356 220.633 356 206.207C356 191.78 276.307 180.084 178 180.084C79.6933 180.084 0 191.78 0 206.207C0 220.633 79.6933 232.329 178 232.329Z"
        fill={`url(#${prefix}paint0_linear_439_715)`}
      />
      <rect
        width="28.3704"
        height="63.234"
        rx="14.1852"
        transform="matrix(-0.866025 0.5 0.5 0.866025 219.871 93.9482)"
        fill={`url(#${prefix}paint1_linear_439_715)`}
      />
      <ellipse
        cx="11.0709"
        cy="12.178"
        rx="11.0709"
        ry="12.178"
        transform="matrix(-0.903963 0.42761 0.42761 0.903963 245.379 141.31)"
        fill={`url(#${prefix}paint2_linear_439_715)`}
        fillOpacity="0.5"
      />
      <circle
        cx="12.178"
        cy="12.178"
        r="12.178"
        transform="matrix(-1 0 0 1 253.863 145.613)"
        fill={`url(#${prefix}paint3_linear_439_715)`}
      />
      <rect
        width="26.393"
        height="49.1194"
        rx="13.1965"
        transform="matrix(-0.625828 0.779961 0.779961 0.625828 246.588 144.957)"
        fill={`url(#${prefix}paint4_linear_439_715)`}
        fillOpacity="0.5"
      />
      <rect
        width="28.3704"
        height="49.1194"
        rx="14.1852"
        transform="matrix(-0.625828 0.779961 0.779961 0.625828 247.985 144.875)"
        fill={`url(#${prefix}paint5_linear_439_715)`}
      />
      <path
        d="M261.136 193.945L263.446 179.714L288.204 195.323L284.833 216.086L265.674 204.007C262.28 201.867 260.493 197.905 261.136 193.945Z"
        fill={`url(#${prefix}paint6_linear_439_715)`}
      />
      <path
        d="M317.329 181.732L280.903 175.819L277.946 194.032L313.781 203.588L317.329 181.732Z"
        fill={`url(#${prefix}paint7_linear_439_715)`}
      />
      <path
        d="M328.356 178.289L316.856 184.646L313.781 203.588L325.163 197.959L328.356 178.289Z"
        fill={`url(#${prefix}paint8_linear_439_715)`}
      />
      <path
        d="M299.409 190.787L287.909 197.145L284.833 216.086L296.215 210.457L299.409 190.787Z"
        fill={`url(#${prefix}paint9_linear_439_715)`}
      />
      <path
        d="M263.343 179.783C262.417 186.378 272.768 193.516 287.809 197.487L299.737 190.97C289.924 188.465 281.835 185.028 282.675 181.4C283.548 177.627 292.346 178.709 302.764 181.121C307.868 182.439 312.908 183.632 316.74 184.959L328.347 178.342C320.943 175.59 312.683 173.501 302.553 171.131C281.967 168.239 264.477 171.71 263.343 179.783Z"
        fill={`url(#${prefix}paint10_linear_439_715)`}
      />
      <path
        d="M227.276 44.1794C226.019 40.8019 223.917 38.5903 221.538 38.5903H219.233C215.386 38.5903 212.266 44.3741 212.266 51.5064C212.266 58.6388 215.386 64.4205 219.233 64.4225H221.538C223.917 64.4225 226.022 62.215 227.276 58.8334C228.097 56.5605 228.518 54.0492 228.503 51.5064C228.518 48.9636 228.097 46.4524 227.276 44.1794Z"
        fill={`url(#${prefix}paint11_linear_439_715)`}
      />
      <path
        d="M220.754 44.7584C219.623 41.483 217.733 39.3364 215.59 39.3286C212.123 39.3286 209.314 44.9514 209.314 51.8766C209.314 58.8018 212.123 64.4169 215.59 64.4227C217.733 64.4227 219.623 62.2781 220.754 58.9949C221.495 56.7867 221.874 54.347 221.861 51.8766C221.874 49.4063 221.495 46.9666 220.754 44.7584Z"
        fill={`url(#${prefix}paint12_linear_439_715)`}
      />
      <path
        d="M146.5 90.4999C146.5 90.4999 152 74.2314 169.518 74.2314C188.5 74.2314 192.029 90.9999 192.029 90.9999V93.4211H147.007L146.5 90.4999Z"
        fill={`url(#${prefix}paint13_linear_439_715)`}
      />
      <g filter={`url(#${prefix}filter0_i_439_715)`}>
        <path
          d="M119.898 103.035C119.775 100.566 120.971 98.2285 123.195 97.1491C130.045 93.8246 146.962 87.3976 173.947 88.3501C199.245 89.2432 212.084 97.3744 217.515 102.18C219.879 104.272 220.813 107.379 220.813 110.535V195L173.947 199.5L141.794 196.574C131.874 195.671 124.13 187.605 123.632 177.656L119.898 103.035Z"
          fill={`url(#${prefix}paint14_linear_439_715)`}
        />
      </g>
      <path
        d="M117.898 40.7969C117.898 19.8241 134.9 2.15186 155.873 2.15186H184.734C205.707 2.15186 222.708 19.8241 222.708 40.7969V68.1387C222.708 76.5278 215.908 83.3285 207.519 83.3285H133.088C124.699 83.3285 117.898 76.5278 117.898 68.1387V40.7969Z"
        fill={`url(#${prefix}paint15_linear_439_715)`}
      />
      <path
        d="M175.311 19.9939C175.311 19.9933 175.31 19.9929 175.309 19.9928C174.168 19.7093 173.418 19.2254 173.414 18.6708L173.409 18.1349C173.402 17.2377 175.347 16.4943 177.754 16.4747C180.16 16.4551 182.116 17.1667 182.124 18.0638L182.129 18.6014C182.133 19.1562 181.392 19.653 180.254 19.9544C179.487 20.1489 178.642 20.2537 177.785 20.2607C176.929 20.2677 176.083 20.1768 175.313 19.995C175.312 19.9948 175.311 19.9944 175.311 19.9939Z"
        fill={`url(#${prefix}paint16_linear_439_715)`}
      />
      <path
        d="M175.249 18.7118C174.108 18.5296 173.356 18.2026 173.346 17.8162C173.334 17.1906 175.277 16.6464 177.681 16.6006C180.086 16.5549 182.045 17.0247 182.059 17.6502C182.067 18.0367 181.329 18.3921 180.192 18.6177C179.426 18.7639 178.582 18.8484 177.725 18.8647C176.868 18.881 176.021 18.8287 175.25 18.7118L175.249 18.7118Z"
        fill="#94BEFF"
      />
      <path
        d="M216.383 58.2361C216.383 44.9258 205.191 34.354 191.903 35.1118L178.409 35.8813L164.914 35.1118C151.626 34.354 140.434 44.9258 140.434 58.2361C140.434 64.5717 145.518 69.7311 151.853 69.816C159.782 69.9221 170.329 70.0633 178.409 70.1715C186.488 70.0633 197.036 69.9221 204.964 69.816C211.299 69.7311 216.383 64.5717 216.383 58.2361Z"
        fill={`url(#${prefix}paint17_linear_439_715)`}
      />
      <path
        d="M192.183 50.888C191.018 52.9049 190.703 55.3017 191.306 57.5513C191.908 59.8008 193.38 61.7188 195.397 62.8832C197.414 64.0476 199.811 64.3632 202.06 63.7604C204.31 63.1577 206.228 61.686 207.392 59.6691L199.787 55.2786L192.183 50.888Z"
        fill={`url(#${prefix}paint18_linear_439_715)`}
      />
      <path
        d="M194.281 52.0988C193.438 53.5593 193.209 55.2949 193.646 56.9239C194.082 58.5529 195.148 59.9417 196.608 60.7849C198.069 61.6282 199.804 61.8567 201.433 61.4202C203.062 60.9837 204.451 59.918 205.295 58.4575L199.788 55.2781L194.281 52.0988Z"
        fill={`url(#${prefix}paint19_linear_439_715)`}
      />
      <path
        d="M195.333 52.7914C194.671 53.9384 194.491 55.3015 194.834 56.5808C195.177 57.8601 196.014 58.9509 197.161 59.6131C198.308 60.2753 199.671 60.4548 200.95 60.112C202.23 59.7692 203.32 58.9323 203.983 57.7852L199.658 55.2883L195.333 52.7914Z"
        fill="white"
      />
      <path
        d="M152.594 58.2816C153.391 60.47 155.024 62.2524 157.135 63.2366C159.246 64.2209 161.661 64.3263 163.849 63.5298C166.038 62.7333 167.82 61.1 168.804 58.9893C169.789 56.8786 169.894 54.4634 169.097 52.275L160.846 55.2783L152.594 58.2816Z"
        fill={`url(#${prefix}paint20_linear_439_715)`}
      />
      <path
        d="M154.871 57.4528C155.448 59.0375 156.63 60.3282 158.159 61.0409C159.687 61.7537 161.436 61.83 163.021 61.2532C164.606 60.6764 165.896 59.4937 166.609 57.9653C167.322 56.4369 167.398 54.6879 166.821 53.1032L160.846 55.278L154.871 57.4528Z"
        fill={`url(#${prefix}paint21_linear_439_715)`}
      />
      <path
        d="M156.078 57.0921C156.531 58.3366 157.459 59.3503 158.66 59.91C159.86 60.4698 161.234 60.5297 162.478 60.0767C163.723 59.6238 164.737 58.6949 165.296 57.4946C165.856 56.2942 165.916 54.9207 165.463 53.6761L160.77 55.3841L156.078 57.0921Z"
        fill="white"
      />
      <path
        d="M175.589 9.67773L180.273 9.96424L179.289 16.3592C179.151 17.2597 178.349 17.9063 177.44 17.8507C176.53 17.795 175.813 17.0556 175.785 16.1449L175.589 9.67773Z"
        fill={`url(#${prefix}paint22_linear_439_715)`}
      />
      <circle
        cx="178.069"
        cy="6.07595"
        r="6.07595"
        fill={`url(#${prefix}paint23_linear_439_715)`}
      />
      <path
        d="M155.277 172.639C158.232 171.417 161.501 171.585 164.646 172.165L203.559 179.344L197.667 211.28L153.037 199.64C152.679 199.547 152.327 199.45 151.984 199.312C149.957 198.497 142.747 194.838 144.795 184.639C146.193 177.668 151.371 174.254 155.277 172.639Z"
        fill={`url(#${prefix}paint24_linear_439_715)`}
        fillOpacity="0.4"
      />
      <path
        d="M157.454 173.041C160.41 171.819 163.678 171.986 166.823 172.567L205.736 179.745L199.845 211.681L161.331 204.576C157.925 203.948 154.557 202.81 152.118 200.352C149.042 197.252 145.568 192.033 146.972 185.04C148.37 178.07 153.548 174.655 157.454 173.041Z"
        fill={`url(#${prefix}paint25_linear_439_715)`}
      />
      <path
        d="M208.255 181.2C212.75 175.817 220.112 174.327 227.09 175.019L253.014 177.588L249.81 209.905L224.111 207.357C216.996 206.652 209.948 203.635 206.62 197.308C205.156 194.524 204.113 191.466 204.443 188.72C204.756 186.112 206.341 183.493 208.255 181.2Z"
        fill={`url(#${prefix}paint26_linear_439_715)`}
      />
      <path
        d="M223.7 195.399C218.805 213.511 214.677 223.105 198.313 217.387C188.305 214.682 182.563 203.716 187.458 185.604C192.633 166.442 206.693 147.887 220.299 151.661C227.413 157.851 228.595 177.287 223.7 195.399Z"
        fill={`url(#${prefix}paint27_linear_439_715)`}
      />
      <path
        d="M275.1 188.572C272.558 207.161 269.69 217.204 252.729 213.624C242.458 212.219 235.362 202.076 237.904 183.487C240.589 163.822 252.163 143.622 266.14 145.627C273.986 150.858 277.641 169.983 275.1 188.572Z"
        fill={`url(#${prefix}paint28_linear_439_715)`}
      />
      <path
        d="M225.052 193.024C221.619 211.631 214.432 219.626 207.617 218.369C200.803 217.111 196.941 207.079 200.374 188.472C203.807 169.865 213.122 150.337 219.936 151.594C226.751 152.851 228.484 174.417 225.052 193.024Z"
        fill={`url(#${prefix}paint29_linear_439_715)`}
      />
      <path
        d="M276.138 186.045C275.11 204.938 269.003 213.785 262.084 213.409C255.164 213.032 250.053 203.575 251.081 184.682C252.109 165.789 258.853 145.231 265.772 145.607C272.692 145.984 277.166 167.152 276.138 186.045Z"
        fill={`url(#${prefix}paint30_linear_439_715)`}
      />
      <path
        d="M129.113 43.4416C127.857 40.0641 125.755 37.8525 123.376 37.8525H121.071C117.224 37.8525 114.104 43.6363 114.104 50.7686C114.104 57.901 117.224 63.6827 121.071 63.6847H123.376C125.755 63.6847 127.859 61.4772 129.113 58.0956C129.935 55.8227 130.356 53.3114 130.341 50.7686C130.356 48.2258 129.935 45.7146 129.113 43.4416Z"
        fill={`url(#${prefix}paint31_linear_439_715)`}
      />
      <path
        d="M122.591 44.0206C121.461 40.7452 119.571 38.5986 117.428 38.5908C113.961 38.5908 111.152 44.2136 111.152 51.1389C111.152 58.0641 113.961 63.6791 117.428 63.6849C119.571 63.6849 121.461 61.5403 122.591 58.2571C123.332 56.0489 123.712 53.6092 123.699 51.1389C123.712 48.6685 123.332 46.2288 122.591 44.0206Z"
        fill={`url(#${prefix}paint32_linear_439_715)`}
      />
      <rect
        x="123.431"
        y="92.4722"
        width="28.3704"
        height="63.9991"
        rx="14.1852"
        transform="rotate(30 123.431 92.4722)"
        fill={`url(#${prefix}paint33_linear_439_715)`}
        fillOpacity="0.5"
      />
      <rect
        x="121.955"
        y="93.9482"
        width="28.3704"
        height="63.234"
        rx="14.1852"
        transform="rotate(30 121.955 93.9482)"
        fill={`url(#${prefix}paint34_linear_439_715)`}
      />
      <ellipse
        cx="101.247"
        cy="157.052"
        rx="11.0709"
        ry="12.178"
        transform="rotate(25.316 101.247 157.052)"
        fill={`url(#${prefix}paint35_linear_439_715)`}
        fillOpacity="0.5"
      />
      <circle
        cx="100.14"
        cy="157.79"
        r="12.178"
        fill={`url(#${prefix}paint36_linear_439_715)`}
      />
      <rect
        x="95.2377"
        y="144.957"
        width="26.393"
        height="49.1194"
        rx="13.1965"
        transform="rotate(51.257 95.2377 144.957)"
        fill={`url(#${prefix}paint37_linear_439_715)`}
        fillOpacity="0.5"
      />
      <rect
        x="93.8408"
        y="144.875"
        width="28.3704"
        height="49.1194"
        rx="14.1852"
        transform="rotate(51.257 93.8408 144.875)"
        fill={`url(#${prefix}paint38_linear_439_715)`}
      />
      <path
        d="M80.6895 193.945L78.3792 179.714L53.6214 195.323L56.9922 216.086L76.152 204.007C79.5461 201.867 81.3325 197.905 80.6895 193.945Z"
        fill={`url(#${prefix}paint39_linear_439_715)`}
      />
      <path
        d="M24.4968 181.732L60.923 175.819L63.8799 194.032L28.0451 203.588L24.4968 181.732Z"
        fill={`url(#${prefix}paint40_linear_439_715)`}
      />
      <path
        d="M13.4695 178.289L24.9698 184.646L28.045 203.588L16.6629 197.959L13.4695 178.289Z"
        fill={`url(#${prefix}paint41_linear_439_715)`}
      />
      <path
        d="M42.4167 190.787L53.9171 197.145L56.9923 216.086L45.6102 210.457L42.4167 190.787Z"
        fill={`url(#${prefix}paint42_linear_439_715)`}
      />
      <path
        d="M78.4825 179.783C79.4085 186.378 69.058 193.516 54.0164 197.487L42.0883 190.97C51.9014 188.465 59.9906 185.028 59.1508 181.4C58.2776 177.627 49.4794 178.709 39.0619 181.121C33.9582 182.439 28.9176 183.632 25.0861 184.959L13.4782 178.342C20.8825 175.59 29.1422 173.501 39.2724 171.131C59.8589 168.239 77.3485 171.71 78.4825 179.783Z"
        fill={`url(#${prefix}paint43_linear_439_715)`}
      />
      <defs>
        <filter
          id={`${prefix}filter0_i_439_715`}
          x="119.89"
          y="88.2549"
          width="107.569"
          height="120.738"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="6.64476" dy="10.4418" />
          <feGaussianBlur stdDeviation="4.74626" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.184314 0 0 0 0 0.254902 0 0 0 0 0.443137 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_439_715"
          />
        </filter>
        <linearGradient
          id={`${prefix}paint0_linear_439_715`}
          x1="192"
          y1="252.5"
          x2="194.208"
          y2="104.033"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDEAFF" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint1_linear_439_715`}
          x1="61.1551"
          y1="10.287"
          x2="-93.0836"
          y2="51.4581"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.153529" stopColor="#98C0FF" />
          <stop offset="0.567708" stopColor="#D5E5FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint2_linear_439_715`}
          x1="29.3054"
          y1="10.3248"
          x2="-17.16"
          y2="0.484887"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CADFFF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint3_linear_439_715`}
          x1="23.8634"
          y1="20.3875"
          x2="0.903595"
          y2="-5.61626"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AECFFF" />
          <stop offset="1" stopColor="#F3F8FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint4_linear_439_715`}
          x1="34.9318"
          y1="20.8224"
          x2="-22.0458"
          y2="13.6906"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CADFFF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint5_linear_439_715`}
          x1="67.9239"
          y1="1.61113"
          x2="-27.3503"
          y2="6.7949"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.252108" stopColor="#98C0FF" />
          <stop offset="0.633257" stopColor="#D5E5FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint6_linear_439_715`}
          x1="271.5"
          y1="198"
          x2="263.261"
          y2="172.548"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#85B7FF" />
          <stop offset="0.9999" stopColor="#CEE2FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint7_linear_439_715`}
          x1="265.035"
          y1="169.929"
          x2="334.97"
          y2="189.174"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ACCCFF" />
          <stop offset="1" stopColor="#418CFF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint8_linear_439_715`}
          x1="309"
          y1="164.5"
          x2="334.449"
          y2="183.008"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D5E5FF" />
          <stop offset="1" stopColor="#86B5FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint9_linear_439_715`}
          x1="285"
          y1="179.5"
          x2="305.356"
          y2="195.376"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D5E5FF" />
          <stop offset="1" stopColor="#8EBAFF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint10_linear_439_715`}
          x1="213"
          y1="98.4999"
          x2="322.049"
          y2="70.7808"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B2D1FE" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint11_linear_439_715`}
          x1="219.937"
          y1="38.0761"
          x2="215.834"
          y2="63.6935"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint12_linear_439_715`}
          x1="206.675"
          y1="62.7773"
          x2="236.601"
          y2="55.2929"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6DDFF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint13_linear_439_715`}
          x1="212.289"
          y1="77.3263"
          x2="126.975"
          y2="95.0768"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CADFFF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint14_linear_439_715`}
          x1="188.5"
          y1="228.5"
          x2="187.612"
          y2="95.9022"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A4C9FF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint15_linear_439_715`}
          x1="163.5"
          y1="123.5"
          x2="204.605"
          y2="-19.8149"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint16_linear_439_715`}
          x1="176.179"
          y1="20.2738"
          x2="179.352"
          y2="16.1812"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint17_linear_439_715`}
          x1="48"
          y1="20.5001"
          x2="265.792"
          y2="52.0295"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.207757" stopColor="#CADFFF" />
          <stop offset="1" stopColor="#5597FD" />
          <stop offset="1" stopColor="#4F89E4" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint18_linear_439_715`}
          x1="178.052"
          y1="57.7576"
          x2="208.806"
          y2="59.8411"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint19_linear_439_715`}
          x1="202.79"
          y1="49.3767"
          x2="195.271"
          y2="59.8219"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint20_linear_439_715`}
          x1="148.774"
          y1="73.5221"
          x2="170.138"
          y2="51.3024"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint21_linear_439_715`}
          x1="158.255"
          y1="49.1848"
          x2="161.423"
          y2="61.659"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint22_linear_439_715`}
          x1="173.717"
          y1="8.02506"
          x2="171.662"
          y2="15.4404"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint23_linear_439_715`}
          x1="178.404"
          y1="-0.241904"
          x2="179.636"
          y2="11.9941"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint24_linear_439_715`}
          x1="219.143"
          y1="196.217"
          x2="168.116"
          y2="150.006"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CADFFF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint25_linear_439_715`}
          x1="179.5"
          y1="217.5"
          x2="182.861"
          y2="172.677"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8DBCFE" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint26_linear_439_715`}
          x1="235"
          y1="222"
          x2="244.932"
          y2="173.123"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#79B0FF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint27_linear_439_715`}
          x1="229.5"
          y1="163"
          x2="172.381"
          y2="180.205"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D5E5FF" />
          <stop offset="1" stopColor="#98C0FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint28_linear_439_715`}
          x1="277.735"
          y1="169.296"
          x2="240.369"
          y2="197.177"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D5E5FF" />
          <stop offset="1" stopColor="#8CB9FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint29_linear_439_715`}
          x1="263"
          y1="182.5"
          x2="178.46"
          y2="160.533"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CADFFF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint30_linear_439_715`}
          x1="341.5"
          y1="152.5"
          x2="231.606"
          y2="125.15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CADFFF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint31_linear_439_715`}
          x1="121.775"
          y1="37.3383"
          x2="117.672"
          y2="62.9557"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint32_linear_439_715`}
          x1="93.6591"
          y1="39.4139"
          x2="142.091"
          y2="49.5587"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#98C0FF" />
          <stop offset="0.567708" stopColor="#D5E5FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint33_linear_439_715`}
          x1="184.624"
          y1="155.324"
          x2="176.619"
          y2="82.719"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CADFFF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint34_linear_439_715`}
          x1="178.576"
          y1="106.929"
          x2="80.8978"
          y2="125.618"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#98C0FF" />
          <stop offset="0.567708" stopColor="#D5E5FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint35_linear_439_715`}
          x1="125.714"
          y1="152.058"
          x2="73.1086"
          y2="142.047"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CADFFF" />
          <stop offset="0.552866" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint36_linear_439_715`}
          x1="117.441"
          y1="168.371"
          x2="68.0688"
          y2="143.676"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6DDFF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint37_linear_439_715`}
          x1="130.17"
          y1="165.779"
          x2="94.0421"
          y2="152.168"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CADFFF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint38_linear_439_715`}
          x1="161.035"
          y1="146.019"
          x2="53.4691"
          y2="172.811"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#98C0FF" />
          <stop offset="0.639586" stopColor="#D5E5FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint39_linear_439_715`}
          x1="80.1841"
          y1="234.563"
          x2="78.4635"
          y2="176.641"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DA9FF" />
          <stop offset="0.9999" stopColor="#BBD7FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint40_linear_439_715`}
          x1="76.7906"
          y1="169.929"
          x2="6.85558"
          y2="189.174"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CADFFF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint41_linear_439_715`}
          x1="35"
          y1="173.5"
          x2="12.711"
          y2="185.666"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D5E5FF" />
          <stop offset="1" stopColor="#8CB9FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint42_linear_439_715`}
          x1="62.5"
          y1="169.5"
          x2="25.3717"
          y2="189.267"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D5E5FF" />
          <stop offset="1" stopColor="#98C0FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint43_linear_439_715`}
          x1="374.699"
          y1="52.2475"
          x2="79.7879"
          y2="-45.2817"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B2D1FE" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const FileSearchEmptyState = (props: any) => {
  return (
    <Icon
      {...props}
      $size={229}
      width="229"
      height="199"
      viewBox="0 0 229 199"
      fill="none"
    >
      <path
        d="M113.502 197.644C171.837 197.644 219.126 185.948 219.126 171.521C219.126 157.095 171.837 145.399 113.502 145.399C55.1674 145.399 7.87793 157.095 7.87793 171.521C7.87793 185.948 55.1674 197.644 113.502 197.644Z"
        fill="url(#paint0_linear_439_1087)"
      />
      <path
        d="M154.807 39.359L156.368 146.659C156.391 148.129 156.127 149.59 155.592 150.956C155.057 152.323 154.261 153.57 153.249 154.624C152.237 155.679 151.03 156.52 149.696 157.101C148.363 157.682 146.929 157.991 145.477 158.01L48.9506 159.478C46.0147 159.52 43.182 158.381 41.0744 156.311C38.9668 154.241 37.7565 151.408 37.7093 148.434L35.9074 24.4074C35.8673 21.4402 36.9917 18.5783 39.0336 16.4501C41.0755 14.3219 43.868 13.1014 46.7977 13.0568L127.014 11.8584L154.807 39.359Z"
        fill="url(#paint1_linear_439_1087)"
      />
      <g filter="url(#filter0_f_439_1087)">
        <path
          d="M169.002 58.6177L150.77 157.655C150.522 159.012 150.018 160.302 149.287 161.451C148.557 162.6 147.614 163.585 146.513 164.35C145.412 165.115 144.174 165.645 142.87 165.909C141.567 166.173 140.223 166.166 138.916 165.888L51.9923 147.655C49.3488 147.098 47.0142 145.476 45.5009 143.143C43.9877 140.811 43.4195 137.959 43.9212 135.214L64.9971 20.7382C65.504 18.0001 67.0371 15.5951 69.2596 14.0514C71.4821 12.5076 74.2123 11.9513 76.8506 12.5047L149.083 27.6771L169.002 58.6177Z"
          fill="url(#paint2_linear_439_1087)"
        />
      </g>
      <path
        d="M181.895 48.9526L161.434 154.245C161.156 155.688 160.599 157.061 159.795 158.285C158.991 159.51 157.957 160.562 156.751 161.381C155.546 162.2 154.192 162.769 152.768 163.057C151.345 163.345 149.879 163.346 148.455 163.059L53.7291 144.207C50.8483 143.632 48.3107 141.923 46.6732 139.454C45.0358 136.986 44.4324 133.96 44.9954 131.042L68.6478 9.33628C69.2166 6.42528 70.903 3.86195 73.3365 2.20924C75.7701 0.556535 78.7518 -0.0504231 81.6269 0.521697L160.343 16.2092L181.895 48.9526Z"
        fill="url(#paint3_linear_439_1087)"
      />
      <path
        d="M181.894 48.9522L155.012 43.6019L160.316 16.2137L181.894 48.9522Z"
        fill="url(#paint4_linear_439_1087)"
      />
      <path
        d="M160.386 144.752L164.545 149.22L164.155 149.761C163.375 150.709 163.375 152.198 164.155 153.146L186.246 179.412C187.156 180.495 188.196 181.443 189.495 182.12C190.795 182.797 192.094 183.203 193.524 182.797C195.083 182.39 196.513 181.307 196.642 179.006C196.772 177.381 196.253 175.892 195.213 174.673L172.991 146.918C171.952 145.699 170.392 145.429 169.353 146.241L164.935 140.69C164.935 140.419 161.556 141.638 160.386 144.752Z"
        fill="url(#paint5_linear_439_1087)"
      />
      <foreignObject x="105.622" y="80.7627" width="71.0554" height="73.0244">
        <div
          style={{
            backdropFilter: "blur(1px)",
            clipPath: "url(#bgblur_0_439_1087_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <g filter="url(#filter1_i_439_1087)" data-figma-bg-blur-radius="2">
        <path
          d="M141.149 151.787C159.666 151.787 174.677 136.336 174.677 117.275C174.677 98.2144 159.666 82.7627 141.149 82.7627C122.633 82.7627 107.622 98.2144 107.622 117.275C107.622 136.336 122.633 151.787 141.149 151.787Z"
          fill="url(#paint6_radial_439_1087)"
          fillOpacity="0.33"
        />
      </g>
      <rect
        width="60.2312"
        height="55.8635"
        rx="25.117"
        transform="matrix(0.953634 0.30097 -0.294091 0.955777 123.942 78.708)"
        fill="url(#paint7_linear_439_1087)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M141.15 87.6697C124.768 87.6697 111.487 100.924 111.487 117.275C111.487 133.626 124.768 146.88 141.15 146.88C157.531 146.88 170.812 133.626 170.812 117.275C170.812 100.924 157.531 87.6697 141.15 87.6697ZM103.225 117.275C103.225 96.3698 120.204 79.4229 141.15 79.4229C162.095 79.4229 179.074 96.3698 179.074 117.275C179.074 138.18 162.095 155.127 141.15 155.127C120.204 155.127 103.225 138.18 103.225 117.275Z"
        fill="url(#paint8_linear_439_1087)"
      />
      <defs>
        <filter
          id="filter0_f_439_1087"
          x="33.7432"
          y="2.2959"
          width="145.259"
          height="173.806"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="5"
            result="effect1_foregroundBlur_439_1087"
          />
        </filter>
        <filter
          id="filter1_i_439_1087"
          x="105.622"
          y="80.7627"
          width="71.0554"
          height="73.0244"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.85204" />
          <feGaussianBlur stdDeviation="11.5753" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.560784 0 0 0 0 0.607843 0 0 0 0 1 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_439_1087"
          />
        </filter>
        <clipPath
          id="bgblur_0_439_1087_clip_path"
          transform="translate(-105.622 -80.7627)"
        >
          <path d="M141.149 151.787C159.666 151.787 174.677 136.336 174.677 117.275C174.677 98.2144 159.666 82.7627 141.149 82.7627C122.633 82.7627 107.622 98.2144 107.622 117.275C107.622 136.336 122.633 151.787 141.149 151.787Z" />
        </clipPath>
        <linearGradient
          id="paint0_linear_439_1087"
          x1="123.156"
          y1="218.087"
          x2="132.81"
          y2="89.748"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDEAFF" />
          <stop offset="1" stopColor="#F0F6FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_439_1087"
          x1="3.7411"
          y1="265.345"
          x2="193.409"
          y2="69.873"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_439_1087"
          x1="130.516"
          y1="-48.2234"
          x2="50.1614"
          y2="160.328"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.760417" stopColor="#B3D2FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_439_1087"
          x1="20.7801"
          y1="177.394"
          x2="310.753"
          y2="-20.5793"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#C6DDFF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_439_1087"
          x1="162.6"
          y1="15.7643"
          x2="169.605"
          y2="51.3697"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDF4FF" />
          <stop offset="1" stopColor="#ABCCFF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_439_1087"
          x1="196.662"
          y1="154.013"
          x2="178.194"
          y2="182.747"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <radialGradient
          id="paint6_radial_439_1087"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(141.149 117.275) rotate(90) scale(34.5123 33.5277)"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#EEF5FF" />
        </radialGradient>
        <linearGradient
          id="paint7_linear_439_1087"
          x1="30.1156"
          y1="0"
          x2="30.1156"
          y2="55.8635"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_439_1087"
          x1="165.883"
          y1="57.1569"
          x2="154.773"
          y2="156.649"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#7FB0FB" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const FiltersEmptyState = (props: any) => {
  return (
    <Icon
      {...props}
      $size={212}
      width="212"
      height="159"
      viewBox="0 0 212 159"
      fill="none"
    >
      <path
        d="M105.624 158.091C163.959 158.091 211.248 146.396 211.248 131.969C211.248 117.542 163.959 105.847 105.624 105.847C47.2895 105.847 0 117.542 0 131.969C0 146.396 47.2895 158.091 105.624 158.091Z"
        fill="url(#paint0_linear_465_356)"
      />
      <path
        d="M118.5 71.2415C118.811 63.6459 123.732 56.9859 128.658 51.1958C130.359 49.1961 131.891 46.99 133.206 44.71L152.955 11.7246L59.4781 11.7246L79.2272 44.71C80.5845 47.0626 82.1724 49.3342 83.9388 51.382C88.857 57.0836 93.7853 63.6216 94.1954 71.1401L95.9665 103.612C96.0533 105.203 97.3687 106.448 98.9621 106.448H103.142C103.956 106.448 104.735 106.118 105.3 105.532L116.827 93.5937C117.338 93.0649 117.636 92.367 117.666 91.6326L118.5 71.2415Z"
        fill="url(#paint1_linear_465_356)"
      />
      <path
        d="M118.5 71.2415C118.811 63.6459 123.732 56.9859 128.658 51.1958C130.359 49.1961 131.891 46.99 133.206 44.71L152.955 11.7246L59.4781 11.7246L79.2272 44.71C80.5845 47.0626 82.1724 49.3342 83.9388 51.382C88.857 57.0836 93.7853 63.6216 94.1954 71.1401L95.9665 103.612C96.0533 105.203 97.3687 106.448 98.9621 106.448H103.142C103.956 106.448 104.735 106.118 105.3 105.532L116.827 93.5937C117.338 93.0649 117.636 92.367 117.666 91.6326L118.5 71.2415Z"
        fill="url(#paint2_linear_465_356)"
      />
      <path
        d="M118.5 71.2415C118.811 63.6459 123.732 56.9859 128.658 51.1958C130.359 49.1961 131.891 46.99 133.206 44.71L152.955 11.7246L59.4781 11.7246L79.2272 44.71C80.5845 47.0626 82.1724 49.3342 83.9388 51.382C88.857 57.0836 93.7853 63.6216 94.1954 71.1401L95.9665 103.612C96.0533 105.203 97.3687 106.448 98.9621 106.448H103.142C103.956 106.448 104.735 106.118 105.3 105.532L116.827 93.5937C117.338 93.0649 117.636 92.367 117.666 91.6326L118.5 71.2415Z"
        fill="url(#paint3_linear_465_356)"
      />
      <g filter="url(#filter0_f_465_356)">
        <rect
          x="61.9709"
          y="4.24634"
          width="88.4919"
          height="14.9564"
          rx="7.47819"
          fill="url(#paint4_linear_465_356)"
          fillOpacity="0.3"
        />
      </g>
      <rect
        x="52"
        y="3"
        width="108.434"
        height="14.9564"
        rx="7.47819"
        fill="url(#paint5_linear_465_356)"
      />
      <path
        d="M62.4057 94.5643C55.1625 97.3519 47.4849 98.8417 39.7248 98.9654C40.5968 101.461 47.1499 114.109 68.4306 125.646C69.0185 125.78 83.1945 120.358 91.0356 116.508C90.7539 116.856 68.2083 106.714 62.4057 94.5643Z"
        fill="url(#paint6_linear_465_356)"
      />
      <path
        d="M61.9684 105.506C61.6777 105.192 61.2379 105.063 60.8237 105.171L52.1289 107.433C51.7455 107.532 51.5808 107.985 51.8105 108.308C51.9982 108.572 52.3296 108.692 52.6425 108.609L61.7662 106.201C62.0742 106.12 62.1847 105.74 61.9684 105.506Z"
        fill="#D7E7FF"
      />
      <path
        d="M66.3573 108.247C66.0509 107.965 65.6191 107.862 65.2181 107.977L55.1843 110.845C54.7905 110.958 54.6407 111.437 54.9002 111.753C55.0987 111.996 55.4227 112.097 55.7237 112.01L66.1833 108.984C66.5084 108.89 66.606 108.477 66.3573 108.247Z"
        fill="#D7E7FF"
      />
      <path
        d="M73.0489 110.33C72.7325 110.099 72.3271 110.027 71.9508 110.136L58.7362 113.941C58.3139 114.062 58.1764 114.592 58.4863 114.904C58.6913 115.11 58.9925 115.188 59.2716 115.107L72.9058 111.145C73.2735 111.038 73.3582 110.555 73.0489 110.33Z"
        fill="#D7E7FF"
      />
      <path
        d="M127.857 107.92C136.749 111.342 146.174 113.171 155.7 113.323C154.63 116.387 146.585 131.914 120.461 146.077C119.739 146.24 102.337 139.585 92.7109 134.859C93.0567 135.286 120.734 122.835 127.857 107.92Z"
        fill="url(#paint7_linear_465_356)"
      />
      <path
        d="M128.393 121.352C128.75 120.967 129.29 120.809 129.798 120.941L140.472 123.718C140.943 123.84 141.145 124.396 140.863 124.792C140.633 125.116 140.226 125.263 139.842 125.162L128.641 122.206C128.263 122.106 128.128 121.639 128.393 121.352Z"
        fill="#E2EEFF"
      />
      <path
        d="M123.006 124.718C123.382 124.37 123.912 124.244 124.405 124.385L136.722 127.906C137.206 128.045 137.389 128.633 137.071 129.022C136.827 129.319 136.43 129.443 136.06 129.336L123.22 125.622C122.821 125.507 122.701 124.999 123.006 124.718Z"
        fill="#E2EEFF"
      />
      <path
        d="M114.792 127.274C115.18 126.99 115.678 126.902 116.14 127.036L132.362 131.707C132.88 131.856 133.049 132.507 132.669 132.889C132.417 133.142 132.047 133.238 131.705 133.138L114.967 128.274C114.516 128.143 114.412 127.551 114.792 127.274Z"
        fill="#E2EEFF"
      />
      <defs>
        <filter
          id="filter0_f_465_356"
          x="57.9709"
          y="0.246338"
          width="96.4919"
          height="22.9563"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2"
            result="effect1_foregroundBlur_465_356"
          />
        </filter>
        <linearGradient
          id="paint0_linear_465_356"
          x1="115.278"
          y1="178.534"
          x2="124.932"
          y2="50.1953"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDEAFF" />
          <stop offset="1" stopColor="#F0F6FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_465_356"
          x1="91.2604"
          y1="-104.187"
          x2="129.46"
          y2="104.331"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D7E7FF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_465_356"
          x1="381.04"
          y1="127.013"
          x2="105.202"
          y2="116.332"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0069FF" />
          <stop offset="1" stopColor="#0069FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_465_356"
          x1="-143.056"
          y1="106.448"
          x2="90.9627"
          y2="23.209"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0069FF" />
          <stop offset="1" stopColor="#0069FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_465_356"
          x1="194.819"
          y1="22.8081"
          x2="177.495"
          y2="-38.4457"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0069FF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_465_356"
          x1="308.751"
          y1="60.9559"
          x2="291.07"
          y2="-42.6049"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_465_356"
          x1="30.6889"
          y1="95.1935"
          x2="105.269"
          y2="155.881"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5597FD" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_465_356"
          x1="165.58"
          y1="123.548"
          x2="31.7744"
          y2="126.473"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5597FD" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const OpenInNewIcon = forwardRef((props, ref: any) => {
  return (
    <svg
      {...props}
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <path
        d="M16 16H2V2H9V0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V16C0 16.5304 0.210714 17.0391 0.585786 17.4142C0.960859 17.7893 1.46957 18 2 18H16C17.1 18 18 17.1 18 16V9H16V16ZM11 0V2H14.59L4.76 11.83L6.17 13.24L16 3.41V7H18V0H11Z"
        fill="inherit"
      />
    </svg>
  );
});

export const AppQrCode = (props: any) => (
  <svg {...props} width="214" height="228" viewBox="0 0 214 228" fill="none">
    <g id="qrCode">
      <path
        d="M17 17H23.1724V23.1724H17V17ZM23.1724 17H29.3448V23.1724H23.1724V17ZM29.3448 17H35.5172V23.1724H29.3448V17ZM35.5172 17H41.6897V23.1724H35.5172V17ZM41.6897 17H47.8621V23.1724H41.6897V17ZM47.8621 17H54.0345V23.1724H47.8621V17ZM54.0345 17H60.2069V23.1724H54.0345V17ZM72.5517 17H78.7241V23.1724H72.5517V17ZM115.759 17H121.931V23.1724H115.759V17ZM128.103 17H134.276V23.1724H128.103V17ZM134.276 17H140.448V23.1724H134.276V17ZM140.448 17H146.621V23.1724H140.448V17ZM152.793 17H158.966V23.1724H152.793V17ZM158.966 17H165.138V23.1724H158.966V17ZM165.138 17H171.31V23.1724H165.138V17ZM171.31 17H177.483V23.1724H171.31V17ZM177.483 17H183.655V23.1724H177.483V17ZM183.655 17H189.828V23.1724H183.655V17ZM189.828 17H196V23.1724H189.828V17ZM17 23.1724H23.1724V29.3448H17V23.1724ZM54.0345 23.1724H60.2069V29.3448H54.0345V23.1724ZM66.3793 23.1724H72.5517V29.3448H66.3793V23.1724ZM72.5517 23.1724H78.7241V29.3448H72.5517V23.1724ZM84.8966 23.1724H91.069V29.3448H84.8966V23.1724ZM91.069 23.1724H97.2414V29.3448H91.069V23.1724ZM109.586 23.1724H115.759V29.3448H109.586V23.1724ZM121.931 23.1724H128.103V29.3448H121.931V23.1724ZM128.103 23.1724H134.276V29.3448H128.103V23.1724ZM140.448 23.1724H146.621V29.3448H140.448V23.1724ZM152.793 23.1724H158.966V29.3448H152.793V23.1724ZM189.828 23.1724H196V29.3448H189.828V23.1724ZM17 29.3448H23.1724V35.5172H17V29.3448ZM29.3448 29.3448H35.5172V35.5172H29.3448V29.3448ZM35.5172 29.3448H41.6897V35.5172H35.5172V29.3448ZM41.6897 29.3448H47.8621V35.5172H41.6897V29.3448ZM54.0345 29.3448H60.2069V35.5172H54.0345V29.3448ZM72.5517 29.3448H78.7241V35.5172H72.5517V29.3448ZM78.7241 29.3448H84.8966V35.5172H78.7241V29.3448ZM84.8966 29.3448H91.069V35.5172H84.8966V29.3448ZM103.414 29.3448H109.586V35.5172H103.414V29.3448ZM134.276 29.3448H140.448V35.5172H134.276V29.3448ZM140.448 29.3448H146.621V35.5172H140.448V29.3448ZM152.793 29.3448H158.966V35.5172H152.793V29.3448ZM165.138 29.3448H171.31V35.5172H165.138V29.3448ZM171.31 29.3448H177.483V35.5172H171.31V29.3448ZM177.483 29.3448H183.655V35.5172H177.483V29.3448ZM189.828 29.3448H196V35.5172H189.828V29.3448ZM17 35.5172H23.1724V41.6897H17V35.5172ZM29.3448 35.5172H35.5172V41.6897H29.3448V35.5172ZM35.5172 35.5172H41.6897V41.6897H35.5172V35.5172ZM41.6897 35.5172H47.8621V41.6897H41.6897V35.5172ZM54.0345 35.5172H60.2069V41.6897H54.0345V35.5172ZM66.3793 35.5172H72.5517V41.6897H66.3793V35.5172ZM72.5517 35.5172H78.7241V41.6897H72.5517V35.5172ZM84.8966 35.5172H91.069V41.6897H84.8966V35.5172ZM97.2414 35.5172H103.414V41.6897H97.2414V35.5172ZM103.414 35.5172H109.586V41.6897H103.414V35.5172ZM109.586 35.5172H115.759V41.6897H109.586V35.5172ZM115.759 35.5172H121.931V41.6897H115.759V35.5172ZM121.931 35.5172H128.103V41.6897H121.931V35.5172ZM134.276 35.5172H140.448V41.6897H134.276V35.5172ZM152.793 35.5172H158.966V41.6897H152.793V35.5172ZM165.138 35.5172H171.31V41.6897H165.138V35.5172ZM171.31 35.5172H177.483V41.6897H171.31V35.5172ZM177.483 35.5172H183.655V41.6897H177.483V35.5172ZM189.828 35.5172H196V41.6897H189.828V35.5172ZM17 41.6897H23.1724V47.8621H17V41.6897ZM29.3448 41.6897H35.5172V47.8621H29.3448V41.6897ZM35.5172 41.6897H41.6897V47.8621H35.5172V41.6897ZM41.6897 41.6897H47.8621V47.8621H41.6897V41.6897ZM54.0345 41.6897H60.2069V47.8621H54.0345V41.6897ZM78.7241 41.6897H84.8966V47.8621H78.7241V41.6897ZM91.069 41.6897H97.2414V47.8621H91.069V41.6897ZM103.414 41.6897H109.586V47.8621H103.414V41.6897ZM115.759 41.6897H121.931V47.8621H115.759V41.6897ZM121.931 41.6897H128.103V47.8621H121.931V41.6897ZM128.103 41.6897H134.276V47.8621H128.103V41.6897ZM134.276 41.6897H140.448V47.8621H134.276V41.6897ZM152.793 41.6897H158.966V47.8621H152.793V41.6897ZM165.138 41.6897H171.31V47.8621H165.138V41.6897ZM171.31 41.6897H177.483V47.8621H171.31V41.6897ZM177.483 41.6897H183.655V47.8621H177.483V41.6897ZM189.828 41.6897H196V47.8621H189.828V41.6897ZM17 47.8621H23.1724V54.0345H17V47.8621ZM54.0345 47.8621H60.2069V54.0345H54.0345V47.8621ZM66.3793 47.8621H72.5517V54.0345H66.3793V47.8621ZM78.7241 47.8621H84.8966V54.0345H78.7241V47.8621ZM103.414 47.8621H109.586V54.0345H103.414V47.8621ZM109.586 47.8621H115.759V54.0345H109.586V47.8621ZM121.931 47.8621H128.103V54.0345H121.931V47.8621ZM140.448 47.8621H146.621V54.0345H140.448V47.8621ZM152.793 47.8621H158.966V54.0345H152.793V47.8621ZM189.828 47.8621H196V54.0345H189.828V47.8621ZM17 54.0345H23.1724V60.2069H17V54.0345ZM23.1724 54.0345H29.3448V60.2069H23.1724V54.0345ZM29.3448 54.0345H35.5172V60.2069H29.3448V54.0345ZM35.5172 54.0345H41.6897V60.2069H35.5172V54.0345ZM41.6897 54.0345H47.8621V60.2069H41.6897V54.0345ZM47.8621 54.0345H54.0345V60.2069H47.8621V54.0345ZM54.0345 54.0345H60.2069V60.2069H54.0345V54.0345ZM66.3793 54.0345H72.5517V60.2069H66.3793V54.0345ZM78.7241 54.0345H84.8966V60.2069H78.7241V54.0345ZM91.069 54.0345H97.2414V60.2069H91.069V54.0345ZM103.414 54.0345H109.586V60.2069H103.414V54.0345ZM115.759 54.0345H121.931V60.2069H115.759V54.0345ZM128.103 54.0345H134.276V60.2069H128.103V54.0345ZM140.448 54.0345H146.621V60.2069H140.448V54.0345ZM152.793 54.0345H158.966V60.2069H152.793V54.0345ZM158.966 54.0345H165.138V60.2069H158.966V54.0345ZM165.138 54.0345H171.31V60.2069H165.138V54.0345ZM171.31 54.0345H177.483V60.2069H171.31V54.0345ZM177.483 54.0345H183.655V60.2069H177.483V54.0345ZM183.655 54.0345H189.828V60.2069H183.655V54.0345ZM189.828 54.0345H196V60.2069H189.828V54.0345ZM91.069 60.2069H97.2414V66.3793H91.069V60.2069ZM109.586 60.2069H115.759V66.3793H109.586V60.2069ZM115.759 60.2069H121.931V66.3793H115.759V60.2069ZM134.276 60.2069H140.448V66.3793H134.276V60.2069ZM140.448 60.2069H146.621V66.3793H140.448V60.2069ZM17 66.3793H23.1724V72.5517H17V66.3793ZM23.1724 66.3793H29.3448V72.5517H23.1724V66.3793ZM29.3448 66.3793H35.5172V72.5517H29.3448V66.3793ZM35.5172 66.3793H41.6897V72.5517H35.5172V66.3793ZM41.6897 66.3793H47.8621V72.5517H41.6897V66.3793ZM54.0345 66.3793H60.2069V72.5517H54.0345V66.3793ZM60.2069 66.3793H66.3793V72.5517H60.2069V66.3793ZM66.3793 66.3793H72.5517V72.5517H66.3793V66.3793ZM72.5517 66.3793H78.7241V72.5517H72.5517V66.3793ZM78.7241 66.3793H84.8966V72.5517H78.7241V66.3793ZM91.069 66.3793H97.2414V72.5517H91.069V66.3793ZM97.2414 66.3793H103.414V72.5517H97.2414V66.3793ZM103.414 66.3793H109.586V72.5517H103.414V66.3793ZM109.586 66.3793H115.759V72.5517H109.586V66.3793ZM115.759 66.3793H121.931V72.5517H115.759V66.3793ZM121.931 66.3793H128.103V72.5517H121.931V66.3793ZM134.276 66.3793H140.448V72.5517H134.276V66.3793ZM146.621 66.3793H152.793V72.5517H146.621V66.3793ZM158.966 66.3793H165.138V72.5517H158.966V66.3793ZM171.31 66.3793H177.483V72.5517H171.31V66.3793ZM183.655 66.3793H189.828V72.5517H183.655V66.3793ZM17 72.5517H23.1724V78.7241H17V72.5517ZM29.3448 72.5517H35.5172V78.7241H29.3448V72.5517ZM41.6897 72.5517H47.8621V78.7241H41.6897V72.5517ZM72.5517 72.5517H78.7241V78.7241H72.5517V72.5517ZM97.2414 72.5517H103.414V78.7241H97.2414V72.5517ZM115.759 72.5517H121.931V78.7241H115.759V72.5517ZM134.276 72.5517H140.448V78.7241H134.276V72.5517ZM140.448 72.5517H146.621V78.7241H140.448V72.5517ZM146.621 72.5517H152.793V78.7241H146.621V72.5517ZM152.793 72.5517H158.966V78.7241H152.793V72.5517ZM158.966 72.5517H165.138V78.7241H158.966V72.5517ZM165.138 72.5517H171.31V78.7241H165.138V72.5517ZM189.828 72.5517H196V78.7241H189.828V72.5517ZM17 78.7241H23.1724V84.8966H17V78.7241ZM47.8621 78.7241H54.0345V84.8966H47.8621V78.7241ZM54.0345 78.7241H60.2069V84.8966H54.0345V78.7241ZM66.3793 78.7241H72.5517V84.8966H66.3793V78.7241ZM72.5517 78.7241H78.7241V84.8966H72.5517V78.7241ZM84.8966 78.7241H91.069V84.8966H84.8966V78.7241ZM91.069 78.7241H97.2414V84.8966H91.069V78.7241ZM109.586 78.7241H115.759V84.8966H109.586V78.7241ZM115.759 78.7241H121.931V84.8966H115.759V78.7241ZM121.931 78.7241H128.103V84.8966H121.931V78.7241ZM128.103 78.7241H134.276V84.8966H128.103V78.7241ZM140.448 78.7241H146.621V84.8966H140.448V78.7241ZM146.621 78.7241H152.793V84.8966H146.621V78.7241ZM29.3448 84.8966H35.5172V91.069H29.3448V84.8966ZM41.6897 84.8966H47.8621V91.069H41.6897V84.8966ZM47.8621 84.8966H54.0345V91.069H47.8621V84.8966ZM60.2069 84.8966H66.3793V91.069H60.2069V84.8966ZM66.3793 84.8966H72.5517V91.069H66.3793V84.8966ZM72.5517 84.8966H78.7241V91.069H72.5517V84.8966ZM78.7241 84.8966H84.8966L83.7776 91.069H78.7241V84.8966ZM84.8966 84.8966H91.069H89.95V91.069H83.7776L84.8966 84.8966ZM103.414 84.8966H109.586V88.831H103.414V84.8966ZM128.103 84.8966H134.276V91.069V88.831H128.103V84.8966ZM152.793 84.8966H158.966V91.069H152.793V84.8966ZM158.966 84.8966H165.138V91.069H158.966V84.8966ZM171.31 84.8966H177.483V91.069H171.31V84.8966ZM183.655 84.8966H189.828V91.069H183.655V84.8966ZM17 91.069H23.1724V97.2414H17V91.069ZM29.3448 91.069H35.5172V97.2414H29.3448V91.069ZM54.0345 91.069H60.2069V97.2414H54.0345V91.069ZM72.5517 91.069H78.7241V97.2414H72.5517V91.069ZM83.7776 91.069H89.95V97.2414H83.7776V91.069ZM97.2414 88.831H103.414L97.2414 90.8343V88.831ZM103.414 88.831H109.586V90.8343H103.414H97.2414L103.414 88.831ZM109.586 88.831H115.759V90.8343H109.586V88.831ZM115.759 88.831H121.931L123.285 90.8343H115.759V88.831ZM121.931 88.831H128.103V97.2414H123.285V90.8343L121.931 88.831ZM134.276 91.069H140.448V97.2414H134.276V91.069ZM171.31 91.069H177.483V97.2414H171.31V91.069ZM177.483 91.069H183.655V97.2414H177.483V91.069ZM17 97.2414H23.1724V103.414H17V97.2414ZM35.5172 97.2414H41.6897V103.414H35.5172V97.2414ZM41.6897 97.2414H47.8621V103.414H41.6897V97.2414ZM47.8621 97.2414H54.0345V103.414H47.8621V97.2414ZM66.3793 97.2414H72.5517V103.414H66.3793V97.2414ZM72.5517 97.2414H78.7241V103.414H72.5517V97.2414ZM78.7241 97.2414H83.7776V103.414H78.7241V97.2414ZM89.95 97.2414H93.0723V103.414H89.95V97.2414ZM123.285 97.2414H128.103V103.414H123.285V97.2414ZM128.103 97.2414H134.276V103.414H128.103V97.2414ZM134.276 97.2414H140.448V103.414H134.276V97.2414ZM140.448 97.2414H146.621V103.414H140.448V97.2414ZM146.621 97.2414H152.793V103.414H146.621V97.2414ZM152.793 97.2414H158.966V103.414H152.793V97.2414ZM165.138 97.2414H171.31V103.414H165.138V97.2414ZM189.828 97.2414H196V103.414H189.828V97.2414ZM17 103.414H23.1724V109.586H17V103.414ZM29.3448 103.414H35.5172V109.586H29.3448V103.414ZM35.5172 103.414H41.6897V109.586H35.5172V103.414ZM54.0345 103.414H60.2069V109.586H54.0345V103.414ZM60.2069 103.414H66.3793V109.586H60.2069V103.414ZM66.3793 103.414H72.5517V109.586H66.3793V103.414ZM123.285 103.414H128.103V109.586H123.285V103.414ZM152.793 103.414H158.966V109.586H152.793V103.414ZM165.138 103.414H171.31V109.586H165.138V103.414ZM171.31 103.414H177.483V109.586H171.31V103.414ZM177.483 103.414H183.655V109.586H177.483V103.414ZM41.6897 109.586H47.8621V115.759H41.6897V109.586ZM47.8621 109.586H54.0345V115.759H47.8621V109.586ZM66.3793 109.586H72.5517V115.759H66.3793V109.586ZM72.5517 109.586H78.7241V115.759H72.5517V109.586ZM128.103 109.586H134.276V115.759H128.103V109.586ZM134.276 109.586H140.448V115.759H134.276V109.586ZM140.448 109.586H146.621V115.759H140.448V109.586ZM152.793 109.586H158.966V115.759H152.793V109.586ZM165.138 109.586H171.31V115.759H165.138V109.586ZM183.655 109.586H189.828V115.759H183.655V109.586ZM23.1724 115.759H29.3448V121.931H23.1724V115.759ZM29.3448 115.759H35.5172V121.931H29.3448V115.759ZM35.5172 115.759H41.6897V121.931H35.5172V115.759ZM41.6897 115.759H47.8621V121.931H41.6897V115.759ZM47.8621 115.759H54.0345V121.931H47.8621V115.759ZM54.0345 115.759H60.2069V121.931H54.0345V115.759ZM60.2069 115.759H66.3793V121.931H60.2069V115.759ZM72.5517 115.759H78.7241V121.931H72.5517V115.759ZM78.7241 115.759H84.8966V121.931H78.7241V115.759ZM91.069 120.722H97.2414V123.285H91.069V120.722ZM97.2414 120.722H103.414V123.285H97.2414V120.722ZM103.414 120.722H109.586V123.285H103.414V120.722ZM121.931 119.368H128.103V115.759V121.931H121.931V119.368ZM134.276 115.759H140.448V121.931H134.276V115.759ZM158.966 115.759H165.138V121.931H158.966V115.759ZM171.31 115.759H177.483V121.931H171.31V115.759ZM177.483 115.759H183.655V121.931H177.483V115.759ZM17 121.931H23.1724V128.103H17V121.931ZM29.3448 121.931H35.5172V128.103H29.3448V121.931ZM41.6897 121.931H47.8621V128.103H41.6897V121.931ZM60.2069 121.931H66.3793V128.103H60.2069V121.931ZM97.2414 123.285H103.414V128.103H97.2414V123.285ZM115.759 121.931H121.931V128.103H115.759V121.931ZM121.931 121.931H128.103V128.103H121.931V121.931ZM128.103 121.931H134.276V128.103H128.103V121.931ZM134.276 121.931H140.448V128.103H134.276V121.931ZM152.793 121.931H158.966V128.103H152.793V121.931ZM158.966 121.931H165.138V128.103H158.966V121.931ZM165.138 121.931H171.31V128.103H165.138V121.931ZM177.483 121.931H183.655V128.103H177.483V121.931ZM189.828 121.931H196V128.103H189.828V121.931ZM17 128.103H23.1724V134.276H17V128.103ZM47.8621 128.103H54.0345V134.276H47.8621V128.103ZM54.0345 128.103H60.2069V134.276H54.0345V128.103ZM60.2069 128.103H66.3793V134.276H60.2069V128.103ZM72.5517 128.103H78.7241V134.276H72.5517V128.103ZM78.7241 128.103H84.8966V134.276H78.7241V128.103ZM84.8966 128.103H91.069V134.276H84.8966V128.103ZM91.069 128.103H97.2414V134.276H91.069V128.103ZM97.2414 128.103H103.414V134.276H97.2414V128.103ZM103.414 128.103H109.586V134.276H103.414V128.103ZM109.586 128.103H115.759V134.276H109.586V128.103ZM115.759 128.103H121.931V134.276H115.759V128.103ZM128.103 128.103H134.276V134.276H128.103V128.103ZM146.621 128.103H152.793V134.276H146.621V128.103ZM165.138 128.103H171.31V134.276H165.138V128.103ZM177.483 128.103H183.655V134.276H177.483V128.103ZM17 134.276H23.1724V140.448H17V134.276ZM29.3448 134.276H35.5172V140.448H29.3448V134.276ZM35.5172 134.276H41.6897V140.448H35.5172V134.276ZM84.8966 134.276H91.069V140.448H84.8966V134.276ZM115.759 134.276H121.931V140.448H115.759V134.276ZM146.621 134.276H152.793V140.448H146.621V134.276ZM152.793 134.276H158.966V140.448H152.793V134.276ZM165.138 134.276H171.31V140.448H165.138V134.276ZM183.655 134.276H189.828V140.448H183.655V134.276ZM17 140.448H23.1724V146.621H17V140.448ZM29.3448 140.448H35.5172V146.621H29.3448V140.448ZM35.5172 140.448H41.6897V146.621H35.5172V140.448ZM54.0345 140.448H60.2069V146.621H54.0345V140.448ZM66.3793 140.448H72.5517V146.621H66.3793V140.448ZM78.7241 140.448H84.8966V146.621H78.7241V140.448ZM84.8966 140.448H91.069V146.621H84.8966V140.448ZM109.586 140.448H115.759V146.621H109.586V140.448ZM121.931 140.448H128.103V146.621H121.931V140.448ZM134.276 140.448H140.448V146.621H134.276V140.448ZM140.448 140.448H146.621V146.621H140.448V140.448ZM146.621 140.448H152.793V146.621H146.621V140.448ZM152.793 140.448H158.966V146.621H152.793V140.448ZM158.966 140.448H165.138V146.621H158.966V140.448ZM165.138 140.448H171.31V146.621H165.138V140.448ZM177.483 140.448H183.655V146.621H177.483V140.448ZM183.655 140.448H189.828V146.621H183.655V140.448ZM189.828 140.448H196V146.621H189.828V140.448ZM66.3793 146.621H72.5517V152.793H66.3793V146.621ZM72.5517 146.621H78.7241V152.793H72.5517V146.621ZM78.7241 146.621H84.8966V152.793H78.7241V146.621ZM91.069 146.621H97.2414V152.793H91.069V146.621ZM97.2414 146.621H103.414V152.793H97.2414V146.621ZM115.759 146.621H121.931V152.793H115.759V146.621ZM121.931 146.621H128.103V152.793H121.931V146.621ZM134.276 146.621H140.448V152.793H134.276V146.621ZM140.448 146.621H146.621V152.793H140.448V146.621ZM165.138 146.621H171.31V152.793H165.138V146.621ZM171.31 146.621H177.483V152.793H171.31V146.621ZM177.483 146.621H183.655V152.793H177.483V146.621ZM183.655 146.621H189.828V152.793H183.655V146.621ZM189.828 146.621H196V152.793H189.828V146.621ZM17 152.793H23.1724V158.966H17V152.793ZM23.1724 152.793H29.3448V158.966H23.1724V152.793ZM29.3448 152.793H35.5172V158.966H29.3448V152.793ZM35.5172 152.793H41.6897V158.966H35.5172V152.793ZM41.6897 152.793H47.8621V158.966H41.6897V152.793ZM47.8621 152.793H54.0345V158.966H47.8621V152.793ZM54.0345 152.793H60.2069V158.966H54.0345V152.793ZM66.3793 152.793H72.5517V158.966H66.3793V152.793ZM97.2414 152.793H103.414V158.966H97.2414V152.793ZM103.414 152.793H109.586V158.966H103.414V152.793ZM109.586 152.793H115.759V158.966H109.586V152.793ZM115.759 152.793H121.931V158.966H115.759V152.793ZM128.103 152.793H134.276V158.966H128.103V152.793ZM134.276 152.793H140.448V158.966H134.276V152.793ZM140.448 152.793H146.621V158.966H140.448V152.793ZM152.793 152.793H158.966V158.966H152.793V152.793ZM165.138 152.793H171.31V158.966H165.138V152.793ZM171.31 152.793H177.483V158.966H171.31V152.793ZM177.483 152.793H183.655V158.966H177.483V152.793ZM17 158.966H23.1724V165.138H17V158.966ZM54.0345 158.966H60.2069V165.138H54.0345V158.966ZM72.5517 158.966H78.7241V165.138H72.5517V158.966ZM91.069 158.966H97.2414V165.138H91.069V158.966ZM97.2414 158.966H103.414V165.138H97.2414V158.966ZM109.586 158.966H115.759V165.138H109.586V158.966ZM115.759 158.966H121.931V165.138H115.759V158.966ZM128.103 158.966H134.276V165.138H128.103V158.966ZM134.276 158.966H140.448V165.138H134.276V158.966ZM140.448 158.966H146.621V165.138H140.448V158.966ZM165.138 158.966H171.31V165.138H165.138V158.966ZM17 165.138H23.1724V171.31H17V165.138ZM29.3448 165.138H35.5172V171.31H29.3448V165.138ZM35.5172 165.138H41.6897V171.31H35.5172V165.138ZM41.6897 165.138H47.8621V171.31H41.6897V165.138ZM54.0345 165.138H60.2069V171.31H54.0345V165.138ZM66.3793 165.138H72.5517V171.31H66.3793V165.138ZM78.7241 165.138H84.8966V171.31H78.7241V165.138ZM91.069 165.138H97.2414V171.31H91.069V165.138ZM103.414 165.138H109.586V171.31H103.414V165.138ZM109.586 165.138H115.759V171.31H109.586V165.138ZM140.448 165.138H146.621V171.31H140.448V165.138ZM146.621 165.138H152.793V171.31H146.621V165.138ZM152.793 165.138H158.966V171.31H152.793V165.138ZM158.966 165.138H165.138V171.31H158.966V165.138ZM165.138 165.138H171.31V171.31H165.138V165.138ZM177.483 165.138H183.655V171.31H177.483V165.138ZM183.655 165.138H189.828V171.31H183.655V165.138ZM189.828 165.138H196V171.31H189.828V165.138ZM17 171.31H23.1724V177.483H17V171.31ZM29.3448 171.31H35.5172V177.483H29.3448V171.31ZM35.5172 171.31H41.6897V177.483H35.5172V171.31ZM41.6897 171.31H47.8621V177.483H41.6897V171.31ZM54.0345 171.31H60.2069V177.483H54.0345V171.31ZM66.3793 171.31H72.5517V177.483H66.3793V171.31ZM78.7241 171.31H84.8966V177.483H78.7241V171.31ZM115.759 171.31H121.931V177.483H115.759V171.31ZM121.931 171.31H128.103V177.483H121.931V171.31ZM134.276 171.31H140.448V177.483H134.276V171.31ZM158.966 171.31H165.138V177.483H158.966V171.31ZM171.31 171.31H177.483V177.483H171.31V171.31ZM177.483 171.31H183.655V177.483H177.483V171.31ZM183.655 171.31H189.828V177.483H183.655V171.31ZM189.828 171.31H196V177.483H189.828V171.31ZM17 177.483H23.1724V183.655H17V177.483ZM29.3448 177.483H35.5172V183.655H29.3448V177.483ZM35.5172 177.483H41.6897V183.655H35.5172V177.483ZM41.6897 177.483H47.8621V183.655H41.6897V177.483ZM54.0345 177.483H60.2069V183.655H54.0345V177.483ZM66.3793 177.483H72.5517V183.655H66.3793V177.483ZM72.5517 177.483H78.7241V183.655H72.5517V177.483ZM78.7241 177.483H84.8966V183.655H78.7241V177.483ZM84.8966 177.483H91.069V183.655H84.8966V177.483ZM91.069 177.483H97.2414V183.655H91.069V177.483ZM109.586 177.483H115.759V183.655H109.586V177.483ZM121.931 177.483H128.103V183.655H121.931V177.483ZM140.448 177.483H146.621V183.655H140.448V177.483ZM146.621 177.483H152.793V183.655H146.621V177.483ZM152.793 177.483H158.966V183.655H152.793V177.483ZM158.966 177.483H165.138V183.655H158.966V177.483ZM165.138 177.483H171.31V183.655H165.138V177.483ZM171.31 177.483H177.483V183.655H171.31V177.483ZM177.483 177.483H183.655V183.655H177.483V177.483ZM183.655 177.483H189.828V183.655H183.655V177.483ZM17 183.655H23.1724V189.828H17V183.655ZM54.0345 183.655H60.2069V189.828H54.0345V183.655ZM66.3793 183.655H72.5517V189.828H66.3793V183.655ZM72.5517 183.655H78.7241V189.828H72.5517V183.655ZM84.8966 183.655H91.069V189.828H84.8966V183.655ZM103.414 183.655H109.586V189.828H103.414V183.655ZM140.448 183.655H146.621V189.828H140.448V183.655ZM152.793 183.655H158.966V189.828H152.793V183.655ZM158.966 183.655H165.138V189.828H158.966V183.655ZM165.138 183.655H171.31V189.828H165.138V183.655ZM171.31 183.655H177.483V189.828H171.31V183.655ZM183.655 183.655H189.828V189.828H183.655V183.655ZM17 189.828H23.1724V196H17V189.828ZM23.1724 189.828H29.3448V196H23.1724V189.828ZM29.3448 189.828H35.5172V196H29.3448V189.828ZM35.5172 189.828H41.6897V196H35.5172V189.828ZM41.6897 189.828H47.8621V196H41.6897V189.828ZM47.8621 189.828H54.0345V196H47.8621V189.828ZM54.0345 189.828H60.2069V196H54.0345V189.828ZM66.3793 189.828H72.5517V196H66.3793V189.828ZM72.5517 189.828H78.7241V196H72.5517V189.828ZM78.7241 189.828H84.8966V196H78.7241V189.828ZM84.8966 189.828H91.069V196H84.8966V189.828ZM109.586 189.828H115.759V196H109.586V189.828ZM115.759 189.828H121.931V196H115.759V189.828ZM121.931 189.828H128.103V196H121.931V189.828ZM134.276 189.828H140.448V196H134.276V189.828ZM146.621 189.828H152.793V196H146.621V189.828ZM152.793 189.828H158.966V196H152.793V189.828ZM165.138 189.828H171.31V196H165.138V189.828ZM177.483 189.828H183.655V196H177.483V189.828Z"
        fill="#0E144B"
      />
      <path
        d="M98.0075 112.286L96.7736 112.96C96.5455 112.722 96.3173 112.556 96.0892 112.452C95.8611 112.359 95.6019 112.307 95.2908 112.307C94.7413 112.307 94.2954 112.473 93.9532 112.805C93.6111 113.136 93.4452 113.551 93.4452 114.07C93.4452 114.567 93.6111 114.982 93.9429 115.293C94.2747 115.615 94.6998 115.77 95.239 115.77C95.9026 115.77 96.4107 115.542 96.7839 115.096L97.9453 115.895C97.3127 116.714 96.421 117.128 95.2701 117.128C94.2332 117.128 93.4244 116.817 92.8438 116.206C92.2631 115.594 91.9624 114.878 91.9624 114.049C91.9624 113.479 92.1076 112.95 92.3875 112.473C92.6675 111.996 93.0719 111.612 93.5799 111.343C94.088 111.073 94.6583 110.928 95.2908 110.928C95.8715 110.928 96.4003 111.042 96.8669 111.28C97.3335 111.529 97.7171 111.861 98.0075 112.286Z"
        fill="#0E144B"
      />
      <path
        d="M101.554 110.949C102.113 110.949 102.632 111.083 103.119 111.363C103.607 111.643 103.99 112.017 104.26 112.494C104.529 112.971 104.675 113.479 104.675 114.039C104.675 114.598 104.54 115.117 104.26 115.594C103.98 116.081 103.607 116.454 103.13 116.724C102.653 116.994 102.124 117.128 101.554 117.128C100.714 117.128 99.9879 116.828 99.3969 116.226C98.7955 115.625 98.5051 114.899 98.5051 114.039C98.5051 113.116 98.8473 112.348 99.5213 111.737C100.102 111.218 100.776 110.949 101.554 110.949ZM101.574 112.338C101.118 112.338 100.734 112.494 100.423 112.815C100.123 113.136 99.9671 113.541 99.9671 114.039C99.9671 114.547 100.123 114.961 100.423 115.283C100.724 115.604 101.108 115.76 101.574 115.76C102.041 115.76 102.425 115.604 102.725 115.283C103.026 114.961 103.181 114.547 103.181 114.049C103.181 113.551 103.026 113.136 102.725 112.815C102.425 112.494 102.041 112.338 101.574 112.338Z"
        fill="#0E144B"
      />
      <path
        d="M104.975 111.104H106.24V111.84C106.375 111.55 106.562 111.322 106.79 111.177C107.018 111.021 107.267 110.949 107.536 110.949C107.723 110.949 107.93 111 108.138 111.104L107.682 112.38C107.505 112.297 107.371 112.245 107.256 112.245C107.028 112.245 106.842 112.39 106.676 112.67C106.52 112.95 106.437 113.499 106.437 114.329L106.448 114.619V117.004H104.986V111.104H104.975Z"
        fill="#0E144B"
      />
      <path
        d="M108.511 111.104H109.983V111.706C110.315 111.426 110.626 111.229 110.896 111.115C111.166 111 111.446 110.949 111.725 110.949C112.306 110.949 112.804 111.156 113.208 111.56C113.55 111.903 113.716 112.421 113.716 113.095V116.983H112.254V114.401C112.254 113.696 112.223 113.23 112.161 113.002C112.099 112.774 111.985 112.597 111.829 112.473C111.674 112.348 111.477 112.297 111.248 112.297C110.948 112.297 110.689 112.4 110.481 112.597C110.263 112.794 110.118 113.074 110.035 113.427C109.994 113.613 109.973 114.007 109.973 114.619V116.983H108.511V111.104Z"
        fill="#0E144B"
      />
      <path
        d="M115.189 108.678C115.448 108.678 115.666 108.771 115.852 108.958C116.039 109.144 116.132 109.373 116.132 109.642C116.132 109.901 116.039 110.13 115.852 110.316C115.666 110.503 115.448 110.596 115.199 110.596C114.94 110.596 114.712 110.503 114.525 110.316C114.338 110.13 114.245 109.901 114.245 109.621C114.245 109.362 114.338 109.144 114.525 108.958C114.701 108.771 114.929 108.678 115.189 108.678ZM114.442 111.104H115.915V116.983H114.442V111.104Z"
        fill="#0E144B"
      />
      <path
        d="M117.656 116.983L121.835 111.197L121.897 111.104H120.218L119.056 112.701L117.895 111.104H116.184L118.206 113.893L115.966 116.983H117.656Z"
        fill="#0E144B"
      />
      <path
        d="M119.305 115.397L120.446 116.983H122.167L120.155 114.215L119.305 115.397Z"
        fill="#0E144B"
      />
      <path
        d="M101.761 102.353C101.554 102.405 101.336 102.457 101.108 102.498C100.88 102.705 101.222 102.695 101.761 102.353Z"
        fill="#0E144B"
      />
      <path
        d="M110.357 96.8885C110.896 96.2456 112.99 98.0187 112.99 98.0187C112.856 96.2975 110.854 95.6131 110.854 95.6131C110.854 95.6131 110.118 94.6592 109.361 94.3792C108.615 94.0993 108.2 94.317 107.848 94.4311C107.495 94.5451 107.371 94.4311 107.371 94.4311L107.464 94.5659L107.215 94.6281L107.308 94.6695L107.091 94.7732H107.288C107.288 94.7732 107.205 94.8458 106.52 95.2398C106.002 95.5302 105.784 95.582 105.701 95.5924H105.919C105.919 95.5924 105.898 95.6131 105.857 95.6546C105.753 95.7479 105.504 95.9553 105.131 96.2456C104.592 96.65 102.891 97.3551 102.176 97.9876C101.709 98.392 101.543 98.6927 101.357 98.983C101.502 98.8689 101.626 98.786 101.73 98.7445C101.73 98.7445 101.533 98.8897 101.274 99.1178C101.201 99.2319 101.118 99.3459 101.014 99.46C100.786 99.7192 100.527 99.9369 100.268 100.155C100.195 100.248 100.123 100.352 100.06 100.445C100.081 100.383 100.112 100.321 100.154 100.258C99.9672 100.424 99.7909 100.601 99.625 100.798C99.1999 101.316 98.7747 101.751 98.36 102.415C97.8001 103.307 96.9706 104.686 97.1365 104.696C97.292 104.707 97.883 103.867 98.5363 103.276C98.3496 103.587 98.1422 103.773 98.1422 103.773C98.1422 103.773 98.7333 103.452 99.345 103.12C99.9568 102.788 98.671 103.493 99.3139 103.286C99.9153 103.089 100.652 102.685 101.087 102.467C100.849 102.508 100.589 102.54 100.33 102.571C100.9 102.425 101.574 102.239 102.269 101.969C102.3 101.938 102.331 101.917 102.373 101.886C102.352 101.907 102.321 101.938 102.3 101.959C103.824 101.347 105.421 100.289 106.251 98.2157C106.251 98.2157 105.577 101.264 101.937 102.291C101.46 102.674 101.025 102.83 100.952 102.633C99.9361 103.182 99.0962 103.514 99.0547 103.421C98.7955 103.525 98.6918 103.639 98.5155 103.825C98.3496 104.022 97.4164 105.07 96.1514 105.619C94.8864 106.179 95.0005 106.428 95.3323 106.366C95.4256 106.345 95.4878 106.335 95.5293 106.324C95.4982 106.335 95.4671 106.355 95.4152 106.376C95.1871 106.48 95.4152 106.594 95.8196 106.5C96.224 106.407 96.8461 106.096 97.3231 105.64C97.1883 105.847 96.6387 106.262 96.7632 106.252C96.8876 106.241 97.1676 106.179 97.3542 106.023C97.5408 105.868 97.012 106.407 97.5408 106.189C98.0593 105.972 100.04 105.173 100.04 105.173C100.04 105.173 100.372 105.298 100.714 105.028C100.911 105.059 101.077 105.08 101.232 105.101C101.211 105.339 101.17 105.609 101.108 105.723C101.004 105.909 101.077 105.909 101.243 105.795C101.408 105.681 101.325 105.733 101.336 105.826C101.346 105.92 101.429 106.086 101.429 105.868C101.398 105.588 101.657 105.64 101.823 105.878C101.989 106.117 103.026 107.703 103.15 107.962C103.275 108.222 102.964 108.346 102.922 108.398C102.881 108.45 102.663 108.491 102.518 108.439C102.311 108.367 102.207 108.564 102.196 108.823C102.29 108.699 102.383 108.678 102.611 108.75C102.839 108.823 102.881 108.719 103.233 108.553C103.161 108.605 103.254 108.761 103.254 108.761C103.254 108.761 103.358 108.782 103.358 109.01C103.461 108.989 103.461 108.782 103.513 108.595C103.555 108.408 103.793 108.491 104.198 108.512C104.229 108.626 104.426 108.75 104.426 108.75C104.426 108.75 104.478 108.688 104.509 108.937C104.55 108.813 104.561 108.699 104.55 108.616C104.633 108.636 104.737 108.657 104.809 108.678C104.944 108.709 105.12 108.481 105.12 108.481C105.12 108.481 105.235 108.522 105.245 108.678C105.411 108.305 105.069 108.242 104.872 108.305C104.675 108.367 104.415 108.305 104.415 108.305C104.312 108.211 104.167 108.18 104.042 108.18C103.762 108.159 103.721 108.066 103.721 108.066C103.721 108.066 102.777 106.552 102.632 106.335C102.476 106.117 102.425 105.93 102.518 105.847C102.611 105.754 103.306 104.758 103.534 104.955C103.762 105.152 103.721 105.619 103.607 105.775C103.493 105.93 103.441 106.241 103.576 106.48C103.576 106.397 103.669 106.283 103.669 106.283L103.773 106.438L103.804 106.283L103.959 106.5C103.959 106.5 103.876 106.22 103.99 106.283C104.104 106.345 106.023 107.828 106.251 108.014C106.479 108.201 106.603 108.356 106.417 108.356C106.23 108.356 106.074 108.325 105.898 108.356C105.722 108.388 105.701 108.678 105.701 108.678C105.701 108.678 105.836 108.553 106.012 108.585C106.116 108.699 106.5 108.657 106.634 108.616C106.78 108.574 107.298 108.491 107.599 108.678C107.899 108.865 108.283 108.688 108.376 108.585C108.47 108.481 108.636 108.522 108.76 108.668C108.884 108.813 109.009 108.668 109.009 108.668C109.009 108.668 109.05 108.678 109.164 108.802C109.175 108.636 108.967 108.439 108.874 108.367C108.781 108.294 108.604 108.367 108.604 108.367C108.604 108.367 108.615 108.159 108.48 108.108C108.345 108.056 108.242 108.191 107.993 108.315C107.744 108.439 107.339 108.346 106.977 108.118C106.614 107.89 105.255 106.78 104.675 106.314C104.799 106.231 104.882 105.92 104.955 105.536C104.986 105.37 105.027 105.215 105.089 105.07C105.11 105.038 105.12 105.007 105.141 104.976C105.224 104.935 105.297 104.883 105.359 104.852C105.763 104.499 106.551 103.763 107.205 102.84C107.049 103.328 106.748 103.701 106.531 103.919C106.8 103.67 107.059 103.4 107.215 103.151C107.651 102.457 108.47 100.943 108.926 100.258C109.382 99.574 109.351 98.0187 109.351 98.0187C109.351 97.5936 110.066 97.9565 110.782 98.4127C111.497 98.8689 112.057 98.7756 112.057 98.7756C112.057 98.7756 109.818 97.5314 110.357 96.8885ZM105.597 96.4634C105.67 96.4426 105.732 96.4219 105.794 96.4115L104.478 97.2514C104.011 97.2721 103.036 97.7387 102.082 98.4127C102.736 97.6039 104.654 96.7537 105.597 96.4634ZM102.082 100.144C102.082 100.144 101.16 100.258 100.32 100.818C100.89 100.144 101.377 100.061 102.082 100.144ZM99.148 102.394C99.4695 101.43 100.382 100.974 100.983 100.818C100.973 100.808 99.7183 101.637 99.148 102.394ZM100.714 102.28C100.714 102.28 101.16 101.731 102.082 101.254L101.844 101.928C101.222 102.228 100.714 102.28 100.714 102.28ZM102.176 101.762C102.103 101.803 102.031 101.845 101.958 101.876L102.196 101.202C102.259 101.171 102.331 101.14 102.404 101.109L102.176 101.762ZM102.29 101.689L102.508 101.067C102.58 101.036 102.642 101.015 102.715 100.984L102.528 101.534C102.445 101.586 102.362 101.648 102.29 101.689ZM102.642 101.44L102.808 100.953C102.953 100.901 103.109 100.86 103.275 100.818C103.078 101.057 102.86 101.264 102.642 101.44ZM105.224 97.8943C104.903 98.0913 103.648 98.589 103.648 98.589C103.648 98.589 103.98 98.5371 104.115 98.4749C104.25 98.4231 104.436 98.4957 104.208 98.6305C104.208 98.6305 104.198 98.6305 104.198 98.6408C103.949 98.7756 102.808 99.1696 102.808 99.1696L103.358 99.0971C102.373 99.6051 101.45 99.9992 101.45 99.9992C101.45 99.9992 103.202 98.8067 104.146 98.0083C104.239 97.9876 104.343 97.9461 104.467 97.9046C104.83 97.7491 105.556 97.6973 105.224 97.8943ZM105.587 97.4795C105.359 97.6143 104.706 97.7802 104.281 97.8839C104.457 97.7284 104.592 97.5936 104.675 97.4899C104.83 97.4277 105.038 97.3343 105.297 97.2203C105.929 96.9403 105.94 97.2721 105.587 97.4795ZM106.199 96.7952L104.726 97.3343C104.706 97.3032 104.675 97.2929 104.633 97.2825L105.815 96.6604L106.095 96.4426C106.209 96.4945 106.251 96.6189 106.199 96.7952ZM96.7943 105.578L100.216 103.659C99.0132 104.561 96.7943 105.578 96.7943 105.578ZM109.268 95.9864C109.123 95.9864 109.009 95.8723 109.009 95.7272C109.009 95.582 109.123 95.468 109.268 95.468C109.413 95.468 109.527 95.582 109.527 95.7272C109.527 95.8723 109.413 95.9864 109.268 95.9864Z"
        fill="#0E144B"
      />
      <path
        d="M111.643 98.3505C111.958 98.3505 112.213 98.0952 112.213 97.7802C112.213 97.4653 111.958 97.21 111.643 97.21C111.328 97.21 111.072 97.4653 111.072 97.7802C111.072 98.0952 111.328 98.3505 111.643 98.3505Z"
        fill="url(#paint0_linear_215_74)"
      />
      <path
        d="M111.643 98.3609C111.952 98.3609 112.202 98.1102 112.202 97.801C112.202 97.4918 111.952 97.2411 111.643 97.2411C111.333 97.2411 111.083 97.4918 111.083 97.801C111.083 98.1102 111.333 98.3609 111.643 98.3609Z"
        fill="url(#paint1_linear_215_74)"
      />
      <path
        d="M111.715 97.1995C111.383 97.158 111.072 97.3965 111.031 97.7283C110.989 98.0601 111.228 98.3712 111.56 98.4127C111.891 98.4541 112.202 98.2157 112.244 97.8839C112.296 97.5417 112.057 97.241 111.715 97.1995ZM111.57 98.3297C111.28 98.2882 111.083 98.029 111.114 97.7387C111.155 97.4484 111.414 97.2514 111.705 97.2825C111.995 97.3239 112.192 97.5832 112.161 97.8735C112.13 98.1638 111.86 98.3608 111.57 98.3297Z"
        fill="url(#paint2_linear_215_74)"
      />
      <path
        d="M111.715 97.1995C111.383 97.158 111.072 97.3965 111.031 97.7283C110.989 98.0601 111.228 98.3712 111.56 98.4127C111.891 98.4541 112.202 98.2157 112.244 97.8839C112.296 97.5417 112.057 97.241 111.715 97.1995ZM111.57 98.3608C111.259 98.3194 111.041 98.0394 111.083 97.7283C111.124 97.4173 111.404 97.1995 111.715 97.241C112.026 97.2825 112.244 97.5624 112.202 97.8735C112.161 98.1846 111.881 98.4023 111.57 98.3608Z"
        fill="url(#paint3_linear_215_74)"
      />
      <path
        d="M111.86 97.8735C111.85 97.8528 111.829 97.832 111.798 97.8217C111.819 97.8113 111.84 97.8009 111.86 97.7802C111.881 97.7594 111.881 97.7387 111.891 97.718C111.891 97.6972 111.891 97.6765 111.881 97.6558C111.871 97.635 111.86 97.6246 111.85 97.6039C111.84 97.5935 111.819 97.5832 111.798 97.5728H111.788L111.798 97.4898L111.726 97.4795L111.715 97.5624L111.643 97.5521L111.653 97.4691L111.58 97.4587L111.57 97.5417L111.508 97.5313L111.446 98.0498L111.508 98.0601L111.497 98.1327L111.57 98.1431L111.58 98.0705H111.622C111.632 98.0705 111.643 98.0705 111.653 98.0705L111.643 98.1431L111.715 98.1535L111.726 98.0809C111.736 98.0809 111.736 98.0809 111.746 98.0809C111.777 98.0809 111.798 98.0809 111.819 98.0705C111.84 98.0601 111.86 98.0394 111.871 98.0187C111.881 97.9979 111.891 97.9772 111.891 97.9564C111.881 97.9253 111.871 97.8942 111.86 97.8735ZM111.58 97.6246L111.643 97.635C111.694 97.6454 111.726 97.6454 111.736 97.6454C111.757 97.6454 111.767 97.6557 111.777 97.6661C111.788 97.6765 111.788 97.6869 111.788 97.7076C111.788 97.7283 111.777 97.7387 111.767 97.7491C111.757 97.7594 111.736 97.7594 111.726 97.7594C111.715 97.7594 111.694 97.7594 111.653 97.7491L111.58 97.7387V97.6246ZM111.746 97.9772C111.736 97.9876 111.726 97.9876 111.705 97.9979C111.694 97.9979 111.674 97.9979 111.632 97.9876L111.539 97.9772L111.56 97.8424L111.643 97.8528C111.694 97.8631 111.726 97.8631 111.736 97.8735C111.746 97.8839 111.757 97.8942 111.767 97.9046C111.777 97.915 111.777 97.9253 111.777 97.9461C111.767 97.9564 111.757 97.9668 111.746 97.9772Z"
        fill="url(#paint4_linear_215_74)"
      />
      <path
        d="M113.385 109.424C113.747 109.476 113.944 109.456 113.084 109.269C113.022 109.259 112.959 109.238 112.887 109.227C112.234 109.113 111.57 108.979 110.917 108.906C109.6 108.709 108.273 108.636 106.945 108.595C105.618 108.564 104.291 108.626 102.964 108.761C101.688 108.896 100.434 109.082 99.1584 109.424C99.0651 109.445 99.0029 109.58 99.0236 109.704L99.1273 110.233C99.1481 110.358 99.2414 110.43 99.3347 110.399C100.527 110.005 101.782 109.725 103.016 109.518C104.322 109.3 105.629 109.155 106.945 109.103C108.262 109.051 109.579 109.051 110.896 109.155C111.56 109.186 112.213 109.279 112.876 109.352C113.042 109.373 113.208 109.404 113.385 109.424Z"
        fill="#0E144B"
      />
    </g>
    <g id="frame">
      <path
        d="M180.966 2L211.5 2C211.776 2 212 2.22386 212 2.5V33.1881"
        stroke="inherit"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M180.966 212H211.5C211.776 212 212 211.776 212 211.5V180.812"
        stroke="inherit"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M33.0345 212H2.5C2.22386 212 2 211.776 2 211.5L2 180.812"
        stroke="inherit"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M33.0345 2L2.5 2C2.22386 2 2 2.22386 2 2.5L2 33.1881"
        stroke="inherit"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </g>
    <g id="arrow">
      <path
        d="M105.837 227.413C106.216 227.748 106.784 227.748 107.163 227.413L124.01 212.499C124.699 211.889 124.268 210.75 123.347 210.75H89.6527C88.7321 210.75 88.3006 211.889 88.9898 212.499L105.837 227.413Z"
        fill="inherit"
      />
    </g>
  </svg>
);

export const AppQrCodeIcon = forwardRef((props: any, ref: any) => {
  return (
    <svg {...props} ref={ref} width="21" height="30" viewBox="0 0 21 30">
      <path
        d="M18.009 0.935303H2.99111C1.84858 0.935303 0.919678 1.86421 0.919678 3.00673V27.8639C0.919678 29.0064 1.84858 29.9353 2.99111 29.9353H18.009C19.1515 29.9353 20.0804 29.0064 20.0804 27.8639V3.00673C20.0804 1.86421 19.1515 0.935303 18.009 0.935303ZM17.75 27.6049H3.25004V3.26566H17.75V27.6049ZM9.20539 24.3036C9.20539 24.647 9.34179 24.9763 9.58459 25.2191C9.82738 25.4619 10.1567 25.5982 10.5 25.5982C10.8434 25.5982 11.1727 25.4619 11.4155 25.2191C11.6583 24.9763 11.7947 24.647 11.7947 24.3036C11.7947 23.9602 11.6583 23.6309 11.4155 23.3882C11.1727 23.1454 10.8434 23.009 10.5 23.009C10.1567 23.009 9.82738 23.1454 9.58459 23.3882C9.34179 23.6309 9.20539 23.9602 9.20539 24.3036Z"
        fill="currentColor"
      />
      <path
        d="M5.625 11.9583V7.625H9.95833V11.9583H5.625ZM6.70833 10.875H8.875V8.70833H6.70833V10.875ZM5.625 17.375V13.0417H9.95833V17.375H5.625ZM6.70833 16.2917H8.875V14.125H6.70833V16.2917ZM11.0417 11.9583V7.625H15.375V11.9583H11.0417ZM12.125 10.875H14.2917V8.70833H12.125V10.875ZM14.2917 17.375V16.2917H15.375V17.375H14.2917ZM11.0417 14.125V13.0417H12.125V14.125H11.0417ZM12.125 15.2083V14.125H13.2083V15.2083H12.125ZM11.0417 16.2917V15.2083H12.125V16.2917H11.0417ZM12.125 17.375V16.2917H13.2083V17.375H12.125ZM13.2083 16.2917V15.2083H14.2917V16.2917H13.2083ZM13.2083 14.125V13.0417H14.2917V14.125H13.2083ZM14.2917 15.2083V14.125H15.375V15.2083H14.2917Z"
        fill="currentColor"
      />
    </svg>
  );
});

export const ReviewsEmptyState = (props: any) => {
  return (
    <Icon
      {...props}
      $size={212}
      width="212"
      height="182"
      viewBox="0 0 212 182"
      fill="none"
    >
      <path
        d="M105.624 181.655C163.959 181.655 211.248 169.96 211.248 155.533C211.248 141.106 163.959 129.411 105.624 129.411C47.2895 129.411 0 141.106 0 155.533C0 169.96 47.2895 181.655 105.624 181.655Z"
        fill="url(#paint0_linear_439_705)"
      />
      <path
        d="M40.3034 0C36.5505 0 31.8246 1.94685 29.1709 5.16775C26.5172 8.38864 23.9999 15.3814 23.9999 19.9364L24.5967 94.5232C24.5967 99.0783 25.3301 105.261 29.8322 110.726C32.4859 113.947 36.5505 115.587 40.3034 115.587H45.5057V136.48C45.5057 138.757 45.9669 140.874 47.2937 142.485C48.6206 144.095 49.9164 145 51.477 145C53.0376 145 55.0145 145 58.5521 142.485L82.1646 116.866H171.822C175.574 116.866 180.697 115.056 183.35 111.835C186.004 108.614 187.495 102.319 187.495 97.7638L186.837 18.823C186.837 14.2679 185.411 8.25127 182.757 5.03037C180.103 1.80948 174.916 0 171.163 0H40.3034Z"
        fill="url(#paint1_linear_439_705)"
      />
      <g clipPath="url(#clip0_439_705)">
        <g filter="url(#filter0_d_439_705)">
          <path
            d="M64.6412 69.8772C63.567 69.8772 63.0299 69.8772 62.6315 69.5811C62.2331 69.285 62.0783 68.7707 61.7686 67.7422L60.7062 64.214C59.5344 60.3223 58.9485 58.3764 57.8336 58.3764C56.7188 58.3764 56.1328 60.3223 54.961 64.214L53.8987 67.7422C53.589 68.7707 53.4341 69.285 53.0357 69.5811C52.6373 69.8772 52.1002 69.8772 51.0261 69.8772H48.2973C44.4683 69.8772 42.5538 69.8772 42.2185 70.9168C41.8832 71.9564 43.437 73.075 46.5446 75.312L48.8904 77.0007C49.7337 77.6077 50.1554 77.9112 50.3092 78.3685C50.463 78.8257 50.3106 79.3223 50.0057 80.3157L48.9636 83.7111C47.8315 87.3995 47.2655 89.2437 48.165 89.8687C49.0644 90.4936 50.5953 89.3197 53.6571 86.9719L56.0096 85.168C56.8867 84.4955 57.3252 84.1592 57.8338 84.159C58.3424 84.1588 58.7812 84.4947 59.6587 85.1666L62.0346 86.9855C65.0946 89.3281 66.6246 90.4994 67.5235 89.8744C68.4223 89.2493 67.8569 87.4073 66.7262 83.7231L65.6799 80.314C65.3752 79.3214 65.2229 78.8252 65.3765 78.3682C65.53 77.9112 65.9511 77.6076 66.7933 77.0003L69.1367 75.3106C72.2391 73.0738 73.7902 71.9553 73.4547 70.9163C73.1192 69.8772 71.2068 69.8772 67.3822 69.8772H64.6412Z"
            fill="white"
          />
        </g>
      </g>
      <g clipPath="url(#clip1_439_705)">
        <g filter="url(#filter1_d_439_705)">
          <path
            d="M162.376 69.8772C161.283 69.8772 160.736 69.8772 160.334 69.5731C159.933 69.2689 159.785 68.7428 159.488 67.6906L158.709 64.9253C157.541 60.7793 156.957 58.7063 155.822 58.7063C154.686 58.7063 154.102 60.7793 152.934 64.9253L152.155 67.6906C151.859 68.7428 151.71 69.2689 151.309 69.5731C150.907 69.8772 150.361 69.8772 149.267 69.8772H147.016C143.361 69.8772 141.533 69.8772 141.187 70.8941C140.841 71.911 142.29 73.0256 145.187 75.2548L147.472 77.0138C148.255 77.6163 148.647 77.9175 148.791 78.3562C148.935 78.7948 148.799 79.2696 148.526 80.2192L147.603 83.4355C146.515 87.2249 145.971 89.1196 146.893 89.726C147.815 90.3325 149.339 89.0829 152.388 86.5836L153.921 85.327C154.831 84.5813 155.286 84.2084 155.822 84.2082C156.358 84.208 156.813 84.5805 157.723 85.3254L159.278 86.598C162.325 89.0918 163.849 90.3387 164.77 89.7322C165.692 89.1256 165.148 87.2332 164.062 83.4485L163.134 80.2176C162.862 79.2687 162.725 78.7943 162.869 78.3559C163.013 77.9175 163.404 77.6162 164.186 77.0136L166.47 75.2533C169.362 73.0243 170.808 71.9098 170.462 70.8935C170.115 69.8772 168.29 69.8772 164.638 69.8772H162.376Z"
            fill="white"
          />
        </g>
      </g>
      <g clipPath="url(#clip2_439_705)">
        <g filter="url(#filter2_d_439_705)">
          <path
            d="M114.23 69.8772C113.155 69.8772 112.618 69.8772 112.22 69.5811C111.822 69.285 111.667 68.7707 111.357 67.7422L110.295 64.214C109.123 60.3223 108.537 58.3764 107.422 58.3764C106.307 58.3764 105.721 60.3223 104.549 64.214L103.487 67.7422C103.177 68.7707 103.023 69.285 102.624 69.5811C102.226 69.8772 101.689 69.8772 100.614 69.8772H97.8857C94.0567 69.8772 92.1421 69.8772 91.8069 70.9168C91.4716 71.9564 93.0254 73.075 96.133 75.312L98.4788 77.0007C99.3221 77.6077 99.7437 77.9112 99.8976 78.3685C100.051 78.8257 99.899 79.3223 99.5941 80.3157L98.552 83.7111C97.4199 87.3995 96.8539 89.2437 97.7533 89.8687C98.6528 90.4936 100.184 89.3197 103.245 86.9719L105.598 85.168C106.475 84.4955 106.914 84.1592 107.422 84.159C107.931 84.1588 108.37 84.4947 109.247 85.1666L111.623 86.9855C114.683 89.3281 116.213 90.4994 117.112 89.8744C118.011 89.2493 117.445 87.4073 116.315 83.7231L115.268 80.314C114.964 79.3214 114.811 78.8252 114.965 78.3682C115.118 77.9112 115.539 77.6076 116.382 77.0003L118.725 75.3106C121.827 73.0738 123.379 71.9553 123.043 70.9163C122.708 69.8772 120.795 69.8772 116.971 69.8772H114.23Z"
            fill="white"
          />
        </g>
      </g>
      <g filter="url(#filter3_d_439_705)">
        <rect
          x="81.5391"
          y="27.3662"
          width="81.3966"
          height="7.01695"
          rx="3.50848"
          fill="url(#paint2_linear_439_705)"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter4_d_439_705)">
        <path
          d="M47.1559 30.5238C47.1559 24.9134 51.7202 20.3491 57.3305 20.3491C62.9408 20.3491 67.505 24.9135 67.505 30.5238C67.505 34.3291 65.4048 37.6528 62.3028 39.3977C60.8316 40.2253 59.1354 40.6983 57.3305 40.6983C55.5255 40.6983 53.8294 40.2253 52.3581 39.3977C49.2563 37.6528 47.1559 34.3292 47.1559 30.5238Z"
          fill="url(#paint3_linear_439_705)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_439_705"
          x="38.1736"
          y="58.3765"
          width="39.326"
          height="39.6646"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.701961 0 0 0 0 0.815686 0 0 0 0 0.976471 0 0 0 0.65 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_439_705"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_439_705"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_439_705"
          x="137.137"
          y="58.7061"
          width="37.3752"
          height="39.1777"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.701961 0 0 0 0 0.815686 0 0 0 0 0.976471 0 0 0 0.65 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_439_705"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_439_705"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_439_705"
          x="87.762"
          y="58.3765"
          width="39.326"
          height="39.6646"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.701961 0 0 0 0 0.815686 0 0 0 0 0.976471 0 0 0 0.65 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_439_705"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_439_705"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_439_705"
          x="77.5391"
          y="27.3662"
          width="89.3966"
          height="15.0171"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.702812 0 0 0 0 0.814479 0 0 0 0 0.975 0 0 0 0.64 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_439_705"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_439_705"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_439_705"
          x="43.1559"
          y="20.3491"
          width="28.3491"
          height="28.3491"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.702812 0 0 0 0 0.814479 0 0 0 0 0.975 0 0 0 0.64 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_439_705"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_439_705"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_439_705"
          x1="115.278"
          y1="202.098"
          x2="124.932"
          y2="73.7593"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDEAFF" />
          <stop offset="1" stopColor="#F0F6FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_439_705"
          x1="105.747"
          y1="177.434"
          x2="-6.8622"
          y2="-66.0523"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_439_705"
          x1="125.093"
          y1="30.8747"
          x2="126.49"
          y2="52.7177"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_439_705"
          x1="57.5913"
          y1="28.6975"
          x2="67.7064"
          y2="39.17"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.755208" stopColor="white" />
          <stop offset="0.9999" stopColor="#FAFCFF" />
        </linearGradient>
        <clipPath id="clip0_439_705">
          <rect
            width="45.213"
            height="45.6102"
            fill="white"
            transform="translate(35.2272 50.873)"
          />
        </clipPath>
        <clipPath id="clip1_439_705">
          <rect
            width="42.296"
            height="45.6102"
            fill="white"
            transform="translate(134.674 50.873)"
          />
        </clipPath>
        <clipPath id="clip2_439_705">
          <rect
            width="45.213"
            height="45.6102"
            fill="white"
            transform="translate(84.8156 50.873)"
          />
        </clipPath>
      </defs>
    </Icon>
  );
};

export const Download = (props: any) => (
  <svg {...props} width="16" height="16" viewBox="0 0 16 16">
    <path
      d="M14 12.6666H2.00004C1.82323 12.6666 1.65366 12.7368 1.52864 12.8618C1.40361 12.9869 1.33337 13.1564 1.33337 13.3333C1.33337 13.5101 1.40361 13.6796 1.52864 13.8047C1.65366 13.9297 1.82323 13.9999 2.00004 13.9999H14C14.1769 13.9999 14.3464 13.9297 14.4714 13.8047C14.5965 13.6796 14.6667 13.5101 14.6667 13.3333C14.6667 13.1564 14.5965 12.9869 14.4714 12.8618C14.3464 12.7368 14.1769 12.6666 14 12.6666ZM8.00004 1.33325C7.82323 1.33325 7.65366 1.40349 7.52864 1.52851C7.40361 1.65354 7.33337 1.82311 7.33337 1.99992V9.05992L5.14004 6.85992C5.0145 6.73438 4.84424 6.66386 4.66671 6.66386C4.48917 6.66386 4.31891 6.73438 4.19337 6.85992C4.06784 6.98545 3.99731 7.15572 3.99731 7.33325C3.99731 7.51079 4.06784 7.68105 4.19337 7.80659L7.52671 11.1399C7.58868 11.2024 7.66242 11.252 7.74366 11.2858C7.8249 11.3197 7.91203 11.3371 8.00004 11.3371C8.08805 11.3371 8.17519 11.3197 8.25642 11.2858C8.33766 11.252 8.4114 11.2024 8.47337 11.1399L11.8067 7.80659C11.8689 7.74443 11.9182 7.67063 11.9518 7.58942C11.9855 7.5082 12.0028 7.42116 12.0028 7.33325C12.0028 7.24535 11.9855 7.1583 11.9518 7.07709C11.9182 6.99587 11.8689 6.92208 11.8067 6.85992C11.7445 6.79776 11.6708 6.74845 11.5895 6.71481C11.5083 6.68117 11.4213 6.66386 11.3334 6.66386C11.2455 6.66386 11.1584 6.68117 11.0772 6.71481C10.996 6.74845 10.9222 6.79776 10.86 6.85992L8.66671 9.05992V1.99992C8.66671 1.82311 8.59647 1.65354 8.47144 1.52851C8.34642 1.40349 8.17685 1.33325 8.00004 1.33325Z"
      fill="inherit"
    />
  </svg>
);

export const Silver = (props: any) => (
  <svg {...props} width="46" height="49" viewBox="0 0 46 49">
    <path
      d="M23.2067 0.160018L2.70858 11.229C2.66594 11.252 2.62687 11.2811 2.5926 11.3154L2.35486 11.5532C2.27278 11.6352 2.22182 11.7433 2.21071 11.8589L0.159745 33.1889C0.150761 33.2823 0.168258 33.3764 0.210236 33.4604L0.532099 34.1041C0.552192 34.1443 0.57761 34.1816 0.607666 34.215L4.2573 38.2701C4.29208 38.3088 4.33268 38.3417 4.37764 38.3679L21.9675 48.5945C22.1203 48.6834 22.3088 48.6849 22.4631 48.5985L42.8043 37.2075C42.9476 37.1272 43.0423 36.9817 43.0578 36.8182L45.1051 15.1162C45.1117 15.0469 45.1037 14.9771 45.0817 14.9111L44.748 13.9102C44.7159 13.8137 44.6551 13.7293 44.5737 13.6683L41.3676 11.2637L23.7102 0.176525C23.5576 0.0807141 23.3653 0.0744081 23.2067 0.160018Z"
      fill="url(#paint0_linear_275_27974)"
    />
    <path
      d="M2.12977 12.3431L0.258396 32.9282C0.189555 33.6855 0.556067 34.4163 1.20415 34.814L17.4858 44.805C18.0931 45.1776 18.8527 45.1991 19.48 44.8613L39.1531 34.2681C39.7545 33.9443 40.149 33.336 40.1995 32.6549L41.694 12.4789C41.7493 11.7326 41.3833 11.0179 40.7455 10.6265L24.4362 0.618519C23.8332 0.248509 23.0796 0.224579 22.4544 0.555588L3.18578 10.7566C2.58824 11.073 2.19098 11.6698 2.12977 12.3431Z"
      fill="url(#paint1_linear_275_27974)"
    />
    <path
      d="M4.67084 14.5479L3.17167 31.2605C3.10363 32.019 3.47225 32.7503 4.12246 33.1468L17.0971 41.0581C17.7075 41.4303 18.4701 41.4484 19.0974 41.1056L35.4075 32.193C36.0075 31.8651 36.3985 31.2533 36.444 30.571L37.5407 14.1205C37.5896 13.3868 37.232 12.6855 36.6095 12.2941L24.0264 4.38482C23.4204 4.00388 22.657 3.97588 22.0247 4.31139L5.72542 12.9599C5.12801 13.2768 4.73126 13.8743 4.67084 14.5479Z"
      fill="url(#paint2_linear_275_27974)"
    />
    <path
      d="M15.1536 20.4993L12.6371 18.3423L11.1542 17.7491C10.8508 17.6278 10.5144 17.8253 10.4726 18.1494L8.92562 30.1385C8.90328 30.3116 8.97285 30.4838 9.10916 30.5929L10.8346 31.9732C10.9232 32.0442 11.0334 32.0828 11.1469 32.0828H31.753C32.0105 32.0828 32.2258 31.8873 32.2507 31.631L33.423 19.5168C33.4429 19.3109 33.334 19.114 33.1489 19.0214L32.036 18.465C31.8831 18.3886 31.7018 18.3955 31.5552 18.4835L28.0424 20.5911C27.8108 20.7301 27.5107 20.66 27.3646 20.4328L23.9357 15.099C23.8985 15.0411 23.8498 14.9915 23.7925 14.9533L21.7677 13.6035C21.5498 13.4582 21.2566 13.5058 21.0957 13.7126L15.8737 20.4266C15.6984 20.652 15.3703 20.6851 15.1536 20.4993Z"
      fill="#A9A9A9"
    />
    <path
      d="M9.66031 18.0866L8.92285 29.8861C8.90486 30.1739 9.13346 30.4173 9.42187 30.4173H30.5038C30.7613 30.4173 30.9767 30.2217 31.0015 29.9654L32.0943 18.673C32.1367 18.2351 31.6337 17.9599 31.2877 18.2317L26.8332 21.7317C26.5931 21.9203 26.2416 21.8517 26.0902 21.5866L21.7586 14.0064C21.5801 13.6941 21.1403 13.6667 20.9245 13.9545L15.4535 21.2491C15.2809 21.4792 14.9502 21.5166 14.7305 21.3308L10.4823 17.7361C10.1684 17.4705 9.68596 17.6762 9.66031 18.0866Z"
      fill="url(#paint3_linear_275_27974)"
    />
    <path
      d="M4.80931 32.4159L5.14245 33.7484L3.06055 32.0829L4.72607 13.7622L23.4632 3.76904L26.3778 5.85094L23.3686 5.47479C23.1594 5.44864 22.9473 5.48926 22.7626 5.59085L7.31845 14.0851C6.7386 14.4041 6.35404 14.9892 6.2913 15.648L4.75861 31.7412C4.73707 31.9673 4.75422 32.1955 4.80931 32.4159Z"
      fill="#B1B1B1"
    />
    <path
      d="M23.5 0L18 3L23.0809 1.61429C23.3483 1.54139 23.6338 1.58266 23.8696 1.72825L40.2195 11.8267C40.4017 11.9393 40.5429 12.1073 40.6225 12.3061L41.5 14.5L45 16V14L42 11.5L23.5 0Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.5712 0.776614C23.1183 0.486982 23.7777 0.507921 24.3053 0.831679L40.6146 10.8396C41.1727 11.1821 41.4929 11.8075 41.4445 12.4605L39.95 32.6365C39.9058 33.2324 39.5606 33.7647 39.0345 34.048L19.3614 44.6412C18.8124 44.9368 18.1478 44.918 17.6164 44.592L1.33475 34.601C1.29741 34.578 1.26114 34.5539 1.22597 34.5285L0.748049 33.9975L0.74417 34.001C0.560286 33.6903 0.473277 33.3243 0.507219 32.951L2.37859 12.3658C2.43215 11.7767 2.77976 11.2545 3.3026 10.9777L22.5712 0.776614ZM0.88786 34.9002C0.275236 34.4345 -0.0613439 33.6825 0.00927199 32.9057L1.88065 12.3206C1.94951 11.5631 2.39643 10.8916 3.06866 10.5358L22.3373 0.33472C23.0407 -0.0376644 23.8885 -0.0107428 24.5668 0.405518L40.8761 10.4135C41.1689 10.5932 41.4108 10.8334 41.5903 11.1119L44.2652 12.8952C44.9506 13.3521 45.3315 14.147 45.2583 14.9674L43.3768 36.0395C43.3101 36.7863 42.8758 37.4509 42.2186 37.8117L22.9205 48.4067C22.2217 48.7904 21.372 48.7756 20.6869 48.3678L4.44245 38.6985C4.24806 38.5828 4.07222 38.4384 3.92088 38.2703L0.88786 34.9002ZM2.41666 35.8515L4.29253 37.9358C4.41024 38.0666 4.547 38.1789 4.6982 38.2689L20.9426 47.9382C21.4755 48.2553 22.1364 48.2668 22.6799 47.9684L41.9779 37.3734C42.4891 37.0928 42.8269 36.5759 42.8788 35.995L44.7602 14.923C44.8172 14.2848 44.5209 13.6666 43.9879 13.3112L41.9129 11.9279C41.9467 12.1132 41.9574 12.3044 41.9431 12.4974L40.4486 32.6734C40.3919 33.4397 39.948 34.124 39.2715 34.4883L19.5984 45.0815C18.8927 45.4615 18.0381 45.4373 17.3549 45.0181L2.41666 35.8515ZM21.1246 14.1045C21.2325 13.9606 21.4525 13.9743 21.5417 14.1305L25.8733 21.7107C26.1004 22.1083 26.6278 22.2112 26.9878 21.9283L31.4424 18.4283C31.6153 18.2924 31.8668 18.43 31.8457 18.649L30.7528 29.9414C30.7404 30.0695 30.6328 30.1673 30.504 30.1673H9.42205C9.27784 30.1673 9.16354 30.0456 9.17254 29.9017L9.91 18.1022C9.92283 17.897 10.1641 17.7942 10.321 17.927L14.5692 21.5216C14.8987 21.8004 15.3948 21.7443 15.6537 21.3991L21.1246 14.1045ZM21.8334 13.7025C21.52 13.4122 21.0004 13.4369 20.7246 13.8045L15.6387 20.5857L12.8743 18.2162C12.8006 18.1531 12.7154 18.1048 12.6234 18.0741L10.218 17.2723L10.1865 17.367C9.8065 17.3551 9.43813 17.6367 9.41098 18.071L8.67351 29.8705C8.65245 30.2075 8.85668 30.5038 9.15301 30.6177L10.6485 32.1131C10.7892 32.2538 10.9799 32.3328 11.1788 32.3328H31.7532C32.1394 32.3328 32.4625 32.0395 32.4997 31.6551L33.6762 19.4972C33.7029 19.2219 33.5759 18.9543 33.3457 18.8009L32.3458 18.1343L32.2579 18.2661C32.0507 17.8871 31.525 17.7275 31.1335 18.0352L27.8029 20.652L24.153 14.9743C24.0906 14.8774 24.0068 14.7961 23.908 14.7368L21.9262 13.5477L21.8334 13.7025ZM11.4163 18.1988L14.8922 21.1399C15.002 21.2329 15.1674 21.2142 15.2537 21.0991L15.3381 20.9866L12.5489 18.5958C12.5244 18.5748 12.4959 18.5587 12.4653 18.5485L11.4163 18.1988ZM22.2177 14.3057L26.3074 21.4626C26.3831 21.5951 26.5589 21.6295 26.6789 21.5352L27.408 20.9623L23.7324 15.2447C23.7116 15.2124 23.6837 15.1853 23.6507 15.1655L22.2177 14.3057ZM32.34 18.7314L31.2505 29.9895C31.2133 30.374 30.8902 30.6673 30.504 30.6673H9.90976L11.0021 31.7596C11.0489 31.8065 11.1125 31.8328 11.1788 31.8328H31.7532C31.8819 31.8328 31.9896 31.735 32.002 31.6069L33.1786 19.449C33.1874 19.3573 33.1451 19.2681 33.0684 19.2169L32.34 18.7314ZM23.8933 4.59642C23.3631 4.2631 22.6951 4.23859 22.1418 4.53217L5.84255 13.1806C5.31982 13.458 4.97267 13.9807 4.9198 14.5701L3.42063 31.2828C3.36109 31.9464 3.68364 32.5863 4.25257 32.9333L17.2272 40.8446C17.7613 41.1703 18.4285 41.1861 18.9775 40.8862L35.2875 31.9736C35.8126 31.6866 36.1547 31.1513 36.1945 30.5543L37.2912 14.1038C37.334 13.4618 37.0211 12.8481 36.4764 12.5057L23.8933 4.59642ZM21.9074 4.09049C22.6188 3.71304 23.4776 3.74455 24.1594 4.1731L36.7425 12.0824C37.4428 12.5226 37.8451 13.3117 37.7901 14.137L36.6934 30.5875C36.6422 31.3552 36.2024 32.0434 35.5273 32.4123L19.2172 41.3249C18.5115 41.7106 17.6536 41.6902 16.9669 41.2715L3.99226 33.3601C3.26078 32.9141 2.84608 32.0914 2.92263 31.2381L4.4218 14.5255C4.48977 13.7677 4.93611 13.0956 5.6082 12.739L21.9074 4.09049Z"
      fill="#373D54"
    />
    <defs>
      <linearGradient
        id="paint0_linear_275_27974"
        x1="13.0538"
        y1="37.0793"
        x2="46.7805"
        y2="13.762"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9A9A9A" />
        <stop offset="0.0315245" stopColor="#AEAEAE" />
        <stop offset="0.569143" stopColor="#C1C1C1" />
        <stop offset="0.619523" stopColor="#E0E0E0" />
        <stop offset="1" stopColor="#CCCCCC" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_275_27974"
        x1="-1.10314"
        y1="24.1715"
        x2="42.2004"
        y2="21.2569"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCFCFC" />
        <stop offset="1" stopColor="#E9E9E9" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_275_27974"
        x1="5.97521"
        y1="24.588"
        x2="38.4528"
        y2="20.8406"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EAEAEA" />
        <stop offset="1" stopColor="#F6F6F6" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_275_27974"
        x1="31.7905"
        y1="21.2569"
        x2="9.30603"
        y2="19.5914"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E8E8E8" />
        <stop offset="1" stopColor="#FDFDFD" />
      </linearGradient>
    </defs>
  </svg>
);

export const Gold = (props: any) => (
  <svg {...props} width="46" height="49" viewBox="0 0 46 49" fill="none">
    <path
      d="M23.2169 0.162459L2.70967 11.2363C2.66702 11.2594 2.62795 11.2885 2.59369 11.3227L2.35577 11.5607C2.27369 11.6427 2.22272 11.7508 2.21162 11.8664L0.159745 33.2058C0.150761 33.2993 0.168258 33.3933 0.210235 33.4773L0.53228 34.1214C0.552373 34.1616 0.577791 34.1989 0.607847 34.2322L4.25911 38.2892C4.29389 38.3279 4.3345 38.3608 4.37945 38.387L21.9771 48.6181C22.1299 48.707 22.3184 48.7085 22.4727 48.6222L42.8229 37.226C42.9662 37.1458 43.061 37.0002 43.0764 36.8367L45.1247 15.1251C45.1312 15.0559 45.1232 14.986 45.1012 14.9201L44.7674 13.9186C44.7352 13.8221 44.6744 13.7377 44.5931 13.6767L41.3855 11.2711L23.7203 0.178966C23.5677 0.0831555 23.3754 0.0768494 23.2169 0.162459Z"
      fill="url(#paint0_linear_275_27993)"
    />
    <path
      d="M2.13067 12.3505L0.258396 32.9455C0.189555 33.7028 0.556068 34.4336 1.20415 34.8312L17.4938 44.8271C18.101 45.1998 18.8607 45.2212 19.488 44.8834L39.1705 34.2852C39.7719 33.9614 40.1664 33.3531 40.2168 32.672L41.7121 12.4862C41.7674 11.7399 41.4014 11.0252 40.7636 10.6338L24.4464 0.62096C23.8434 0.250951 23.0898 0.227021 22.4645 0.558029L3.18669 10.764C2.58915 11.0803 2.19189 11.6771 2.13067 12.3505Z"
      fill="url(#paint1_linear_275_27993)"
    />
    <path
      d="M4.67305 14.556L3.17313 31.2769C3.10509 32.0354 3.47372 32.7667 4.12392 33.1632L17.1051 41.0785C17.7155 41.4507 18.478 41.4688 19.1054 41.126L35.4234 32.209C36.0235 31.8811 36.4144 31.2693 36.4599 30.587L37.5572 14.1283C37.6061 13.3947 37.2485 12.6933 36.6259 12.302L24.0366 4.38872C23.4305 4.00779 22.6671 3.97978 22.0348 4.31529L5.72763 12.968C5.13022 13.285 4.73347 13.8824 4.67305 14.556Z"
      fill="url(#paint2_linear_275_27993)"
    />
    <path
      d="M15.1604 20.5105L12.6426 18.3524L11.1588 17.7589C10.8554 17.6375 10.5191 17.8351 10.4772 18.1592L8.92953 30.1539C8.90719 30.327 8.97676 30.4993 9.11307 30.6083L10.8394 31.9894C10.9281 32.0603 11.0382 32.0989 11.1517 32.0989H31.7733C32.0281 32.0989 32.2422 31.9073 32.2703 31.654L33.7321 18.4626C33.7527 18.2768 33.6679 18.0951 33.5125 17.9915L32.7573 17.488C32.608 17.3885 32.4169 17.3766 32.2564 17.4568L30.9022 18.1339C30.8673 18.1514 30.8345 18.1729 30.8046 18.198L28.0668 20.493C27.8385 20.6844 27.4944 20.6348 27.3294 20.3868L24.3453 15.9022C24.2459 15.7529 24.2341 15.5619 24.3143 15.4016L25.2732 13.4838C25.3694 13.2913 25.3317 13.0588 25.1795 12.9066L23.8407 11.5678C23.7928 11.5199 23.7357 11.4823 23.6728 11.4571L22.2963 10.9065C21.9893 10.7837 21.6497 10.9875 21.6136 11.3163L21.4058 13.2129C21.3957 13.305 21.3603 13.3924 21.3035 13.4655L15.8805 20.4379C15.7052 20.6632 15.3771 20.6963 15.1604 20.5105Z"
      fill="#FAA931"
    />
    <path
      d="M9.56374 18.088L8.92217 29.9056C8.90662 30.192 9.13464 30.4327 9.42144 30.4327H30.5172C30.7747 30.4327 30.9901 30.237 31.0149 29.9807L32.2579 17.0867L30.9268 17.7077C30.8757 17.7315 30.8291 17.7638 30.7888 17.8031L26.8543 21.647C26.6194 21.8765 26.2309 21.8211 26.0694 21.5352L22.6491 15.4758C22.5674 15.3311 22.563 15.1551 22.6374 15.0064L23.607 13.0672C23.7032 12.8748 23.6655 12.6423 23.5133 12.4901L22.0082 10.985C21.8253 10.8021 21.5332 10.7889 21.3345 10.9544L19.4242 12.5464C19.2783 12.668 19.2138 12.8618 19.2579 13.0466L19.7738 15.2082C19.8083 15.3528 19.7767 15.5053 19.6875 15.6243L18.2662 17.5193L15.472 21.2449C15.295 21.4808 14.9534 21.5132 14.7353 21.3146L11.3224 18.2068C11.2885 18.1759 11.2505 18.1498 11.2094 18.1293L10.2866 17.6679C9.96468 17.5069 9.58325 17.7286 9.56374 18.088Z"
      fill="url(#paint3_linear_275_27993)"
    />
    <path
      d="M4.8115 32.4321L5.14482 33.7653L3.06201 32.0991L4.72826 13.7704L23.4735 3.77295L26.3894 5.85575L23.3787 5.47942C23.1696 5.45327 22.9575 5.49389 22.7728 5.59548L7.32136 14.0938C6.74151 14.4127 6.35695 14.9978 6.29421 15.6566L4.7608 31.7574C4.73926 31.9835 4.75641 32.2117 4.8115 32.4321Z"
      fill="#FDAC28"
    />
    <path
      d="M23.5 0L18 3L23.0809 1.61429C23.3483 1.54139 23.6338 1.58266 23.8696 1.72825L40.2195 11.8267C40.4017 11.9393 40.5429 12.1073 40.6225 12.3061L41.5 14.5L45 16V14L42 11.5L23.5 0Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.5814 0.779056C23.1285 0.489423 23.7878 0.510362 24.3155 0.83412L40.6327 10.847C41.1908 11.1894 41.511 11.8148 41.4626 12.4678L39.9674 32.6536C39.9232 33.2496 39.578 33.7818 39.0518 34.0651L19.3693 44.6634C18.8204 44.959 18.1557 44.9402 17.6244 44.6141L1.33475 34.6182C1.29759 34.5954 1.26149 34.5714 1.22649 34.5462L0.74823 34.0148L0.744233 34.0184C0.560306 33.7077 0.473273 33.3416 0.507219 32.9682L2.3795 12.3732C2.43306 11.784 2.78066 11.2618 3.30351 10.985L22.5814 0.779056ZM0.888443 34.918C0.27545 34.4522 -0.0613663 33.7 0.00927199 32.923L1.88155 12.3279C1.95041 11.5704 2.39733 10.899 3.06956 10.5431L22.3474 0.337162C23.0508 -0.0352229 23.8986 -0.0083016 24.577 0.407959L40.8942 10.4208C41.1871 10.6005 41.429 10.8409 41.6086 11.1195L44.2848 12.9036C44.9701 13.3605 45.3511 14.1554 45.2778 14.9758L43.3955 36.0581C43.3288 36.8049 42.8945 37.4694 42.2372 37.8303L22.93 48.4303C22.2311 48.814 21.3814 48.7992 20.6963 48.3914L4.44426 38.7176C4.24987 38.6019 4.07403 38.4575 3.92269 38.2894L0.888443 34.918ZM2.41707 35.869L4.29434 37.9549C4.41205 38.0857 4.54881 38.198 4.70001 38.288L20.952 47.9618C21.4849 48.2789 22.1458 48.2905 22.6893 47.992L41.9966 37.392C42.5078 37.1113 42.8456 36.5944 42.8974 36.0136L44.7798 14.9314C44.8368 14.2933 44.5405 13.675 44.0074 13.3197L41.9311 11.9354C41.9648 12.1206 41.9755 12.3118 41.9613 12.5047L40.466 32.6905C40.4093 33.4568 39.9654 34.1411 39.2889 34.5054L19.6064 45.1036C18.9006 45.4836 18.046 45.4595 17.3629 45.0403L2.41707 35.869ZM21.3371 10.5467L23.7112 11.2195C23.8344 11.2544 23.9466 11.3202 24.0371 11.4107L25.3565 12.7301C25.5848 12.9584 25.6413 13.3071 25.497 13.5959L24.5381 15.5136C24.498 15.5938 24.5039 15.6893 24.5536 15.7639L27.7071 20.5033L30.7991 17.5628L30.8063 17.5559L30.8141 17.5496L31.4135 17.0647C31.8038 16.7489 32.334 16.9062 32.5442 17.2851L32.6547 17.1193L33.6513 17.7837C33.8845 17.9392 34.0116 18.2118 33.9807 18.4904L32.5188 31.682C32.4767 32.0619 32.1556 32.3493 31.7734 32.3493H11.1835C10.9846 32.3493 10.7939 32.2703 10.6532 32.1297L9.15687 30.6333C8.8605 30.5195 8.65625 30.2232 8.67731 29.8862L9.41514 18.0809C9.45298 17.4755 10.1536 17.167 10.6246 17.536L12.6017 18.0821C12.7079 18.1115 12.8064 18.1639 12.8901 18.2356L15.6495 20.6009L19.6609 15.3037C19.7107 15.2379 19.7248 15.1519 19.6988 15.0737L19.0467 13.1174C18.9568 12.8479 19.027 12.5508 19.2279 12.3499L20.7693 10.8085C20.9214 10.6563 21.124 10.5825 21.325 10.5892L21.3371 10.5467ZM15.3471 21.0002L12.5647 18.6152C12.5368 18.5913 12.504 18.5739 12.4686 18.5641L11.5361 18.3065L12.5959 19.2032L14.9006 21.1534C15.0101 21.246 15.1748 21.2278 15.2614 21.1135L15.3471 21.0002ZM10.3737 17.9779L10.3718 17.9849L10.3869 17.9891L10.9191 18.4394L12.2729 19.5849L14.5776 21.5351C14.906 21.8129 15.4003 21.7582 15.66 21.4153L20.0595 15.6055C20.2088 15.4083 20.2513 15.1502 20.1731 14.9156L19.521 12.9593C19.4911 12.8695 19.5144 12.7704 19.5814 12.7035L21.1228 11.162C21.2143 11.0706 21.3603 11.064 21.4597 11.1467L23.304 12.6837C23.3931 12.758 23.4195 12.8838 23.3676 12.9876L22.4139 14.8949C22.3024 15.118 22.309 15.3818 22.4316 15.599L25.8562 21.6661C26.0963 22.0914 26.6723 22.1775 27.0262 21.8409L31.1364 17.932L31.7279 17.4534C31.9016 17.3129 32.1583 17.4533 32.1337 17.6753L30.7722 29.9605C30.7582 30.0871 30.6511 30.183 30.5237 30.183H9.42585C9.28165 30.183 9.16734 30.0613 9.17634 29.9174L9.91417 18.1121C9.92699 17.9069 10.1682 17.804 10.3252 17.9368L10.3737 17.9779ZM22.5602 11.413L23.6241 12.2996C23.8915 12.5224 23.9704 12.8999 23.8148 13.2112L22.8611 15.1185C22.824 15.1929 22.8262 15.2808 22.867 15.3532L26.2916 21.4203C26.3717 21.5621 26.5637 21.5908 26.6816 21.4786L27.3393 20.8531L24.1373 16.0409C23.9883 15.8171 23.9706 15.5306 24.0909 15.29L25.0498 13.3723C25.0979 13.276 25.079 13.1598 25.0029 13.0837L23.6835 11.7643C23.6534 11.7341 23.616 11.7122 23.5749 11.7005L22.5602 11.413ZM9.91359 30.683L11.0068 31.7761C11.0536 31.823 11.1172 31.8493 11.1835 31.8493H31.7734C31.9008 31.8493 32.0078 31.7535 32.0219 31.6269L33.4838 18.4353C33.4941 18.3424 33.4517 18.2516 33.374 18.1997L32.633 17.7057L32.6322 17.7148L32.6306 17.7304L31.2691 30.0156C31.227 30.3955 30.906 30.683 30.5237 30.683H9.91359ZM23.9033 4.60049C23.373 4.26717 22.705 4.24266 22.1518 4.53624L5.84456 13.1889C5.32183 13.4663 4.97468 13.989 4.92181 14.5784L3.42189 31.2993C3.36236 31.963 3.68491 32.6029 4.25383 32.9498L17.235 40.8652C17.7691 41.1908 18.4363 41.2067 18.9852 40.9067L35.3033 31.9898C35.8284 31.7028 36.1704 31.1675 36.2102 30.5705L37.3075 14.1118C37.3503 13.4699 37.0374 12.8562 36.4927 12.5138L23.9033 4.60049ZM21.9174 4.09456C22.6287 3.71711 23.4876 3.74862 24.1694 4.17717L36.7587 12.0905C37.4591 12.5307 37.8614 13.3197 37.8064 14.1451L36.7091 30.6037C36.658 31.3714 36.2181 32.0596 35.543 32.4285L19.225 41.3455C18.5193 41.7311 17.6614 41.7108 16.9747 41.2921L3.99353 33.3767C3.26205 32.9307 2.84735 32.108 2.92389 31.2546L4.42381 14.5338C4.49178 13.776 4.93812 13.1039 5.61021 12.7472L21.9174 4.09456Z"
      fill="#A06000"
    />
    <path
      d="M22.31 23.637C22.2886 24.704 21.59 25.4557 20.8572 25.441C20.1244 25.4263 19.4566 24.647 19.4781 23.5801C19.4995 22.5131 20.1981 21.7614 20.9309 21.7761C21.6637 21.7909 22.3315 22.5701 22.31 23.637Z"
      fill="#FEAC2D"
      stroke="#A06000"
      strokeWidth="0.5"
    />
    <circle cx="21.2691" cy="22.7427" r="0.416561" fill="white" />
    <defs>
      <linearGradient
        id="paint0_linear_275_27993"
        x1="13.0594"
        y1="37.0979"
        x2="46.8008"
        y2="13.7704"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9B12E" />
        <stop offset="0.0315245" stopColor="#FFAE2A" />
        <stop offset="0.569143" stopColor="#FDAB2D" />
        <stop offset="0.619523" stopColor="#FDD05B" />
        <stop offset="1" stopColor="#FEC75C" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_275_27993"
        x1="-1.10369"
        y1="24.1845"
        x2="42.2187"
        y2="21.2685"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEFFBB" />
        <stop offset="1" stopColor="#FDEC78" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_275_27993"
        x1="5.97794"
        y1="24.601"
        x2="38.4697"
        y2="20.852"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDDA5B" />
        <stop offset="1" stopColor="#FFE586" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_275_27993"
        x1="31.8044"
        y1="21.2683"
        x2="9.31011"
        y2="19.6021"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8EB7A" />
        <stop offset="1" stopColor="#FFFFB8" />
      </linearGradient>
    </defs>
  </svg>
);

export const Platinum = (props: any) => (
  <svg {...props} width="46" height="49" viewBox="0 0 46 49" fill="none">
    <path
      d="M23.2169 0.162459L2.70967 11.2363C2.66702 11.2594 2.62795 11.2885 2.59369 11.3227L2.35577 11.5607C2.27369 11.6427 2.22272 11.7508 2.21161 11.8664L0.159745 33.2058C0.150761 33.2992 0.168258 33.3933 0.210235 33.4773L0.53228 34.1214C0.552373 34.1616 0.577791 34.1988 0.607847 34.2322L4.25911 38.2892C4.29389 38.3278 4.33449 38.3608 4.37945 38.387L21.9771 48.6181C22.1299 48.707 22.3184 48.7085 22.4727 48.6221L42.8229 37.226C42.9662 37.1458 43.061 37.0002 43.0764 36.8367L45.1247 15.1251C45.1312 15.0559 45.1232 14.986 45.1012 14.9201L44.7674 13.9186C44.7352 13.8221 44.6744 13.7377 44.5931 13.6767L41.3855 11.2711L23.7203 0.178966C23.5677 0.0831555 23.3754 0.0768494 23.2169 0.162459Z"
      fill="url(#paint0_linear_275_28012)"
    />
    <path
      d="M2.13067 12.3505L0.258396 32.9455C0.189555 33.7028 0.556067 34.4336 1.20415 34.8312L17.4938 44.8271C18.101 45.1998 18.8607 45.2212 19.488 44.8834L39.1705 34.2852C39.7718 33.9614 40.1664 33.3531 40.2168 32.672L41.7121 12.4862C41.7674 11.7399 41.4014 11.0252 40.7636 10.6338L24.4464 0.62096C23.8434 0.250951 23.0898 0.227021 22.4645 0.558029L3.18669 10.764C2.58915 11.0803 2.19189 11.6771 2.13067 12.3505Z"
      fill="url(#paint1_linear_275_28012)"
    />
    <path
      d="M4.67305 14.556L3.17313 31.2769C3.10509 32.0354 3.47372 32.7667 4.12392 33.1632L17.1051 41.0785C17.7155 41.4507 18.478 41.4688 19.1054 41.126L35.4234 32.209C36.0235 31.8811 36.4144 31.2693 36.4599 30.587L37.5572 14.1283C37.6061 13.3947 37.2485 12.6933 36.6259 12.302L24.0366 4.38872C23.4305 4.00779 22.6671 3.97978 22.0348 4.31529L5.72763 12.968C5.13022 13.285 4.73347 13.8824 4.67305 14.556Z"
      fill="url(#paint2_linear_275_28012)"
    />
    <path
      d="M15.4809 20.0236L12.6426 18.3524L13.3541 16.9105L12.6039 15.7852C12.5498 15.7041 12.4731 15.6405 12.3834 15.6024L11.2553 15.1232C10.9255 14.9831 10.5598 15.2251 10.5598 15.5834V17.5193L8.92953 30.1539C8.90719 30.327 8.97676 30.4992 9.11307 30.6083L10.8394 31.9894C10.9281 32.0603 11.0382 32.0989 11.1517 32.0989H31.7657C32.0238 32.0989 32.2394 31.9026 32.2636 31.6457L33.7376 15.9581C33.7549 15.775 33.6702 15.5972 33.5172 15.4953L32.9872 15.1419C32.7369 14.9751 32.3971 15.0653 32.2626 15.3343L30.8961 18.0673C30.8655 18.1286 30.8226 18.1829 30.7701 18.2269L28.0668 20.493C27.8385 20.6844 27.4944 20.6348 27.3294 20.3868L24.3453 15.9022C24.2459 15.7529 24.2341 15.5619 24.3143 15.4016L25.2732 13.4838C25.3694 13.2913 25.3317 13.0588 25.1795 12.9066L23.8407 11.5678C23.7928 11.5199 23.7357 11.4823 23.6728 11.4571L22.2963 10.9065C21.9893 10.7837 21.6497 10.9875 21.6136 11.3163L21.4063 13.2086C21.3959 13.3034 21.3587 13.3931 21.299 13.4674L16.1243 19.906C15.9688 20.0995 15.6948 20.1496 15.4809 20.0236Z"
      fill="#335BFF"
    />
    <path
      d="M9.72668 17.1027L8.92675 29.9015C8.90876 30.1893 9.13737 30.4327 9.42578 30.4327H30.5172C30.7747 30.4327 30.9901 30.237 31.0149 29.9807L32.5159 14.4112H32.2378C32.1472 14.4112 32.0583 14.4358 31.9806 14.4824L30.3817 15.4418C30.1712 15.568 30.0835 15.8283 30.1747 16.0562L30.7201 17.4197C30.7979 17.6143 30.7461 17.8368 30.5903 17.977L27.1138 21.1059C26.8872 21.3098 26.5324 21.2653 26.3633 21.0116L22.6794 15.4857C22.5799 15.3364 22.568 15.1452 22.6482 14.9848L23.6069 13.0672C23.7032 12.8748 23.6655 12.6423 23.5133 12.4901L22.0082 10.985C21.8253 10.8021 21.5332 10.7889 21.3345 10.9544L19.4242 12.5464C19.2783 12.668 19.2138 12.8618 19.2579 13.0466L19.7738 15.2082C19.8083 15.3528 19.7767 15.5053 19.6875 15.6243L18.2662 17.5193L15.7297 20.7081C15.5652 20.9149 15.2681 20.958 15.0516 20.8064L11.596 18.3875C11.4058 18.2544 11.3323 18.0078 11.4185 17.7922L11.982 16.3835C12.0562 16.1978 12.0127 15.9857 11.8713 15.8443L10.9121 14.8851C10.8741 14.8471 10.8302 14.8155 10.7822 14.7914L10.0216 14.4112L9.72668 17.1027Z"
      fill="url(#paint3_linear_275_28012)"
    />
    <path
      d="M4.8115 32.4321L5.14482 33.7653L3.06201 32.0991L4.72826 13.7704L23.4735 3.77295L26.3894 5.85575L23.3787 5.47942C23.1696 5.45327 22.9575 5.49389 22.7728 5.59548L7.32136 14.0938C6.74151 14.4127 6.35695 14.9978 6.29421 15.6566L4.7608 31.7574C4.73926 31.9835 4.75641 32.2117 4.8115 32.4321Z"
      fill="#3353FF"
    />
    <path
      d="M23.5 0L18 3L23.0809 1.61429C23.3483 1.54139 23.6338 1.58266 23.8696 1.72825L40.2195 11.8267C40.4017 11.9393 40.5429 12.1073 40.6225 12.3061L41.5 14.5L45 16V14L42 11.5L23.5 0Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.5814 0.779056C23.1284 0.489423 23.7878 0.510362 24.3154 0.83412L40.6327 10.847C41.1908 11.1894 41.511 11.8148 41.4626 12.4678L39.9674 32.6536C39.9232 33.2495 39.578 33.7818 39.0518 34.0651L19.3693 44.6634C18.8204 44.959 18.1557 44.9402 17.6244 44.6141L1.33475 34.6182C1.29759 34.5954 1.26149 34.5714 1.22649 34.5462L0.74823 34.0148L0.744233 34.0184C0.560306 33.7077 0.473273 33.3416 0.507219 32.9682L2.3795 12.3732C2.43306 11.784 2.78066 11.2618 3.30351 10.985L22.5814 0.779056ZM0.888425 34.918C0.275443 34.4522 -0.0613656 33.7 0.00927199 32.923L1.88155 12.3279C1.95041 11.5704 2.39733 10.899 3.06956 10.5431L22.3474 0.337162C23.0508 -0.035223 23.8986 -0.00830153 24.577 0.407959L40.8942 10.4208C41.1871 10.6005 41.429 10.8409 41.6085 11.1195L44.2848 12.9036C44.9701 13.3605 45.3511 14.1554 45.2778 14.9758L43.3955 36.058C43.3288 36.8049 42.8945 37.4694 42.2372 37.8303L22.93 48.4303C22.2311 48.814 21.3814 48.7992 20.6963 48.3914L4.44426 38.7176C4.24987 38.6019 4.07403 38.4575 3.92269 38.2894L0.888425 34.918ZM2.41706 35.869L4.29434 37.9549C4.41205 38.0857 4.54881 38.198 4.70001 38.288L20.952 47.9618C21.4849 48.2789 22.1458 48.2905 22.6893 47.992L41.9966 37.392C42.5078 37.1113 42.8456 36.5944 42.8974 36.0136L44.7798 14.9314C44.8368 14.2933 44.5405 13.675 44.0074 13.3197L41.9311 11.9354C41.9648 12.1206 41.9755 12.3118 41.9612 12.5047L40.466 32.6905C40.4092 33.4568 39.9654 34.1411 39.2889 34.5054L19.6064 45.1036C18.9006 45.4836 18.046 45.4595 17.3629 45.0403L2.41706 35.869ZM21.3371 10.5467L23.7112 11.2195C23.8344 11.2544 23.9466 11.3202 24.0371 11.4107L25.3565 12.7301C25.5848 12.9584 25.6413 13.3071 25.497 13.5959L24.5381 15.5136C24.498 15.5938 24.5039 15.6893 24.5536 15.7639L27.6074 20.3535L30.526 17.8013C30.6092 17.7285 30.6347 17.6095 30.5886 17.5089L29.9672 16.153C29.8136 15.818 29.9262 15.4209 30.2329 15.2165L31.504 14.3691C31.9154 14.0948 32.4318 14.2904 32.608 14.69L32.6547 14.62L33.656 15.2875C33.8855 15.4405 34.0125 15.7071 33.9867 15.9817L32.5125 31.6695C32.4763 32.0548 32.1529 32.3493 31.7658 32.3493H11.1835C10.9846 32.3493 10.7939 32.2703 10.6532 32.1296L9.15695 30.6334C8.86054 30.5195 8.65625 30.2232 8.67731 29.8862L9.47723 17.0874L9.47774 17.0794L9.47787 17.0794L9.67254 15.0285C9.71545 14.5764 10.1212 14.3063 10.513 14.3537L10.5552 14.2738L12.6309 15.372C12.757 15.4387 12.8614 15.5399 12.9319 15.6638L13.4402 16.5564C13.5634 16.7727 13.5712 17.0361 13.461 17.2594L13.0724 18.0469C13.0144 18.1643 13.0569 18.3065 13.1697 18.3729L15.9548 20.0128L19.6564 15.3018C19.7083 15.2357 19.7235 15.148 19.6969 15.0682L19.0467 13.1174C18.9568 12.8479 19.027 12.5508 19.2278 12.3499L20.7693 10.8085C20.9214 10.6563 21.124 10.5825 21.325 10.5892L21.3371 10.5467ZM15.6431 20.4095L12.916 18.8038C12.5776 18.6045 12.4502 18.1779 12.624 17.8256L13.0126 17.0381C13.0493 16.9637 13.0467 16.8759 13.0057 16.8038L12.4974 15.9112C12.4739 15.8699 12.4391 15.8362 12.3971 15.8139L11.9667 15.5862L12.0326 15.6522C12.2564 15.876 12.3157 16.2162 12.1806 16.5025L11.493 17.9603C11.4396 18.0734 11.4781 18.2085 11.583 18.2766L15.19 20.618C15.2985 20.6884 15.4428 20.6645 15.5227 20.5627L15.6431 20.4095ZM22.5602 11.413L23.6241 12.2996C23.8915 12.5224 23.9704 12.8999 23.8148 13.2112L22.872 15.0968C22.8319 15.1771 22.8378 15.2727 22.8876 15.3473L26.5761 20.8801C26.6598 21.0057 26.835 21.029 26.9487 20.9296L27.2278 20.6855L24.1373 16.0409C23.9883 15.817 23.9706 15.5306 24.0909 15.29L25.0498 13.3723C25.0979 13.276 25.079 13.1598 25.0029 13.0837L23.6835 11.7643C23.6534 11.7341 23.616 11.7122 23.5749 11.7005L22.5602 11.413ZM9.91364 30.683L11.0068 31.7761C11.0536 31.823 11.1172 31.8493 11.1835 31.8493H31.7658C31.8948 31.8493 32.0027 31.7511 32.0147 31.6227L33.4889 15.9349C33.4975 15.8434 33.4552 15.7545 33.3787 15.7035L32.6521 15.2191L31.2628 30.0031C31.2266 30.3885 30.9032 30.683 30.5161 30.683H9.91364ZM21.1228 11.162C21.2143 11.0706 21.3603 11.064 21.4596 11.1467L23.304 12.6837C23.3931 12.758 23.4195 12.8838 23.3676 12.9876L22.4248 14.8732C22.3044 15.1139 22.3223 15.4007 22.4715 15.6247L26.1601 21.1574C26.4113 21.5343 26.9368 21.6042 27.2778 21.306L30.8551 18.1777C31.105 17.9592 31.1815 17.6024 31.0432 17.3006L30.4217 15.9447C30.3705 15.833 30.4081 15.7007 30.5103 15.6325L31.7814 14.7851C31.9565 14.6684 32.1886 14.807 32.169 15.0165L30.765 29.9563C30.753 30.0848 30.6451 30.183 30.5161 30.183H9.42585C9.28164 30.183 9.16734 30.0613 9.17634 29.9174L9.97601 17.1226L10.1703 15.0758C10.1903 14.8652 10.4464 14.7731 10.596 14.9226L11.6791 16.0057C11.7537 16.0803 11.7734 16.1937 11.7284 16.2892L11.0408 17.7469C10.8807 18.0863 10.996 18.4917 11.3107 18.696L14.9178 21.0374C15.2433 21.2486 15.6761 21.1768 15.9159 20.8717L20.0495 15.6107C20.2052 15.4125 20.251 15.1493 20.1713 14.9101L19.521 12.9593C19.4911 12.8694 19.5144 12.7704 19.5814 12.7034L21.1228 11.162ZM23.9033 4.60049C23.373 4.26717 22.705 4.24266 22.1517 4.53624L5.84456 13.1889C5.32183 13.4663 4.97468 13.989 4.92181 14.5784L3.42189 31.2993C3.36236 31.963 3.68491 32.6029 4.25383 32.9498L17.235 40.8652C17.7691 41.1908 18.4363 41.2066 18.9852 40.9067L35.3033 31.9897C35.8284 31.7028 36.1704 31.1675 36.2102 30.5705L37.3075 14.1118C37.3503 13.4699 37.0374 12.8562 36.4927 12.5138L23.9033 4.60049ZM21.9174 4.09456C22.6287 3.71711 23.4876 3.74862 24.1694 4.17717L36.7587 12.0905C37.4591 12.5307 37.8614 13.3197 37.8064 14.1451L36.7091 30.6037C36.658 31.3714 36.2181 32.0596 35.543 32.4285L19.225 41.3455C18.5193 41.7311 17.6614 41.7108 16.9747 41.2921L3.99353 33.3767C3.26205 32.9307 2.84735 32.108 2.92389 31.2546L4.42381 14.5338C4.49178 13.776 4.93812 13.1039 5.61021 12.7472L21.9174 4.09456Z"
      fill="#001376"
    />
    <path
      d="M24.5061 22.5699L23.5318 20.7432C23.4852 20.6558 23.5796 20.5606 23.6674 20.6066L24.4009 20.9665L25.4236 23.3528L20.8216 28.4662L20.1398 28.4661L24.4188 23.3947C24.6139 23.1635 24.6484 22.8368 24.5061 22.5699Z"
      fill="url(#paint4_linear_275_28012)"
    />
    <path
      d="M19.7988 28.4662L21.8441 23.012L24.7417 23.012L19.9692 28.6367L19.7988 28.4662Z"
      fill="#A8CAFF"
    />
    <path
      d="M19.7988 28.4565L18.0944 22.8418L16.2195 22.8418L19.6284 28.4564L19.7988 28.4565Z"
      fill="#91BBFF"
    />
    <path
      d="M19.799 28.466L21.8443 23.0118L18.0945 22.8413L19.6285 28.1251L19.799 28.466Z"
      fill="white"
    />
    <path
      d="M20.3101 20.4557L21.8441 23.0123L18.0944 22.8419L19.7988 20.967L20.3101 20.4557Z"
      fill="#E2EEFF"
    />
    <path
      d="M23.2076 20.285L24.5712 23.0122L21.8441 23.0122L22.8668 21.1373L23.2076 20.285Z"
      fill="#BCCFFF"
    />
    <path
      d="M17.4127 20.4553L16.2196 22.8415L18.0945 22.8416L17.5831 20.4553L17.4127 20.4553Z"
      fill="#BCCFFF"
    />
    <path
      d="M18.2651 22.6712L20.3104 20.2849L17.5833 20.2849L18.0946 22.6712L18.2651 22.6712Z"
      fill="white"
    />
    <path
      d="M21.8444 23.0121L20.3109 20.4022L23.1572 20.4022L22.0148 22.6712L21.8444 23.0121Z"
      fill="#DFF2FF"
    />
    <path
      d="M24.6058 23.0617C24.5987 23.1273 24.5716 23.1891 24.5282 23.239L20.0866 28.4789C20.0545 28.5159 20.0143 28.5449 19.9691 28.5639C19.9239 28.5829 19.875 28.5913 19.826 28.5885C19.777 28.5856 19.7293 28.5716 19.6866 28.5475C19.6439 28.5234 19.6073 28.4899 19.5798 28.4495L16.2541 23.0616C16.2167 23.007 16.197 22.9425 16.1975 22.8765M24.6058 23.0617C24.613 22.9962 24.5999 22.93 24.5684 22.872L23.4127 20.505C23.3868 20.4572 23.3489 20.4167 23.3028 20.3874C23.2566 20.3581 23.2038 20.3411 23.1492 20.3379L17.7283 20.3695C17.6737 20.3664 17.6192 20.3772 17.57 20.4009C17.5208 20.4247 17.4785 20.4605 17.4472 20.5051L16.2567 22.6924C16.2186 22.7463 16.1979 22.8106 16.1975 22.8765M24.6058 23.0617L16.1975 22.8765"
      stroke="#001376"
      strokeWidth="0.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.2079 20.4552L21.8443 23.0118M21.8443 23.0118L20.2997 20.4202L18.0945 22.8414M21.8443 23.0118L19.799 28.4661L18.0945 22.8414M17.5832 20.4552L18.0945 22.8414"
      stroke="#001376"
      strokeWidth="0.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.7988 28.5683L20.629 28.4852C20.7529 28.4729 20.8676 28.4147 20.9509 28.3222L25.2097 23.5903C25.34 23.4454 25.3744 23.238 25.2976 23.0588L24.473 21.1348C24.4264 21.0261 24.3428 20.9374 24.237 20.8845L23.3782 20.4551"
      stroke="#001376"
      strokeWidth="0.3"
    />
    <defs>
      <linearGradient
        id="paint0_linear_275_28012"
        x1="13.0594"
        y1="37.0978"
        x2="46.8008"
        y2="13.7704"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3246FE" />
        <stop offset="0.0315245" stopColor="#3246FE" />
        <stop offset="0.569143" stopColor="#325FFE" />
        <stop offset="0.619523" stopColor="#778DFF" />
        <stop offset="1" stopColor="#7795FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_275_28012"
        x1="-1.10369"
        y1="24.1845"
        x2="42.2186"
        y2="21.2685"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DFEEFF" />
        <stop offset="1" stopColor="#BCCBFF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_275_28012"
        x1="5.97794"
        y1="24.601"
        x2="38.4697"
        y2="20.8519"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7896FF" />
        <stop offset="1" stopColor="#ACC3FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_275_28012"
        x1="31.8044"
        y1="21.2683"
        x2="9.31011"
        y2="19.6021"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BCCFFF" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_275_28012"
        x1="24.2305"
        y1="23.0119"
        x2="24.9123"
        y2="20.6257"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3253FE" />
        <stop offset="0.0185376" stopColor="#77A2FF" />
        <stop offset="0.9999" stopColor="#77A2FF" />
        <stop offset="1" stopColor="#77A2FF" />
      </linearGradient>
    </defs>
  </svg>
);

export const SilverWithBg = (props: any) => (
  <svg {...props} width="78" height="82" viewBox="0 0 78 82" fill="none">
    <g clipPath="url(#clip0_267_27663)">
      <rect
        width="78"
        height="82"
        rx="8"
        fill="url(#paint0_linear_267_27663)"
      />
      <path
        d="M35.875 43.5L8.875 90L-8.625 80.5L-5.125 58L35.875 43.5Z"
        fill="url(#paint1_linear_267_27663)"
      />
      <path
        d="M38.8751 49.7609L92.1134 42.2159L85.4176 62.2205L38.8751 49.7609Z"
        fill="url(#paint2_linear_267_27663)"
      />
      <path
        d="M42.1469 49.3157L79.0705 88.404L58.8751 94.5L42.1469 49.3157Z"
        fill="url(#paint3_linear_267_27663)"
      />
      <path
        d="M37.8753 40.9999L-3.62483 24L-3.62482 3.00045L1.37532 3.00043L37.8753 40.9999Z"
        fill="url(#paint4_linear_267_27663)"
      />
      <path
        d="M44.875 34.5L71.875 -12L84.375 0L85.875 14L44.875 34.5Z"
        fill="url(#paint5_linear_267_27663)"
      />
      <path
        d="M37.5584 35.1757L22 -3.5001L44 -3.5L42.0882 34.2205L37.5584 35.1757Z"
        fill="url(#paint6_linear_267_27663)"
      />
      <path
        d="M37.8895 11.3692L13.2103 24.696C13.1677 24.719 13.1286 24.7481 13.0943 24.7824L12.773 25.1037C12.6909 25.1858 12.6399 25.2939 12.6288 25.4094L10.1597 51.0877C10.1508 51.1812 10.1683 51.2752 10.2102 51.3592L10.6157 52.1702C10.6358 52.2103 10.6612 52.2476 10.6913 52.281L15.0935 57.1724C15.1283 57.211 15.1689 57.244 15.2138 57.2702L36.3993 69.5873C36.5522 69.6762 36.7407 69.6777 36.8949 69.5913L61.4171 55.8589C61.5605 55.7786 61.6552 55.6331 61.6706 55.4696L64.1361 29.3357C64.1426 29.2665 64.1346 29.1966 64.1126 29.1306L63.6954 27.8789C63.6632 27.7824 63.6024 27.698 63.521 27.637L59.646 24.7307L38.3929 11.3858C38.2403 11.2899 38.048 11.2836 37.8895 11.3692Z"
        fill="url(#paint7_linear_267_27663)"
      />
      <path
        d="M12.5479 25.8101L10.2584 50.9943C10.1896 51.7516 10.5561 52.4823 11.2041 52.88L31.1651 65.1288C31.7723 65.5014 32.532 65.5229 33.1593 65.1851L57.1807 52.2505C57.782 51.9267 58.1765 51.3184 58.227 50.6373L60.056 25.9458C60.1113 25.1995 59.7453 24.4848 59.1075 24.0934L39.1189 11.8277C38.516 11.4577 37.7624 11.4338 37.1371 11.7648L13.6039 24.2236C13.0063 24.5399 12.6091 25.1368 12.5479 25.8101Z"
        fill="url(#paint8_linear_267_27663)"
      />
      <path
        d="M15.5991 28.4573L13.7571 48.9919C13.6891 49.7504 14.0577 50.4818 14.7079 50.8782L30.6996 60.6292C31.3099 61.0014 32.0725 61.0195 32.6998 60.6767L52.6825 49.7572C53.2826 49.4293 53.6735 48.8175 53.719 48.1352L55.0666 27.9218C55.1155 27.1881 54.7579 26.4868 54.1354 26.0955L38.6256 16.3465C38.0196 15.9656 37.2562 15.9375 36.6239 16.2731L16.6537 26.8693C16.0563 27.1863 15.6596 27.7838 15.5991 28.4573Z"
        fill="url(#paint9_linear_267_27663)"
      />
      <path
        d="M28.2479 35.8895L25.146 33.2307L23.245 32.4703C22.9416 32.349 22.6053 32.5465 22.5634 32.8706L20.682 47.4519C20.6596 47.625 20.7292 47.7973 20.8655 47.9063L23.009 49.6211C23.0977 49.6921 23.2078 49.7307 23.3214 49.7307H48.192C48.4495 49.7307 48.6649 49.5352 48.6897 49.2789L50.1129 34.5725C50.1328 34.3666 50.0239 34.1697 49.8389 34.0771L48.3915 33.3535C48.2386 33.277 48.0572 33.284 47.9106 33.3719L43.5617 35.9813C43.3301 36.1203 43.0299 36.0502 42.8839 35.8229L38.7024 29.3185C38.6652 29.2606 38.6164 29.211 38.5592 29.1728L36.0327 27.4885C35.8147 27.3432 35.5215 27.3908 35.3607 27.5976L28.9679 35.8168C28.7927 36.0421 28.4646 36.0752 28.2479 35.8895Z"
        fill="#A9A9A9"
      />
      <path
        d="M21.5839 32.7242L20.6792 47.1995C20.6612 47.4874 20.8898 47.7307 21.1782 47.7307H46.692C46.9495 47.7307 47.1649 47.5352 47.1897 47.2789L48.5334 33.3943C48.5758 32.9564 48.0727 32.6811 47.7268 32.9529L42.1016 37.3728C41.8615 37.5614 41.51 37.4927 41.3585 37.2277L36.0235 27.8914C35.8451 27.5791 35.4052 27.5518 35.1894 27.8395L28.4642 36.8065C28.2916 37.0366 27.9608 37.074 27.7412 36.8882L22.4059 32.3737C22.092 32.1081 21.6096 32.3138 21.5839 32.7242Z"
        fill="url(#paint10_linear_267_27663)"
      />
      <path
        d="M15.7292 50.0637L16.146 51.7307L13.646 49.7307L15.646 27.7307L38.146 15.7307L41.646 18.2307L37.9678 17.7709C37.7586 17.7448 37.5465 17.7854 37.3618 17.887L18.5729 28.2209C17.993 28.5399 17.6084 29.125 17.5457 29.7838L15.6785 49.389C15.657 49.6152 15.6741 49.8433 15.7292 50.0637Z"
        fill="#B1B1B1"
      />
      <path
        d="M37.4325 13.4348L31.8263 15.0367C31.6445 15.0886 31.5126 14.8646 31.6463 14.7309L38.1463 11.231L60.1463 24.9355L64.146 28.2311L64.1459 30.7312L59.7146 28.6372L58.7666 26.0581C58.6887 25.8462 58.5414 25.6669 58.3486 25.5493L38.7802 13.6174C38.3762 13.371 37.8875 13.3048 37.4325 13.4348Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.254 11.9858C37.801 11.6962 38.4604 11.7171 38.988 12.0409L58.9766 24.3066C59.2136 24.452 59.4076 24.6484 59.5488 24.8763L59.5072 24.9388L59.6287 25.0198C59.7658 25.2959 59.8302 25.6084 59.8065 25.9274L57.9775 50.6189C57.9334 51.2149 57.5882 51.7472 57.062 52.0305L33.0406 64.965C32.4917 65.2606 31.827 65.2418 31.2957 64.9158L11.4242 52.7219L10.8317 52.0635L10.7739 52.1155C10.5698 51.7948 10.4715 51.41 10.5072 51.017L12.7967 25.8328C12.8503 25.2436 13.1979 24.7214 13.7207 24.4446L37.254 11.9858ZM11.101 53.1102L11.0732 53.0932C10.3442 52.6458 9.93183 51.8237 10.0093 50.9718L12.2987 25.7875C12.3676 25.03 12.8145 24.3586 13.4868 24.0027L37.02 11.5439C37.7234 11.1716 38.5712 11.1985 39.2495 11.6147L59.2381 23.8804C59.5634 24.08 59.8258 24.3544 60.0097 24.6729L63.2962 26.8639C63.9816 27.3208 64.3625 28.1157 64.2892 28.9361L61.9897 54.6909C61.923 55.4377 61.4887 56.1023 60.8314 56.4631L37.2688 69.3995C36.5699 69.7832 35.7202 69.7684 35.0351 69.3606L15.2787 57.6008C15.0843 57.4851 14.9084 57.3407 14.7571 57.1725L11.101 53.1102ZM12.6034 54.0322L15.1287 56.8381C15.2464 56.9688 15.3832 57.0811 15.5344 57.1711L35.2909 68.9309C35.8237 69.2481 36.4846 69.2596 37.0282 68.9612L60.5908 56.0248C61.102 55.7442 61.4398 55.2273 61.4917 54.6464L63.7912 28.8917C63.8482 28.2535 63.5519 27.6353 63.0189 27.2799L60.2855 25.4577C60.3108 25.6232 60.3178 25.7931 60.3052 25.9644L58.4762 50.6559C58.4194 51.4221 57.9755 52.1064 57.299 52.4707L33.2777 65.4053C32.5719 65.7853 31.7173 65.7612 31.0342 65.3419L12.6034 54.0322ZM35.3893 27.9896C35.4972 27.8457 35.7171 27.8594 35.8063 28.0155L41.1413 37.3518C41.3685 37.7494 41.8958 37.8523 42.2559 37.5694L47.8811 33.1496C48.0541 33.0137 48.3056 33.1513 48.2844 33.3703L46.9407 47.2549C46.9283 47.383 46.8206 47.4808 46.6919 47.4808H21.1781C21.0339 47.4808 20.9196 47.3591 20.9286 47.2152L21.8333 32.7399C21.8461 32.5347 22.0873 32.4318 22.2443 32.5646L27.5796 37.0791C27.909 37.3579 28.4051 37.3018 28.664 36.9566L35.3893 27.9896ZM36.1789 27.6757C35.8823 27.2956 35.2904 27.2881 34.9893 27.6896L28.7581 35.9978L25.3829 33.1047C25.3092 33.0416 25.224 32.9933 25.132 32.9627L22.2249 31.9936L22.2174 32.0161C21.8024 31.941 21.364 32.2333 21.3342 32.7087L20.4295 47.184C20.4058 47.5641 20.6687 47.8925 21.0271 47.9656L22.8226 49.7611C22.9633 49.9018 23.154 49.9808 23.353 49.9808H48.1919C48.5781 49.9808 48.9012 49.6875 48.9384 49.303L50.3658 34.5529C50.3925 34.2777 50.2655 34.0101 50.0353 33.8567L48.7845 33.0228L48.7417 33.087C48.5784 32.6383 47.9965 32.423 47.5722 32.7564L43.3448 36.078L38.9193 29.1939C38.857 29.0969 38.7731 29.0156 38.6743 28.9563L36.2745 27.5164L36.1789 27.6757ZM23.4483 32.9285L27.9025 36.6974C28.0123 36.7903 28.1777 36.7716 28.264 36.6566L28.4575 36.3986L25.0575 33.4843C25.033 33.4633 25.0046 33.4472 24.9739 33.437L23.4483 32.9285ZM36.5114 28.2417L41.5755 37.1037C41.6512 37.2362 41.827 37.2706 41.947 37.1763L43.1703 36.2151L42.9356 36.366L38.4987 29.4642C38.4779 29.4319 38.45 29.4048 38.4171 29.3851L36.5114 28.2417ZM48.7636 33.6097L47.4384 47.303C47.4012 47.6875 47.0781 47.9808 46.6919 47.9808H21.7494L23.1762 49.4076C23.2231 49.4545 23.2866 49.4808 23.353 49.4808H48.1919C48.3206 49.4808 48.4283 49.383 48.4407 49.2549L49.8682 34.5048C49.877 34.413 49.8347 34.3238 49.758 34.2727L48.7636 33.6097ZM38.4924 16.5582C37.9622 16.2249 37.2942 16.2004 36.7409 16.494L16.7707 27.0903C16.248 27.3676 15.9009 27.8904 15.848 28.4798L14.006 49.0144C13.9464 49.678 14.269 50.3179 14.8379 50.6648L30.8296 60.4159C31.3636 60.7415 32.0309 60.7573 32.5798 60.4574L52.5625 49.5379C53.0876 49.251 53.4296 48.7157 53.4694 48.1186L54.817 27.9052C54.8598 27.2633 54.5469 26.6496 54.0022 26.3072L38.4924 16.5582ZM36.5065 16.0523C37.2179 15.6748 38.0767 15.7064 38.7585 16.1349L54.2683 25.8839C54.9686 26.3241 55.3709 27.1131 55.3159 27.9385L53.9683 48.1519C53.9172 48.9195 53.4773 49.6078 52.8022 49.9767L32.8196 60.8962C32.1138 61.2818 31.2559 61.2615 30.5693 60.8428L14.5776 51.0917C13.8461 50.6457 13.4314 49.823 13.508 48.9697L15.35 28.4351C15.418 27.6773 15.8643 27.0052 16.5364 26.6486L36.5065 16.0523Z"
        fill="#373D54"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_267_27663"
        x1="70.5"
        y1="16"
        x2="0.331876"
        y2="98.7813"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8F8F8" />
        <stop offset="1" stopColor="#E2E2E2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_267_27663"
        x1="24.9999"
        y1="51.5"
        x2="-21.95"
        y2="90.1016"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_267_27663"
        x1="39"
        y1="48"
        x2="128.938"
        y2="47.0585"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_267_27663"
        x1="42.5001"
        y1="51"
        x2="98.5076"
        y2="126.8"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_267_27663"
        x1="25.0001"
        y1="30"
        x2="-33.1568"
        y2="7.09149"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_267_27663"
        x1="49.5"
        y1="29"
        x2="85.4977"
        y2="-8.87808"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_267_27663"
        x1="40.3266"
        y1="33.9175"
        x2="13.6611"
        y2="-10.3629"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.191882" stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_267_27663"
        x1="25.646"
        y1="55.7307"
        x2="66.146"
        y2="27.7307"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9A9A9A" />
        <stop offset="0.0315245" stopColor="#AEAEAE" />
        <stop offset="0.569143" stopColor="#C1C1C1" />
        <stop offset="0.619523" stopColor="#E0E0E0" />
        <stop offset="1" stopColor="#CCCCCC" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_267_27663"
        x1="8.646"
        y1="40.2307"
        x2="60.646"
        y2="36.7307"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCFCFC" />
        <stop offset="1" stopColor="#E9E9E9" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_267_27663"
        x1="17.146"
        y1="40.7307"
        x2="56.146"
        y2="36.2307"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EAEAEA" />
        <stop offset="1" stopColor="#F6F6F6" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_267_27663"
        x1="48.146"
        y1="36.7307"
        x2="21.146"
        y2="34.7307"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E8E8E8" />
        <stop offset="1" stopColor="#FDFDFD" />
      </linearGradient>
      <clipPath id="clip0_267_27663">
        <rect width="78" height="82" rx="8" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const GoldWithBg = (props: any) => (
  <svg {...props} width="78" height="82" viewBox="0 0 78 82" fill="none">
    <g clipPath="url(#clip0_267_27638)">
      <rect
        width="78"
        height="82"
        rx="8"
        fill="url(#paint0_linear_267_27638)"
      />
      <path
        d="M37 37.5L10 84L-7.5 74.5L-4 52L37 37.5Z"
        fill="url(#paint1_linear_267_27638)"
      />
      <path
        d="M40.0001 43.7609L93.2384 36.2159L86.5426 56.2205L40.0001 43.7609Z"
        fill="url(#paint2_linear_267_27638)"
      />
      <path
        d="M43.2718 43.3157L80.1954 82.404L59.9999 88.5L43.2718 43.3157Z"
        fill="url(#paint3_linear_267_27638)"
      />
      <path
        d="M39.0001 34.9999L-2.49995 18L-2.49994 -2.99955L2.50019 -2.99957L39.0001 34.9999Z"
        fill="url(#paint4_linear_267_27638)"
      />
      <path
        d="M46 28.5L73 -18L85.5 -6L87 8L46 28.5Z"
        fill="url(#paint5_linear_267_27638)"
      />
      <path
        d="M38.6833 29.1758L29.8754 -1.71521L43.2132 -0.582739L43.2132 28.2206L38.6833 29.1758Z"
        fill="url(#paint6_linear_267_27638)"
      />
      <path
        d="M37.8895 11.3692L13.2103 24.696C13.1677 24.719 13.1286 24.7481 13.0943 24.7824L12.773 25.1037C12.6909 25.1858 12.6399 25.2939 12.6288 25.4094L10.1597 51.0877C10.1508 51.1812 10.1683 51.2752 10.2102 51.3592L10.6157 52.1702C10.6358 52.2103 10.6612 52.2476 10.6913 52.281L15.0935 57.1724C15.1283 57.211 15.1689 57.244 15.2138 57.2702L36.3993 69.5873C36.5522 69.6762 36.7407 69.6777 36.8949 69.5913L61.4171 55.8589C61.5605 55.7786 61.6552 55.6331 61.6706 55.4696L64.1361 29.3357C64.1426 29.2665 64.1346 29.1966 64.1126 29.1306L63.6954 27.8789C63.6632 27.7824 63.6024 27.698 63.521 27.637L59.646 24.7307L38.3929 11.3858C38.2403 11.2899 38.048 11.2836 37.8895 11.3692Z"
        fill="url(#paint7_linear_267_27638)"
      />
      <path
        d="M12.5479 25.8101L10.2584 50.9943C10.1896 51.7516 10.5561 52.4823 11.2041 52.88L31.1651 65.1288C31.7723 65.5014 32.532 65.5229 33.1593 65.1851L57.1807 52.2505C57.782 51.9267 58.1765 51.3184 58.227 50.6373L60.056 25.9458C60.1113 25.1995 59.7453 24.4848 59.1075 24.0934L39.1189 11.8277C38.516 11.4577 37.7624 11.4338 37.1371 11.7648L13.6039 24.2236C13.0063 24.5399 12.6091 25.1368 12.5479 25.8101Z"
        fill="url(#paint8_linear_267_27638)"
      />
      <path
        d="M15.5991 28.4573L13.7571 48.9919C13.6891 49.7504 14.0577 50.4818 14.7079 50.8782L30.6996 60.6292C31.3099 61.0014 32.0725 61.0195 32.6998 60.6767L52.6825 49.7572C53.2826 49.4293 53.6735 48.8175 53.719 48.1352L55.0666 27.9218C55.1155 27.1881 54.7579 26.4868 54.1354 26.0955L38.6256 16.3465C38.0196 15.9656 37.2562 15.9375 36.6239 16.2731L16.6537 26.8693C16.0563 27.1863 15.6596 27.7838 15.5991 28.4573Z"
        fill="url(#paint9_linear_267_27638)"
      />
      <path
        d="M28.2479 35.8895L25.146 33.2307L23.245 32.4703C22.9416 32.349 22.6053 32.5465 22.5634 32.8706L20.682 47.4519C20.6596 47.625 20.7292 47.7973 20.8655 47.9063L23.009 49.6211C23.0977 49.6921 23.2078 49.7307 23.3214 49.7307H48.1983C48.4532 49.7307 48.6672 49.5391 48.6953 49.2858L50.4665 33.3024C50.4871 33.1166 50.4024 32.9349 50.2469 32.8313L49.2414 32.161C49.0921 32.0614 48.901 32.0495 48.7405 32.1298L47.0526 32.9737C47.0176 32.9912 46.9849 33.0127 46.955 33.0378L43.574 35.8719C43.3457 36.0633 43.0016 36.0138 42.8366 35.7657L39.1606 30.2413C39.0613 30.0921 39.0495 29.9011 39.1296 29.7407L40.3388 27.3223C40.4351 27.1298 40.3974 26.8974 40.2452 26.7452L38.5726 25.0726C38.5247 25.0247 38.4676 24.987 38.4047 24.9619L36.611 24.2444C36.3039 24.1216 35.9643 24.3254 35.9283 24.6542L35.6614 27.09C35.6513 27.182 35.6159 27.2694 35.5591 27.3425L28.9679 35.8168C28.7927 36.0421 28.4646 36.0752 28.2479 35.8895Z"
        fill="#FAA931"
      />
      <path
        d="M21.4587 32.7609L20.6746 47.2036C20.6591 47.49 20.8871 47.7307 21.1739 47.7307H46.6919C46.9494 47.7307 47.1649 47.5351 47.1896 47.2787L48.6904 31.7115L47.0772 32.464C47.0261 32.4878 46.9794 32.5201 46.9391 32.5595L42.1112 37.2763C41.8763 37.5057 41.4877 37.4503 41.3263 37.1644L37.1307 29.7316C37.049 29.5868 37.0446 29.4109 37.1189 29.2622L38.3388 26.8223C38.4351 26.6298 38.3974 26.3974 38.2452 26.2452L36.3229 24.3229C36.14 24.14 35.8479 24.1268 35.6492 24.2923L33.2382 26.3015C33.0923 26.4231 33.0279 26.6169 33.072 26.8016L33.7165 29.5024C33.751 29.647 33.7194 29.7995 33.6302 29.9185L31.896 32.2307L28.476 36.7907C28.299 37.0266 27.9574 37.059 27.7393 36.8604L23.5512 33.0466C23.5172 33.0157 23.4792 32.9896 23.4381 32.9691L22.1816 32.3408C21.8596 32.1798 21.4782 32.4015 21.4587 32.7609Z"
        fill="url(#paint10_linear_267_27638)"
      />
      <path
        d="M15.7292 50.0637L16.146 51.7307L13.646 49.7307L15.646 27.7307L38.146 15.7307L41.646 18.2307L37.9678 17.7709C37.7586 17.7448 37.5465 17.7854 37.3618 17.887L18.5729 28.2209C17.993 28.5399 17.6084 29.125 17.5457 29.7838L15.6785 49.389C15.657 49.6152 15.6741 49.8433 15.7292 50.0637Z"
        fill="#FDAC28"
      />
      <path
        d="M37.4325 13.4348L31.8263 15.0367C31.6445 15.0886 31.5126 14.8646 31.6463 14.7309L38.1463 11.231L60.1463 24.9355L64.146 28.2311L64.1459 30.7312L59.7146 28.6372L58.7666 26.0581C58.6887 25.8462 58.5414 25.6669 58.3486 25.5493L38.7802 13.6174C38.3762 13.371 37.8875 13.3048 37.4325 13.4348Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.254 11.9858C37.801 11.6962 38.4604 11.7171 38.988 12.0409L58.9766 24.3066C59.2136 24.452 59.4076 24.6484 59.5488 24.8763L59.5072 24.9388L59.6287 25.0198C59.7658 25.2959 59.8302 25.6084 59.8065 25.9274L57.9775 50.6189C57.9334 51.2149 57.5882 51.7472 57.062 52.0305L33.0406 64.965C32.4917 65.2606 31.827 65.2418 31.2957 64.9158L11.4242 52.7219L10.8317 52.0635L10.7739 52.1155C10.5698 51.7948 10.4715 51.41 10.5072 51.017L12.7967 25.8328C12.8503 25.2436 13.1979 24.7214 13.7207 24.4446L37.254 11.9858ZM11.101 53.1102L11.0732 53.0932C10.3442 52.6458 9.93183 51.8237 10.0093 50.9718L12.2987 25.7875C12.3676 25.03 12.8145 24.3586 13.4868 24.0027L37.02 11.5439C37.7234 11.1716 38.5712 11.1985 39.2495 11.6147L59.2381 23.8804C59.5634 24.08 59.8258 24.3544 60.0097 24.6729L63.2962 26.8639C63.9816 27.3208 64.3625 28.1157 64.2892 28.9361L61.9897 54.6909C61.923 55.4377 61.4887 56.1023 60.8314 56.4631L37.2688 69.3995C36.5699 69.7832 35.7202 69.7684 35.0351 69.3606L15.2787 57.6008C15.0843 57.4851 14.9084 57.3407 14.7571 57.1725L11.101 53.1102ZM12.6034 54.0322L15.1287 56.8381C15.2464 56.9688 15.3832 57.0811 15.5344 57.1711L35.2909 68.9309C35.8237 69.2481 36.4846 69.2596 37.0282 68.9612L60.5908 56.0248C61.102 55.7442 61.4398 55.2273 61.4917 54.6464L63.7912 28.8917C63.8482 28.2535 63.5519 27.6353 63.0189 27.2799L60.2855 25.4577C60.3108 25.6232 60.3178 25.7931 60.3052 25.9644L58.4762 50.6559C58.4194 51.4221 57.9755 52.1064 57.299 52.4707L33.2777 65.4053C32.5719 65.7853 31.7173 65.7612 31.0342 65.3419L12.6034 54.0322ZM35.7866 23.9714L38.4429 24.7241C38.5661 24.759 38.6783 24.8248 38.7688 24.9153L40.4219 26.5685C40.6502 26.7968 40.7068 27.1455 40.5624 27.4342L39.3532 29.8526C39.3131 29.9328 39.319 30.0283 39.3687 30.1029L43.2191 35.8896L46.9736 32.3189L46.9808 32.312L46.9886 32.3057L47.8974 31.5705C48.32 31.2286 48.9067 31.4414 49.0736 31.8895L49.1386 31.7919L50.3855 32.6231C50.6188 32.7786 50.7458 33.0512 50.7149 33.3298L48.9436 49.3134C48.9015 49.6933 48.5804 49.9808 48.1982 49.9808H23.353C23.154 49.9808 22.9633 49.9018 22.8226 49.7611L21.0271 47.9656C20.6687 47.8925 20.4058 47.5641 20.4295 47.184L21.3342 32.7087C21.3727 32.0931 22.0964 31.7845 22.5672 32.1829L22.7009 32.2961L25.1049 32.9601C25.2111 32.9895 25.3096 33.0419 25.3933 33.1136L28.7629 36.0018L33.6416 29.5592C33.6914 29.4935 33.7056 29.4074 33.6795 29.3292L32.8605 26.8723C32.7707 26.6028 32.8408 26.3057 33.0417 26.1048L35.0003 24.1462C35.1542 23.9923 35.3597 23.9185 35.5631 23.9272L35.5681 23.9095L35.6833 23.9421C35.7183 23.9494 35.7528 23.9591 35.7866 23.9714ZM28.4605 36.4012L25.0679 33.4932C25.04 33.4693 25.0071 33.4518 24.9717 33.4421L23.6111 33.0662L25.0573 34.2899L27.9044 36.699C28.0139 36.7916 28.1786 36.7734 28.2652 36.6591L28.4605 36.4012ZM22.437 32.7278L22.4334 32.7409L22.4619 32.7488L23.1094 33.2966L24.7344 34.6716L27.5814 37.0807C27.9098 37.3586 28.4041 37.3039 28.6638 36.9609L34.0402 29.861C34.1895 29.6639 34.232 29.4057 34.1538 29.1711L33.3349 26.7142C33.3049 26.6243 33.3283 26.5253 33.3953 26.4583L35.3539 24.4997C35.4122 24.4414 35.4928 24.4176 35.5693 24.4295L35.6276 24.446C35.6499 24.4554 35.6712 24.4682 35.6907 24.4844L38.0357 26.4386C38.1248 26.5129 38.1511 26.6387 38.0993 26.7425L36.8953 29.1504C36.7838 29.3735 36.7904 29.6374 36.913 29.8545L41.1129 37.2952C41.3529 37.7205 41.929 37.8065 42.2829 37.47L47.3109 32.6881L48.2118 31.9593C48.3855 31.8188 48.6422 31.9592 48.6176 32.1812L46.9467 47.2583C46.9326 47.385 46.8256 47.4808 46.6982 47.4808H21.1781C21.0339 47.4808 20.9196 47.3591 20.9286 47.2152L21.8333 32.7399C21.8461 32.5347 22.0873 32.4318 22.2443 32.5646L22.437 32.7278ZM36.8368 24.7886L38.3066 25.2051C38.3477 25.2168 38.385 25.2387 38.4152 25.2689L40.0684 26.922C40.1445 26.9981 40.1633 27.1144 40.1152 27.2106L38.906 29.629C38.7857 29.8695 38.8034 30.156 38.9524 30.3799L42.8513 36.2394L41.9383 37.1077C41.8203 37.2198 41.6283 37.1912 41.5483 37.0494L37.3484 29.6087C37.3075 29.5364 37.3053 29.4484 37.3425 29.3741L38.5465 26.9661C38.7021 26.6548 38.6232 26.2773 38.3558 26.0545L36.8368 24.7886ZM21.7494 47.9808L23.1762 49.4076C23.2231 49.4545 23.2866 49.4808 23.353 49.4808H48.1982C48.3256 49.4808 48.4326 49.385 48.4467 49.2583L50.218 33.2747C50.2283 33.1819 50.1859 33.091 50.1082 33.0392L49.1 32.3671L47.4436 47.3134C47.4015 47.6933 47.0804 47.9808 46.6982 47.9808H21.7494ZM38.4924 16.5582C37.9622 16.2249 37.2942 16.2004 36.7409 16.494L16.7707 27.0903C16.248 27.3676 15.9009 27.8904 15.848 28.4798L14.006 49.0144C13.9464 49.678 14.269 50.3179 14.8379 50.6648L30.8296 60.4159C31.3636 60.7415 32.0309 60.7573 32.5798 60.4574L52.5625 49.5379C53.0876 49.251 53.4296 48.7157 53.4694 48.1186L54.817 27.9052C54.8598 27.2633 54.5469 26.6496 54.0022 26.3072L38.4924 16.5582ZM36.5065 16.0523C37.2179 15.6748 38.0767 15.7064 38.7585 16.1349L54.2683 25.8839C54.9686 26.3241 55.3709 27.1131 55.3159 27.9385L53.9683 48.1519C53.9172 48.9195 53.4773 49.6078 52.8022 49.9767L32.8196 60.8962C32.1138 61.2818 31.2559 61.2615 30.5693 60.8428L14.5776 51.0917C13.8461 50.6457 13.4314 49.823 13.508 48.9697L15.35 28.4351C15.418 27.6773 15.8643 27.0052 16.5364 26.6486L36.5065 16.0523Z"
        fill="#A06000"
      />
      <path
        d="M36.7996 39.5749C36.7735 40.8722 35.9218 41.8077 35.0047 41.7893C34.0875 41.7708 33.2742 40.8018 33.3003 39.5045C33.3264 38.2072 34.178 37.2717 35.0952 37.2902C36.0123 37.3086 36.8257 38.2776 36.7996 39.5749Z"
        fill="#FEAC2D"
        stroke="#A06000"
        strokeWidth="0.5"
      />
      <circle cx="35.5" cy="38.5" r="0.5" fill="white" />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_267_27638"
        x1="83.5714"
        y1="-9.46154"
        x2="39.3674"
        y2="82.1772"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE9A5" />
        <stop offset="1" stopColor="#FFCA56" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_267_27638"
        x1="77.5"
        y1="0.500003"
        x2="9.54853"
        y2="84.489"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="#FFCB57" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_267_27638"
        x1="-14.1234"
        y1="34.8219"
        x2="84.741"
        y2="38.4688"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="#FFDC83" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_267_27638"
        x1="19.2895"
        y1="-6.02092"
        x2="80.5362"
        y2="82.9757"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="#FFCB57" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_267_27638"
        x1="158.5"
        y1="107"
        x2="-16.4814"
        y2="44.8895"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="#FFDD85" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_267_27638"
        x1="-63.5"
        y1="102"
        x2="68.6145"
        y2="-2.22777"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="#FFE497" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_267_27638"
        x1="41.4516"
        y1="27.9175"
        x2="14.7861"
        y2="-16.3629"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE196" />
        <stop offset="0.478779" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_267_27638"
        x1="25.646"
        y1="55.7307"
        x2="66.146"
        y2="27.7307"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9B12E" />
        <stop offset="0.0315245" stopColor="#FFAE2A" />
        <stop offset="0.569143" stopColor="#FDAB2D" />
        <stop offset="0.619523" stopColor="#FDD05B" />
        <stop offset="1" stopColor="#FEC75C" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_267_27638"
        x1="8.646"
        y1="40.2307"
        x2="60.646"
        y2="36.7307"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEFFBB" />
        <stop offset="1" stopColor="#FDEC78" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_267_27638"
        x1="17.146"
        y1="40.7307"
        x2="56.146"
        y2="36.2307"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDDA5B" />
        <stop offset="1" stopColor="#FFE586" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_267_27638"
        x1="48.146"
        y1="36.7307"
        x2="21.146"
        y2="34.7307"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8EB7A" />
        <stop offset="1" stopColor="#FFFFB8" />
      </linearGradient>
      <clipPath id="clip0_267_27638">
        <rect width="78" height="82" rx="8" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PlatinumWithBg = (props: any) => (
  <svg {...props} width="78" height="82" viewBox="0 0 78 82" fill="none">
    <g clipPath="url(#clip0_267_27601)">
      <rect
        width="78"
        height="82"
        rx="8"
        fill="url(#paint0_linear_267_27601)"
      />
      <path
        opacity="0.3"
        d="M38.5 35.5L2.5 83.5L-3.5 79V49L38.5 35.5Z"
        fill="url(#paint1_linear_267_27601)"
      />
      <path
        opacity="0.3"
        d="M38.5 34.9997L-1.50036 34.9998L-1.50033 24.0007L38.5 34.9997Z"
        fill="url(#paint2_linear_267_27601)"
      />
      <path
        opacity="0.3"
        d="M41.0747 36.4017L81.5 45.9998L81.5 70.9997L41.0747 36.4017Z"
        fill="url(#paint3_linear_267_27601)"
      />
      <path
        opacity="0.3"
        d="M41.95 46.7568L78.1772 85.1079L58.3627 91.0889L41.95 46.7568Z"
        fill="url(#paint4_linear_267_27601)"
      />
      <path
        opacity="0.3"
        d="M36.8548 34.2577L-1.99996 14L-0.99998 -1.5001L21 -4.99994L36.8548 34.2577Z"
        fill="url(#paint5_linear_267_27601)"
      />
      <path
        opacity="0.3"
        d="M38.5 35.5L70.5 -1.64516H80.5V18L38.5 35.5Z"
        fill="url(#paint6_linear_267_27601)"
      />
      <path
        d="M37.8895 11.3692L13.2103 24.696C13.1677 24.719 13.1286 24.7481 13.0943 24.7824L12.773 25.1037C12.6909 25.1858 12.6399 25.2939 12.6288 25.4094L10.1597 51.0877C10.1508 51.1812 10.1683 51.2752 10.2102 51.3592L10.6157 52.1702C10.6358 52.2103 10.6612 52.2476 10.6913 52.281L15.0935 57.1724C15.1283 57.211 15.1689 57.244 15.2138 57.2702L36.3993 69.5873C36.5522 69.6762 36.7407 69.6777 36.8949 69.5913L61.4171 55.8589C61.5605 55.7786 61.6552 55.6331 61.6706 55.4696L64.1361 29.3357C64.1426 29.2665 64.1346 29.1966 64.1126 29.1306L63.6954 27.8789C63.6632 27.7824 63.6024 27.698 63.521 27.637L59.646 24.7307L38.3929 11.3858C38.2403 11.2899 38.048 11.2836 37.8895 11.3692Z"
        fill="url(#paint7_linear_267_27601)"
      />
      <path
        d="M12.5479 25.8101L10.2584 50.9943C10.1896 51.7516 10.5561 52.4823 11.2041 52.88L31.1651 65.1288C31.7723 65.5014 32.532 65.5229 33.1593 65.1851L57.1807 52.2505C57.782 51.9267 58.1765 51.3184 58.227 50.6373L60.056 25.9458C60.1113 25.1995 59.7453 24.4848 59.1075 24.0934L39.1189 11.8277C38.516 11.4577 37.7624 11.4338 37.1371 11.7648L13.6039 24.2236C13.0063 24.5399 12.6091 25.1368 12.5479 25.8101Z"
        fill="url(#paint8_linear_267_27601)"
      />
      <path
        d="M15.5991 28.4573L13.7571 48.9919C13.6891 49.7504 14.0577 50.4818 14.7079 50.8782L30.6996 60.6292C31.3099 61.0014 32.0725 61.0195 32.6998 60.6767L52.6825 49.7572C53.2826 49.4293 53.6735 48.8175 53.719 48.1352L55.0666 27.9218C55.1155 27.1881 54.7579 26.4868 54.1354 26.0955L38.6256 16.3465C38.0196 15.9656 37.2562 15.9375 36.6239 16.2731L16.6537 26.8693C16.0563 27.1863 15.6596 27.7838 15.5991 28.4573Z"
        fill="url(#paint9_linear_267_27601)"
      />
      <path
        d="M28.6274 35.2806L25.146 33.2307L26 31.5L25.0829 30.1244C25.0288 30.0432 24.9522 29.9797 24.8624 29.9415L23.3415 29.2955C23.0117 29.1554 22.646 29.3974 22.646 29.7556V32.2307L20.682 47.4519C20.6596 47.625 20.7292 47.7973 20.8655 47.9063L23.009 49.6211C23.0977 49.6921 23.2078 49.7307 23.3214 49.7307H48.1908C48.4488 49.7307 48.6644 49.5344 48.6886 49.2775L50.4721 30.2972C50.4893 30.1141 50.4046 29.9364 50.2516 29.8344L49.4713 29.3142C49.221 29.1474 48.8812 29.2376 48.7467 29.5066L47.0464 32.9071C47.0158 32.9684 46.9729 33.0227 46.9204 33.0667L43.574 35.8719C43.3457 36.0633 43.0016 36.0138 42.8366 35.7657L39.1606 30.2413C39.0613 30.0921 39.0495 29.9011 39.1296 29.7407L40.3388 27.3223C40.4351 27.1298 40.3974 26.8974 40.2452 26.7452L38.5726 25.0726C38.5247 25.0247 38.4676 24.987 38.4047 24.9619L36.611 24.2444C36.3039 24.1216 35.9643 24.3254 35.9283 24.6542L35.6619 27.0857C35.6515 27.1804 35.6143 27.2702 35.5546 27.3444L29.2709 35.163C29.1153 35.3565 28.8414 35.4066 28.6274 35.2806Z"
        fill="#335BFF"
      />
      <path
        d="M21.646 31.7307L20.6792 47.1995C20.6612 47.4874 20.8898 47.7307 21.1782 47.7307H46.6919C46.9494 47.7307 47.1649 47.5351 47.1896 47.2787L49 28.5H48.6385C48.5479 28.5 48.459 28.5246 48.3812 28.5713L46.3651 29.7809C46.1547 29.9072 46.067 30.1675 46.1581 30.3954L46.8704 32.1761C46.9483 32.3707 46.8965 32.5932 46.7407 32.7334L42.4298 36.6132C42.2032 36.8171 41.8484 36.7726 41.6793 36.5189L37.161 29.7414C37.0614 29.5921 37.0495 29.401 37.1298 29.2405L38.3388 26.8223C38.4351 26.6298 38.3974 26.3974 38.2452 26.2452L36.3229 24.3229C36.14 24.14 35.8479 24.1268 35.6492 24.2923L33.2382 26.3015C33.0923 26.4231 33.0279 26.6169 33.072 26.8016L33.7165 29.5024C33.751 29.647 33.7194 29.7995 33.6302 29.9185L31.896 32.2307L28.7928 36.132C28.6283 36.3388 28.3312 36.3819 28.1147 36.2303L23.8247 33.2273C23.6345 33.0941 23.561 32.8476 23.6472 32.632L24.3776 30.8061C24.4518 30.6204 24.4083 30.4083 24.2669 30.2669L23.0574 29.0574C23.0194 29.0194 22.9755 28.9877 22.9274 28.9637L22 28.5L21.646 31.7307Z"
        fill="url(#paint10_linear_267_27601)"
      />
      <path
        d="M15.7292 50.0637L16.146 51.7307L13.646 49.7307L15.646 27.7307L38.146 15.7307L41.646 18.2307L37.9678 17.7709C37.7586 17.7448 37.5465 17.7854 37.3618 17.887L18.5729 28.2209C17.993 28.5399 17.6084 29.125 17.5457 29.7838L15.6785 49.389C15.657 49.6152 15.6741 49.8433 15.7292 50.0637Z"
        fill="#3353FF"
      />
      <path
        d="M37.4325 13.4348L31.8263 15.0367C31.6445 15.0886 31.5126 14.8646 31.6463 14.7309L38.1463 11.231L60.1463 24.9355L64.146 28.2311L64.1459 30.7312L59.7146 28.6372L58.7666 26.0581C58.6887 25.8462 58.5414 25.6669 58.3486 25.5493L38.7802 13.6174C38.3762 13.371 37.8875 13.3048 37.4325 13.4348Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.254 11.9858C37.801 11.6962 38.4604 11.7171 38.988 12.0409L58.9766 24.3066C59.2136 24.452 59.4076 24.6484 59.5488 24.8763L59.5072 24.9388L59.6287 25.0198C59.7658 25.2959 59.8302 25.6084 59.8065 25.9274L57.9775 50.6189C57.9334 51.2149 57.5882 51.7472 57.062 52.0305L33.0406 64.965C32.4917 65.2606 31.827 65.2418 31.2957 64.9158L11.4242 52.7219L10.8317 52.0635L10.7739 52.1155C10.5698 51.7948 10.4715 51.41 10.5072 51.017L12.7967 25.8328C12.8503 25.2436 13.1979 24.7214 13.7207 24.4446L37.254 11.9858ZM11.101 53.1102L11.0732 53.0932C10.3442 52.6458 9.93183 51.8237 10.0093 50.9718L12.2987 25.7875C12.3676 25.03 12.8145 24.3586 13.4868 24.0027L37.02 11.5439C37.7234 11.1716 38.5712 11.1985 39.2495 11.6147L59.2381 23.8804C59.5634 24.08 59.8258 24.3544 60.0097 24.6729L63.2962 26.8639C63.9816 27.3208 64.3625 28.1157 64.2892 28.9361L61.9897 54.6909C61.923 55.4377 61.4887 56.1023 60.8314 56.4631L37.2688 69.3995C36.5699 69.7832 35.7202 69.7684 35.0351 69.3606L15.2787 57.6008C15.0843 57.4851 14.9084 57.3407 14.7571 57.1725L11.101 53.1102ZM12.6034 54.0322L15.1287 56.8381C15.2464 56.9688 15.3832 57.0811 15.5344 57.1711L35.2909 68.9309C35.8237 69.2481 36.4846 69.2596 37.0282 68.9612L60.5908 56.0248C61.102 55.7442 61.4398 55.2273 61.4917 54.6464L63.7912 28.8917C63.8482 28.2535 63.5519 27.6353 63.0189 27.2799L60.2855 25.4577C60.3108 25.6232 60.3178 25.7931 60.3052 25.9644L58.4762 50.6559C58.4194 51.4221 57.9755 52.1064 57.299 52.4707L33.2777 65.4053C32.5719 65.7853 31.7173 65.7612 31.0342 65.3419L12.6034 54.0322ZM35.7863 23.9712L38.4429 24.724C38.566 24.7589 38.6782 24.8247 38.7687 24.9153L40.4219 26.5684C40.6501 26.7967 40.7067 27.1454 40.5624 27.4341L39.3532 29.8525C39.3131 29.9327 39.319 30.0282 39.3686 30.1028L43.098 35.7076L46.7004 32.5574C46.7837 32.4846 46.8092 32.3656 46.7631 32.265L45.9504 30.4919C45.7968 30.1569 45.9095 29.7599 46.2161 29.5554L47.9879 28.3742C48.4353 28.076 49.0069 28.3334 49.1301 28.8047L49.1386 28.792L50.3902 29.6264C50.6197 29.7794 50.7467 30.046 50.7209 30.3206L48.9373 49.301C48.9011 49.6863 48.5776 49.9808 48.1906 49.9808H23.3529C23.154 49.9808 22.9632 49.9018 22.8226 49.7612L21.0269 47.9655C20.6686 47.8923 20.4057 47.564 20.4295 47.1839L21.3963 31.7151L21.3968 31.7071L21.3969 31.7071L21.6507 29.0336C21.6981 28.534 22.1889 28.2566 22.6139 28.3846L22.6168 28.3791L22.6487 28.396C22.7129 28.4189 22.7752 28.4513 22.8339 28.494L25.134 29.7109C25.2601 29.7775 25.3645 29.8788 25.4351 30.0027L26.0858 31.1456C26.209 31.3619 26.2168 31.6253 26.1067 31.8486L25.5755 32.9249C25.5176 33.0423 25.56 33.1846 25.6728 33.251L29.1268 35.2846L29.0963 35.3364L33.637 29.5572C33.6889 29.4911 33.7042 29.4034 33.6776 29.3237L32.8605 26.8722C32.7706 26.6027 32.8408 26.3056 33.0416 26.1047L35.0003 24.1461C35.1542 23.9922 35.3597 23.9184 35.563 23.9271L35.5681 23.9094L35.6835 23.9421C35.7183 23.9493 35.7526 23.959 35.7863 23.9712ZM28.822 35.6854L25.4192 33.6819C25.0807 33.4826 24.9533 33.0559 25.1271 32.7037L25.6583 31.6273C25.695 31.5529 25.6924 31.4651 25.6513 31.393L25.0006 30.2501C24.977 30.2088 24.9422 30.1751 24.9002 30.1528L24.0637 29.7103L24.428 30.0745C24.6518 30.2983 24.711 30.6385 24.576 30.9248L23.6832 32.8174C23.6298 32.9305 23.6683 33.0657 23.7732 33.1338L28.2529 36.0416C28.3614 36.112 28.5057 36.0881 28.5856 35.9864L28.822 35.6854ZM22.4602 28.8619L22.5603 28.9149C22.565 28.919 22.5696 28.9232 22.5741 28.9277L24.0744 30.4281C24.149 30.5027 24.1688 30.6161 24.1237 30.7115L23.231 32.6041C23.0709 32.9435 23.1862 33.3489 23.501 33.5532L27.9806 36.461C28.3061 36.6723 28.739 36.6004 28.9787 36.2953L34.0302 29.8661C34.1859 29.6679 34.2317 29.4047 34.152 29.1656L33.3348 26.7141C33.3049 26.6243 33.3282 26.5252 33.3952 26.4583L35.3538 24.4997C35.4122 24.4413 35.4928 24.4175 35.5694 24.4294L35.6274 24.4459C35.6498 24.4553 35.6711 24.4681 35.6906 24.4844L38.0356 26.4385C38.1248 26.5128 38.1511 26.6386 38.0992 26.7424L36.9061 29.1287C36.7857 29.3694 36.8036 29.6562 36.9529 29.8801L41.4758 36.6645C41.727 37.0414 42.2525 37.1112 42.5935 36.813L47.0295 32.9338C47.2794 32.7153 47.3559 32.3585 47.2176 32.0567L46.4049 30.2836C46.3537 30.1719 46.3913 30.0396 46.4935 29.9714L48.2652 28.7903C48.4403 28.6735 48.6725 28.8122 48.6528 29.0217L46.9395 47.2541C46.9274 47.3826 46.8196 47.4807 46.6906 47.4807H21.178C21.0338 47.4807 20.9195 47.359 20.9285 47.2151L21.8951 31.7503L22.1484 29.0809C22.1639 28.918 22.3208 28.826 22.4602 28.8619ZM36.8367 24.7885L38.3065 25.2051C38.3476 25.2167 38.385 25.2386 38.4152 25.2688L40.0683 26.922C40.1444 26.998 40.1633 27.1143 40.1151 27.2105L38.9059 29.6289C38.7857 29.8695 38.8034 30.156 38.9524 30.3798L42.7184 36.0396L42.2644 36.4366C42.1507 36.536 41.9755 36.5128 41.8918 36.3871L37.3689 29.6028C37.3191 29.5281 37.3132 29.4325 37.3533 29.3523L38.5464 26.966C38.7021 26.6547 38.6231 26.2772 38.3557 26.0544L36.8367 24.7885ZM21.7492 47.9807L23.1761 49.4076C23.223 49.4545 23.2866 49.4808 23.3529 49.4808H48.1906C48.3196 49.4808 48.4274 49.3827 48.4395 49.2542L50.2231 30.2738C50.2317 30.1823 50.1894 30.0934 50.1129 30.0424L49.1212 29.3813L47.4373 47.3009C47.4011 47.6862 47.0776 47.9807 46.6906 47.9807H21.7492ZM38.4924 16.5582C37.9622 16.2249 37.2942 16.2004 36.7409 16.494L16.7707 27.0903C16.248 27.3676 15.9009 27.8904 15.848 28.4798L14.006 49.0144C13.9464 49.678 14.269 50.3179 14.8379 50.6648L30.8296 60.4159C31.3636 60.7415 32.0309 60.7573 32.5798 60.4574L52.5625 49.5379C53.0876 49.251 53.4296 48.7157 53.4694 48.1186L54.817 27.9052C54.8598 27.2633 54.5469 26.6496 54.0022 26.3072L38.4924 16.5582ZM36.5065 16.0523C37.2179 15.6748 38.0767 15.7064 38.7585 16.1349L54.2683 25.8839C54.9686 26.3241 55.3709 27.1131 55.3159 27.9385L53.9683 48.1519C53.9172 48.9195 53.4773 49.6078 52.8022 49.9767L32.8196 60.8962C32.1138 61.2818 31.2559 61.2615 30.5693 60.8428L14.5776 51.0917C13.8461 50.6457 13.4314 49.823 13.508 48.9697L15.35 28.4351C15.418 27.6773 15.8643 27.0052 16.5364 26.6486L36.5065 16.0523Z"
        fill="#001376"
      />
      <path
        d="M39.3858 38.2929L38.2164 36.1003C38.1605 35.9953 38.2738 35.8811 38.3792 35.9363L39.2596 36.3683L40.4871 39.2326L34.9633 45.3702L34.1449 45.3701L39.2811 39.2829C39.5152 39.0054 39.5567 38.6132 39.3858 38.2929Z"
        fill="url(#paint11_linear_267_27601)"
      />
      <path
        d="M33.7357 45.3699L36.1907 38.8232L39.6687 38.8232L33.9403 45.5745L33.7357 45.3699Z"
        fill="#A8CAFF"
      />
      <path
        d="M33.7358 45.358L31.69 38.6187L29.4395 38.6187L33.5312 45.358L33.7358 45.358Z"
        fill="#91BBFF"
      />
      <path
        d="M33.7358 45.3699L36.1908 38.8231L31.6899 38.6186L33.5312 44.9607L33.7358 45.3699Z"
        fill="white"
      />
      <path
        d="M34.3495 35.7546L36.1908 38.8234L31.6899 38.6188L33.7357 36.3684L34.3495 35.7546Z"
        fill="#E2EEFF"
      />
      <path
        d="M37.8275 35.5499L39.4642 38.8233L36.1908 38.8233L37.4183 36.5728L37.8275 35.5499Z"
        fill="#BCCFFF"
      />
      <path
        d="M30.8716 35.7547L29.4395 38.6188L31.69 38.6189L31.0762 35.7546L30.8716 35.7547Z"
        fill="#BCCFFF"
      />
      <path
        d="M31.8945 38.4141L34.3495 35.5499L31.0762 35.5499L31.6899 38.4141L31.8945 38.4141Z"
        fill="white"
      />
      <path
        d="M36.1909 38.8232L34.3502 35.6905L37.7667 35.6905L36.3955 38.414L36.1909 38.8232Z"
        fill="#DFF2FF"
      />
      <path
        d="M39.5052 38.8827C39.4966 38.9614 39.4641 39.0356 39.4121 39.0955L34.0807 45.385C34.0422 45.4293 33.994 45.4642 33.9398 45.487C33.8855 45.5098 33.8267 45.5199 33.7679 45.5165C33.7091 45.5131 33.6519 45.4963 33.6006 45.4673C33.5494 45.4384 33.5055 45.3982 33.4724 45.3497L29.4805 38.8825C29.4358 38.817 29.4121 38.7395 29.4126 38.6604M39.5052 38.8827C39.5138 38.804 39.4981 38.7245 39.4602 38.6549L38.0731 35.8139C38.042 35.7564 37.9965 35.7078 37.9412 35.6727C37.8858 35.6376 37.8223 35.6171 37.7568 35.6132L31.2501 35.6512C31.1845 35.6474 31.1191 35.6604 31.0601 35.6889C31.001 35.7174 30.9502 35.7604 30.9126 35.8139L29.4837 38.4393C29.438 38.5041 29.4132 38.5812 29.4126 38.6604M39.5052 38.8827L29.4126 38.6604"
        stroke="#001376"
        strokeWidth="0.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.8276 35.7544L36.1909 38.8232M36.1909 38.8232L34.3369 35.7125L31.69 38.6186M36.1909 38.8232L33.7358 45.37L31.69 38.6186M31.0762 35.7544L31.69 38.6186"
        stroke="#001376"
        strokeWidth="0.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.7357 45.4927L34.7707 45.3892C34.8946 45.3768 35.0094 45.3187 35.0926 45.2261L40.2732 39.47C40.4036 39.3251 40.4379 39.1177 40.3611 38.9385L39.3317 36.5365C39.2851 36.4278 39.2015 36.3391 39.0957 36.2862L38.032 35.7544"
        stroke="#001376"
        strokeWidth="0.3"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_267_27601"
        x1="83.5714"
        y1="-9.46154"
        x2="39.3674"
        y2="82.1772"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BCCBFF" />
        <stop offset="1" stopColor="#81A4FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_267_27601"
        x1="20.5"
        y1="51"
        x2="-1.38094"
        y2="69.423"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00354279" stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_267_27601"
        x1="18.5"
        y1="33"
        x2="-9.99968"
        y2="33.0044"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_267_27601"
        x1="62.5"
        y1="48"
        x2="88.5141"
        y2="55.7814"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_267_27601"
        x1="52.5"
        y1="60"
        x2="74.4521"
        y2="89.5498"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_267_27601"
        x1="29"
        y1="24.5"
        x2="-2.26831"
        y2="5.53869"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_267_27601"
        x1="55.5"
        y1="24"
        x2="81.8165"
        y2="-1.34404"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_267_27601"
        x1="25.646"
        y1="55.7307"
        x2="66.146"
        y2="27.7307"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3246FE" />
        <stop offset="0.0315245" stopColor="#3246FE" />
        <stop offset="0.569143" stopColor="#325FFE" />
        <stop offset="0.619523" stopColor="#778DFF" />
        <stop offset="1" stopColor="#7795FF" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_267_27601"
        x1="8.646"
        y1="40.2307"
        x2="60.646"
        y2="36.7307"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DFEEFF" />
        <stop offset="1" stopColor="#BCCBFF" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_267_27601"
        x1="17.146"
        y1="40.7307"
        x2="56.146"
        y2="36.2307"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7896FF" />
        <stop offset="1" stopColor="#ACC3FF" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_267_27601"
        x1="48.146"
        y1="36.7307"
        x2="21.146"
        y2="34.7307"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BCCFFF" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_267_27601"
        x1="39.055"
        y1="38.8234"
        x2="39.8734"
        y2="35.9592"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3253FE" />
        <stop offset="0.0185376" stopColor="#77A2FF" />
        <stop offset="0.9999" stopColor="#77A2FF" />
        <stop offset="1" stopColor="#77A2FF" />
      </linearGradient>
      <clipPath id="clip0_267_27601">
        <rect width="78" height="82" rx="8" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const UsersEmptyState = (props: any) => {
  return (
    <Icon
      {...props}
      $size={212}
      width="212"
      height="173"
      viewBox="0 0 212 173"
      fill="none"
    >
      <path
        d="M105.624 172.655C163.959 172.655 211.248 160.96 211.248 146.533C211.248 132.106 163.959 120.411 105.624 120.411C47.2895 120.411 0 132.106 0 146.533C0 160.96 47.2895 172.655 105.624 172.655Z"
        fill="url(#paint0_linear_439_595)"
      />
      <path
        d="M169.102 79.5893H155.488C156.876 83.3399 157.634 87.3876 157.634 91.6064V142.402C157.634 144.161 157.324 145.849 156.759 147.419H179.266C187.674 147.419 194.513 140.667 194.513 132.367V104.676C194.514 90.8434 183.114 79.5893 169.102 79.5893ZM55.3574 91.6067C55.3574 87.3876 56.1156 83.3403 57.5032 79.5896H43.8893C29.8773 79.5896 18.4775 90.8437 18.4775 104.677V132.368C18.4775 140.667 25.3172 147.42 33.7246 147.42H56.2318C55.6525 145.809 55.3568 144.112 55.3574 142.402V91.6067ZM122.057 66.5195H90.9339C76.9219 66.5195 65.5222 77.7736 65.5222 91.6067V142.402C65.5222 145.173 67.7976 147.42 70.6045 147.42H142.387C145.194 147.42 147.469 145.173 147.469 142.402V91.6067C147.469 77.7736 136.069 66.5195 122.057 66.5195ZM106.496 0C89.6443 0 75.9348 13.5344 75.9348 30.1708C75.9348 41.4551 82.2435 51.3104 91.5604 56.4847C95.9795 58.9388 101.074 60.3413 106.496 60.3413C111.917 60.3413 117.012 58.9388 121.431 56.4847C130.748 51.3104 137.056 41.4548 137.056 30.1708C137.056 13.5347 123.347 0 106.496 0ZM52.8314 28.1213C40.2287 28.1213 29.9759 38.2431 29.9759 50.6849C29.9759 63.1266 40.2287 73.2484 52.8314 73.2484C55.9284 73.251 58.9932 72.6287 61.8378 71.4195C66.6189 69.3874 70.5612 65.7901 73.0006 61.2842C74.7677 58.0239 75.6906 54.3826 75.6869 50.6849C75.6869 38.2434 65.4341 28.1213 52.8314 28.1213ZM160.16 28.1213C147.557 28.1213 137.304 38.2431 137.304 50.6849C137.301 54.3826 138.223 58.0239 139.991 61.2842C142.43 65.7905 146.372 69.3877 151.153 71.4195C153.998 72.6287 157.063 73.251 160.16 73.2484C172.763 73.2484 183.015 63.1266 183.015 50.6849C183.015 38.2431 172.763 28.1213 160.16 28.1213Z"
        fill="url(#paint1_linear_439_595)"
      />
      <path
        d="M90.934 66.5195H122.057C136.069 66.5195 147.469 77.7736 147.469 91.6067V142.402C147.469 145.173 145.194 147.42 142.387 147.42H70.6046C67.7976 147.42 65.5222 145.173 65.5222 142.402V91.6067C65.5222 77.7736 76.9219 66.5195 90.934 66.5195Z"
        fill="url(#paint2_linear_439_595)"
      />
      <path
        d="M75.9348 30.1708C75.9348 13.5344 89.6443 0 106.496 0C123.347 0 137.056 13.5347 137.056 30.1708C137.056 41.4548 130.748 51.3104 121.431 56.4847C117.012 58.9387 111.917 60.3413 106.496 60.3413C101.074 60.3413 95.9796 58.9387 91.5604 56.4847C82.2436 51.3104 75.9348 41.4551 75.9348 30.1708Z"
        fill="url(#paint3_linear_439_595)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_439_595"
          x1="115.278"
          y1="193.098"
          x2="124.932"
          y2="64.7593"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDEAFF" />
          <stop offset="1" stopColor="#F0F6FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_439_595"
          x1="207.087"
          y1="-17.01"
          x2="55.6783"
          y2="462.494"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#81B2FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_439_595"
          x1="106.496"
          y1="180.395"
          x2="-43.4481"
          y2="20.5616"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_439_595"
          x1="106.496"
          y1="180.395"
          x2="-43.4481"
          y2="20.5616"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const DefaultEmptyState = (props: any) => {
  const prefix = useMemo(() => uuidv4(), []);
  return (
    <svg {...props} width="212" height="144" viewBox="0 0 212 144" fill="none">
      <path
        d="M105.624 143.655C163.959 143.655 211.248 131.96 211.248 117.533C211.248 103.106 163.959 91.4106 105.624 91.4106C47.2895 91.4106 0 103.106 0 117.533C0 131.96 47.2895 143.655 105.624 143.655Z"
        fill={`url(#${prefix}paint0_linear_439_569)`}
      />
      <path
        d="M26.4541 45.2552L67.5557 0V90.5104H26.4541V45.2552Z"
        fill={`url(#${prefix}paint1_linear_439_569)`}
      />
      <path
        d="M186.163 45.2552L145.061 0V90.5104H186.163V45.2552Z"
        fill={`url(#${prefix}paint2_linear_439_569)`}
      />
      <rect
        x="67.5557"
        width="77.5059"
        height="88.1896"
        fill={`url(#${prefix}paint3_linear_439_569)`}
      />
      <path
        d="M70.6001 52.8701C69.502 48.3987 65.4928 45.2549 60.8886 45.2549H26.4541V119.52H186.163V45.2549H151.729C147.124 45.2549 143.115 48.3987 142.017 52.8701L141.06 56.7685C139.962 61.2399 135.953 64.3837 131.348 64.3837H81.2688C76.6646 64.3837 72.6554 61.2399 71.5574 56.7685L70.6001 52.8701Z"
        fill={`url(#${prefix}paint4_linear_439_569)`}
      />
      <defs>
        <linearGradient
          id={`${prefix}paint0_linear_439_569`}
          x1="115.278"
          y1="164.098"
          x2="124.932"
          y2="35.7593"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDEAFF" />
          <stop offset="1" stopColor="#F0F6FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint1_linear_439_569`}
          x1="58.7482"
          y1="-5.80195"
          x2="-44.6106"
          y2="92.1752"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#81B2FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint2_linear_439_569`}
          x1="142.126"
          y1="-10.4435"
          x2="204.465"
          y2="51.2528"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#81B2FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint3_linear_439_569`}
          x1="106.309"
          y1="107.916"
          x2="27.4184"
          y2="-25.0384"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint4_linear_439_569`}
          x1="159.154"
          y1="223.603"
          x2="138.931"
          y2="12.001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const PayoutMethodsEmptyState = (props: any) => {
  return (
    <Icon
      {...props}
      $size={212}
      width="212"
      height="185"
      viewBox="0 0 212 185"
      fill="none"
    >
      <path
        d="M105.624 184.909C163.959 184.909 211.248 173.214 211.248 158.787C211.248 144.36 163.959 132.665 105.624 132.665C47.2895 132.665 0 144.36 0 158.787C0 173.214 47.2895 184.909 105.624 184.909Z"
        fill="url(#paint0_linear_439_1012)"
      />
      <path
        d="M155.977 80.8358C158.374 80.8358 160.371 79.1179 160.871 76.795C161.37 74.573 161.27 72.2493 160.671 70.1284L149.487 26.086L131.267 25.2988L146.99 16.288L145.692 11.3384C143.464 2.77778 134.758 -1.58972 127.518 0.529885L21.082 28.3087C13.0195 30.3993 8.16175 38.8845 10.3972 46.6932L11.5955 51.5415L30.9157 52.0237L14.092 61.3402L25.3639 105.483C27.1613 112.251 33.2523 116.797 39.8429 116.797C42.9289 116.797 44.4154 116.089 46.334 115.686C48.5312 115.08 50.1286 113.06 50.1286 110.736V85.8865C50.1286 83.0578 52.3252 80.8358 55.1215 80.8358H155.977ZM154.979 126.292H95.0643C100.574 126.292 105.05 121.759 105.05 116.191V95.9879C105.05 90.4193 100.574 85.8865 95.0643 85.8865H65.107C59.5971 85.8865 55.1212 90.4193 55.1212 95.9879V116.191C55.1212 121.759 59.5971 126.292 65.107 126.292C59.5971 126.292 55.1212 130.825 55.1212 136.393C55.1212 141.962 59.5971 146.495 65.107 146.495H154.979C160.489 146.495 164.965 141.962 164.965 136.393C164.965 130.825 160.489 126.292 154.979 126.292ZM144.993 85.8865C139.483 85.8865 135.007 90.4193 135.007 95.9879C135.007 101.556 139.483 106.089 144.993 106.089H154.979C160.489 106.089 164.965 101.556 164.965 95.9879C164.965 90.4193 160.489 85.8865 154.979 85.8865H144.993Z"
        fill="url(#paint1_linear_439_1012)"
      />
      <path
        d="M146.886 17.2344L12.0068 52.2409L14.4938 61.9709L149.373 26.9637L146.886 17.2344ZM165.123 71.2994H55.3669C47.1389 71.2994 40.4454 78.0486 40.4454 86.3453V146.529C40.4454 154.826 47.1389 161.575 55.3669 161.575H165.123C173.352 161.575 180.045 154.826 180.045 146.529V86.3453C180.045 78.0486 173.352 71.2994 165.123 71.2994ZM60.3408 96.3759C60.3408 93.6037 62.5654 91.3606 65.3147 91.3606H95.1578C97.907 91.3606 100.132 93.6037 100.132 96.3759V116.437C100.132 119.209 97.907 121.452 95.1578 121.452H65.3147C62.5654 121.452 60.3408 119.209 60.3408 116.437V96.3759ZM154.844 141.514H65.3147C62.5654 141.514 60.3408 139.27 60.3408 136.498C60.3408 133.726 62.5654 131.483 65.3147 131.483H154.844C157.593 131.483 159.818 133.726 159.818 136.498C159.818 139.27 157.593 141.514 154.844 141.514ZM154.844 101.391H144.896C142.147 101.391 139.923 99.148 139.923 96.3759C139.923 93.6037 142.147 91.3606 144.896 91.3606H154.844C157.593 91.3606 159.818 93.6037 159.818 96.3759C159.818 99.148 157.593 101.391 154.844 101.391Z"
        fill="url(#paint2_linear_439_1012)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_439_1012"
          x1="115.278"
          y1="205.353"
          x2="124.932"
          y2="77.0137"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDEAFF" />
          <stop offset="1" stopColor="#F0F6FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_439_1012"
          x1="176.044"
          y1="-16.9032"
          x2="-121.648"
          y2="286.971"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#81B2FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_439_1012"
          x1="151.627"
          y1="363.87"
          x2="80.5728"
          y2="-38.6098"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const DarkModeSilverWithBg = (props: any) => (
  <Icon
    {...props}
    $size={78}
    width="78"
    height="82"
    viewBox="0 0 78 82"
    fill="none"
  >
    <g clipPath="url(#clip0_933_72508)">
      <rect
        width="78"
        height="82"
        rx="8"
        fill="url(#paint0_linear_933_72508)"
        fillOpacity="0.8"
      />
      <path
        opacity="0.2"
        d="M35.8751 43.5L8.87506 90L-8.62494 80.5L-5.12494 58L35.8751 43.5Z"
        fill="url(#paint1_linear_933_72508)"
      />
      <path
        opacity="0.2"
        d="M38.8751 49.7609L92.1134 42.2159L85.4176 62.2205L38.8751 49.7609Z"
        fill="url(#paint2_linear_933_72508)"
      />
      <path
        opacity="0.2"
        d="M42.1469 49.3157L79.0704 88.404L58.875 94.5L42.1469 49.3157Z"
        fill="url(#paint3_linear_933_72508)"
      />
      <path
        opacity="0.2"
        d="M37.8752 40.9999L-3.62489 24L-3.62488 3.00045L1.37525 3.00043L37.8752 40.9999Z"
        fill="url(#paint4_linear_933_72508)"
      />
      <path
        opacity="0.2"
        d="M44.875 34.5L71.875 -12L84.375 0L85.875 14L44.875 34.5Z"
        fill="url(#paint5_linear_933_72508)"
      />
      <path
        opacity="0.2"
        d="M37.5584 35.1758L22 -3.49998L44 -3.49988L42.0882 34.2206L37.5584 35.1758Z"
        fill="url(#paint6_linear_933_72508)"
      />
      <path
        d="M37.8895 11.3692L13.2103 24.696C13.1677 24.719 13.1286 24.7481 13.0943 24.7824L12.773 25.1037C12.6909 25.1858 12.6399 25.2939 12.6288 25.4094L10.1597 51.0877C10.1508 51.1812 10.1683 51.2752 10.2102 51.3592L10.6157 52.1702C10.6358 52.2103 10.6612 52.2476 10.6913 52.281L15.0935 57.1724C15.1283 57.211 15.1689 57.244 15.2138 57.2702L36.3993 69.5873C36.5522 69.6762 36.7407 69.6777 36.8949 69.5913L61.4171 55.8589C61.5605 55.7786 61.6552 55.6331 61.6706 55.4696L64.1361 29.3357C64.1426 29.2665 64.1346 29.1966 64.1126 29.1306L63.6954 27.8789C63.6632 27.7824 63.6024 27.698 63.521 27.637L59.646 24.7307L38.3929 11.3858C38.2403 11.2899 38.048 11.2836 37.8895 11.3692Z"
        fill="url(#paint7_linear_933_72508)"
      />
      <path
        d="M12.5479 25.8101L10.2584 50.9943C10.1896 51.7516 10.5561 52.4823 11.2041 52.88L31.1651 65.1288C31.7723 65.5014 32.532 65.5229 33.1593 65.1851L57.1807 52.2505C57.782 51.9267 58.1765 51.3184 58.227 50.6373L60.056 25.9458C60.1113 25.1995 59.7453 24.4848 59.1075 24.0934L39.1189 11.8277C38.516 11.4577 37.7624 11.4338 37.1371 11.7648L13.6039 24.2236C13.0063 24.5399 12.6091 25.1368 12.5479 25.8101Z"
        fill="url(#paint8_linear_933_72508)"
      />
      <path
        d="M15.5991 28.4573L13.7571 48.9919C13.6891 49.7504 14.0577 50.4818 14.7079 50.8782L30.6996 60.6292C31.3099 61.0014 32.0725 61.0195 32.6998 60.6767L52.6825 49.7572C53.2826 49.4293 53.6735 48.8175 53.719 48.1352L55.0666 27.9218C55.1155 27.1881 54.7579 26.4868 54.1354 26.0955L38.6256 16.3465C38.0196 15.9656 37.2562 15.9375 36.6239 16.2731L16.6537 26.8693C16.0563 27.1863 15.6596 27.7838 15.5991 28.4573Z"
        fill="url(#paint9_linear_933_72508)"
      />
      <path
        d="M28.2479 35.8895L25.146 33.2307L23.245 32.4703C22.9416 32.349 22.6053 32.5465 22.5634 32.8706L20.682 47.4519C20.6596 47.625 20.7292 47.7973 20.8655 47.9063L23.009 49.6211C23.0977 49.6921 23.2078 49.7307 23.3214 49.7307H48.192C48.4495 49.7307 48.6649 49.5352 48.6897 49.2789L50.1129 34.5725C50.1328 34.3666 50.0239 34.1697 49.8389 34.0771L48.3915 33.3535C48.2386 33.277 48.0572 33.284 47.9106 33.3719L43.5617 35.9813C43.3301 36.1203 43.0299 36.0502 42.8839 35.8229L38.7024 29.3185C38.6652 29.2606 38.6164 29.211 38.5592 29.1728L36.0327 27.4885C35.8147 27.3432 35.5215 27.3908 35.3607 27.5976L28.9679 35.8168C28.7927 36.0421 28.4646 36.0752 28.2479 35.8895Z"
        fill="#A9A9A9"
      />
      <path
        d="M21.5839 32.7242L20.6792 47.1995C20.6612 47.4874 20.8898 47.7307 21.1782 47.7307H46.692C46.9495 47.7307 47.1649 47.5352 47.1897 47.2789L48.5334 33.3943C48.5758 32.9564 48.0727 32.6811 47.7268 32.9529L42.1016 37.3728C41.8615 37.5614 41.51 37.4927 41.3585 37.2277L36.0235 27.8914C35.8451 27.5791 35.4052 27.5518 35.1894 27.8395L28.4642 36.8065C28.2916 37.0366 27.9608 37.074 27.7412 36.8882L22.4059 32.3737C22.092 32.1081 21.6096 32.3138 21.5839 32.7242Z"
        fill="url(#paint10_linear_933_72508)"
      />
      <path
        d="M15.7292 50.0637L16.146 51.7307L13.646 49.7307L15.646 27.7307L38.146 15.7307L41.646 18.2307L37.9678 17.7709C37.7586 17.7448 37.5465 17.7854 37.3618 17.887L18.5729 28.2209C17.993 28.5399 17.6084 29.125 17.5457 29.7838L15.6785 49.389C15.657 49.6152 15.6741 49.8433 15.7292 50.0637Z"
        fill="#B1B1B1"
      />
      <path
        d="M37.4325 13.4348L31.8263 15.0367C31.6444 15.0886 31.5126 14.8646 31.6463 14.7309L38.1463 11.231L60.1463 24.9355L64.146 28.2311L64.1458 30.7312L59.7146 28.6372L58.7666 26.0581C58.6887 25.8462 58.5414 25.6669 58.3486 25.5493L38.7802 13.6174C38.3761 13.371 37.8875 13.3048 37.4325 13.4348Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.254 11.9858C37.801 11.6962 38.4604 11.7171 38.988 12.0409L58.9766 24.3066C59.2136 24.452 59.4076 24.6484 59.5488 24.8763L59.5072 24.9388L59.6287 25.0198C59.7658 25.2959 59.8302 25.6084 59.8065 25.9274L57.9775 50.6189C57.9334 51.2149 57.5882 51.7472 57.062 52.0305L33.0406 64.965C32.4917 65.2606 31.827 65.2418 31.2957 64.9158L11.4242 52.7219L10.8317 52.0635L10.7739 52.1155C10.5698 51.7948 10.4715 51.41 10.5072 51.017L12.7967 25.8328C12.8503 25.2436 13.1979 24.7214 13.7207 24.4446L37.254 11.9858ZM11.101 53.1102L11.0732 53.0932C10.3442 52.6458 9.93183 51.8237 10.0093 50.9718L12.2987 25.7875C12.3676 25.03 12.8145 24.3586 13.4868 24.0027L37.02 11.5439C37.7234 11.1716 38.5712 11.1985 39.2495 11.6147L59.2381 23.8804C59.5634 24.08 59.8258 24.3544 60.0097 24.6729L63.2962 26.8639C63.9816 27.3208 64.3625 28.1157 64.2892 28.9361L61.9897 54.6909C61.923 55.4377 61.4887 56.1023 60.8314 56.4631L37.2688 69.3995C36.5699 69.7832 35.7202 69.7684 35.0351 69.3606L15.2787 57.6008C15.0843 57.4851 14.9084 57.3407 14.7571 57.1725L11.101 53.1102ZM12.6034 54.0322L15.1287 56.8381C15.2464 56.9688 15.3832 57.0811 15.5344 57.1711L35.2909 68.9309C35.8237 69.2481 36.4846 69.2596 37.0282 68.9612L60.5908 56.0248C61.102 55.7442 61.4398 55.2273 61.4917 54.6464L63.7912 28.8917C63.8482 28.2535 63.5519 27.6353 63.0189 27.2799L60.2855 25.4577C60.3108 25.6232 60.3178 25.7931 60.3052 25.9644L58.4762 50.6559C58.4194 51.4221 57.9755 52.1064 57.299 52.4707L33.2777 65.4053C32.5719 65.7853 31.7173 65.7612 31.0342 65.3419L12.6034 54.0322ZM35.3893 27.9896C35.4972 27.8457 35.7171 27.8594 35.8063 28.0155L41.1413 37.3518C41.3685 37.7494 41.8958 37.8523 42.2559 37.5694L47.8811 33.1496C48.0541 33.0137 48.3056 33.1513 48.2844 33.3703L46.9407 47.2549C46.9283 47.383 46.8206 47.4808 46.6919 47.4808H21.1781C21.0339 47.4808 20.9196 47.3591 20.9286 47.2152L21.8333 32.7399C21.8461 32.5347 22.0873 32.4318 22.2443 32.5646L27.5796 37.0791C27.909 37.3579 28.4051 37.3018 28.664 36.9566L35.3893 27.9896ZM36.1789 27.6757C35.8823 27.2956 35.2904 27.2881 34.9893 27.6896L28.7581 35.9978L25.3829 33.1047C25.3092 33.0416 25.224 32.9933 25.132 32.9627L22.2249 31.9936L22.2174 32.0161C21.8024 31.941 21.364 32.2333 21.3342 32.7087L20.4295 47.184C20.4058 47.5641 20.6687 47.8925 21.0271 47.9656L22.8226 49.7611C22.9633 49.9018 23.154 49.9808 23.353 49.9808H48.1919C48.5781 49.9808 48.9012 49.6875 48.9384 49.303L50.3658 34.5529C50.3925 34.2777 50.2655 34.0101 50.0353 33.8567L48.7845 33.0228L48.7417 33.087C48.5784 32.6383 47.9965 32.423 47.5722 32.7564L43.3448 36.078L38.9193 29.1939C38.857 29.0969 38.7731 29.0156 38.6743 28.9563L36.2745 27.5164L36.1789 27.6757ZM23.4483 32.9285L27.9025 36.6974C28.0123 36.7903 28.1777 36.7716 28.264 36.6566L28.4575 36.3986L25.0575 33.4843C25.033 33.4633 25.0046 33.4472 24.9739 33.437L23.4483 32.9285ZM36.5114 28.2417L41.5755 37.1037C41.6512 37.2362 41.827 37.2706 41.947 37.1763L43.1703 36.2151L42.9356 36.366L38.4987 29.4642C38.4779 29.4319 38.45 29.4048 38.4171 29.3851L36.5114 28.2417ZM48.7636 33.6097L47.4384 47.303C47.4012 47.6875 47.0781 47.9808 46.6919 47.9808H21.7494L23.1762 49.4076C23.2231 49.4545 23.2866 49.4808 23.353 49.4808H48.1919C48.3206 49.4808 48.4283 49.383 48.4407 49.2549L49.8682 34.5048C49.877 34.413 49.8347 34.3238 49.758 34.2727L48.7636 33.6097ZM38.4924 16.5582C37.9622 16.2249 37.2942 16.2004 36.7409 16.494L16.7707 27.0903C16.248 27.3676 15.9009 27.8904 15.848 28.4798L14.006 49.0144C13.9464 49.678 14.269 50.3179 14.8379 50.6648L30.8296 60.4159C31.3636 60.7415 32.0309 60.7573 32.5798 60.4574L52.5625 49.5379C53.0876 49.251 53.4296 48.7157 53.4694 48.1186L54.817 27.9052C54.8598 27.2633 54.5469 26.6496 54.0022 26.3072L38.4924 16.5582ZM36.5065 16.0523C37.2179 15.6748 38.0767 15.7064 38.7585 16.1349L54.2683 25.8839C54.9686 26.3241 55.3709 27.1131 55.3159 27.9385L53.9683 48.1519C53.9172 48.9195 53.4773 49.6078 52.8022 49.9767L32.8196 60.8962C32.1138 61.2818 31.2559 61.2615 30.5693 60.8428L14.5776 51.0917C13.8461 50.6457 13.4314 49.823 13.508 48.9697L15.35 28.4351C15.418 27.6773 15.8643 27.0052 16.5364 26.6486L36.5065 16.0523Z"
        fill="#373D54"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_933_72508"
        x1="74"
        y1="7"
        x2="0.368014"
        y2="98.7952"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EBEBEB" stopOpacity="0.7" />
        <stop offset="1" stopColor="#A3A3A3" stopOpacity="0.7" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_933_72508"
        x1="20.5001"
        y1="55"
        x2="-22.3357"
        y2="95.3298"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_933_72508"
        x1="54"
        y1="45"
        x2="129.2"
        y2="48.0321"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_933_72508"
        x1="45.9999"
        y1="57"
        x2="98.1281"
        y2="127.056"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_933_72508"
        x1="25"
        y1="30"
        x2="-33.1569"
        y2="7.09149"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.130582" stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_933_72508"
        x1="53"
        y1="25"
        x2="93.3795"
        y2="-14.6676"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_933_72508"
        x1="40.3266"
        y1="33.9176"
        x2="5.92544"
        y2="-17.58"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.191882" stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_933_72508"
        x1="25.646"
        y1="55.7307"
        x2="66.146"
        y2="27.7307"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9A9A9A" />
        <stop offset="0.0315245" stopColor="#AEAEAE" />
        <stop offset="0.569143" stopColor="#C1C1C1" />
        <stop offset="0.619523" stopColor="#E0E0E0" />
        <stop offset="1" stopColor="#CCCCCC" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_933_72508"
        x1="8.646"
        y1="40.2307"
        x2="60.646"
        y2="36.7307"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCFCFC" />
        <stop offset="1" stopColor="#E9E9E9" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_933_72508"
        x1="17.146"
        y1="40.7307"
        x2="56.146"
        y2="36.2307"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EAEAEA" />
        <stop offset="1" stopColor="#F6F6F6" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_933_72508"
        x1="48.146"
        y1="36.7307"
        x2="21.146"
        y2="34.7307"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E8E8E8" />
        <stop offset="1" stopColor="#FDFDFD" />
      </linearGradient>
      <clipPath id="clip0_933_72508">
        <rect width="78" height="82" rx="8" fill="white" />
      </clipPath>
    </defs>
  </Icon>
);

export const DarkModeGoldWithBg = (props: any) => (
  <Icon
    {...props}
    $size={78}
    width="78"
    height="82"
    viewBox="0 0 78 82"
    fill="none"
  >
    <g clipPath="url(#clip0_933_72568)">
      <rect
        width="78"
        height="82"
        rx="8"
        fill="url(#paint0_linear_933_72568)"
        fillOpacity="0.9"
      />
      <path
        opacity="0.14"
        d="M37 37.5L10 84L-7.5 74.5L-4 52L37 37.5Z"
        fill="url(#paint1_linear_933_72568)"
      />
      <path
        opacity="0.14"
        d="M40 43.7609L93.2384 36.2159L86.5426 56.2205L40 43.7609Z"
        fill="url(#paint2_linear_933_72568)"
      />
      <path
        opacity="0.14"
        d="M43.2718 43.3157L80.1954 82.404L59.9999 88.5L43.2718 43.3157Z"
        fill="url(#paint3_linear_933_72568)"
      />
      <path
        opacity="0.14"
        d="M39.0001 34.9999L-2.50001 18L-2.5 -2.99955L2.50013 -2.99957L39.0001 34.9999Z"
        fill="url(#paint4_linear_933_72568)"
      />
      <path
        opacity="0.14"
        d="M46 28.5L73 -18L85.5 -6L87 8L46 28.5Z"
        fill="url(#paint5_linear_933_72568)"
      />
      <path
        d="M37.8895 11.3692L13.2103 24.696C13.1677 24.719 13.1286 24.7481 13.0943 24.7824L12.773 25.1037C12.6909 25.1858 12.6399 25.2939 12.6288 25.4094L10.1597 51.0877C10.1508 51.1812 10.1683 51.2752 10.2102 51.3592L10.6157 52.1702C10.6358 52.2103 10.6612 52.2476 10.6913 52.281L15.0935 57.1724C15.1283 57.211 15.1689 57.244 15.2138 57.2702L36.3993 69.5873C36.5522 69.6762 36.7407 69.6777 36.8949 69.5913L61.4171 55.8589C61.5605 55.7786 61.6552 55.6331 61.6706 55.4696L64.1361 29.3357C64.1426 29.2665 64.1346 29.1966 64.1126 29.1306L63.6954 27.8789C63.6632 27.7824 63.6024 27.698 63.521 27.637L59.646 24.7307L38.3929 11.3858C38.2403 11.2899 38.048 11.2836 37.8895 11.3692Z"
        fill="url(#paint6_linear_933_72568)"
      />
      <path
        d="M12.5479 25.8101L10.2584 50.9943C10.1896 51.7516 10.5561 52.4823 11.2041 52.88L31.1651 65.1288C31.7723 65.5014 32.532 65.5229 33.1593 65.1851L57.1807 52.2505C57.782 51.9267 58.1765 51.3184 58.227 50.6373L60.056 25.9458C60.1113 25.1995 59.7453 24.4848 59.1075 24.0934L39.1189 11.8277C38.516 11.4577 37.7624 11.4338 37.1371 11.7648L13.6039 24.2236C13.0063 24.5399 12.6091 25.1368 12.5479 25.8101Z"
        fill="url(#paint7_linear_933_72568)"
      />
      <path
        d="M15.5991 28.4573L13.7571 48.9919C13.6891 49.7504 14.0577 50.4818 14.7079 50.8782L30.6996 60.6292C31.3099 61.0014 32.0725 61.0195 32.6998 60.6767L52.6825 49.7572C53.2826 49.4293 53.6735 48.8175 53.719 48.1352L55.0666 27.9218C55.1155 27.1881 54.7579 26.4868 54.1354 26.0955L38.6256 16.3465C38.0196 15.9656 37.2562 15.9375 36.6239 16.2731L16.6537 26.8693C16.0563 27.1863 15.6596 27.7838 15.5991 28.4573Z"
        fill="url(#paint8_linear_933_72568)"
      />
      <path
        d="M28.2479 35.8895L25.146 33.2307L23.245 32.4703C22.9416 32.349 22.6053 32.5465 22.5634 32.8706L20.682 47.4519C20.6596 47.625 20.7292 47.7973 20.8655 47.9063L23.009 49.6211C23.0977 49.6921 23.2078 49.7307 23.3214 49.7307H48.1983C48.4532 49.7307 48.6672 49.5391 48.6953 49.2858L50.4665 33.3024C50.4871 33.1166 50.4024 32.9349 50.2469 32.8313L49.2414 32.161C49.0921 32.0614 48.901 32.0495 48.7405 32.1298L47.0526 32.9737C47.0176 32.9912 46.9849 33.0127 46.955 33.0378L43.574 35.8719C43.3457 36.0633 43.0016 36.0138 42.8366 35.7657L39.1606 30.2413C39.0613 30.0921 39.0495 29.9011 39.1296 29.7407L40.3388 27.3223C40.4351 27.1298 40.3974 26.8974 40.2452 26.7452L38.5726 25.0726C38.5247 25.0247 38.4676 24.987 38.4047 24.9619L36.611 24.2444C36.3039 24.1216 35.9643 24.3254 35.9283 24.6542L35.6614 27.09C35.6513 27.182 35.6159 27.2694 35.5591 27.3425L28.9679 35.8168C28.7927 36.0421 28.4646 36.0752 28.2479 35.8895Z"
        fill="#FAA931"
      />
      <path
        d="M21.4587 32.7609L20.6746 47.2036C20.6591 47.49 20.8871 47.7307 21.1739 47.7307H46.6919C46.9494 47.7307 47.1649 47.5351 47.1896 47.2787L48.6904 31.7115L47.0772 32.464C47.0261 32.4878 46.9794 32.5201 46.9391 32.5595L42.1112 37.2763C41.8763 37.5057 41.4877 37.4503 41.3263 37.1644L37.1307 29.7316C37.049 29.5868 37.0446 29.4109 37.1189 29.2622L38.3388 26.8223C38.4351 26.6298 38.3974 26.3974 38.2452 26.2452L36.3229 24.3229C36.14 24.14 35.8479 24.1268 35.6492 24.2923L33.2382 26.3015C33.0923 26.4231 33.0279 26.6169 33.072 26.8016L33.7165 29.5024C33.751 29.647 33.7194 29.7995 33.6302 29.9185L31.896 32.2307L28.476 36.7907C28.299 37.0266 27.9574 37.059 27.7393 36.8604L23.5512 33.0466C23.5172 33.0157 23.4792 32.9896 23.4381 32.9691L22.1816 32.3408C21.8596 32.1798 21.4782 32.4015 21.4587 32.7609Z"
        fill="url(#paint9_linear_933_72568)"
      />
      <path
        d="M15.7292 50.0637L16.146 51.7307L13.646 49.7307L15.646 27.7307L38.146 15.7307L41.646 18.2307L37.9678 17.7709C37.7586 17.7448 37.5465 17.7854 37.3618 17.887L18.5729 28.2209C17.993 28.5399 17.6084 29.125 17.5457 29.7838L15.6785 49.389C15.657 49.6152 15.6741 49.8433 15.7292 50.0637Z"
        fill="#FDAC28"
      />
      <path
        d="M37.4325 13.4348L31.8263 15.0367C31.6444 15.0886 31.5126 14.8646 31.6463 14.7309L38.1463 11.231L60.1463 24.9355L64.146 28.2311L64.1458 30.7312L59.7146 28.6372L58.7666 26.0581C58.6887 25.8462 58.5414 25.6669 58.3486 25.5493L38.7802 13.6174C38.3761 13.371 37.8875 13.3048 37.4325 13.4348Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.254 11.9858C37.801 11.6962 38.4604 11.7171 38.988 12.0409L58.9766 24.3066C59.2136 24.452 59.4076 24.6484 59.5488 24.8763L59.5072 24.9388L59.6287 25.0198C59.7658 25.2959 59.8302 25.6084 59.8065 25.9274L57.9775 50.6189C57.9334 51.2149 57.5882 51.7472 57.062 52.0305L33.0406 64.965C32.4917 65.2606 31.827 65.2418 31.2957 64.9158L11.4242 52.7219L10.8317 52.0635L10.7739 52.1155C10.5698 51.7948 10.4715 51.41 10.5072 51.017L12.7967 25.8328C12.8503 25.2436 13.1979 24.7214 13.7207 24.4446L37.254 11.9858ZM11.101 53.1102L11.0732 53.0932C10.3442 52.6458 9.93183 51.8237 10.0093 50.9718L12.2987 25.7875C12.3676 25.03 12.8145 24.3586 13.4868 24.0027L37.02 11.5439C37.7234 11.1716 38.5712 11.1985 39.2495 11.6147L59.2381 23.8804C59.5634 24.08 59.8258 24.3544 60.0097 24.6729L63.2962 26.8639C63.9816 27.3208 64.3625 28.1157 64.2892 28.9361L61.9897 54.6909C61.923 55.4377 61.4887 56.1023 60.8314 56.4631L37.2688 69.3995C36.5699 69.7832 35.7202 69.7684 35.0351 69.3606L15.2787 57.6008C15.0843 57.4851 14.9084 57.3407 14.7571 57.1725L11.101 53.1102ZM12.6034 54.0322L15.1287 56.8381C15.2464 56.9688 15.3832 57.0811 15.5344 57.1711L35.2909 68.9309C35.8237 69.2481 36.4846 69.2596 37.0282 68.9612L60.5908 56.0248C61.102 55.7442 61.4398 55.2273 61.4917 54.6464L63.7912 28.8917C63.8482 28.2535 63.5519 27.6353 63.0189 27.2799L60.2855 25.4577C60.3108 25.6232 60.3178 25.7931 60.3052 25.9644L58.4762 50.6559C58.4194 51.4221 57.9755 52.1064 57.299 52.4707L33.2777 65.4053C32.5719 65.7853 31.7173 65.7612 31.0342 65.3419L12.6034 54.0322ZM35.7866 23.9714L38.4429 24.7241C38.5661 24.759 38.6783 24.8248 38.7688 24.9153L40.4219 26.5685C40.6502 26.7968 40.7068 27.1455 40.5624 27.4342L39.3532 29.8526C39.3131 29.9328 39.319 30.0283 39.3687 30.1029L43.2191 35.8896L46.9736 32.3189L46.9808 32.312L46.9886 32.3057L47.8974 31.5705C48.32 31.2286 48.9067 31.4414 49.0736 31.8895L49.1386 31.7919L50.3855 32.6231C50.6188 32.7786 50.7458 33.0512 50.7149 33.3298L48.9436 49.3134C48.9015 49.6933 48.5804 49.9808 48.1982 49.9808H23.353C23.154 49.9808 22.9633 49.9018 22.8226 49.7611L21.0271 47.9656C20.6687 47.8925 20.4058 47.5641 20.4295 47.184L21.3342 32.7087C21.3727 32.0931 22.0964 31.7845 22.5672 32.1829L22.7009 32.2961L25.1049 32.9601C25.2111 32.9895 25.3096 33.0419 25.3933 33.1136L28.7629 36.0018L33.6416 29.5592C33.6914 29.4935 33.7056 29.4074 33.6795 29.3292L32.8605 26.8723C32.7707 26.6028 32.8408 26.3057 33.0417 26.1048L35.0003 24.1462C35.1542 23.9923 35.3597 23.9185 35.5631 23.9272L35.5681 23.9095L35.6833 23.9421C35.7183 23.9494 35.7528 23.9591 35.7866 23.9714ZM28.4605 36.4012L25.0679 33.4932C25.04 33.4693 25.0071 33.4518 24.9717 33.4421L23.6111 33.0662L25.0573 34.2899L27.9044 36.699C28.0139 36.7916 28.1786 36.7734 28.2652 36.6591L28.4605 36.4012ZM22.437 32.7278L22.4334 32.7409L22.4619 32.7488L23.1094 33.2966L24.7344 34.6716L27.5814 37.0807C27.9098 37.3586 28.4041 37.3039 28.6638 36.9609L34.0402 29.861C34.1895 29.6639 34.232 29.4057 34.1538 29.1711L33.3349 26.7142C33.3049 26.6243 33.3283 26.5253 33.3953 26.4583L35.3539 24.4997C35.4122 24.4414 35.4928 24.4176 35.5693 24.4295L35.6276 24.446C35.6499 24.4554 35.6712 24.4682 35.6907 24.4844L38.0357 26.4386C38.1248 26.5129 38.1511 26.6387 38.0993 26.7425L36.8953 29.1504C36.7838 29.3735 36.7904 29.6374 36.913 29.8545L41.1129 37.2952C41.3529 37.7205 41.929 37.8065 42.2829 37.47L47.3109 32.6881L48.2118 31.9593C48.3855 31.8188 48.6422 31.9592 48.6176 32.1812L46.9467 47.2583C46.9326 47.385 46.8256 47.4808 46.6982 47.4808H21.1781C21.0339 47.4808 20.9196 47.3591 20.9286 47.2152L21.8333 32.7399C21.8461 32.5347 22.0873 32.4318 22.2443 32.5646L22.437 32.7278ZM36.8368 24.7886L38.3066 25.2051C38.3477 25.2168 38.385 25.2387 38.4152 25.2689L40.0684 26.922C40.1445 26.9981 40.1633 27.1144 40.1152 27.2106L38.906 29.629C38.7857 29.8695 38.8034 30.156 38.9524 30.3799L42.8513 36.2394L41.9383 37.1077C41.8203 37.2198 41.6283 37.1912 41.5483 37.0494L37.3484 29.6087C37.3075 29.5364 37.3053 29.4484 37.3425 29.3741L38.5465 26.9661C38.7021 26.6548 38.6232 26.2773 38.3558 26.0545L36.8368 24.7886ZM21.7494 47.9808L23.1762 49.4076C23.2231 49.4545 23.2866 49.4808 23.353 49.4808H48.1982C48.3256 49.4808 48.4326 49.385 48.4467 49.2583L50.218 33.2747C50.2283 33.1819 50.1859 33.091 50.1082 33.0392L49.1 32.3671L47.4436 47.3134C47.4015 47.6933 47.0804 47.9808 46.6982 47.9808H21.7494ZM38.4924 16.5582C37.9622 16.2249 37.2942 16.2004 36.7409 16.494L16.7707 27.0903C16.248 27.3676 15.9009 27.8904 15.848 28.4798L14.006 49.0144C13.9464 49.678 14.269 50.3179 14.8379 50.6648L30.8296 60.4159C31.3636 60.7415 32.0309 60.7573 32.5798 60.4574L52.5625 49.5379C53.0876 49.251 53.4296 48.7157 53.4694 48.1186L54.817 27.9052C54.8598 27.2633 54.5469 26.6496 54.0022 26.3072L38.4924 16.5582ZM36.5065 16.0523C37.2179 15.6748 38.0767 15.7064 38.7585 16.1349L54.2683 25.8839C54.9686 26.3241 55.3709 27.1131 55.3159 27.9385L53.9683 48.1519C53.9172 48.9195 53.4773 49.6078 52.8022 49.9767L32.8196 60.8962C32.1138 61.2818 31.2559 61.2615 30.5693 60.8428L14.5776 51.0917C13.8461 50.6457 13.4314 49.823 13.508 48.9697L15.35 28.4351C15.418 27.6773 15.8643 27.0052 16.5364 26.6486L36.5065 16.0523Z"
        fill="#A06000"
      />
      <path
        d="M36.7996 39.5749C36.7735 40.8722 35.9218 41.8077 35.0047 41.7893C34.0875 41.7708 33.2742 40.8018 33.3003 39.5045C33.3264 38.2072 34.178 37.2717 35.0952 37.2902C36.0123 37.3086 36.8257 38.2776 36.7996 39.5749Z"
        fill="#FEAC2D"
        stroke="#A06000"
        strokeWidth="0.5"
      />
      <circle cx="35.5" cy="38.5" r="0.5" fill="white" />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_933_72568"
        x1="83.5714"
        y1="-9.46154"
        x2="39.3674"
        y2="82.1772"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFEAA7" stopOpacity="0.8" />
        <stop offset="1" stopColor="#FFC33F" stopOpacity="0.5" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_933_72568"
        x1="77.5"
        y1="0.500003"
        x2="9.54853"
        y2="84.489"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="#FFCB57" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_933_72568"
        x1="-14.1234"
        y1="34.8219"
        x2="84.7409"
        y2="38.4688"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="#FFDC83" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_933_72568"
        x1="19.2895"
        y1="-6.02092"
        x2="80.5362"
        y2="82.9757"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="#FFCB57" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_933_72568"
        x1="158.5"
        y1="107"
        x2="-16.4815"
        y2="44.8895"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="#FFDD85" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_933_72568"
        x1="-63.5"
        y1="102"
        x2="68.6145"
        y2="-2.22777"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="#FFE497" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_933_72568"
        x1="25.646"
        y1="55.7307"
        x2="66.146"
        y2="27.7307"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8A50D" />
        <stop offset="0.0315245" stopColor="#DF900F" />
        <stop offset="0.569143" stopColor="#FFA214" />
        <stop offset="0.619523" stopColor="#FDD05B" />
        <stop offset="1" stopColor="#FEC75C" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_933_72568"
        x1="8.646"
        y1="40.2307"
        x2="60.646"
        y2="36.7307"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEFFBB" />
        <stop offset="1" stopColor="#FDEC78" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_933_72568"
        x1="17.146"
        y1="40.7307"
        x2="56.146"
        y2="36.2307"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDDA5B" />
        <stop offset="1" stopColor="#FFE586" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_933_72568"
        x1="48.146"
        y1="36.7307"
        x2="21.146"
        y2="34.7307"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8EB7A" />
        <stop offset="1" stopColor="#FFFFB8" />
      </linearGradient>
      <clipPath id="clip0_933_72568">
        <rect width="78" height="82" rx="8" fill="white" />
      </clipPath>
    </defs>
  </Icon>
);

export const DarkModePlatinumWithBg = (props: any) => (
  <Icon
    {...props}
    $size={78}
    width="78"
    height="82"
    viewBox="0 0 78 82"
    fill="none"
  >
    <g clipPath="url(#clip0_933_72531)">
      <rect
        width="78"
        height="82"
        rx="8"
        fill="url(#paint0_linear_933_72531)"
        fillOpacity="0.9"
      />
      <path
        opacity="0.15"
        d="M38.5 35.5L2.5 83.5L-3.5 79V49L38.5 35.5Z"
        fill="url(#paint1_linear_933_72531)"
      />
      <path
        opacity="0.15"
        d="M38.5 34.9997L-1.50033 34.9998L-1.5003 24.0007L38.5 34.9997Z"
        fill="url(#paint2_linear_933_72531)"
      />
      <path
        opacity="0.15"
        d="M41.0747 36.4017L81.5 45.9998L81.5 70.9997L41.0747 36.4017Z"
        fill="url(#paint3_linear_933_72531)"
      />
      <path
        opacity="0.15"
        d="M41.95 46.7568L78.1772 85.1079L58.3627 91.0889L41.95 46.7568Z"
        fill="url(#paint4_linear_933_72531)"
      />
      <path
        opacity="0.15"
        d="M36.8548 34.2577L-1.99999 14L-1.00001 -1.5001L21 -4.99994L36.8548 34.2577Z"
        fill="url(#paint5_linear_933_72531)"
      />
      <path
        opacity="0.15"
        d="M38.5 35.5L70.5 -1.64516H80.5V18L38.5 35.5Z"
        fill="url(#paint6_linear_933_72531)"
      />
      <path
        d="M37.8895 11.3692L13.2103 24.696C13.1677 24.719 13.1286 24.7481 13.0943 24.7824L12.773 25.1037C12.6909 25.1858 12.6399 25.2939 12.6288 25.4094L10.1597 51.0877C10.1508 51.1812 10.1683 51.2752 10.2102 51.3592L10.6157 52.1702C10.6358 52.2103 10.6612 52.2476 10.6913 52.281L15.0935 57.1724C15.1283 57.211 15.1689 57.244 15.2138 57.2702L36.3993 69.5873C36.5522 69.6762 36.7407 69.6777 36.8949 69.5913L61.4171 55.8589C61.5605 55.7786 61.6552 55.6331 61.6706 55.4696L64.1361 29.3357C64.1426 29.2665 64.1346 29.1966 64.1126 29.1306L63.6954 27.8789C63.6632 27.7824 63.6024 27.698 63.521 27.637L59.646 24.7307L38.3929 11.3858C38.2403 11.2899 38.048 11.2836 37.8895 11.3692Z"
        fill="url(#paint7_linear_933_72531)"
      />
      <path
        d="M12.5479 25.8101L10.2584 50.9943C10.1896 51.7516 10.5561 52.4823 11.2041 52.88L31.1651 65.1288C31.7723 65.5014 32.532 65.5229 33.1593 65.1851L57.1807 52.2505C57.782 51.9267 58.1765 51.3184 58.227 50.6373L60.056 25.9458C60.1113 25.1995 59.7453 24.4848 59.1075 24.0934L39.1189 11.8277C38.516 11.4577 37.7624 11.4338 37.1371 11.7648L13.6039 24.2236C13.0063 24.5399 12.6091 25.1368 12.5479 25.8101Z"
        fill="url(#paint8_linear_933_72531)"
      />
      <path
        d="M15.5991 28.4573L13.7571 48.9919C13.6891 49.7504 14.0577 50.4818 14.7079 50.8782L30.6996 60.6292C31.3099 61.0014 32.0725 61.0195 32.6998 60.6767L52.6825 49.7572C53.2826 49.4293 53.6735 48.8175 53.719 48.1352L55.0666 27.9218C55.1155 27.1881 54.7579 26.4868 54.1354 26.0955L38.6256 16.3465C38.0196 15.9656 37.2562 15.9375 36.6239 16.2731L16.6537 26.8693C16.0563 27.1863 15.6596 27.7838 15.5991 28.4573Z"
        fill="url(#paint9_linear_933_72531)"
      />
      <path
        d="M28.6274 35.2806L25.146 33.2307L26 31.5L25.0829 30.1244C25.0288 30.0432 24.9522 29.9797 24.8624 29.9415L23.3415 29.2955C23.0117 29.1554 22.646 29.3974 22.646 29.7556V32.2307L20.682 47.4519C20.6596 47.625 20.7292 47.7973 20.8655 47.9063L23.009 49.6211C23.0977 49.6921 23.2078 49.7307 23.3214 49.7307H48.1908C48.4488 49.7307 48.6644 49.5344 48.6886 49.2775L50.4721 30.2972C50.4893 30.1141 50.4046 29.9364 50.2516 29.8344L49.4713 29.3142C49.221 29.1474 48.8812 29.2376 48.7467 29.5066L47.0464 32.9071C47.0158 32.9684 46.9729 33.0227 46.9204 33.0667L43.574 35.8719C43.3457 36.0633 43.0016 36.0138 42.8366 35.7657L39.1606 30.2413C39.0613 30.0921 39.0495 29.9011 39.1296 29.7407L40.3388 27.3223C40.4351 27.1298 40.3974 26.8974 40.2452 26.7452L38.5726 25.0726C38.5247 25.0247 38.4676 24.987 38.4047 24.9619L36.611 24.2444C36.3039 24.1216 35.9643 24.3254 35.9283 24.6542L35.6619 27.0857C35.6515 27.1804 35.6143 27.2702 35.5546 27.3444L29.2709 35.163C29.1153 35.3565 28.8414 35.4066 28.6274 35.2806Z"
        fill="#335BFF"
      />
      <path
        d="M21.646 31.7307L20.6792 47.1995C20.6612 47.4874 20.8898 47.7307 21.1782 47.7307H46.6919C46.9494 47.7307 47.1649 47.5351 47.1896 47.2787L49 28.5H48.6385C48.5479 28.5 48.459 28.5246 48.3812 28.5713L46.3651 29.7809C46.1547 29.9072 46.067 30.1675 46.1581 30.3954L46.8704 32.1761C46.9483 32.3707 46.8965 32.5932 46.7407 32.7334L42.4298 36.6132C42.2032 36.8171 41.8484 36.7726 41.6793 36.5189L37.161 29.7414C37.0614 29.5921 37.0495 29.401 37.1298 29.2405L38.3388 26.8223C38.4351 26.6298 38.3974 26.3974 38.2452 26.2452L36.3229 24.3229C36.14 24.14 35.8479 24.1268 35.6492 24.2923L33.2382 26.3015C33.0923 26.4231 33.0279 26.6169 33.072 26.8016L33.7165 29.5024C33.751 29.647 33.7194 29.7995 33.6302 29.9185L31.896 32.2307L28.7928 36.132C28.6283 36.3388 28.3312 36.3819 28.1147 36.2303L23.8247 33.2273C23.6345 33.0941 23.561 32.8476 23.6472 32.632L24.3776 30.8061C24.4518 30.6204 24.4083 30.4083 24.2669 30.2669L23.0574 29.0574C23.0194 29.0194 22.9755 28.9877 22.9274 28.9637L22 28.5L21.646 31.7307Z"
        fill="url(#paint10_linear_933_72531)"
      />
      <path
        d="M15.7292 50.0637L16.146 51.7307L13.646 49.7307L15.646 27.7307L38.146 15.7307L41.646 18.2307L37.9678 17.7709C37.7586 17.7448 37.5465 17.7854 37.3618 17.887L18.5729 28.2209C17.993 28.5399 17.6084 29.125 17.5457 29.7838L15.6785 49.389C15.657 49.6152 15.6741 49.8433 15.7292 50.0637Z"
        fill="#3353FF"
      />
      <path
        d="M37.4325 13.4348L31.8263 15.0367C31.6444 15.0886 31.5126 14.8646 31.6463 14.7309L38.1463 11.231L60.1463 24.9355L64.146 28.2311L64.1458 30.7312L59.7146 28.6372L58.7666 26.0581C58.6887 25.8462 58.5414 25.6669 58.3486 25.5493L38.7802 13.6174C38.3761 13.371 37.8875 13.3048 37.4325 13.4348Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.254 11.9858C37.801 11.6962 38.4604 11.7171 38.988 12.0409L58.9766 24.3066C59.2136 24.452 59.4076 24.6484 59.5488 24.8763L59.5072 24.9388L59.6287 25.0198C59.7658 25.2959 59.8302 25.6084 59.8065 25.9274L57.9775 50.6189C57.9334 51.2149 57.5882 51.7472 57.062 52.0305L33.0406 64.965C32.4917 65.2606 31.827 65.2418 31.2957 64.9158L11.4242 52.7219L10.8317 52.0635L10.7739 52.1155C10.5698 51.7948 10.4715 51.41 10.5072 51.017L12.7967 25.8328C12.8503 25.2436 13.1979 24.7214 13.7207 24.4446L37.254 11.9858ZM11.101 53.1102L11.0732 53.0932C10.3442 52.6458 9.93183 51.8237 10.0093 50.9718L12.2987 25.7875C12.3676 25.03 12.8145 24.3586 13.4868 24.0027L37.02 11.5439C37.7234 11.1716 38.5712 11.1985 39.2495 11.6147L59.2381 23.8804C59.5634 24.08 59.8258 24.3544 60.0097 24.6729L63.2962 26.8639C63.9816 27.3208 64.3625 28.1157 64.2892 28.9361L61.9897 54.6909C61.923 55.4377 61.4887 56.1023 60.8314 56.4631L37.2688 69.3995C36.5699 69.7832 35.7202 69.7684 35.0351 69.3606L15.2787 57.6008C15.0843 57.4851 14.9084 57.3407 14.7571 57.1725L11.101 53.1102ZM12.6034 54.0322L15.1287 56.8381C15.2464 56.9688 15.3832 57.0811 15.5344 57.1711L35.2909 68.9309C35.8237 69.2481 36.4846 69.2596 37.0282 68.9612L60.5908 56.0248C61.102 55.7442 61.4398 55.2273 61.4917 54.6464L63.7912 28.8917C63.8482 28.2535 63.5519 27.6353 63.0189 27.2799L60.2855 25.4577C60.3108 25.6232 60.3178 25.7931 60.3052 25.9644L58.4762 50.6559C58.4194 51.4221 57.9755 52.1064 57.299 52.4707L33.2777 65.4053C32.5719 65.7853 31.7173 65.7612 31.0342 65.3419L12.6034 54.0322ZM35.7863 23.9712L38.4429 24.724C38.566 24.7589 38.6782 24.8247 38.7687 24.9153L40.4219 26.5684C40.6501 26.7967 40.7067 27.1454 40.5624 27.4341L39.3532 29.8525C39.3131 29.9327 39.319 30.0282 39.3686 30.1028L43.098 35.7076L46.7004 32.5574C46.7837 32.4846 46.8092 32.3656 46.7631 32.265L45.9504 30.4919C45.7968 30.1569 45.9095 29.7599 46.2161 29.5554L47.9879 28.3742C48.4353 28.076 49.0069 28.3334 49.1301 28.8047L49.1386 28.792L50.3902 29.6264C50.6197 29.7794 50.7467 30.046 50.7209 30.3206L48.9373 49.301C48.9011 49.6863 48.5776 49.9808 48.1906 49.9808H23.3529C23.154 49.9808 22.9632 49.9018 22.8226 49.7612L21.0269 47.9655C20.6686 47.8923 20.4057 47.564 20.4295 47.1839L21.3963 31.7151L21.3968 31.7071L21.3969 31.7071L21.6507 29.0336C21.6981 28.534 22.1889 28.2566 22.6139 28.3846L22.6168 28.3791L22.6487 28.396C22.7129 28.4189 22.7752 28.4513 22.8339 28.494L25.134 29.7109C25.2601 29.7775 25.3645 29.8788 25.4351 30.0027L26.0858 31.1456C26.209 31.3619 26.2168 31.6253 26.1067 31.8486L25.5755 32.9249C25.5176 33.0423 25.56 33.1846 25.6728 33.251L29.1268 35.2846L29.0963 35.3364L33.637 29.5572C33.6889 29.4911 33.7042 29.4034 33.6776 29.3237L32.8605 26.8722C32.7706 26.6027 32.8408 26.3056 33.0416 26.1047L35.0003 24.1461C35.1542 23.9922 35.3597 23.9184 35.563 23.9271L35.5681 23.9094L35.6835 23.9421C35.7183 23.9493 35.7526 23.959 35.7863 23.9712ZM28.822 35.6854L25.4192 33.6819C25.0807 33.4826 24.9533 33.0559 25.1271 32.7037L25.6583 31.6273C25.695 31.5529 25.6924 31.4651 25.6513 31.393L25.0006 30.2501C24.977 30.2088 24.9422 30.1751 24.9002 30.1528L24.0637 29.7103L24.428 30.0745C24.6518 30.2983 24.711 30.6385 24.576 30.9248L23.6832 32.8174C23.6298 32.9305 23.6683 33.0657 23.7732 33.1338L28.2529 36.0416C28.3614 36.112 28.5057 36.0881 28.5856 35.9864L28.822 35.6854ZM22.4602 28.8619L22.5603 28.9149C22.565 28.919 22.5696 28.9232 22.5741 28.9277L24.0744 30.4281C24.149 30.5027 24.1688 30.6161 24.1237 30.7115L23.231 32.6041C23.0709 32.9435 23.1862 33.3489 23.501 33.5532L27.9806 36.461C28.3061 36.6723 28.739 36.6004 28.9787 36.2953L34.0302 29.8661C34.1859 29.6679 34.2317 29.4047 34.152 29.1656L33.3348 26.7141C33.3049 26.6243 33.3282 26.5252 33.3952 26.4583L35.3538 24.4997C35.4122 24.4413 35.4928 24.4175 35.5694 24.4294L35.6274 24.4459C35.6498 24.4553 35.6711 24.4681 35.6906 24.4844L38.0356 26.4385C38.1248 26.5128 38.1511 26.6386 38.0992 26.7424L36.9061 29.1287C36.7857 29.3694 36.8036 29.6562 36.9529 29.8801L41.4758 36.6645C41.727 37.0414 42.2525 37.1112 42.5935 36.813L47.0295 32.9338C47.2794 32.7153 47.3559 32.3585 47.2176 32.0567L46.4049 30.2836C46.3537 30.1719 46.3913 30.0396 46.4935 29.9714L48.2652 28.7903C48.4403 28.6735 48.6725 28.8122 48.6528 29.0217L46.9395 47.2541C46.9274 47.3826 46.8196 47.4807 46.6906 47.4807H21.178C21.0338 47.4807 20.9195 47.359 20.9285 47.2151L21.8951 31.7503L22.1484 29.0809C22.1639 28.918 22.3208 28.826 22.4602 28.8619ZM36.8367 24.7885L38.3065 25.2051C38.3476 25.2167 38.385 25.2386 38.4152 25.2688L40.0683 26.922C40.1444 26.998 40.1633 27.1143 40.1151 27.2105L38.9059 29.6289C38.7857 29.8695 38.8034 30.156 38.9524 30.3798L42.7184 36.0396L42.2644 36.4366C42.1507 36.536 41.9755 36.5128 41.8918 36.3871L37.3689 29.6028C37.3191 29.5281 37.3132 29.4325 37.3533 29.3523L38.5464 26.966C38.7021 26.6547 38.6231 26.2772 38.3557 26.0544L36.8367 24.7885ZM21.7492 47.9807L23.1761 49.4076C23.223 49.4545 23.2866 49.4808 23.3529 49.4808H48.1906C48.3196 49.4808 48.4274 49.3827 48.4395 49.2542L50.2231 30.2738C50.2317 30.1823 50.1894 30.0934 50.1129 30.0424L49.1212 29.3813L47.4373 47.3009C47.4011 47.6862 47.0776 47.9807 46.6906 47.9807H21.7492ZM38.4924 16.5582C37.9622 16.2249 37.2942 16.2004 36.7409 16.494L16.7707 27.0903C16.248 27.3676 15.9009 27.8904 15.848 28.4798L14.006 49.0144C13.9464 49.678 14.269 50.3179 14.8379 50.6648L30.8296 60.4159C31.3636 60.7415 32.0309 60.7573 32.5798 60.4574L52.5625 49.5379C53.0876 49.251 53.4296 48.7157 53.4694 48.1186L54.817 27.9052C54.8598 27.2633 54.5469 26.6496 54.0022 26.3072L38.4924 16.5582ZM36.5065 16.0523C37.2179 15.6748 38.0767 15.7064 38.7585 16.1349L54.2683 25.8839C54.9686 26.3241 55.3709 27.1131 55.3159 27.9385L53.9683 48.1519C53.9172 48.9195 53.4773 49.6078 52.8022 49.9767L32.8196 60.8962C32.1138 61.2818 31.2559 61.2615 30.5693 60.8428L14.5776 51.0917C13.8461 50.6457 13.4314 49.823 13.508 48.9697L15.35 28.4351C15.418 27.6773 15.8643 27.0052 16.5364 26.6486L36.5065 16.0523Z"
        fill="#001376"
      />
      <path
        d="M39.3859 38.2929L38.2165 36.1003C38.1605 35.9953 38.2738 35.8811 38.3792 35.9363L39.2596 36.3683L40.4871 39.2326L34.9633 45.3702L34.145 45.3701L39.2811 39.2829C39.5152 39.0054 39.5567 38.6132 39.3859 38.2929Z"
        fill="url(#paint11_linear_933_72531)"
      />
      <path
        d="M33.7357 45.3701L36.1908 38.8233L39.6687 38.8234L33.9403 45.5747L33.7357 45.3701Z"
        fill="#A8CAFF"
      />
      <path
        d="M33.7358 45.358L31.6899 38.6187L29.4395 38.6187L33.5312 45.358L33.7358 45.358Z"
        fill="#91BBFF"
      />
      <path
        d="M33.7358 45.37L36.1908 38.8233L31.6899 38.6187L33.5312 44.9608L33.7358 45.37Z"
        fill="white"
      />
      <path
        d="M34.3496 35.7545L36.1908 38.8233L31.6899 38.6187L33.7358 36.3683L34.3496 35.7545Z"
        fill="#E2EEFF"
      />
      <path
        d="M37.8275 35.5499L39.4642 38.8233L36.1909 38.8233L37.4184 36.5728L37.8275 35.5499Z"
        fill="#BCCFFF"
      />
      <path
        d="M30.8716 35.7545L29.4395 38.6187L31.6899 38.6188L31.0762 35.7545L30.8716 35.7545Z"
        fill="#BCCFFF"
      />
      <path
        d="M31.8945 38.4141L34.3495 35.5499L31.0762 35.5499L31.6899 38.4141L31.8945 38.4141Z"
        fill="white"
      />
      <path
        d="M36.1908 38.8232L34.3502 35.6905L37.7666 35.6905L36.3954 38.414L36.1908 38.8232Z"
        fill="#DFF2FF"
      />
      <path
        d="M39.5053 38.8826C39.4967 38.9613 39.4642 39.0355 39.4121 39.0953L34.0808 45.3849C34.0423 45.4292 33.9941 45.4641 33.9398 45.4869C33.8856 45.5097 33.8268 45.5198 33.768 45.5164C33.7092 45.513 33.6519 45.4961 33.6007 45.4672C33.5494 45.4383 33.5056 45.398 33.4725 45.3496L29.4806 38.8824C29.4358 38.8169 29.4121 38.7394 29.4127 38.6603M39.5053 38.8826C39.5139 38.8039 39.4982 38.7244 39.4603 38.6548L38.0732 35.8138C38.042 35.7563 37.9966 35.7077 37.9412 35.6726C37.8858 35.6374 37.8224 35.617 37.7568 35.6131L31.2502 35.6511C31.1846 35.6473 31.1192 35.6603 31.0601 35.6888C31.0011 35.7173 30.9503 35.7603 30.9127 35.8138L29.4837 38.4392C29.438 38.504 29.4132 38.5811 29.4127 38.6603M39.5053 38.8826L29.4127 38.6603"
        stroke="#001376"
        strokeWidth="0.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.8276 35.7544L36.1909 38.8232M36.1909 38.8232L34.3369 35.7125L31.69 38.6186M36.1909 38.8232L33.7359 45.37L31.69 38.6186M31.0762 35.7544L31.69 38.6186"
        stroke="#001376"
        strokeWidth="0.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.7358 45.4928L34.7708 45.3893C34.8946 45.3769 35.0094 45.3188 35.0927 45.2263L40.2732 39.4701C40.4036 39.3252 40.4379 39.1178 40.3612 38.9386L39.3317 36.5366C39.2851 36.4279 39.2015 36.3393 39.0958 36.2864L38.0321 35.7545"
        stroke="#001376"
        strokeWidth="0.3"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_933_72531"
        x1="83.5714"
        y1="-9.46154"
        x2="39.3674"
        y2="82.1772"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BCCBFF" stopOpacity="0.9" />
        <stop offset="1" stopColor="#759CFF" stopOpacity="0.5" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_933_72531"
        x1="20.5"
        y1="51"
        x2="-1.38094"
        y2="69.423"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00354279" stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_933_72531"
        x1="18.5"
        y1="33"
        x2="-9.99965"
        y2="33.0044"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_933_72531"
        x1="62.5"
        y1="48"
        x2="88.5141"
        y2="55.7814"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_933_72531"
        x1="52.5"
        y1="60"
        x2="74.4521"
        y2="89.5498"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_933_72531"
        x1="29"
        y1="24.5"
        x2="-2.26834"
        y2="5.53869"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_933_72531"
        x1="55.5"
        y1="24"
        x2="81.8165"
        y2="-1.34404"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_933_72531"
        x1="25.646"
        y1="55.7307"
        x2="66.146"
        y2="27.7307"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3246FE" />
        <stop offset="0.0315245" stopColor="#3246FE" />
        <stop offset="0.569143" stopColor="#325FFE" />
        <stop offset="0.619523" stopColor="#778DFF" />
        <stop offset="1" stopColor="#7795FF" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_933_72531"
        x1="8.646"
        y1="40.2307"
        x2="60.646"
        y2="36.7307"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DFEEFF" />
        <stop offset="1" stopColor="#BCCBFF" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_933_72531"
        x1="17.146"
        y1="40.7307"
        x2="56.146"
        y2="36.2307"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7896FF" />
        <stop offset="1" stopColor="#ACC3FF" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_933_72531"
        x1="48.146"
        y1="36.7307"
        x2="21.146"
        y2="34.7307"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BCCFFF" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_933_72531"
        x1="39.055"
        y1="38.8234"
        x2="39.8734"
        y2="35.9592"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3253FE" />
        <stop offset="0.0185376" stopColor="#77A2FF" />
        <stop offset="0.9999" stopColor="#77A2FF" />
        <stop offset="1" stopColor="#77A2FF" />
      </linearGradient>
      <clipPath id="clip0_933_72531">
        <rect width="78" height="82" rx="8" fill="white" />
      </clipPath>
    </defs>
  </Icon>
);

export const ArrowRightOutlined = (props: any) => (
  <svg {...props} viewBox="0 0 20 20">
    <path
      d="M7.5 6.175L8.675 5L13.675 10L8.675 15L7.5 13.825L11.3167 10L7.5 6.175Z"
      fill="inherit"
    />
  </svg>
);

export const FormGraphLayoutIcon = (props: any) => (
  <svg {...props} width="16" height="16" viewBox="0 0 16 16">
    <path
      d="M5.33333 2V14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H5.33333ZM14 6.66667V12.6667C14.0001 13.0031 13.8731 13.327 13.6443 13.5737C13.4156 13.8204 13.1021 13.9714 12.7667 13.9967L12.6667 14H6.66667V6.66667H14ZM12.6667 2C13.0031 1.99989 13.327 2.12694 13.5737 2.35566C13.8204 2.58439 13.9714 2.8979 13.9967 3.23333L14 3.33333V6.66667H6.66667V2H12.6667Z"
      fill="inherit"
    />
  </svg>
);

export const GridLayoutIcon = (props: any) => (
  <svg {...props} width="16" height="16" viewBox="0 0 16 16">
    <path
      d="M2.66667 7.33333H6.66667C6.84348 7.33333 7.01305 7.2631 7.13807 7.13807C7.2631 7.01305 7.33333 6.84348 7.33333 6.66667V2.66667C7.33333 2.48986 7.2631 2.32029 7.13807 2.19526C7.01305 2.07024 6.84348 2 6.66667 2H2.66667C2.48986 2 2.32029 2.07024 2.19526 2.19526C2.07024 2.32029 2 2.48986 2 2.66667V6.66667C2 6.84348 2.07024 7.01305 2.19526 7.13807C2.32029 7.2631 2.48986 7.33333 2.66667 7.33333ZM9.33333 7.33333H13.3333C13.5101 7.33333 13.6797 7.2631 13.8047 7.13807C13.9298 7.01305 14 6.84348 14 6.66667V2.66667C14 2.48986 13.9298 2.32029 13.8047 2.19526C13.6797 2.07024 13.5101 2 13.3333 2H9.33333C9.15652 2 8.98695 2.07024 8.86193 2.19526C8.73691 2.32029 8.66667 2.48986 8.66667 2.66667V6.66667C8.66667 6.84348 8.73691 7.01305 8.86193 7.13807C8.98695 7.2631 9.15652 7.33333 9.33333 7.33333ZM2.66667 14H6.66667C6.84348 14 7.01305 13.9298 7.13807 13.8047C7.2631 13.6797 7.33333 13.5101 7.33333 13.3333V9.33333C7.33333 9.15652 7.2631 8.98695 7.13807 8.86193C7.01305 8.73691 6.84348 8.66667 6.66667 8.66667H2.66667C2.48986 8.66667 2.32029 8.73691 2.19526 8.86193C2.07024 8.98695 2 9.15652 2 9.33333V13.3333C2 13.5101 2.07024 13.6797 2.19526 13.8047C2.32029 13.9298 2.48986 14 2.66667 14ZM9.33333 14H13.3333C13.5101 14 13.6797 13.9298 13.8047 13.8047C13.9298 13.6797 14 13.5101 14 13.3333V9.33333C14 9.15652 13.9298 8.98695 13.8047 8.86193C13.6797 8.73691 13.5101 8.66667 13.3333 8.66667H9.33333C9.15652 8.66667 8.98695 8.73691 8.86193 8.86193C8.73691 8.98695 8.66667 9.15652 8.66667 9.33333V13.3333C8.66667 13.5101 8.73691 13.6797 8.86193 13.8047C8.98695 13.9298 9.15652 14 9.33333 14Z"
      fill="inherit"
    />
  </svg>
);

export const PlusIcon = (props: any) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M11.8332 6.83317H6.83317V11.8332H5.1665V6.83317H0.166504V5.1665H5.1665V0.166504H6.83317V5.1665H11.8332V6.83317Z"
      fill="inherit"
    />
  </svg>
);

export const ShareIconAnimation = (props: any) => (
  <svg
    {...props}
    id="eir8jFunxeA1"
    viewBox="0 0 33 32"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
  >
    <g id="eir8jFunxeA2_ts" transform="translate(16.499585,16) scale(0,0)">
      <ellipse
        id="eir8jFunxeA2"
        rx="2.238806"
        ry="2.238806"
        transform="translate(0.000061,-0.000003)"
        fill="#b3c9fb"
        strokeWidth="0"
      />
    </g>
    <g id="eir8jFunxeA3_ts" transform="translate(16.499585,16) scale(1,1)">
      <path
        d="M21.8567,19.3929c-.6361,0-1.2232.2232-1.683.5959l-4.625-3.3459c.0774-.4251.0774-.8607,0-1.2858l4.625-3.3459c.4598.3727,1.0469.5959,1.683.5959c1.4777,0,2.6786-1.2008,2.6786-2.67853s-1.2009-2.67857-2.6786-2.67857-2.6785,1.20089-2.6785,2.67857c0,.25893.0357.50673.1049.74333l-4.3929,3.1808c-.6518-.8639-1.6875-1.4241-2.8549-1.4241-1.9732,0-3.57143,1.5982-3.57143,3.5714s1.59823,3.5714,3.57143,3.5714c1.1674,0,2.2031-.5602,2.8549-1.4241l4.3929,3.1808c-.0692.2366-.1049.4866-.1049.7433c0,1.4777,1.2008,2.6786,2.6785,2.6786s2.6786-1.2009,2.6786-2.6786-1.2009-2.6785-2.6786-2.6785Zm0-10.62504c.6407,0,1.1607.52009,1.1607,1.16071s-.52,1.16073-1.1607,1.16073-1.1607-.5201-1.1607-1.16073.5201-1.16071,1.1607-1.16071ZM12.0353,17.9643c-1.0826,0-1.9643-.8817-1.9643-1.9643s.8817-1.9643,1.9643-1.9643s1.9643.8817,1.9643,1.9643-.8817,1.9643-1.9643,1.9643Zm9.8214,5.2678c-.6406,0-1.1607-.52-1.1607-1.1607s.5201-1.1607,1.1607-1.1607s1.1607.5201,1.1607,1.1607-.52,1.1607-1.1607,1.1607Z"
        transform="translate(-16.499585,-16)"
        fill="inherit"
      />
    </g>
  </svg>
);

export const Manual = (props: any) => (
  <Icon
    {...props}
    viewBox={"0 0 24 24"}
    d={[
      "M9.64029 7.22222C9.64029 6.94227 9.76156 6.67379 9.97743 6.47583C10.1933 6.27788 10.4861 6.16667 10.7914 6.16667C11.0967 6.16667 11.3894 6.27788 11.6053 6.47583C11.8212 6.67379 11.9424 6.94227 11.9424 7.22222V11.9406L13.3353 12.0778L19.0216 14.3894C19.6317 14.6428 20 15.2022 20 15.8144V20.4167C19.9655 21.2822 19.2173 21.9683 18.2734 22H10.7914C10.354 22 9.93957 21.8417 9.64029 21.5461L4 17.1128L4.8518 16.3C5.0705 16.0783 5.3813 15.9622 5.7036 15.9622H5.95683L9.64029 17.7778V7.22222ZM10.7914 3C12.0125 3 13.1836 3.44484 14.0471 4.23666C14.9106 5.02848 15.3957 6.10242 15.3957 7.22222C15.3957 8.80556 14.4748 10.1461 13.0935 10.8744V9.58667C13.7957 9.00611 14.2446 8.16167 14.2446 7.22222C14.2446 6.38237 13.8808 5.57692 13.2332 4.98305C12.5856 4.38918 11.7072 4.05556 10.7914 4.05556C9.87551 4.05556 8.99717 4.38918 8.34956 4.98305C7.70195 5.57692 7.33813 6.38237 7.33813 7.22222C7.33813 8.16167 7.78705 9.00611 8.48921 9.58667V10.8744C7.10791 10.1461 6.18705 8.80556 6.18705 7.22222C6.18705 6.10242 6.67215 5.02848 7.53562 4.23666C8.3991 3.44484 9.57023 3 10.7914 3Z",
    ]}
  />
);

export const ConfigurationSearchEmptyState = (props: any) => {
  return (
    <Icon
      {...props}
      $size={212}
      width="212"
      height="141"
      viewBox="0 0 212 141"
      fill="none"
    >
      <path
        d="M105.624 130.091C163.959 130.091 211.248 118.396 211.248 103.969C211.248 89.5419 163.959 77.8467 105.624 77.8467C47.2895 77.8467 0 89.5419 0 103.969C0 118.396 47.2895 130.091 105.624 130.091Z"
        fill="url(#paint0_linear_439_850)"
      />
      <rect
        x="34"
        width="135"
        height="92"
        rx="4"
        fill="url(#paint1_linear_439_850)"
      />
      <rect
        x="36"
        y="2"
        width="131"
        height="88"
        rx="2"
        fill="url(#paint2_linear_439_850)"
      />
      <rect
        x="58"
        y="75"
        width="58"
        height="7"
        rx="3.5"
        transform="rotate(-90 58 75)"
        fill="url(#paint3_linear_439_850)"
        fillOpacity="0.2"
      />
      <rect
        x="57"
        y="55"
        width="20"
        height="9"
        rx="4.5"
        transform="rotate(-90 57 55)"
        fill="url(#paint4_linear_439_850)"
      />
      <rect
        x="85"
        y="75"
        width="58"
        height="7"
        rx="3.5"
        transform="rotate(-90 85 75)"
        fill="url(#paint5_linear_439_850)"
        fillOpacity="0.2"
      />
      <rect
        x="84"
        y="70"
        width="20"
        height="9"
        rx="4.5"
        transform="rotate(-90 84 70)"
        fill="url(#paint6_linear_439_850)"
      />
      <rect
        x="112"
        y="75"
        width="58"
        height="7"
        rx="3.5"
        transform="rotate(-90 112 75)"
        fill="url(#paint7_linear_439_850)"
        fillOpacity="0.2"
      />
      <rect
        x="111"
        y="37"
        width="20"
        height="9"
        rx="4.5"
        transform="rotate(-90 111 37)"
        fill="url(#paint8_linear_439_850)"
      />
      <rect
        x="139"
        y="75"
        width="58"
        height="7"
        rx="3.5"
        transform="rotate(-90 139 75)"
        fill="url(#paint9_linear_439_850)"
        fillOpacity="0.2"
      />
      <rect
        x="139"
        y="65"
        width="20"
        height="7"
        rx="3.5"
        transform="rotate(-90 139 65)"
        fill="url(#paint10_linear_439_850)"
      />
      <path
        d="M172.175 104.193L176.181 108.497L175.805 109.018C175.054 109.931 175.054 111.366 175.805 112.279L197.084 137.578C197.96 138.622 198.962 139.534 200.213 140.186C201.465 140.839 202.717 141.23 204.094 140.839C205.596 140.447 206.973 139.404 207.098 137.187C207.223 135.622 206.722 134.188 205.721 133.014L184.317 106.28C183.315 105.106 181.813 104.845 180.812 105.628L176.556 100.281C176.556 100.02 173.302 101.194 172.175 104.193Z"
        fill="url(#paint11_linear_439_850)"
      />
      <foreignObject x="115.352" y="38.4858" width="76.5886" height="78.4854">
        <div
          style={{
            backdropFilter: "blur(3px)",
            clipPath: "url(#bgblur_0_439_850_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <g filter="url(#filter0_i_439_850)" data-figma-bg-blur-radius="6">
        <path
          d="M153.646 110.971C171.482 110.971 185.941 96.0879 185.941 77.7285C185.941 59.3691 171.482 44.4858 153.646 44.4858C135.811 44.4858 121.352 59.3691 121.352 77.7285C121.352 96.0879 135.811 110.971 153.646 110.971Z"
          fill="url(#paint12_radial_439_850)"
          fillOpacity="0.33"
        />
      </g>
      <path
        d="M128.371 61.7821C133.299 49.7737 146.555 43.5731 158.942 47.4822L166.877 49.9868C180.703 54.3501 188.058 69.5052 182.927 83.0573L179.509 92.0865C174.598 105.059 160.117 111.512 147.171 106.497L139.189 103.404C126.001 98.2953 119.544 83.2934 124.907 70.2235L128.371 61.7821Z"
        fill="url(#paint13_linear_439_850)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M153.647 49.213C137.868 49.213 125.076 61.9801 125.076 77.7292C125.076 93.4782 137.868 106.245 153.647 106.245C169.426 106.245 182.218 93.4782 182.218 77.7292C182.218 61.9801 169.426 49.213 153.647 49.213ZM117.117 77.7292C117.117 57.5931 133.472 41.2695 153.647 41.2695C173.822 41.2695 190.176 57.5931 190.176 77.7292C190.176 97.8653 173.822 114.189 153.647 114.189C133.472 114.189 117.117 97.8653 117.117 77.7292Z"
        fill="url(#paint14_linear_439_850)"
      />
      <defs>
        <filter
          id="filter0_i_439_850"
          x="115.352"
          y="38.4858"
          width="76.5886"
          height="78.4854"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.85204" />
          <feGaussianBlur stdDeviation="11.5753" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.560784 0 0 0 0 0.607843 0 0 0 0 1 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_439_850"
          />
        </filter>
        <clipPath
          id="bgblur_0_439_850_clip_path"
          transform="translate(-115.352 -38.4858)"
        >
          <path d="M153.646 110.971C171.482 110.971 185.941 96.0879 185.941 77.7285C185.941 59.3691 171.482 44.4858 153.646 44.4858C135.811 44.4858 121.352 59.3691 121.352 77.7285C121.352 96.0879 135.811 110.971 153.646 110.971Z" />
        </clipPath>
        <linearGradient
          id="paint0_linear_439_850"
          x1="115.278"
          y1="150.534"
          x2="124.932"
          y2="22.1953"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDEAFF" />
          <stop offset="1" stopColor="#F0F6FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_439_850"
          x1="101.5"
          y1="0"
          x2="101.5"
          y2="92"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7CB0FF" />
          <stop offset="1" stopColor="#4F94FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_439_850"
          x1="101.5"
          y1="2"
          x2="101.5"
          y2="90"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F8FBFF" />
          <stop offset="1" stopColor="#DFECFF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_439_850"
          x1="87"
          y1="75"
          x2="87"
          y2="82"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.42" stopColor="#73A8FE" />
          <stop offset="0.995" stopColor="#3E89FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_439_850"
          x1="67"
          y1="55"
          x2="67"
          y2="64"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.42" stopColor="#73A8FE" />
          <stop offset="0.995" stopColor="#3E89FF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_439_850"
          x1="114"
          y1="75"
          x2="114"
          y2="82"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.42" stopColor="#73A8FE" />
          <stop offset="0.995" stopColor="#3E89FF" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_439_850"
          x1="94"
          y1="70"
          x2="94"
          y2="79"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.42" stopColor="#73A8FE" />
          <stop offset="0.995" stopColor="#3E89FF" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_439_850"
          x1="141"
          y1="75"
          x2="141"
          y2="82"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.42" stopColor="#73A8FE" />
          <stop offset="0.995" stopColor="#3E89FF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_439_850"
          x1="121"
          y1="37"
          x2="121"
          y2="46"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.42" stopColor="#73A8FE" />
          <stop offset="0.995" stopColor="#3E89FF" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_439_850"
          x1="168"
          y1="75"
          x2="168"
          y2="82"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.42" stopColor="#73A8FE" />
          <stop offset="0.995" stopColor="#3E89FF" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_439_850"
          x1="149"
          y1="65"
          x2="149"
          y2="72"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.42" stopColor="#73A8FE" />
          <stop offset="0.995" stopColor="#3E89FF" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_439_850"
          x1="207.117"
          y1="113.114"
          x2="189.328"
          y2="140.79"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <radialGradient
          id="paint12_radial_439_850"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(153.646 77.7285) rotate(90) scale(33.2426 32.2943)"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#EEF5FF" />
        </radialGradient>
        <linearGradient
          id="paint13_linear_439_850"
          x1="172.116"
          y1="38.5791"
          x2="146.555"
          y2="116.395"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_439_850"
          x1="177.47"
          y1="19.8227"
          x2="166.769"
          y2="115.654"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#7FB0FB" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const BacktestingHistoryEmptyState = (props: any) => (
  <Icon
    {...props}
    $size={212}
    width="212"
    height="162"
    viewBox="0 0 212 162"
    fill="none"
  >
    <path
      d="M105.624 161.244C163.959 161.244 211.248 149.549 211.248 135.122C211.248 120.695 163.959 109 105.624 109C47.2895 109 0 120.695 0 135.122C0 149.549 47.2895 161.244 105.624 161.244Z"
      fill="url(#paint0_linear_439_909)"
    />
    <path
      d="M174 0H166.824C161.95 0 158 3.95043 158 8.82353V14H188C188 6.26801 181.732 0 174 0Z"
      fill="#196AE7"
    />
    <g filter="url(#filter0_i_439_909)">
      <path
        d="M164.26 137L183.512 42.3988C183.764 41.1594 182.817 40 181.552 40H68.8521L45 137H164.26Z"
        fill="url(#paint1_linear_439_909)"
      />
    </g>
    <path
      d="M163.04 16.4359V133H46V14.5744C46 8.21669 50.165 2.60967 56.2517 0.773256L175 0C167.87 2.30471 163.04 8.94309 163.04 16.4359Z"
      fill="url(#paint2_linear_439_909)"
    />
    <g filter="url(#filter1_i_439_909)">
      <path
        d="M64.8333 36H27.6228C25.7418 36 24.3247 37.7112 24.6755 39.5593L43.1667 137H164L149.466 60.9813C149.196 59.5673 147.959 58.5446 146.519 58.5446H85.6667L64.8333 36Z"
        fill="url(#paint3_linear_439_909)"
      />
    </g>
    <rect
      x="46.9464"
      y="70.6743"
      width="5.95946"
      height="4.25676"
      fill="url(#paint4_linear_439_909)"
    />
    <rect
      x="43.5405"
      y="62.1606"
      width="12.7703"
      height="8.51351"
      rx="1"
      fill="url(#paint5_linear_439_909)"
    />
    <rect
      x="23.7812"
      y="82.6162"
      width="4.40248"
      height="4.33595"
      transform="rotate(-45 23.7812 82.6162)"
      fill="#5397FF"
    />
    <rect
      x="68.2297"
      y="83.3115"
      width="4.40248"
      height="4.41695"
      transform="rotate(-45 68.2297 83.3115)"
      fill="url(#paint6_linear_439_909)"
    />
    <circle cx="49.5" cy="105.58" r="31.5" fill="url(#paint7_linear_439_909)" />
    <g filter="url(#filter2_di_439_909)">
      <circle cx="49.4999" cy="105.58" r="25.5405" fill="white" />
    </g>
    <circle cx="49.0742" cy="105.154" r="2.97973" fill="#5397FF" />
    <path
      d="M63.5473 93.2349L47.3716 102.6L51.2027 107.282L63.5473 93.2349Z"
      fill="#5397FF"
    />
    <path
      d="M49.4999 83.4443V88.9781M49.4999 122.181V127.289"
      stroke="#8DBBFF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M27.3646 105.58H32.8984M66.1011 105.58H71.2092"
      stroke="#8DBBFF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <rect
      x="18"
      y="80.145"
      width="9.08205"
      height="6.97112"
      rx="1"
      transform="rotate(-45 18 80.145)"
      fill="url(#paint8_linear_439_909)"
    />
    <rect
      width="9.08205"
      height="6.97112"
      rx="1"
      transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 80.6865 80.5015)"
      fill="url(#paint9_linear_439_909)"
    />
    <path
      d="M142 26H79M142 40H103.837"
      stroke="white"
      strokeOpacity="0.62"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <defs>
      <filter
        id="filter0_i_439_909"
        x="44"
        y="40"
        width="139.553"
        height="97"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.392157 0 0 0 0 0.631373 0 0 0 0 1 0 0 0 0.49 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_439_909"
        />
      </filter>
      <filter
        id="filter1_i_439_909"
        x="23.6219"
        y="36"
        width="140.378"
        height="102"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-1" dy="2" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.407843 0 0 0 0 0.639216 0 0 0 0 1 0 0 0 0.42 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_439_909"
        />
      </filter>
      <filter
        id="filter2_di_439_909"
        x="21.9594"
        y="78.0391"
        width="55.0811"
        height="55.0811"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.194904 0 0 0 0 0.423127 0 0 0 0 0.772174 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_439_909"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_439_909"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-1" dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.645436 0 0 0 0 0.713543 0 0 0 0 0.817708 0 0 0 0.41 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_439_909"
        />
      </filter>
      <linearGradient
        id="paint0_linear_439_909"
        x1="115.278"
        y1="181.688"
        x2="124.932"
        y2="53.3486"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DDEAFF" />
        <stop offset="1" stopColor="#F0F6FF" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_439_909"
        x1="114.5"
        y1="40"
        x2="114.5"
        y2="137"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BED9FF" />
        <stop offset="1" stopColor="#B0D1FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_439_909"
        x1="116.191"
        y1="36.0387"
        x2="116.579"
        y2="7.29239"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4F94FF" />
        <stop offset="1" stopColor="#73AAFF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_439_909"
        x1="45.3245"
        y1="41.5"
        x2="133.336"
        y2="157.733"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EBF3FF" />
        <stop offset="1" stopColor="#BDD8FF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_439_909"
        x1="46.5045"
        y1="72.2561"
        x2="53.0368"
        y2="72.2561"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#83B3FF" />
        <stop offset="1" stopColor="#3F89FA" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_439_909"
        x1="44.1292"
        y1="66.3176"
        x2="53.6307"
        y2="66.3176"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7BAEFF" />
        <stop offset="0.288845" stopColor="#A0C5FF" />
        <stop offset="1" stopColor="#3A86F9" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_439_909"
        x1="70.431"
        y1="83.3115"
        x2="70.431"
        y2="87.7285"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#83B3FF" />
        <stop offset="1" stopColor="#3F89FA" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_439_909"
        x1="41.1599"
        y1="74.0375"
        x2="49.5"
        y2="137.08"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7DAFFF" />
        <stop offset="1" stopColor="#5095FF" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_439_909"
        x1="18.9595"
        y1="83.3847"
        x2="26.5179"
        y2="83.3847"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5397FF" />
        <stop offset="0.548663" stopColor="#A5C8FF" />
        <stop offset="1" stopColor="#7AAEFF" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_439_909"
        x1="9.84516"
        y1="4.06277"
        x2="0.187197"
        y2="4.48268"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#83B3FF" />
        <stop offset="0.287812" stopColor="#B7D2FC" />
        <stop offset="1" stopColor="#3F89FA" />
      </linearGradient>
    </defs>
  </Icon>
);

export const ConfigurationEmptyState = (props: any) => {
  const prefix = useMemo(() => uuidv4(), []);

  const getGradientUrl = (num: number, isId?: boolean) => {
    const id = `${prefix}_paint${num}_linear_2294_9297`;
    if (isId) return id;
    return `url(#${id})`;
  };

  return (
    <Icon
      {...props}
      $size={212}
      width="212"
      height="134"
      viewBox="0 0 212 134"
      fill="none"
    >
      <path
        d="M105.624 133.091C163.959 133.091 211.248 121.396 211.248 106.969C211.248 92.5419 163.959 80.8467 105.624 80.8467C47.2895 80.8467 0 92.5419 0 106.969C0 121.396 47.2895 133.091 105.624 133.091Z"
        fill={getGradientUrl(0)}
      />
      <rect
        x="30"
        width="152.609"
        height="104"
        rx="4"
        fill={getGradientUrl(1)}
      />
      <rect
        x="32.261"
        y="2.26074"
        width="148.087"
        height="99.4783"
        rx="2"
        fill={getGradientUrl(2)}
      />
      <rect
        x="57.1304"
        y="84.7827"
        width="65.5652"
        height="7.91304"
        rx="3.95652"
        transform="rotate(-90 57.1304 84.7827)"
        fill={getGradientUrl(3)}
        fillOpacity="0.2"
      />
      <rect
        x="56"
        y="62.1738"
        width="22.6087"
        height="10.1739"
        rx="5.08696"
        transform="rotate(-90 56 62.1738)"
        fill={getGradientUrl(4)}
      />
      <rect
        x="87.6521"
        y="84.7827"
        width="65.5652"
        height="7.91304"
        rx="3.95652"
        transform="rotate(-90 87.6521 84.7827)"
        fill={getGradientUrl(5)}
        fillOpacity="0.2"
      />
      <rect
        x="86.5217"
        y="79.1304"
        width="22.6087"
        height="10.1739"
        rx="5.08696"
        transform="rotate(-90 86.5217 79.1304)"
        fill={getGradientUrl(6)}
      />
      <rect
        x="118.174"
        y="84.7827"
        width="65.5652"
        height="7.91304"
        rx="3.95652"
        transform="rotate(-90 118.174 84.7827)"
        fill={getGradientUrl(7)}
        fillOpacity="0.2"
      />
      <rect
        x="117.043"
        y="41.8262"
        width="22.6087"
        height="10.1739"
        rx="5.08696"
        transform="rotate(-90 117.043 41.8262)"
        fill={getGradientUrl(8)}
      />
      <rect
        x="148.696"
        y="84.7827"
        width="65.5652"
        height="7.91304"
        rx="3.95652"
        transform="rotate(-90 148.696 84.7827)"
        fill={getGradientUrl(9)}
        fillOpacity="0.2"
      />
      <rect
        x="148.696"
        y="73.478"
        width="22.6087"
        height="7.91304"
        rx="3.95652"
        transform="rotate(-90 148.696 73.478)"
        fill={getGradientUrl(10)}
      />
      <defs>
        <linearGradient
          id={getGradientUrl(0, true)}
          x1="115.278"
          y1="153.534"
          x2="124.932"
          y2="25.1953"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDEAFF" />
          <stop offset="1" stopColor="#F0F6FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={getGradientUrl(1, true)}
          x1="106.304"
          y1="0"
          x2="106.304"
          y2="104"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7CB0FF" />
          <stop offset="1" stopColor="#4F94FF" />
        </linearGradient>
        <linearGradient
          id={getGradientUrl(2, true)}
          x1="106.304"
          y1="2.26074"
          x2="106.304"
          y2="101.739"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F8FBFF" />
          <stop offset="1" stopColor="#DFECFF" />
        </linearGradient>
        <linearGradient
          id={getGradientUrl(3, true)}
          x1="89.913"
          y1="84.7827"
          x2="89.913"
          y2="92.6958"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.42" stopColor="#73A8FE" />
          <stop offset="0.995" stopColor="#3E89FF" />
        </linearGradient>
        <linearGradient
          id={getGradientUrl(4, true)}
          x1="67.3043"
          y1="62.1738"
          x2="67.3043"
          y2="72.3477"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.42" stopColor="#73A8FE" />
          <stop offset="0.995" stopColor="#3E89FF" />
        </linearGradient>
        <linearGradient
          id={getGradientUrl(5, true)}
          x1="120.435"
          y1="84.7827"
          x2="120.435"
          y2="92.6958"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.42" stopColor="#73A8FE" />
          <stop offset="0.995" stopColor="#3E89FF" />
        </linearGradient>
        <linearGradient
          id={getGradientUrl(6, true)}
          x1="97.8261"
          y1="79.1304"
          x2="97.8261"
          y2="89.3043"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.42" stopColor="#73A8FE" />
          <stop offset="0.995" stopColor="#3E89FF" />
        </linearGradient>
        <linearGradient
          id={getGradientUrl(7, true)}
          x1="150.956"
          y1="84.7827"
          x2="150.956"
          y2="92.6958"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.42" stopColor="#73A8FE" />
          <stop offset="0.995" stopColor="#3E89FF" />
        </linearGradient>
        <linearGradient
          id={getGradientUrl(8, true)}
          x1="128.348"
          y1="41.8262"
          x2="128.348"
          y2="52.0001"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.42" stopColor="#73A8FE" />
          <stop offset="0.995" stopColor="#3E89FF" />
        </linearGradient>
        <linearGradient
          id={getGradientUrl(9, true)}
          x1="181.478"
          y1="84.7827"
          x2="181.478"
          y2="92.6958"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.42" stopColor="#73A8FE" />
          <stop offset="0.995" stopColor="#3E89FF" />
        </linearGradient>
        <linearGradient
          id={getGradientUrl(10, true)}
          x1="160"
          y1="73.478"
          x2="160"
          y2="81.3911"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.42" stopColor="#73A8FE" />
          <stop offset="0.995" stopColor="#3E89FF" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const InProgressAnimation = (props: any) => (
  <svg
    {...props}
    id="eAfKVS5CPcG1"
    viewBox="0 0 117 117"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    width="45"
    height="45"
  >
    <g
      id="eAfKVS5CPcG3_tr"
      transform="translate(58.499997,58.314486) rotate(0)"
    >
      <g transform="translate(-58.499996,-67.314485)">
        <path
          id="frame"
          d="M17.5149,0C7.84169,0,0,7.84287,0,17.5175s7.84168,17.5176,17.5149,17.5176h17.5149v28.7788c0,7.5075,6.5156,29.1855,26.2723,60.0601c14.5258,22.7,22.6831,33.979,26.3842,39.096l.0044.006c.2943.407.5604.775.7993,1.107.2547.353.4211.731.5253,1.122.2088.783.0649,1.637-.4082,2.295v0c-.2399.334-.5073.704-.8032,1.114-3.699,5.122-11.8517,16.413-26.3692,39.135-19.7455,30.906-26.2574,52.606-26.2574,60.121v30.06h-16.2545c-9.6677,0-17.50493,7.851-17.50493,17.535s7.83721,17.535,17.50493,17.535h257.5722c9.668,0,17.505-7.851,17.505-17.535s-7.837-17.535-17.505-17.535h-17.505v-28.808c0-7.515-6.512-29.215-26.257-60.12-14.518-22.723-22.67-34.013-26.369-39.136-.296-.409-.564-.78-.804-1.113-.254-.354-.403-.731-.491-1.121-.178-.79-.032-1.641.441-2.298v0c.24-.333.508-.703.804-1.113c3.701-5.117,11.858-16.396,26.384-39.096c19.757-30.8744,26.272-52.5524,26.272-60.0599v-30.03h16.264c9.673,0,17.515-7.8429,17.515-17.5176s-7.842-17.5175-17.515-17.5175L17.5149,0ZM180.422,167.961c-.157-1.021-.106-2.067.157-3.066.375-1.421.999-2.79,1.87-4.04c9.181-13.176,22.914-33.542,30.232-45.74C223.94,96.3464,235.2,74.0741,235.2,65.0651v-30.03h-176.4v28.7788c0,9.009,11.2596,31.2813,22.5192,50.0501c7.3174,12.198,21.0508,32.564,30.2318,45.74c1.12,1.607,1.829,3.412,2.125,5.27.163,1.019.111,2.065-.151,3.063-.375,1.423-.999,2.794-1.87,4.046-9.176,13.19-22.9014,33.577-30.2147,45.786C70.1872,236.557,58.934,258.852,58.934,267.87v30.06h176.3v-28.808c0-9.018-11.254-31.313-22.507-50.1-7.313-12.21-21.038-32.597-30.215-45.786-1.119-1.609-1.804-3.415-2.09-5.275Z"
          transform="matrix(-.249081 0.003671-.003671-.249081 95.726137 108.246813)"
          clipRule="evenodd"
          fill="inherit"
          fillRule="evenodd"
        />
        <g>
          <g
            id="eAfKVS5CPcG6_ts"
            transform="translate(58.364978,70.379458) scale(1,1)"
          >
            <path
              id="eAfKVS5CPcG6"
              d="M58.5,73.18738c6.60719-.06206,11.7543,8.64712,14.44445,13.3592s1.88699,8.95086-2.00339,8.95086c-2.59102,0-6.73804,0-12.44106,0-.00566,0-.01132,0-.01698,0-5.70302,0-9.85004,0-12.44106,0-3.89038,0-4.69355-4.23878-2.00339-8.95086s7.83727-13.42126,14.44445-13.3592"
              transform="translate(-58.362015,-70.214582)"
              fill="inherit"
              strokeWidth="0.5"
            />
          </g>
        </g>
        <g id="eAfKVS5CPcG7_to">
          <ellipse
            id="eAfKVS5CPcG7"
            rx="4.760917"
            ry="4.760917"
            transform="scale(0.796119,0.796119) translate(0,0)"
            fill="inherit"
            strokeWidth="0"
          />
        </g>
        <g id="eAfKVS5CPcG8_to" transform="translate(58.651318,82.098903)">
          <g id="eAfKVS5CPcG8_ts" transform="scale(0.457106,0.457106)">
            <rect
              id="eAfKVS5CPcG8"
              width="7.579288"
              height="33.162866"
              rx="3.79"
              ry="3.79"
              transform="translate(-3.789644,-16.581433)"
              fill="inherit"
              strokeWidth="0"
            />
          </g>
        </g>
      </g>
    </g>
    <g
      id="eAfKVS5CPcG9_ts"
      transform="translate(58.835476,86.761886) scale(0.012915,0.012915)"
    >
      <g
        id="eAfKVS5CPcG9"
        transform="translate(-58.494466,-95.662313)"
        opacity="0"
      >
        <path
          d="M58.5,73.18738c6.60719-.06206,11.7543,8.64712,14.44445,13.3592s1.88699,8.95086-2.00339,8.95086c-2.59102,0-6.73804,0-12.44106,0-.00566,0-.01132,0-.01698,0-5.70302,0-9.85004,0-12.44106,0-3.89038,0-4.69355-4.23878-2.00339-8.95086s7.83727-13.42126,14.44445-13.3592"
          transform="translate(.002963 0.164876)"
          fill="inherit"
          strokeWidth="0.5"
        />
      </g>
    </g>
  </svg>
);

export const WarningIcon = (props: any) => (
  <Icon {...props} viewBox="0 0 20 20" fill="none">
    <path
      d="M9 13H11V15H9V13ZM9 5H11V11H9V5ZM9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z"
      fill="#E79900"
    />
  </Icon>
);

export const BacktestingQuotaIcon = (props: any) => (
  <Icon
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    d={[
      "M10.6364 21.3495H4.04545V2.95878H19.9545V11.5556C19.9545 11.6753 20.0568 11.7733 20.1818 11.7733H21.7727C21.8977 11.7733 22 11.6753 22 11.5556V1.87057C22 1.38903 21.5938 1 21.0909 1H2.90909C2.40625 1 2 1.38903 2 1.87057V22.4377C2 22.9192 2.40625 23.3083 2.90909 23.3083H10.6364C10.7614 23.3083 10.8636 23.2103 10.8636 23.0906V21.5671C10.8636 21.4474 10.7614 21.3495 10.6364 21.3495Z",
      "M6.57317 12.8614C6.50846 12.9251 6.40201 12.9251 6.3373 12.8614L5.57125 12.1035C5.54017 12.0726 5.52274 12.0309 5.52274 11.9874C5.52274 11.944 5.54017 11.9023 5.57125 11.8714L10.0569 7.45532C10.0883 7.42474 10.1307 7.40758 10.1748 7.40758C10.219 7.40758 10.2614 7.42474 10.2928 7.45532L12.6807 9.80713L17.4546 5.29152C17.4859 5.26094 17.5283 5.24378 17.5725 5.24378C17.6167 5.24378 17.659 5.26094 17.6904 5.29152L18.4586 6.04738C18.5233 6.11105 18.5233 6.21581 18.4586 6.27948L12.7976 11.6701C12.7329 11.7338 12.6264 11.7338 12.5617 11.6701L10.1738 9.31828L6.57317 12.8614Z",
      "M20.5648 16.1675V14.9208H21.7158C21.7747 14.9208 21.8229 14.8733 21.8229 14.8153V13.5566C21.8229 13.4986 21.7747 13.4511 21.7158 13.4511H13.2575C13.1986 13.4511 13.1504 13.4986 13.1504 13.5566V14.8153C13.1504 14.8733 13.1986 14.9208 13.2575 14.9208H14.4085V16.1675C14.4085 17.2421 14.9759 18.1876 15.8325 18.7256C14.9759 19.2636 14.4085 20.209 14.4085 21.2837V22.5817H13.2575C13.1986 22.5817 13.1504 22.6291 13.1504 22.6872V23.8945C13.1504 23.9525 13.1986 24 13.2575 24H21.7158C21.7747 24 21.8229 23.9525 21.8229 23.8945L21.8229 22.6872C21.8229 22.6291 21.7747 22.5817 21.7158 22.5817H20.5648V21.2837C20.5648 20.209 19.9974 19.2636 19.1408 18.7256C19.9974 18.1876 20.5648 17.2421 20.5648 16.1675ZM19.2991 21.3892V22.5817H15.6511V21.3892C15.6511 20.8327 15.8708 20.3018 16.2478 19.8496C16.4948 19.5534 16.9215 19.3308 17.4635 19.3308C17.8743 19.3308 18.2806 19.522 18.6794 19.9163C19.0796 20.3092 19.2991 20.8327 19.2991 21.3892ZM19.2991 16.1675C19.2991 16.7239 19.0796 17.2474 18.6794 17.6403C18.2806 18.0346 17.9059 18.1454 17.4635 18.1454C17.059 18.1454 16.6696 17.9291 16.2708 17.5349C16.0736 17.3421 15.9173 17.1126 15.8109 16.8597C15.7045 16.6069 15.6502 16.3357 15.6511 16.062V14.9208H19.2991V16.1675Z",
    ]}
  />
);

export const DemoAccountIcon = ({ colors, ...props }: any) => {
  const prefix = useMemo(() => uuidv4(), []);
  return (
    <Icon {...props} viewBox="0 0 37 33" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.9444 0.569336H10.2775C9.73237 0.569336 9.20944 0.786135 8.82402 1.17156C8.43847 1.55698 8.22192 2.0789 8.22192 2.62491V14.9584H10.2775V11.875H34.9454L34.9464 27.2918H22.611V29.3474H34.9444C35.4893 29.3474 36.0117 29.1306 36.397 28.7452C36.7823 28.3598 36.9991 27.8358 37 27.2918V2.62491C37 2.0789 36.7834 1.55698 36.3979 1.17156C36.0125 0.786135 35.4895 0.569336 34.9444 0.569336ZM18.4998 9.81943H10.2775V2.62491H18.4998V9.81943ZM20.5554 9.81943V2.62491H34.9444V9.81943H20.5554ZM30.8333 20.0973H32.8888V25.2362H30.8333V20.0973ZM28.7777 14.9584H26.7221V25.2362H28.7777V14.9584ZM22.611 17.0139H24.6665V25.2362H22.611V17.0139ZM20.5601 20.7654C20.4689 19.4657 19.8875 18.2493 18.9335 17.362C17.9794 16.4748 16.724 15.983 15.4212 15.9862H5.14329C3.82542 15.9844 2.55723 16.489 1.60081 17.3957C0.644404 18.3023 0.0728752 19.5418 0.004347 20.8579C-0.001449 20.9469 -0.001449 21.0361 0.004347 21.1251V28.8335C0.00161978 29.3067 0.0928037 29.7757 0.272617 30.2134C0.45243 30.651 0.717299 31.0487 1.05188 31.3833C1.38646 31.7178 1.7841 31.9827 2.22177 32.1625C2.65944 32.3423 3.12844 32.4335 3.6016 32.4308C5.06589 32.4308 5.97929 31.3494 6.87031 30.2945L6.88025 30.2827L6.98228 30.1646L6.9823 30.1645C7.27928 29.8203 7.58539 29.4656 7.90804 29.1521C8.38526 28.8026 8.92136 28.5415 9.49083 28.3813C10.0166 28.3196 10.5478 28.3196 11.0736 28.3813C11.6431 28.5415 12.1792 28.8026 12.6564 29.1521C12.9791 29.4656 13.2852 29.8203 13.5821 30.1645L13.5822 30.1645L13.6842 30.2827L13.7853 30.3991C14.648 31.3932 15.5484 32.4308 16.9628 32.4308C17.436 32.4335 17.905 32.3423 18.3427 32.1625C18.7803 31.9827 19.178 31.7178 19.5126 31.3833C19.8472 31.0487 20.112 30.651 20.2918 30.2134C20.4716 29.7757 20.5628 29.3067 20.5601 28.8335V21.1251C20.5657 21.0361 20.5657 20.9469 20.5601 20.8579V20.7654ZM18.5045 28.8335C18.5045 29.2424 18.3421 29.6345 18.053 29.9237C17.7639 30.2128 17.3717 30.3752 16.9628 30.3752C16.5071 30.3752 16.0513 29.8578 15.4809 29.2102L15.4808 29.2101C15.408 29.1276 15.3334 29.0429 15.2567 28.9569C15.194 28.8849 15.13 28.8107 15.0645 28.7348L15.0645 28.7348C14.7654 28.3879 14.4374 28.0076 14.0748 27.6618C13.3306 27.0623 12.4694 26.6247 11.5464 26.3771C10.7104 26.2263 9.85409 26.2263 9.01805 26.3771C8.09503 26.6247 7.23388 27.0623 6.48969 27.6618C6.12707 28.0076 5.79904 28.388 5.49994 28.7348L5.49993 28.7348L5.49982 28.7349L5.49937 28.7354L5.49892 28.736L5.49887 28.736L5.49829 28.7367C5.43343 28.8119 5.36993 28.8855 5.30773 28.9569C4.6705 29.7174 4.1155 30.3752 3.6016 30.3752C3.19273 30.3752 2.80059 30.2128 2.51147 29.9237C2.22235 29.6345 2.05992 29.2424 2.05992 28.8335V21.1251C2.06494 21.0739 2.06494 21.0222 2.05992 20.9709C2.09951 20.1802 2.44176 19.435 3.01576 18.8897C3.58977 18.3444 4.35155 18.0408 5.14329 18.0418H15.4212C16.1914 18.0384 16.935 18.3235 17.5057 18.8408C18.0763 19.3582 18.4326 20.0704 18.5045 20.8373V20.9607C18.4994 21.0154 18.4994 21.0704 18.5045 21.1251V28.8335ZM14.3929 25.2362C14.9606 25.2362 15.4207 24.7761 15.4207 24.2084C15.4207 23.6408 14.9606 23.1806 14.3929 23.1806C13.8253 23.1806 13.3651 23.6408 13.3651 24.2084C13.3651 24.7761 13.8253 25.2362 14.3929 25.2362ZM17.4762 22.1528C17.4762 22.7205 17.016 23.1806 16.4484 23.1806C15.8808 23.1806 15.4206 22.7205 15.4206 22.1528C15.4206 21.5852 15.8808 21.125 16.4484 21.125C17.016 21.125 17.4762 21.5852 17.4762 22.1528ZM14.3929 21.1251C14.9606 21.1251 15.4207 20.6649 15.4207 20.0973C15.4207 19.5297 14.9606 19.0695 14.3929 19.0695C13.8253 19.0695 13.3651 19.5297 13.3651 20.0973C13.3651 20.6649 13.8253 21.1251 14.3929 21.1251ZM13.3661 22.1528C13.3661 22.7205 12.9059 23.1806 12.3383 23.1806C11.7706 23.1806 11.3105 22.7205 11.3105 22.1528C11.3105 21.5852 11.7706 21.125 12.3383 21.125C12.9059 21.125 13.3661 21.5852 13.3661 22.1528ZM6.17064 24.2084C7.30591 24.2084 8.22622 23.2881 8.22622 22.1528C8.22622 21.0176 7.30591 20.0973 6.17064 20.0973C5.03538 20.0973 4.11507 21.0176 4.11507 22.1528C4.11507 23.2881 5.03538 24.2084 6.17064 24.2084Z"
        fill={`url(#${prefix}paint0_linear_2357_37169)`}
      />
      <defs>
        <linearGradient
          id={`${prefix}paint0_linear_2357_37169`}
          x1="38.5416"
          y1="28.3197"
          x2="4.1108"
          y2="3.13922"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors?.[0]} />
          <stop offset="1" stopColor={colors?.[1]} />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const GroupMedal = (props: any) => {
  return (
    <Icon {...props} width="38" height="39" viewBox="0 0 38 39" fill="none">
      <path d="M37.5 32.5L27 22L19 27.5L30.5 39V32.5H37.5Z" fill="#A5CFFF" />
      <path d="M0 32.5L10.5 22L18.5 27.5L7 39V32.5H0Z" fill="#A5CFFF" />
      <g filter="url(#filter0_d_251_43676)">
        <circle
          cx="18.5"
          cy="17.5"
          r="12.5"
          fill="url(#paint0_linear_251_43676)"
        />
        <circle
          cx="18.5"
          cy="17.5"
          r="11.5"
          stroke="url(#paint1_linear_251_43676)"
          strokeWidth="2"
          width="25"
          height="25"
        />
      </g>
      <path
        d="M10 17.5C15.9198 17.5 18.5 15.0095 18.5 9C18.5 15.0095 21.0623 17.5 27 17.5C21.0623 17.5 18.5 20.0623 18.5 26C18.5 20.0623 15.9198 17.5 10 17.5Z"
        fill="url(#paint2_linear_251_43676)"
      />
      <defs>
        <filter
          id="filter0_d_251_43676"
          x="0"
          y="0"
          width="37"
          height="37"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.12549 0 0 0 0 0.4 0 0 0 0 0.92549 0 0 0 0.35 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_251_43676"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_251_43676"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_251_43676"
          x1="18.5"
          y1="5"
          x2="15"
          y2="29"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3781F1" />
          <stop offset="1" stopColor="#0D4ECE" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_251_43676"
          x1="18.5"
          y1="5"
          x2="18.5"
          y2="30"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#76BBFF" />
          <stop offset="1" stopColor="#357FF0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_251_43676"
          x1="17"
          y1="11"
          x2="22.7601"
          y2="26"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const Diamond = (props: any) => {
  const prefix = useMemo(() => uuidv4(), []);

  return (
    <Icon {...props} viewBox="0 0 13 13" fill="none">
      <path
        d="M0 6.5C4.52689 6.5 6.5 4.5955 6.5 0C6.5 4.5955 8.45939 6.5 13 6.5C8.45939 6.5 6.5 8.45939 6.5 13C6.5 8.45939 4.52689 6.5 0 6.5Z"
        fill={`url(#${prefix}paint0_linear_265_44777)`}
      />
      <defs>
        <linearGradient
          id={`${prefix}paint0_linear_265_44777`}
          x1="5.35294"
          y1="1.52941"
          x2="9.75773"
          y2="13"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.51" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const ProfitIcon = (props: any) => (
  <Icon {...props} width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M21.4923 4.94752L16.8235 5.51002C16.6688 5.52877 16.6032 5.71862 16.7134 5.82877L18.1032 7.21862L12.8063 12.5155L10.4204 10.1319C10.2727 9.98424 10.036 9.98659 9.8907 10.1319L2.35086 17.6741C2.31596 17.7093 2.29639 17.7569 2.29639 17.8065C2.29639 17.8561 2.31596 17.9037 2.35086 17.9389L3.40554 18.9983C3.4782 19.071 3.59773 19.071 3.67039 18.9983L10.1555 12.5155L12.5391 14.8991C12.6868 15.0444 12.9235 15.0444 13.0688 14.8991L19.4298 8.54284L20.8196 9.93268C20.8445 9.95746 20.8759 9.97476 20.9101 9.9826C20.9444 9.99045 20.9801 9.98852 21.0133 9.97704C21.0466 9.96557 21.0759 9.945 21.098 9.91768C21.1201 9.89037 21.1341 9.8574 21.1384 9.82252L21.7009 5.15377C21.7173 5.03424 21.6141 4.93112 21.4923 4.94752Z"
      fill="#B8BEC8"
    />
  </Icon>
);

export const RiskIcon = (props: any) => (
  <Icon {...props} width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M20.3802 8.57012L19.1502 10.4201C19.7433 11.6032 20.0337 12.915 19.9954 14.2378C19.957 15.5607 19.591 16.8534 18.9302 18.0001H5.07017C4.21134 16.5102 3.85547 14.7832 4.05531 13.0752C4.25516 11.3671 5.00008 9.76895 6.17965 8.51755C7.35922 7.26615 8.91064 6.42816 10.6039 6.12782C12.2972 5.82747 14.0422 6.08076 15.5802 6.85012L17.4302 5.62012C15.5467 4.41234 13.3125 3.87113 11.0851 4.08306C8.85763 4.29499 6.76562 5.24782 5.14367 6.78913C3.52171 8.33045 2.46353 10.3712 2.13839 12.5849C1.81325 14.7987 2.23992 17.0575 3.35017 19.0001C3.52468 19.3024 3.77526 19.5537 4.077 19.7292C4.37875 19.9046 4.72115 19.998 5.07017 20.0001H18.9202C19.2726 20.0015 19.6191 19.9098 19.9247 19.7342C20.2302 19.5586 20.484 19.3053 20.6602 19.0001C21.5815 17.404 22.0439 15.5844 21.9963 13.7421C21.9486 11.8998 21.3928 10.1064 20.3902 8.56012L20.3802 8.57012ZM10.5902 15.4101C10.7759 15.5961 10.9965 15.7436 11.2393 15.8442C11.4821 15.9449 11.7423 15.9967 12.0052 15.9967C12.268 15.9967 12.5283 15.9449 12.7711 15.8442C13.0138 15.7436 13.2344 15.5961 13.4202 15.4101L19.0802 6.92012L10.5902 12.5801C10.4042 12.7659 10.2567 12.9864 10.1561 13.2292C10.0554 13.472 10.0036 13.7323 10.0036 13.9951C10.0036 14.258 10.0554 14.5182 10.1561 14.761C10.2567 15.0038 10.4042 15.2244 10.5902 15.4101Z"
      fill="#B8BEC8"
    />
  </Icon>
);

export const ServiceIcon = (props: any) => (
  <Icon {...props} width="24" height="24" viewBox="0 0 23 12" fill="none">
    <path
      d="M20.7814 6.55701C21.4079 6.55701 21.9361 6.77558 22.366 7.21272C22.7958 7.64985 23.0071 8.15984 22.9998 8.74268L14.2243 12.0212L6.5745 9.83552V0H8.70553L16.6504 2.93973C17.2187 3.16558 17.5029 3.57357 17.5029 4.1637C17.5029 4.50613 17.379 4.80483 17.1313 5.05983C16.8836 5.31482 16.5703 5.44961 16.1915 5.46418H13.1315L11.219 4.73198L10.8584 5.75924L13.1315 6.55701H20.7814ZM0 0H4.38883V12.0212H0V0Z"
      fill="#B8BEC8"
    />
  </Icon>
);

export const RocketIcon = (props: any) => (
  <Icon {...props} viewBox="0 0 16 16" fill="inherit">
    <g clipPath="url(#clip0_2758_280021)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.31147 4.1109L8.1648 3.25756C8.85174 2.56956 10.0581 2.09276 11.256 1.92103C11.787 1.83769 12.3272 1.8305 12.8603 1.8997C13.3328 1.9701 13.6219 2.10876 13.7563 2.24423C13.8917 2.37863 14.0304 2.6677 14.1008 3.14023C14.1691 3.5957 14.1637 4.15356 14.0795 4.7445C13.9088 5.94236 13.4309 7.14876 12.7429 7.8357L8.00054 12.5792L6.77814 11.3568C6.72862 11.3072 6.66982 11.2678 6.6051 11.241C6.54037 11.2141 6.47099 11.2002 6.40091 11.2002C6.33084 11.2002 6.26144 11.2139 6.19667 11.2407C6.13191 11.2674 6.07306 11.3067 6.02347 11.3562C5.92332 11.4562 5.86701 11.5919 5.86691 11.7335C5.86686 11.8035 5.88061 11.8729 5.90738 11.9377C5.93415 12.0025 5.97342 12.0613 6.02294 12.1109L7.62294 13.7109C7.67248 13.7606 7.73133 13.8 7.79613 13.8269C7.86092 13.8537 7.93038 13.8676 8.00054 13.8676C8.07069 13.8676 8.14015 13.8537 8.20495 13.8269C8.26974 13.8 8.32859 13.7606 8.37814 13.7109L8.9616 13.1264L10.2096 15.2074C10.2512 15.2771 10.3082 15.3364 10.3762 15.3807C10.4442 15.425 10.5214 15.4533 10.6019 15.4633C10.6825 15.4732 10.7642 15.4647 10.841 15.4383C10.9177 15.4119 10.9874 15.3683 11.0448 15.3109L13.1781 13.1776C13.2367 13.1189 13.2808 13.0474 13.3069 12.9687C13.333 12.89 13.3404 12.8063 13.3285 12.7242L12.8325 9.25543L13.4981 8.5909C14.4101 7.67783 14.9467 6.21756 15.1355 4.8949C15.2315 4.2261 15.2421 3.56156 15.1557 2.9813C15.0704 2.4181 14.8827 1.8613 14.5115 1.48903C14.1392 1.11783 13.5824 0.929031 13.0181 0.844764C12.3829 0.76065 11.7388 0.767834 11.1056 0.866097C9.78187 1.05276 8.32054 1.5893 7.4096 2.5013L6.74507 3.1669L3.27627 2.6709C3.19422 2.659 3.11052 2.6664 3.03183 2.69251C2.95313 2.71862 2.88161 2.76272 2.82294 2.8213L0.689603 4.95463C0.632183 5.01199 0.588612 5.0817 0.56221 5.15845C0.535808 5.2352 0.527271 5.31697 0.537249 5.39751C0.547228 5.47806 0.575458 5.55527 0.619791 5.62326C0.664123 5.69124 0.723387 5.74821 0.793069 5.78983L2.87307 7.03783L2.2896 7.6213C2.23994 7.67084 2.20053 7.72969 2.17364 7.79449C2.14676 7.85928 2.13292 7.92875 2.13292 7.9989C2.13292 8.06905 2.14676 8.13851 2.17364 8.20331C2.20053 8.2681 2.23994 8.32695 2.2896 8.3765L3.8896 9.9765C3.93919 10.0261 3.99806 10.0654 4.06285 10.0923C4.12764 10.1191 4.19708 10.1329 4.2672 10.1329C4.33733 10.1329 4.40677 10.1191 4.47156 10.0923C4.53635 10.0654 4.59522 10.0261 4.6448 9.9765C4.69439 9.92691 4.73373 9.86804 4.76056 9.80325C4.7874 9.73846 4.80121 9.66902 4.80121 9.5989C4.80121 9.52877 4.7874 9.45933 4.76056 9.39454C4.73373 9.32975 4.69439 9.27088 4.6448 9.2213L3.42134 7.99996L4.11147 7.3109L7.31147 4.1109ZM10.7728 14.0736L9.73814 12.3488L11.8896 10.1984L12.2352 12.6112L10.7728 14.0736ZM3.65174 6.2613L5.80214 4.1109L3.38934 3.7653L1.928 5.22663L3.65174 6.2613ZM2.5104 11.0442C2.55999 10.9947 2.59934 10.9359 2.6262 10.8712C2.65306 10.8065 2.66692 10.7371 2.66697 10.667C2.66702 10.5969 2.65326 10.5275 2.62649 10.4628C2.59972 10.398 2.56045 10.3391 2.51094 10.2896C2.46142 10.24 2.40262 10.2006 2.3379 10.1738C2.27317 10.1469 2.20379 10.133 2.13371 10.133C2.06364 10.1329 1.99424 10.1467 1.92947 10.1735C1.86471 10.2002 1.80586 10.2395 1.75627 10.289L0.689603 11.3557C0.589598 11.4558 0.533473 11.5916 0.533573 11.7331C0.533673 11.8747 0.58999 12.0104 0.690136 12.1104C0.790282 12.2104 0.926052 12.2665 1.06758 12.2664C1.20911 12.2663 1.3448 12.21 1.4448 12.1098L2.5104 11.0442ZM4.1104 12.6442C4.16134 12.595 4.20197 12.5362 4.22992 12.4711C4.25788 12.406 4.27259 12.3361 4.2732 12.2652C4.27382 12.1944 4.26032 12.1242 4.23351 12.0587C4.20669 11.9931 4.16709 11.9336 4.11701 11.8835C4.06694 11.8334 4.00739 11.7938 3.94185 11.767C3.8763 11.7402 3.80607 11.7267 3.73526 11.7273C3.66444 11.7279 3.59446 11.7426 3.52939 11.7706C3.46432 11.7985 3.40547 11.8392 3.35627 11.8901L1.22294 14.0234C1.12293 14.1236 1.06681 14.2593 1.06691 14.4009C1.06701 14.5424 1.12332 14.6781 1.22347 14.7781C1.32362 14.8781 1.45939 14.9342 1.60091 14.9341C1.74244 14.934 1.87813 14.8777 1.97814 14.7776L4.1104 12.6442ZM5.7104 14.2442C5.75999 14.1947 5.79934 14.1359 5.8262 14.0712C5.85307 14.0065 5.86692 13.9371 5.86697 13.867C5.86702 13.7969 5.85326 13.7275 5.82649 13.6628C5.79972 13.598 5.76045 13.5391 5.71094 13.4896C5.66142 13.44 5.60262 13.4006 5.5379 13.3738C5.47317 13.3469 5.40379 13.333 5.33371 13.333C5.26364 13.3329 5.19424 13.3467 5.12947 13.3735C5.06471 13.4002 5.00586 13.4395 4.95627 13.489L3.8896 14.5557C3.7896 14.6558 3.73347 14.7916 3.73357 14.9331C3.73367 15.0747 3.78999 15.2104 3.89014 15.3104C3.99028 15.4104 4.12605 15.4665 4.26758 15.4664C4.40911 15.4663 4.5448 15.41 4.6448 15.3098L5.7104 14.2442ZM10.1339 7.1989C10.3088 7.1989 10.4821 7.16444 10.6437 7.09748C10.8053 7.03053 10.9522 6.9324 11.0759 6.80868C11.1996 6.68497 11.2978 6.5381 11.3647 6.37647C11.4317 6.21483 11.4661 6.04159 11.4661 5.86663C11.4661 5.69167 11.4317 5.51843 11.3647 5.35679C11.2978 5.19516 11.1996 5.04829 11.0759 4.92458C10.9522 4.80086 10.8053 4.70273 10.6437 4.63578C10.4821 4.56882 10.3088 4.53436 10.1339 4.53436C9.78053 4.53436 9.44166 4.67473 9.19181 4.92458C8.94197 5.17442 8.8016 5.51329 8.8016 5.86663C8.8016 6.21997 8.94197 6.55884 9.19181 6.80868C9.44166 7.05853 9.78053 7.1989 10.1339 7.1989Z"
        fill="inherit"
      />
    </g>
    <defs>
      <clipPath id="clip0_2758_280021">
        <rect width="16" height="16" fill="inherit" />
      </clipPath>
    </defs>
  </Icon>
);

export const CreateAccountIcon = (props: any) => (
  <Icon {...props} width="28" height="28" viewBox="0 0 28 28" fill="inherit">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 0H26C26.5304 0 27.0391 0.210714 27.4142 0.585786C27.7893 0.960859 28 1.46957 28 2V26C27.9992 26.5302 27.7882 27.0384 27.4133 27.4133C27.0384 27.7882 26.5302 27.9992 26 28H2C1.2445 27.9831 0.910939 27.8788 0.5 27.5C0.205227 27.1373 0.039766 26.9282 0 26V2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0ZM2 26V11H26.001L26.002 26H2ZM10 9H2V2H10V9ZM12 9V2H26V9H12ZM23 19H21V24H23V19ZM19 14H17V24H19V14ZM15 16H13V24H15V16ZM11.5 19H9.5V24H11.5V19ZM7.5 17H5.5V24H7.5V17Z"
      fill="inherit"
    />
  </Icon>
);

export const PositiveFeedbackIcon = (props: any) => (
  <Icon {...props} width="126" height="120" viewBox="0 0 126 120" fill="none">
    <path
      d="M0.722009 85.0841C1.14523 82.968 32.9929 42.938 48.8638 23.1875L80.0767 90.3744C56.2703 90.7271 8.02263 91.4324 5.48328 91.4324C2.3091 91.4324 0.192978 87.7292 0.722009 85.0841Z"
      fill="url(#paint0_linear_309_8018)"
    />
    <mask
      id="mask0_309_8018"
      maskUnits="userSpaceOnUse"
      x="0"
      y="23"
      width="81"
      height="69"
    >
      <path
        d="M0.722009 85.0841C1.14523 82.968 32.9929 42.938 48.8638 23.1875L80.0767 90.3744C56.2703 90.7271 8.02263 91.4324 5.48328 91.4324C2.3091 91.4324 0.192978 87.7292 0.722009 85.0841Z"
        fill="url(#paint1_linear_309_8018)"
      />
    </mask>
    <g mask="url(#mask0_309_8018)">
      <ellipse
        cx="50.2828"
        cy="69.8837"
        rx="46.1679"
        ry="36.4315"
        transform="rotate(-26.1391 50.2828 69.8837)"
        fill="url(#paint2_linear_309_8018)"
      />
      <ellipse
        cx="64.7509"
        cy="61.405"
        rx="49.6543"
        ry="42.9547"
        transform="rotate(-26.1391 64.7509 61.405)"
        fill="url(#paint3_linear_309_8018)"
      />
      <ellipse
        cx="74.0587"
        cy="52.3443"
        rx="44.3205"
        ry="43.7293"
        transform="rotate(-26.1391 74.0587 52.3443)"
        fill="url(#paint4_linear_309_8018)"
      />
    </g>
    <ellipse
      cx="66.6389"
      cy="55.9561"
      rx="15.7309"
      ry="37.0321"
      transform="rotate(-26.1391 66.6389 55.9561)"
      fill="url(#paint5_linear_309_8018)"
    />
    <path
      d="M91.3365 2.50651L90.8961 1.90865M94.7977 3.03112L95.3955 2.59064M93.9794 6.09368L94.5667 6.89083M91.0112 5.82081L90.2141 6.40812"
      stroke="#2276BB"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M76.3001 7.71631C81.9645 11.3719 82.7987 24.0258 74.3316 29.7458M85.0427 45.5066C90.5501 45.9987 102.967 36.4681 102.075 25.7483M92.1745 56.095C96.909 53.7833 108.148 50.7652 115.226 57.187M92.1745 71.858C94.5543 72.3347 100.036 74.5332 102.926 79.5133"
      stroke="#72AAFE"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M51.7396 4.56942L51.5703 2.86401M48.9455 7.52493L47.2401 7.69426M52.0088 10.535L52.1993 12.4536"
      stroke="#2368D3"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M108.59 81.1733L109.235 82.049M110.835 81.6585L110.927 80.5776M112.181 82.581L113.063 81.8188M112.609 84.0668L113.669 84.2995M111.762 85.479L112.407 86.3548M110.162 85.8695L109.999 87.0035M108.87 85.02L107.935 85.7093M108.388 83.4612L107.257 83.2816"
      stroke="#92BDFF"
      strokeLinecap="round"
    />
    <path
      d="M55.2266 6.60051C56.9348 6.08244 60.3504 5.8263 61.9068 8.36278C63.4631 10.8993 62.7899 15.3833 59.671 15.9648C56.552 16.5463 55.2195 13.0351 58.1166 11.6734C61.5991 10.0365 65.2435 12.2662 66.1314 14.997C66.8418 17.1816 65.3845 19.0258 64.5671 19.6749"
      stroke="#2368D3"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M97.8212 17.8481L99.459 20.0711M103.52 19.0799L103.753 16.3359M106.936 21.4216L109.175 19.4867M108.024 25.1932L110.714 25.7838M105.874 28.778L107.512 31.0011M101.813 29.7693L101.397 32.6479M98.5331 27.6128L96.1582 29.3625M97.3089 23.6559L94.4364 23.2"
      stroke="#BCD6FF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M112.88 53.1495L114.105 54.8122M117.07 54.1243L117.21 52.0971M119.6 55.8946L121.218 54.4883M120.439 58.6966L122.416 59.1635M118.903 61.3243L120.128 62.987M115.938 62.0122L115.666 64.1369M113.511 60.3804L111.79 61.6482M112.57 57.4399L110.46 57.0705"
      stroke="#AECEFF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <ellipse
      cx="105.192"
      cy="70.1176"
      rx="1.73274"
      ry="1.73274"
      transform="rotate(-178.42 105.192 70.1176)"
      fill="#2368D3"
    />
    <circle
      cx="86.1566"
      cy="64.6193"
      r="2.97041"
      transform="rotate(-36.3811 86.1566 64.6193)"
      fill="#5C99F6"
    />
    <circle
      cx="114.598"
      cy="37.5754"
      r="1.96628"
      transform="rotate(-36.3811 114.598 37.5754)"
      fill="#5C99F6"
    />
    <g filter="url(#filter0_f_309_8018)">
      <path
        d="M20.8253 89.3164H24.5285H28.7607L86.4251 78.7358L85.367 70.8003C66.3219 70.8003 27.0679 71.3293 22.4124 73.4454C17.7569 75.5616 19.5908 84.3787 20.8253 89.3164Z"
        fill="#2C70D9"
        fillOpacity="0.3"
      />
    </g>
    <path
      d="M24.7548 75.5654C25.957 74.5739 28.0978 73.9746 29.7979 73.9746H59.4381H89.0783C90.7784 73.9746 93.1282 74.5316 94.3303 75.5231C95.5324 76.5145 96.1785 78.3666 96.1785 79.7688L96.4766 104.069C96.4766 105.471 95.8013 107.409 94.5992 108.4C93.397 109.392 91.0765 109.949 89.3765 109.949H70.0251L60.8906 118.621C60.0888 119.383 58.8213 119.349 58.0612 118.546L49.9219 109.949H31.3128C29.6127 109.949 26.2565 109.05 25.0544 108.059C23.0149 106.377 22.6827 104.473 22.6827 103.071L22.4124 80.1115C22.4124 78.7094 23.5527 76.5568 24.7548 75.5654Z"
      fill="url(#paint6_linear_309_8018)"
    />
    <path
      d="M41.2571 88.9989C40.9796 88.9989 40.8409 88.9989 40.7293 88.9383C40.6881 88.9159 40.6503 88.8879 40.6169 88.855C40.5264 88.7658 40.4861 88.633 40.4055 88.3676L39.1349 84.1844C38.8335 83.1922 38.6828 82.696 38.4218 82.6208C38.3313 82.5947 38.2353 82.5947 38.1448 82.6208C37.8838 82.696 37.7331 83.1922 37.4317 84.1844L36.1611 88.3676C36.0804 88.633 36.0401 88.7658 35.9497 88.855C35.9163 88.8879 35.8785 88.9159 35.8373 88.9383C35.7256 88.9989 35.5869 88.9989 35.3095 88.9989H31.5401C30.5496 88.9989 30.0544 88.9989 29.906 89.2218C29.8544 89.2993 29.8255 89.3896 29.8225 89.4827C29.8138 89.7503 30.2169 90.038 31.0232 90.6134L34.1223 92.8249C34.3427 92.9822 34.453 93.0608 34.5086 93.1722C34.5291 93.2133 34.5438 93.2571 34.5524 93.3022C34.5756 93.4245 34.5356 93.5539 34.4555 93.8126L33.2288 97.7745C32.9362 98.7196 32.7899 99.1921 32.9588 99.3998C33.0175 99.472 33.0952 99.5263 33.1831 99.5568C33.4361 99.6443 33.8299 99.345 34.6176 98.7463L37.7451 96.3689C37.971 96.1972 38.084 96.1114 38.2121 96.0929C38.2593 96.0861 38.3073 96.086 38.3545 96.0928C38.4827 96.1112 38.5957 96.197 38.8217 96.3685L41.9602 98.7503C42.7473 99.3477 43.1409 99.6464 43.3938 99.5587C43.4817 99.5282 43.5593 99.4739 43.618 99.4017C43.7868 99.194 43.6407 98.7221 43.3484 97.7781L42.1204 93.8121C42.0404 93.5536 42.0004 93.4243 42.0236 93.3021C42.0321 93.257 42.0468 93.2132 42.0673 93.1721C42.1228 93.0608 42.2329 92.9821 42.4531 92.8248L45.5476 90.613C46.3525 90.0377 46.755 89.75 46.7461 89.4824C46.7431 89.3894 46.7141 89.2992 46.6626 89.2217C46.5141 88.9989 46.0195 88.9989 45.0301 88.9989H41.2571Z"
      fill="white"
    />
    <path
      d="M62.4183 88.9989C62.1409 88.9989 62.0021 88.9989 61.8905 88.9383C61.8493 88.9159 61.8115 88.8879 61.7781 88.855C61.6877 88.7658 61.6474 88.633 61.5667 88.3676L60.2961 84.1844C59.9947 83.1922 59.844 82.696 59.583 82.6208C59.4925 82.5947 59.3965 82.5947 59.306 82.6208C59.045 82.696 58.8943 83.1922 58.5929 84.1844L57.3223 88.3676C57.2417 88.633 57.2013 88.7658 57.1109 88.855C57.0775 88.8879 57.0397 88.9159 56.9985 88.9383C56.8869 88.9989 56.7482 88.9989 56.4707 88.9989H52.7014C51.7109 88.9989 51.2156 88.9989 51.0672 89.2218C51.0156 89.2993 50.9867 89.3896 50.9837 89.4827C50.975 89.7503 51.3781 90.038 52.1844 90.6134L55.2835 92.8249C55.504 92.9822 55.6142 93.0608 55.6698 93.1722C55.6903 93.2133 55.7051 93.2571 55.7136 93.3022C55.7369 93.4245 55.6968 93.5539 55.6167 93.8126L54.39 97.7745C54.0974 98.7196 53.9511 99.1921 54.1201 99.3998C54.1788 99.472 54.2564 99.5263 54.3444 99.5568C54.5974 99.6443 54.9912 99.345 55.7788 98.7463L58.9064 96.3689C59.1323 96.1972 59.2452 96.1114 59.3733 96.0929C59.4206 96.0861 59.4685 96.086 59.5158 96.0928C59.6439 96.1112 59.7569 96.197 59.983 96.3685L63.1214 98.7503C63.9086 99.3477 64.3022 99.6464 64.555 99.5587C64.6429 99.5282 64.7205 99.4739 64.7792 99.4017C64.948 99.194 64.8019 98.7221 64.5096 97.7781L63.2817 93.8121C63.2016 93.5536 63.1616 93.4243 63.1848 93.3021C63.1933 93.257 63.2081 93.2132 63.2286 93.1721C63.2841 93.0608 63.3942 92.9821 63.6143 92.8248L66.7088 90.613C67.5137 90.0377 67.9162 89.75 67.9074 89.4824C67.9043 89.3894 67.8754 89.2992 67.8238 89.2217C67.6754 88.9989 67.1807 88.9989 66.1913 88.9989H62.4183Z"
      fill="white"
    />
    <path
      d="M83.5795 88.9989C83.3021 88.9989 83.1633 88.9989 83.0517 88.9383C83.0105 88.9159 82.9727 88.8879 82.9393 88.855C82.8489 88.7658 82.8086 88.633 82.7279 88.3676L81.4573 84.1844C81.1559 83.1922 81.0052 82.696 80.7442 82.6208C80.6537 82.5947 80.5577 82.5947 80.4672 82.6208C80.2062 82.696 80.0555 83.1922 79.7541 84.1844L78.4835 88.3676C78.4029 88.633 78.3625 88.7658 78.2721 88.855C78.2387 88.8879 78.2009 88.9159 78.1597 88.9383C78.0481 88.9989 77.9094 88.9989 77.6319 88.9989H73.8626C72.8721 88.9989 72.3768 88.9989 72.2284 89.2218C72.1768 89.2993 72.1479 89.3896 72.1449 89.4827C72.1362 89.7503 72.5393 90.038 73.3456 90.6134L76.4447 92.8249C76.6652 92.9822 76.7754 93.0608 76.831 93.1722C76.8515 93.2133 76.8663 93.2571 76.8748 93.3022C76.8981 93.4245 76.858 93.5539 76.7779 93.8126L75.5512 97.7745C75.2586 98.7196 75.1123 99.1921 75.2813 99.3998C75.34 99.472 75.4177 99.5263 75.5056 99.5568C75.7586 99.6443 76.1524 99.345 76.94 98.7463L80.0676 96.3689C80.2935 96.1972 80.4064 96.1114 80.5346 96.0929C80.5818 96.0861 80.6297 96.086 80.677 96.0928C80.8051 96.1112 80.9181 96.197 81.1442 96.3685L84.2826 98.7503C85.0698 99.3477 85.4634 99.6464 85.7162 99.5587C85.8041 99.5282 85.8817 99.4739 85.9404 99.4017C86.1092 99.194 85.9631 98.7221 85.6708 97.7781L84.4429 93.8121C84.3628 93.5536 84.3228 93.4243 84.346 93.3021C84.3545 93.257 84.3693 93.2132 84.3898 93.1721C84.4453 93.0608 84.5554 92.9821 84.7755 92.8248L87.87 90.613C88.6749 90.0377 89.0774 89.75 89.0686 89.4824C89.0655 89.3894 89.0366 89.2992 88.985 89.2217C88.8366 88.9989 88.3419 88.9989 87.3525 88.9989H83.5795Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_f_309_8018"
        x="11.4091"
        y="62.8003"
        width="83.016"
        height="34.5161"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="4"
          result="effect1_foregroundBlur_309_8018"
        />
      </filter>
      <linearGradient
        id="paint0_linear_309_8018"
        x1="7.5995"
        y1="84.555"
        x2="12.8898"
        y2="98.3098"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EBF3FF" />
        <stop offset="1" stopColor="#AECFFF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_309_8018"
        x1="6.01241"
        y1="64.9809"
        x2="18.1801"
        y2="97.7808"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E9F2FF" />
        <stop offset="1" stopColor="#8C9199" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_309_8018"
        x1="37.4051"
        y1="59.2809"
        x2="39.7313"
        y2="85.7624"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B9D5FF" />
        <stop offset="0.830826" stopColor="#88B7FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_309_8018"
        x1="59.2826"
        y1="52.0972"
        x2="61.1779"
        y2="84.2602"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#ECF4FF" />
        <stop offset="1" stopColor="#D2E4FF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_309_8018"
        x1="59.9849"
        y1="73.0679"
        x2="54.2815"
        y2="37.8574"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#90BBFE" />
        <stop offset="1" stopColor="#B9D5FF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_309_8018"
        x1="76.4975"
        y1="25.2515"
        x2="52.287"
        y2="80.4897"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#74ABFF" />
        <stop offset="1" stopColor="#115ACA" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_309_8018"
        x1="59.4445"
        y1="130.295"
        x2="31.9309"
        y2="45.3932"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#ABCDFF" />
        <stop offset="0.9999" stopColor="#EAF2FF" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
    </defs>
  </Icon>
);

export const DarkPositiveFeedbackIcon = (props: any) => {
  return (
    <Icon {...props} width="177" height="170" viewBox="0 0 177 170" fill="none">
      <path
        d="M0.114775 120.536C0.714343 117.538 45.8318 60.8287 68.3156 32.8489L112.534 128.03C78.8082 128.53 10.4573 129.529 6.85992 129.529C2.36316 129.529 -0.634685 124.283 0.114775 120.536Z"
        fill="url(#paint0_linear_3238_244120)"
      />
      <mask
        id="mask0_3238_244120"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="32"
        width="113"
        height="98"
      >
        <path
          d="M0.114775 120.536C0.714343 117.538 45.8318 60.8287 68.3156 32.8489L112.534 128.03C78.8082 128.53 10.4573 129.529 6.85992 129.529C2.36316 129.529 -0.634685 124.283 0.114775 120.536Z"
          fill="url(#paint1_linear_3238_244120)"
        />
      </mask>
      <g mask="url(#mask0_3238_244120)">
        <ellipse
          cx="62.958"
          cy="98.619"
          rx="70.3436"
          ry="60.8525"
          transform="rotate(-26.1391 62.958 98.619)"
          fill="url(#paint2_linear_3238_244120)"
        />
        <ellipse
          cx="70.326"
          cy="99.0023"
          rx="65.4046"
          ry="51.6113"
          transform="rotate(-26.1391 70.326 99.0023)"
          fill="url(#paint3_linear_3238_244120)"
        />
        <ellipse
          cx="90.8224"
          cy="86.9906"
          rx="70.3436"
          ry="60.8525"
          transform="rotate(-26.1391 90.8224 86.9906)"
          fill="url(#paint4_linear_3238_244120)"
        />
        <ellipse
          cx="104.008"
          cy="74.1543"
          rx="62.7873"
          ry="61.9498"
          transform="rotate(-26.1391 104.008 74.1543)"
          fill="url(#paint5_linear_3238_244120)"
        />
      </g>
      <ellipse
        cx="93.4971"
        cy="79.2712"
        rx="22.2854"
        ry="52.4622"
        transform="rotate(-26.1391 93.4971 79.2712)"
        fill="url(#paint6_linear_3238_244120)"
      />
      <path
        d="M128.485 3.55113L127.861 2.70416M133.389 4.29433L134.236 3.67032M132.229 8.63296L133.061 9.76225M128.025 8.2464L126.895 9.07841"
        stroke="#2276BB"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M107.184 10.9318C115.208 16.1106 116.39 34.0369 104.395 42.1403M119.569 64.468C127.371 65.1651 144.962 51.6635 143.697 36.477M129.672 79.4683C136.38 76.1933 152.301 71.9176 162.328 81.0153M129.672 101.799C133.044 102.475 140.81 105.589 144.903 112.644"
        stroke="#72AAFE"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M72.3898 6.47323L72.1499 4.05723M68.4314 10.6602L66.0154 10.9001M72.7711 14.9245L73.0409 17.6425"
        stroke="#4D92FF"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M152.928 114.996L153.842 116.236M156.108 115.683L156.238 114.152M158.015 116.99L159.264 115.91M158.622 119.095L160.123 119.425M157.422 121.096L158.336 122.336M155.155 121.649L154.923 123.255M153.325 120.445L152 121.422M152.642 118.237L151.039 117.983"
        stroke="#92BDFF"
        strokeLinecap="round"
      />
      <path
        d="M77.3297 9.35101C79.7497 8.61708 84.5884 8.25422 86.7932 11.8476C88.9981 15.4409 88.0444 21.7932 83.6259 22.617C79.2073 23.4408 77.3196 18.4666 81.4238 16.5375C86.3574 14.2187 91.5203 17.3774 92.7782 21.246C93.7845 24.3409 91.7201 26.9536 90.562 27.873"
        stroke="#4D92FF"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M137.672 25.2849L139.992 28.4342M145.745 27.0299L146.075 23.1426M150.585 30.3474L153.756 27.6063M152.126 35.6905L155.936 36.5271M149.08 40.769L151.4 43.9183M143.327 42.1733L142.738 46.2513M138.68 39.1182L135.316 41.5969M136.946 33.5127L132.877 32.8668"
        stroke="#447CCF"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M159.006 75.2953L160.741 77.6507M164.941 76.6762L165.14 73.8044M168.525 79.1841L170.818 77.1919M169.713 83.1536L172.515 83.815M167.538 86.8762L169.273 89.2316M163.338 87.8507L162.952 90.8607M159.899 85.5391L157.461 87.335M158.566 81.3733L155.577 80.85"
        stroke="#447CCF"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle
        cx="148.113"
        cy="99.3335"
        r="2.45472"
        transform="rotate(-178.42 148.113 99.3335)"
        fill="#2368D3"
      />
      <circle
        cx="121.147"
        cy="91.5443"
        r="4.20809"
        transform="rotate(-36.3811 121.147 91.5443)"
        fill="#5C99F6"
      />
      <circle
        cx="161.438"
        cy="53.2318"
        r="2.78556"
        transform="rotate(-36.3811 161.438 53.2318)"
        fill="#5C99F6"
      />
      <g filter="url(#filter0_f_3238_244120)">
        <path
          d="M28.5944 126.531H33.8406H39.8363L121.527 111.542L120.029 100.3C93.048 100.3 37.438 101.05 30.8428 104.048C24.2476 107.045 26.8456 119.536 28.5944 126.531Z"
          fill="#2C70D9"
          fillOpacity="0.3"
        />
      </g>
      <path
        d="M34.1613 107.051C35.8643 105.646 38.8972 104.797 41.3057 104.797H83.296H125.286C127.695 104.797 131.023 105.586 132.727 106.991C134.43 108.395 135.345 111.019 135.345 113.005L135.767 147.43C135.767 149.417 134.81 152.162 133.107 153.567C131.404 154.971 128.117 155.76 125.709 155.76H98.2942L84.7484 168.621C83.9466 169.382 82.6792 169.349 81.919 168.546L69.8147 155.76H43.4518C41.0433 155.76 36.2887 154.487 34.5857 153.083C31.6964 150.7 31.2257 148.003 31.2257 146.017L30.8428 113.491C30.8428 111.505 32.4583 108.455 34.1613 107.051Z"
        fill="url(#paint7_linear_3238_244120)"
      />
      <path
        d="M57.2645 126.082C56.9871 126.082 56.8484 126.082 56.7367 126.021C56.6956 125.999 56.6577 125.971 56.6244 125.938C56.5339 125.849 56.4936 125.716 56.413 125.45L54.1782 118.093C53.8768 117.101 53.7261 116.605 53.4651 116.529C53.3746 116.503 53.2786 116.503 53.1881 116.529C52.9271 116.605 52.7764 117.101 52.475 118.093L50.2402 125.45C50.1596 125.716 50.1193 125.849 50.0288 125.938C49.9954 125.971 49.9576 125.999 49.9164 126.021C49.8048 126.082 49.6661 126.082 49.3886 126.082H42.6157C41.6252 126.082 41.13 126.082 40.9815 126.305C40.93 126.382 40.9011 126.473 40.898 126.566C40.8893 126.833 41.2925 127.121 42.0987 127.696L47.6499 131.658C47.8704 131.815 47.9806 131.893 48.0362 132.005C48.0567 132.046 48.0715 132.09 48.08 132.135C48.1033 132.257 48.0632 132.386 47.9831 132.645L45.824 139.619C45.5314 140.564 45.3851 141.036 45.554 141.244C45.6128 141.316 45.6904 141.37 45.7784 141.401C46.0313 141.488 46.4252 141.189 47.2128 140.59L52.7884 136.352C53.0144 136.181 53.1273 136.095 53.2554 136.076C53.3027 136.069 53.3506 136.069 53.3978 136.076C53.526 136.094 53.639 136.18 53.865 136.352L59.4555 140.594C60.2427 141.192 60.6363 141.491 60.8892 141.403C60.977 141.372 61.0547 141.318 61.1133 141.246C61.2822 141.038 61.136 140.566 60.8438 139.622L58.6834 132.645C58.6033 132.386 58.5633 132.257 58.5865 132.135C58.5951 132.09 58.6098 132.046 58.6303 132.005C58.6858 131.893 58.7959 131.815 59.016 131.657L64.5586 127.696C65.3636 127.121 65.766 126.833 65.7572 126.565C65.7541 126.472 65.7252 126.382 65.6736 126.305C65.5252 126.082 65.0305 126.082 64.0411 126.082H57.2645Z"
        fill="url(#paint8_linear_3238_244120)"
      />
      <path
        d="M87.2429 126.082C86.9655 126.082 86.8268 126.082 86.7151 126.021C86.674 125.999 86.6361 125.971 86.6028 125.938C86.5123 125.849 86.472 125.716 86.3913 125.45L84.1566 118.093C83.8552 117.101 83.7045 116.605 83.4435 116.529C83.353 116.503 83.257 116.503 83.1665 116.529C82.9055 116.605 82.7548 117.101 82.4534 118.093L80.2186 125.45C80.138 125.716 80.0977 125.849 80.0072 125.938C79.9738 125.971 79.936 125.999 79.8948 126.021C79.7832 126.082 79.6445 126.082 79.367 126.082H72.5941C71.6036 126.082 71.1083 126.082 70.9599 126.305C70.9084 126.382 70.8795 126.473 70.8764 126.566C70.8677 126.833 71.2709 127.121 72.0771 127.696L77.6283 131.658C77.8488 131.815 77.959 131.893 78.0146 132.005C78.0351 132.046 78.0499 132.09 78.0584 132.135C78.0817 132.257 78.0416 132.386 77.9615 132.645L75.8024 139.619C75.5098 140.564 75.3635 141.036 75.5324 141.244C75.5911 141.316 75.6688 141.37 75.7567 141.401C76.0097 141.488 76.4035 141.189 77.1912 140.59L82.7668 136.352C82.9927 136.181 83.1057 136.095 83.2338 136.076C83.281 136.069 83.329 136.069 83.3762 136.076C83.5044 136.094 83.6174 136.18 83.8434 136.352L89.4339 140.594C90.2211 141.192 90.6147 141.491 90.8675 141.403C90.9554 141.372 91.0331 141.318 91.0917 141.246C91.2605 141.038 91.1144 140.566 90.8221 139.622L88.6618 132.645C88.5817 132.386 88.5417 132.257 88.5649 132.135C88.5735 132.09 88.5882 132.046 88.6087 132.005C88.6642 131.893 88.7743 131.815 88.9944 131.657L94.537 127.696C95.3419 127.121 95.7444 126.833 95.7356 126.565C95.7325 126.472 95.7036 126.382 95.652 126.305C95.5036 126.082 95.0089 126.082 94.0195 126.082H87.2429Z"
        fill="url(#paint9_linear_3238_244120)"
      />
      <path
        d="M117.221 126.082C116.944 126.082 116.805 126.082 116.694 126.021C116.652 125.999 116.615 125.971 116.581 125.938C116.491 125.849 116.45 125.716 116.37 125.45L114.135 118.093C113.834 117.101 113.683 116.605 113.422 116.529C113.331 116.503 113.235 116.503 113.145 116.529C112.884 116.605 112.733 117.101 112.432 118.093L110.197 125.45C110.116 125.716 110.076 125.849 109.986 125.938C109.952 125.971 109.914 125.999 109.873 126.021C109.762 126.082 109.623 126.082 109.345 126.082H102.573C101.582 126.082 101.087 126.082 100.938 126.305C100.887 126.382 100.858 126.473 100.855 126.566C100.846 126.833 101.249 127.121 102.056 127.696L107.607 131.658C107.827 131.815 107.937 131.893 107.993 132.005C108.013 132.046 108.028 132.09 108.037 132.135C108.06 132.257 108.02 132.386 107.94 132.645L105.781 139.619C105.488 140.564 105.342 141.036 105.511 141.244C105.57 141.316 105.647 141.37 105.735 141.401C105.988 141.488 106.382 141.189 107.17 140.59L112.745 136.352C112.971 136.181 113.084 136.095 113.212 136.076C113.259 136.069 113.307 136.069 113.355 136.076C113.483 136.094 113.596 136.18 113.822 136.352L119.412 140.594C120.199 141.192 120.593 141.491 120.846 141.403C120.934 141.372 121.011 141.318 121.07 141.246C121.239 141.038 121.093 140.566 120.801 139.622L118.64 132.645C118.56 132.386 118.52 132.257 118.543 132.135C118.552 132.09 118.567 132.046 118.587 132.005C118.643 131.893 118.753 131.815 118.973 131.657L124.515 127.696C125.32 127.121 125.723 126.833 125.714 126.565C125.711 126.472 125.682 126.382 125.63 126.305C125.482 126.082 124.987 126.082 123.998 126.082H117.221Z"
        fill="url(#paint10_linear_3238_244120)"
      />
      <defs>
        <filter
          id="filter0_f_3238_244120"
          x="18.5883"
          y="92.3003"
          width="110.939"
          height="42.2311"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="4"
            result="effect1_foregroundBlur_3238_244120"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3238_244120"
          x1="9.85789"
          y1="119.786"
          x2="17.3525"
          y2="139.272"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EBF3FF" />
          <stop offset="1" stopColor="#AECFFF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3238_244120"
          x1="7.60951"
          y1="92.0562"
          x2="24.8471"
          y2="138.523"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C7DDFF" />
          <stop offset="1" stopColor="#97C0FC" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3238_244120"
          x1="53.0983"
          y1="83.6225"
          x2="53.0277"
          y2="104.195"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C7DDFF" />
          <stop offset="1" stopColor="#7FB2FA" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3238_244120"
          x1="52.0825"
          y1="83.9817"
          x2="55.378"
          y2="121.497"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7EB1FB" />
          <stop offset="0.830826" stopColor="#0B5DDA" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3238_244120"
          x1="82.9439"
          y1="59.1854"
          x2="80.3462"
          y2="100.797"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C7DDFF" />
          <stop offset="1" stopColor="#7AB1FF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_3238_244120"
          x1="84.0706"
          y1="103.513"
          x2="75.9907"
          y2="53.6313"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.145029" stopColor="#0E5DD8" />
          <stop offset="1" stopColor="#79ABF6" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_3238_244120"
          x1="107.463"
          y1="35.773"
          x2="73.1652"
          y2="114.027"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4E8FF4" />
          <stop offset="1" stopColor="#104394" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_3238_244120"
          x1="83.305"
          y1="184.585"
          x2="44.3273"
          y2="64.3066"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6CA4F5" />
          <stop offset="0.9999" stopColor="#BCD5FA" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_3238_244120"
          x1="53.3266"
          y1="115.29"
          x2="53.3266"
          y2="142.27"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.66" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_3238_244120"
          x1="83.305"
          y1="115.29"
          x2="83.305"
          y2="142.27"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.66" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_3238_244120"
          x1="113.283"
          y1="115.29"
          x2="113.283"
          y2="142.27"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.66" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const AccountsIcon = (props: any) => (
  <Icon
    {...props}
    width="38"
    height="38"
    viewBox="0 0 38 38"
    d={[
      "M26 19H28.5V25.3333H26V19Z",
      "M31.667 11.0833V7.91667C31.667 6.17025 30.2467 4.75 28.5003 4.75H7.91696C5.29812 4.75 3.50045 6.88117 3.50045 9.5L3.48291 24.5H5.98291L22.8389 30.7661V33.25H31.667C33.4134 33.25 34.8336 31.8298 34.8336 30.0833V14.25C34.8336 12.5036 33.4134 11.0833 31.667 11.0833ZM7.6106 7.42871H29.0005L29.0005 11.0833H7.6106C7.20293 11.0651 6.818 10.8903 6.53596 10.5954C6.25392 10.3004 6.02727 9.59023 6.02727 9.18215C6.02727 8.77406 6.25392 8.2116 6.53596 7.91667C6.818 7.62173 7.20293 7.44695 7.6106 7.42871ZM32.157 30.7661H22.8389L5.98291 24.5H6.00023L6.02727 13.5C6.50045 14 7.03269 14 7.59161 14H32.157V30.7661Z",
      "M9.59397 34.5068C9.59346 34.4582 9.57455 34.4118 9.54134 34.3776C9.50814 34.3435 9.46334 34.3244 9.41666 34.3244L5.79196 34.3472C4.11374 34.3577 2.60064 32.9856 2.591 31.0553C2.5798 29.1233 4.07533 27.7339 5.75355 27.7234L9.37825 27.7006C9.47495 27.7 9.55402 27.6167 9.55343 27.516L9.54594 26.2237C9.54543 26.1752 9.52651 26.1288 9.49331 26.0946C9.46011 26.0605 9.41531 26.0413 9.36863 26.0414L5.74393 26.0642C3.10494 26.0808 0.982628 28.3167 1.00011 31.062C1.01759 33.8073 3.16413 36.0181 5.80154 35.9999L9.42625 35.9771C9.52295 35.9765 9.60201 35.8932 9.60143 35.7926L9.59397 34.5068ZM20.9999 30.938C20.984 28.191 18.8359 25.9819 16.1985 26.0001L12.5722 26.0213C12.5255 26.0218 12.481 26.0415 12.4482 26.076C12.4154 26.1106 12.397 26.1572 12.397 26.2058L12.4045 27.4949C12.4051 27.5955 12.4851 27.6778 12.5818 27.6772L16.2065 27.6544C17.8847 27.6439 19.3979 29.016 19.4075 30.9464C19.4187 32.8783 17.9232 34.2677 16.2449 34.2783L12.6202 34.301C12.5736 34.3016 12.529 34.3213 12.4962 34.3558C12.4634 34.3904 12.445 34.437 12.4451 34.4856L12.4525 35.7779C12.4531 35.8785 12.5332 35.9608 12.6299 35.9602L16.2546 35.9375C18.892 35.9193 21.0143 33.6833 20.9999 30.938ZM14.7043 30.3021C14.7037 30.2536 14.6848 30.2072 14.6516 30.173C14.6184 30.1389 14.5736 30.1197 14.5269 30.1198L7.46313 30.1626C7.41646 30.1631 7.37188 30.1828 7.33907 30.2173C7.30627 30.2519 7.2879 30.2985 7.28795 30.3471L7.29541 31.6329C7.29599 31.7336 7.37602 31.8159 7.47272 31.8153L14.535 31.7709C14.6317 31.7703 14.7107 31.687 14.7101 31.5863L14.7043 30.3021Z",
    ]}
  />
);

export const GroupsIcon = (props: any) => (
  <Icon
    {...props}
    width="43"
    height="43"
    viewBox="0 0 43 43"
    d={[
      "M31.7617 20.9888C31.795 20.6615 31.8135 20.3304 31.8135 19.9956C31.8135 19.3975 31.7579 18.8144 31.6542 18.2463C31.6283 18.1109 31.6987 17.9717 31.8209 17.9152C32.3247 17.6857 32.7877 17.3697 33.1878 16.971C33.6592 16.5068 34.0301 15.9478 34.2769 15.3299C34.5238 14.712 34.641 14.0485 34.6213 13.382C34.588 12.1744 34.1101 11.027 33.2767 10.1617C32.3617 9.20989 31.1319 8.69073 29.8244 8.70578C28.6427 8.71707 27.5018 9.1798 26.6388 9.99992C26.3461 10.2783 26.0942 10.5868 25.8831 10.9179C25.809 11.0345 25.6646 11.0834 25.5386 11.0382C24.8867 10.8088 24.1977 10.647 23.4902 10.5717C23.2828 10.5492 23.1642 10.3235 23.2568 10.1354C24.4607 7.71637 26.9203 6.04603 29.7651 6.00088C33.8693 5.93693 37.292 9.35661 37.292 13.5249C37.292 15.8875 36.2215 17.9942 34.5435 19.3749C35.7214 19.9279 36.8068 20.6916 37.7476 21.6472C39.7775 23.705 40.9258 26.4212 40.9999 29.3217C41.0009 29.3619 40.994 29.4018 40.9795 29.4392C40.9651 29.4766 40.9434 29.5106 40.9158 29.5394C40.8882 29.5681 40.8552 29.591 40.8187 29.6066C40.7823 29.6222 40.7431 29.6302 40.7036 29.6302H38.6255C38.4662 29.6302 38.3329 29.5023 38.3292 29.3405C38.2588 27.1585 37.3883 25.1157 35.8585 23.5658C34.7695 22.4598 33.4359 21.6923 31.9802 21.3199C31.8394 21.2785 31.7431 21.1393 31.7617 20.9888Z",
      "M12.1865 19.9956C12.1865 20.3304 12.205 20.6615 12.2383 20.9888C12.2569 21.1393 12.1606 21.2785 12.0198 21.3199C10.5641 21.6923 9.23054 22.4598 8.14151 23.5658C6.61168 25.1157 5.74119 27.1585 5.67081 29.3405C5.66711 29.5023 5.53376 29.6302 5.37448 29.6302H3.29643C3.25688 29.6302 3.21773 29.6222 3.18129 29.6066C3.14484 29.591 3.11184 29.5681 3.08422 29.5394C3.05661 29.5106 3.03494 29.4766 3.02049 29.4392C3.00604 29.4018 2.9991 29.3619 3.00009 29.3217C3.07418 26.4212 4.22248 23.705 6.25237 21.6472C7.19324 20.6916 8.27856 19.9279 9.4565 19.3749C7.7785 17.9942 6.70799 15.8875 6.70799 13.5249C6.70799 9.35661 10.1307 5.93693 14.2349 6.00088C17.0797 6.04603 19.5393 7.71637 20.7432 10.1354C20.8358 10.3235 20.7172 10.5492 20.5098 10.5717C19.8023 10.647 19.1133 10.8088 18.4614 11.0382C18.3354 11.0834 18.191 11.0345 18.1169 10.9179C17.9058 10.5868 17.6539 10.2783 17.3612 9.99992C16.4982 9.1798 15.3573 8.71707 14.1756 8.70578C12.8681 8.69073 11.6383 9.20989 10.7233 10.1617C9.88989 11.027 9.41205 12.1744 9.37871 13.382C9.35896 14.0485 9.47625 14.712 9.72307 15.3299C9.96989 15.9478 10.3408 16.5068 10.8122 16.971C11.2123 17.3697 11.6753 17.6857 12.1791 17.9152C12.3013 17.9717 12.3717 18.1109 12.3458 18.2463C12.242 18.8144 12.1865 19.3975 12.1865 19.9956Z",
      "M28.9257 19.9956C28.9257 15.88 25.6697 12.5355 21.6322 12.4716C20.3558 12.4517 19.1457 12.7687 18.0841 13.3404C15.7051 14.593 14.079 17.1164 14.079 20.0249C14.079 22.3824 15.1463 24.4858 16.8163 25.8651C15.6424 26.4237 14.5732 27.186 13.657 28.1178C11.6272 30.1757 10.4789 32.8919 10.4048 35.7886C10.4038 35.8288 10.4107 35.8687 10.4252 35.9061C10.4396 35.9435 10.4613 35.9776 10.4889 36.0063C10.5165 36.0351 10.5495 36.0579 10.586 36.0735C10.6224 36.0891 10.6616 36.0971 10.7011 36.0971H12.7755C12.9347 36.0971 13.0681 35.9692 13.0718 35.8074C13.1422 33.6255 14.0127 31.5827 15.5425 30.0327C17.0211 28.531 18.9477 27.6554 21.0192 27.5342C21.174 27.544 21.3301 27.549 21.4873 27.549C23.7469 27.549 25.8657 28.4406 27.4622 30.062C28.992 31.612 29.8625 33.6548 29.9329 35.8367C29.9366 35.9985 30.0699 36.1264 30.2292 36.1264H32.3036C32.3431 36.1264 32.3823 36.1184 32.4187 36.1028C32.4552 36.0872 32.4882 36.0644 32.5158 36.0356C32.5434 36.0069 32.5651 35.9728 32.5795 35.9354C32.594 35.898 32.6009 35.8581 32.5999 35.8179C32.5258 32.9212 31.3775 30.205 29.3476 28.1472C28.4207 27.2044 27.3373 26.4352 26.1472 25.8749C26.3085 25.7419 26.4643 25.6021 26.614 25.456C28.0376 24.0851 28.9257 22.1461 28.9257 19.9956ZM24.7864 23.4829C23.9002 24.3409 22.7453 24.811 21.5173 24.811C20.2505 24.811 19.0615 24.3107 18.1651 23.4003C17.7177 22.9483 17.3643 22.4098 17.1257 21.8166C16.8871 21.2233 16.7682 20.5875 16.776 19.9467C16.7871 18.7128 17.2723 17.5202 18.1206 16.6361C18.205 16.5482 18.2922 16.464 18.3819 16.3836C19.2529 15.6199 20.3785 15.1991 21.5355 15.2095C22.806 15.2246 23.9951 15.74 24.8841 16.6654C25.7323 17.5495 26.2176 18.7421 26.2287 19.976C26.2365 20.6168 26.1176 21.2526 25.879 21.8459C25.6404 22.4391 25.287 22.9776 24.8396 23.4296C24.822 23.4475 24.8042 23.4653 24.7864 23.4829Z",
    ]}
  />
);

export const DomainIcon = (props: any) => {
  const theme = useTheme();
  return (
    <Icon {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.0914 19.5612C1.48805 19.4419 1.90635 19.6666 2.0257 20.0633C2.29256 20.9501 2.64407 21.8011 3.07113 22.6071H8.30059C8.19493 22.1696 8.09961 21.7219 8.0151 21.2652C7.99723 21.1687 7.97984 21.0717 7.96294 20.9744C7.89208 20.5663 8.16548 20.178 8.57359 20.1071C8.9817 20.0363 9.36998 20.3097 9.44083 20.7178C9.45679 20.8097 9.4732 20.9012 9.49005 20.9923C9.59305 21.5488 9.7124 22.0878 9.84667 22.6071H15.2545L15.249 20.8932C15.2476 20.479 15.5823 20.1421 15.9965 20.1408C16.4107 20.1395 16.7476 20.4742 16.7489 20.8884L16.7545 22.6071H22.1536C22.2872 22.088 22.406 21.5492 22.5084 20.9929C22.5252 20.9018 22.5415 20.8103 22.5574 20.7184C22.628 20.3102 23.016 20.0365 23.4242 20.107C23.8323 20.1776 24.1061 20.5656 24.0355 20.9738C24.0187 21.0711 24.0014 21.1681 23.9836 21.2646C23.8995 21.7215 23.8045 22.1694 23.6993 22.6071H28.9342C29.359 21.8014 29.7087 20.9508 29.9742 20.0642C30.0931 19.6674 30.5111 19.4421 30.9079 19.5609C31.3047 19.6798 31.53 20.0978 31.4112 20.4946C31.073 21.6238 30.6115 22.6999 30.0422 23.7077L30.0368 23.7178C30.0318 23.7269 30.0266 23.7359 30.0213 23.7447C27.2742 28.5773 22.0432 31.8311 16.0317 31.8311H16.0149L15.9952 31.8311C8.70776 31.8152 2.56241 27.0525 0.589324 20.4955C0.469969 20.0989 0.694756 19.6806 1.0914 19.5612ZM3.98845 24.1071H8.71572C9.27855 25.8992 10.0269 27.4711 10.923 28.721C11.1723 29.0687 11.4357 29.3948 11.7122 29.6953C8.5364 28.7331 5.82773 26.7369 3.98845 24.1071ZM28.0214 24.1071C26.1825 26.7491 23.4703 28.7511 20.2903 29.7081C20.5704 29.4037 20.837 29.0729 21.0891 28.7197C21.981 27.4701 22.7259 25.8986 23.286 24.1071H28.0214ZM19.8682 27.8483C20.5817 26.8487 21.2091 25.5813 21.7086 24.1071H16.7593L16.779 30.2401C17.8522 29.9841 18.9122 29.1877 19.8682 27.8483ZM12.1421 27.847C13.1118 29.1997 14.1886 29.9996 15.279 30.2476L15.2593 24.1071H10.2938C10.7956 25.5807 11.4256 26.8477 12.1421 27.847Z"
        fill={theme.colors.primaryGrey}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9939 0.168988C10.0412 0.182361 4.84775 3.34937 2.07115 8.07197L2.06132 8.08872C1.15829 9.62901 0.512169 11.3343 0.180329 13.1493C0.147514 13.3288 0.181527 13.505 0.264684 13.6524C0.274298 13.6985 1.67533 13.1729 1.69417 13.218C1.97589 11.7951 2.47275 10.4477 3.1506 9.20949H8.33613C8.19344 9.78246 8.06871 10.3735 7.96303 10.9797C7.89189 11.3877 8.16501 11.7762 8.57307 11.8473C8.98113 11.9185 9.3696 11.6453 9.44074 11.2373C9.56354 10.5329 9.71263 9.85557 9.88515 9.20949H15.2817V11.1085C15.2817 11.5227 15.6175 11.8585 16.0317 11.8585C16.4459 11.8585 16.7817 11.5227 16.7817 11.1085V9.20949H22.1153C22.287 9.85539 22.4353 10.5325 22.5575 11.2367C22.6283 11.6448 23.0166 11.9182 23.4247 11.8474C23.8328 11.7766 24.1063 11.3884 24.0354 10.9802C23.9302 10.3738 23.806 9.78264 23.6639 9.20949H28.8552C29.5296 10.4475 30.024 11.7948 30.3043 13.2177L30.3028 13.2215L31.6955 13.7786C31.7122 13.737 31.7248 13.6948 31.7337 13.6525C31.8167 13.5052 31.8508 13.3292 31.8181 13.1499C31.489 11.3412 30.8491 9.6411 29.9547 8.10468C29.9463 8.08912 29.9374 8.0739 29.928 8.05902C27.1563 3.33444 21.9739 0.168945 16.0317 0.168945H16.0149L15.9939 0.168988ZM4.09814 7.70949C5.93295 5.16994 8.5943 3.24312 11.7051 2.30366C11.4074 2.62645 11.1249 2.97889 10.8588 3.35607C10.0166 4.54976 9.3074 6.02948 8.76389 7.70949H4.09814ZM15.2817 7.70949H10.3468C10.8258 6.34725 11.4164 5.16757 12.0844 4.22085C13.0685 2.8261 14.1677 2.0024 15.2817 1.75142V7.70949ZM16.7817 7.70949V1.76008C17.8766 2.02072 18.9568 2.84045 19.9256 4.21958C20.5908 5.16656 21.179 6.34668 21.6559 7.70949H16.7817ZM27.9122 7.70949H23.2381C22.6972 6.03005 21.9914 4.55077 21.153 3.35734C20.8842 2.97474 20.5986 2.61752 20.2974 2.29085C23.4126 3.22543 26.0777 5.15801 27.9122 7.70949Z"
        fill={theme.colors.primaryGrey}
      />
      <path
        d="M20.786 13.7787C20.9398 13.3942 20.7528 12.9577 20.3682 12.8038C19.9836 12.65 19.5471 12.8371 19.3933 13.2217L18.0742 16.5193L16.6907 13.2108C16.5732 12.9299 16.2974 12.7479 15.9929 12.7502C15.6883 12.7526 15.4155 12.9389 15.3024 13.2217L13.9833 16.5193L12.5998 13.2108C12.4399 12.8287 12.0006 12.6485 11.6185 12.8083C11.2363 12.9681 11.0561 13.4074 11.2159 13.7896L13.3068 18.7896C13.4243 19.0705 13.7 19.2525 14.0046 19.2502C14.3091 19.2478 14.582 19.0615 14.6951 18.7787L16.0142 15.4811L17.3977 18.7896C17.5152 19.0705 17.7909 19.2525 18.0955 19.2502C18.4 19.2478 18.6729 19.0615 18.786 18.7787L20.786 13.7787Z"
        fill={theme.colors.primaryBlue}
      />
      <path
        d="M1.69372 13.2181L3.07421 16.5193L4.39328 13.2217C4.50639 12.9389 4.77926 12.7526 5.0838 12.7502C5.38834 12.7479 5.66408 12.9299 5.78157 13.2108L7.16512 16.5193L8.48419 13.2217C8.63802 12.8371 9.0745 12.65 9.45909 12.8038C9.84368 12.9577 10.0307 13.3942 9.8769 13.7787L7.8769 18.7787C7.7638 19.0615 7.49093 19.2478 7.18639 19.2502C6.88185 19.2525 6.60611 19.0705 6.48861 18.7896L5.10506 15.4811L3.786 18.7787C3.67289 19.0615 3.40002 19.2478 3.09548 19.2502C2.79094 19.2525 2.5152 19.0705 2.3977 18.7896L0.306795 13.7896C0.287959 13.7445 0.273847 13.6987 0.264233 13.6526C0.163059 13.1614 0.998612 12.5002 1.69372 13.2181Z"
        fill={theme.colors.primaryBlue}
      />
      <path
        d="M31.7332 13.6526C31.7244 13.695 31.7117 13.7372 31.6951 13.7787L29.6951 18.7787C29.582 19.0615 29.3091 19.2478 29.0046 19.2502C28.7 19.2525 28.4243 19.0705 28.3068 18.7896L26.9232 15.4811L25.6042 18.7787C25.4911 19.0615 25.2182 19.2478 24.9137 19.2502C24.6091 19.2525 24.3334 19.0705 24.2159 18.7896L22.125 13.7896C21.9652 13.4074 22.1454 12.9681 22.5276 12.8083C22.9097 12.6485 23.349 12.8287 23.5088 13.2108L24.8924 16.5193L26.2115 13.2217C26.3246 12.9389 26.5974 12.7526 26.902 12.7502C27.2065 12.7479 27.4823 12.9299 27.5998 13.2108L28.9833 16.5193L30.3024 13.2217L30.3039 13.2179C30.5 12.5002 31.8481 12.7502 31.7332 13.6526Z"
        fill={theme.colors.primaryBlue}
      />
    </Icon>
  );
};

export const SecurityIcon = (props: any) => {
  const theme = useTheme();
  return (
    <Icon {...props} viewBox="0 0 20 26">
      <path
        d="M9.58681 14.769V14.0142C9.47932 13.9298 9.3991 13.8103 9.35768 13.6728C9.31626 13.5354 9.31578 13.3871 9.35631 13.2494C9.39685 13.1116 9.4763 12.9915 9.58324 12.9062C9.69017 12.821 9.81907 12.7751 9.95139 12.7751C10.0837 12.7751 10.2126 12.821 10.3195 12.9062C10.4265 12.9915 10.5059 13.1116 10.5465 13.2494C10.587 13.3871 10.5865 13.5354 10.5451 13.6728C10.5037 13.8103 10.4235 13.9298 10.316 14.0142V14.769C10.316 14.8317 10.2691 14.8829 10.2118 14.8829H9.69097C9.63368 14.8829 9.58681 14.8317 9.58681 14.769Z"
        fill={theme.colors.primaryGrey}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2812 10.1831H14.1667C14.3971 10.1831 14.5833 10.3868 14.5833 10.6389V17.2182C14.5833 17.4703 14.3971 17.674 14.1667 17.674H5.83333C5.60286 17.674 5.41667 17.4703 5.41667 17.2182V10.6389C5.41667 10.3868 5.60286 10.1831 5.83333 10.1831H6.71875V8.10373C6.71875 7.09686 7.46484 6.28083 8.38542 6.28083H11.6146C12.5352 6.28083 13.2812 7.09686 13.2812 8.10373V10.1831ZM8.38542 7.37104C7.98307 7.37104 7.72937 7.66367 7.72937 8.10373V10.1831H12.2743V8.10373C12.2743 7.66367 12.0169 7.37104 11.6146 7.37104H8.38542ZM6.44123 16.5672H13.5414V11.3701H6.44123V16.5672Z"
        fill={theme.colors.primaryBlue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 26C15.7333 24.5277 20 18.1706 20 11.6853V4.67411L10 0L0 4.67411V11.6853C0 18.1706 4.26667 24.5277 10 26ZM18.3333 11.6853C18.3333 17.6742 15 22.4944 10 24.2472C5 22.4944 1.66667 17.2361 1.66667 11.6853V5.73832L10 1.89914L18.3333 5.84292V11.6853Z"
        fill={theme.colors.primaryGrey}
      />
    </Icon>
  );
};

export const TwoFAIcon = (props: any) => {
  const theme = useTheme();
  return (
    <Icon {...props} viewBox="0 0 21 25">
      <path
        d="M1.87544 0H15.4724C16.5068 0 17.3478 0.800781 17.3478 1.78571V4.46429H15.238V2.00893H2.10987V22.9911H15.238V20.5357H17.3478V23.2143C17.3478 24.1992 16.5068 25 15.4724 25H1.87544C0.841018 25 0 24.1992 0 23.2143V1.78571C0 0.800781 0.841018 0 1.87544 0Z"
        fill={theme.colors.primaryGrey}
      />
      <path
        d="M7.84508 20.9343C7.62526 20.725 7.50176 20.4411 7.50176 20.1451C7.50176 19.8491 7.62526 19.5652 7.84508 19.3559C8.0649 19.1466 8.36304 19.029 8.67391 19.029C8.98479 19.029 9.28293 19.1466 9.50275 19.3559C9.72257 19.5652 9.84606 19.8491 9.84606 20.1451C9.84606 20.4411 9.72257 20.725 9.50275 20.9343C9.28293 21.1436 8.98479 21.2612 8.67391 21.2612C8.36304 21.2612 8.0649 21.1436 7.84508 20.9343Z"
        fill={theme.colors.primaryGrey}
      />
      <path
        d="M18.2609 11.0804L17.2017 9.82143L13.9239 13.0268L12.4722 11.6071L11.413 12.6429L13.9239 15.3214L18.2609 11.0804Z"
        fill={theme.colors.primaryBlue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3834 19.4278C15.1304 19.5121 14.872 19.5841 14.6087 19.6429C10.9443 18.8247 8.21739 15.4545 8.21739 11.8506V7.95455L14.6087 5.35714L21 7.95455V11.8506C21 15.1956 18.6508 18.3392 15.3834 19.4278ZM15.5991 17.7847C17.8191 16.7958 19.5797 14.4436 19.5797 11.9935V8.7987L14.6087 6.77273L9.63768 8.7987V11.9935C9.63768 14.7987 11.9457 17.4756 14.6087 18.125C14.9458 18.0428 15.2773 17.9281 15.5991 17.7847Z"
        fill={theme.colors.primaryGrey}
      />
    </Icon>
  );
};

export const InfoIcon = ({ mainColor, secondaryColor, ...props }: any) => (
  <Icon {...props} width="125" height="127" viewBox="0 0 125 127">
    <path
      d="M80.0611 26.7246C80.7665 26.8373 81.4438 26.95 82.1492 27.0345C85.0275 27.3726 86.9182 29.4572 86.9746 32.3589C86.9746 32.7533 86.9746 33.1759 86.9746 33.7111C87.5954 33.7111 88.1598 33.7111 88.7241 33.7111C89.994 33.7111 91.292 33.683 92.5619 33.7393C95.158 33.852 97.3872 35.993 97.4154 38.5848C97.4719 45.6558 97.4436 52.755 97.4436 59.8261C97.4436 60.8966 96.71 61.6009 95.6941 61.5727C94.65 61.5727 93.9728 60.8121 93.9728 59.6007C93.9728 52.9522 93.9728 46.3038 93.9728 39.6835C93.9728 37.7115 93.4649 37.2044 91.5178 37.2044C90.0504 37.2044 88.5831 37.2044 86.9746 37.2044C86.9746 37.5706 86.9746 37.8805 86.9746 38.1904C86.9746 43.9937 86.9746 49.797 86.9746 55.6004C86.9746 55.9102 86.9746 56.192 86.9464 56.5018C86.8617 57.4597 86.128 58.1358 85.2251 58.1358C84.3221 58.1358 83.5884 57.4315 83.5037 56.5018C83.4755 56.2201 83.5037 55.9666 83.5037 55.6849C83.5037 47.9941 83.5037 40.3314 83.5037 32.6406C83.5037 31.2602 82.9394 30.6968 81.5849 30.4996C74.4174 29.5136 68.1529 31.5983 62.3963 35.7958C61.1829 36.6691 60.7314 37.5706 60.7597 39.0919C60.8443 48.1349 60.7879 57.178 60.7879 66.221C60.7879 67.7986 60.2235 68.5874 59.0948 68.6156C57.9378 68.6437 57.317 67.7986 57.317 66.1928C57.317 56.7554 57.317 47.2898 57.2888 37.8523C57.2888 37.4861 57.1195 36.979 56.8373 36.7537C52.8021 33.4294 48.3153 31.0348 43.0385 30.4996C40.781 30.2742 38.4671 30.4714 36.1814 30.5559C35.1655 30.6123 34.6012 31.4011 34.5729 32.4998C34.5447 33.852 34.5729 35.2324 34.5729 36.5846C34.5729 48.5857 34.5729 60.5867 34.5729 72.6159C34.5729 74.5034 35.2784 75.095 37.1408 74.926C42.333 74.4189 47.2995 75.2922 51.9837 77.5741C53.1125 78.1094 53.5075 79.0672 53.0278 80.025C52.5763 80.9265 51.5887 81.2364 50.5164 80.7011C46.9044 78.9827 43.0949 78.1657 39.1161 78.2784C38.326 78.3066 37.5359 78.3911 36.7458 78.4192C33.4724 78.5601 31.1021 76.3064 31.1021 73.0385C31.1021 61.46 31.1021 49.8816 31.1021 38.3313C31.1021 37.9932 31.1021 37.6833 31.1021 37.2889C29.2114 37.2889 27.3772 37.2326 25.543 37.3171C24.8376 37.3453 24.3296 37.9087 24.1885 38.6693C24.1321 38.9792 24.1321 39.3173 24.1321 39.6553C24.1321 53.1776 24.1321 66.7281 24.1321 80.2504C24.1321 80.3631 24.1321 80.4758 24.1321 80.5884C24.1603 81.9407 24.8093 82.5886 26.1638 82.5886C29.7476 82.5886 33.3031 82.5886 36.8868 82.5886C41.1761 82.5886 45.4653 82.5886 49.7262 82.5886C50.0649 82.5886 50.3753 82.5886 50.7139 82.6731C51.5604 82.8703 52.0966 83.5465 52.0684 84.3634C52.0684 85.1522 51.5322 85.8283 50.7421 85.9974C50.4317 86.0819 50.0931 86.0819 49.7827 86.0819C41.9944 86.0819 34.1779 86.0819 26.3896 86.0819C22.8623 86.0819 20.6895 83.9127 20.6895 80.3631C20.6895 66.7281 20.6895 53.0931 20.6895 39.4299C20.6895 35.9649 22.8623 33.7956 26.3614 33.7675C27.9416 33.7675 29.5218 33.7675 31.1585 33.7675C31.1585 33.204 31.1585 32.7533 31.1585 32.3026C31.2149 29.5981 33.162 27.4289 35.871 27.0908C36.6047 27.0063 37.3101 26.8936 38.0438 26.781C39.3419 26.781 40.6681 26.781 41.9662 26.781C42.4741 26.8655 42.982 26.95 43.49 27.0063C48.9361 27.7388 53.7615 29.9362 58.1071 33.2322C59.0948 33.9928 59.123 33.9928 60.1389 33.2322C63.9201 30.3587 68.0682 28.3022 72.7525 27.3444C73.8812 27.119 75.0382 26.9782 76.1952 26.781C77.4368 26.7246 78.7348 26.7246 80.0611 26.7246Z"
      fill={`${mainColor}`}
    />
    <path
      d="M104.443 89.632C104.189 90.8997 104.019 92.1956 103.681 93.4633C100.887 103.887 91.4904 110.789 80.6828 110.366C69.8187 109.944 60.4784 101.351 59.2368 90.5898C57.8541 78.6451 65.473 67.9963 77.2401 65.5172C89.6563 62.8973 102.185 71.5178 104.132 84.0259C104.217 84.6457 104.33 85.2654 104.443 85.857C104.443 87.1248 104.443 88.3925 104.443 89.632ZM100.944 87.2938C100.549 76.3914 91.7162 68.1654 80.8239 68.5598C70.383 68.9542 62.1433 77.969 62.5665 88.646C62.9616 98.8722 71.9915 107.267 82.1784 106.901C92.9014 106.507 101.31 97.7172 100.944 87.2938Z"
      fill={`${secondaryColor}`}
    />
    <path
      d="M80.0326 93.7439C80.1172 90.1661 81.7539 87.4053 84.5193 85.2643C86.156 83.9966 87.0872 82.4753 86.9743 80.3906C86.8332 77.8833 84.745 75.7423 82.2618 75.5733C79.4964 75.3761 77.0978 77.1791 76.6464 79.7427C76.5899 80.0807 76.5617 80.447 76.5053 80.785C76.3924 81.8837 75.6869 82.5035 74.6711 82.4471C73.6834 82.3908 73.0344 81.6583 73.0344 80.5878C73.0062 76.8128 75.828 73.2632 79.5811 72.3054C83.5881 71.2912 87.7362 73.1787 89.5422 76.841C91.3764 80.5315 90.3887 84.9262 87.2001 87.5462C86.4382 88.1659 85.7045 88.8139 85.0554 89.5463C83.9267 90.8141 83.4188 92.3635 83.4752 94.0538C83.4752 94.3918 83.5034 94.7017 83.4188 95.0398C83.2495 95.8849 82.4594 96.4765 81.641 96.4202C80.7662 96.3638 80.089 95.7159 80.0043 94.7862C80.0043 94.4482 80.0326 94.1101 80.0326 93.7439Z"
      fill={`${secondaryColor}`}
    />
    <path
      d="M81.7544 103.379C80.7668 103.379 80.0049 102.619 80.0049 101.633C80.0049 100.675 80.7668 99.9422 81.7262 99.9141C82.6856 99.9141 83.504 100.731 83.4758 101.689C83.4758 102.647 82.7139 103.379 81.7544 103.379Z"
      fill={`${secondaryColor}`}
    />
  </Icon>
);

export const SuccessConfetti = (props: any) => {
  return (
    <Icon {...props} width="100" height="91" viewBox="0 0 100 91" fill="none">
      <path
        d="M0.0649607 68.221C0.404306 66.5243 25.94 34.4279 38.6655 18.5918L63.6922 72.4628C44.604 72.7456 5.91866 73.3112 3.88259 73.3112C1.3375 73.3112 -0.359221 70.3419 0.0649607 68.221Z"
        fill="url(#paint0_linear_3809_196552)"
      />
      <mask
        id="mask0_3809_196552"
        style={{ maskType: "alpha" }}
        mask={"alpha"}
        maskUnits="userSpaceOnUse"
        x="0"
        y="18"
        width="64"
        height="56"
      >
        <path
          d="M0.0649607 68.221C0.404306 66.5243 25.94 34.4279 38.6655 18.5918L63.6922 72.4628C44.604 72.7456 5.91866 73.3112 3.88259 73.3112C1.3375 73.3112 -0.359221 70.3419 0.0649607 68.221Z"
          fill="url(#paint1_linear_3809_196552)"
        />
      </mask>
      <g mask="url(#mask0_3809_196552)">
        <ellipse
          cx="39.8031"
          cy="56.0344"
          rx="37.0179"
          ry="29.2111"
          transform="rotate(-26.1391 39.8031 56.0344)"
          fill="url(#paint2_linear_3809_196552)"
        />
        <ellipse
          cx="51.4039"
          cy="49.2347"
          rx="39.8133"
          ry="34.4414"
          transform="rotate(-26.1391 51.4039 49.2347)"
          fill="url(#paint3_linear_3809_196552)"
        />
        <ellipse
          cx="58.8671"
          cy="41.9693"
          rx="35.5365"
          ry="35.0625"
          transform="rotate(-26.1391 58.8671 41.9693)"
          fill="url(#paint4_linear_3809_196552)"
        />
      </g>
      <ellipse
        cx="52.9175"
        cy="44.8668"
        rx="12.6131"
        ry="29.6927"
        transform="rotate(-26.1391 52.9175 44.8668)"
        fill="url(#paint5_linear_3809_196552)"
      />
      <path
        d="M72.7205 2.00948L72.3673 1.5301M75.4957 2.43012L75.975 2.07694M74.8396 4.8857L75.3105 5.52486M72.4596 4.66692L71.8205 5.13782"
        stroke="#2276BB"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M60.6641 6.1875C65.2058 9.11862 65.8747 19.2646 59.0857 23.851M67.674 36.4881C72.0898 36.8826 82.0459 29.241 81.3302 20.6457M73.3923 44.978C77.1885 43.1244 86.1996 40.7044 91.8749 45.8536M73.3923 57.6169C75.3004 57.9991 79.6959 59.7619 82.0127 63.7549"
        stroke="#72AAFE"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M40.9718 3.66402L40.836 2.29661M38.7314 6.03377L37.364 6.16954M41.1876 8.44727L41.3403 9.98561"
        stroke="#2368D3"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M86.5548 65.0867L87.0721 65.7889M88.3549 65.4758L88.4285 64.6091M89.434 66.2155L90.141 65.6043M89.7775 67.4068L90.6271 67.5933M89.0984 68.5391L89.6157 69.2413M87.8157 68.8522L87.6843 69.7615M86.7797 68.1711L86.0295 68.7237M86.393 66.9212L85.4857 66.7772"
        stroke="#92BDFF"
        strokeLinecap="round"
      />
      <path
        d="M43.7673 5.29197C45.1369 4.87657 47.8756 4.6712 49.1235 6.70497C50.3714 8.73874 49.8316 12.3341 47.3308 12.8003C44.83 13.2666 43.7616 10.4512 46.0845 9.35942C48.8768 8.04697 51.7989 9.83474 52.5109 12.0243C53.0804 13.776 51.912 15.2547 51.2566 15.7751"
        stroke="#2368D3"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M77.9205 14.3103L79.2338 16.0928M82.4899 15.298L82.6768 13.0978M85.2291 17.1756L87.0239 15.6242M86.1013 20.1997L88.258 20.6732M84.3772 23.0741L85.6905 24.8565M81.1211 23.8689L80.7878 26.1769M78.4913 22.1398L76.5871 23.5427M77.5098 18.9671L75.2066 18.6015"
        stroke="#BCD6FF"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M89.9945 42.6168L90.9767 43.9499M93.3538 43.3983L93.4662 41.773M95.382 44.8178L96.6798 43.6902M96.0548 47.0645L97.6405 47.4388M94.8236 49.1714L95.8058 50.5045M92.4465 49.723L92.228 51.4265M90.5001 48.4146L89.1204 49.4311M89.7454 46.0568L88.0536 45.7607"
        stroke="#AECEFF"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle
        cx="83.8302"
        cy="56.2213"
        r="1.38933"
        transform="rotate(-178.42 83.8302 56.2213)"
        fill="#2368D3"
      />
      <circle
        cx="68.5675"
        cy="51.8134"
        r="2.3817"
        transform="rotate(-36.3811 68.5675 51.8134)"
        fill="#5C99F6"
      />
      <circle
        cx="91.3714"
        cy="30.1291"
        r="1.57658"
        transform="rotate(-36.3811 91.3714 30.1291)"
        fill="#5C99F6"
      />
      <g filter="url(#filter0_f_3809_196552)">
        <path
          d="M16.5366 71.263H19.4823H22.8488L68.7171 62.1557L67.8755 55.3253C52.7263 55.3253 29.938 47.9868 24.4676 52.2151C15.6305 59.0457 15.5547 67.013 16.5366 71.263Z"
          fill="#2C70D9"
          fillOpacity="0.3"
        />
      </g>
      <path
        d="M39.0456 50.3047C50.1406 50.3047 59.1355 59.3197 59.1355 70.4154C59.1355 81.5111 50.1406 90.5261 39.0456 90.5261C27.9667 90.5261 18.9784 81.5361 18.9558 70.4565C18.9331 59.3448 27.9345 50.3047 39.0456 50.3047Z"
        fill="url(#paint6_linear_3809_196552)"
        stroke="#ABC9F7"
        strokeWidth="0.5"
      />
      <path
        d="M31.3896 71.168L37.1324 77.2008L50.0536 63.627"
        stroke="white"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_f_3809_196552"
          x="8.11865"
          y="42.9023"
          width="68.5981"
          height="36.3613"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="4"
            result="effect1_foregroundBlur_3809_196552"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3809_196552"
          x1="5.57939"
          y1="67.7968"
          x2="9.82121"
          y2="78.8255"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EBF3FF" />
          <stop offset="1" stopColor="#AECFFF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3809_196552"
          x1="4.30685"
          y1="52.1021"
          x2="14.063"
          y2="78.4014"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E9F2FF" />
          <stop offset="1" stopColor="#8C9199" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3809_196552"
          x1="29.4776"
          y1="47.533"
          x2="31.3428"
          y2="68.7661"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B9D5FF" />
          <stop offset="0.830826" stopColor="#88B7FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3809_196552"
          x1="47.0194"
          y1="41.7716"
          x2="48.539"
          y2="67.5601"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ECF4FF" />
          <stop offset="1" stopColor="#D2E4FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3809_196552"
          x1="47.5826"
          y1="58.5857"
          x2="43.0095"
          y2="30.3536"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#90BBFE" />
          <stop offset="1" stopColor="#B9D5FF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_3809_196552"
          x1="60.8222"
          y1="20.2476"
          x2="41.41"
          y2="64.538"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#74ABFF" />
          <stop offset="1" stopColor="#115ACA" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_3809_196552"
          x1="39.0248"
          y1="99.8848"
          x2="4.99325"
          y2="34.6253"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const Notifications = (props: any) => {
  return (
    <Icon {...props} width="120" height="120" viewBox="0 0 120 120" fill="none">
      <circle
        cx="59.1813"
        cy="64.1102"
        r="47.9296"
        fill="url(#paint0_linear_4057_64831)"
        fillOpacity="0.9"
      />
      <path
        d="M92.6446 39.2168L86.5621 49.2791M92.5328 60.5133L106.974 53.0063M94.13 72.3489L107.783 74.8685M91.6076 84.3581L99.7852 92.13"
        stroke="url(#paint1_radial_4057_64831)"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <g filter="url(#filter0_i_4057_64831)">
        <path
          d="M33.7567 21.1269L36.8117 33.7424L13.9272 16.4834L33.7567 21.1269Z"
          fill="#68A4F8"
        />
      </g>
      <path
        d="M30.3676 26.3935L22.4812 37.2147L0 12.3779L42.0312 11.2502L33.8425 21.1339L14.8968 16.8909L30.3676 26.3935Z"
        fill="url(#paint2_linear_4057_64831)"
      />
      <path
        d="M38.0002 34.0002C45.5693 35.9913 57.6933 32.1464 62.3336 25.6404C66 20.4999 54.0001 13.4995 51.0002 22.5003C49.6275 26.6187 57.4685 35.7536 70.533 31.9472C75.5 30.5 83.5 37.5 78.1008 44.5602C74.2698 49.5698 62.4291 48.98 63.5 44.5602"
        stroke="#9AC0F9"
        strokeLinecap="round"
        strokeDasharray="2 2"
      />
      <path
        d="M35.6986 97.3213C35.0054 95.8843 33.5275 95.2687 32.8752 95.1405L22.0808 95.2549C25.1776 101.216 31.6856 113.605 32.9434 115.478C34.2013 117.351 34.5157 117.82 36.3923 117.579L43.8985 116.615C46.0342 116.341 46.2399 115.043 45.4537 113.872C44.6676 112.701 36.5651 99.1175 35.6986 97.3213Z"
        fill="url(#paint3_linear_4057_64831)"
      />
      <path
        d="M69.7343 99.9446C68.233 100.137 35.6716 97.1123 19.5785 95.5758C11.8545 94.8438 5.7926 87.2472 4.41762 76.5401C3.05206 65.9064 9.04933 58.1421 14.438 55.5427C19.8267 52.9433 52.139 37.9851 59.9494 34.4388C65.6594 34.3415 73.845 42.8278 78.1482 66.4368C82.4515 90.0458 71.6108 99.7036 69.7343 99.9446Z"
        fill="url(#paint4_linear_4057_64831)"
      />
      <path
        d="M20.2163 75.7834C21.7508 87.7339 27.7639 94.9488 31.1592 96.6323C21.5355 95.9606 8.73929 98.0351 4.73948 79.0424C2.64505 69.0972 5.92225 62.1377 11.2899 57.573C14.1301 55.1577 15.6892 55.3823 21.623 52.077C20.1481 55.4456 18.7705 64.5241 20.2163 75.7834Z"
        fill="url(#paint5_linear_4057_64831)"
      />
      <path
        d="M78.1974 65.7943C79.3673 74.9054 78.9996 83.1504 77.4116 89.2173C76.6173 92.2517 75.5246 94.7152 74.1886 96.4693C72.8559 98.2191 71.3022 99.2387 69.5702 99.4611C67.8344 99.684 66.0038 99.0953 64.1697 97.7452C62.3341 96.3939 60.5244 94.2995 58.8602 91.5818C55.5327 86.1479 52.8351 78.3017 51.6665 69.201C50.4972 60.0951 50.9747 51.6777 52.6735 45.4362C53.5232 42.3142 54.6718 39.7616 56.0515 37.9403C57.4298 36.1208 59.012 35.0629 60.7386 34.8412C62.4652 34.6195 64.2634 35.2433 66.0567 36.6555C67.8518 38.0692 69.608 40.2488 71.2189 43.0548C74.4395 48.6646 77.0281 56.6884 78.1974 65.7943Z"
        fill="url(#paint6_linear_4057_64831)"
        stroke="url(#paint7_linear_4057_64831)"
      />
      <path
        d="M64.2066 67.5911C65.572 78.2249 55.5637 79.51 54.9382 79.5903C54.2324 79.0451 53.0286 74.6217 52.3217 69.1172C51.6149 63.6126 51.5818 58.4031 52.2073 58.3228C55.7519 57.8676 63.1142 59.0841 64.2066 67.5911Z"
        fill="url(#paint8_linear_4057_64831)"
      />
      <path
        d="M47.1987 46.4521L11.8822 61.5878C10.3686 63.6059 9.99023 66.2126 9.99023 67.2637L45.9374 59.0652C45.9374 53.0109 46.7783 48.1339 47.1987 46.4521Z"
        fill="url(#paint9_linear_4057_64831)"
      />
      <defs>
        <filter
          id="filter0_i_4057_64831"
          x="13.9272"
          y="16.4834"
          width="22.8845"
          height="17.2588"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0705882 0 0 0 0 0.333333 0 0 0 0 0.741176 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_4057_64831"
          />
        </filter>
        <linearGradient
          id="paint0_linear_4057_64831"
          x1="65"
          y1="166.5"
          x2="46.6851"
          y2="7.74812"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="1" stopColor="#ABCDFF" stopOpacity="0" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_4057_64831"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(81.974 65.0606) rotate(-8.1301) scale(20.5664 33.3641)"
        >
          <stop stopColor="#72AAFE" stopOpacity="0" />
          <stop offset="1" stopColor="#72AAFE" />
        </radialGradient>
        <linearGradient
          id="paint2_linear_4057_64831"
          x1="19.2026"
          y1="6.1889"
          x2="28.5698"
          y2="35.2523"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B7D2FA" />
          <stop offset="1" stopColor="#A5C7F9" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_4057_64831"
          x1="29.6937"
          y1="86.0115"
          x2="33.9799"
          y2="104.536"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0C3A81" />
          <stop offset="1" stopColor="#1568E7" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_4057_64831"
          x1="50.7883"
          y1="101.742"
          x2="45.3094"
          y2="54.1219"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4691F7" />
          <stop offset="0.645604" stopColor="#9FC3F9" />
          <stop offset="0.99" stopColor="#B7D2FB" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_4057_64831"
          x1="15.7837"
          y1="66.8151"
          x2="21.8078"
          y2="113.729"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#74ABFF" />
          <stop offset="1" stopColor="#0758D5" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_4057_64831"
          x1="60.638"
          y1="29.8992"
          x2="69.1889"
          y2="100.65"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#74ABFF" />
          <stop offset="1" stopColor="#0A58D2" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_4057_64831"
          x1="60.6749"
          y1="34.3453"
          x2="69.1086"
          y2="100.024"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#115ED5" />
          <stop offset="1" stopColor="#68A1FA" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_4057_64831"
          x1="59.1813"
          y1="56.5432"
          x2="59.6296"
          y2="78.9879"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.539507" stopColor="#CCD9F9" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_4057_64831"
          x1="28.9098"
          y1="43.2989"
          x2="31.4324"
          y2="61.5878"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const DarkModeNotifications = (props: any) => {
  return (
    <Icon {...props} width="120" height="120" viewBox="0 0 120 120" fill="none">
      <svg
        width="120"
        height="120"
        viewBox="0 0 120 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="59.1813"
          cy="64.1102"
          r="47.9296"
          fill="url(#paint0_linear_4071_63633)"
          fillOpacity="0.9"
        />
        <path
          d="M92.6446 39.2168L86.5621 49.2791M92.5328 60.5133L106.974 53.0063M94.13 72.3489L107.783 74.8685M91.6076 84.3581L99.7852 92.13"
          stroke="url(#paint1_radial_4071_63633)"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <g filter="url(#filter0_i_4071_63633)">
          <path
            d="M33.7567 21.1269L36.8117 33.7424L13.9272 16.4834L33.7567 21.1269Z"
            fill="#3787F6"
          />
        </g>
        <path
          d="M30.3676 26.3935L22.4812 37.2147L0 12.3779L42.0312 11.2502L33.8425 21.1339L14.8968 16.8909L30.3676 26.3935Z"
          fill="url(#paint2_linear_4071_63633)"
        />
        <path
          d="M38.0002 34.0002C45.5693 35.9913 57.6933 32.1464 62.3336 25.6404C66 20.4999 54.0001 13.4995 51.0002 22.5003C49.6275 26.6187 57.4685 35.7536 70.533 31.9472C75.5 30.5 83.5 37.5 78.1008 44.5602C74.2698 49.5698 62.4291 48.98 63.5 44.5602"
          stroke="#4D8BEB"
          strokeLinecap="round"
          strokeDasharray="2 2"
        />
        <path
          d="M35.6986 97.3213C35.0054 95.8843 33.5275 95.2687 32.8752 95.1405L22.0808 95.2549C25.1776 101.216 31.6856 113.605 32.9434 115.478C34.2013 117.351 34.5157 117.82 36.3923 117.579L43.8985 116.615C46.0342 116.341 46.2399 115.043 45.4537 113.872C44.6676 112.701 36.5651 99.1175 35.6986 97.3213Z"
          fill="url(#paint3_linear_4071_63633)"
        />
        <path
          d="M69.7343 99.9446C68.233 100.137 35.6716 97.1123 19.5785 95.5758C11.8545 94.8438 5.7926 87.2472 4.41762 76.5401C3.05206 65.9064 9.04933 58.1421 14.438 55.5427C19.8267 52.9433 52.139 37.9851 59.9494 34.4388C65.6594 34.3415 73.845 42.8278 78.1482 66.4368C82.4515 90.0458 71.6108 99.7036 69.7343 99.9446Z"
          fill="url(#paint4_linear_4071_63633)"
        />
        <path
          d="M20.2163 75.7834C21.7508 87.7339 27.7639 94.9488 31.1592 96.6323C21.5355 95.9606 8.73929 98.0351 4.73948 79.0424C2.64505 69.0972 5.92225 62.1377 11.2899 57.573C14.1301 55.1577 15.6892 55.3823 21.623 52.077C20.1481 55.4456 18.7705 64.5241 20.2163 75.7834Z"
          fill="url(#paint5_linear_4071_63633)"
        />
        <path
          d="M78.1974 65.7943C79.3673 74.9054 78.9996 83.1504 77.4116 89.2173C76.6173 92.2517 75.5246 94.7152 74.1886 96.4693C72.8559 98.2191 71.3022 99.2387 69.5702 99.4611C67.8344 99.684 66.0038 99.0953 64.1697 97.7452C62.3341 96.3939 60.5244 94.2995 58.8602 91.5818C55.5327 86.1479 52.8351 78.3017 51.6665 69.201C50.4972 60.0951 50.9747 51.6777 52.6735 45.4362C53.5232 42.3142 54.6718 39.7616 56.0515 37.9403C57.4298 36.1208 59.012 35.0629 60.7386 34.8412C62.4652 34.6195 64.2634 35.2433 66.0567 36.6555C67.8518 38.0692 69.608 40.2488 71.2189 43.0548C74.4395 48.6646 77.0281 56.6884 78.1974 65.7943Z"
          fill="url(#paint6_linear_4071_63633)"
          stroke="url(#paint7_linear_4071_63633)"
        />
        <path
          d="M64.2066 67.5911C65.572 78.2249 55.5637 79.51 54.9382 79.5903C54.2324 79.0451 53.0286 74.6217 52.3217 69.1172C51.6149 63.6126 51.5818 58.4031 52.2073 58.3228C55.7519 57.8676 63.1142 59.0841 64.2066 67.5911Z"
          fill="url(#paint8_linear_4071_63633)"
        />
        <path
          d="M47.1987 46.4521L11.8822 61.5878C10.3686 63.6059 9.99023 66.2126 9.99023 67.2637L45.9374 59.0652C45.9374 53.0109 46.7783 48.1339 47.1987 46.4521Z"
          fill="url(#paint9_linear_4071_63633)"
        />
        <defs>
          <filter
            id="filter0_i_4071_63633"
            x="13.9272"
            y="16.4834"
            width="22.8845"
            height="17.2588"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.0705882 0 0 0 0 0.333333 0 0 0 0 0.741176 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect1_innerShadow_4071_63633"
            />
          </filter>
          <linearGradient
            id="paint0_linear_4071_63633"
            x1="36.5001"
            y1="213"
            x2="50.8342"
            y2="10.8711"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B0CFFF" />
            <stop offset="1" stopColor="#70A8FF" stopOpacity="0" />
          </linearGradient>
          <radialGradient
            id="paint1_radial_4071_63633"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(89.0001 63.9995) rotate(-6.70984) scale(17.1172 49.3567)"
          >
            <stop stopColor="#70A8FF" stopOpacity="0" />
            <stop offset="1" stopColor="#72AAFE" />
          </radialGradient>
          <linearGradient
            id="paint2_linear_4071_63633"
            x1="15"
            y1="3.49988"
            x2="28.5698"
            y2="35.2523"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7D2FA" />
            <stop offset="1" stopColor="#70A8FF" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_4071_63633"
            x1="29.6937"
            y1="86.0115"
            x2="33.9799"
            y2="104.536"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0C3A81" />
            <stop offset="1" stopColor="#1568E7" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_4071_63633"
            x1="50.7883"
            y1="101.742"
            x2="39"
            y2="24.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#4691F7" />
            <stop offset="0.491736" stopColor="#9FC3F9" />
            <stop offset="0.99" stopColor="#B7D2FB" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_4071_63633"
            x1="15.7837"
            y1="66.8151"
            x2="21.8078"
            y2="113.729"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#74ABFF" />
            <stop offset="1" stopColor="#0758D5" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_4071_63633"
            x1="60.638"
            y1="29.8992"
            x2="69.1889"
            y2="100.65"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#74ABFF" />
            <stop offset="1" stopColor="#0A58D2" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_4071_63633"
            x1="60.6749"
            y1="34.3453"
            x2="69.1086"
            y2="100.024"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#115ED5" />
            <stop offset="1" stopColor="#68A1FA" />
          </linearGradient>
          <linearGradient
            id="paint8_linear_4071_63633"
            x1="53"
            y1="41.0001"
            x2="59.6296"
            y2="78.9879"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.539507" stopColor="#CCD9F9" />
            <stop offset="0.874379" stopColor="#9FB8F4" />
          </linearGradient>
          <linearGradient
            id="paint9_linear_4071_63633"
            x1="28.9098"
            y1="43.2989"
            x2="31.4324"
            y2="61.5878"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </Icon>
  );
};

export const SignalsBotIcon = (props: any) => {
  return (
    <Icon
      $size={70}
      width="70"
      height="70"
      viewBox="0 0 70 70"
      {...props}
      fill="none"
    >
      <circle cx="35" cy="35" r="35" fill="#E6EEFE" />
      <circle
        opacity="0.4"
        cx="34.7394"
        cy="34.7397"
        r="21.4575"
        transform="rotate(116.285 34.7394 34.7397)"
        fill="white"
        stroke="#E0EAFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33 39H37L37.9377 54.9413C37.9715 55.5157 37.5148 56 36.9394 56H32.1245C31.526 56 31.0615 55.4777 31.1314 54.8832L33 39Z"
        fill="#3272FE"
      />
      <path
        d="M28 56.4C28 55.0745 29.0745 54 30.4 54H38C39.6569 54 41 55.3431 41 57H28.6C28.2686 57 28 56.7314 28 56.4Z"
        fill="#7AA4FE"
      />
      <circle cx="35" cy="35" r="5" fill="#3272FE" />
      <mask id="path-6-inside-1_4942_248799" fill="white">
        <path d="M27.0755 40.8931C26.6051 41.2706 25.9126 41.1979 25.5839 40.6922C24.4807 38.9949 23.8669 37.0175 23.8224 34.9794C23.7779 32.9412 24.3047 30.9389 25.3328 29.195C25.6391 28.6754 26.3278 28.5726 26.8142 28.9292C27.3006 29.2859 27.399 29.9666 27.1058 30.4937C26.3549 31.8435 25.9721 33.3745 26.0061 34.9317C26.0401 36.4888 26.4894 38.0017 27.2985 39.3174C27.6145 39.8311 27.5459 40.5156 27.0755 40.8931Z" />
      </mask>
      <path
        d="M27.0755 40.8931C26.6051 41.2706 25.9126 41.1979 25.5839 40.6922C24.4807 38.9949 23.8669 37.0175 23.8224 34.9794C23.7779 32.9412 24.3047 30.9389 25.3328 29.195C25.6391 28.6754 26.3278 28.5726 26.8142 28.9292C27.3006 29.2859 27.399 29.9666 27.1058 30.4937C26.3549 31.8435 25.9721 33.3745 26.0061 34.9317C26.0401 36.4888 26.4894 38.0017 27.2985 39.3174C27.6145 39.8311 27.5459 40.5156 27.0755 40.8931Z"
        stroke="#3272FE"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
        mask="url(#path-6-inside-1_4942_248799)"
      />
      <mask id="path-7-inside-2_4942_248799" fill="white">
        <path d="M42.5515 28.7746C43.031 28.4086 43.7215 28.4982 44.0378 29.0117C45.0993 30.7354 45.6647 32.7272 45.6595 34.7658C45.6543 36.8045 45.0789 38.7933 44.0086 40.5116C43.6898 41.0236 42.9988 41.1096 42.5212 40.7413C42.0436 40.3729 41.9618 39.6899 42.2678 39.1701C43.0513 37.8391 43.4714 36.3178 43.4753 34.7603C43.4793 33.2028 43.0669 31.6794 42.2902 30.3444C41.9868 29.8231 42.0721 29.1405 42.5515 28.7746Z" />
      </mask>
      <path
        d="M42.5515 28.7746C43.031 28.4086 43.7215 28.4982 44.0378 29.0117C45.0993 30.7354 45.6647 32.7272 45.6595 34.7658C45.6543 36.8045 45.0789 38.7933 44.0086 40.5116C43.6898 41.0236 42.9988 41.1096 42.5212 40.7413C42.0436 40.3729 41.9618 39.6899 42.2678 39.1701C43.0513 37.8391 43.4714 36.3178 43.4753 34.7603C43.4793 33.2028 43.0669 31.6794 42.2902 30.3444C41.9868 29.8231 42.0721 29.1405 42.5515 28.7746Z"
        stroke="#3272FE"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
        mask="url(#path-7-inside-2_4942_248799)"
      />
      <mask id="path-8-inside-3_4942_248799" fill="white">
        <path d="M22.7761 44.1875C22.2403 44.6106 21.4587 44.5215 21.077 43.9555C19.2895 41.3051 18.3062 38.1833 18.2617 34.9689C18.2172 31.7545 19.1136 28.6067 20.827 25.9077C21.1929 25.3314 21.9717 25.2208 22.519 25.6288C23.0663 26.0368 23.174 26.8087 22.8158 27.3899C21.4234 29.6486 20.6966 32.2646 20.7335 34.9347C20.7705 37.6047 21.5695 40.1996 23.0239 42.4189C23.3981 42.9899 23.3119 43.7645 22.7761 44.1875Z" />
      </mask>
      <path
        d="M22.7761 44.1875C22.2403 44.6106 21.4587 44.5215 21.077 43.9555C19.2895 41.3051 18.3062 38.1833 18.2617 34.9689C18.2172 31.7545 19.1136 28.6067 20.827 25.9077C21.1929 25.3314 21.9717 25.2208 22.519 25.6288C23.0663 26.0368 23.174 26.8087 22.8158 27.3899C21.4234 29.6486 20.6966 32.2646 20.7335 34.9347C20.7705 37.6047 21.5695 40.1996 23.0239 42.4189C23.3981 42.9899 23.3119 43.7645 22.7761 44.1875Z"
        stroke="#A2BFFF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        mask="url(#path-8-inside-3_4942_248799)"
      />
      <mask id="path-9-inside-4_4942_248799" fill="white">
        <path d="M47.0749 25.7837C47.6273 25.3827 48.4046 25.5033 48.7631 26.0843C50.4419 28.805 51.2979 31.964 51.2123 35.1775C51.1266 38.3911 50.1035 41.5 48.2821 44.1274C47.8932 44.6884 47.1106 44.7675 46.5803 44.3376C46.05 43.9078 45.9736 43.1321 46.3551 42.566C47.8378 40.3655 48.6699 37.781 48.7411 35.1117C48.8122 32.4423 48.1189 29.8172 46.7556 27.5408C46.4048 26.9552 46.5224 26.1847 47.0749 25.7837Z" />
      </mask>
      <path
        d="M47.0749 25.7837C47.6273 25.3827 48.4046 25.5033 48.7631 26.0843C50.4419 28.805 51.2979 31.964 51.2123 35.1775C51.1266 38.3911 50.1035 41.5 48.2821 44.1274C47.8932 44.6884 47.1106 44.7675 46.5803 44.3376C46.05 43.9078 45.9736 43.1321 46.3551 42.566C47.8378 40.3655 48.6699 37.781 48.7411 35.1117C48.8122 32.4423 48.1189 29.8172 46.7556 27.5408C46.4048 26.9552 46.5224 26.1847 47.0749 25.7837Z"
        stroke="#A2BFFF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        mask="url(#path-9-inside-4_4942_248799)"
      />
    </Icon>
  );
};

export const DcaBotIcon = (props: any) => {
  return (
    <Icon
      {...props}
      $size={70}
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
    >
      <circle cx="35" cy="35" r="35" fill="#E6EEFE" />
      <path
        d="M36.0385 31.9988L37.077 33.4988L36.0385 34.9988L35 33.4988L36.0385 31.9988Z"
        fill="#E6EEFE"
      />
      <path
        d="M39.4985 31.9978L40.537 33.4977L39.4985 34.9977L38.4601 33.4977L39.4985 31.9978Z"
        fill="#E6EEFE"
      />
      <path
        d="M42.9615 31.9978L44 33.4977L42.9615 34.9977L41.923 33.4977L42.9615 31.9978Z"
        fill="#E6EEFE"
      />
      <path
        d="M39.4992 27L42.2686 31.0001L41.23 32.5002L39.4992 30.0002L37.7685 32.5002L36.7299 31.0001L39.4992 27Z"
        fill="#E6EEFE"
      />
      <path
        d="M39.4992 40L36.7299 35.9999L37.7685 34.4998L39.4992 36.9998L41.23 34.4998L42.2686 35.9999L39.4992 40Z"
        fill="#E6EEFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.8711 27.6875L35.6212 27.8728L35.6211 27.873L38.871 27.6876L38.8711 27.6875Z"
        fill="white"
      />
      <path
        d="M11.5234 31.3809C11.5234 30.8286 11.9712 30.3809 12.5234 30.3809H16.0472V43.0475H12.5234C11.9712 43.0475 11.5234 42.5998 11.5234 42.0475V31.3809Z"
        fill="#3272FE"
      />
      <path
        d="M59.4766 42.0479C59.4766 42.6001 59.0288 43.0479 58.4766 43.0479L54.9528 43.0479L54.9528 30.3812L58.4766 30.3812C59.0288 30.3812 59.4766 30.8289 59.4766 31.3812L59.4766 42.0479Z"
        fill="#3272FE"
      />
      <rect
        x="16.0469"
        y="21.333"
        width="38.9048"
        height="31.6667"
        rx="4"
        fill="#A8C3FF"
      />
      <rect
        x="21.4766"
        y="26.7617"
        width="27.1429"
        height="16.2857"
        rx="2"
        fill="#3272FE"
      />
      <path
        d="M34.6719 18.7686H36.4738V20.9566C36.4738 21.4542 36.0704 21.8576 35.5728 21.8576C35.0753 21.8576 34.6719 21.4542 34.6719 20.9566V18.7686Z"
        fill="#3272FE"
      />
      <circle cx="35.5002" cy="17.2619" r="2.2619" fill="#3272FE" />
      <path
        d="M26.5 36L30.5 32L37.5 38.5L43.5 32.5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};

export const GridBotIcon = (props: any) => {
  return (
    <Icon {...props} width="30" height="30" viewBox="0 0 30 30" fill="none">
      <circle cx="15" cy="15" r="15" fill="#E6EEFE" />
      <rect x="10" y="6" width="3" height="18" fill="#A8C3FF" />
      <rect
        x="7"
        y="20"
        width="3"
        height="17"
        transform="rotate(-90 7 20)"
        fill="#3272FE"
      />
      <rect x="18" y="6" width="3" height="18" fill="#A8C3FF" />
      <rect
        x="7"
        y="12"
        width="3"
        height="17"
        transform="rotate(-90 7 12)"
        fill="#3272FE"
      />
      <rect x="10" y="6" width="3" height="11" fill="#A8C3FF" />
    </Icon>
  );
};

export const TradingViewBotIcon = (props: any) => {
  return (
    <Icon {...props} width="30" height="30" viewBox="0 0 30 30" fill="none">
      <circle cx="15" cy="15" r="15" fill="#E6EEFE" />
      <path
        d="M15.4615 13.9226L15.9231 14.4995L15.4615 15.0765L15 14.4995L15.4615 13.9226Z"
        fill="#E6EEFE"
      />
      <path
        d="M16.9993 13.9222L17.4609 14.4991L16.9993 15.0761L16.5378 14.4991L16.9993 13.9222Z"
        fill="#E6EEFE"
      />
      <path
        d="M18.5385 13.9222L19 14.4991L18.5385 15.0761L18.0769 14.4991L18.5385 13.9222Z"
        fill="#E6EEFE"
      />
      <path
        d="M16.9997 12L18.2305 13.5385L17.7689 14.1155L16.9997 13.1539L16.2304 14.1155L15.7688 13.5385L16.9997 12Z"
        fill="#E6EEFE"
      />
      <path
        d="M16.9997 17L15.7688 15.4615L16.2304 14.8845L16.9997 15.8461L17.7689 14.8845L18.2305 15.4615L16.9997 17Z"
        fill="#E6EEFE"
      />
      <path
        d="M12.6384 10.7148H4.92969V14.9237H8.87367V20.9967H12.6384V10.7148Z"
        fill="#3272FE"
      />
      <path
        d="M18.7336 13.3453C18.7336 14.7981 17.5297 15.9759 16.0445 15.9759C14.5594 15.9759 13.3555 14.7981 13.3555 13.3453C13.3555 11.8926 14.5594 10.7148 16.0445 10.7148C17.5297 10.7148 18.7336 11.8926 18.7336 13.3453Z"
        fill="#A8C3FF"
      />
      <path
        d="M18.7336 13.3453C18.7336 14.7981 17.5297 15.9759 16.0445 15.9759C14.5594 15.9759 13.3555 14.7981 13.3555 13.3453C13.3555 11.8926 14.5594 10.7148 16.0445 10.7148C17.5297 10.7148 18.7336 11.8926 18.7336 13.3453Z"
        stroke="#A8C3FF"
      />
      <path
        d="M25.5014 10.7148H20.9523L16.4033 21.0006H20.9748L25.5014 10.7148Z"
        fill="#3272FE"
      />
    </Icon>
  );
};

export const HedgingBotIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="30" height="30" viewBox="0 0 30 30" fill="none">
      <circle cx="15" cy="15" r="15" fill="#E6EEFE" />
      <path
        d="M15 9.5V21M12.25 21H17.75M15 9.5L10.5 12M15 9.5L19.5 12M10.5 12L8.75 17.25M10.5 12L12.25 17.25M8 17.25H13M19.5 12L17.75 17.25M19.5 12L21.25 17.25M17 17.25H22"
        stroke="#3272FE"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="15" cy="9.5" r="2.5" fill="#3272FE" />
    </svg>
  );
};

export const DarkSignalsBotIcon = (props: any) => {
  return (
    <Icon
      {...props}
      $size={70}
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
    >
      <circle cx="35" cy="35" r="35" fill="#70A8FF" fillOpacity="0.22" />
      <circle
        opacity="0.4"
        cx="34.7394"
        cy="34.7399"
        r="21.4575"
        transform="rotate(116.285 34.7394 34.7399)"
        fill="#70A8FF"
        fillOpacity="0.22"
        stroke="#E0EAFF"
        strokeOpacity="0.1"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.628 54.9416L33.4446 39.5H36.5285L37.4386 54.9706C37.4555 55.2578 37.2271 55.5 36.9394 55.5H32.1245C31.8252 55.5 31.593 55.2388 31.628 54.9416Z"
        fill="#70A8FF"
        stroke="#70A8FF"
      />
      <path
        d="M28 56.4C28 55.0745 29.0745 54 30.4 54H38C39.6569 54 41 55.3431 41 57H28.6C28.2686 57 28 56.7314 28 56.4Z"
        fill="#7AA4FE"
      />
      <circle cx="35" cy="35" r="4.5" fill="#70A8FF" stroke="#70A8FF" />
      <mask id="path-6-inside-1_4942_248869" fill="white">
        <path d="M27.0755 40.8931C26.6051 41.2706 25.9126 41.1979 25.5839 40.6922C24.4807 38.9949 23.8669 37.0175 23.8224 34.9794C23.7779 32.9412 24.3047 30.9389 25.3328 29.195C25.6391 28.6754 26.3278 28.5726 26.8142 28.9292C27.3006 29.2859 27.399 29.9666 27.1058 30.4937C26.3549 31.8435 25.9721 33.3745 26.0061 34.9317C26.0401 36.4888 26.4894 38.0017 27.2985 39.3174C27.6145 39.8311 27.5459 40.5156 27.0755 40.8931Z" />
      </mask>
      <path
        d="M27.0755 40.8931C26.6051 41.2706 25.9126 41.1979 25.5839 40.6922C24.4807 38.9949 23.8669 37.0175 23.8224 34.9794C23.7779 32.9412 24.3047 30.9389 25.3328 29.195C25.6391 28.6754 26.3278 28.5726 26.8142 28.9292C27.3006 29.2859 27.399 29.9666 27.1058 30.4937C26.3549 31.8435 25.9721 33.3745 26.0061 34.9317C26.0401 36.4888 26.4894 38.0017 27.2985 39.3174C27.6145 39.8311 27.5459 40.5156 27.0755 40.8931Z"
        fill="#70A8FF"
        stroke="#70A8FF"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
        mask="url(#path-6-inside-1_4942_248869)"
      />
      <mask id="path-7-inside-2_4942_248869" fill="white">
        <path d="M42.5515 28.7748C43.031 28.4089 43.7215 28.4984 44.0378 29.012C45.0993 30.7357 45.6647 32.7275 45.6595 34.7661C45.6543 36.8047 45.0789 38.7936 44.0086 40.5119C43.6898 41.0239 42.9988 41.1099 42.5212 40.7415C42.0436 40.3731 41.9618 39.6901 42.2678 39.1704C43.0513 37.8393 43.4714 36.3181 43.4753 34.7605C43.4793 33.203 43.0669 31.6797 42.2902 30.3447C41.9868 29.8233 42.0721 29.1408 42.5515 28.7748Z" />
      </mask>
      <path
        d="M42.5515 28.7748C43.031 28.4089 43.7215 28.4984 44.0378 29.012C45.0993 30.7357 45.6647 32.7275 45.6595 34.7661C45.6543 36.8047 45.0789 38.7936 44.0086 40.5119C43.6898 41.0239 42.9988 41.1099 42.5212 40.7415C42.0436 40.3731 41.9618 39.6901 42.2678 39.1704C43.0513 37.8393 43.4714 36.3181 43.4753 34.7605C43.4793 33.203 43.0669 31.6797 42.2902 30.3447C41.9868 29.8233 42.0721 29.1408 42.5515 28.7748Z"
        fill="#70A8FF"
        stroke="#70A8FF"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
        mask="url(#path-7-inside-2_4942_248869)"
      />
      <mask id="path-8-inside-3_4942_248869" fill="white">
        <path d="M22.7761 44.1878C22.2403 44.6108 21.4587 44.5217 21.077 43.9558C19.2895 41.3053 18.3062 38.1835 18.2617 34.9691C18.2172 31.7548 19.1136 28.607 20.827 25.908C21.1929 25.3317 21.9717 25.221 22.519 25.629C23.0663 26.0371 23.174 26.809 22.8158 27.3901C21.4234 29.6488 20.6966 32.2648 20.7335 34.9349C20.7705 37.605 21.5695 40.1999 23.0239 42.4192C23.3981 42.9901 23.3119 43.7647 22.7761 44.1878Z" />
      </mask>
      <path
        d="M22.7761 44.1878C22.2403 44.6108 21.4587 44.5217 21.077 43.9558C19.2895 41.3053 18.3062 38.1835 18.2617 34.9691C18.2172 31.7548 19.1136 28.607 20.827 25.908C21.1929 25.3317 21.9717 25.221 22.519 25.629C23.0663 26.0371 23.174 26.809 22.8158 27.3901C21.4234 29.6488 20.6966 32.2648 20.7335 34.9349C20.7705 37.605 21.5695 40.1999 23.0239 42.4192C23.3981 42.9901 23.3119 43.7647 22.7761 44.1878Z"
        stroke="#5A86CC"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        mask="url(#path-8-inside-3_4942_248869)"
      />
      <mask id="path-9-inside-4_4942_248869" fill="white">
        <path d="M47.0749 25.7835C47.6273 25.3825 48.4046 25.5031 48.7631 26.0841C50.4419 28.8047 51.2979 31.9638 51.2123 35.1773C51.1266 38.3909 50.1035 41.4998 48.2821 44.1272C47.8932 44.6882 47.1106 44.7672 46.5803 44.3374C46.05 43.9075 45.9736 43.1319 46.3551 42.5657C47.8378 40.3653 48.6699 37.7808 48.7411 35.1114C48.8122 32.4421 48.1189 29.8169 46.7556 27.5406C46.4048 26.9549 46.5224 26.1844 47.0749 25.7835Z" />
      </mask>
      <path
        d="M47.0749 25.7835C47.6273 25.3825 48.4046 25.5031 48.7631 26.0841C50.4419 28.8047 51.2979 31.9638 51.2123 35.1773C51.1266 38.3909 50.1035 41.4998 48.2821 44.1272C47.8932 44.6882 47.1106 44.7672 46.5803 44.3374C46.05 43.9075 45.9736 43.1319 46.3551 42.5657C47.8378 40.3653 48.6699 37.7808 48.7411 35.1114C48.8122 32.4421 48.1189 29.8169 46.7556 27.5406C46.4048 26.9549 46.5224 26.1844 47.0749 25.7835Z"
        stroke="#5A86CC"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        mask="url(#path-9-inside-4_4942_248869)"
      />
    </Icon>
  );
};

export const DarkDcaBotIcon = (props: any) => {
  return (
    <Icon
      {...props}
      $size={70}
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
    >
      <circle cx="35" cy="35" r="35" fill="#70A8FF" fillOpacity="0.22" />
      <path
        d="M36.0385 31.9988L37.077 33.4988L36.0385 34.9988L35 33.4988L36.0385 31.9988Z"
        fill="#E6EEFE"
      />
      <path
        d="M39.4985 31.9978L40.537 33.4977L39.4985 34.9977L38.4601 33.4977L39.4985 31.9978Z"
        fill="#E6EEFE"
      />
      <path
        d="M42.9615 31.9978L44 33.4977L42.9615 34.9977L41.923 33.4977L42.9615 31.9978Z"
        fill="#E6EEFE"
      />
      <path
        d="M39.4992 27L42.2686 31.0001L41.23 32.5002L39.4992 30.0002L37.7685 32.5002L36.7299 31.0001L39.4992 27Z"
        fill="#E6EEFE"
      />
      <path
        d="M39.4992 40L36.7299 35.9999L37.7685 34.4998L39.4992 36.9998L41.23 34.4998L42.2686 35.9999L39.4992 40Z"
        fill="#E6EEFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.8711 27.6873L35.6212 27.8726L35.6212 27.8727L38.871 27.6874L38.8711 27.6873Z"
        fill="white"
      />
      <path
        d="M11.5238 31.3809C11.5238 30.8286 11.9715 30.3809 12.5238 30.3809H16.0476V43.0475H12.5238C11.9715 43.0475 11.5238 42.5998 11.5238 42.0475V31.3809Z"
        fill="#70A8FF"
      />
      <path
        d="M59.4762 42.0476C59.4762 42.5999 59.0285 43.0476 58.4762 43.0476L54.9524 43.0476L54.9524 30.3809L58.4762 30.3809C59.0285 30.3809 59.4762 30.8287 59.4762 31.3809L59.4762 42.0476Z"
        fill="#70A8FF"
      />
      <path
        d="M34.6713 18.7681H36.4732V20.9561C36.4732 21.4537 36.0698 21.8571 35.5722 21.8571C35.0746 21.8571 34.6713 21.4537 34.6713 20.9561V18.7681Z"
        fill="#70A8FF"
      />
      <circle cx="35.5" cy="17.2619" r="2.2619" fill="#70A8FF" />
      <rect
        x="16.0476"
        y="21.3333"
        width="38.9048"
        height="31.6667"
        rx="4"
        fill="#A8C3FF"
      />
      <rect
        x="21.4762"
        y="26.762"
        width="27.1429"
        height="16.2857"
        rx="2"
        fill="#4D85FE"
      />
      <path
        d="M26.5 36L30.5 32L37.5 38.5L43.5 32.5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};

export const DarkGridBotIcon = (props: any) => {
  return (
    <Icon
      {...props}
      $size={70}
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
    >
      <circle cx="35" cy="35" r="35" fill="#70A8FF" fillOpacity="0.22" />
      <rect x="23.5" y="15" width="6" height="40" fill="#567FC1" />
      <rect
        x="15.5"
        y="47"
        width="6"
        height="40"
        transform="rotate(-90 15.5 47)"
        fill="#70A8FF"
      />
      <rect x="41.5" y="15" width="6" height="40" fill="#567FC1" />
      <rect
        x="15.5"
        y="29"
        width="6"
        height="40"
        transform="rotate(-90 15.5 29)"
        fill="#70A8FF"
      />
      <rect x="23.5" y="15" width="6" height="26" fill="#567FC1" />
    </Icon>
  );
};

export const DarkTradingViewBotIcon = (props: any) => {
  return (
    <Icon
      {...props}
      $size={70}
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
    >
      <circle cx="35" cy="35" r="35" fill="#70A8FF" fillOpacity="0.22" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.8711 27.6875L35.6212 27.8728L35.6211 27.873L38.871 27.6876L38.8711 27.6875Z"
        fill="white"
      />
      <path
        d="M29.4869 25H11.5V34.8206H20.7026V48.9911H29.4869V25Z"
        fill="#70A8FF"
      />
      <ellipse
        cx="37.4345"
        cy="31.1378"
        rx="6.27452"
        ry="6.13784"
        fill="#567FC1"
      />
      <path
        d="M59.5002 25H48.8858L38.2714 49H48.9381L59.5002 25Z"
        fill="#70A8FF"
      />
    </Icon>
  );
};

export const BalanceScaleIcon = (props: any) => {
  return (
    <Icon {...props} width="24" height="24" viewBox="0 0 24 24">
      <path
        d="M4.3 18.9063V19.9688C4.3 20.2623 4.54613 20.5 4.85 20.5H12.55C12.8539 20.5 13.1 20.2623 13.1 19.9688V8.58848C13.2568 8.52207 13.4066 8.44405 13.5465 8.35207L18.4295 9.93353C18.7176 10.0268 19.0293 9.87675 19.1259 9.59884L19.4755 8.59147C19.5721 8.31323 19.4167 8.01208 19.129 7.91878L14.7153 6.48939C14.7297 6.37916 14.75 6.27026 14.75 6.15637C14.75 4.68947 13.5187 3.50014 12 3.50014C10.9794 3.50014 10.0991 4.04334 9.62434 4.84054L5.5705 3.5277C5.28244 3.4344 4.97066 3.58448 4.87406 3.86238L4.52447 4.86976C4.42788 5.148 4.58325 5.44915 4.87097 5.54245L9.40847 7.01201C9.65872 7.71757 10.1977 8.29165 10.8997 8.58815V18.375H4.85C4.54613 18.375 4.3 18.6128 4.3 18.9063ZM1 13.5938C1 15.0607 2.97003 16.25 5.4 16.25C7.82997 16.25 9.8 15.0607 9.8 13.5938H9.79931C9.79931 13.0735 9.87081 13.3531 6.87572 7.56716C6.26797 6.39311 4.53066 6.39543 3.92394 7.56716C0.954625 13.3039 1.00069 13.0566 1.00069 13.5938H1ZM2.925 13.0626L5.4 8.28135L7.875 13.0626H2.925ZM14.2007 17.8438H14.2C14.2 19.3107 16.17 20.5 18.6 20.5C21.03 20.5 23 19.3107 23 17.8438H22.9993C22.9993 17.3235 23.0708 17.6031 20.0757 11.8171C19.468 10.6431 17.7307 10.6454 17.1239 11.8171C14.1546 17.5539 14.2007 17.3066 14.2007 17.8438ZM16.125 17.3125L18.6 12.5313L21.075 17.3125H16.125Z"
        fill="inherit"
      />
    </Icon>
  );
};

export const DarkHedgingBotIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="70" height="70" viewBox="0 0 70 70" fill="none">
      <circle cx="35" cy="35" r="35" fill="#70A8FF" fillOpacity="0.22" />
      <path
        d="M35 22V49M28.5 49H41.5M35 22L24.5 28M35 22L45.5 28M24.5 28L20.5 40M24.5 28L28.5 40M18.5 40H30.5M45.5 28L41.5 40M45.5 28L49.5 40M39.5 40H51.5"
        stroke="#70A8FF"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="35" cy="22" r="6" fill="#70A8FF" />
    </svg>
  );
};

export const ColoredSignalsBotIcon = (props: any) => {
  return (
    <Icon {...props} width="38" height="38" viewBox="0 0 38 38" fill="none">
      <g clipPath="url(#clip0_43_3491)">
        <circle
          opacity="0.8"
          cx="18.5823"
          cy="18.5822"
          r="16.8595"
          transform="rotate(116.285 18.5823 18.5822)"
          fill="white"
        />
        <mask
          id="mask0_43_3491"
          maskUnits="userSpaceOnUse"
          x="3"
          y="3"
          width="31"
          height="31"
        >
          <path
            d="M3.28711 33.2865V3.2865L18.2871 18.2865L33.2871 3.2865V33.2865L18.2871 18.2865L3.28711 33.2865Z"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_43_3491)">
          <circle cx="18.7871" cy="18.7865" r="12.5" fill="#FDE2AD" />
          <circle cx="18.7871" cy="18.7865" r="8.5" fill="#FEB932" />
        </g>
        <path
          d="M17.2157 21.9293H20.3586L21.082 34.2277C21.1158 34.8021 20.6591 35.2865 20.0837 35.2865H16.7688C16.1702 35.2865 15.7057 34.7641 15.7757 34.1696L17.2157 21.9293Z"
          fill="#3272FE"
        />
        <path
          d="M13.2871 35.6008C13.2871 34.5594 14.1314 33.7151 15.1728 33.7151H21.1443C22.4461 33.7151 23.5014 34.7704 23.5014 36.0722H13.7585C13.4982 36.0722 13.2871 35.8612 13.2871 35.6008Z"
          fill="#3272FE"
        />
        <circle cx="18.7871" cy="18.7865" r="3.5" fill="#3272FE" />
      </g>
      <defs>
        <clipPath id="clip0_43_3491">
          <rect width="38" height="38" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  );
};

export const DarkColoredSignalsBotIcon = (props: any) => {
  return (
    <Icon {...props} width="38" height="38" viewBox="0 0 38 38" fill="none">
      <g clipPath="url(#clip0_54_15285)">
        <circle
          opacity="0.8"
          cx="18.5823"
          cy="18.5822"
          r="16.8595"
          transform="rotate(116.285 18.5823 18.5822)"
          fill="#7A90BF"
          fillOpacity="0.6"
        />
        <mask
          id="mask0_54_15285"
          maskUnits="userSpaceOnUse"
          x="3"
          y="3"
          width="31"
          height="31"
        >
          <path
            d="M3.28687 33.2866V3.28662L18.2869 18.2866L33.2869 3.28662V33.2866L18.2869 18.2866L3.28687 33.2866Z"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_54_15285)">
          <circle
            cx="18.7869"
            cy="18.7866"
            r="12.5"
            fill="#FEB932"
            fillOpacity="0.4"
          />
          <circle cx="18.7869" cy="18.7866" r="8.5" fill="#FEB932" />
        </g>
        <path
          d="M17.2155 21.9294H20.3583L21.0818 34.2279C21.1156 34.8022 20.6589 35.2866 20.0835 35.2866H16.7686C16.17 35.2866 15.7055 34.7642 15.7754 34.1697L17.2155 21.9294Z"
          fill="#3272FE"
        />
        <path
          d="M13.2869 35.6008C13.2869 34.5594 14.1311 33.7151 15.1726 33.7151H21.144C22.4458 33.7151 23.5012 34.7704 23.5012 36.0722H13.7583C13.4979 36.0722 13.2869 35.8612 13.2869 35.6008Z"
          fill="#3272FE"
        />
        <circle cx="18.7869" cy="18.7866" r="3.5" fill="#3272FE" />
      </g>
      <defs>
        <clipPath id="clip0_54_15285">
          <rect width="38" height="38" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  );
};

export const ColoredDcaBotIcon = (props: any) => {
  return (
    <svg {...props} width="38" height="38" viewBox="0 0 38 38" fill="none">
      <circle cx="18.9456" cy="8.5" r="7.5" fill="#FEB932" fillOpacity="0.3" />
      <circle cx="18.9456" cy="8.5" r="4.5" fill="#FEB932" />
      <path
        d="M0 19.6564C0 19.2225 0.351764 18.8707 0.785714 18.8707H3.55441V28.8231H0.785714C0.351764 28.8231 0 28.4713 0 28.0373V19.6564Z"
        fill="#3272FE"
      />
      <path
        d="M37.677 28.0374C37.677 28.4714 37.3252 28.8231 36.8913 28.8231H34.1226V18.8707H36.8913C37.3252 18.8707 37.677 19.2226 37.677 19.6564V28.0374Z"
        fill="#3272FE"
      />
      <path
        d="M19.6031 10.1677C20.2019 9.88187 20.6157 9.27075 20.6157 8.56297C20.6157 7.58146 19.82 6.78577 18.8385 6.78577C17.857 6.78577 17.0613 7.58146 17.0613 8.56297C17.0613 9.31467 17.5279 9.9573 18.1874 10.2171V12.1736H19.6031V10.1677Z"
        fill="#3272FE"
      />
      <g filter="url(#filter0_i_43_3459)">
        <path
          d="M30.9796 11.762H6.6973C4.96155 11.762 3.55444 13.1691 3.55444 14.9048V33.5001C3.55444 35.2358 4.96155 36.6429 6.6973 36.6429H30.9796C32.7154 36.6429 34.1225 35.2358 34.1225 33.5001V14.9048C34.1225 13.1691 32.7154 11.762 30.9796 11.762Z"
          fill="#A8C3FF"
        />
      </g>
      <path
        d="M27.575 16.0273H9.39125C8.52338 16.0273 7.81982 16.7309 7.81982 17.5988V27.2518C7.81982 28.1197 8.52338 28.8232 9.39125 28.8232H27.575C28.4428 28.8232 29.1464 28.1197 29.1464 27.2518V17.5988C29.1464 16.7309 28.4428 16.0273 27.575 16.0273Z"
        fill="#3272FE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8947 19.3246L20.3947 24.4317L24.7075 20.119C24.9376 19.8889 25.3107 19.8889 25.5409 20.119C25.771 20.3491 25.771 20.7222 25.5409 20.9524L20.425 26.0682L14.925 20.961L12.1837 23.7024C11.9536 23.9325 11.5805 23.9325 11.3503 23.7024C11.1202 23.4722 11.1202 23.0991 11.3503 22.869L14.8947 19.3246Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_i_43_3459"
          x="3.55444"
          y="11.762"
          width="30.5681"
          height="24.881"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.196078 0 0 0 0 0.447059 0 0 0 0 0.996078 0 0 0 0.37 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_43_3459"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const ColoredGridBotIcon = (props: any) => {
  return (
    <svg {...props} width="38" height="38" viewBox="0 0 38 38" fill="none">
      <rect x="9.28589" y="3" width="4.71429" height="31.4286" fill="#FEB932" />
      <rect
        x="3"
        y="28.1428"
        width="4.71429"
        height="31.4286"
        transform="rotate(-90 3 28.1428)"
        fill="#3272FE"
      />
      <rect x="23.4287" y="3" width="4.71429" height="31.4286" fill="#FEB932" />
      <rect
        x="3"
        y="14"
        width="4.71429"
        height="31.4286"
        transform="rotate(-90 3 14)"
        fill="#3272FE"
      />
      <rect x="9.28589" y="3" width="4.71429" height="20.4286" fill="#FEB932" />
    </svg>
  );
};

export const ColoredTradingViewBotIcon = (props: any) => {
  return (
    <Icon {...props} viewBox="0 0 38 38" fill="none">
      <path
        d="M14.1326 10H0L0 17.7162H7.23063V28.8501H14.1326V10Z"
        fill="#3272FE"
      />
      <ellipse
        cx="20.377"
        cy="14.8226"
        rx="4.92998"
        ry="4.82259"
        fill="#FEB932"
      />
      <path
        d="M37.7144 10H29.3745L21.0347 28.8571H29.4156L37.7144 10Z"
        fill="#3272FE"
      />
    </Icon>
  );
};

export const ColoredManualTradingIcon = (props: any) => {
  return (
    <Icon {...props} viewBox="0 0 38 38" fill="none">
      <path
        d="M20.4998 5.10001C20.4998 4.4925 20.0073 4.00001 19.3998 4.00001C18.7923 4 18.2998 4.49249 18.2998 5.10001V6.19988C18.2998 6.80735 18.7922 7.29982 19.3997 7.29988C20.0072 7.29995 20.4998 6.80744 20.4998 6.19988V5.10001Z"
        fill="#FEB932"
      />
      <path
        d="M20.4998 27.1001L18.2998 27.1001V31.4998L20.4998 31.5001V27.1001Z"
        fill="#FEB932"
      />
      <path
        d="M19.5617 29.3001L18.2998 31.1022L22.5795 34.0988C23.0771 34.4472 23.7629 34.3264 24.1114 33.8289C24.46 33.3312 24.3391 32.6452 23.8414 32.2967L19.5617 29.3001Z"
        fill="#FEB932"
      />
      <path
        d="M20.3656 31.1022L19.1038 29.3L14.8013 32.3127C14.3037 32.6611 14.1827 33.3469 14.531 33.8445C14.8794 34.3423 15.5654 34.4633 16.0631 34.1148L20.3656 31.1022Z"
        fill="#FEB932"
      />
      <g filter="url(#filter0_i_43_3485)">
        <path
          d="M31.6333 6.20007H7.1667C5.41778 6.20007 4 7.44425 4 8.97902V25.4211C4 26.9559 5.41778 28.2001 7.1667 28.2001H31.6333C33.3822 28.2001 34.8 26.9559 34.8 25.4211V8.97902C34.8 7.44425 33.3822 6.20007 31.6333 6.20007Z"
          fill="#A8C3FF"
        />
      </g>
      <path
        d="M29.7167 9.5H9.08296C8.09815 9.5 7.2998 10.3467 7.2998 11.3912V23.0088C7.2998 24.0533 8.09815 24.9 9.08296 24.9H29.7167C30.7015 24.9 31.4998 24.0533 31.4998 23.0088V11.3912C31.4998 10.3467 30.7015 9.5 29.7167 9.5Z"
        fill="#3272FE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3817 12.8L22.4574 19.4646L28.0057 13.8367C28.3017 13.5364 28.7817 13.5364 29.0778 13.8367C29.3739 14.137 29.3739 14.6239 29.0778 14.9242L22.4964 21.6L15.4207 14.9355L11.894 18.5128C11.598 18.8131 11.118 18.8131 10.8219 18.5128C10.5258 18.2125 10.5258 17.7256 10.8219 17.4253L15.3817 12.8Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_i_43_3485"
          x="4"
          y="6.20007"
          width="30.8"
          height="22"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.196078 0 0 0 0 0.447059 0 0 0 0 0.996078 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_43_3485"
          />
        </filter>
      </defs>
    </Icon>
  );
};

export const BillingIcon = (props: any) => {
  return (
    <Icon {...props} width="24" height="24" viewBox="0 0 24 24">
      <path
        d="M6.21345 4.982C6.09559 4.982 5.99916 5.07843 5.99916 5.19629V6.482C5.99916 6.59986 6.09559 6.69629 6.21345 6.69629H16.4992C16.617 6.69629 16.7134 6.59986 16.7134 6.482V5.19629C16.7134 5.07843 16.617 4.982 16.4992 4.982H6.21345Z"
        fill="currentColor"
      />
      <path
        d="M11.142 8.83915H6.21345C6.09559 8.83915 5.99916 8.93558 5.99916 9.05343V10.3391C5.99916 10.457 6.09559 10.5534 6.21345 10.5534H11.142C11.2599 10.5534 11.3563 10.457 11.3563 10.3391V9.05343C11.3563 8.93558 11.2599 8.83915 11.142 8.83915Z"
        fill="currentColor"
      />
      <path
        d="M9.85631 21.107H3.85631V2.24986H18.8563V10.8213C18.8563 10.9391 18.9527 11.0356 19.0706 11.0356H20.5706C20.6884 11.0356 20.7849 10.9391 20.7849 10.8213V1.17843C20.7849 0.704325 20.4018 0.321289 19.9277 0.321289H2.78488C2.31077 0.321289 1.92773 0.704325 1.92773 1.17843V22.1784C1.92773 22.6525 2.31077 23.0356 2.78488 23.0356H9.85631C9.97416 23.0356 10.0706 22.9391 10.0706 22.8213V21.3213C10.0706 21.2034 9.97416 21.107 9.85631 21.107Z"
        fill="currentColor"
      />
      <path
        d="M18.0008 14.5879C18.0008 14.1737 17.665 13.8379 17.2508 13.8379C16.8366 13.8379 16.5008 14.1737 16.5008 14.5879V14.8807C16.285 14.9434 16.0737 15.0415 15.8818 15.1869C15.4279 15.5308 15.1883 16.0587 15.1883 16.6879C15.1883 17.0051 15.2627 17.3007 15.4184 17.5614C15.5714 17.8178 15.7789 18.0004 15.9868 18.1327C16.3554 18.3673 16.8125 18.4915 17.1396 18.5804L17.1847 18.5927C17.5774 18.6998 17.8164 18.772 17.972 18.871C18.0348 18.911 18.0528 18.9375 18.0577 18.9457C18.0605 18.9504 18.0758 18.9756 18.0758 19.0504C18.0758 19.2532 18.0044 19.3456 17.9105 19.4114C17.7864 19.4983 17.5668 19.5665 17.2776 19.5561C16.8257 19.5401 16.4405 19.3454 16.2761 19.1258C16.0278 18.7943 15.5578 18.7268 15.2262 18.9751C14.8947 19.2233 14.8272 19.6934 15.0754 20.0249C15.4295 20.4977 15.9568 20.7964 16.5008 20.9446V21.4129C16.5008 21.8271 16.8366 22.1629 17.2508 22.1629C17.665 22.1629 18.0008 21.8271 18.0008 21.4129V20.9801C18.2712 20.9149 18.5349 20.8053 18.7709 20.6401C19.2629 20.2955 19.5758 19.7459 19.5758 19.0504C19.5758 18.7331 19.5013 18.4376 19.3457 18.1769C19.1927 17.9205 18.9852 17.7378 18.7773 17.6055C18.4087 17.371 17.9516 17.2467 17.6245 17.1578L17.5794 17.1456C17.1866 17.0385 16.9477 16.9662 16.7921 16.8673C16.7293 16.8273 16.7112 16.8008 16.7064 16.7926C16.7035 16.7879 16.6883 16.7627 16.6883 16.6879C16.6883 16.5649 16.7103 16.4948 16.727 16.4585C16.7426 16.4246 16.7618 16.4021 16.7876 16.3826C16.848 16.3367 16.9875 16.2807 17.2303 16.2873C17.6529 16.2988 18.0927 16.4905 18.2955 16.6932C18.5883 16.9861 19.0632 16.9861 19.3561 16.6932C19.649 16.4003 19.649 15.9255 19.3561 15.6326C19.0059 15.2824 18.5131 15.0279 18.0008 14.8942V14.5879Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.25 18C11.25 14.6862 13.9362 12 17.25 12C20.5638 12 23.25 14.6862 23.25 18C23.25 21.3138 20.5638 24 17.25 24C13.9362 24 11.25 21.3138 11.25 18ZM17.25 13.5C14.7646 13.5 12.75 15.5146 12.75 18C12.75 20.4854 14.7646 22.5 17.25 22.5C19.7354 22.5 21.75 20.4854 21.75 18C21.75 15.5146 19.7354 13.5 17.25 13.5Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export const DarkTradesEmptyState = (props: any) => {
  const prefix = useMemo(() => uuidv4(), []);

  return (
    <Icon
      {...props}
      $size={212}
      width="212"
      height="212"
      viewBox="0 0 212 212"
      fill="none"
    >
      <path
        d="M105.624 185.763C163.959 185.763 211.248 174.067 211.248 159.641C211.248 145.214 163.959 133.518 105.624 133.518C47.2895 133.518 0 145.214 0 159.641C0 174.067 47.2895 185.763 105.624 185.763Z"
        fill={`url(#${prefix}paint0_linear_3238_243751)`}
      />
      <path
        d="M66.849 72.7122L66.8489 165.618L44.0122 165.618C42.9899 165.618 42.0982 165.988 41.337 166.752C40.5758 167.516 40.206 168.41 40.206 169.436C40.206 170.548 40.554 171.465 41.2717 172.185L79.3331 210.365C80.0508 211.085 80.9643 211.434 82.0735 211.434C83.1827 211.434 84.0962 211.085 84.8139 210.365L122.745 172.294C123.549 171.334 123.941 170.374 123.941 169.436C123.941 168.323 123.593 167.407 122.875 166.687C122.157 165.967 121.244 165.618 120.135 165.618L97.298 165.618L97.298 72.7122C97.298 71.6868 96.9283 70.7923 96.167 70.0287C95.4058 69.2651 94.5141 68.8942 93.4919 68.8942L70.6551 68.8942C69.6329 68.8942 68.7411 69.2651 67.9799 70.0287C67.2187 70.7923 66.849 71.6868 66.849 72.7122Z"
        fill={`url(#${prefix}paint1_linear_3238_243751)`}
      />
      <path
        d="M142.863 138.722L142.863 45.8163L167.657 45.8163C168.767 45.8163 169.735 45.4455 170.562 44.6818C171.388 43.9182 171.789 43.0237 171.789 41.9983C171.789 40.8856 171.412 39.9693 170.632 39.2493L129.309 1.06905C128.529 0.349076 127.538 -1.47063e-05 126.333 -1.47205e-05C125.129 -1.47348e-05 124.137 0.349076 123.358 1.06905L82.1761 39.1403C81.3024 40.1002 80.8773 41.0602 80.8773 41.9983C80.8773 43.111 81.2551 44.0273 82.0344 44.7473C82.8136 45.4672 83.8054 45.8163 85.0097 45.8163L109.804 45.8163L109.804 138.722C109.804 139.747 110.205 140.642 111.032 141.405C111.858 142.169 112.826 142.54 113.936 142.54L138.731 142.54C139.84 142.54 140.809 142.169 141.635 141.405C142.461 140.642 142.863 139.747 142.863 138.722Z"
        fill={`url(#${prefix}paint2_linear_3238_243751)`}
      />
      <defs>
        <linearGradient
          id={`${prefix}paint0_linear_3238_243751`}
          x1="117.5"
          y1="273.608"
          x2="115"
          y2="90.1081"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0CFFF" />
          <stop offset="1" stopColor="#70A8FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint1_linear_3238_243751`}
          x1="148.569"
          y1="186.644"
          x2="37.6303"
          y2="179.353"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8EB5F1" />
          <stop offset="1" stopColor="#5A86CC" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint2_linear_3238_243751`}
          x1="123.5"
          y1="-3.96104"
          x2="89.3029"
          y2="144.023"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#98B9E9" />
          <stop offset="1" stopColor="#77A4EA" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const DarkSignalsEmptyState = (props: any) => {
  return (
    <Icon
      {...props}
      $size={212}
      width="212"
      height="175"
      viewBox="0 0 212 175"
      fill="none"
    >
      <path
        d="M105.624 174.86C163.959 174.86 211.248 163.165 211.248 148.738C211.248 134.311 163.959 122.616 105.624 122.616C47.2895 122.616 0 134.311 0 148.738C0 163.165 47.2895 174.86 105.624 174.86Z"
        fill="url(#paint0_linear_3238_243758)"
      />
      <path
        d="M95.2737 64.4544H115.006L121.931 147.2H87.3998L95.2737 64.4544Z"
        fill="url(#paint1_linear_3238_243758)"
      />
      <path
        d="M72.7904 151.797C72.7904 143.818 79.2588 137.349 87.2381 137.349H122.093C130.072 137.349 136.54 143.818 136.54 151.797H72.7904Z"
        fill="url(#paint2_linear_3238_243758)"
      />
      <ellipse
        cx="104.997"
        cy="44.7529"
        rx="22.2461"
        ry="21.6715"
        fill="url(#paint3_linear_3238_243758)"
      />
      <path
        d="M140.313 18.6316C142.45 17.0185 145.531 17.4155 146.942 19.6825C151.67 27.2781 154.189 36.0542 154.165 45.0367C154.142 54.0245 151.576 62.7929 146.804 70.3677C145.384 72.6203 142.309 72.9971 140.181 71.3741C138.052 69.7499 137.685 66.7399 139.048 64.4511C142.541 58.5839 144.414 51.8781 144.431 45.0123C144.449 38.1495 142.612 31.4373 139.152 25.5546C137.799 23.2541 138.177 20.2443 140.313 18.6316Z"
        fill="url(#paint4_linear_3238_243758)"
      />
      <path
        d="M70.6764 18.6316C68.5394 17.0185 65.4591 17.4155 64.0479 19.6825C59.3196 27.2781 56.8012 36.0542 56.8243 45.0367C56.8473 54.0245 59.4136 62.7929 64.1861 70.3677C65.6054 72.6203 68.6812 72.9971 70.8089 71.3741C72.938 69.7499 73.3045 66.7399 71.9419 64.4511C68.4488 58.5839 66.576 51.8781 66.5584 45.0123C66.5408 38.1495 68.3776 31.4373 71.8376 25.5546C73.1907 23.2541 72.8128 20.2443 70.6764 18.6316Z"
        fill="url(#paint5_linear_3238_243758)"
      />
      <path
        d="M159.083 3.80295C161.546 2.0353 165.014 2.57086 166.615 5.13678C174.093 17.1256 177.905 31.0448 177.524 45.2042C177.142 59.372 172.579 73.0783 164.457 84.6604C162.728 87.1273 159.246 87.4721 156.883 85.5785C154.519 83.683 154.175 80.2644 155.874 77.7724C162.483 68.073 166.193 56.6807 166.51 44.9139C166.827 33.1519 163.739 21.5848 157.666 11.5538C156.101 8.96819 156.622 5.56992 159.083 3.80295Z"
        fill="url(#paint6_linear_3238_243758)"
      />
      <path
        d="M52.5192 3.80295C50.0565 2.0353 46.5882 2.57086 44.9878 5.13678C37.51 17.1256 33.6971 31.0448 34.0788 45.2042C34.4606 59.372 39.0232 73.0783 47.1451 84.6604C48.875 87.1273 52.3569 87.4721 54.7192 85.5785C57.0838 83.683 57.4272 80.2644 55.729 77.7724C49.1191 68.073 45.4093 56.6807 45.0922 44.9139C44.7751 33.1519 47.8633 21.5848 53.9364 11.5538C55.5017 8.96819 54.9809 5.56992 52.5192 3.80295Z"
        fill="url(#paint7_linear_3238_243758)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3238_243758"
          x1="117.5"
          y1="262.705"
          x2="115"
          y2="79.2053"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0CFFF" />
          <stop offset="1" stopColor="#70A8FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3238_243758"
          x1="116.5"
          y1="196.571"
          x2="148.193"
          y2="62.5514"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#72A0E9" />
          <stop offset="1" stopColor="#5A86CC" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3238_243758"
          x1="146.135"
          y1="148.986"
          x2="125.961"
          y2="112.92"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AACCFF" />
          <stop offset="1" stopColor="#75A5F0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3238_243758"
          x1="117.5"
          y1="81.2031"
          x2="122.794"
          y2="28.7575"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5A86CC" />
          <stop offset="1" stopColor="#AACCFE" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3238_243758"
          x1="152.908"
          y1="-40.1025"
          x2="22.6652"
          y2="99.0041"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8EB7F6" />
          <stop offset="1" stopColor="#6DA6FF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_3238_243758"
          x1="58.0814"
          y1="-40.1025"
          x2="188.325"
          y2="99.0041"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8EB7F6" />
          <stop offset="1" stopColor="#6DA6FF" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_3238_243758"
          x1="272.666"
          y1="-185.94"
          x2="27.8832"
          y2="296.663"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7E9FD0" />
          <stop offset="0.567708" stopColor="#A9CCFD" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_3238_243758"
          x1="-61.0637"
          y1="-185.94"
          x2="183.719"
          y2="296.663"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7E9FD0" />
          <stop offset="0.567708" stopColor="#A9CCFD" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const DarkDefaultEmptyState = (props: any) => {
  return (
    <Icon
      {...props}
      $size={212}
      width="212"
      height="145"
      viewBox="0 0 212 145"
      fill="none"
    >
      <path
        d="M105.872 144.86C164.207 144.86 211.496 133.165 211.496 118.738C211.496 104.311 164.207 92.6157 105.872 92.6157C47.5375 92.6157 0.248047 104.311 0.248047 118.738C0.248047 133.165 47.5375 144.86 105.872 144.86Z"
        fill="url(#paint0_linear_3238_243797)"
      />
      <path
        d="M26.248 46.0427L67.3497 0.688965V91.3965H26.248V46.0427Z"
        fill="url(#paint1_linear_3238_243797)"
      />
      <path
        d="M185.957 46.0427L144.856 0.688965V91.3965H185.957V46.0427Z"
        fill="url(#paint2_linear_3238_243797)"
      />
      <rect
        x="67.3496"
        y="0.688965"
        width="77.5059"
        height="88.3817"
        fill="url(#paint3_linear_3238_243797)"
      />
      <path
        d="M70.3911 53.6628C69.2949 49.189 65.2846 46.0427 60.6784 46.0427H26.248V120.469H185.957V46.0427H151.527C146.921 46.0427 142.91 49.189 141.814 53.6628L140.851 57.5931C139.755 62.0669 135.744 65.2132 131.138 65.2132H81.0668C76.4607 65.2132 72.4504 62.0669 71.3542 57.5931L70.3911 53.6628Z"
        fill="url(#paint4_linear_3238_243797)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3238_243797"
          x1="117.748"
          y1="232.705"
          x2="115.248"
          y2="49.2053"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0CFFF" />
          <stop offset="1" stopColor="#70A8FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3238_243797"
          x1="58.5422"
          y1="-5.12563"
          x2="11.5804"
          y2="50.5252"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6793DB" />
          <stop offset="1" stopColor="#436599" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3238_243797"
          x1="141.92"
          y1="-9.77729"
          x2="204.393"
          y2="51.9174"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#628FD6" />
          <stop offset="1" stopColor="#436599" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3238_243797"
          x1="91.252"
          y1="91.7053"
          x2="60.0621"
          y2="1.2153"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5686D4" />
          <stop offset="0.9999" stopColor="#9DBEF0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3238_243797"
          x1="85.252"
          y1="111.205"
          x2="82.459"
          y2="44.7618"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#80ACEA" />
          <stop offset="0.958435" stopColor="#9EBEF0" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const DarkGraphDataEmptyState = (props: any) => {
  return (
    <Icon
      {...props}
      $size={212}
      width="212"
      height="165"
      viewBox="0 0 212 165"
      fill="none"
    >
      <path
        d="M106.12 164.86C164.455 164.86 211.744 153.165 211.744 138.738C211.744 124.311 164.455 112.616 106.12 112.616C47.7856 112.616 0.496094 124.311 0.496094 138.738C0.496094 153.165 47.7856 164.86 106.12 164.86Z"
        fill="url(#paint0_linear_3238_243805)"
      />
      <rect
        x="15.4961"
        y="43.8853"
        width="36.4"
        height="100.707"
        rx="6"
        fill="url(#paint1_linear_3238_243805)"
      />
      <rect
        x="112.563"
        y="43.8853"
        width="36.4"
        height="100.707"
        rx="6"
        fill="url(#paint2_linear_3238_243805)"
      />
      <rect
        x="64.0294"
        y="0.205261"
        width="36.4"
        height="144.387"
        rx="6"
        fill="url(#paint3_linear_3238_243805)"
      />
      <rect
        x="161.096"
        y="18.4053"
        width="36.4"
        height="126.187"
        rx="6"
        fill="url(#paint4_linear_3238_243805)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3238_243805"
          x1="117.996"
          y1="252.705"
          x2="115.496"
          y2="69.2053"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0CFFF" />
          <stop offset="1" stopColor="#70A8FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3238_243805"
          x1="34.5234"
          y1="196.215"
          x2="65.1764"
          y2="43.8476"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#436599" />
          <stop offset="1" stopColor="#C2DBFF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3238_243805"
          x1="131.59"
          y1="196.215"
          x2="162.243"
          y2="43.8476"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#436599" />
          <stop offset="1" stopColor="#C2DBFF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3238_243805"
          x1="81.4241"
          y1="9.30526"
          x2="85.5592"
          y2="202.661"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8CB6F6" />
          <stop offset="1" stopColor="#477BCF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3238_243805"
          x1="178.491"
          y1="26.3582"
          x2="181.649"
          y2="195.359"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8CB6F6" />
          <stop offset="1" stopColor="#477BCF" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const DarkMarketplaceEmptyState = (props: any) => {
  return (
    <Icon
      {...props}
      $size={212}
      width="212"
      height="170"
      viewBox="0 0 212 170"
      fill="none"
    >
      <path
        d="M105.624 169.444C163.959 169.444 211.248 157.748 211.248 143.322C211.248 128.895 163.959 117.2 105.624 117.2C47.2895 117.2 0 128.895 0 143.322C0 157.748 47.2895 169.444 105.624 169.444Z"
        fill="url(#paint0_linear_3238_243878)"
      />
      <path
        d="M36.8572 35.884C36.8572 34.7795 37.7526 33.884 38.8572 33.884H173.143C174.247 33.884 175.143 34.7795 175.143 35.884V138.065C175.143 139.169 174.247 140.065 173.143 140.065H38.8572C37.7526 140.065 36.8572 139.169 36.8572 138.065V35.884Z"
        fill="url(#paint1_linear_3238_243878)"
      />
      <path
        d="M95.3334 0.572327H116.667L122.762 52.6218H89.2382L95.3334 0.572327Z"
        fill="url(#paint2_linear_3238_243878)"
      />
      <path
        d="M116.476 0.572327H139.04L158.381 52.6218H122.923L116.476 0.572327Z"
        fill="url(#paint3_linear_3238_243878)"
      />
      <path
        d="M137.429 0.572327H159.628C160.31 0.572327 160.945 0.920156 161.313 1.49501L194 52.6218H157.395L137.429 0.572327Z"
        fill="url(#paint4_linear_3238_243878)"
      />
      <path
        d="M50.6874 1.49501C51.0549 0.920156 51.6901 0.572327 52.3724 0.572327H74.5714L54.605 52.6218H18L50.6874 1.49501Z"
        fill="url(#paint5_linear_3238_243878)"
      />
      <path
        d="M18 52.6218H53.619V57.714C53.619 67.5499 45.6454 75.5235 35.8095 75.5235C25.9736 75.5235 18 67.5499 18 57.714V52.6218Z"
        fill="url(#paint6_linear_3238_243878)"
      />
      <path
        d="M53.6191 52.6218H89.2382V57.714C89.2382 67.5499 81.2646 75.5235 71.4287 75.5235C61.5927 75.5235 53.6191 67.5499 53.6191 57.714V52.6218Z"
        fill="url(#paint7_linear_3238_243878)"
      />
      <path
        d="M89.2382 52.6218H122.762V58.7616C122.762 68.019 115.257 75.5235 106 75.5235C96.7427 75.5235 89.2382 68.019 89.2382 58.7616V52.6218Z"
        fill="url(#paint8_linear_3238_243878)"
      />
      <path
        d="M122.762 52.6218H158.381V57.714C158.381 67.5499 150.407 75.5235 140.571 75.5235C130.736 75.5235 122.762 67.5499 122.762 57.714V52.6218Z"
        fill="url(#paint9_linear_3238_243878)"
      />
      <path
        d="M158.381 52.6218H194V57.714C194 67.5499 186.026 75.5235 176.191 75.5235C166.355 75.5235 158.381 67.5499 158.381 57.714V52.6218Z"
        fill="url(#paint10_linear_3238_243878)"
      />
      <path
        d="M87.1429 85.8515C87.1429 84.7469 88.0384 83.8515 89.1429 83.8515H124.952C126.057 83.8515 126.952 84.7469 126.952 85.8515V140.065H87.1429V85.8515Z"
        fill="url(#paint11_linear_3238_243878)"
      />
      <path
        d="M128 83.8515L128 88.0155L86.0953 88.0155L86.0953 83.8515L128 83.8515Z"
        fill="#6CA1EE"
      />
      <path
        d="M128 83.8515L123.81 88.0155V140.065H128V83.8515Z"
        fill="#BDD7FF"
      />
      <path
        d="M86.0953 83.8515L90.2858 88.0155V140.065H86.0953V83.8515Z"
        fill="#BDD7FF"
      />
      <path
        d="M72.9598 0.572327H95.5239L89.077 52.6218H53.6191L72.9598 0.572327Z"
        fill="url(#paint12_linear_3238_243878)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3238_243878"
          x1="117.5"
          y1="257.289"
          x2="115"
          y2="73.7891"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0CFFF" />
          <stop offset="1" stopColor="#70A8FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3238_243878"
          x1="138"
          y1="140"
          x2="143.571"
          y2="61.4097"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0001" stopColor="#81AFEF" />
          <stop offset="0.9999" stopColor="#AFCFFD" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3238_243878"
          x1="62.5715"
          y1="26.597"
          x2="154.705"
          y2="24.297"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A3C9FF" />
          <stop offset="1" stopColor="#E1EDFF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3238_243878"
          x1="147.48"
          y1="87.8093"
          x2="132.108"
          y2="-35.5333"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#66A5FF" />
          <stop offset="0.9999" stopColor="#CBE0FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3238_243878"
          x1="91.6723"
          y1="38.7961"
          x2="234.436"
          y2="33.3919"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8FBDFF" />
          <stop offset="1" stopColor="#F3F8FF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_3238_243878"
          x1="8.01681"
          y1="9.51833"
          x2="112.285"
          y2="30.9094"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8ABAFF" />
          <stop offset="1" stopColor="#E7F1FF" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_3238_243878"
          x1="36"
          y1="88.2121"
          x2="57.478"
          y2="23.3577"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B1D0FB" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_3238_243878"
          x1="67.5001"
          y1="82.2705"
          x2="74.0302"
          y2="-11.3579"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5C9FFF" />
          <stop offset="0.9999" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_3238_243878"
          x1="103"
          y1="94.1538"
          x2="118.812"
          y2="34.6871"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B1D0FB" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_3238_243878"
          x1="146.5"
          y1="82.7656"
          x2="141.814"
          y2="21.8952"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5C9FFF" />
          <stop offset="0.9999" stopColor="#D1E4FF" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_3238_243878"
          x1="170.524"
          y1="96.7894"
          x2="200.447"
          y2="40.4938"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B1D0FB" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_3238_243878"
          x1="108.095"
          y1="160.885"
          x2="116.92"
          y2="33.4433"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5F9DF7" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_3238_243878"
          x1="64.9012"
          y1="90.8456"
          x2="112.157"
          y2="-32.0699"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#579CFF" />
          <stop offset="0.9999" stopColor="#D6E7FF" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const DarkCoinsEmptyState = (props: any) => {
  const prefix = useMemo(() => uuidv4(), []);

  return (
    <Icon
      {...props}
      $size={223}
      width="223"
      height="198"
      viewBox="0 0 223 198"
      fill="none"
    >
      <path
        d="M105.624 197.444C163.959 197.444 211.248 185.749 211.248 171.322C211.248 156.895 163.959 145.2 105.624 145.2C47.2895 145.2 0 156.895 0 171.322C0 185.749 47.2895 197.444 105.624 197.444Z"
        fill={`url(#${prefix}paint0_linear_439_179)`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.9385 18.6917C31.5112 28.5244 28.6466 41.3958 28.8727 54.9349C29.0988 68.4741 32.3904 81.1742 38.1409 90.696C44.1074 100.576 52.006 105.888 60.3814 105.655L72.5622 105.317C80.9282 105.084 88.6028 99.3347 94.172 89.1282C99.5213 79.3248 102.343 66.4578 102.116 52.8978C101.89 39.3377 98.6416 26.6396 92.9699 17.1427C87.065 7.25529 79.2057 1.93815 70.8398 2.17084L58.6591 2.50962C50.2836 2.74279 42.5697 8.48946 36.9385 18.6917ZM33.3578 54.8104C33.571 67.5785 36.6369 79.4919 41.9903 88.3564C47.0984 96.8146 53.6034 101.37 60.3068 101.183C66.9723 100.998 73.2328 96.0943 77.9353 87.3756C82.8461 78.271 85.4325 66.194 85.2184 53.3682C85.0042 40.5424 82.0168 28.62 76.8069 19.7969C71.8177 11.3477 65.3991 6.79669 58.7338 6.98208C52.0302 7.16852 45.6835 12.0812 40.8625 20.8156C35.8097 29.9693 33.1446 42.0423 33.3578 54.8104Z"
        fill={`url(#${prefix}paint1_linear_439_179)`}
      />
      <path
        data-figma-bg-blur-radius="1.27803"
        d="M59.0054 2.57302C67.0302 2.36822 75.1308 6.34566 81.1981 15.6295C87.5583 25.3616 91.2192 38.5454 91.4774 52.7598C91.7356 66.9739 88.5566 80.3327 82.5544 90.3823C76.8035 100.011 69.2142 105.326 61.2264 105.53C53.1914 105.735 45.3118 100.807 39.0717 91.4715C32.536 81.6933 28.7788 68.5213 28.5218 54.3743C28.2649 40.2275 31.5393 26.8739 37.7153 16.7695C43.5967 7.14683 50.9452 2.77877 59.0054 2.57302Z"
        stroke={`url(#${prefix}paint2_linear_439_179)`}
      />
      <mask
        id="mask0_439_179"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="30"
        y="5"
        width="56"
        height="99"
      >
        <path
          data-figma-bg-blur-radius="1.27803"
          d="M39.8193 90.1097C34.1682 80.9015 30.9338 68.5241 30.7124 55.2573C30.4909 41.9905 33.3091 29.4445 38.648 19.9307C43.7421 10.8527 50.4462 5.74499 57.5259 5.54799C64.5653 5.35212 71.3426 10.0778 76.6093 18.8547C82.109 28.02 85.2605 40.4067 85.4829 53.7335C85.7053 67.0603 82.9703 79.6104 77.7813 89.0731C72.8124 98.1347 66.1993 103.233 59.1597 103.429C52.0802 103.626 45.2116 98.8959 39.8193 90.1097Z"
          fill="#797BF6"
        />
      </mask>
      <g mask="url(#mask0_439_179)">
        <g filter="url(#filter0_i_439_179)" data-figma-bg-blur-radius="3.44504">
          <path
            d="M33.4132 97.7531C28.3185 85.3809 26.5281 69.3815 28.3723 52.7019C30.2165 36.0224 35.4712 20.687 43.1687 9.52113C50.5133 -1.13322 59.0962 -6.57264 67.3369 -5.79566C75.5306 -5.0231 82.6411 1.8873 87.3583 13.6626C92.2841 25.9591 93.9769 41.9582 92.1244 58.7132C90.2718 75.4682 85.1129 90.8207 77.5973 101.944C70.4004 112.596 61.9245 118.037 53.7306 117.264C45.4902 116.487 38.2746 109.558 33.4132 97.7531Z"
            fill={`url(#${prefix}paint3_linear_439_179)`}
          />
        </g>
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.1574 45.3812C69.0686 44.5537 67.5246 44.4217 65.5254 44.9856C67.8921 42.2451 68.7788 39.3091 68.1864 36.1767C67.9801 35.0362 67.5837 34.167 66.9963 33.568C66.4085 32.969 65.6577 32.6399 64.7414 32.5819C63.8256 32.5229 62.8452 32.6332 61.802 32.9105C60.7586 33.1879 59.5711 33.6249 58.2405 34.2213L57.634 27.3745L53.7763 29.4885L54.366 36.1451C53.698 36.5112 52.6809 37.0875 51.3147 37.8742L50.7202 31.1632L46.8621 33.2775L47.4686 40.1244C46.9189 40.4447 46.1098 40.8977 45.041 41.4834L39.7277 44.3664L40.1224 48.8224L42.903 47.2986C44.1723 46.603 44.9701 46.8117 45.2963 47.9243L45.9871 55.7222C46.1543 55.6305 46.2886 55.5667 46.3905 55.5298L45.9895 55.7496L46.9571 66.6714C46.9054 67.6681 46.4621 68.3957 45.6269 68.8534L42.8466 70.3771L42.5103 75.7749L47.5207 73.0292C47.8381 72.8553 48.2975 72.6083 48.8997 72.2868C49.5017 71.9666 49.9528 71.7241 50.2536 71.5593L50.8673 78.4875L54.7261 76.3729L54.1195 69.5261C54.8225 69.1604 55.842 68.611 57.1781 67.8788L57.7822 74.6981L61.6399 72.5841L61.0261 65.6559C62.3895 64.8329 63.5925 64.032 64.6348 63.2511C65.6777 62.47 66.6649 61.6019 67.5956 60.6452C68.5263 59.6892 69.2892 58.7152 69.8843 57.7243C70.4798 56.7338 70.9465 55.6325 71.2865 54.4204C71.625 53.2091 71.7965 51.9281 71.799 50.578C71.7941 47.9414 71.2464 46.2091 70.1574 45.3812ZM51.8227 42.7238L52.5617 51.0648C52.6454 51.019 52.9335 50.866 53.4272 50.6048C53.9209 50.3437 54.3091 50.131 54.5923 49.9664C54.8753 49.8019 55.2913 49.5546 55.8402 49.2254C56.3891 48.8963 56.8438 48.5947 57.2049 48.3208C57.5657 48.0473 57.9869 47.712 58.4681 47.3153C58.9494 46.9187 59.3399 46.5289 59.6385 46.147C59.9374 45.765 60.2253 45.3506 60.5008 44.9052C60.7762 44.4599 60.9713 43.9872 61.0843 43.4886C61.1975 42.9895 61.2316 42.4863 61.1866 41.9791C61.1337 41.3815 60.9824 40.9089 60.7324 40.5616C60.4831 40.2139 60.1948 39.9729 59.8674 39.839C59.5407 39.7047 59.1177 39.6705 58.5978 39.7372C58.0787 39.8032 57.6058 39.9056 57.1804 40.044C56.7549 40.1823 56.235 40.3911 55.6206 40.6708C55.006 40.9506 54.5196 41.1934 54.1613 41.3992C53.803 41.6051 53.3531 41.861 52.8109 42.168C52.2693 42.4743 51.9399 42.6596 51.8227 42.7238ZM63.4796 56.8741C63.7027 56.4288 63.8748 55.9544 63.997 55.4504C64.119 54.9464 64.1574 54.4418 64.1125 53.934C64.0547 53.2818 63.8781 52.7707 63.5822 52.4012C63.2868 52.0311 62.9412 51.7844 62.5448 51.6591C62.1483 51.5345 61.6434 51.5216 61.0307 51.6202C60.4172 51.7186 59.8559 51.8509 59.3454 52.0165C58.8343 52.1826 58.2091 52.4401 57.4699 52.7886C56.7299 53.1367 56.1511 53.4259 55.7336 53.6546C55.3161 53.8835 54.7785 54.1869 54.1202 54.5669C53.462 54.9469 53.0661 55.1732 52.9326 55.2463L53.7462 64.4301C53.8799 64.3568 54.189 64.1922 54.6744 63.9351C55.1595 63.6785 55.5608 63.4638 55.8782 63.2898C56.1954 63.116 56.637 62.8595 57.2023 62.5218C57.7679 62.1831 58.2531 61.8795 58.658 61.6099C59.0636 61.3399 59.5325 61.0027 60.0663 60.5961C60.5989 60.1899 61.0514 59.8097 61.4228 59.4536C61.7938 59.0983 62.174 58.6909 62.562 58.231C62.9502 57.7717 63.2561 57.3189 63.4796 56.8741Z"
        fill={`url(#${prefix}paint4_linear_439_179)`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M140.72 56.2103C127.711 62.3822 115.056 73.5819 105.086 87.7469C95.1163 101.912 88.9409 117.466 87.6974 131.543C86.4071 146.149 90.5516 157.456 99.3673 163.379L112.188 171.994C120.994 177.911 133.244 177.615 146.681 171.161C159.587 164.962 172.194 153.735 182.18 139.548C192.165 125.362 198.383 109.842 199.69 95.8481C201.049 81.2792 196.949 69.9971 188.143 64.0804L175.322 55.4656C166.506 49.5423 154.218 49.8065 140.72 56.2103ZM109.807 90.9192C100.405 104.277 94.5895 118.852 93.4317 131.957C92.3271 144.462 95.6047 153.959 102.66 158.7C109.676 163.414 119.83 162.952 131.252 157.399C143.179 151.6 154.949 141.016 164.393 127.598C173.838 114.179 179.741 99.6534 181.015 86.6963C182.236 74.2884 179.044 64.8588 172.029 60.1447C164.973 55.4037 154.723 55.8119 143.168 61.2943C131.057 67.0398 119.209 77.561 109.807 90.9192Z"
        fill={`url(#${prefix}paint5_linear_439_179)`}
      />
      <path
        data-figma-bg-blur-radius="1.27803"
        d="M176.574 56.133C185.047 61.8615 189.43 72.6991 188.78 86.7783C188.102 101.476 182.045 117.708 171.695 132.473C161.345 147.237 148.068 158.588 134.328 164.457C121.165 170.08 109.289 169.927 100.814 164.198C92.2896 158.435 87.8003 147.511 88.3068 133.311C88.8377 118.437 94.7881 102.147 105.089 87.4511C115.39 72.7557 128.763 61.4811 142.724 55.6845C156.052 50.1505 168.047 50.3689 176.574 56.133Z"
        stroke={`url(#${prefix}paint6_linear_439_179)`}
      />
      <mask
        id="mask1_439_179"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="89"
        y="54"
        width="93"
        height="110"
      >
        <path
          data-figma-bg-blur-radius="1.27803"
          d="M89.8674 132.094C90.9563 118.415 96.9272 103.246 106.681 89.3798C116.435 75.5141 128.787 64.6347 141.462 58.7463C153.557 53.1276 164.328 52.797 171.792 57.8154C179.214 62.8051 182.662 72.6849 181.5 85.6345C180.287 99.1572 174.223 114.275 164.426 128.204C154.628 142.132 142.358 153.077 129.876 159.023C117.923 164.717 107.253 165.105 99.8313 160.115C92.3673 155.097 88.8286 145.146 89.8674 132.094Z"
          fill="#797BF6"
        />
      </mask>
      <g mask="url(#mask1_439_179)">
        <g filter="url(#filter1_i_439_179)" data-figma-bg-blur-radius="3.44504">
          <path
            d="M82.1238 126.59C86.5826 110.706 97.032 93.7492 111.548 78.8421C126.063 63.935 142.883 52.887 158.909 47.7339C174.201 42.8167 186.726 43.9155 194.177 50.8278C201.586 57.7006 203.259 69.757 198.887 84.7758C194.321 100.459 183.776 117.343 169.195 132.318C154.614 147.292 137.874 158.428 122.058 163.676C106.913 168.701 94.4913 167.684 87.0819 160.811C79.6305 153.898 77.8695 141.745 82.1238 126.59Z"
            fill={`url(#${prefix}paint7_linear_439_179)`}
          />
        </g>
      </g>
      <path
        d="M145.66 84.2582L151.527 75.4108L158.458 80.007L152.591 88.8544L145.66 84.2582ZM106.596 143.165L112.564 134.167L119.495 138.763L113.527 147.762L106.596 143.165ZM114.703 139.069C111.87 137.19 109.959 134.762 108.972 131.785C107.984 128.807 107.92 125.462 108.78 121.75C109.639 118.037 111.423 114.139 114.13 110.056L121.365 114.853C119.058 118.332 117.826 121.362 117.668 123.943C117.545 126.546 118.562 128.563 120.72 129.995C122.44 131.136 124.174 131.487 125.921 131.049C127.736 130.583 129.345 129.291 130.749 127.173C131.752 125.661 132.217 124.228 132.144 122.873C132.072 121.518 131.646 120.183 130.867 118.868C130.155 117.525 129.292 116.154 128.277 114.756C127.296 113.379 126.365 111.891 125.484 110.29C124.603 108.69 123.956 106.955 123.545 105.085C123.168 103.238 123.243 101.184 123.772 98.9214C124.335 96.6088 125.552 94.0409 127.424 91.2178C129.363 88.2939 131.624 86.0191 134.208 84.3935C136.858 82.7398 139.596 81.8698 142.421 81.7836C145.246 81.6973 147.957 82.5152 150.554 84.2374C152.949 85.8254 154.69 87.9598 155.777 90.6405C156.898 93.3436 157.23 96.3945 156.773 99.7931C156.316 103.192 154.901 106.753 152.528 110.478L145.142 105.58C146.311 103.743 146.994 102.018 147.189 100.405C147.418 98.8154 147.278 97.4159 146.768 96.207C146.326 94.9702 145.582 94.005 144.537 93.3117C143.019 92.3052 141.403 91.9958 139.689 92.3835C138.009 92.7936 136.517 93.9816 135.213 95.9477C134.277 97.3593 133.862 98.7172 133.969 100.022C134.075 101.326 134.501 102.624 135.246 103.917C136.058 105.182 136.972 106.513 137.987 107.912C139.035 109.26 139.983 110.724 140.83 112.302C141.744 113.852 142.357 115.601 142.668 117.549C143.046 119.469 142.92 121.635 142.291 124.049C141.661 126.462 140.344 129.181 138.338 132.206C136.299 135.281 133.92 137.623 131.202 139.232C128.484 140.841 125.696 141.641 122.836 141.632C119.977 141.623 117.266 140.769 114.703 139.069Z"
        fill={`url(#${prefix}paint8_linear_439_179)`}
      />
      <defs>
        <clipPath id="bgblur_0_439_179_clip_path" transform="translate(0 0)">
          <path d="M59.0054 2.57302C67.0302 2.36822 75.1308 6.34566 81.1981 15.6295C87.5583 25.3616 91.2192 38.5454 91.4774 52.7598C91.7356 66.9739 88.5566 80.3327 82.5544 90.3823C76.8035 100.011 69.2142 105.326 61.2264 105.53C53.1914 105.735 45.3118 100.807 39.0717 91.4715C32.536 81.6933 28.7788 68.5213 28.5218 54.3743C28.2649 40.2275 31.5393 26.8739 37.7153 16.7695C43.5967 7.14683 50.9452 2.77877 59.0054 2.57302Z" />
        </clipPath>
        <clipPath id="bgblur_1_439_179_clip_path" transform="translate(0 0)">
          <path d="M39.8193 90.1097C34.1682 80.9015 30.9338 68.5241 30.7124 55.2573C30.4909 41.9905 33.3091 29.4445 38.648 19.9307C43.7421 10.8527 50.4462 5.74499 57.5259 5.54799C64.5653 5.35212 71.3426 10.0778 76.6093 18.8547C82.109 28.02 85.2605 40.4067 85.4829 53.7335C85.7053 67.0603 82.9703 79.6104 77.7813 89.0731C72.8124 98.1347 66.1993 103.233 59.1597 103.429C52.0802 103.626 45.2116 98.8959 39.8193 90.1097Z" />
        </clipPath>
        <filter
          id="filter0_i_439_179"
          x="24.2199"
          y="-9.31369"
          width="72.0812"
          height="130.173"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.52284" />
          <feGaussianBlur stdDeviation="23.4856" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.560784 0 0 0 0 0.607843 0 0 0 0 1 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_439_179"
          />
        </filter>
        <clipPath
          id="bgblur_2_439_179_clip_path"
          transform="translate(-24.2199 9.31369)"
        >
          <path d="M33.4132 97.7531C28.3185 85.3809 26.5281 69.3815 28.3723 52.7019C30.2165 36.0224 35.4712 20.687 43.1687 9.52113C50.5133 -1.13322 59.0962 -6.57264 67.3369 -5.79566C75.5306 -5.0231 82.6411 1.8873 87.3583 13.6626C92.2841 25.9591 93.9769 41.9582 92.1244 58.7132C90.2718 75.4682 85.1129 90.8207 77.5973 101.944C70.4004 112.596 61.9245 118.037 53.7306 117.264C45.4902 116.487 38.2746 109.558 33.4132 97.7531Z" />
        </clipPath>
        <clipPath
          id="bgblur_3_439_179_clip_path"
          transform="translate(-24.2199 9.31369)"
        >
          <path d="M176.574 56.133C185.047 61.8615 189.43 72.6991 188.78 86.7783C188.102 101.476 182.045 117.708 171.695 132.473C161.345 147.237 148.068 158.588 134.328 164.457C121.165 170.08 109.289 169.927 100.814 164.198C92.2896 158.435 87.8003 147.511 88.3068 133.311C88.8377 118.437 94.7881 102.147 105.089 87.4511C115.39 72.7557 128.763 61.4811 142.724 55.6845C156.052 50.1505 168.047 50.3689 176.574 56.133Z" />
        </clipPath>
        <clipPath
          id="bgblur_4_439_179_clip_path"
          transform="translate(-24.2199 9.31369)"
        >
          <path d="M89.8674 132.094C90.9563 118.415 96.9272 103.246 106.681 89.3798C116.435 75.5141 128.787 64.6347 141.462 58.7463C153.557 53.1276 164.328 52.797 171.792 57.8154C179.214 62.8051 182.662 72.6849 181.5 85.6345C180.287 99.1572 174.223 114.275 164.426 128.204C154.628 142.132 142.358 153.077 129.876 159.023C117.923 164.717 107.253 165.105 99.8313 160.115C92.3673 155.097 88.8286 145.146 89.8674 132.094Z" />
        </clipPath>
        <filter
          id="filter1_i_439_179"
          x="76.4076"
          y="41.2605"
          width="128.311"
          height="129.086"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.52284" />
          <feGaussianBlur stdDeviation="23.4856" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.560784 0 0 0 0 0.607843 0 0 0 0 1 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_439_179"
          />
        </filter>
        <clipPath
          id="bgblur_5_439_179_clip_path"
          transform="translate(-76.4076 -41.2605)"
        >
          <path d="M82.1238 126.59C86.5826 110.706 97.032 93.7492 111.548 78.8421C126.063 63.935 142.883 52.887 158.909 47.7339C174.201 42.8167 186.726 43.9155 194.177 50.8278C201.586 57.7006 203.259 69.757 198.887 84.7758C194.321 100.459 183.776 117.343 169.195 132.318C154.614 147.292 137.874 158.428 122.058 163.676C106.913 168.701 94.4913 167.684 87.0819 160.811C79.6305 153.898 77.8695 141.745 82.1238 126.59Z" />
        </clipPath>
        <linearGradient
          id={`${prefix}paint0_linear_439_179`}
          x1="117.5"
          y1="285.289"
          x2="115"
          y2="101.789"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0CFFF" />
          <stop offset="1" stopColor="#70A8FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint1_linear_439_179`}
          x1="58.4919"
          y1="-5.87005"
          x2="130.495"
          y2="38.6927"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#98BDF6" />
          <stop offset="1" stopColor="#4079CF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint2_linear_439_179`}
          x1="85.5"
          y1="83.4999"
          x2="-0.405558"
          y2="52.1133"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#82AEEB" />
          <stop offset="0.9999" stopColor="#BFD7F7" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint3_linear_439_179`}
          x1="112.5"
          y1="34.9999"
          x2="29.5665"
          y2="44.0824"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint4_linear_439_179`}
          x1="51"
          y1="10"
          x2="85.4208"
          y2="44.2601"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#71A9FF" />
          <stop offset="1" stopColor="#5B87CD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint5_linear_439_179`}
          x1="194"
          y1="75.4994"
          x2="209.389"
          y2="169.476"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8AB2EF" />
          <stop offset="1" stopColor="#3E73C5" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint6_linear_439_179`}
          x1="154.5"
          y1="152.999"
          x2="55.3407"
          y2="59.9347"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#81ADEA" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint7_linear_439_179`}
          x1="209.5"
          y1="62.9994"
          x2="76.5797"
          y2="80.0068"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0CCF2" />
          <stop offset="1" stopColor="#E0EAFA" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint8_linear_439_179`}
          x1="153.5"
          y1="95.9996"
          x2="102.058"
          y2="102.997"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70A8FF" />
          <stop offset="1" stopColor="#5A86CC" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const DarkWideCoinsEmptyState = (props: any) => {
  return (
    <Icon
      {...props}
      $size={356}
      width="356"
      height="176"
      viewBox="0 0 356 176"
      fill="none"
    >
      <path
        d="M178 162.359C276.307 162.359 356 150.664 356 136.237C356 121.81 276.307 110.115 178 110.115C79.6933 110.115 0 121.81 0 136.237C0 150.664 79.6933 162.359 178 162.359Z"
        fill="url(#paint0_linear_3251_96678)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.492 96.8818C100.697 93.0273 91.7583 90.9086 82.3212 90.9163C72.8842 90.9239 63.9995 93.0571 57.3036 96.9225C50.356 100.933 46.5706 106.328 46.6444 112.112L46.7519 120.525C46.8257 126.303 50.7509 131.664 57.8044 135.621C64.5794 139.421 73.5158 141.51 82.9674 141.502C92.419 141.495 101.302 139.391 107.98 135.58C114.932 131.612 118.72 126.245 118.646 120.467L118.539 112.054C118.465 106.269 114.542 100.881 107.492 96.8818ZM82.3607 94.014C73.4611 94.0212 65.127 96.0071 58.8933 99.6056C52.9454 103.039 49.7024 107.48 49.7615 112.11C49.8203 116.713 53.1713 121.089 59.1972 124.431C65.4898 127.921 73.8782 129.839 82.818 129.832C91.7578 129.824 100.097 127.893 106.301 124.393C112.241 121.041 115.48 116.66 115.421 112.057C115.362 107.427 112.006 102.991 105.97 99.5675C99.645 95.979 91.2602 94.0068 82.3607 94.014Z"
        fill="url(#paint1_linear_3251_96678)"
      />
      <ellipse
        cx="82.5701"
        cy="111.907"
        rx="33.2666"
        ry="18.1568"
        transform="rotate(0.586894 82.5701 111.907)"
        fill="#C7DFFF"
      />
      <foreignObject x="0" y="0" width="0" height="0"></foreignObject>
      <path
        data-figma-bg-blur-radius="1.27803"
        d="M108.611 97.4099L108.611 97.4099C115.306 101.581 118.92 106.921 118.979 112.408C119.037 117.858 115.545 123.136 108.953 127.233C102.074 131.507 92.7976 133.889 82.8259 133.911C72.8544 133.932 63.5271 131.59 56.5556 127.344C49.8731 123.275 46.2675 118.008 46.2096 112.556C46.1513 107.072 49.6497 101.719 56.2527 97.5214C63.1658 93.1268 72.4345 90.6789 82.358 90.6575C92.2813 90.6361 101.603 93.0437 108.611 97.4099Z"
        stroke="url(#paint2_linear_3251_96678)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M88.5415 119.52C89.13 118.777 89.2386 117.713 88.867 116.327C90.7517 117.99 92.7884 118.634 94.978 118.259C95.7751 118.129 96.3852 117.865 96.809 117.466C97.2328 117.067 97.4702 116.553 97.5205 115.921C97.5715 115.289 97.5051 114.611 97.3231 113.888C97.1409 113.165 96.8491 112.341 96.4477 111.416L101.226 111.072L99.7944 108.386L95.1486 108.721C94.9006 108.256 94.5098 107.548 93.9762 106.596L98.6599 106.259L97.2278 103.573L92.4492 103.917C92.2319 103.534 91.9248 102.971 91.5281 102.227L89.5758 98.5285L86.4659 98.7526L87.4981 100.688C87.9692 101.572 87.8152 102.12 87.0363 102.333L81.5939 102.725C81.656 102.842 81.699 102.935 81.7237 103.006L81.5748 102.727L73.9522 103.276C73.2581 103.23 72.7557 102.916 72.4457 102.334L71.4137 100.399L67.6551 100.108L69.515 103.596C69.6328 103.817 69.8 104.137 70.0175 104.556C70.2343 104.975 70.3984 105.289 70.5101 105.498L65.6747 105.847L67.1071 108.533L71.8856 108.189C72.1329 108.678 72.5049 109.387 73.0008 110.317L68.2415 110.66L69.6735 113.346L74.5088 112.998C75.0678 113.947 75.613 114.786 76.1461 115.514C76.6793 116.243 77.2737 116.933 77.9305 117.586C78.5868 118.239 79.2575 118.776 79.9417 119.197C80.6256 119.619 81.3882 119.953 82.2293 120.201C83.0699 120.448 83.9609 120.58 84.9019 120.597C86.7396 120.622 87.9528 120.263 88.5415 119.52ZM90.5907 106.894L84.7693 107.314C84.8004 107.372 84.9039 107.573 85.0806 107.916C85.2573 108.26 85.4014 108.53 85.5131 108.727C85.6247 108.924 85.7926 109.214 86.0161 109.597C86.2396 109.979 86.4449 110.296 86.6319 110.548C86.8187 110.8 87.0478 111.095 87.3192 111.431C87.5904 111.768 87.8579 112.041 88.1208 112.252C88.3839 112.462 88.6696 112.665 88.9771 112.86C89.2845 113.055 89.6118 113.195 89.9582 113.278C90.3048 113.362 90.6551 113.391 91.0091 113.365C91.4262 113.335 91.7572 113.236 92.0019 113.067C92.2469 112.899 92.418 112.702 92.5149 112.478C92.612 112.254 92.6404 111.962 92.5995 111.603C92.559 111.244 92.4928 110.916 92.4009 110.621C92.3091 110.326 92.1691 109.965 91.9808 109.538C91.7923 109.111 91.6284 108.772 91.4888 108.523C91.3491 108.273 91.1756 107.96 90.9675 107.582C90.7598 107.205 90.6342 106.976 90.5907 106.894ZM80.6031 114.786C80.9111 114.945 81.2399 115.069 81.5898 115.159C81.9398 115.248 82.2911 115.28 82.6454 115.255C83.1006 115.222 83.4588 115.106 83.7195 114.906C83.9806 114.706 84.1563 114.47 84.2478 114.198C84.3389 113.925 84.3533 113.577 84.2913 113.153C84.2292 112.729 84.1431 112.34 84.0332 111.985C83.9229 111.631 83.7501 111.197 83.5152 110.683C83.2805 110.168 83.0852 109.766 82.9302 109.475C82.7752 109.184 82.5695 108.81 82.3117 108.351C82.0539 107.893 81.9005 107.617 81.851 107.524L75.4414 107.986C75.491 108.079 75.6024 108.294 75.7764 108.632C75.95 108.97 76.0954 109.249 76.2132 109.47C76.3309 109.691 76.5049 109.999 76.7342 110.392C76.9642 110.786 77.1707 111.125 77.3542 111.407C77.538 111.69 77.768 112.017 78.0456 112.39C78.323 112.762 78.5831 113.078 78.8274 113.339C79.071 113.599 79.3509 113.865 79.6672 114.138C79.9832 114.411 80.2955 114.627 80.6031 114.786Z"
        fill="url(#paint3_linear_3251_96678)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M275.775 91.841C268.8 87.1602 259.384 84.168 249.264 83.4158C239.143 82.6637 229.444 84.2353 221.952 87.841C214.179 91.5822 209.685 97.0621 209.298 103.271L208.735 112.301C208.349 118.503 212.126 124.569 219.371 129.38C226.33 134.001 235.745 136.961 245.881 137.715C256.017 138.468 265.712 136.928 273.18 133.379C280.955 129.684 285.45 124.233 285.837 118.031L286.399 109.001C286.786 102.792 283.013 96.6978 275.775 91.841ZM249.057 86.7408C239.513 86.0315 230.415 87.4897 223.441 90.8464C216.786 94.0493 212.95 98.5501 212.641 103.52C212.333 108.461 215.574 113.423 221.766 117.493C228.233 121.742 237.074 124.475 246.661 125.187C256.249 125.9 265.347 124.5 272.281 121.247C278.922 118.131 282.748 113.694 283.056 108.753C283.366 103.783 280.124 98.7564 273.927 94.5984C267.433 90.2406 258.601 87.4501 249.057 86.7408Z"
        fill="url(#paint4_linear_3251_96678)"
      />
      <ellipse
        cx="248.063"
        cy="106.201"
        rx="36.084"
        ry="19.1836"
        transform="rotate(4.3815 248.063 106.201)"
        fill="#C7DFFF"
      />
      <foreignObject x="0" y="0" width="0" height="0"></foreignObject>
      <path
        data-figma-bg-blur-radius="1.27803"
        d="M276.955 92.468L276.955 92.468C283.804 97.4843 287.26 103.514 286.88 109.42C286.502 115.286 282.32 120.675 274.914 124.54C267.185 128.573 257.039 130.381 246.338 129.6C235.638 128.82 225.817 125.555 218.677 120.436C211.833 115.529 208.38 109.579 208.758 103.711C209.138 97.807 213.333 92.3391 220.759 88.3662C228.534 84.2066 238.678 82.3276 249.327 83.1046C259.976 83.8816 269.785 87.2163 276.955 92.468Z"
        stroke="url(#paint5_linear_3251_96678)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M277.133 72.1787C270.157 67.4978 260.742 64.5056 250.621 63.7535C240.501 63.0013 230.801 64.573 223.31 68.1787C215.536 71.9198 211.042 77.3998 210.655 83.6088L210.093 92.639C209.706 98.8411 213.484 104.906 220.729 109.718C227.688 114.339 237.103 117.299 247.239 118.052C257.375 118.805 267.07 117.266 274.538 113.717C282.313 110.022 286.808 104.571 287.194 98.3689L287.757 89.3388C288.143 83.1297 284.371 77.0354 277.133 72.1787ZM250.414 67.0785C240.87 66.3692 231.773 67.8273 224.798 71.184C218.143 74.387 214.308 78.8878 213.998 83.8573C213.69 88.7987 216.931 93.761 223.124 97.8303C229.591 102.08 238.432 104.812 248.019 105.525C257.606 106.237 266.705 104.838 273.639 101.584C280.279 98.4689 284.106 94.0317 284.414 89.0904C284.723 84.1207 281.481 79.0941 275.285 74.9361C268.791 70.5783 259.958 67.7878 250.414 67.0785Z"
        fill="url(#paint6_linear_3251_96678)"
      />
      <foreignObject x="0" y="0" width="0" height="0"></foreignObject>
      <path
        data-figma-bg-blur-radius="1.27803"
        d="M278.313 72.8057L278.313 72.8057C285.162 77.822 288.618 83.8514 288.237 89.7573C287.859 95.6237 283.678 101.013 276.271 104.878C268.543 108.911 258.396 110.719 247.696 109.938C236.995 109.157 227.175 105.893 220.034 100.773C213.19 95.8663 209.737 89.9171 210.115 84.0484C210.496 78.1447 214.691 72.6769 222.116 68.7039C229.891 64.5443 240.035 62.6653 250.684 63.4423C261.333 64.2193 271.142 67.554 278.313 72.8057Z"
        stroke="url(#paint7_linear_3251_96678)"
      />
      <ellipse
        cx="249.86"
        cy="86.4443"
        rx="36.04"
        ry="20.0205"
        transform="rotate(2.74381 249.86 86.4443)"
        fill="#C7DFFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M277.703 48.3017C270.727 43.6208 261.312 40.6287 251.191 39.8765C241.071 39.1244 231.371 40.696 223.879 44.3017C216.106 48.0429 211.612 53.5228 211.225 59.7319L210.663 68.762C210.276 74.9641 214.054 81.0295 221.299 85.8407C228.258 90.4619 237.672 93.422 247.809 94.1753C257.945 94.9285 267.64 93.3887 275.108 89.8396C282.883 86.1446 287.378 80.694 287.764 74.492L288.327 65.4619C288.713 59.2528 284.94 53.1585 277.703 48.3017ZM250.984 43.2015C241.44 42.4922 232.343 43.9504 225.368 47.3071C218.713 50.51 214.878 55.0108 214.568 59.9803C214.26 64.9218 217.501 69.8841 223.694 73.9534C230.16 78.2029 239.001 80.9355 248.589 81.648C258.176 82.3605 267.275 80.961 274.209 77.7075C280.849 74.5919 284.676 70.1547 284.983 65.2134C285.293 60.2438 282.051 55.2171 275.855 51.0591C269.361 46.7013 260.528 43.9108 250.984 43.2015Z"
        fill="url(#paint8_linear_3251_96678)"
      />
      <foreignObject x="0" y="0" width="0" height="0"></foreignObject>
      <path
        data-figma-bg-blur-radius="1.27803"
        d="M278.883 48.9287L278.883 48.9287C285.732 53.945 289.188 59.9744 288.808 65.8802C288.43 71.7467 284.248 77.1356 276.841 81.0009C269.113 85.034 258.967 86.8419 248.266 86.0611C237.566 85.2804 227.745 82.0158 220.605 76.8962C213.761 71.9893 210.308 66.0401 210.686 60.1714C211.066 54.2677 215.261 48.7998 222.687 44.8269C230.462 40.6673 240.606 38.7883 251.255 39.5653C261.903 40.3423 271.713 43.677 278.883 48.9287Z"
        stroke="url(#paint9_linear_3251_96678)"
      />
      <ellipse
        cx="249.842"
        cy="62.4242"
        rx="35.3329"
        ry="19.3293"
        transform="rotate(4.3815 249.842 62.4242)"
        fill="#C7DFFF"
      />
      <path
        d="M267.448 58.7792L273.627 59.0966L273.378 63.9372L267.199 63.6199L267.448 58.7792ZM226.306 56.666L232.591 56.9888L232.343 61.8295L226.058 61.5067L226.306 56.666ZM230.767 59.5167C230.869 57.538 231.52 55.8591 232.72 54.4801C233.921 53.1011 235.579 52.0763 237.697 51.4056C239.814 50.735 242.299 50.4729 245.15 50.6194L244.891 55.6721C242.462 55.5473 240.576 55.8283 239.235 56.5152C237.892 57.2256 237.182 58.3346 237.105 59.8422C237.043 61.0435 237.381 62.0174 238.119 62.7639C238.892 63.5357 240.017 63.9596 241.496 64.0355C242.552 64.0898 243.409 63.8976 244.067 63.4591C244.725 63.0205 245.268 62.4107 245.697 61.6297C246.159 60.8741 246.591 60.0342 246.991 59.1101C247.391 58.2095 247.861 57.3007 248.402 56.3838C248.943 55.4669 249.622 54.6279 250.438 53.8668C251.252 53.1293 252.305 52.5575 253.597 52.1515C254.924 51.7473 256.573 51.5958 258.545 51.6971C260.587 51.802 262.399 52.2611 263.981 53.0745C265.597 53.9133 266.846 55.0285 267.728 56.42C268.61 57.8115 269.004 59.4141 268.911 61.2279C268.825 62.9003 268.271 64.407 267.249 65.748C266.226 67.1125 264.794 68.1844 262.953 68.9638C261.113 69.7431 258.906 70.0903 256.334 70.0054L256.599 64.8467C257.867 64.8883 258.935 64.7187 259.802 64.3381C260.668 63.9811 261.328 63.4954 261.783 62.8811C262.272 62.2922 262.536 61.6326 262.573 60.9024C262.628 59.8424 262.303 58.94 261.6 58.1954C260.896 57.4743 259.857 57.0785 258.484 57.008C257.498 56.9573 256.694 57.1522 256.071 57.5926C255.448 58.0329 254.923 58.6318 254.496 59.3893C254.103 60.1721 253.706 61.0256 253.306 61.9497C252.94 62.8756 252.488 63.7853 251.948 64.6786C251.441 65.5974 250.746 66.4237 249.861 67.1576C249.01 67.9169 247.886 68.4969 246.489 68.8974C245.091 69.298 243.336 69.4441 241.224 69.3356C239.076 69.2252 237.195 68.7271 235.582 67.8412C233.968 66.9554 232.739 65.794 231.895 64.3572C231.051 62.9204 230.675 61.3069 230.767 59.5167Z"
        fill="url(#paint10_linear_3251_96678)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M177.214 63.4518C170.577 69.0981 164.939 77.6553 161.339 87.5473C157.739 97.4393 156.578 107.565 158.068 116.06C159.615 124.873 163.821 130.903 169.911 133.037L178.767 136.141C184.85 138.272 191.969 136.209 198.812 130.33C205.385 124.684 210.99 116.118 214.596 106.21C218.201 96.3032 219.393 86.1907 217.952 77.7359C216.452 68.9335 212.276 62.9118 206.193 60.7801L197.336 57.6763C191.246 55.5423 184.1 57.5933 177.214 63.4518ZM164.6 88.6903C161.205 98.0189 160.1 107.512 161.488 115.42C162.812 122.965 166.226 128.061 171.1 129.769C175.946 131.468 181.813 129.629 187.619 124.592C193.682 119.333 198.898 111.276 202.309 101.905C205.719 92.5342 206.883 83.0567 205.587 75.2181C204.346 67.7117 200.994 62.6424 196.147 60.944C191.273 59.2359 185.342 61.0573 179.446 66.0729C173.268 71.3292 167.995 79.3617 164.6 88.6903Z"
        fill="url(#paint11_linear_3251_96678)"
      />
      <ellipse
        cx="183.491"
        cy="95.2345"
        rx="19.9762"
        ry="36.8352"
        transform="rotate(20.1707 183.491 95.2345)"
        fill="#C7DFFF"
      />
      <foreignObject x="0" y="0" width="0" height="0"></foreignObject>
      <path
        data-figma-bg-blur-radius="1.27803"
        d="M178.16 62.4353L178.16 62.4353C185.099 57.0075 192.098 55.251 197.895 57.2965C203.654 59.3284 207.86 65.0271 209.634 73.5133C211.486 82.3684 210.434 93.0106 206.641 103.476C202.848 113.941 196.823 122.83 189.698 128.52C182.87 133.973 175.952 135.75 170.191 133.717C164.396 131.672 160.115 125.938 158.238 117.402C156.273 108.465 157.254 97.8056 161.028 87.3904C164.803 76.9754 170.895 68.1178 178.16 62.4353Z"
        stroke="url(#paint12_linear_3251_96678)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M194.69 92.9643C194.137 92.0639 193.063 91.5432 191.469 91.4026C193.932 90.0636 195.386 88.1754 195.83 85.7377C195.998 84.8526 195.955 84.1124 195.699 83.5157C195.443 82.919 194.994 82.4735 194.351 82.1792C193.709 81.8844 192.973 81.6947 192.146 81.6091C191.319 81.5235 190.343 81.5141 189.221 81.5811L190.687 76.442L187.325 76.9158L185.9 81.9121C185.318 81.9942 184.426 82.1329 183.225 82.3283L184.662 77.2912L181.3 77.7651L179.834 82.9042C179.35 82.9855 178.642 83.0919 177.711 83.2232L173.088 83.855L172.134 87.1995L174.557 86.858C175.663 86.7021 176.179 87.0732 176.105 87.9709L174.435 93.8238C174.581 93.8033 174.695 93.7939 174.778 93.7951L174.429 93.8444L172.09 102.042C171.776 102.752 171.255 103.158 170.527 103.261L168.105 103.602L166.363 107.43L170.729 106.814C171.006 106.775 171.405 106.722 171.927 106.655C172.449 106.588 172.841 106.536 173.103 106.499L171.619 111.699L174.982 111.225L176.448 106.086C177.055 106.014 177.941 105.895 179.105 105.731L177.645 110.85L181.007 110.376L182.49 105.176C183.699 104.953 184.787 104.702 185.753 104.422C186.72 104.142 187.672 103.783 188.607 103.344C189.542 102.906 190.361 102.409 191.064 101.853C191.768 101.297 192.409 100.626 192.99 99.8393C193.571 99.0528 194.05 98.1697 194.427 97.1899C195.156 95.2739 195.243 93.8652 194.69 92.9643ZM182.243 85.9899L180.457 92.2505C180.53 92.2403 180.78 92.2085 181.207 92.1547C181.635 92.1008 181.973 92.0532 182.222 92.0116C182.472 91.97 182.84 91.9048 183.326 91.8168C183.812 91.7288 184.223 91.6349 184.558 91.5354C184.894 91.436 185.29 91.3084 185.746 91.1527C186.203 90.9971 186.592 90.8215 186.913 90.6263C187.234 90.4311 187.556 90.2094 187.878 89.9617C188.199 89.7141 188.471 89.4246 188.691 89.0935C188.911 88.7622 189.075 88.4062 189.184 88.0255C189.312 87.5769 189.334 87.1921 189.251 86.8712C189.168 86.55 189.028 86.2957 188.83 86.1083C188.632 85.9209 188.337 85.7797 187.945 85.6851C187.553 85.5902 187.185 85.5345 186.84 85.5179C186.496 85.5013 186.064 85.5099 185.545 85.5439C185.025 85.5781 184.608 85.6206 184.293 85.6714C183.978 85.7223 183.583 85.7844 183.108 85.8581C182.633 85.9316 182.345 85.9755 182.243 85.9899ZM186.694 99.4733C186.979 99.2112 187.234 98.9141 187.462 98.5817C187.69 98.2492 187.858 97.8933 187.966 97.5123C188.106 97.0227 188.121 96.6029 188.011 96.2532C187.901 95.9032 187.721 95.6289 187.471 95.4289C187.221 95.2293 186.861 95.081 186.393 94.984C185.925 94.8867 185.484 94.8283 185.071 94.8081C184.657 94.7881 184.136 94.8031 183.508 94.8528C182.879 94.902 182.382 94.9527 182.018 95.004C181.655 95.0553 181.184 95.1278 180.605 95.2226C180.026 95.3175 179.678 95.3728 179.562 95.3892L177.595 102.282C177.712 102.266 177.98 102.231 178.4 102.178C178.821 102.125 179.169 102.08 179.445 102.041C179.722 102.002 180.111 101.937 180.611 101.848C181.112 101.757 181.545 101.67 181.911 101.586C182.278 101.501 182.709 101.385 183.206 101.237C183.702 101.089 184.133 100.937 184.499 100.781C184.864 100.625 185.251 100.433 185.658 100.206C186.064 99.9794 186.41 99.7348 186.694 99.4733Z"
        fill="url(#paint13_linear_3251_96678)"
      />
      <defs>
        <clipPath id="bgblur_0_3251_96678_clip_path" transform="translate(0 0)">
          <path d="M108.611 97.4099L108.611 97.4099C115.306 101.581 118.92 106.921 118.979 112.408C119.037 117.858 115.545 123.136 108.953 127.233C102.074 131.507 92.7976 133.889 82.8259 133.911C72.8544 133.932 63.5271 131.59 56.5556 127.344C49.8731 123.275 46.2675 118.008 46.2096 112.556C46.1513 107.072 49.6497 101.719 56.2527 97.5214C63.1658 93.1268 72.4345 90.6789 82.358 90.6575C92.2813 90.6361 101.603 93.0437 108.611 97.4099Z" />
        </clipPath>
        <clipPath id="bgblur_1_3251_96678_clip_path" transform="translate(0 0)">
          <path d="M276.955 92.468L276.955 92.468C283.804 97.4843 287.26 103.514 286.88 109.42C286.502 115.286 282.32 120.675 274.914 124.54C267.185 128.573 257.039 130.381 246.338 129.6C235.638 128.82 225.817 125.555 218.677 120.436C211.833 115.529 208.38 109.579 208.758 103.711C209.138 97.807 213.333 92.3391 220.759 88.3662C228.534 84.2066 238.678 82.3276 249.327 83.1046C259.976 83.8816 269.785 87.2163 276.955 92.468Z" />
        </clipPath>
        <clipPath id="bgblur_2_3251_96678_clip_path" transform="translate(0 0)">
          <path d="M278.313 72.8057L278.313 72.8057C285.162 77.822 288.618 83.8514 288.237 89.7573C287.859 95.6237 283.678 101.013 276.271 104.878C268.543 108.911 258.396 110.719 247.696 109.938C236.995 109.157 227.175 105.893 220.034 100.773C213.19 95.8663 209.737 89.9171 210.115 84.0484C210.496 78.1447 214.691 72.6769 222.116 68.7039C229.891 64.5443 240.035 62.6653 250.684 63.4423C261.333 64.2193 271.142 67.554 278.313 72.8057Z" />
        </clipPath>
        <clipPath id="bgblur_3_3251_96678_clip_path" transform="translate(0 0)">
          <path d="M278.883 48.9287L278.883 48.9287C285.732 53.945 289.188 59.9744 288.808 65.8802C288.43 71.7467 284.248 77.1356 276.841 81.0009C269.113 85.034 258.967 86.8419 248.266 86.0611C237.566 85.2804 227.745 82.0158 220.605 76.8962C213.761 71.9893 210.308 66.0401 210.686 60.1714C211.066 54.2677 215.261 48.7998 222.687 44.8269C230.462 40.6673 240.606 38.7883 251.255 39.5653C261.903 40.3423 271.713 43.677 278.883 48.9287Z" />
        </clipPath>
        <clipPath id="bgblur_4_3251_96678_clip_path" transform="translate(0 0)">
          <path d="M178.16 62.4353L178.16 62.4353C185.099 57.0075 192.098 55.251 197.895 57.2965C203.654 59.3284 207.86 65.0271 209.634 73.5133C211.486 82.3684 210.434 93.0106 206.641 103.476C202.848 113.941 196.823 122.83 189.698 128.52C182.87 133.973 175.952 135.75 170.191 133.717C164.396 131.672 160.115 125.938 158.238 117.402C156.273 108.465 157.254 97.8056 161.028 87.3904C164.803 76.9754 170.895 68.1178 178.16 62.4353Z" />
        </clipPath>
        <linearGradient
          id="paint0_linear_3251_96678"
          x1="198.014"
          y1="250.204"
          x2="196.53"
          y2="66.6824"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0CFFF" />
          <stop offset="1" stopColor="#70A8FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3251_96678"
          x1="118.472"
          y1="106.862"
          x2="102.272"
          y2="148.936"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A8CAFF" />
          <stop offset="1" stopColor="#4A82DE" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3251_96678"
          x1="73.0001"
          y1="115.5"
          x2="103.441"
          y2="43.3548"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#85B7FF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3251_96678"
          x1="154.281"
          y1="99.1457"
          x2="101.141"
          y2="145.415"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#4386EF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3251_96678"
          x1="286.746"
          y1="103.428"
          x2="265.983"
          y2="147.241"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0CEFD" />
          <stop offset="1" stopColor="#4D8EF5" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_3251_96678"
          x1="184.983"
          y1="148.497"
          x2="217.821"
          y2="65.4959"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#69A5FC" />
          <stop offset="0.9999" stopColor="#BDD8FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_3251_96678"
          x1="288.104"
          y1="83.7654"
          x2="267.341"
          y2="127.579"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0CEFD" />
          <stop offset="1" stopColor="#4D8EF5" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_3251_96678"
          x1="186.34"
          y1="128.835"
          x2="219.178"
          y2="45.8336"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#69A5FC" />
          <stop offset="0.9999" stopColor="#BDD8FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_3251_96678"
          x1="288.674"
          y1="59.8885"
          x2="267.911"
          y2="103.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0CEFD" />
          <stop offset="1" stopColor="#4D8EF5" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_3251_96678"
          x1="186.91"
          y1="104.958"
          x2="219.749"
          y2="21.9566"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#69A5FC" />
          <stop offset="0.9999" stopColor="#BDD8FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_3251_96678"
          x1="258.074"
          y1="70.2011"
          x2="243.577"
          y2="47.8307"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#639DF8" />
          <stop offset="1" stopColor="#4188F6" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_3251_96678"
          x1="191.87"
          y1="55.7607"
          x2="229.765"
          y2="88.8234"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0CEFD" />
          <stop offset="1" stopColor="#4D8EF5" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_3251_96678"
          x1="208.216"
          y1="170.043"
          x2="134.597"
          y2="113.894"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#69A5FC" />
          <stop offset="0.9999" stopColor="#BDD8FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_3251_96678"
          x1="198.473"
          y1="16.2862"
          x2="226.643"
          y2="89.6621"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B2CEFB" />
          <stop offset="1" stopColor="#448BF8" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const DarkPayoutMethodsEmptyState = (props: any) => {
  return (
    <Icon
      {...props}
      $size={212}
      width="212"
      height="186"
      viewBox="0 0 212 186"
      fill="none"
    >
      <path
        d="M105.624 185.821C163.959 185.821 211.248 174.126 211.248 159.699C211.248 145.272 163.959 133.577 105.624 133.577C47.2895 133.577 0 145.272 0 159.699C0 174.126 47.2895 185.821 105.624 185.821Z"
        fill="url(#paint0_linear_3238_243775)"
      />
      <path
        d="M155.977 81.5975C158.374 81.5975 160.371 79.8796 160.871 77.5566C161.37 75.3347 161.27 73.011 160.671 70.8901L149.486 26.8477L131.267 26.0605L146.99 17.0497L145.692 12.1C143.464 3.53947 134.757 -0.828032 127.518 1.29157L21.0818 29.0704C13.0192 31.161 8.1615 39.6462 10.397 47.4549L11.5953 52.3032L30.9154 52.7854L14.0917 62.1019L25.3637 106.245C27.1611 113.013 33.2521 117.558 39.8427 117.558C42.9286 117.558 44.4152 116.85 46.3338 116.448C48.531 115.842 50.1284 113.821 50.1284 111.497V86.6482C50.1284 83.8195 52.3249 81.5975 55.1213 81.5975H155.977ZM154.979 127.054H95.064C100.574 127.054 105.05 122.521 105.05 116.952V96.7496C105.05 91.181 100.574 86.6482 95.064 86.6482H65.1067C59.5969 86.6482 55.1209 91.181 55.1209 96.7496V116.952C55.1209 122.521 59.5969 127.054 65.1067 127.054C59.5969 127.054 55.1209 131.587 55.1209 137.155C55.1209 142.724 59.5969 147.256 65.1067 147.256H154.979C160.488 147.256 164.964 142.724 164.964 137.155C164.964 131.587 160.488 127.054 154.979 127.054ZM144.993 86.6482C139.483 86.6482 135.007 91.181 135.007 96.7496C135.007 102.318 139.483 106.851 144.993 106.851H154.979C160.488 106.851 164.964 102.318 164.964 96.7496C164.964 91.181 160.488 86.6482 154.979 86.6482H144.993Z"
        fill="url(#paint1_linear_3238_243775)"
        fillOpacity="0.9"
      />
      <path
        d="M146.886 17.9963L12.0066 53.0028L14.4935 62.7328L149.373 27.7257L146.886 17.9963ZM165.123 72.0613H55.3667C47.1386 72.0613 40.4451 78.8106 40.4451 87.1072V147.291C40.4451 155.588 47.1386 162.337 55.3667 162.337H165.123C173.351 162.337 180.045 155.588 180.045 147.291V87.1072C180.045 78.8106 173.351 72.0613 165.123 72.0613ZM60.3406 97.1378C60.3406 94.3657 62.5652 92.1225 65.3144 92.1225H95.1576C97.9068 92.1225 100.131 94.3657 100.131 97.1378V117.199C100.131 119.971 97.9068 122.214 95.1576 122.214H65.3144C62.5652 122.214 60.3406 119.971 60.3406 117.199V97.1378ZM154.844 142.276H65.3144C62.5652 142.276 60.3406 140.032 60.3406 137.26C60.3406 134.488 62.5652 132.245 65.3144 132.245H154.844C157.593 132.245 159.818 134.488 159.818 137.26C159.818 140.032 157.593 142.276 154.844 142.276ZM154.844 102.153H144.896C142.147 102.153 139.922 99.91 139.922 97.1378C139.922 94.3657 142.147 92.1225 144.896 92.1225H154.844C157.593 92.1225 159.818 94.3657 159.818 97.1378C159.818 99.91 157.593 102.153 154.844 102.153Z"
        fill="url(#paint2_linear_3238_243775)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3238_243775"
          x1="117.5"
          y1="273.667"
          x2="115"
          y2="90.1667"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0CFFF" />
          <stop offset="1" stopColor="#70A8FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3238_243775"
          x1="144.5"
          y1="-17.5"
          x2="63.4305"
          y2="174.161"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADCDFF" />
          <stop offset="1" stopColor="#6697E6" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3238_243775"
          x1="127"
          y1="224.5"
          x2="91.624"
          y2="-11.0266"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#87B8FF" />
          <stop offset="1" stopColor="white" />
          <stop offset="1" stopColor="#EAF2FF" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const DarkConnectEmptyState = (props: any) => {
  return (
    <Icon
      {...props}
      $size={309}
      width="309"
      height="188"
      viewBox="0 0 309 188"
      fill="none"
    >
      <path
        d="M148.624 180.411C206.959 180.411 254.248 168.716 254.248 154.289C254.248 139.862 206.959 128.167 148.624 128.167C90.2895 128.167 43 139.862 43 154.289C43 168.716 90.2895 180.411 148.624 180.411Z"
        fill="url(#paint0_linear_3238_243847)"
      />
      <rect
        x="299.139"
        y="84"
        width="17.7441"
        height="70.8911"
        rx="8.87206"
        transform="rotate(90 299.139 84)"
        fill="url(#paint1_linear_3238_243847)"
      />
      <path
        d="M198.087 137.134H229.514C240.051 137.134 248.599 117.996 248.599 94.3806C248.599 70.7653 240.051 51.6196 229.514 51.6196H198.087C204.607 51.6196 210.362 58.9428 213.8 70.1501C216.056 77.6738 217.21 85.9898 217.168 94.4103C217.21 102.828 216.056 111.142 213.8 118.663C210.362 129.811 204.607 137.134 198.087 137.134Z"
        fill="url(#paint2_linear_3238_243847)"
      />
      <path
        d="M225.577 67.9112C220.814 55.2875 212.851 47.0218 203.835 47.0218H195.099C180.52 47.0218 168.698 68.6388 168.698 95.2962C168.698 121.954 180.52 143.563 195.099 143.571H203.835C212.851 143.571 220.825 135.32 225.577 122.681C228.691 114.186 230.285 104.8 230.23 95.2962C230.285 85.7924 228.691 76.4064 225.577 67.9112Z"
        fill="url(#paint3_linear_3238_243847)"
      />
      <path
        d="M212.239 68.634C207.935 56.1519 200.742 47.9717 192.586 47.942C179.391 47.942 168.698 69.3696 168.698 95.7603C168.698 122.151 179.391 143.549 192.586 143.571C200.742 143.571 207.935 135.398 212.239 122.887C215.06 114.472 216.504 105.174 216.454 95.7603C216.504 86.3463 215.06 77.049 212.239 68.634Z"
        fill="url(#paint4_linear_3238_243847)"
      />
      <path
        d="M195.45 83.3182C195.448 83.319 195.446 83.3206 195.444 83.3227C194.172 85.4752 192.042 86.8843 189.632 86.8843H187.302C183.403 86.8843 180.241 83.1953 180.241 78.646C180.241 74.0967 183.403 70.4089 187.302 70.4077H189.639C192.051 70.4077 194.184 71.8157 195.454 73.9726C196.272 75.4264 196.697 77.0248 196.697 78.6447C196.697 80.2634 196.273 81.8605 195.456 83.3134C195.454 83.3156 195.452 83.3173 195.45 83.3182Z"
        fill="url(#paint5_linear_3238_243847)"
      />
      <path
        d="M195.45 115.004C195.448 115.005 195.446 115.007 195.444 115.009C194.172 117.161 192.042 118.571 189.632 118.571H187.302C183.403 118.571 180.241 114.882 180.241 110.332C180.241 105.783 183.403 102.095 187.302 102.094H189.639C192.051 102.094 194.184 103.502 195.454 105.659C196.272 107.113 196.697 108.711 196.697 110.331C196.697 111.95 196.273 113.547 195.456 115C195.454 115.002 195.452 115.004 195.45 115.004Z"
        fill="url(#paint6_linear_3238_243847)"
      />
      <path
        d="M191.782 83.3194C190.642 85.4699 188.734 86.8792 186.573 86.8843C183.075 86.8843 180.241 83.1927 180.241 78.646C180.241 74.0993 183.075 70.4128 186.573 70.4077C188.734 70.4077 190.642 71.8157 191.782 73.9726C192.517 75.4262 192.9 77.0246 192.9 78.6447C192.9 80.2648 192.517 81.8633 191.782 83.3169V83.3194Z"
        fill="#6895DC"
      />
      <path
        d="M191.782 115.006C190.642 117.156 188.734 118.565 186.573 118.571C183.075 118.571 180.241 114.879 180.241 110.332C180.241 105.786 183.075 102.099 186.573 102.094C188.734 102.094 190.642 103.502 191.782 105.659C192.517 107.112 192.9 108.711 192.9 110.331C192.9 111.951 192.517 113.55 191.782 115.003V115.006Z"
        fill="#6895DC"
      />
      <rect
        x="150.682"
        y="72.9435"
        width="39.2433"
        height="11.4069"
        rx="5.70347"
        fill="url(#paint7_linear_3238_243847)"
      />
      <rect
        x="151.125"
        y="104.629"
        width="39.2433"
        height="11.4069"
        rx="5.70347"
        fill="url(#paint8_linear_3238_243847)"
      />
      <rect
        x="73.0945"
        y="84"
        width="18.2652"
        height="72.9728"
        rx="9.13258"
        transform="rotate(90 73.0945 84)"
        fill="url(#paint9_linear_3238_243847)"
      />
      <path
        d="M106.88 136.479H74.5308C63.6839 136.479 54.8845 116.779 54.8845 92.4698C54.8845 68.1611 63.6839 48.4531 74.5308 48.4531L106.88 48.4531C100.169 48.4531 94.2453 55.9914 90.7055 67.5278C88.384 75.2724 87.1955 83.8326 87.2385 92.5003C87.1954 101.166 88.3838 109.724 90.7055 117.465C94.2453 128.941 100.169 136.479 106.88 136.479Z"
        fill="url(#paint10_linear_3238_243847)"
      />
      <path
        d="M78.5832 65.2236C83.4858 52.2293 91.6831 43.7208 100.964 43.7208L109.956 43.7208C124.963 43.7208 137.132 65.9726 137.132 93.4128C137.132 120.853 124.963 143.097 109.956 143.105H100.964C91.6831 143.105 83.4745 134.612 78.5832 121.602C75.3779 112.857 73.7363 103.196 73.7934 93.4128C73.7363 83.6299 75.3779 73.9683 78.5832 65.2236Z"
        fill="url(#paint11_linear_3238_243847)"
      />
      <path
        d="M92.3122 65.9672C96.7426 53.1185 104.147 44.6981 112.543 44.6675C126.125 44.6675 137.132 66.7243 137.132 93.89C137.132 121.056 126.125 143.082 112.543 143.105C104.147 143.105 96.7426 134.692 92.3122 121.813C89.409 113.151 87.9221 103.581 87.9738 93.89C87.9221 84.1995 89.409 74.6292 92.3122 65.9672Z"
        fill="url(#paint12_linear_3238_243847)"
      />
      <path
        d="M113.498 83.4737C117.152 83.4737 120.115 79.4479 120.115 74.4818C120.115 69.5157 117.152 65.4899 113.498 65.4899C109.843 65.4899 106.88 69.5157 106.88 74.4818C106.88 79.4479 109.843 83.4737 113.498 83.4737Z"
        fill="#6895DC"
      />
      <path
        d="M113.498 121.335C117.152 121.335 120.115 117.309 120.115 112.343C120.115 107.377 117.152 103.351 113.498 103.351C109.843 103.351 106.88 107.377 106.88 112.343C106.88 117.309 109.843 121.335 113.498 121.335Z"
        fill="#6895DC"
      />
      <path
        d="M113.025 81.5808C115.897 81.5808 118.225 78.1907 118.225 74.0087C118.225 69.8267 115.897 66.4366 113.025 66.4366C110.153 66.4366 107.826 69.8267 107.826 74.0087C107.826 78.1907 110.153 81.5808 113.025 81.5808Z"
        fill="url(#paint13_linear_3238_243847)"
      />
      <path
        d="M113.025 119.442C115.897 119.442 118.225 116.051 118.225 111.869C118.225 107.688 115.897 104.297 113.025 104.297C110.153 104.297 107.826 107.688 107.826 111.869C107.826 116.051 110.153 119.442 113.025 119.442Z"
        fill="url(#paint14_linear_3238_243847)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3238_243847"
          x1="160.5"
          y1="268.256"
          x2="158"
          y2="84.7563"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0CFFF" />
          <stop offset="1" stopColor="#70A8FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3238_243847"
          x1="328.023"
          y1="100.139"
          x2="268.203"
          y2="109.429"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6290D9" />
          <stop offset="1" stopColor="#99BBEF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3238_243847"
          x1="203"
          y1="153.167"
          x2="276.867"
          y2="111.096"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#81ADEA" />
          <stop offset="1" stopColor="#BFD9FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3238_243847"
          x1="168.698"
          y1="77.5109"
          x2="214.545"
          y2="130.53"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#99BBEF" />
          <stop offset="1" stopColor="#6390DA" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3238_243847"
          x1="158.653"
          y1="137.301"
          x2="272.575"
          y2="108.844"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AACCFE" />
          <stop offset="1" stopColor="#EBF3FF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_3238_243847"
          x1="196.697"
          y1="81.6812"
          x2="190.008"
          y2="69.5583"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9FBFF0" />
          <stop offset="1" stopColor="#6593DB" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_3238_243847"
          x1="196.697"
          y1="113.367"
          x2="190.008"
          y2="101.245"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9FBFF0" />
          <stop offset="1" stopColor="#6593DB" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_3238_243847"
          x1="189.925"
          y1="76.5457"
          x2="188.215"
          y2="87.2198"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D5E7FF" />
          <stop offset="1" stopColor="#769FE1" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_3238_243847"
          x1="190.368"
          y1="108.231"
          x2="188.658"
          y2="118.906"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D5E7FF" />
          <stop offset="1" stopColor="#769FE1" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_3238_243847"
          x1="116.825"
          y1="86.3935"
          x2="44.028"
          y2="94.0269"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6391DA" />
          <stop offset="1" stopColor="#9ABCEF" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_3238_243847"
          x1="107"
          y1="156.667"
          x2="13.0075"
          y2="117.426"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6F9BDF" />
          <stop offset="0.9999" stopColor="#CDE1FF" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_3238_243847"
          x1="137.132"
          y1="75.1052"
          x2="89.9388"
          y2="129.681"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9ABCEF" />
          <stop offset="1" stopColor="#608FD9" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_3238_243847"
          x1="147.472"
          y1="136.651"
          x2="30.2051"
          y2="107.358"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9FBFF0" />
          <stop offset="1" stopColor="#D8E4F6" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_3238_243847"
          x1="118.225"
          y1="71.219"
          x2="111.13"
          y2="80.0594"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#567EBE" />
          <stop offset="1" stopColor="#99BBEF" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_3238_243847"
          x1="118.225"
          y1="109.08"
          x2="111.13"
          y2="117.92"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#567EBE" />
          <stop offset="1" stopColor="#99BBEF" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const DarkFileSearchEmptyState = (props: any) => {
  return (
    <Icon
      {...props}
      $size={229}
      width="229"
      height="199"
      viewBox="0 0 229 199"
      fill="none"
    >
      <path
        d="M113.624 197.821C171.959 197.821 219.248 186.126 219.248 171.699C219.248 157.272 171.959 145.577 113.624 145.577C55.2895 145.577 8 157.272 8 171.699C8 186.126 55.2895 197.821 113.624 197.821Z"
        fill="url(#paint0_linear_3238_243778)"
      />
      <path
        d="M154.807 39.3559L156.368 146.656C156.391 148.126 156.127 149.587 155.592 150.953C155.057 152.32 154.261 153.567 153.249 154.621C152.237 155.675 151.03 156.517 149.696 157.098C148.363 157.679 146.929 157.988 145.477 158.007L48.9506 159.475C46.0147 159.517 43.182 158.378 41.0744 156.308C38.9668 154.238 37.7565 151.405 37.7093 148.431L35.9074 24.4044C35.8673 21.4372 36.9917 18.5752 39.0336 16.447C41.0756 14.3188 43.868 13.0984 46.7977 13.0537L127.014 11.8553L154.807 39.3559Z"
        fill="url(#paint1_linear_3238_243778)"
      />
      <g filter="url(#filter0_f_3238_243778)">
        <path
          d="M169.002 58.6145L150.77 157.652C150.522 159.009 150.018 160.299 149.287 161.448C148.557 162.597 141.101 144.232 140 144.997C138.899 145.762 126.804 154.233 125.5 154.497C124.196 154.761 102.807 157.929 101.5 157.652L51.9923 147.651C49.3488 147.095 47.0142 145.473 45.5009 143.14C43.9877 140.808 43.4195 137.956 43.9212 135.211L64.9971 20.735C65.504 17.9969 67.0371 15.592 69.2596 14.0482C71.4821 12.5044 74.2123 11.9481 76.8506 12.5015L149.083 27.674L169.002 58.6145Z"
          fill="url(#paint2_linear_3238_243778)"
          fillOpacity="0.6"
        />
      </g>
      <path
        d="M181.895 48.9493L161.434 154.241C161.156 155.684 160.599 157.058 159.795 158.282C158.991 159.507 157.957 160.559 156.751 161.377C155.546 162.196 154.192 162.766 152.768 163.054C151.345 163.342 149.879 163.343 148.455 163.056L53.7291 144.204C50.8483 143.629 48.3107 141.919 46.6732 139.451C45.0358 136.983 44.4324 133.957 44.9954 131.039L68.6478 9.33299C69.2166 6.42199 70.903 3.85866 73.3365 2.20595C75.7701 0.553239 78.7518 -0.0537191 81.6269 0.518402L160.343 16.2059L181.895 48.9493Z"
        fill="url(#paint3_linear_3238_243778)"
      />
      <path
        d="M181.894 48.9488L155.012 43.5986L160.316 16.2104L181.894 48.9488Z"
        fill="url(#paint4_linear_3238_243778)"
      />
      <path
        d="M160.386 144.748L164.545 149.216L164.155 149.758C163.375 150.706 163.375 152.195 164.155 153.143L186.246 179.409C187.156 180.492 188.196 181.439 189.495 182.116C190.795 182.793 192.094 183.2 193.524 182.793C195.083 182.387 196.513 181.304 196.642 179.002C196.772 177.378 196.253 175.888 195.213 174.67L172.991 146.915C171.952 145.696 170.392 145.425 169.353 146.238L164.935 140.687C164.935 140.416 161.556 141.634 160.386 144.748Z"
        fill="url(#paint5_linear_3238_243778)"
      />
      <foreignObject
        x="105.622"
        y="80.7597"
        width="71.0554"
        height="73.0246"
      ></foreignObject>
      <g
        opacity="0.6"
        filter="url(#filter1_i_3238_243778)"
        data-figma-bg-blur-radius="2"
      >
        <path
          d="M141.149 151.784C159.666 151.784 174.677 136.333 174.677 117.272C174.677 98.2114 159.666 82.7597 141.149 82.7597C122.633 82.7597 107.622 98.2114 107.622 117.272C107.622 136.333 122.633 151.784 141.149 151.784Z"
          fill="url(#paint6_radial_3238_243778)"
          fillOpacity="0.33"
        />
      </g>
      <rect
        opacity="0.9"
        width="60.2312"
        height="61.0531"
        rx="25.117"
        transform="matrix(0.953634 0.30097 -0.294091 0.955777 122.289 79.2028)"
        fill="url(#paint7_linear_3238_243778)"
        fillOpacity="0.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M141.15 87.6664C124.768 87.6664 111.487 100.921 111.487 117.272C111.487 133.622 124.768 146.877 141.15 146.877C157.531 146.877 170.812 133.622 170.812 117.272C170.812 100.921 157.531 87.6664 141.15 87.6664ZM103.225 117.272C103.225 96.3665 120.204 79.4196 141.15 79.4196C162.095 79.4196 179.074 96.3666 179.074 117.272C179.074 138.177 162.095 155.124 141.15 155.124C120.204 155.124 103.225 138.177 103.225 117.272Z"
        fill="url(#paint8_linear_3238_243778)"
      />
      <defs>
        <filter
          id="filter0_f_3238_243778"
          x="36.7432"
          y="5.2926"
          width="139.259"
          height="163.207"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="3.5"
            result="effect1_foregroundBlur_3238_243778"
          />
        </filter>
        <filter
          id="filter1_i_3238_243778"
          x="105.622"
          y="80.7597"
          width="71.0554"
          height="73.0246"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.85204" />
          <feGaussianBlur stdDeviation="11.5753" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.560784 0 0 0 0 0.607843 0 0 0 0 1 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_3238_243778"
          />
        </filter>
        <clipPath
          id="bgblur_0_3238_243778_clip_path"
          transform="translate(-105.622 -80.7597)"
        >
          <path d="M141.149 151.784C159.666 151.784 174.677 136.333 174.677 117.272C174.677 98.2114 159.666 82.7597 141.149 82.7597C122.633 82.7597 107.622 98.2114 107.622 117.272C107.622 136.333 122.633 151.784 141.149 151.784Z" />
        </clipPath>
        <linearGradient
          id="paint0_linear_3238_243778"
          x1="125.5"
          y1="285.667"
          x2="123"
          y2="102.167"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0CFFF" />
          <stop offset="1" stopColor="#70A8FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3238_243778"
          x1="51.5"
          y1="163"
          x2="210.94"
          y2="-151.684"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#83AEEB" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3238_243778"
          x1="158"
          y1="-24.5"
          x2="72.8894"
          y2="129.516"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.781197" stopColor="#B3D2FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3238_243778"
          x1="59"
          y1="120"
          x2="224.771"
          y2="13.705"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D6E7FF" />
          <stop offset="1" stopColor="#ABCEFF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3238_243778"
          x1="162.5"
          y1="38.9969"
          x2="193.909"
          y2="19.8478"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E3EEFE" />
          <stop offset="1" stopColor="#ABCCFF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_3238_243778"
          x1="196.662"
          y1="154.01"
          x2="178.194"
          y2="182.743"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#1C66D9" />
        </linearGradient>
        <radialGradient
          id="paint6_radial_3238_243778"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(141.149 117.272) rotate(90) scale(34.5123 33.5277)"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#EEF5FF" />
        </radialGradient>
        <linearGradient
          id="paint7_linear_3238_243778"
          x1="30.1156"
          y1="0"
          x2="30.1156"
          y2="61.0531"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.58" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_3238_243778"
          x1="165.883"
          y1="57.1536"
          x2="154.773"
          y2="156.645"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#558EE7" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const DarkSearchEmptyState = (props: any) => {
  return (
    <Icon
      {...props}
      $size={212}
      width="212"
      height="183"
      viewBox="0 0 212 183"
      fill="none"
    >
      <path
        d="M105.624 182.821C163.959 182.821 211.248 171.126 211.248 156.699C211.248 142.272 163.959 130.577 105.624 130.577C47.2895 130.577 0 142.272 0 156.699C0 171.126 47.2895 182.821 105.624 182.821Z"
        fill="url(#paint0_linear_3251_96677)"
      />
      <g filter="url(#filter0_i_3251_96677)">
        <path
          d="M105.19 94.8177L111.024 101.086L110.477 101.845C109.384 103.175 109.384 105.264 110.477 106.594L141.469 143.442C142.745 144.961 144.204 146.291 146.027 147.24C147.85 148.19 149.673 148.76 151.678 148.19C153.866 147.62 155.871 146.101 156.054 142.872C156.236 140.593 155.507 138.503 154.048 136.794L122.874 97.8567C121.415 96.1473 119.228 95.7674 117.77 96.907L111.571 89.1196C111.571 88.7397 106.831 90.4492 105.19 94.8177Z"
          fill="url(#paint1_linear_3251_96677)"
        />
      </g>
      <foreignObject
        x="26.1683"
        y="2.85522"
        width="104.07"
        height="106.833"
      ></foreignObject>
      <g
        opacity="0.7"
        filter="url(#filter1_i_3251_96677)"
        data-figma-bg-blur-radius="5"
      >
        <path
          d="M78.2036 104.688C104.18 104.688 125.239 83.0113 125.239 56.2717C125.239 29.532 104.18 7.85522 78.2036 7.85522C52.2267 7.85522 31.1683 29.532 31.1683 56.2717C31.1683 83.0113 52.2267 104.688 78.2036 104.688Z"
          fill="url(#paint2_radial_3251_96677)"
          fillOpacity="0.33"
        />
      </g>
      <rect
        width="89.19"
        height="88.1105"
        rx="41"
        transform="matrix(0.953634 0.30097 -0.294091 0.955777 49.5887 0.754272)"
        fill="url(#paint3_linear_3251_96677)"
      />
      <g filter="url(#filter2_i_3251_96677)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M78.2037 14.7387C55.2219 14.7387 36.5914 33.3335 36.5914 56.2713C36.5914 79.2092 55.2219 97.804 78.2037 97.804C101.186 97.804 119.816 79.2092 119.816 56.2713C119.816 33.3335 101.186 14.7387 78.2037 14.7387ZM24.9999 56.2713C24.9999 26.944 48.8201 3.16943 78.2037 3.16943C107.587 3.16943 131.407 26.944 131.407 56.2713C131.407 85.5987 107.587 109.373 78.2037 109.373C48.8201 109.373 24.9999 85.5987 24.9999 56.2713Z"
          fill="url(#paint4_linear_3251_96677)"
        />
      </g>
      <defs>
        <filter
          id="filter0_i_3251_96677"
          x="105.19"
          y="86.0682"
          width="50.8906"
          height="62.3492"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-3" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_3251_96677"
          />
        </filter>
        <filter
          id="filter1_i_3251_96677"
          x="26.1683"
          y="2.85522"
          width="104.07"
          height="106.833"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.85204" />
          <feGaussianBlur stdDeviation="11.5753" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.560784 0 0 0 0 0.607843 0 0 0 0 1 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_3251_96677"
          />
        </filter>
        <clipPath
          id="bgblur_0_3251_96677_clip_path"
          transform="translate(-26.1683 -2.85522)"
        >
          <path d="M78.2036 104.688C104.18 104.688 125.239 83.0113 125.239 56.2717C125.239 29.532 104.18 7.85522 78.2036 7.85522C52.2267 7.85522 31.1683 29.532 31.1683 56.2717C31.1683 83.0113 52.2267 104.688 78.2036 104.688Z" />
        </clipPath>
        <filter
          id="filter2_i_3251_96677"
          x="24.9999"
          y="0.169434"
          width="107.408"
          height="109.204"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="-3" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.165619 0 0 0 0 0.26038 0 0 0 0 0.371621 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_3251_96677"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3251_96677"
          x1="117.5"
          y1="270.667"
          x2="115"
          y2="87.1667"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0CFFF" />
          <stop offset="1" stopColor="#70A8FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3251_96677"
          x1="153"
          y1="89.1667"
          x2="127.212"
          y2="157.871"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#4885E4" />
        </linearGradient>
        <radialGradient
          id="paint2_radial_3251_96677"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(78.2035 56.2717) rotate(90.1139) scale(102.395 99.4741)"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#EEF5FF" />
        </radialGradient>
        <linearGradient
          id="paint3_linear_3251_96677"
          x1="52.4216"
          y1="-55.8339"
          x2="35.859"
          y2="131.947"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.35" />
          <stop offset="0.824379" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3251_96677"
          x1="112.902"
          y1="-28.067"
          x2="97.3153"
          y2="111.507"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#699CEB" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const DarkReviewsEmptyState = (props: any) => {
  return (
    <Icon
      {...props}
      $size={212}
      width="212"
      height="181"
      viewBox="0 0 212 181"
      fill="none"
    >
      <path
        d="M105.624 180.444C163.959 180.444 211.248 168.748 211.248 154.322C211.248 139.895 163.959 128.2 105.624 128.2C47.2895 128.2 0 139.895 0 154.322C0 168.748 47.2895 180.444 105.624 180.444Z"
        fill="url(#paint0_linear_3238_243900)"
      />
      <path
        d="M40.254 0.71814C36.5125 0.71814 31.8009 2.64607 29.1552 5.83566C26.5096 9.02525 23.9999 15.95 23.9999 20.4608L24.5948 94.3226C24.5948 98.8334 25.326 104.956 29.8146 110.368C32.4602 113.557 36.5125 115.181 40.254 115.181H45.4406V135.871C45.4406 138.127 45.9004 140.223 47.2232 141.818C48.546 143.413 49.838 144.309 51.3938 144.309C52.9497 144.309 54.9207 144.309 58.4475 141.818L81.9885 116.448H171.374C175.116 116.448 180.222 114.656 182.868 111.466C185.514 108.277 187 102.042 187 97.5317L186.344 19.3581C186.344 14.8474 184.922 8.88921 182.276 5.69962C179.631 2.51003 174.459 0.71814 170.718 0.71814H40.254Z"
        fill="url(#paint1_linear_3238_243900)"
      />
      <g clipPath="url(#clip0_3238_243900)">
        <g filter="url(#filter0_d_3238_243900)">
          <path
            d="M64.2743 69.2126C63.1989 69.2126 62.6613 69.2126 62.2627 68.916C61.8641 68.6194 61.7096 68.1044 61.4007 67.0743L60.3617 63.6098C59.1901 59.7032 58.6043 57.7499 57.4881 57.7499C56.372 57.7499 55.7862 59.7032 54.6146 63.6098L53.5755 67.0743C53.2666 68.1044 53.1122 68.6194 52.7136 68.916C52.315 69.2126 51.7773 69.2126 50.702 69.2126H48.0204C44.2021 69.2126 42.293 69.2126 41.9571 70.2508C41.6211 71.2891 43.1685 72.4074 46.2631 74.644L48.5906 76.3262C49.4302 76.933 49.85 77.2364 50.0032 77.6925C50.1565 78.1486 50.0051 78.644 49.7022 79.6346L48.6728 83.0021C47.5435 86.6963 46.9788 88.5434 47.8796 89.1672C48.7804 89.7911 50.3109 88.6128 53.3718 86.2563L55.6595 84.495C56.5386 83.8183 56.9781 83.4799 57.4883 83.4797C57.9985 83.4795 58.4383 83.8175 59.3178 84.4936L61.6287 86.2698C64.6879 88.6212 66.2175 89.7969 67.1177 89.173C68.0179 88.549 67.4539 86.7041 66.3259 83.0142L65.2923 79.633C64.9897 78.643 64.8383 78.1481 64.9913 77.6922C65.1443 77.2363 65.5635 76.9328 66.402 76.3258L68.7272 74.6426C71.8166 72.4062 73.3613 71.288 73.0251 70.2503C72.6889 69.2126 70.7819 69.2126 66.968 69.2126H64.2743Z"
            fill="url(#paint2_linear_3238_243900)"
            shapeRendering="crispEdges"
          />
        </g>
      </g>
      <g clipPath="url(#clip1_3238_243900)">
        <g filter="url(#filter1_d_3238_243900)">
          <path
            d="M161.497 69.2126C160.403 69.2126 159.856 69.2126 159.454 68.9079C159.052 68.6033 158.904 68.0765 158.609 67.0229L157.851 64.3238C156.684 60.1621 156.1 58.0812 154.963 58.0812C153.826 58.0812 153.242 60.1621 152.074 64.3238L151.317 67.0229C151.021 68.0765 150.874 68.6033 150.472 68.9079C150.07 69.2126 149.523 69.2126 148.429 69.2126H146.222C142.576 69.2126 140.754 69.2126 140.407 70.2281C140.061 71.2435 141.503 72.3579 144.388 74.5866L146.656 76.3395C147.436 76.9416 147.826 77.2427 147.969 77.6803C148.113 78.1178 147.978 78.5913 147.707 79.5383L146.796 82.7247C145.71 86.5205 145.167 88.4183 146.091 89.0237C147.014 89.6291 148.538 88.3747 151.586 85.866L153.058 84.6548C153.97 83.9046 154.425 83.5294 154.963 83.5292C155.501 83.529 155.957 83.9038 156.869 84.6533L158.362 85.8805C161.409 88.3837 162.932 89.6353 163.855 89.0298C164.778 88.4244 164.236 86.5288 163.151 82.7377L162.236 79.5367C161.965 78.5904 161.83 78.1173 161.973 77.68C162.117 77.2427 162.506 76.9416 163.284 76.3393L165.551 74.5851C168.431 72.3567 169.871 71.2424 169.524 70.2275C169.177 69.2126 167.356 69.2126 163.715 69.2126H161.497Z"
            fill="url(#paint3_linear_3238_243900)"
            shapeRendering="crispEdges"
          />
        </g>
      </g>
      <g clipPath="url(#clip2_3238_243900)">
        <g filter="url(#filter2_d_3238_243900)">
          <path
            d="M113.603 69.2126C112.528 69.2126 111.99 69.2126 111.591 68.916C111.193 68.6194 111.038 68.1044 110.729 67.0743L109.69 63.6098C108.519 59.7032 107.933 57.7499 106.817 57.7499C105.701 57.7499 105.115 59.7032 103.943 63.6098L102.904 67.0743C102.595 68.1044 102.441 68.6194 102.042 68.916C101.644 69.2126 101.106 69.2126 100.031 69.2126H97.3491C93.5308 69.2126 91.6217 69.2126 91.2858 70.2508C90.9499 71.2891 92.4972 72.4074 95.5918 74.644L97.9193 76.3262C98.7589 76.933 99.1787 77.2364 99.332 77.6925C99.4852 78.1486 99.3338 78.644 99.0309 79.6346L98.0015 83.0021C96.8722 86.6963 96.3075 88.5434 97.2084 89.1672C98.1092 89.7911 99.6396 88.6128 102.701 86.2563L104.988 84.495C105.867 83.8183 106.307 83.4799 106.817 83.4797C107.327 83.4795 107.767 83.8175 108.647 84.4936L110.957 86.2698C114.017 88.6212 115.546 89.7969 116.446 89.173C117.347 88.549 116.783 86.7041 115.655 83.0142L114.621 79.633C114.318 78.643 114.167 78.1481 114.32 77.6922C114.473 77.2363 114.892 76.9328 115.731 76.3258L118.056 74.6426C121.145 72.4062 122.69 71.288 122.354 70.2503C122.018 69.2126 120.111 69.2126 116.297 69.2126H113.603Z"
            fill="url(#paint4_linear_3238_243900)"
            shapeRendering="crispEdges"
          />
        </g>
      </g>
      <g filter="url(#filter3_d_3238_243900)">
        <rect
          x="81"
          y="27.4557"
          width="81"
          height="7.92224"
          rx="3.96112"
          fill="url(#paint5_linear_3238_243900)"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter4_d_3238_243900)">
        <path
          d="M46 31.4169C46 25.9564 50.7103 21.514 56.5 21.514C62.2897 21.514 67 25.9565 67 31.4169C67 35.1206 64.8326 38.3555 61.6314 40.0538C60.1131 40.8593 58.3627 41.3196 56.5 41.3196C54.6373 41.3196 52.8869 40.8593 51.3686 40.0538C48.1675 38.3555 46 35.1207 46 31.4169Z"
          fill="url(#paint6_linear_3238_243900)"
          shapeRendering="crispEdges"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3238_243900"
          x="33.9119"
          y="50.7499"
          width="47.1586"
          height="47.5887"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.389583 0 0 0 0 0.613643 0 0 0 0 0.930417 0 0 0 0.65 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3238_243900"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3238_243900"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_3238_243900"
          x="132.356"
          y="51.0812"
          width="45.2183"
          height="47.0994"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.33563 0 0 0 0 0.562965 0 0 0 0 0.88437 0 0 0 0.65 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3238_243900"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3238_243900"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_3238_243900"
          x="84.2406"
          y="51.7499"
          width="45.1586"
          height="45.5887"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="3.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.386518 0 0 0 0 0.596546 0 0 0 0 0.893482 0 0 0 0.65 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3238_243900"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3238_243900"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_3238_243900"
          x="73"
          y="23.4557"
          width="97"
          height="23.9222"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.430824 0 0 0 0 0.651686 0 0 0 0 0.969176 0 0 0 0.64 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3238_243900"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3238_243900"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_3238_243900"
          x="37"
          y="16.514"
          width="39"
          height="37.8056"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.426098 0 0 0 0 0.642632 0 0 0 0 0.953902 0 0 0 0.64 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3238_243900"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3238_243900"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3238_243900"
          x1="117.5"
          y1="268.289"
          x2="115"
          y2="84.7891"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0CFFF" />
          <stop offset="1" stopColor="#70A8FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3238_243900"
          x1="114"
          y1="132"
          x2="30.5089"
          y2="-23.2189"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6BA4F5" />
          <stop offset="0.9999" stopColor="#CCDFFA" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3238_243900"
          x1="57.4881"
          y1="54.0283"
          x2="57.4881"
          y2="91.989"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.8" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3238_243900"
          x1="154.963"
          y1="54.0283"
          x2="154.963"
          y2="91.989"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.8" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3238_243900"
          x1="106.817"
          y1="54.0283"
          x2="106.817"
          y2="91.989"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.8" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_3238_243900"
          x1="122"
          y1="42.5"
          x2="112.879"
          y2="17.4516"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.8" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_3238_243900"
          x1="56.7692"
          y1="29.6394"
          x2="66.5773"
          y2="40.4065"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.81" />
          <stop offset="0.9999" stopColor="white" />
        </linearGradient>
        <clipPath id="clip0_3238_243900">
          <rect
            width="44.9762"
            height="45.5529"
            fill="white"
            transform="translate(35 50.2322)"
          />
        </clipPath>
        <clipPath id="clip1_3238_243900">
          <rect
            width="42.0745"
            height="45.5529"
            fill="white"
            transform="translate(133.926 50.2322)"
          />
        </clipPath>
        <clipPath id="clip2_3238_243900">
          <rect
            width="44.9762"
            height="45.5529"
            fill="white"
            transform="translate(84.3287 50.2322)"
          />
        </clipPath>
      </defs>
    </Icon>
  );
};

export const DarkBotsEmptyState = (props: any) => {
  const prefix = useMemo(() => uuidv4(), []);

  return (
    <Icon
      {...props}
      $size={356}
      width="356"
      height="231"
      viewBox="0 0 356 231"
      fill="none"
    >
      <path
        d="M178 230.444C276.307 230.444 356 218.749 356 204.322C356 189.895 276.307 178.2 178 178.2C79.6933 178.2 0 189.895 0 204.322C0 218.749 79.6933 230.444 178 230.444Z"
        fill={`url(#${prefix}paint0_linear_463_268)`}
      />
      <rect
        width="28.3704"
        height="63.234"
        rx="14.1852"
        transform="matrix(-0.866025 0.5 0.5 0.866025 219.871 101.063)"
        fill={`url(#${prefix}paint1_linear_463_268)`}
      />
      <ellipse
        cx="11.0709"
        cy="12.178"
        rx="11.0709"
        ry="12.178"
        transform="matrix(-0.903963 0.42761 0.42761 0.903963 245.379 148.425)"
        fill={`url(#${prefix}paint2_linear_463_268)`}
      />
      <circle
        cx="12.178"
        cy="12.178"
        r="12.178"
        transform="matrix(-1 0 0 1 253.863 152.728)"
        fill={`url(#${prefix}paint3_linear_463_268)`}
      />
      <rect
        width="26.393"
        height="49.1194"
        rx="13.1965"
        transform="matrix(-0.625828 0.779961 0.779961 0.625828 246.588 152.072)"
        fill={`url(#${prefix}paint4_linear_463_268)`}
      />
      <rect
        width="28.3704"
        height="49.1194"
        rx="14.1852"
        transform="matrix(-0.625828 0.779961 0.779961 0.625828 247.985 151.989)"
        fill={`url(#${prefix}paint5_linear_463_268)`}
      />
      <path
        d="M261.136 201.06L263.447 186.829L288.204 202.439L284.834 223.202L265.674 211.122C262.28 208.982 260.493 205.021 261.136 201.06Z"
        fill={`url(#${prefix}paint6_linear_463_268)`}
      />
      <path
        d="M317.329 188.848L280.903 182.934L277.946 201.147L313.781 210.703L317.329 188.848Z"
        fill={`url(#${prefix}paint7_linear_463_268)`}
      />
      <path
        d="M328.356 185.404L316.856 191.762L313.781 210.703L325.163 205.074L328.356 185.404Z"
        fill={`url(#${prefix}paint8_linear_463_268)`}
      />
      <path
        d="M299.409 197.902L287.909 204.26L284.833 223.201L296.216 217.572L299.409 197.902Z"
        fill={`url(#${prefix}paint9_linear_463_268)`}
      />
      <path
        d="M263.343 186.899C262.417 193.493 272.768 200.632 287.809 204.602L299.737 198.086C289.924 195.58 281.835 192.144 282.675 188.515C283.548 184.743 292.346 185.825 302.764 188.236C307.868 189.555 312.908 190.747 316.74 192.074L328.348 185.457C320.943 182.705 312.684 180.616 302.553 178.246C281.967 175.354 264.477 178.826 263.343 186.899Z"
        fill={`url(#${prefix}paint10_linear_463_268)`}
      />
      <path
        d="M227.276 43.7501C226.019 40.4054 223.917 38.2153 221.538 38.2153H219.233C215.386 38.2153 212.266 43.9429 212.266 51.0059C212.266 58.0689 215.386 63.7944 219.233 63.7964H221.538C223.917 63.7964 226.022 61.6103 227.276 58.2617C228.097 56.0108 228.518 53.524 228.503 51.0059C228.518 48.4878 228.097 46.0009 227.276 43.7501Z"
        fill={`url(#${prefix}paint11_linear_463_268)`}
      />
      <path
        d="M220.754 44.3233C219.623 41.0797 217.733 38.954 215.59 38.9463C212.124 38.9463 209.314 44.5145 209.314 51.3724C209.314 58.2302 212.124 63.7907 215.59 63.7965C217.733 63.7965 219.623 61.6727 220.754 58.4214C221.495 56.2347 221.874 53.8187 221.861 51.3724C221.874 48.926 221.495 46.51 220.754 44.3233Z"
        fill={`url(#${prefix}paint12_linear_463_268)`}
      />
      <path
        d="M146.5 97.6151C146.5 97.6151 152 81.3467 169.518 81.3467C188.5 81.3467 192.029 98.1151 192.029 98.1151V100.536H147.007L146.5 97.6151Z"
        fill={`url(#${prefix}paint13_linear_463_268)`}
      />
      <g filter={`url(#${prefix}filter0_i_463_268)`}>
        <path
          d="M119.898 110.15C119.775 107.681 120.971 105.343 123.195 104.264C130.045 100.939 146.962 94.5123 173.947 95.4649C199.245 96.358 212.084 104.489 217.515 109.295C219.879 111.386 220.814 114.494 220.814 117.65V202.115L173.947 206.615L141.795 203.689C131.874 202.786 124.13 194.72 123.632 184.771L119.898 110.15Z"
          fill={`url(#${prefix}paint14_linear_463_268)`}
        />
      </g>
      <path
        d="M117.898 40.4003C117.898 19.6313 134.9 2.13086 155.873 2.13086H184.734C205.706 2.13086 222.708 19.6313 222.708 40.4003V67.4763C222.708 75.7839 215.908 82.5185 207.518 82.5185H133.088C124.699 82.5185 117.898 75.7839 117.898 67.4763V40.4003Z"
        fill={`url(#${prefix}paint15_linear_463_268)`}
      />
      <path
        d="M175.311 19.7999C175.311 19.7993 175.31 19.7989 175.309 19.7988C174.168 19.518 173.418 19.0389 173.414 18.4897L173.409 17.9589C173.402 17.0705 175.347 16.3343 177.754 16.3149C180.16 16.2955 182.116 17.0001 182.124 17.8885L182.129 18.4209C182.133 18.9703 181.392 19.4623 180.254 19.7608C179.487 19.9534 178.642 20.0572 177.785 20.0641C176.929 20.071 176.083 19.981 175.313 19.8009C175.312 19.8008 175.311 19.8004 175.311 19.7999Z"
        fill={`url(#${prefix}paint16_linear_463_268)`}
      />
      <path
        d="M175.249 18.53C174.108 18.3496 173.356 18.0257 173.346 17.643C173.334 17.0235 175.277 16.4847 177.681 16.4393C180.086 16.394 182.045 16.8593 182.059 17.4787C182.067 17.8614 181.329 18.2134 180.192 18.4368C179.426 18.5815 178.582 18.6652 177.725 18.6814C176.868 18.6975 176.021 18.6457 175.25 18.53L175.249 18.53Z"
        fill="#94BEFF"
      />
      <path
        d="M216.383 57.6649C216.383 44.4845 205.304 34.0138 192.145 34.7569L178.408 35.5326L164.672 34.7569C151.513 34.0138 140.434 44.4845 140.434 57.6649C140.434 63.9415 145.471 69.0528 151.747 69.136C159.687 69.2413 170.293 69.3819 178.408 69.4895C186.524 69.3819 197.13 69.2413 205.069 69.136C211.346 69.0528 216.383 63.9415 216.383 57.6649Z"
        fill={`url(#${prefix}paint17_linear_463_268)`}
      />
      <path
        d="M192.183 50.0028C191.018 52.0196 190.703 54.4165 191.305 56.666C191.908 58.9155 193.38 60.8335 195.397 61.9979C197.414 63.1624 199.811 63.4779 202.06 62.8752C204.31 62.2724 206.228 60.8007 207.392 58.7838L199.787 54.3933L192.183 50.0028Z"
        fill={`url(#${prefix}paint18_linear_463_268)`}
      />
      <path
        d="M194.281 51.2135C193.438 52.674 193.209 54.4097 193.646 56.0386C194.082 57.6676 195.148 59.0565 196.608 59.8997C198.069 60.7429 199.804 60.9714 201.433 60.5349C203.062 60.0985 204.451 59.0327 205.294 57.5722L199.788 54.3929L194.281 51.2135Z"
        fill={`url(#${prefix}paint19_linear_463_268)`}
      />
      <path
        d="M195.333 51.9061C194.671 53.0532 194.491 54.4163 194.834 55.6956C195.177 56.9749 196.014 58.0656 197.161 58.7279C198.308 59.3901 199.671 59.5695 200.95 59.2268C202.23 58.884 203.32 58.047 203.982 56.9L199.658 54.4031L195.333 51.9061Z"
        fill="white"
      />
      <path
        d="M152.594 57.3968C153.391 59.5853 155.024 61.3676 157.135 62.3519C159.246 63.3361 161.661 63.4416 163.849 62.645C166.038 61.8485 167.82 60.2152 168.804 58.1046C169.788 55.9939 169.894 53.5786 169.097 51.3902L160.846 54.3935L152.594 57.3968Z"
        fill={`url(#${prefix}paint20_linear_463_268)`}
      />
      <path
        d="M154.871 56.568C155.448 58.1528 156.63 59.4435 158.159 60.1562C159.687 60.8689 161.436 60.9453 163.021 60.3685C164.606 59.7917 165.896 58.609 166.609 57.0805C167.322 55.5521 167.398 53.8031 166.821 52.2184L160.846 54.3932L154.871 56.568Z"
        fill={`url(#${prefix}paint21_linear_463_268)`}
      />
      <path
        d="M156.078 56.2073C156.531 57.4519 157.459 58.4655 158.66 59.0253C159.86 59.585 161.234 59.645 162.478 59.192C163.723 58.739 164.736 57.8102 165.296 56.6098C165.856 55.4094 165.916 54.0359 165.463 52.7913L160.77 54.4993L156.078 56.2073Z"
        fill="white"
      />
      <path
        d="M175.589 9.5835L180.273 9.86722L179.292 16.1849C179.152 17.0854 178.349 17.7321 177.44 17.677C176.53 17.6219 175.813 16.8832 175.785 15.9724L175.589 9.5835Z"
        fill={`url(#${prefix}paint22_linear_463_268)`}
      />
      <ellipse
        cx="178.069"
        cy="6.01689"
        rx="6.07595"
        ry="6.01689"
        fill={`url(#${prefix}paint23_linear_463_268)`}
      />
      <path
        d="M155.277 179.754C158.232 178.532 161.501 178.699 164.646 179.28L203.559 186.458L197.667 218.394L153.037 206.755C152.679 206.661 152.327 206.565 151.984 206.427C149.957 205.612 142.747 201.953 144.795 191.753C146.193 184.783 151.371 181.368 155.277 179.754Z"
        fill={`url(#${prefix}paint24_linear_463_268)`}
        fillOpacity="0.7"
      />
      <path
        d="M157.454 180.155C160.41 178.934 163.678 179.101 166.823 179.681L205.736 186.86L199.845 218.796L161.331 211.691C157.925 211.063 154.557 209.925 152.118 207.467C149.042 204.367 145.568 199.147 146.972 192.155C148.37 185.185 153.548 181.77 157.454 180.155Z"
        fill={`url(#${prefix}paint25_linear_463_268)`}
      />
      <path
        d="M208.255 188.315C212.75 182.931 220.112 181.442 227.09 182.133L253.014 184.703L249.81 217.019L224.111 214.472C216.996 213.767 209.948 210.749 206.62 204.422C205.156 201.639 204.113 198.581 204.443 195.835C204.756 193.227 206.341 190.608 208.255 188.315Z"
        fill={`url(#${prefix}paint26_linear_463_268)`}
      />
      <path
        d="M223.7 202.513C218.805 220.626 214.677 230.219 198.313 224.502C188.305 221.797 182.563 210.831 187.458 192.718C192.633 173.557 206.693 155.001 220.299 158.775C227.413 164.966 228.595 184.401 223.7 202.513Z"
        fill={`url(#${prefix}paint27_linear_463_268)`}
      />
      <path
        d="M275.1 195.688C272.558 214.277 269.69 224.319 252.729 220.739C242.458 219.334 235.362 209.191 237.904 190.602C240.589 170.937 252.163 150.737 266.14 152.742C273.986 157.973 277.641 177.098 275.1 195.688Z"
        fill={`url(#${prefix}paint28_linear_463_268)`}
      />
      <path
        d="M225.052 200.139C221.619 218.746 214.432 226.741 207.617 225.483C200.803 224.226 196.941 214.194 200.374 195.587C203.807 176.979 213.122 157.451 219.936 158.708C226.751 159.966 228.484 181.532 225.052 200.139Z"
        fill={`url(#${prefix}paint29_linear_463_268)`}
      />
      <path
        d="M276.138 193.16C275.11 212.053 269.003 220.9 262.084 220.524C255.164 220.147 250.053 210.69 251.081 191.797C252.109 172.904 258.853 152.346 265.772 152.722C272.692 153.098 277.166 174.267 276.138 193.16Z"
        fill={`url(#${prefix}paint30_linear_463_268)`}
      />
      <path
        d="M129.113 43.0191C127.857 39.6744 125.755 37.4844 123.376 37.4844H121.071C117.224 37.4844 114.104 43.2119 114.104 50.2749C114.104 57.3379 117.224 63.0635 121.071 63.0655H123.376C125.755 63.0655 127.859 60.8794 129.113 57.5307C129.935 55.2799 130.356 52.793 130.341 50.2749C130.356 47.7568 129.935 45.27 129.113 43.0191Z"
        fill={`url(#${prefix}paint31_linear_463_268)`}
      />
      <path
        d="M122.591 43.5924C121.461 40.3488 119.571 38.2231 117.428 38.2153C113.961 38.2153 111.152 43.7835 111.152 50.6414C111.152 57.4993 113.961 63.0597 117.428 63.0655C119.571 63.0655 121.461 60.9418 122.591 57.6904C123.332 55.5037 123.712 53.0877 123.699 50.6414C123.712 48.1951 123.332 45.7791 122.591 43.5924Z"
        fill={`url(#${prefix}paint32_linear_463_268)`}
      />
      <rect
        x="123.431"
        y="99.5869"
        width="28.3704"
        height="63.9991"
        rx="14.1852"
        transform="rotate(30 123.431 99.5869)"
        fill={`url(#${prefix}paint33_linear_463_268)`}
        fillOpacity="0.7"
      />
      <rect
        x="121.955"
        y="101.063"
        width="28.3704"
        height="63.234"
        rx="14.1852"
        transform="rotate(30 121.955 101.063)"
        fill={`url(#${prefix}paint34_linear_463_268)`}
      />
      <ellipse
        cx="101.247"
        cy="164.167"
        rx="11.0709"
        ry="12.178"
        transform="rotate(25.316 101.247 164.167)"
        fill={`url(#${prefix}paint35_linear_463_268)`}
        fillOpacity="0.7"
      />
      <circle
        cx="100.14"
        cy="164.906"
        r="12.178"
        fill={`url(#${prefix}paint36_linear_463_268)`}
      />
      <rect
        x="95.2377"
        y="152.072"
        width="26.393"
        height="49.1194"
        rx="13.1965"
        transform="rotate(51.257 95.2377 152.072)"
        fill={`url(#${prefix}paint37_linear_463_268)`}
        fillOpacity="0.79"
      />
      <rect
        x="93.8409"
        y="151.989"
        width="28.3704"
        height="49.1194"
        rx="14.1852"
        transform="rotate(51.257 93.8409 151.989)"
        fill={`url(#${prefix}paint38_linear_463_268)`}
      />
      <path
        d="M80.6896 201.06L78.3792 186.829L53.6214 202.439L56.9923 223.202L76.1521 211.122C79.5461 208.982 81.3326 205.021 80.6896 201.06Z"
        fill={`url(#${prefix}paint39_linear_463_268)`}
      />
      <path
        d="M24.4968 188.848L60.923 182.934L63.8798 201.147L28.045 210.703L24.4968 188.848Z"
        fill={`url(#${prefix}paint40_linear_463_268)`}
      />
      <path
        d="M13.4695 185.404L24.9699 191.762L28.0451 210.703L16.663 205.074L13.4695 185.404Z"
        fill={`url(#${prefix}paint41_linear_463_268)`}
      />
      <path
        d="M42.4167 197.902L53.9171 204.26L56.9922 223.201L45.6102 217.572L42.4167 197.902Z"
        fill={`url(#${prefix}paint42_linear_463_268)`}
      />
      <path
        d="M78.4825 186.899C79.4085 193.493 69.058 200.632 54.0164 204.602L42.0883 198.086C51.9014 195.58 59.9906 192.144 59.1508 188.515C58.2776 184.743 49.4794 185.825 39.0619 188.236C33.9582 189.555 28.9176 190.747 25.0861 192.074L13.4782 185.457C20.8825 182.705 29.1422 180.616 39.2724 178.246C59.8589 175.354 77.3485 178.826 78.4825 186.899Z"
        fill={`url(#${prefix}paint43_linear_463_268)`}
      />
      <defs>
        <filter
          id={`${prefix}filter0_i_463_268`}
          x="119.89"
          y="95.3696"
          width="107.569"
          height="120.738"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="6.64476" dy="10.4418" />
          <feGaussianBlur stdDeviation="4.74626" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.184314 0 0 0 0 0.254902 0 0 0 0 0.443137 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_463_268"
          />
        </filter>
        <linearGradient
          id={`${prefix}paint0_linear_463_268`}
          x1="198.014"
          y1="318.289"
          x2="196.53"
          y2="134.767"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0CFFF" />
          <stop offset="1" stopColor="#70A8FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint1_linear_463_268`}
          x1="61.1551"
          y1="10.287"
          x2="-65.6504"
          y2="33.8703"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.192174" stopColor="#6BA5FF" />
          <stop offset="0.528117" stopColor="#D5E5FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint2_linear_463_268`}
          x1="34.0182"
          y1="16.0722"
          x2="12.2351"
          y2="-5.35041"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CADFFF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint3_linear_463_268`}
          x1="23.8634"
          y1="20.3875"
          x2="0.903595"
          y2="-5.61626"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8ABAFF" />
          <stop offset="1" stopColor="#E6F0FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint4_linear_463_268`}
          x1="34.9318"
          y1="20.8224"
          x2="-0.298867"
          y2="6.38729"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CADFFF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint5_linear_463_268`}
          x1="67.9239"
          y1="1.61113"
          x2="-27.3503"
          y2="6.7949"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.252108" stopColor="#6BA5FF" />
          <stop offset="0.633257" stopColor="#CCE0FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint6_linear_463_268`}
          x1="283"
          y1="211.5"
          x2="261.673"
          y2="193.214"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#66A5FF" />
          <stop offset="0.9999" stopColor="#CEE2FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint7_linear_463_268`}
          x1="277"
          y1="183"
          x2="334.531"
          y2="197.416"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#81B0F8" />
          <stop offset="1" stopColor="#166DF3" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint8_linear_463_268`}
          x1="309"
          y1="171.615"
          x2="334.449"
          y2="190.123"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D5E5FF" />
          <stop offset="1" stopColor="#72A7F8" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint9_linear_463_268`}
          x1="285"
          y1="186.615"
          x2="305.356"
          y2="202.492"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D5E5FF" />
          <stop offset="1" stopColor="#6EA4F7" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint10_linear_463_268`}
          x1="286.5"
          y1="141"
          x2="337.512"
          y2="129.225"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B2D1FE" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint11_linear_463_268`}
          x1="218"
          y1="28.5"
          x2="214.64"
          y2="58.9078"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint12_linear_463_268`}
          x1="206.675"
          y1="62.1671"
          x2="236.566"
          y2="54.618"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6DDFF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint13_linear_463_268`}
          x1="212.289"
          y1="84.4415"
          x2="126.975"
          y2="102.192"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B8D4FF" />
          <stop offset="1" stopColor="#3481F9" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint14_linear_463_268`}
          x1="177"
          y1="183.5"
          x2="181.8"
          y2="103.644"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#99C3FF" />
          <stop offset="0.9999" stopColor="#CCE1FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint15_linear_463_268`}
          x1="170.198"
          y1="89.0411"
          x2="197.699"
          y2="-16.4937"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A4C9FE" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint16_linear_463_268`}
          x1="176.179"
          y1="20.0771"
          x2="179.313"
          y2="15.9946"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint17_linear_463_268`}
          x1="120"
          y1="23.5002"
          x2="213.75"
          y2="57.4269"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3D0FF" />
          <stop offset="1" stopColor="#5597FD" />
          <stop offset="1" stopColor="#4F89E4" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint18_linear_463_268`}
          x1="178.052"
          y1="56.8724"
          x2="208.806"
          y2="58.9558"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint19_linear_463_268`}
          x1="202.79"
          y1="48.4914"
          x2="195.27"
          y2="58.9367"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint20_linear_463_268`}
          x1="148.774"
          y1="72.6374"
          x2="170.138"
          y2="50.4177"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint21_linear_463_268`}
          x1="158.255"
          y1="48.3"
          x2="161.423"
          y2="60.7742"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint22_linear_463_268`}
          x1="173.717"
          y1="7.94689"
          x2="171.699"
          y2="15.3003"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint23_linear_463_268`}
          x1="178.404"
          y1="-0.239552"
          x2="179.613"
          y2="11.8799"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint24_linear_463_268`}
          x1="219.143"
          y1="203.332"
          x2="168.116"
          y2="157.121"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CADFFF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint25_linear_463_268`}
          x1="180"
          y1="217"
          x2="182.462"
          y2="179.745"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7EB2FB" />
          <stop offset="0.9999" stopColor="#CADEFC" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint26_linear_463_268`}
          x1="238"
          y1="218.5"
          x2="240.9"
          y2="182.694"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#82B4FC" />
          <stop offset="0.9999" stopColor="#C7DDFD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint27_linear_463_268`}
          x1="229.5"
          y1="170.115"
          x2="172.381"
          y2="187.32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BDD7FF" />
          <stop offset="1" stopColor="#6EA4F7" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint28_linear_463_268`}
          x1="277.735"
          y1="176.411"
          x2="240.369"
          y2="204.292"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3D0FF" />
          <stop offset="1" stopColor="#79ACFC" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint29_linear_463_268`}
          x1="263"
          y1="189.615"
          x2="178.46"
          y2="167.648"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CADFFF" />
          <stop offset="1" stopColor="#0D67F2" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint30_linear_463_268`}
          x1="341.5"
          y1="159.615"
          x2="231.606"
          y2="132.265"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CADFFF" />
          <stop offset="1" stopColor="#0D67F2" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint31_linear_463_268`}
          x1="119"
          y1="27.9999"
          x2="116.131"
          y2="62.5598"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint32_linear_463_268`}
          x1="107"
          y1="46.9999"
          x2="141.948"
          y2="57.0578"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#98C0FF" />
          <stop offset="0.567708" stopColor="#D5E5FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint33_linear_463_268`}
          x1="184.624"
          y1="162.439"
          x2="176.619"
          y2="89.8338"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CADFFF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint34_linear_463_268`}
          x1="163.332"
          y1="129.64"
          x2="83.2463"
          y2="144.946"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#98C0FF" />
          <stop offset="0.567708" stopColor="#D5E5FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint35_linear_463_268`}
          x1="125.714"
          y1="159.173"
          x2="73.1086"
          y2="149.162"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CADFFF" />
          <stop offset="0.552866" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint36_linear_463_268`}
          x1="108.5"
          y1="171"
          x2="68.5339"
          y2="149.358"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B4D2FD" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint37_linear_463_268`}
          x1="130.17"
          y1="172.894"
          x2="107.485"
          y2="146.592"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CADFFF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint38_linear_463_268`}
          x1="130.226"
          y1="174.57"
          x2="56.2368"
          y2="195.328"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#98C0FF" />
          <stop offset="0.639586" stopColor="#D5E5FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint39_linear_463_268`}
          x1="71.5"
          y1="223"
          x2="89.1583"
          y2="166.747"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DA9FF" />
          <stop offset="0.9999" stopColor="#BBD7FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint40_linear_463_268`}
          x1="76.7906"
          y1="177.044"
          x2="25.3388"
          y2="195.325"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CADFFF" />
          <stop offset="1" stopColor="#3780F1" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint41_linear_463_268`}
          x1="35"
          y1="180.615"
          x2="12.711"
          y2="192.781"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D5E5FF" />
          <stop offset="1" stopColor="#7BAEFF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint42_linear_463_268`}
          x1="62.5"
          y1="176.615"
          x2="25.3716"
          y2="196.382"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D5E5FF" />
          <stop offset="1" stopColor="#70A8FF" />
        </linearGradient>
        <linearGradient
          id={`${prefix}paint43_linear_463_268`}
          x1="40"
          y1="197"
          x2="53.0145"
          y2="144.583"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B2D1FE" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const DarkBacktestingHistoryEmptyState = (props: any) => {
  return (
    <Icon
      {...props}
      $size={212}
      width="212"
      height="162"
      viewBox="0 0 212 162"
      fill="none"
    >
      <path
        d="M105.624 161.444C163.959 161.444 211.248 149.748 211.248 135.322C211.248 120.895 163.959 109.199 105.624 109.199C47.2895 109.199 0 120.895 0 135.322C0 149.748 47.2895 161.444 105.624 161.444Z"
        fill="url(#paint0_linear_3238_244100)"
      />
      <path
        d="M174 0H166.824C161.95 0 158 3.95043 158 8.82353V14H188C188 6.26801 181.732 0 174 0Z"
        fill="#1E57AE"
      />
      <g filter="url(#filter0_i_3238_244100)">
        <path
          d="M164.26 137L183.512 42.3988C183.764 41.1594 182.817 40 181.552 40H68.8521L45 137H164.26Z"
          fill="url(#paint1_linear_3238_244100)"
        />
      </g>
      <path
        d="M163.04 16.4359V133H46V14.5744C46 8.21669 50.165 2.60967 56.2517 0.773256L175 0C167.87 2.30471 163.04 8.94309 163.04 16.4359Z"
        fill="url(#paint2_linear_3238_244100)"
      />
      <g filter="url(#filter1_i_3238_244100)">
        <path
          d="M64.8333 36H27.6228C25.7418 36 24.3247 37.7112 24.6755 39.5593L43.1667 137H164L149.466 60.9813C149.196 59.5673 147.959 58.5446 146.519 58.5446H85.6667L64.8333 36Z"
          fill="url(#paint3_linear_3238_244100)"
        />
      </g>
      <rect
        x="46.9464"
        y="70.6742"
        width="5.95946"
        height="4.25676"
        fill="url(#paint4_linear_3238_244100)"
      />
      <rect
        x="43.5405"
        y="62.1606"
        width="12.7703"
        height="8.51351"
        rx="1"
        fill="url(#paint5_linear_3238_244100)"
      />
      <rect
        x="23.7812"
        y="82.6162"
        width="4.40248"
        height="4.33595"
        transform="rotate(-45 23.7812 82.6162)"
        fill="#5397FF"
      />
      <rect
        x="68.2297"
        y="83.3118"
        width="4.40248"
        height="4.41695"
        transform="rotate(-45 68.2297 83.3118)"
        fill="url(#paint6_linear_3238_244100)"
      />
      <circle
        cx="49.5"
        cy="105.58"
        r="31.5"
        fill="url(#paint7_linear_3238_244100)"
      />
      <g filter="url(#filter2_di_3238_244100)">
        <circle cx="49.4999" cy="105.58" r="25.5405" fill="#E6F0FF" />
      </g>
      <path
        d="M47.3716 102.6L63.5473 93.235L51.2027 107.282L51.1834 107.259C50.644 107.799 49.8982 108.134 49.0742 108.134C47.4286 108.134 46.0945 106.8 46.0945 105.154C46.0945 104.117 46.6245 103.203 47.4285 102.669L47.3716 102.6Z"
        fill="#5397FF"
      />
      <path
        d="M49.4999 83.4445V88.9782M49.4999 122.181V127.289"
        stroke="#8DBBFF"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M27.3646 105.58H32.8984M66.1011 105.58H71.2092"
        stroke="#8DBBFF"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <rect
        x="18"
        y="80.1451"
        width="9.08205"
        height="6.97112"
        rx="1"
        transform="rotate(-45 18 80.1451)"
        fill="url(#paint8_linear_3238_244100)"
      />
      <rect
        width="9.08205"
        height="6.97112"
        rx="1"
        transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 80.6865 80.5017)"
        fill="url(#paint9_linear_3238_244100)"
      />
      <path
        d="M142 26H79M142 40H103.837"
        stroke="white"
        strokeOpacity="0.62"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <defs>
        <filter
          id="filter0_i_3238_244100"
          x="44"
          y="40"
          width="139.553"
          height="97"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.24 0 0 0 0 0.523355 0 0 0 0 0.96 0 0 0 0.72 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_3238_244100"
          />
        </filter>
        <filter
          id="filter1_i_3238_244100"
          x="23.6219"
          y="36"
          width="140.378"
          height="102"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1" dy="2" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.24 0 0 0 0 0.521325 0 0 0 0 0.96 0 0 0 0.42 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_3238_244100"
          />
        </filter>
        <filter
          id="filter2_di_3238_244100"
          x="21.9594"
          y="78.0391"
          width="55.0811"
          height="55.0811"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.194904 0 0 0 0 0.423127 0 0 0 0 0.772174 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3238_244100"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3238_244100"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1" dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.645436 0 0 0 0 0.713543 0 0 0 0 0.817708 0 0 0 0.41 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_3238_244100"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3238_244100"
          x1="117.5"
          y1="249.289"
          x2="115"
          y2="65.7891"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0CFFF" />
          <stop offset="1" stopColor="#70A8FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3238_244100"
          x1="114.5"
          y1="40"
          x2="114.5"
          y2="137"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#90BBF9" />
          <stop offset="1" stopColor="#6BA7FA" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3238_244100"
          x1="116.191"
          y1="36.0387"
          x2="116.579"
          y2="7.29239"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4C8AEB" />
          <stop offset="1" stopColor="#81ADF1" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3238_244100"
          x1="45.3245"
          y1="41.5"
          x2="100.52"
          y2="133.07"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D7E8FF" />
          <stop offset="1" stopColor="#BAD7FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3238_244100"
          x1="46.5045"
          y1="72.2559"
          x2="53.0368"
          y2="72.2559"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#83B3FF" />
          <stop offset="1" stopColor="#3F89FA" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_3238_244100"
          x1="44.1292"
          y1="66.3176"
          x2="53.6307"
          y2="66.3176"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7BAEFF" />
          <stop offset="0.288845" stopColor="#A0C5FF" />
          <stop offset="1" stopColor="#3A86F9" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_3238_244100"
          x1="70.431"
          y1="83.3118"
          x2="70.431"
          y2="87.7287"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#83B3FF" />
          <stop offset="1" stopColor="#3F89FA" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_3238_244100"
          x1="41.1599"
          y1="74.0375"
          x2="49.5"
          y2="137.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6AA2FB" />
          <stop offset="1" stopColor="#357CE9" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_3238_244100"
          x1="18.9595"
          y1="83.3848"
          x2="26.5179"
          y2="83.3848"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5397FF" />
          <stop offset="0.548663" stopColor="#A5C8FF" />
          <stop offset="1" stopColor="#7AAEFF" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_3238_244100"
          x1="9.84516"
          y1="4.06277"
          x2="0.187197"
          y2="4.48268"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#83B3FF" />
          <stop offset="0.287812" stopColor="#B7D2FC" />
          <stop offset="1" stopColor="#3F89FA" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const DarkConfigurationEmptyState = (props: any) => {
  return (
    <Icon
      {...props}
      $size={212}
      width="212"
      height="134"
      viewBox="0 0 212 134"
      fill="none"
    >
      <path
        d="M105.624 133.444C163.959 133.444 211.248 121.748 211.248 107.322C211.248 92.8947 163.959 81.1995 105.624 81.1995C47.2895 81.1995 0 92.8947 0 107.322C0 121.748 47.2895 133.444 105.624 133.444Z"
        fill="url(#paint0_linear_3260_110415)"
      />
      <rect
        x="30"
        width="152"
        height="104"
        rx="4"
        fill="url(#paint1_linear_3260_110415)"
      />
      <rect
        x="32"
        y="2"
        width="148"
        height="100"
        rx="2"
        fill="url(#paint2_linear_3260_110415)"
      />
      <rect
        opacity="0.8"
        x="57.0222"
        y="84.6517"
        width="65.3037"
        height="7.88148"
        rx="3.94074"
        transform="rotate(-90 57.0222 84.6517)"
        fill="url(#paint3_linear_3260_110415)"
      />
      <rect
        x="55.8962"
        y="62.1333"
        width="22.5185"
        height="10.1333"
        rx="5.06667"
        transform="rotate(-90 55.8962 62.1333)"
        fill="url(#paint4_linear_3260_110415)"
      />
      <rect
        opacity="0.8"
        x="87.4222"
        y="84.6517"
        width="65.3037"
        height="7.88148"
        rx="3.94074"
        transform="rotate(-90 87.4222 84.6517)"
        fill="url(#paint5_linear_3260_110415)"
      />
      <rect
        x="86.2963"
        y="79.0221"
        width="22.5185"
        height="10.1333"
        rx="5.06667"
        transform="rotate(-90 86.2963 79.0221)"
        fill="url(#paint6_linear_3260_110415)"
      />
      <rect
        opacity="0.8"
        x="117.822"
        y="84.6519"
        width="65.3037"
        height="7.88148"
        rx="3.94074"
        transform="rotate(-90 117.822 84.6519)"
        fill="url(#paint7_linear_3260_110415)"
      />
      <rect
        x="116.696"
        y="41.8666"
        width="22.5185"
        height="10.1333"
        rx="5.06667"
        transform="rotate(-90 116.696 41.8666)"
        fill="url(#paint8_linear_3260_110415)"
      />
      <rect
        opacity="0.8"
        x="148.222"
        y="84.6517"
        width="65.3037"
        height="7.88148"
        rx="3.94074"
        transform="rotate(-90 148.222 84.6517)"
        fill="url(#paint9_linear_3260_110415)"
      />
      <rect
        x="147.096"
        y="73.3926"
        width="22.5185"
        height="10.1333"
        rx="5.06667"
        transform="rotate(-90 147.096 73.3926)"
        fill="url(#paint10_linear_3260_110415)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3260_110415"
          x1="117.5"
          y1="221.289"
          x2="115"
          y2="37.7891"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0CFFF" />
          <stop offset="1" stopColor="#70A8FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3260_110415"
          x1="106"
          y1="0"
          x2="106"
          y2="104"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7CB0FF" />
          <stop offset="1" stopColor="#4F94FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3260_110415"
          x1="95.2672"
          y1="-3.11364"
          x2="169.813"
          y2="94.1955"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D7E8FF" />
          <stop offset="1" stopColor="#B9D7FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3260_110415"
          x1="113.318"
          y1="81.8369"
          x2="47.4518"
          y2="94.7851"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#94C3FF" />
          <stop offset="0.995" stopColor="#579FFF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3260_110415"
          x1="68.8444"
          y1="62.1333"
          x2="64.3407"
          y2="72.2666"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#73A8FE" />
          <stop offset="0.995" stopColor="#1A69E6" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_3260_110415"
          x1="146.533"
          y1="78.4591"
          x2="84.0444"
          y2="97.0369"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#94C3FF" />
          <stop offset="0.995" stopColor="#579FFF" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_3260_110415"
          x1="99.2444"
          y1="79.0221"
          x2="94.7407"
          y2="89.1554"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#73A8FE" />
          <stop offset="0.995" stopColor="#1A69E6" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_3260_110415"
          x1="174.681"
          y1="78.4593"
          x2="123.452"
          y2="100.978"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#94C3FF" />
          <stop offset="0.995" stopColor="#579FFF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_3260_110415"
          x1="129.644"
          y1="41.8666"
          x2="125.141"
          y2="51.9999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#73A8FE" />
          <stop offset="0.995" stopColor="#1A69E6" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_3260_110415"
          x1="204.519"
          y1="83.5258"
          x2="157.793"
          y2="99.2888"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#94C3FF" />
          <stop offset="0.995" stopColor="#579FFF" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_3260_110415"
          x1="160.044"
          y1="73.3926"
          x2="155.541"
          y2="83.5259"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#73A8FE" />
          <stop offset="0.995" stopColor="#1A69E6" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const DarkConfigurationSearchEmptyState = (props: any) => {
  return (
    <Icon
      {...props}
      $size={212}
      width="212"
      height="141"
      viewBox="0 0 212 141"
      fill="none"
    >
      <path
        d="M105.624 130.444C163.959 130.444 211.248 118.748 211.248 104.322C211.248 89.8947 163.959 78.1995 105.624 78.1995C47.2895 78.1995 0 89.8947 0 104.322C0 118.748 47.2895 130.444 105.624 130.444Z"
        fill="url(#paint0_linear_3256_96967)"
      />
      <rect
        x="34"
        width="135"
        height="92"
        rx="4"
        fill="url(#paint1_linear_3256_96967)"
      />
      <rect
        x="36"
        y="2"
        width="131"
        height="88"
        rx="2"
        fill="url(#paint2_linear_3256_96967)"
      />
      <rect
        opacity="0.8"
        x="58"
        y="75"
        width="58"
        height="7"
        rx="3.5"
        transform="rotate(-90 58 75)"
        fill="url(#paint3_linear_3256_96967)"
      />
      <rect
        x="57"
        y="55"
        width="20"
        height="9"
        rx="4.5"
        transform="rotate(-90 57 55)"
        fill="url(#paint4_linear_3256_96967)"
      />
      <rect
        opacity="0.8"
        x="85"
        y="75"
        width="58"
        height="7"
        rx="3.5"
        transform="rotate(-90 85 75)"
        fill="url(#paint5_linear_3256_96967)"
      />
      <rect
        x="84"
        y="70"
        width="20"
        height="9"
        rx="4.5"
        transform="rotate(-90 84 70)"
        fill="url(#paint6_linear_3256_96967)"
      />
      <rect
        opacity="0.8"
        x="112"
        y="75"
        width="58"
        height="7"
        rx="3.5"
        transform="rotate(-90 112 75)"
        fill="url(#paint7_linear_3256_96967)"
      />
      <rect
        x="111"
        y="37"
        width="20"
        height="9"
        rx="4.5"
        transform="rotate(-90 111 37)"
        fill="url(#paint8_linear_3256_96967)"
      />
      <rect
        opacity="0.8"
        x="139"
        y="75"
        width="58"
        height="7"
        rx="3.5"
        transform="rotate(-90 139 75)"
        fill="url(#paint9_linear_3256_96967)"
      />
      <rect
        x="138"
        y="65"
        width="20"
        height="9"
        rx="4.5"
        transform="rotate(-90 138 65)"
        fill="url(#paint10_linear_3256_96967)"
      />
      <path
        d="M172.175 104.193L176.181 108.497L175.805 109.018C175.054 109.931 175.054 111.366 175.805 112.279L197.084 137.578C197.96 138.622 198.962 139.534 200.213 140.186C201.465 140.839 202.717 141.23 204.094 140.839C205.596 140.447 206.973 139.404 207.098 137.187C207.223 135.622 206.722 134.188 205.721 133.014L184.317 106.28C183.315 105.106 181.813 104.845 180.812 105.628L176.556 100.281C176.556 100.02 173.302 101.194 172.175 104.193Z"
        fill="url(#paint11_linear_3256_96967)"
      />
      <foreignObject x="115.352" y="38.486" width="76.5886" height="78.4852">
        <div
          style={{
            backdropFilter: "blur(3px)",
            clipPath: "url(#bgblur_0_3256_96967_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <g filter="url(#filter0_i_3256_96967)" data-figma-bg-blur-radius="6">
        <path
          d="M153.646 110.971C171.482 110.971 185.941 96.088 185.941 77.7286C185.941 59.3692 171.482 44.486 153.646 44.486C135.811 44.486 121.352 59.3692 121.352 77.7286C121.352 96.088 135.811 110.971 153.646 110.971Z"
          fill="url(#paint12_radial_3256_96967)"
          fillOpacity="0.33"
        />
      </g>
      <g filter="url(#filter1_i_3256_96967)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M153.647 49.2129C137.868 49.2129 125.076 61.98 125.076 77.7291C125.076 93.4781 137.868 106.245 153.647 106.245C169.426 106.245 182.218 93.4781 182.218 77.7291C182.218 61.98 169.426 49.2129 153.647 49.2129ZM117.117 77.7291C117.117 57.5929 133.472 41.2694 153.647 41.2694C173.822 41.2694 190.176 57.5929 190.176 77.7291C190.176 97.8652 173.822 114.189 153.647 114.189C133.472 114.189 117.117 97.8652 117.117 77.7291Z"
          fill="url(#paint13_linear_3256_96967)"
        />
      </g>
      <defs>
        <filter
          id="filter0_i_3256_96967"
          x="115.352"
          y="38.486"
          width="76.5886"
          height="78.4852"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.85204" />
          <feGaussianBlur stdDeviation="11.5753" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.560784 0 0 0 0 0.607843 0 0 0 0 1 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_3256_96967"
          />
        </filter>
        <clipPath
          id="bgblur_0_3256_96967_clip_path"
          transform="translate(-115.352 -38.486)"
        >
          <path d="M153.646 110.971C171.482 110.971 185.941 96.088 185.941 77.7286C185.941 59.3692 171.482 44.486 153.646 44.486C135.811 44.486 121.352 59.3692 121.352 77.7286C121.352 96.088 135.811 110.971 153.646 110.971Z" />
        </clipPath>
        <filter
          id="filter1_i_3256_96967"
          x="117.117"
          y="41.2694"
          width="73.0592"
          height="72.9193"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.384314 0 0 0 0 0.623529 0 0 0 0 0.996078 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_3256_96967"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3256_96967"
          x1="117.5"
          y1="218.289"
          x2="115"
          y2="34.7891"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0CFFF" />
          <stop offset="1" stopColor="#70A8FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3256_96967"
          x1="101.5"
          y1="0"
          x2="101.5"
          y2="92"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7CB0FF" />
          <stop offset="1" stopColor="#4F94FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3256_96967"
          x1="92"
          y1="-2.5"
          x2="157.5"
          y2="83.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D7E8FF" />
          <stop offset="1" stopColor="#B9D7FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3256_96967"
          x1="108"
          y1="72.5"
          x2="49.5"
          y2="84"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#94C3FF" />
          <stop offset="0.995" stopColor="#579FFF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3256_96967"
          x1="68.5"
          y1="55"
          x2="64.5"
          y2="64"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#73A8FE" />
          <stop offset="0.995" stopColor="#1A69E6" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_3256_96967"
          x1="137.5"
          y1="69.5"
          x2="82"
          y2="86"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#94C3FF" />
          <stop offset="0.995" stopColor="#579FFF" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_3256_96967"
          x1="95.5"
          y1="70"
          x2="91.5"
          y2="79"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#73A8FE" />
          <stop offset="0.995" stopColor="#1A69E6" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_3256_96967"
          x1="162.5"
          y1="69.5"
          x2="117"
          y2="89.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#94C3FF" />
          <stop offset="0.995" stopColor="#579FFF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_3256_96967"
          x1="122.5"
          y1="37"
          x2="118.5"
          y2="46"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#73A8FE" />
          <stop offset="0.995" stopColor="#1A69E6" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_3256_96967"
          x1="189"
          y1="74"
          x2="147.5"
          y2="88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#94C3FF" />
          <stop offset="0.995" stopColor="#579FFF" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_3256_96967"
          x1="149.5"
          y1="65"
          x2="145.5"
          y2="74"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#73A8FE" />
          <stop offset="0.995" stopColor="#1A69E6" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_3256_96967"
          x1="207.117"
          y1="113.114"
          x2="189.328"
          y2="140.79"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#3683FC" />
        </linearGradient>
        <radialGradient
          id="paint12_radial_3256_96967"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(153.646 77.7286) rotate(90) scale(33.2426 32.2943)"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#EEF5FF" />
        </radialGradient>
        <linearGradient
          id="paint13_linear_3256_96967"
          x1="177.47"
          y1="19.8226"
          x2="166.769"
          y2="115.654"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3D0FF" />
          <stop offset="1" stopColor="#6CA3F9" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const DarkUsersEmptyState = (props: any) => {
  return (
    <Icon
      {...props}
      $size={212}
      width="212"
      height="175"
      viewBox="0 0 212 175"
      fill="none"
    >
      <path
        d="M106.368 174.449C164.703 174.449 211.992 162.754 211.992 148.327C211.992 133.901 164.703 122.205 106.368 122.205C48.0336 122.205 0.744141 133.901 0.744141 148.327C0.744141 162.754 48.0336 174.449 106.368 174.449Z"
        fill="url(#paint0_linear_3238_243813)"
      />
      <path
        d="M169.368 80.8534H155.755C157.142 84.6179 157.9 88.6805 157.9 92.9148V143.898C157.9 145.663 157.59 147.357 157.026 148.933H179.533C187.94 148.933 194.78 142.156 194.78 133.826V106.033C194.78 92.149 183.381 80.8534 169.368 80.8534ZM55.624 92.9152C55.624 88.6805 56.3822 84.6182 57.7698 80.8537H44.1559C30.1439 80.8537 18.7441 92.1493 18.7441 106.033V133.826C18.7441 142.157 25.5838 148.934 33.9912 148.934H56.4984C55.9191 147.317 55.6234 145.614 55.624 143.898V92.9152ZM122.324 67.7355H91.2005C77.1885 67.7355 65.7888 79.0311 65.7888 92.9152V143.898C65.7888 146.679 68.0642 148.934 70.8711 148.934H142.653C145.46 148.934 147.736 146.679 147.736 143.898V92.9152C147.736 79.0311 136.336 67.7355 122.324 67.7355ZM106.762 0.970825C89.9109 0.970825 76.2014 14.5551 76.2014 31.2528C76.2014 42.5787 82.5101 52.4703 91.827 57.6637C96.2461 60.1268 101.341 61.5345 106.762 61.5345C112.184 61.5345 117.278 60.1268 121.697 57.6637C131.015 52.4703 137.323 42.5784 137.323 31.2528C137.323 14.5554 123.614 0.970825 106.762 0.970825ZM53.098 29.1958C40.4953 29.1958 30.2425 39.3549 30.2425 51.8425C30.2425 64.3301 40.4953 74.4892 53.098 74.4892C56.195 74.4918 59.2598 73.8671 62.1044 72.6536C66.8855 70.6139 70.8278 67.0034 73.2672 62.4809C75.0343 59.2085 75.9572 55.5538 75.9535 51.8425C75.9535 39.3552 65.7007 29.1958 53.098 29.1958ZM160.426 29.1958C147.824 29.1958 137.571 39.3549 137.571 51.8425C137.567 55.5539 138.49 59.2085 140.257 62.4809C142.697 67.0037 146.639 70.6143 151.42 72.6536C154.265 73.8671 157.329 74.4918 160.426 74.4892C173.029 74.4892 183.282 64.3301 183.282 51.8425C183.282 39.3549 173.029 29.1958 160.426 29.1958Z"
        fill="url(#paint1_linear_3238_243813)"
      />
      <path
        d="M91.2007 67.7355H122.324C136.336 67.7355 147.736 79.0311 147.736 92.9152V143.898C147.736 146.679 145.46 148.934 142.653 148.934H70.8712C68.0643 148.934 65.7889 146.679 65.7889 143.898V92.9152C65.7889 79.0311 77.1886 67.7355 91.2007 67.7355Z"
        fill="url(#paint2_linear_3238_243813)"
      />
      <path
        d="M76.2015 31.2528C76.2015 14.5551 89.911 0.970825 106.762 0.970825C123.614 0.970825 137.323 14.5554 137.323 31.2528C137.323 42.5784 131.015 52.4703 121.698 57.6637C117.278 60.1268 112.184 61.5345 106.762 61.5345C101.341 61.5345 96.2462 60.1268 91.8271 57.6637C82.5102 52.4703 76.2015 42.5787 76.2015 31.2528Z"
        fill="url(#paint3_linear_3238_243813)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3238_243813"
          x1="118.244"
          y1="262.295"
          x2="115.744"
          y2="78.7949"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0CFFF" />
          <stop offset="1" stopColor="#70A8FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3238_243813"
          x1="167"
          y1="24"
          x2="172.524"
          y2="176.503"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8CB6F6" />
          <stop offset="1" stopColor="#5E8FDC" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3238_243813"
          x1="107"
          y1="168.5"
          x2="19.4322"
          y2="69.6289"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#81ADEA" />
          <stop offset="1" stopColor="#C3DAFE" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3238_243813"
          x1="107"
          y1="168.5"
          x2="19.4322"
          y2="69.6289"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#81ADEA" />
          <stop offset="1" stopColor="#C3DAFE" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const DarkFiltersEmptyState = (props: any) => {
  return (
    <Icon
      {...props}
      $size={212}
      width="212"
      height="159"
      viewBox="0 0 212 159"
      fill="none"
    >
      <path
        d="M105.624 158.443C163.959 158.443 211.248 146.748 211.248 132.321C211.248 117.894 163.959 106.199 105.624 106.199C47.2895 106.199 0 117.894 0 132.321C0 146.748 47.2895 158.443 105.624 158.443Z"
        fill="url(#paint0_linear_465_395)"
      />
      <path
        d="M118.5 71.2415C118.811 63.6459 123.732 56.9859 128.658 51.1958C130.359 49.1961 131.891 46.99 133.206 44.71L152.956 11.7246L59.4782 11.7246L79.2273 44.71C80.5845 47.0626 82.1725 49.3342 83.9389 51.382C88.8571 57.0836 93.7853 63.6216 94.1954 71.1401L95.9666 103.612C96.0533 105.203 97.3687 106.448 98.9621 106.448H103.142C103.956 106.448 104.735 106.118 105.3 105.532L116.827 93.5937C117.338 93.0649 117.636 92.367 117.666 91.6326L118.5 71.2415Z"
        fill="url(#paint1_linear_465_395)"
      />
      <path
        d="M118.5 71.2415C118.811 63.6459 123.732 56.9859 128.658 51.1958C130.359 49.1961 131.891 46.99 133.206 44.71L152.956 11.7246L59.4782 11.7246L79.2273 44.71C80.5845 47.0626 82.1725 49.3342 83.9389 51.382C88.8571 57.0836 93.7853 63.6216 94.1954 71.1401L95.9666 103.612C96.0533 105.203 97.3687 106.448 98.9621 106.448H103.142C103.956 106.448 104.735 106.118 105.3 105.532L116.827 93.5937C117.338 93.0649 117.636 92.367 117.666 91.6326L118.5 71.2415Z"
        fill="url(#paint2_linear_465_395)"
      />
      <path
        d="M118.5 71.2415C118.811 63.6459 123.732 56.9859 128.658 51.1958C130.359 49.1961 131.891 46.99 133.206 44.71L152.956 11.7246L59.4782 11.7246L79.2273 44.71C80.5845 47.0626 82.1725 49.3342 83.9389 51.382C88.8571 57.0836 93.7853 63.6216 94.1954 71.1401L95.9666 103.612C96.0533 105.203 97.3687 106.448 98.9621 106.448H103.142C103.956 106.448 104.735 106.118 105.3 105.532L116.827 93.5937C117.338 93.0649 117.636 92.367 117.666 91.6326L118.5 71.2415Z"
        fill="url(#paint3_linear_465_395)"
      />
      <g filter="url(#filter0_f_465_395)">
        <rect
          x="61.9709"
          y="4.24658"
          width="88.4919"
          height="14.9564"
          rx="7.47819"
          fill="url(#paint4_linear_465_395)"
          fillOpacity="0.3"
        />
      </g>
      <rect
        x="52"
        y="3"
        width="108.434"
        height="14.9564"
        rx="7.47819"
        fill="url(#paint5_linear_465_395)"
      />
      <path
        d="M62.4057 94.5646C55.1625 97.3521 47.4849 98.8419 39.7248 98.9656C40.5967 101.462 47.1499 114.109 68.4306 125.647C69.0184 125.78 83.1945 120.359 91.0355 116.509C90.7538 116.856 68.2083 106.714 62.4057 94.5646Z"
        fill="url(#paint6_linear_465_395)"
      />
      <path
        d="M61.9684 105.506C61.6777 105.192 61.2379 105.063 60.8237 105.171L52.1289 107.432C51.7455 107.532 51.5808 107.985 51.8106 108.308C51.9982 108.571 52.3296 108.691 52.6425 108.609L61.7662 106.201C62.0742 106.12 62.1848 105.74 61.9684 105.506Z"
        fill="#D7E7FF"
      />
      <path
        d="M66.3573 108.247C66.0509 107.965 65.6191 107.862 65.2182 107.977L55.1843 110.845C54.7905 110.958 54.6407 111.437 54.9002 111.753C55.0988 111.996 55.4227 112.097 55.7237 112.01L66.1833 108.984C66.5085 108.89 66.6061 108.477 66.3573 108.247Z"
        fill="#D7E7FF"
      />
      <path
        d="M73.0489 110.33C72.7325 110.099 72.3271 110.027 71.9507 110.136L58.7362 113.941C58.3138 114.062 58.1763 114.592 58.4863 114.904C58.6913 115.11 58.9925 115.188 59.2716 115.107L72.9058 111.145C73.2734 111.038 73.3582 110.555 73.0489 110.33Z"
        fill="#D7E7FF"
      />
      <path
        d="M127.857 107.92C136.749 111.342 146.174 113.171 155.7 113.323C154.63 116.387 146.585 131.914 120.461 146.077C119.739 146.24 102.337 139.585 92.7109 134.859C93.0567 135.286 120.734 122.835 127.857 107.92Z"
        fill="url(#paint7_linear_465_395)"
      />
      <path
        d="M128.393 121.352C128.75 120.967 129.29 120.809 129.798 120.941L140.472 123.718C140.943 123.84 141.145 124.396 140.863 124.792C140.633 125.116 140.226 125.263 139.842 125.162L128.641 122.206C128.263 122.106 128.128 121.639 128.393 121.352Z"
        fill="#E2EEFF"
      />
      <path
        d="M123.006 124.718C123.382 124.37 123.912 124.244 124.405 124.385L136.722 127.906C137.206 128.045 137.389 128.633 137.071 129.022C136.827 129.319 136.429 129.443 136.06 129.336L123.22 125.622C122.821 125.507 122.701 124.999 123.006 124.718Z"
        fill="#E2EEFF"
      />
      <path
        d="M114.792 127.274C115.18 126.99 115.678 126.902 116.14 127.036L132.362 131.707C132.88 131.856 133.049 132.507 132.669 132.889C132.417 133.142 132.047 133.238 131.705 133.138L114.967 128.274C114.516 128.143 114.412 127.551 114.792 127.274Z"
        fill="#E2EEFF"
      />
      <defs>
        <filter
          id="filter0_f_465_395"
          x="57.9709"
          y="0.246582"
          width="96.4919"
          height="22.9565"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2"
            result="effect1_foregroundBlur_465_395"
          />
        </filter>
        <linearGradient
          id="paint0_linear_465_395"
          x1="117.5"
          y1="246.289"
          x2="115"
          y2="62.7888"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0CFFF" />
          <stop offset="1" stopColor="#70A8FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_465_395"
          x1="91.2605"
          y1="-104.187"
          x2="129.46"
          y2="104.331"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D7E7FF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_465_395"
          x1="381.04"
          y1="127.013"
          x2="105.202"
          y2="116.332"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0069FF" />
          <stop offset="1" stopColor="#0069FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_465_395"
          x1="16"
          y1="85"
          x2="168.92"
          y2="35.5559"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0069FF" />
          <stop offset="0.285958" stopColor="#0069FF" stopOpacity="0.28" />
          <stop offset="0.579166" stopColor="#0069FF" stopOpacity="0.04" />
          <stop offset="0.989861" stopColor="#0069FF" stopOpacity="0.18" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_465_395"
          x1="194.819"
          y1="22.8084"
          x2="162.736"
          y2="-99.3667"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0044A5" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_465_395"
          x1="197.5"
          y1="21.5"
          x2="169.208"
          y2="-104.972"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_465_395"
          x1="30.6889"
          y1="95.1938"
          x2="111"
          y2="137"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5597FD" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_465_395"
          x1="165.267"
          y1="118.381"
          x2="25"
          y2="130.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5597FD" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const DarkGearsEmptyState = (props: any) => {
  return (
    <Icon {...props} width="255" height="169" viewBox="0 0 255 169" fill="none">
      <path
        d="M127.5 168.461C197.916 168.461 255 154.358 255 136.961C255 119.564 197.916 105.461 127.5 105.461C57.0837 105.461 0 119.564 0 136.961C0 154.358 57.0837 168.461 127.5 168.461Z"
        fill="url(#paint0_linear_3256_97036)"
      />
      <path
        d="M185.09 52.452L175.352 51.1407C174.372 47.7201 173.025 44.4157 171.334 41.2852L178.555 28.9974C178.815 28.5073 178.911 27.9463 178.827 27.3976C178.743 26.849 178.484 26.3421 178.09 25.952L167.59 15.952C167.2 15.5572 166.614 15.0904 166.09 14.952C165.565 14.8136 160.58 11.6917 160.09 11.952L151.75 21.5321C148.588 19.7583 145.563 18.4895 142.09 17.452L138.09 5.45204C137.911 4.93607 137.573 4.49018 137.124 4.17854C136.676 3.8669 133.09 0.951981 132.09 0.451981L120.745 1.56741C120.196 1.56996 119.662 1.74774 119.221 2.07487C118.779 2.402 118.454 2.8614 118.292 3.38622L114.062 17.3446C110.56 18.3765 107.183 19.7952 103.995 21.5744L91.3057 14.7221C90.8156 14.4618 90.2546 14.3665 89.7059 14.4503C89.1573 14.5341 88.6504 14.7926 88.2603 15.1874L77.9819 25.212C77.5871 25.6021 77.3286 26.109 77.2448 26.6577C77.161 27.2063 77.2563 27.7673 77.5166 28.2574L84.3689 40.9469C82.5926 44.1217 81.174 47.4838 80.1391 50.9715L66.1384 55.2013C65.6136 55.3634 65.1542 55.6887 64.8271 56.1299C64.4999 56.5712 64.3222 57.1053 64.3196 57.6546L61.1472 71.3585C60.8201 70.9172 61.1498 71.9077 61.1472 71.3585C61.4744 71.7997 65.6136 74.2425 66.1384 74.4046L80.2237 78.6344C81.2699 82.064 82.6882 85.3688 84.4535 88.4898L77.5166 101.771C77.2563 102.262 77.161 102.823 77.2448 103.371C77.3286 103.92 77.5871 104.427 77.9819 104.817L85.0896 113.452C85.4797 113.847 88.9881 115.579 89.5367 115.663C90.0854 115.747 90.6464 115.652 91.1365 115.391L102.884 109.452C105.976 111.12 110.56 111.413 113.935 112.388L115.09 125.952C116.09 126.452 118.652 127.627 119.094 127.954C119.535 128.281 120.069 128.459 120.618 128.461H134.915C135.464 128.459 135.998 128.281 136.44 127.954C136.881 127.627 137.206 127.167 137.368 126.643L141.598 112.346C144.945 111.366 148.177 110.033 151.242 108.37L160 114.961L163.9 115.69C164.39 115.95 164.951 116.045 165.5 115.961C166.049 115.878 166.556 115.619 166.946 115.224L177.551 104.817C177.946 104.427 178.205 103.92 178.288 103.371C178.372 102.823 178.277 102.262 178.017 101.771L170.995 88.659C172.676 85.5826 173.599 83.8147 174.59 80.452L187.565 76.8806C188.09 76.7186 188.549 76.3932 188.877 75.952C189.204 75.5107 189.381 74.9766 189.384 74.4273L189.268 58.452C189.293 57.926 189.156 57.405 188.877 56.9589C188.597 56.5128 186.147 52.452 185.09 52.452ZM127.894 88.2783C123.292 88.2783 133.826 82.0177 130 79.4614C126.174 76.9052 124 80.952 119.5 77.9614C116 73.9614 113.566 71.4212 113 67.4614C112.5 63.9614 113.247 59.7149 116.5 56.4614C119 53.9614 122.5 52.4614 127 52.9614C131.5 53.4614 134.5 55.9614 141.5 62.4614C145.751 64.2222 144.68 48.264 147.237 52.0897C149.793 55.9154 151.157 60.4132 151.157 65.0144C151.157 71.1844 148.706 77.1016 144.344 81.4645C139.981 85.8273 134.063 88.2783 127.894 88.2783Z"
        fill="#507DD3"
      />
      <path
        d="M234.044 23.8769L230.253 23.3665C229.872 22.0351 229.348 20.749 228.689 19.5305L231.5 14.7478C231.601 14.5571 231.638 14.3387 231.606 14.1252C231.573 13.9116 231.473 13.7143 231.319 13.5625L227.232 9.67027C227.08 9.51661 226.853 9.3349 226.648 9.28104C226.444 9.22719 224.504 8.01207 224.313 8.11338L221.067 11.8422C219.836 11.1518 218.659 10.6579 217.307 10.2541L215.75 5.58346C215.68 5.38264 215.549 5.20908 215.374 5.08779C215.2 4.96649 213.804 3.83194 213.415 3.63733L208.999 4.07148C208.785 4.07247 208.578 4.14167 208.406 4.26899C208.234 4.39632 208.107 4.57513 208.044 4.7794L206.398 10.2123C205.035 10.614 203.721 11.1661 202.48 11.8586L197.541 9.19157C197.35 9.09025 197.132 9.05316 196.918 9.08578C196.705 9.1184 196.507 9.21901 196.355 9.37266L192.355 13.2745C192.201 13.4263 192.101 13.6236 192.068 13.8371C192.035 14.0507 192.072 14.269 192.174 14.4598L194.841 19.3988C194.149 20.6345 193.597 21.9431 193.194 23.3006L187.745 24.9469C187.541 25.01 187.362 25.1367 187.235 25.3084C187.107 25.4801 187.038 25.688 187.037 25.9018L185.802 31.2357C185.675 31.0639 185.803 31.4495 185.802 31.2357C185.93 31.4074 187.541 32.3582 187.745 32.4213L193.227 34.0676C193.635 35.4025 194.187 36.6888 194.874 37.9036L192.174 43.073C192.072 43.2638 192.035 43.4822 192.068 43.6957C192.101 43.9092 192.201 44.1066 192.355 44.2584L195.121 47.6194C195.273 47.773 196.639 48.4474 196.852 48.48C197.066 48.5126 197.284 48.4755 197.475 48.3742L202.047 46.0625C203.251 46.7118 205.035 46.8259 206.349 47.2053L206.798 52.4847C207.187 52.6793 208.185 53.1365 208.356 53.2639C208.528 53.3912 208.736 53.4604 208.95 53.4614H214.514C214.728 53.4604 214.936 53.3912 215.108 53.2639C215.28 53.1365 215.406 52.9577 215.469 52.7535L217.116 47.1889C218.418 46.8075 219.676 46.2887 220.869 45.6413L224 48L225.989 48.3742C226.18 48.4755 226.399 48.5126 226.612 48.48C226.826 48.4474 227.023 48.3468 227.175 48.1931L231.109 44.2584C231.263 44.1066 231.364 43.9092 231.396 43.6957C231.429 43.4822 231.392 43.2638 231.291 43.073L228.558 37.9694C229.212 36.772 229.571 36.0839 229.957 34.7751L235.007 33.385C235.211 33.3219 235.39 33.1953 235.517 33.0236C235.645 32.8518 235.714 32.6439 235.715 32.4301L235.67 26.2122C235.68 26.0075 235.626 25.8047 235.517 25.6311C235.409 25.4574 234.455 23.8769 234.044 23.8769ZM211.782 37.8212C209.991 37.8212 214.091 35.3845 212.601 34.3895C211.112 33.3946 210.266 34.9697 208.515 33.8057C207.152 32.2488 206.205 31.2601 205.985 29.7189C205.79 28.3566 206.081 26.7038 207.347 25.4374C208.32 24.4644 209.682 23.8805 211.434 24.0751C213.185 24.2698 214.353 25.2428 217.078 27.7728C218.732 28.4581 218.315 22.2468 219.31 23.7358C220.305 25.2249 220.836 26.9756 220.836 28.7664C220.836 31.1679 219.882 33.471 218.184 35.1691C216.486 36.8673 214.183 37.8212 211.782 37.8212Z"
        fill="#507DD3"
      />
      <path
        d="M65.0819 108.06L61.4433 107.57C61.0773 106.292 60.5739 105.057 59.9419 103.888L62.6402 99.2963C62.7374 99.1132 62.773 98.9036 62.7417 98.6986C62.7104 98.4936 62.6138 98.3042 62.4663 98.1584L58.543 94.4219C58.3972 94.2744 58.1786 94.0999 57.9825 94.0482C57.7864 93.9965 55.9237 92.83 55.7406 92.9273L52.6243 96.5069C51.443 95.8441 50.3126 95.37 49.0148 94.9824L47.5202 90.4985C47.4533 90.3057 47.327 90.1391 47.1595 90.0227C46.9919 89.9062 45.6519 88.8171 45.2783 88.6302L41.0394 89.047C40.8341 89.048 40.6346 89.1144 40.4697 89.2366C40.3048 89.3589 40.1832 89.5305 40.1227 89.7266L38.5422 94.9422C37.2336 95.3278 35.972 95.8579 34.7807 96.5227L30.0392 93.9623C29.8561 93.8651 29.6465 93.8294 29.4415 93.8608C29.2365 93.8921 29.047 93.9887 28.9013 94.1362L25.0607 97.8819C24.9132 98.0277 24.8166 98.2171 24.7853 98.4221C24.754 98.6271 24.7896 98.8367 24.8869 99.0198L27.4472 103.761C26.7835 104.948 26.2535 106.204 25.8668 107.507L20.6354 109.087C20.4393 109.148 20.2676 109.27 20.1454 109.434C20.0232 109.599 19.9567 109.799 19.9558 110.004L18.7704 115.125C18.6482 114.96 18.7714 115.33 18.7704 115.125C18.8927 115.29 20.4393 116.202 20.6354 116.263L25.8984 117.843C26.2893 119.125 26.8193 120.36 27.4789 121.526L24.8869 126.489C24.7896 126.672 24.754 126.881 24.7853 127.086C24.8166 127.291 24.9132 127.481 25.0607 127.627L27.7166 130.853C27.8623 131.001 29.1733 131.648 29.3782 131.679C29.5832 131.711 29.7929 131.675 29.976 131.578L34.3655 129.358C35.5208 129.982 37.2336 130.091 38.4948 130.456L38.9262 135.524C39.2998 135.711 40.2574 136.15 40.4223 136.272C40.5871 136.394 40.7867 136.46 40.992 136.461H46.334C46.5392 136.46 46.7388 136.394 46.9037 136.272C47.0685 136.15 47.1901 135.978 47.2506 135.782L48.8311 130.44C50.0815 130.074 51.2895 129.576 52.4346 128.954L55.5 131L57.3499 131.578C57.533 131.675 57.7427 131.711 57.9477 131.679C58.1527 131.648 58.3421 131.551 58.4878 131.404L62.2652 127.627C62.4127 127.481 62.5093 127.291 62.5406 127.086C62.5719 126.881 62.5363 126.672 62.439 126.489L59.8154 121.589C60.4435 120.44 60.7884 119.779 61.1585 118.523L66.0069 117.188C66.203 117.127 66.3747 117.006 66.4969 116.841C66.6191 116.676 66.6855 116.477 66.6865 116.271L66.6431 110.302C66.6524 110.106 66.6014 109.911 66.4969 109.744C66.3924 109.578 65.477 108.06 65.0819 108.06ZM43.7104 121.447C41.9911 121.447 45.927 119.108 44.4975 118.152C43.068 117.197 42.2556 118.709 40.5741 117.592C39.2663 116.097 38.3568 115.148 38.1454 113.669C37.9586 112.361 38.2375 110.774 39.4532 109.558C40.3873 108.624 41.6951 108.064 43.3765 108.251C45.058 108.437 46.1789 109.372 48.7945 111.8C50.3829 112.458 49.9829 106.495 50.938 107.925C51.8932 109.354 52.403 111.035 52.403 112.754C52.403 115.06 51.4872 117.271 49.857 118.901C48.2268 120.531 46.0158 121.447 43.7104 121.447Z"
        fill="#507DD3"
      />
      <path
        d="M184.695 51.9657L171.032 49.0351C170.053 45.6145 168.705 42.3101 167.014 39.1797L173.951 26.1942C174.211 25.7041 174.306 25.143 174.223 24.5944C174.139 24.0458 173.88 23.5388 173.486 23.1488L161.946 12.6984C161.556 12.3036 161.049 12.0451 160.5 11.9613C159.951 11.8775 159.39 11.9728 158.9 12.2331L146.5 18.9613C143.339 17.1876 141.473 16.4988 138 15.4613L132.965 1.73487C132.786 1.2189 132.448 0.773005 132 0.461365C131.552 0.149726 131.016 -0.0115865 130.47 0.000647873L114.953 0.142535C114.404 0.145092 113.87 0.322871 113.429 0.649998C112.987 0.977125 112.662 1.43653 112.5 1.96135L109 14.9612C105.498 15.9932 103.188 17.1821 100 18.9612L87.5455 12.4959C87.0553 12.2357 86.4943 12.1403 85.9457 12.2242C85.397 12.308 84.8901 12.5665 84.5 12.9612L72.7371 24.5156C72.3423 24.9056 72.0838 25.4126 72 25.9612C71.9162 26.5098 72.0115 27.0709 72.2718 27.561L79 39.9612C77.2237 43.1361 75.5349 45.4736 74.5 48.9612L62 52.4612C61.4752 52.6233 61.0158 52.9486 60.6886 53.3899C60.3615 53.8311 60.1837 54.3652 60.1812 54.9145L60.1812 71.008C60.1837 71.5572 60.3615 72.0914 60.6886 72.5326C61.0157 72.9738 61.4751 73.2992 62 73.4612L75.5 77.9612C76.5462 81.3908 77.2348 83.0518 79 86.1728L72.0347 98.4158C71.7744 98.9059 71.6791 99.467 71.7629 100.016C71.8467 100.564 72.1052 101.071 72.5 101.461L83.7714 112.821C84.1615 113.215 84.6685 113.474 85.2171 113.558C85.7657 113.641 86.3267 113.546 86.8169 113.286L99.887 106.307C102.979 107.975 106.24 109.308 109.616 110.283L113.845 124.537C114.007 125.062 114.333 125.521 114.774 125.848C115.215 126.176 115.749 126.353 116.299 126.356H130.595C131.145 126.353 131.679 126.176 132.12 125.848C132.561 125.521 132.887 125.062 133.049 124.537L138 110.461C141.346 109.482 143.935 108.625 147 106.961L158.9 114.69C159.39 114.95 159.951 115.045 160.5 114.961C161.049 114.877 161.556 114.619 161.946 114.224L173.763 102.907C174.158 102.517 174.416 102.01 174.5 101.461C174.584 100.913 174.489 100.352 174.228 99.8615L167 86.4613C168.681 83.385 170.042 80.824 171.032 77.4613L184.948 73.89C185.473 73.7279 185.932 73.4025 186.26 72.9613C186.587 72.5201 186.765 71.9859 186.767 71.4367L186.26 54.4613C186.285 53.9353 186.148 53.4143 185.868 52.9682C185.589 52.5221 185.179 52.1723 184.695 51.9657ZM123.574 86.1728C118.973 86.1728 114.475 84.8084 110.649 82.2521C106.823 79.6958 103.842 76.0625 102.081 71.8116C100.32 67.5607 99.8593 62.8831 100.757 58.3703C101.655 53.8576 103.87 49.7123 107.124 46.4588C110.377 43.2053 114.523 40.9896 119.035 40.092C123.548 39.1943 128.226 39.655 132.477 41.4158C136.728 43.1766 140.361 46.1584 142.917 49.9841C145.473 53.8099 146.838 58.3077 146.838 62.9089C146.838 69.0788 144.387 74.9961 140.024 79.359C135.661 83.7218 129.744 86.1728 123.574 86.1728Z"
        fill="url(#paint1_linear_3256_97036)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M123 87.4614C136.255 87.4614 147 76.7163 147 63.4614C147 50.2066 136.255 39.4614 123 39.4614C109.745 39.4614 99 50.2066 99 63.4614C99 76.7163 109.745 87.4614 123 87.4614ZM123 76.4614C130.18 76.4614 136 70.6411 136 63.4614C136 56.2817 130.18 50.4614 123 50.4614C115.82 50.4614 110 56.2817 110 63.4614C110 70.6411 115.82 76.4614 123 76.4614Z"
        fill="url(#paint2_linear_3256_97036)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M228.785 22.4769L234.181 23.6134C234.373 23.6935 234.534 23.8292 234.645 24.0022C234.755 24.1752 234.809 24.3772 234.8 24.5812L235 31.1641C234.999 31.3771 234.929 31.5842 234.8 31.7553C234.67 31.9265 234.489 32.0526 234.282 32.1155L228.785 33.5004C228.394 34.8045 227.856 35.7976 227.192 36.9906L230.047 42.1871C230.15 42.3772 230.188 42.5947 230.155 42.8075C230.122 43.0202 230.019 43.2168 229.864 43.3681L225.196 47.7569C225.042 47.9099 224.841 48.0102 224.625 48.0427C224.408 48.0752 224.187 48.0382 223.993 47.9373L219.292 44.9403C218.082 45.5854 217.059 45.9177 215.738 46.2976L213.782 51.7561C213.718 51.9596 213.589 52.1378 213.415 52.2646C213.241 52.3915 213.03 52.4604 212.813 52.4614H207.166C206.949 52.4604 206.738 52.3915 206.564 52.2646C206.389 52.1378 206.261 51.9596 206.197 51.7561L204.526 46.2283C203.193 45.8503 201.905 45.3334 200.683 44.6865L195.521 47.3929C195.327 47.4939 195.106 47.5308 194.889 47.4983C194.672 47.4658 194.472 47.3656 194.318 47.2125L189.866 42.8074C189.71 42.6562 189.608 42.4596 189.575 42.2468C189.542 42.0341 189.579 41.8165 189.682 41.6264L192.433 36.8787C191.736 35.6684 191.464 35.0243 191.051 33.6943L185.718 31.9492C185.511 31.8864 185.33 31.7602 185.2 31.5891C185.071 31.418 185.001 31.2109 185 30.9979L185 24.7569C185.001 24.5439 185.071 24.3368 185.2 24.1657C185.33 23.9946 185.511 23.8684 185.718 23.8055L190.656 22.4483C190.969 21.4118 191.434 20.6373 191.95 19.7778C192.107 19.5158 192.269 19.2458 192.433 18.9581L189.776 14.1494C189.673 13.9593 189.635 13.7418 189.668 13.529C189.701 13.3163 189.804 13.1197 189.959 12.9684L194.606 8.4877C194.76 8.33462 194.96 8.23438 195.177 8.20188C195.393 8.16937 195.615 8.20634 195.809 8.30727L200.728 10.8145C201.987 10.1245 202.9 9.66349 204.283 9.26329L205.665 4.22202C205.729 4.0185 205.858 3.84035 206.032 3.71349C206.206 3.58663 206.417 3.51769 206.634 3.5167L212.763 3.46168C212.979 3.45693 213.19 3.51949 213.368 3.64034C213.545 3.76119 213.678 3.93411 213.749 4.1342L215.738 9.45722C217.109 9.85956 217.846 10.1267 219.095 10.8145L223.993 8.20534C224.187 8.1044 224.408 8.06744 224.625 8.09994C224.841 8.13245 225.042 8.23268 225.196 8.38577L229.754 12.4384C229.91 12.5896 230.012 12.7862 230.045 12.999C230.078 13.2117 230.041 13.4293 229.938 13.6194L227.198 18.6551C227.866 19.869 228.398 21.1505 228.785 22.4769ZM214.937 28.1619C214.937 30.9564 212.671 33.2218 209.877 33.2218C207.082 33.2218 204.817 30.9564 204.817 28.1619C204.817 25.3674 207.082 23.1021 209.877 23.1021C212.671 23.1021 214.937 25.3674 214.937 28.1619Z"
        fill="url(#paint3_linear_3256_97036)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.0336 106.716L65.2142 107.807C65.3978 107.884 65.5531 108.014 65.6592 108.181C65.7653 108.347 65.8171 108.541 65.8076 108.736L66 115.056C65.9991 115.261 65.9317 115.459 65.8076 115.624C65.6836 115.788 65.5094 115.909 65.3104 115.969L60.0336 117.299C59.658 118.551 59.1419 119.504 58.5046 120.649L61.2454 125.638C61.3441 125.821 61.3803 126.029 61.3485 126.234C61.3167 126.438 61.2187 126.627 61.069 126.772L56.588 130.985C56.4401 131.132 56.2479 131.228 56.0398 131.259C55.8318 131.291 55.6191 131.255 55.4332 131.158L50.9208 128.281C49.7587 128.9 48.777 129.219 47.5081 129.584L45.6306 134.824C45.5691 135.02 45.4458 135.191 45.2784 135.313C45.1111 135.434 44.9086 135.501 44.7003 135.501H39.2791C39.0709 135.501 38.8683 135.434 38.701 135.313C38.5337 135.191 38.4103 135.02 38.3489 134.824L36.745 129.518C35.4651 129.155 34.2284 128.659 33.056 128.037L28.1 130.636C27.9141 130.733 27.7014 130.768 27.4934 130.737C27.2853 130.706 27.0931 130.609 26.9452 130.462L22.6712 126.234C22.5215 126.088 22.4235 125.9 22.3917 125.695C22.3599 125.491 22.396 125.282 22.4947 125.1L25.1359 120.542C24.4665 119.38 24.2054 118.762 23.8087 117.485L18.6897 115.81C18.4907 115.749 18.3165 115.628 18.1924 115.464C18.0684 115.3 18.001 115.101 18 114.896L18 108.905C18.001 108.701 18.0684 108.502 18.1924 108.338C18.3165 108.173 18.4907 108.052 18.6897 107.992L23.4296 106.689C23.7303 105.694 24.1766 104.95 24.6719 104.125C24.823 103.874 24.9785 103.614 25.1359 103.338L22.5846 98.7219C22.4859 98.5394 22.4498 98.3306 22.4816 98.1263C22.5134 97.9221 22.6114 97.7334 22.7611 97.5881L27.2214 93.2867C27.3694 93.1397 27.5616 93.0435 27.7696 93.0123C27.9777 92.9811 28.1904 93.0165 28.3763 93.1134L33.0989 95.5204C34.3078 94.858 35.1836 94.4154 36.5116 94.0312L37.8388 89.1916C37.9002 88.9962 38.0236 88.8252 38.1909 88.7034C38.3582 88.5816 38.5607 88.5154 38.769 88.5145L44.6527 88.4617C44.8597 88.4571 45.0629 88.5172 45.2329 88.6332C45.403 88.7492 45.5312 88.9152 45.599 89.1073L47.5081 94.2174C48.8251 94.6036 49.5325 94.8601 50.7312 95.5204L55.4332 93.0156C55.6191 92.9187 55.8318 92.8832 56.0398 92.9144C56.2479 92.9456 56.4401 93.0418 56.588 93.1888L60.9638 97.0793C61.1135 97.2245 61.2115 97.4132 61.2433 97.6175C61.2751 97.8217 61.2389 98.0306 61.1402 98.2131L58.5099 103.047C59.1512 104.213 59.6621 105.443 60.0336 106.716ZM46.7394 112.174C46.7394 114.857 44.5646 117.031 41.8819 117.031C39.1992 117.031 37.0244 114.857 37.0244 112.174C37.0244 109.491 39.1992 107.316 41.8819 107.316C44.5646 107.316 46.7394 109.491 46.7394 112.174Z"
        fill="url(#paint4_linear_3256_97036)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3256_97036"
          x1="141.836"
          y1="274.392"
          x2="138.824"
          y2="53.1137"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0CFFF" />
          <stop offset="1" stopColor="#70A8FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3256_97036"
          x1="159.5"
          y1="16.9614"
          x2="79"
          y2="99.4614"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BFD5FC" />
          <stop offset="1" stopColor="#7BAAF9" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3256_97036"
          x1="119.5"
          y1="43.4614"
          x2="133.5"
          y2="82.9614"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8EB4FA" />
          <stop offset="1" stopColor="#5F94F7" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3256_97036"
          x1="204"
          y1="61"
          x2="229.5"
          y2="10.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#86AEF9" />
          <stop offset="1" stopColor="#BED5FD" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3256_97036"
          x1="29.5"
          y1="133.5"
          x2="60"
          y2="93.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#86AEF9" />
          <stop offset="1" stopColor="#BED5FD" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const CornixDashboardLogo = ({
  primaryColor,
  secondaryColor,
  ...props
}: any) => {
  return (
    <svg {...props} width="150" height="41" viewBox="0 0 150 41" fill="none">
      <path
        d="M29.8942 17.3933L23.7923 20.6422C22.6642 19.4925 21.5361 18.6928 20.408 18.193C19.2799 17.7431 17.998 17.4932 16.4597 17.4932C13.7421 17.4932 11.5372 18.2929 9.84508 19.8924C8.15296 21.4919 7.33253 23.4912 7.33253 25.9903C7.33253 28.3895 8.15296 30.3889 9.7938 31.8884C11.4347 33.4378 13.537 34.1876 16.2034 34.1876C19.4851 34.1876 21.9976 33.0879 23.8435 30.9387L29.5865 34.7874C26.4587 38.736 22.0489 40.7354 16.3572 40.7354C11.2295 40.7354 7.22998 39.2359 4.3585 36.2869C1.48702 33.3379 0 29.889 0 25.8904C0 23.1413 0.717873 20.5922 2.10234 18.2929C3.4868 15.9937 5.48658 14.1443 7.99913 12.8448C10.5117 11.5452 13.3319 10.8455 16.4597 10.8455C19.3312 10.8455 21.9463 11.3953 24.2538 12.5449C26.5612 13.7445 28.4584 15.3439 29.8942 17.3933Z"
        fill={primaryColor}
      />
      <path
        d="M47.4316 10.9468C50.2005 10.9468 52.7643 11.5966 55.1743 12.9461C57.5843 14.2956 59.4816 16.0951 60.8148 18.3943C62.1479 20.6935 62.8658 23.1427 62.8658 25.8418C62.8658 28.5408 62.1992 31.04 60.8148 33.3392C59.4303 35.6884 57.5843 37.4878 55.2256 38.7874C52.8669 40.0869 50.2518 40.7367 47.4316 40.7367C43.2782 40.7367 39.6889 39.2872 36.7661 36.3882C33.7921 33.4892 32.3563 29.9904 32.3563 25.8418C32.3563 21.3933 34.0484 17.6945 37.3814 14.7455C40.2529 12.2463 43.5859 10.9468 47.4316 10.9468ZM47.5342 17.6445C45.278 17.6445 43.3808 18.3943 41.8425 19.9437C40.3554 21.4932 39.5863 23.4426 39.5863 25.8418C39.5863 28.2909 40.3554 30.2903 41.8425 31.8397C43.3295 33.3892 45.2267 34.139 47.5342 34.139C49.8416 34.139 51.7388 33.3892 53.2258 31.8397C54.7129 30.2903 55.482 28.2909 55.482 25.8917C55.482 23.4926 54.7129 21.4932 53.2258 19.9437C51.7388 18.3943 49.8416 17.6445 47.5342 17.6445Z"
        fill={primaryColor}
      />
      <path
        d="M64.3542 11.6965H70.61V15.2453C71.2766 13.8458 72.1995 12.7462 73.3276 12.0464C74.4557 11.2967 75.6863 10.9468 77.0195 10.9468C77.9425 10.9468 78.968 11.1967 79.9936 11.6965L77.7374 17.8445C76.8657 17.4446 76.1991 17.1947 75.6351 17.1947C74.507 17.1947 73.584 17.8944 72.7636 19.244C71.9944 20.5935 71.5842 23.2426 71.5842 27.2413L71.6355 28.6408V40.1369H64.4055V11.6965H64.3542Z"
        fill={primaryColor}
      />
      <path
        d="M81.8385 11.6965H89.1198V14.5956C90.7606 13.246 92.2989 12.2963 93.6321 11.7465C94.9653 11.1967 96.3497 10.9468 97.7342 10.9468C100.606 10.9468 103.067 11.9465 105.067 13.8958C106.759 15.5452 107.579 18.0444 107.579 21.2933V40.037H100.349V27.5912C100.349 24.1923 100.195 21.9431 99.8878 20.8434C99.5802 19.7438 99.0161 18.8941 98.247 18.2943C97.4778 17.6945 96.5036 17.4446 95.3755 17.4446C93.8885 17.4446 92.6066 17.9444 91.581 18.8941C90.5042 19.8438 89.7864 21.1933 89.3761 22.8928C89.171 23.7925 89.0685 25.6918 89.0685 28.6408V40.037H81.8385V11.6965Z"
        fill={primaryColor}
      />
      <path
        d="M114.856 0C116.138 0 117.215 0.449854 118.138 1.34955C119.061 2.24925 119.522 3.34888 119.522 4.64844C119.522 5.89802 119.061 6.99765 118.138 7.89734C117.215 8.79704 116.138 9.24688 114.907 9.24688C113.625 9.24688 112.497 8.79704 111.574 7.89734C110.651 6.99765 110.19 5.89801 110.19 4.54847C110.19 3.29889 110.651 2.24925 111.574 1.34955C112.446 0.449854 113.574 0 114.856 0ZM111.164 11.696H118.445V40.0365H111.164V11.696Z"
        fill={primaryColor}
      />
      <path
        d="M127.068 40.036L147.732 12.1454L148.04 11.6956H139.733L133.99 19.393L128.247 11.6956H119.787L129.786 25.141L118.71 40.036H127.068Z"
        fill={primaryColor}
      />
      <path
        d="M135.219 32.3897L140.86 40.0372H149.371L139.424 26.6917L135.219 32.3897Z"
        fill={secondaryColor}
      />
    </svg>
  );
};

export const IdeaIcon = (props: any) => (
  <Icon
    {...props}
    viewBox="0 0 16 17"
    d={[
      "M3.4065 1.703L2.7025 2.406L3.75 3.453L4.453 2.75L3.4065 1.703ZM12.594 1.703L11.5465 2.75L12.25 3.453L13.297 2.4065L12.594 1.703ZM8 2.015C7.835 2.01634 7.66833 2.027 7.5 2.047H7.485C5.457 2.2795 3.843 3.918 3.5625 5.937C3.3385 7.562 4.0085 9.0355 5.125 9.9845C5.58164 10.3743 5.89054 10.9092 6 11.4995V14.4995H7.14C7.314 14.798 7.6315 14.9995 8 14.9995C8.3685 14.9995 8.686 14.798 8.86 14.4995H10V12.4995H10.047V11.9055C10.047 11.1725 10.428 10.4335 11.047 9.859C11.875 9.03 12.5 7.8525 12.5 6.5C12.5 4.03 10.467 1.992 8 2.015ZM8 3.015C9.9325 2.988 11.5 4.57 11.5 6.5C11.5 7.547 11.015 8.469 10.3435 9.14L10.3595 9.156C9.69246 9.77156 9.26101 10.6005 9.1395 11.5H6.9525C6.8425 10.643 6.475 9.8135 5.7805 9.2185C4.897 8.4685 4.3705 7.3385 4.5465 6.0625C4.765 4.4875 6.043 3.221 7.609 3.0475C7.7383 3.02957 7.86851 3.01889 7.999 3.0155L8 3.015ZM1 6.5V7.5H2.5V6.5H1ZM13.5 6.5V7.5H15V6.5H13.5ZM3.75 10.547L2.703 11.5935L3.4065 12.297L4.4525 11.25L3.75 10.547ZM12.25 10.547L11.547 11.25L12.5935 12.297L13.297 11.5935L12.25 10.547ZM7 12.5H9V13.5H7V12.5Z",
    ]}
  />
);

export const BrokenLink = (props: any) => {
  return (
    <Icon {...props} viewBox="0 0 136 121">
      <path
        d="M68.0004 120.5C105.406 120.5 135.729 112.905 135.729 103.536C135.729 94.1673 105.406 86.5723 68.0004 86.5723C30.5948 86.5723 0.271484 94.1673 0.271484 103.536C0.271484 112.905 30.5948 120.5 68.0004 120.5Z"
        fill="url(#paint0_linear_5169_19082)"
      />
      <path
        d="M82.4788 85.3095L64.6243 57.3295C64.2185 56.6936 63.9326 55.6633 64.3479 54.1679C64.7714 52.6429 65.9012 50.8899 67.9129 49.6062L61.5363 39.6133C52.9364 45.101 49.9617 55.8132 54.892 63.5397L72.7466 91.5197C77.677 99.2462 88.6454 101.061 97.2454 95.5734L90.8687 85.5805C88.857 86.8642 86.7912 87.1504 85.2297 86.892C83.6985 86.6386 82.8845 85.9454 82.4788 85.3095Z"
        fill="url(#paint1_linear_5169_19082)"
      />
      <g filter="url(#filter0_f_5169_19082)">
        <path
          d="M55.1742 59.5262C57.4878 60.2935 62.9912 61.821 66.496 61.7927"
          stroke="#3F51EE"
          strokeOpacity="0.6"
        />
      </g>
      <g filter="url(#filter1_f_5169_19082)">
        <path
          d="M55.361 46.0203C56.3435 47.859 58.8869 52.0207 61.2003 53.9578"
          stroke="#3F51EE"
          strokeOpacity="0.6"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.1063 27.1189L71.7709 42.2645C72.1767 42.9004 72.4626 43.9306 72.0473 45.4261C71.6238 46.951 70.494 48.7041 68.4823 49.9878C66.4706 51.2715 64.4047 51.5577 62.8432 51.2993C61.312 51.0459 60.498 50.3527 60.0923 49.7168L42.2378 21.7368C41.832 21.1009 41.5462 20.0706 41.9614 18.5752C42.3849 17.0502 43.5148 15.2972 45.5265 14.0135C47.5381 12.7298 49.604 12.4436 51.1655 12.702C52.6967 12.9553 53.5107 13.6486 53.9164 14.2845L60.0968 23.9697L66.1804 25.4012L66.5445 18.1185L70.9165 19.4637L63.6486 8.0742C58.7182 0.347726 47.7498 -1.46714 39.1498 4.02059C30.5499 9.50832 27.5752 20.2205 32.5056 27.947L50.3601 55.927C55.2905 63.6535 66.259 65.4684 74.8589 59.9807C83.4588 54.4929 86.4335 43.7807 81.5031 36.0542L76.3173 27.9275L71.6424 26.1294C70.7928 27.586 69.1663 30.5719 69.4576 30.8632C69.7489 31.1545 64.7239 28.557 62.1749 27.2218L62.1063 27.1189Z"
        fill="url(#paint2_linear_5169_19082)"
      />
      <g filter="url(#filter2_f_5169_19082)">
        <path
          d="M82.4041 41.0627C79.9315 38.9649 73.7522 35.5749 68.8155 38.7976"
          stroke="#3F51EE"
          strokeOpacity="0.6"
        />
      </g>
      <g filter="url(#filter3_f_5169_19082)">
        <path
          d="M80.3879 54.0936C79.1994 52.3808 76.192 48.541 73.6701 46.8844"
          stroke="#3F51EE"
          strokeOpacity="0.6"
        />
      </g>
      <path
        d="M76.3025 49.8761L94.157 77.8561C94.5627 78.4919 94.8486 79.5222 94.4333 81.0177C94.0099 82.5426 92.88 84.2957 90.8683 85.5794L97.2449 95.5723C105.845 90.0845 108.82 79.3723 103.889 71.6458L86.0347 43.6658C81.1043 35.9393 70.1358 34.1245 61.5359 39.6122L67.9125 49.6051C69.9242 48.3214 71.9901 48.0352 73.5516 48.2936C75.0828 48.5469 75.8967 49.2402 76.3025 49.8761Z"
        fill="url(#paint3_linear_5169_19082)"
      />
      <path
        d="M87.3224 8.97346L76.6071 20.1493L90.7113 14.5957L87.3224 8.97346Z"
        fill="#C4DBFF"
      />
      <path
        d="M71.1548 3.86127L74.5258 17.867L77.5066 3.49076L71.1548 3.86127Z"
        fill="#C4DBFF"
      />
      <path
        d="M92.0821 24.4969L77.9287 23.1229L90.3452 30.6144L92.0821 24.4969Z"
        fill="#C4DBFF"
      />
      <defs>
        <filter
          id="filter0_f_5169_19082"
          x="51.0176"
          y="55.0508"
          width="19.4824"
          height="11.2422"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2"
            result="effect1_foregroundBlur_5169_19082"
          />
        </filter>
        <filter
          id="filter1_f_5169_19082"
          x="50.9199"
          y="41.7852"
          width="14.6016"
          height="16.5566"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2"
            result="effect1_foregroundBlur_5169_19082"
          />
        </filter>
        <filter
          id="filter2_f_5169_19082"
          x="64.543"
          y="32.9688"
          width="22.1855"
          height="12.4746"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2"
            result="effect1_foregroundBlur_5169_19082"
          />
        </filter>
        <filter
          id="filter3_f_5169_19082"
          x="69.3965"
          y="42.4668"
          width="15.4023"
          height="15.9121"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2"
            result="effect1_foregroundBlur_5169_19082"
          />
        </filter>
        <linearGradient
          id="paint0_linear_5169_19082"
          x1="74.1907"
          y1="133.776"
          x2="80.5391"
          y2="50.4438"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDEAFF" />
          <stop offset="1" stopColor="#F0F6FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5169_19082"
          x1="22.5513"
          y1="19.2966"
          x2="106.254"
          y2="17.3917"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CEE1FF" />
          <stop offset="1" stopColor="#8CB9FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_5169_19082"
          x1="79.4504"
          y1="46.0824"
          x2="-23.012"
          y2="22.0311"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D1E3FF" />
          <stop offset="1" stopColor="#8CB9FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_5169_19082"
          x1="104.84"
          y1="79.7577"
          x2="38.039"
          y2="86.0377"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#89B7FF" />
          <stop offset="1" stopColor="#D1E3FF" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const ContactInstagram = (props: any) => (
  <Icon
    {...props}
    viewBox="0 0 17 17"
    d={[
      "M8.50065 4.95801C7.56134 4.95801 6.66051 5.33115 5.99631 5.99534C5.33212 6.65953 4.95898 7.56037 4.95898 8.49967C4.95898 9.43898 5.33212 10.3398 5.99631 11.004C6.66051 11.6682 7.56134 12.0413 8.50065 12.0413C9.43996 12.0413 10.3408 11.6682 11.005 11.004C11.6692 10.3398 12.0423 9.43898 12.0423 8.49967C12.0423 7.56037 11.6692 6.65953 11.005 5.99534C10.3408 5.33115 9.43996 4.95801 8.50065 4.95801ZM6.37565 8.49967C6.37565 9.06326 6.59953 9.60376 6.99805 10.0023C7.39656 10.4008 7.93707 10.6247 8.50065 10.6247C9.06424 10.6247 9.60474 10.4008 10.0033 10.0023C10.4018 9.60376 10.6257 9.06326 10.6257 8.49967C10.6257 7.93609 10.4018 7.39559 10.0033 6.99707C9.60474 6.59856 9.06424 6.37467 8.50065 6.37467C7.93707 6.37467 7.39656 6.59856 6.99805 6.99707C6.59953 7.39559 6.37565 7.93609 6.37565 8.49967Z",
      "M12.7513 3.54102C12.5634 3.54102 12.3833 3.61564 12.2504 3.74848C12.1176 3.88132 12.043 4.06149 12.043 4.24935C12.043 4.43721 12.1176 4.61738 12.2504 4.75022C12.3833 4.88305 12.5634 4.95768 12.7513 4.95768C12.9392 4.95768 13.1193 4.88305 13.2522 4.75022C13.385 4.61738 13.4596 4.43721 13.4596 4.24935C13.4596 4.06149 13.385 3.88132 13.2522 3.74848C13.1193 3.61564 12.9392 3.54102 12.7513 3.54102Z",
      "M3.54232 0.708008C2.79087 0.708008 2.0702 1.00652 1.53885 1.53787C1.0075 2.06922 0.708984 2.78989 0.708984 3.54134V13.458C0.708984 14.2095 1.0075 14.9301 1.53885 15.4615C2.0702 15.9928 2.79087 16.2913 3.54232 16.2913H13.459C14.2104 16.2913 14.9311 15.9928 15.4625 15.4615C15.9938 14.9301 16.2923 14.2095 16.2923 13.458V3.54134C16.2923 2.78989 15.9938 2.06922 15.4625 1.53787C14.9311 1.00652 14.2104 0.708008 13.459 0.708008H3.54232ZM13.459 2.12467H3.54232C3.16659 2.12467 2.80626 2.27393 2.54058 2.53961C2.27491 2.80528 2.12565 3.16562 2.12565 3.54134V13.458C2.12565 13.8337 2.27491 14.1941 2.54058 14.4597C2.80626 14.7254 3.16659 14.8747 3.54232 14.8747H13.459C13.8347 14.8747 14.195 14.7254 14.4607 14.4597C14.7264 14.1941 14.8757 13.8337 14.8757 13.458V3.54134C14.8757 3.16562 14.7264 2.80528 14.4607 2.53961C14.195 2.27393 13.8347 2.12467 13.459 2.12467Z",
    ]}
  />
);

export const ContactFacebook = (props: any) => (
  <Icon
    {...props}
    viewBox="0 0 17 17"
    d={[
      "M5.18515 8.96216H6.72223V15.3552C6.72223 15.4814 6.82346 15.5837 6.9484 15.5837H9.55457C9.6795 15.5837 9.78074 15.4814 9.78074 15.3552V8.99227H11.5477C11.6626 8.99227 11.7593 8.90517 11.7724 8.78987L12.0408 6.43629C12.0482 6.37153 12.0278 6.30669 11.985 6.25811C11.942 6.20948 11.8806 6.18165 11.8162 6.18165H9.78083V4.70631C9.78083 4.26157 10.0178 4.03604 10.4854 4.03604C10.552 4.03604 11.8162 4.03604 11.8162 4.03604C11.9411 4.03604 12.0423 3.93372 12.0423 3.80755V1.64718C12.0423 1.52096 11.9411 1.41868 11.8162 1.41868H9.98216C9.96922 1.41804 9.9405 1.41699 9.89816 1.41699C9.57994 1.41699 8.47385 1.4801 7.60012 2.29217C6.63203 3.19208 6.7666 4.26956 6.79876 4.45638V6.18161H5.18515C5.06022 6.18161 4.95898 6.28388 4.95898 6.4101V8.73362C4.95898 8.85984 5.06022 8.96216 5.18515 8.96216Z",
    ]}
  />
);

export const ContactLinkedin = (props: any) => (
  <Icon
    {...props}
    viewBox="0 0 17 17"
    d={[
      "M5.75753 14H3.40039V6H5.75753V14ZM14.4004 14H12.0432V9.7264C12.0432 8.6128 11.6535 8.0584 10.8812 8.0584C10.2691 8.0584 9.88096 8.3688 9.6861 8.9904V14H7.32896C7.32896 14 7.36039 6.8 7.32896 6H9.18953L9.33332 7.6H9.38203C9.86525 6.8 10.6376 6.2576 11.6967 6.2576C12.5021 6.2576 13.1535 6.4856 13.6508 7.0584C14.1513 7.632 14.4004 8.4016 14.4004 9.4824V14Z",
      "M4.90039 5C5.72882 5 6.40039 4.32843 6.40039 3.5C6.40039 2.67157 5.72882 2 4.90039 2C4.07196 2 3.40039 2.67157 3.40039 3.5C3.40039 4.32843 4.07196 5 4.90039 5Z",
    ]}
  />
);

export const ContactYoutube = (props: any) => (
  <Icon
    {...props}
    viewBox="0 0 17 17"
    d={[
      "M8.49935 2.83301C9.10497 2.83301 9.72618 2.84859 10.3283 2.87409L11.0394 2.90809L11.7201 2.94847L12.3576 2.99167L12.9399 3.03701C13.5718 3.08537 14.1663 3.35501 14.619 3.79849C15.0717 4.24198 15.3535 4.83089 15.4148 5.46163L15.4431 5.76267L15.4963 6.40726C15.5458 7.07522 15.5827 7.80338 15.5827 8.49967C15.5827 9.19597 15.5458 9.92413 15.4963 10.5921L15.4431 11.2367C15.4339 11.3401 15.4247 11.44 15.4148 11.5377C15.3535 12.1686 15.0716 12.7576 14.6187 13.2011C14.1659 13.6446 13.5712 13.9141 12.9392 13.9623L12.3583 14.007L11.7208 14.0509L11.0394 14.0913L10.3283 14.1253C9.71898 14.1517 9.10921 14.1654 8.49935 14.1663C7.88949 14.1654 7.27972 14.1517 6.67043 14.1253L5.95927 14.0913L5.27856 14.0509L4.64106 14.007L4.05881 13.9623C3.42694 13.914 2.83236 13.6443 2.37968 13.2009C1.927 12.7574 1.64521 12.1685 1.58389 11.5377L1.55556 11.2367L1.50243 10.5921C1.44827 9.8959 1.41945 9.19796 1.41602 8.49967C1.41602 7.80338 1.45285 7.07522 1.50243 6.40726L1.55556 5.76267C1.56477 5.65926 1.57397 5.55938 1.58389 5.46163C1.64519 4.831 1.92688 4.24218 2.37941 3.79871C2.83195 3.35524 3.42636 3.08553 4.0581 3.03701L4.63964 2.99167L5.27714 2.94847L5.95856 2.90809L6.66972 2.87409C7.27925 2.84762 7.88925 2.83393 8.49935 2.83301ZM7.08268 6.78197V10.2174C7.08268 10.5446 7.43685 10.7486 7.72018 10.5857L10.6952 8.86801C10.7599 8.83074 10.8137 8.77708 10.8511 8.71241C10.8885 8.64775 10.9082 8.57437 10.9082 8.49967C10.9082 8.42498 10.8885 8.3516 10.8511 8.28694C10.8137 8.22227 10.7599 8.16861 10.6952 8.13134L7.72018 6.41434C7.65555 6.37703 7.58224 6.35739 7.50761 6.3574C7.43299 6.35741 7.35968 6.37708 7.29506 6.41441C7.23045 6.45174 7.1768 6.50543 7.13952 6.57008C7.10224 6.63473 7.08263 6.70805 7.08268 6.78267V6.78197Z",
    ]}
  />
);

export const ContactTelegram = (props: any) => (
  <Icon
    {...props}
    viewBox="0 0 17 17"
    d={[
      "M1.66624 8.24733L4.93052 9.46566L6.194 13.529C6.27485 13.7892 6.59308 13.8854 6.8043 13.7127L8.62387 12.2294C8.8146 12.074 9.08627 12.0662 9.28559 12.2109L12.5674 14.5936C12.7934 14.7579 13.1135 14.634 13.1702 14.361L15.5743 2.7967C15.6362 2.49845 15.3431 2.24964 15.0591 2.35947L1.66242 7.52752C1.33181 7.65502 1.33469 8.12309 1.66624 8.24733ZM5.99038 8.81711L12.37 4.88789C12.4847 4.81749 12.6026 4.97252 12.5042 5.06384L7.23912 9.95795C7.05406 10.1302 6.93468 10.3608 6.90087 10.611L6.72152 11.9401C6.69777 12.1176 6.44848 12.1352 6.39951 11.9634L5.70974 9.53975C5.63074 9.26332 5.74586 8.96804 5.99038 8.81711Z",
    ]}
  />
);

export const ContactWeb = (props: any) => (
  <Icon
    {...props}
    viewBox="0 0 17 17"
    d={[
      "M8.49227 1.41699C4.58227 1.41699 1.41602 4.59033 1.41602 8.50033C1.41602 12.4103 4.58227 15.5837 8.49227 15.5837C12.4093 15.5837 15.5827 12.4103 15.5827 8.50033C15.5827 4.59033 12.4093 1.41699 8.49227 1.41699ZM13.401 5.66699H11.3114C11.0848 4.78158 10.7589 3.93158 10.3339 3.14533C11.6373 3.59158 12.721 4.49824 13.401 5.66699ZM8.49935 2.86199C9.08727 3.71199 9.54768 4.65408 9.85227 5.66699H7.14643C7.45102 4.65408 7.91143 3.71199 8.49935 2.86199ZM3.01685 9.91699C2.90352 9.46366 2.83268 8.98908 2.83268 8.50033C2.83268 8.01158 2.90352 7.53699 3.01685 7.08366H5.41102C5.35435 7.55116 5.31185 8.01866 5.31185 8.50033C5.31185 8.98199 5.35435 9.44949 5.41102 9.91699H3.01685ZM3.59768 11.3337H5.68727C5.91393 12.2191 6.23977 13.0691 6.66477 13.8553C5.36143 13.4091 4.27768 12.5095 3.59768 11.3337ZM5.68727 5.66699H3.59768C4.27768 4.49116 5.36143 3.59158 6.66477 3.14533C6.23977 3.93158 5.91393 4.78158 5.68727 5.66699ZM8.49935 14.1387C7.91143 13.2887 7.45102 12.3466 7.14643 11.3337H9.85227C9.54768 12.3466 9.08727 13.2887 8.49935 14.1387ZM10.1568 9.91699H6.84185C6.7781 9.44949 6.72852 8.98199 6.72852 8.50033C6.72852 8.01866 6.7781 7.54408 6.84185 7.08366H10.1568C10.2206 7.54408 10.2702 8.01866 10.2702 8.50033C10.2702 8.98199 10.2206 9.44949 10.1568 9.91699ZM10.3339 13.8553C10.7589 13.0691 11.0848 12.2191 11.3114 11.3337H13.401C12.721 12.5024 11.6373 13.4091 10.3339 13.8553ZM11.5877 9.91699C11.6443 9.44949 11.6868 8.98199 11.6868 8.50033C11.6868 8.01866 11.6443 7.55116 11.5877 7.08366H13.9818C14.0952 7.53699 14.166 8.01158 14.166 8.50033C14.166 8.98908 14.0952 9.46366 13.9818 9.91699H11.5877Z",
    ]}
  />
);

export const CheckCancelIcon = (props: any) => (
  <Icon
    {...props}
    width="12"
    height="10"
    viewBox="0 0 12 10"
    d={[
      "M0.75 5.53549L4.43327 9.08317L7.16667 6.44587L6.0628 5.3988L4.43327 6.97287L1.84548 4.48034L0.75 5.53549Z",
      "M10.7099 0.927271L7.82678 3.70657L8.91667 4.77249L11.8333 1.96089L10.7099 0.927271Z",
      "M9.97751 8.51791L10.9668 7.56504L4.49989 1.3362L3.49966 2.27314L9.97751 8.51791Z",
    ]}
  />
);

export const Password = (props: any) => (
  <Icon {...props} viewBox="0 0 212 196">
    <path
      d="M105.624 195.644C163.959 195.644 211.248 183.949 211.248 169.522C211.248 155.095 163.959 143.4 105.624 143.4C47.2895 143.4 0 155.095 0 169.522C0 183.949 47.2895 195.644 105.624 195.644Z"
      fill="url(#paint0_linear_5281_219127)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42 26.2937V72.6917C42 105.053 65.8848 143.498 100.493 160.591C135.102 143.498 158.987 105.053 158.987 72.6917V26.2937C156.431 26.6131 153.831 26.7804 151.188 26.7804C130.136 26.7804 111.56 16.1731 100.493 0C89.4269 16.1731 70.8506 26.7804 49.7991 26.7804C47.1563 26.7804 44.5553 26.6131 42 26.2937Z"
      fill="url(#paint1_linear_5281_219127)"
    />
    <path
      d="M42 72.6917V26.2937C44.5553 26.6131 47.1563 26.7804 49.7991 26.7804C70.8506 26.7804 89.4269 16.1731 100.493 0V62.305V98.3011V160.591C65.8848 143.498 42 105.053 42 72.6917Z"
      fill="url(#paint2_linear_5281_219127)"
    />
    <path
      d="M79 105L120.5 104.5L122 73.5L156 93C152.5 107.5 144 123 133 135L79 105Z"
      fill="url(#paint3_linear_5281_219127)"
      fillOpacity="0.8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M99.9128 48C90.383 48 82.6575 55.7255 82.6575 65.2554V72.3449H79.8641C78.2823 72.3449 77 73.6363 77 75.2294V101.19C77 103.845 79.1371 105.998 81.7734 105.998H118.052C120.688 105.998 122.825 103.845 122.825 101.19V75.2294C122.825 73.6363 121.543 72.3449 119.961 72.3449H117.168V65.2554C117.168 55.7255 109.443 48 99.9128 48ZM109.499 72.3449V65.2557C109.499 59.9613 105.207 55.6694 99.913 55.6694C94.6186 55.6694 90.3267 59.9613 90.3267 65.2557V72.3449H109.499ZM101.822 90.2135C103.508 89.4717 104.686 87.7773 104.686 85.806C104.686 83.1508 102.549 80.9984 99.9125 80.9984C97.2761 80.9984 95.139 83.1508 95.139 85.806C95.139 87.7773 96.3173 89.4717 98.0031 90.2135V96.3825C98.0031 96.648 98.2168 96.8633 98.4805 96.8633H101.345C101.608 96.8633 101.822 96.648 101.822 96.3825V90.2135Z"
      fill="white"
    />
    <rect
      x="120"
      y="106"
      width="57"
      height="57"
      rx="28.5"
      fill="url(#paint4_linear_5281_219127)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M163.541 124.51C164.823 125.687 164.836 127.705 163.571 128.9L146.446 145.067C145.29 146.158 143.483 146.158 142.327 145.067L135.497 138.618C134.231 137.423 134.245 135.405 135.527 134.228L135.719 134.051C136.878 132.986 138.664 132.998 139.808 134.078L143.7 137.753C144.086 138.117 144.688 138.117 145.073 137.753L159.259 124.36C160.404 123.28 162.189 123.268 163.348 124.333L163.541 124.51Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5281_219127"
        x1="115.278"
        y1="216.087"
        x2="124.932"
        y2="87.7483"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DDEAFF" />
        <stop offset="1" stopColor="#F0F6FF" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5281_219127"
        x1="100.493"
        y1="-6.91285"
        x2="170.685"
        y2="122.836"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DCEAFF" />
        <stop offset="1" stopColor="#9BC4FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5281_219127"
        x1="116.978"
        y1="-19.675"
        x2="30.8331"
        y2="147.297"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C6DBFA" />
        <stop offset="1" stopColor="#87B8FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_5281_219127"
        x1="151.5"
        y1="115"
        x2="104.714"
        y2="99.2805"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#81B2FF" stopOpacity="0" />
        <stop offset="1" stopColor="#81B2FF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_5281_219127"
        x1="149.059"
        y1="93.9423"
        x2="149.059"
        y2="175.058"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3788FF" />
        <stop offset="1" stopColor="#87B8FF" />
      </linearGradient>
    </defs>
  </Icon>
);

export const DarkModePassword = (props: any) => (
  <Icon {...props} viewBox="0 0 212 196">
    <path
      d="M105.624 195.871C163.959 195.871 211.248 184.176 211.248 169.749C211.248 155.322 163.959 143.627 105.624 143.627C47.2895 143.627 0 155.322 0 169.749C0 184.176 47.2895 195.871 105.624 195.871Z"
      fill="url(#paint0_linear_5281_219143)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42 26.2937V72.6917C42 105.053 65.8848 143.498 100.493 160.591C135.102 143.498 158.987 105.053 158.987 72.6917V26.2937C156.431 26.6131 153.831 26.7804 151.188 26.7804C130.136 26.7804 111.56 16.1731 100.493 0C89.4269 16.1731 70.8506 26.7804 49.7991 26.7804C47.1563 26.7804 44.5553 26.6131 42 26.2937Z"
      fill="url(#paint1_linear_5281_219143)"
    />
    <path
      d="M42 72.6917V26.2937C44.5553 26.6131 47.1563 26.7804 49.7991 26.7804C70.8506 26.7804 89.4269 16.1731 100.493 0V62.305V98.3011V160.591C65.8848 143.498 42 105.053 42 72.6917Z"
      fill="url(#paint2_linear_5281_219143)"
    />
    <path
      d="M79 105L120.5 104.5L122 73.5L156 93C152.5 107.5 144 123 133 135L79 105Z"
      fill="url(#paint3_linear_5281_219143)"
      fillOpacity="0.8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M99.9128 48C90.383 48 82.6575 55.7255 82.6575 65.2554V72.3449H79.8641C78.2823 72.3449 77 73.6363 77 75.2294V101.19C77 103.845 79.1371 105.998 81.7734 105.998H118.052C120.688 105.998 122.825 103.845 122.825 101.19V75.2294C122.825 73.6363 121.543 72.3449 119.961 72.3449H117.168V65.2554C117.168 55.7255 109.443 48 99.9128 48ZM109.499 72.3449V65.2557C109.499 59.9613 105.207 55.6694 99.913 55.6694C94.6186 55.6694 90.3267 59.9613 90.3267 65.2557V72.3449H109.499ZM101.822 90.2135C103.508 89.4717 104.686 87.7773 104.686 85.806C104.686 83.1508 102.549 80.9984 99.9125 80.9984C97.2761 80.9984 95.139 83.1508 95.139 85.806C95.139 87.7773 96.3173 89.4717 98.0031 90.2135V96.3825C98.0031 96.648 98.2168 96.8633 98.4805 96.8633H101.345C101.608 96.8633 101.822 96.648 101.822 96.3825V90.2135Z"
      fill="white"
    />
    <rect
      x="120"
      y="106"
      width="57"
      height="57"
      rx="28.5"
      fill="url(#paint4_linear_5281_219143)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M163.541 124.51C164.823 125.687 164.836 127.705 163.571 128.9L146.446 145.067C145.29 146.158 143.483 146.158 142.327 145.067L135.497 138.618C134.231 137.423 134.245 135.405 135.527 134.228L135.719 134.051C136.878 132.986 138.664 132.998 139.808 134.078L143.7 137.753C144.086 138.117 144.688 138.117 145.073 137.753L159.259 124.36C160.404 123.28 162.189 123.268 163.348 124.333L163.541 124.51Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5281_219143"
        x1="117.5"
        y1="283.717"
        x2="115"
        y2="100.217"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B0CFFF" />
        <stop offset="1" stopColor="#70A8FF" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5281_219143"
        x1="100.493"
        y1="-6.91285"
        x2="170.685"
        y2="122.836"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CCE1FF" />
        <stop offset="1" stopColor="#94BFFF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5281_219143"
        x1="116.978"
        y1="-19.675"
        x2="53"
        y2="127"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#ADCEFF" />
        <stop offset="1" stopColor="#7BB1FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_5281_219143"
        x1="151.5"
        y1="115"
        x2="104.714"
        y2="99.2805"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6BA5FF" stopOpacity="0" />
        <stop offset="1" stopColor="#6BA5FF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_5281_219143"
        x1="149.059"
        y1="93.9423"
        x2="149.059"
        y2="175.058"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3788FF" />
        <stop offset="1" stopColor="#61A1FF" />
      </linearGradient>
    </defs>
  </Icon>
);

export const User = (props: any) => {
  return (
    <Icon {...props} viewBox="0 0 212 171">
      <path
        d="M105.624 170.816C163.959 170.816 211.248 159.121 211.248 144.694C211.248 130.268 163.959 118.572 105.624 118.572C47.2895 118.572 0 130.268 0 144.694C0 159.121 47.2895 170.816 105.624 170.816Z"
        fill="url(#paint0_linear_5281_219161)"
      />
      <foreignObject x="68.4102" y="-8" width="73.7578" height="73.7583">
        <div
          style={{
            backdropFilter: "blur(4px)",
            clipPath: "url(#bgblur_0_5281_219161_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <circle
        data-figma-bg-blur-radius="8"
        cx="105.289"
        cy="28.8792"
        r="28.8792"
        fill="url(#paint1_linear_5281_219161)"
      />
      <foreignObject x="41" y="58.5686" width="126.621" height="89.4219">
        <div
          style={{
            backdropFilter: "blur(4px)",
            clipPath: "url(#bgblur_1_5281_219161_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <g filter="url(#filter1_i_5281_219161)" data-figma-bg-blur-radius="8">
        <path
          d="M49 130.699C49 136.274 52.7184 139.99 58.296 139.99H151.256C156.833 139.99 159.622 136.274 159.622 130.699V105.61C159.622 92.6016 148.095 67.3275 105.705 66.5842C63.3158 65.8408 49 91.6724 49 105.61V130.699Z"
          fill="url(#paint2_linear_5281_219161)"
          fillOpacity="0.89"
        />
      </g>
      <circle
        cx="159.006"
        cy="119.5"
        r="31.5"
        fill="url(#paint3_linear_5281_219161)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M174.387 110.067C175.669 111.245 175.683 113.263 174.417 114.458L157.292 130.625C156.136 131.716 154.33 131.716 153.174 130.625L146.343 124.176C145.077 122.981 145.091 120.963 146.373 119.785L146.565 119.608C147.725 118.543 149.51 118.555 150.655 119.636L154.546 123.31C154.932 123.674 155.534 123.674 155.919 123.31L170.105 109.918C171.25 108.837 173.035 108.825 174.194 109.89L174.387 110.067Z"
        fill="white"
      />
      <defs>
        <clipPath
          id="bgblur_0_5281_219161_clip_path"
          transform="translate(-68.4102 8)"
        >
          <circle cx="105.289" cy="28.8792" r="28.8792" />
        </clipPath>
        <filter
          id="filter1_i_5281_219161"
          x="41"
          y="58.5686"
          width="126.621"
          height="89.4219"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-2" dy="2" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_5281_219161"
          />
        </filter>
        <clipPath
          id="bgblur_1_5281_219161_clip_path"
          transform="translate(-41 -58.5686)"
        >
          <path d="M49 130.699C49 136.274 52.7184 139.99 58.296 139.99H151.256C156.833 139.99 159.622 136.274 159.622 130.699V105.61C159.622 92.6016 148.095 67.3275 105.705 66.5842C63.3158 65.8408 49 91.6724 49 105.61V130.699Z" />
        </clipPath>
        <linearGradient
          id="paint0_linear_5281_219161"
          x1="115.278"
          y1="191.26"
          x2="124.932"
          y2="62.9209"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDEAFF" />
          <stop offset="1" stopColor="#F0F6FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5281_219161"
          x1="90.1155"
          y1="3.91582"
          x2="120.504"
          y2="62"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBE8FC" />
          <stop offset="1" stopColor="#A5C9FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_5281_219161"
          x1="76.4107"
          y1="53.8424"
          x2="115.079"
          y2="159.57"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D3E5FF" />
          <stop offset="0.676003" stopColor="#A6C9FF" />
          <stop offset="1" stopColor="#5D9BFC" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_5281_219161"
          x1="159.006"
          y1="88"
          x2="181.241"
          y2="151"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#74A9FF" />
          <stop offset="1" stopColor="#3986FF" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const DarkModeUser = (props: any) => {
  return (
    <Icon {...props} viewBox="0 0 212 171">
      <path
        d="M105.624 170.443C163.959 170.443 211.248 158.748 211.248 144.321C211.248 129.894 163.959 118.199 105.624 118.199C47.2895 118.199 0 129.894 0 144.321C0 158.748 47.2895 170.443 105.624 170.443Z"
        fill="url(#paint0_linear_5281_219168)"
      />
      <foreignObject x="68.9062" y="-8" width="73.7578" height="73.7583">
        <div
          style={{
            backdropFilter: "blur(4px)",
            clipPath: "url(#bgblur_0_5281_219168_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <circle
        data-figma-bg-blur-radius="8"
        cx="105.785"
        cy="28.8792"
        r="28.8792"
        fill="url(#paint1_linear_5281_219168)"
      />
      <foreignObject x="41.4941" y="58.5686" width="126.621" height="89.4219">
        <div
          style={{
            backdropFilter: "blur(4px)",
            clipPath: "url(#bgblur_1_5281_219168_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <g filter="url(#filter1_i_5281_219168)" data-figma-bg-blur-radius="8">
        <path
          d="M49.4941 130.699C49.4941 136.274 53.2125 139.99 58.7901 139.99H151.75C157.327 139.99 160.116 136.274 160.116 130.699V105.61C160.116 92.6016 148.589 67.3275 106.199 66.5842C63.8099 65.8408 49.4941 91.6724 49.4941 105.61V130.699Z"
          fill="url(#paint2_linear_5281_219168)"
          fillOpacity="0.89"
        />
      </g>
      <rect
        x="128"
        y="88"
        width="63"
        height="63"
        rx="31.5"
        fill="url(#paint3_linear_5281_219168)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M174.387 110.067C175.669 111.245 175.683 113.263 174.417 114.458L157.292 130.625C156.136 131.716 154.33 131.716 153.174 130.625L146.343 124.176C145.077 122.981 145.091 120.963 146.373 119.785L146.565 119.608C147.725 118.543 149.51 118.555 150.655 119.636L154.546 123.31C154.932 123.674 155.534 123.674 155.919 123.31L170.105 109.918C171.25 108.837 173.035 108.825 174.194 109.89L174.387 110.067Z"
        fill="white"
      />
      <defs>
        <clipPath
          id="bgblur_0_5281_219168_clip_path"
          transform="translate(-68.9062 8)"
        >
          <circle cx="105.785" cy="28.8792" r="28.8792" />
        </clipPath>
        <filter
          id="filter1_i_5281_219168"
          x="41.4941"
          y="58.5686"
          width="126.621"
          height="89.4219"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-2" dy="2" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_5281_219168"
          />
        </filter>
        <clipPath
          id="bgblur_1_5281_219168_clip_path"
          transform="translate(-41.4941 -58.5686)"
        >
          <path d="M49.4941 130.699C49.4941 136.274 53.2125 139.99 58.7901 139.99H151.75C157.327 139.99 160.116 136.274 160.116 130.699V105.61C160.116 92.6016 148.589 67.3275 106.199 66.5842C63.8099 65.8408 49.4941 91.6724 49.4941 105.61V130.699Z" />
        </clipPath>
        <linearGradient
          id="paint0_linear_5281_219168"
          x1="117.5"
          y1="258.289"
          x2="115"
          y2="74.7888"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0CFFF" />
          <stop offset="1" stopColor="#70A8FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5281_219168"
          x1="135"
          y1="8"
          x2="77.0005"
          y2="44"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AAC9F8" />
          <stop offset="1" stopColor="#85B6FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_5281_219168"
          x1="195"
          y1="134.5"
          x2="72.9995"
          y2="210"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A6C9FF" />
          <stop offset="1" stopColor="#5D9BFC" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_5281_219168"
          x1="160.118"
          y1="74.6731"
          x2="160.118"
          y2="164.327"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3788FF" />
          <stop offset="1" stopColor="#61A1FF" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const BoldRemoveOutlined = (props: any) => {
  return (
    <Icon {...props} viewBox="0 0 13 2">
      <path
        d="M12.0413 1.79183H0.958008V0.208496H12.0413V1.79183Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export const BoldPlusOutlined = (props: any) => {
  return (
    <Icon {...props} viewBox="0 0 13 12">
      <path
        d="M12.0413 6.79183H7.29134V11.5418H5.70801V6.79183H0.958008V5.2085H5.70801V0.458496H7.29134V5.2085H12.0413V6.79183Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export const TimeLockOutlined = (props: any) => {
  return (
    <Icon
      {...props}
      viewBox="0 0 16 16"
      d={[
        "M6.99023 2.58301C6.00073 2.58301 5.63781 2.75586 5.33014 3.06354C5.02246 3.37121 4.84961 3.78851 4.84961 4.22363V6.61947H6.43823C6.73763 6.61947 6.73763 6.89929 6.73763 7.24447C6.73763 7.58964 6.76384 7.86947 6.43823 7.86947H2.71419C2.67966 7.86947 2.64654 7.88319 2.62212 7.9076C2.5977 7.93202 2.58398 7.96514 2.58398 7.99967V13.2861C2.58398 13.3207 2.5977 13.3538 2.62212 13.3782C2.64654 13.4026 2.67966 13.4163 2.71419 13.4163H6.43823C6.78341 13.4163 6.73763 13.6962 6.73763 14.0413C6.73763 14.3865 6.78341 14.6663 6.43823 14.6663H2.33919C1.97314 14.6663 1.75073 14.6248 1.56313 14.4371C1.405 14.279 1.33398 14.1522 1.33398 13.7861V7.62467C1.33398 7.25862 1.33403 7.04133 1.56318 6.81213C1.75583 6.61945 1.97314 6.61947 2.33919 6.61947H3.59961V4.22363C3.59961 3.45699 3.90416 2.72175 4.44625 2.17965C4.98835 1.63756 5.68823 1.33301 6.99023 1.33301C8.43823 1.33301 8.99212 1.63756 9.53422 2.17965C10.0763 2.72175 10.3809 3.45699 10.3809 4.22363V5.70932C10.3757 5.97751 10.101 5.98145 9.75586 5.98145C9.41068 5.98145 9.13086 5.97751 9.13086 5.70932V4.22363C9.13086 3.78851 8.95801 3.37121 8.65033 3.06354C8.34266 2.75586 7.87573 2.58301 6.99023 2.58301ZM10.6439 7.86947C9.90832 7.86947 9.20288 8.16167 8.68276 8.68179C8.16264 9.20191 7.87044 9.90734 7.87044 10.6429C7.87044 11.3785 8.16264 12.0839 8.68276 12.604C9.20288 13.1241 9.90832 13.4163 10.6439 13.4163C11.3794 13.4163 12.0849 13.1241 12.605 12.604C13.1251 12.0839 13.4173 11.3785 13.4173 10.6429C13.4173 9.90734 13.1251 9.20191 12.605 8.68179C12.0849 8.16167 11.3794 7.86947 10.6439 7.86947ZM7.79888 7.7979C8.55342 7.04336 9.5768 6.61947 10.6439 6.61947C11.711 6.61947 12.7343 7.04336 13.4889 7.7979C14.2434 8.55244 14.6673 9.57582 14.6673 10.6429C14.6673 11.71 14.2434 12.7334 13.4889 13.4879C12.7343 14.2424 11.711 14.6663 10.6439 14.6663C9.5768 14.6663 8.55342 14.2424 7.79888 13.4879C7.04434 12.7334 6.62044 11.71 6.62044 10.6429C6.62044 9.57582 7.04434 8.55244 7.79888 7.7979ZM10.0189 9.26009H11.0007V10.509L12.0632 11.4371L11.4382 12.1767L10.2019 11.0848C10.0847 10.9676 10.0189 10.8087 10.0189 10.6429V9.26009Z",
      ]}
    />
  );
};

export const SignalIcon = (props: any) => {
  return (
    <Icon {...props} viewBox="0 0 55 55">
      <g clipPath="url(#clip0_5552_116893)">
        <rect width="55" height="55" rx="15" fill="#EFF4FF" />
      </g>
      <circle cx="28" cy="29" r="12" fill="white" />
      <mask
        id="mask0_5552_116893"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="2"
        width="53"
        height="53"
      >
        <path d="M1 55V2L27.5 28.5L54 2V55L27.5 28.5L1 55Z" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5552_116893)">
        <circle cx="28.3841" cy="29.3834" r="22.0833" fill="#DBE6FF" />
        <circle cx="28.3839" cy="29.3834" r="15.0167" fill="#ACC6FF" />
      </g>
      <circle cx="28" cy="29" r="5" fill="#3272FE" />
      <defs>
        <clipPath id="clip0_5552_116893">
          <rect width="55" height="55" rx="15" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  );
};

export const DarkSignalIcon = (props: any) => {
  return (
    <Icon {...props} viewBox="0 0 55 55">
      <g clipPath="url(#clip0_5556_118335)">
        <rect
          width="55"
          height="55"
          rx="15"
          fill="#70A8FF"
          fillOpacity="0.22"
        />
      </g>
      <circle cx="28" cy="29" r="12" fill="#70A8FF" fillOpacity="0.22" />
      <mask
        id="mask0_5556_118335"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="2"
        width="53"
        height="53"
      >
        <path d="M1 55V2L27.5 28.5L54 2V55L27.5 28.5L1 55Z" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5556_118335)">
        <circle
          cx="28.3841"
          cy="29.3834"
          r="22.0833"
          fill="#70A8FF"
          fillOpacity="0.23"
        />
        <circle cx="28.3839" cy="29.3834" r="15.0167" fill="#678CC5" />
      </g>
      <circle cx="28" cy="29" r="5" fill="#70A8FF" />
      <defs>
        <clipPath id="clip0_5556_118335">
          <rect width="55" height="55" rx="15" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  );
};
export const ClockIcon = (props: any) => {
  return (
    <Icon {...props} viewBox="0 0 55 55">
      <rect width="55" height="55" rx="15" fill="#EFF4FF" />
      <path
        opacity="0.9"
        d="M33 16.443C34.3755 16.7948 35.6496 17.483 36.7158 18.4498C37.782 19.4166 38.6092 20.634 39.1282 22.0001C39.6658 21.6274 40.1135 21.1315 40.4366 20.5508C40.7596 19.97 40.9494 19.3201 40.9912 18.6511C41.033 17.9822 40.9257 17.3123 40.6776 16.6932C40.4295 16.0742 40.0472 15.5226 39.5604 15.0812C39.0736 14.6397 38.4953 14.3203 37.8703 14.1476C37.2453 13.9749 36.5903 13.9536 35.9561 14.0852C35.3218 14.2169 34.7253 14.498 34.2127 14.9069C33.7001 15.3158 33.2851 15.8414 33 16.443Z"
        fill="#ACC6FF"
      />
      <path
        opacity="0.9"
        d="M22 16.443C20.6245 16.7948 19.3504 17.483 18.2842 18.4498C17.218 19.4166 16.3908 20.634 15.8718 22.0001C15.3342 21.6274 14.8865 21.1315 14.5634 20.5508C14.2404 19.97 14.0506 19.3201 14.0088 18.6511C13.967 17.9822 14.0743 17.3123 14.3224 16.6932C14.5705 16.0742 14.9528 15.5226 15.4396 15.0812C15.9264 14.6397 16.5047 14.3203 17.1297 14.1476C17.7547 13.9749 18.4097 13.9536 19.0439 14.0852C19.6782 14.2169 20.2747 14.498 20.7873 14.9069C21.2999 15.3158 21.7149 15.8414 22 16.443Z"
        fill="#ACC6FF"
      />
      <path
        d="M16.7568 41.0374L20.2255 37.5687L18.5883 35.9337L15.1195 39.4025C14.9027 39.6196 14.781 39.9139 14.7813 40.2208C14.7815 40.5276 14.9036 40.8218 15.1207 41.0386C15.3378 41.2554 15.6321 41.377 15.939 41.3768C16.2458 41.3766 16.54 41.2545 16.7568 41.0374Z"
        fill="#ACC6FF"
      />
      <path
        d="M39.8794 39.4025L36.4107 35.9337L34.7734 37.5687L38.2422 41.0374C38.3488 41.1478 38.4764 41.2359 38.6175 41.2965C38.7586 41.3571 38.9103 41.389 39.0638 41.3903C39.2173 41.3917 39.3696 41.3624 39.5117 41.3043C39.6538 41.2462 39.7829 41.1603 39.8915 41.0517C40 40.9432 40.0859 40.8141 40.144 40.672C40.2021 40.5299 40.2314 40.3776 40.2301 40.2241C40.2287 40.0706 40.1968 39.9188 40.1362 39.7778C40.0756 39.6367 39.9876 39.5091 39.8771 39.4025"
        fill="#ACC6FF"
      />
      <path
        d="M40.2188 28.6562C40.2188 32.0295 38.8787 35.2645 36.4935 37.6498C34.1083 40.035 30.8732 41.375 27.5 41.375C24.1268 41.375 20.8917 40.035 18.5065 37.6498C16.1213 35.2645 14.7813 32.0295 14.7812 28.6562C14.7812 25.283 16.1213 22.048 18.5065 19.6627C20.8917 17.2775 24.1268 15.9375 27.5 15.9375C30.8732 15.9375 34.1083 17.2775 36.4935 19.6627C38.8787 22.048 40.2188 25.283 40.2188 28.6562Z"
        fill="#3272FE"
      />
      <path
        d="M37.9062 28.6562C37.9062 31.4162 36.8099 34.063 34.8583 36.0146C32.9068 37.9661 30.2599 39.0625 27.5 39.0625C24.7401 39.0625 22.0932 37.9661 20.1417 36.0146C18.1901 34.063 17.0938 31.4162 17.0938 28.6562C17.0938 25.8963 18.1901 23.2495 20.1417 21.2979C22.0932 19.3464 24.7401 18.25 27.5 18.25C30.2599 18.25 32.9068 19.3464 34.8583 21.2979C36.8099 23.2495 37.9062 25.8963 37.9062 28.6562Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.3438 21.7188C26.6504 21.7188 26.9445 21.8406 27.1613 22.0574C27.3782 22.2742 27.5 22.5683 27.5 22.875V28.6562H30.9688C31.2754 28.6562 31.5695 28.7781 31.7863 28.9949C32.0032 29.2117 32.125 29.5058 32.125 29.8125C32.125 30.1192 32.0032 30.4133 31.7863 30.6301C31.5695 30.8469 31.2754 30.9688 30.9688 30.9688H26.3438C26.0371 30.9688 25.743 30.8469 25.5262 30.6301C25.3093 30.4133 25.1875 30.1192 25.1875 29.8125V22.875C25.1875 22.5683 25.3093 22.2742 25.5262 22.0574C25.743 21.8406 26.0371 21.7188 26.3438 21.7188Z"
        fill="#3272FE"
      />
    </Icon>
  );
};

export const DarkClockIcon = (props: any) => {
  return (
    <Icon {...props} viewBox="0 0 55 55">
      <rect width="55" height="55" rx="15" fill="#70A8FF" fillOpacity="0.22" />
      <path
        opacity="0.9"
        d="M33 16.443C34.3755 16.7948 35.6496 17.483 36.7158 18.4498C37.782 19.4166 38.6092 20.634 39.1282 22.0001C39.6658 21.6274 40.1135 21.1315 40.4366 20.5508C40.7596 19.97 40.9494 19.3201 40.9912 18.6511C41.033 17.9822 40.9257 17.3123 40.6776 16.6932C40.4295 16.0742 40.0472 15.5226 39.5604 15.0812C39.0736 14.6397 38.4953 14.3203 37.8703 14.1476C37.2453 13.9749 36.5903 13.9536 35.9561 14.0852C35.3218 14.2169 34.7253 14.498 34.2127 14.9069C33.7001 15.3158 33.2851 15.8414 33 16.443Z"
        fill="#678CC5"
      />
      <path
        opacity="0.9"
        d="M22 16.443C20.6245 16.7948 19.3504 17.483 18.2842 18.4498C17.218 19.4166 16.3908 20.634 15.8718 22.0001C15.3342 21.6274 14.8865 21.1315 14.5634 20.5508C14.2404 19.97 14.0506 19.3201 14.0088 18.6511C13.967 17.9822 14.0743 17.3123 14.3224 16.6932C14.5705 16.0742 14.9528 15.5226 15.4396 15.0812C15.9264 14.6397 16.5047 14.3203 17.1297 14.1476C17.7547 13.9749 18.4097 13.9536 19.0439 14.0852C19.6782 14.2169 20.2747 14.498 20.7873 14.9069C21.2999 15.3158 21.7149 15.8414 22 16.443Z"
        fill="#678CC5"
      />
      <path
        d="M16.7568 41.0374L20.2255 37.5687L18.5883 35.9337L15.1195 39.4025C14.9027 39.6196 14.781 39.9139 14.7813 40.2208C14.7815 40.5276 14.9036 40.8218 15.1207 41.0386C15.3378 41.2554 15.6321 41.377 15.939 41.3768C16.2458 41.3766 16.54 41.2545 16.7568 41.0374Z"
        fill="#678CC5"
      />
      <path
        d="M39.8794 39.4025L36.4107 35.9337L34.7734 37.5687L38.2422 41.0374C38.3488 41.1478 38.4764 41.2359 38.6175 41.2965C38.7586 41.3571 38.9103 41.389 39.0638 41.3903C39.2173 41.3917 39.3696 41.3624 39.5117 41.3043C39.6538 41.2462 39.7829 41.1603 39.8915 41.0517C40 40.9432 40.0859 40.8141 40.144 40.672C40.2021 40.5299 40.2314 40.3776 40.2301 40.2241C40.2287 40.0706 40.1968 39.9188 40.1362 39.7778C40.0756 39.6367 39.9876 39.5091 39.8771 39.4025"
        fill="#678CC5"
      />
      <path
        d="M40.2188 28.6562C40.2188 32.0295 38.8787 35.2645 36.4935 37.6498C34.1083 40.035 30.8732 41.375 27.5 41.375C24.1268 41.375 20.8917 40.035 18.5065 37.6498C16.1213 35.2645 14.7813 32.0295 14.7812 28.6562C14.7812 25.283 16.1213 22.048 18.5065 19.6627C20.8917 17.2775 24.1268 15.9375 27.5 15.9375C30.8732 15.9375 34.1083 17.2775 36.4935 19.6627C38.8787 22.048 40.2188 25.283 40.2188 28.6562Z"
        fill="#70A8FF"
      />
      <path
        d="M37.9062 28.6562C37.9062 31.4162 36.8099 34.063 34.8583 36.0146C32.9068 37.9661 30.2599 39.0625 27.5 39.0625C24.7401 39.0625 22.0932 37.9661 20.1417 36.0146C18.1901 34.063 17.0938 31.4162 17.0938 28.6562C17.0938 25.8963 18.1901 23.2495 20.1417 21.2979C22.0932 19.3464 24.7401 18.25 27.5 18.25C30.2599 18.25 32.9068 19.3464 34.8583 21.2979C36.8099 23.2495 37.9062 25.8963 37.9062 28.6562Z"
        fill="#425A7F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.3438 21.7188C26.6504 21.7188 26.9445 21.8406 27.1613 22.0574C27.3782 22.2742 27.5 22.5683 27.5 22.875V28.6562H30.9688C31.2754 28.6562 31.5695 28.7781 31.7863 28.9949C32.0032 29.2117 32.125 29.5058 32.125 29.8125C32.125 30.1192 32.0032 30.4133 31.7863 30.6301C31.5695 30.8469 31.2754 30.9688 30.9688 30.9688H26.3438C26.0371 30.9688 25.743 30.8469 25.5262 30.6301C25.3093 30.4133 25.1875 30.1192 25.1875 29.8125V22.875C25.1875 22.5683 25.3093 22.2742 25.5262 22.0574C25.743 21.8406 26.0371 21.7188 26.3438 21.7188Z"
        fill="#70A8FF"
      />
    </Icon>
  );
};

export const SupportChat = (props: any) => {
  return (
    <Icon
      {...props}
      viewBox="0 0 24 24"
      d={[
        "M2.47989 0C1.91119 0 1.19503 0.241948 0.792898 0.642229C0.390765 1.04251 0.00929752 1.91154 0.00929752 2.47763L0 15.102C0 15.6681 0.111139 16.4365 0.793388 17.1156C1.19552 17.5159 1.81146 17.7197 2.38017 17.7197H3.16851V21.0886C3.16851 21.3717 3.23841 21.6348 3.43947 21.8349C3.64054 22.035 3.83691 22.1475 4.0734 22.1475C4.30988 22.1475 4.60947 22.1475 5.14554 21.8349L9.32691 17.8787H17.6529C18.2216 17.8787 18.9978 17.6538 19.4 17.2535C19.8021 16.8532 20.028 16.0708 20.028 15.5047V2.33925C20.028 1.77317 19.8119 1.02544 19.4098 0.625156C19.0076 0.224875 18.2216 0 17.6529 0H2.47989ZM1.98347 2.0136H18.0491C18.0491 2.0136 18.0523 13.1039 18.0496 15.7442C18.0496 15.7442 18.0491 15.7442 16.4623 15.7442C15.4706 15.7442 8.44775 15.7442 8.44775 15.7442L5.14554 19.0312V15.7442C5.14554 15.7442 4.35405 15.7442 3.16851 15.7442C1.98298 15.7442 1.98298 15.7442 1.98298 14.4979C1.98535 11.6378 1.98347 2.0136 1.98347 2.0136Z",
        "M22.1382 7.8916C22.632 7.8916 23.1055 8.10425 23.4547 8.48275C23.8038 8.86126 24 9.37463 24 9.90992V14.4511V18.9924C24 19.5276 23.8038 20.041 23.4547 20.4195C23.1055 20.798 22.632 21.0107 22.1382 21.0107H21.3818V22.9555C21.3818 23.7934 20.7561 24.0004 20.2764 24.0004C19.7966 24.0004 19.6652 23.9623 19.3274 23.7048L16.2645 21.0107H11.7025C11.2087 21.0107 10.7351 20.798 10.386 20.4195C10.0368 20.041 9.84066 19.5276 9.84066 18.9924V16.7217H11.7025V9.90992L19.5293 9.7966V7.8916H22.1382ZM22.1382 9.7966H19.5293L11.7025 9.90992V14.4511V16.7217V19.1296H16.8595L19.6652 21.5898V19.1296H22.1382V9.7966Z",
        "M9.27111 13.692H10.9571V12.014H9.27111V13.692ZM10.1141 3.62402C8.25111 3.62402 6.74219 5.12583 6.74219 6.98003H8.42814C8.42814 6.05712 9.18682 5.30202 10.1141 5.30202C11.0414 5.30202 11.8 6.05712 11.8 6.98003C11.8 8.65803 9.27111 8.44828 9.27111 11.175H10.9571C10.9571 9.28728 13.486 9.07753 13.486 6.98003C13.486 5.12583 11.9771 3.62402 10.1141 3.62402Z",
      ]}
    />
  );
};

export const CrowLogo = (props: any) => {
  return (
    <Icon
      {...props}
      viewBox="0 0 180 156"
      d={[
        "M64.1238 78.2205C62.1238 78.7205 60.0238 79.2205 57.8238 79.6205C55.6238 81.6205 58.9238 81.5205 64.1238 78.2205Z",
        "M147.024 25.5204C152.224 19.3204 172.424 36.4204 172.424 36.4204C171.124 19.8204 151.824 13.2204 151.824 13.2204C151.824 13.2204 144.724 4.02037 137.424 1.32037C130.224 -1.37963 126.224 0.72037 122.824 1.82037C119.424 2.92037 118.224 1.82037 118.224 1.82037L119.124 3.12037L116.724 3.72036L117.624 4.12037L115.524 5.12037H117.424C117.424 5.12037 116.624 5.82037 110.024 9.62037C105.024 12.4204 102.924 12.9204 102.124 13.0204H104.224C104.224 13.0204 104.024 13.2204 103.624 13.6204C102.624 14.5204 100.224 16.5204 96.6237 19.3204C91.4237 23.2204 75.0237 30.0204 68.1237 36.1204C63.6237 40.0204 62.0237 42.9204 60.2237 45.7204C61.6237 44.6204 62.8237 43.8204 63.8237 43.4204C63.8237 43.4204 61.9237 44.8204 59.4237 47.0204C58.7237 48.1204 57.9237 49.2204 56.9237 50.3204C54.7237 52.8204 52.2237 54.9204 49.7237 57.0204C49.0237 57.9204 48.3237 58.9204 47.7237 59.8204C47.9237 59.2204 48.2237 58.6204 48.6237 58.0204C46.8237 59.6204 45.1237 61.3204 43.5237 63.2204C39.4237 68.2204 35.3237 72.4204 31.3237 78.8204C25.9237 87.4204 17.9237 100.72 19.5237 100.82C21.0237 100.92 26.7237 92.8204 33.0237 87.1204C31.2237 90.1204 29.2237 91.9204 29.2237 91.9204C29.2237 91.9204 34.9237 88.8204 40.8237 85.6204C46.7237 82.4204 34.3237 89.2204 40.5237 87.2204C46.3237 85.3204 53.4237 81.4204 57.6237 79.3204C55.3237 79.7204 52.8237 80.0204 50.3237 80.3204C55.8237 78.9204 62.3237 77.1204 69.0237 74.5204C69.3237 74.2204 69.6237 74.0204 70.0237 73.7204C69.8237 73.9204 69.5237 74.2204 69.3237 74.4204C84.0237 68.5204 99.4238 58.3204 107.424 38.3204C107.424 38.3204 100.924 67.7204 65.8237 77.6204C61.2237 81.3204 57.0237 82.8204 56.3237 80.9204C46.5237 86.2204 38.4237 89.4204 38.0237 88.5204C35.5237 89.5204 34.5237 90.6204 32.8237 92.4204C31.2237 94.3204 22.2237 104.42 10.0237 109.72C-2.17626 115.12 -1.07627 117.52 2.12373 116.92C3.02373 116.72 3.62374 116.62 4.02374 116.52C3.72374 116.62 3.42373 116.82 2.92373 117.02C0.723734 118.02 2.92374 119.12 6.82374 118.22C10.7237 117.32 16.7237 114.32 21.3237 109.92C20.0237 111.92 14.7237 115.92 15.9237 115.82C17.1237 115.72 19.8237 115.12 21.6237 113.62C23.4237 112.12 18.3237 117.32 23.4237 115.22C28.4237 113.12 47.5237 105.42 47.5237 105.42C47.5237 105.42 50.7237 106.62 54.0237 104.02C55.9237 104.32 57.5237 104.52 59.0237 104.72C58.8237 107.02 58.4237 109.62 57.8237 110.72C56.8237 112.52 57.5237 112.52 59.1237 111.42C60.7237 110.32 59.9237 110.82 60.0237 111.72C60.1237 112.62 60.9237 114.22 60.9237 112.12C60.6237 109.42 63.1237 109.92 64.7237 112.22C66.3237 114.52 76.3237 129.82 77.5237 132.32C78.7237 134.82 75.7237 136.02 75.3237 136.52C74.9237 137.02 72.8238 137.42 71.4238 136.92C69.4238 136.22 68.4237 138.12 68.3237 140.62C69.2237 139.42 70.1237 139.22 72.3237 139.92C74.5237 140.62 74.9237 139.62 78.3237 138.02C77.6237 138.52 78.5237 140.02 78.5237 140.02C78.5237 140.02 79.5237 140.22 79.5237 142.42C80.5237 142.22 80.5237 140.22 81.0237 138.42C81.4237 136.62 83.7237 137.42 87.6237 137.62C87.9237 138.72 89.8237 139.92 89.8237 139.92C89.8237 139.92 90.3237 139.32 90.6237 141.72C91.0237 140.52 91.1237 139.42 91.0237 138.62C91.8237 138.82 92.8237 139.02 93.5237 139.22C94.8237 139.52 96.5237 137.32 96.5237 137.32C96.5237 137.32 97.6237 137.72 97.7237 139.22C99.3237 135.62 96.0237 135.02 94.1237 135.62C92.2237 136.22 89.7237 135.62 89.7237 135.62C88.7237 134.72 87.3237 134.42 86.1237 134.42C83.4237 134.22 83.0237 133.32 83.0237 133.32C83.0237 133.32 73.9237 118.72 72.5237 116.62C71.0237 114.52 70.5238 112.72 71.4238 111.92C72.3238 111.02 79.0237 101.42 81.2237 103.32C83.4237 105.22 83.0238 109.72 81.9238 111.22C80.8238 112.72 80.3237 115.72 81.6237 118.02C81.6237 117.22 82.5237 116.12 82.5237 116.12L83.5237 117.62L83.8237 116.12L85.3237 118.22C85.3237 118.22 84.5237 115.52 85.6237 116.12C86.7237 116.72 105.224 131.02 107.424 132.82C109.624 134.62 110.824 136.12 109.024 136.12C107.224 136.12 105.724 135.82 104.024 136.12C102.324 136.42 102.124 139.22 102.124 139.22C102.124 139.22 103.424 138.02 105.124 138.32C106.124 139.42 109.824 139.02 111.124 138.62C112.524 138.22 117.524 137.42 120.424 139.22C123.324 141.02 127.024 139.32 127.924 138.32C128.824 137.32 130.424 137.72 131.624 139.12C132.824 140.52 134.024 139.12 134.024 139.12C134.024 139.12 134.424 139.22 135.524 140.42C135.624 138.82 133.624 136.92 132.724 136.22C131.824 135.52 130.124 136.22 130.124 136.22C130.124 136.22 130.224 134.22 128.924 133.72C127.624 133.22 126.624 134.52 124.224 135.72C121.824 136.92 117.924 136.02 114.424 133.82C110.924 131.62 97.8237 120.92 92.2237 116.42C93.4237 115.62 94.2238 112.62 94.9238 108.92C95.2238 107.32 95.6237 105.82 96.2237 104.42C96.4237 104.12 96.5237 103.82 96.7237 103.52C97.5237 103.12 98.2237 102.62 98.8237 102.32C102.724 98.9204 110.324 91.8204 116.624 82.9204C115.124 87.6204 112.224 91.2204 110.124 93.3204C112.724 90.9204 115.224 88.3204 116.724 85.9204C120.924 79.2204 128.824 64.6204 133.224 58.0204C137.624 51.4204 137.324 36.4204 137.324 36.4204C137.324 32.3204 144.224 35.8204 151.124 40.2204C158.024 44.6204 163.424 43.7204 163.424 43.7204C163.424 43.7204 141.824 31.7204 147.024 25.5204ZM101.124 21.4204C101.824 21.2204 102.424 21.0204 103.024 20.9204L90.3237 29.0204C85.8237 29.2204 76.4237 33.7204 67.2237 40.2204C73.5237 32.4204 92.0237 24.2204 101.124 21.4204ZM67.2237 56.9204C67.2237 56.9204 58.3237 58.0204 50.2237 63.4204C55.7237 56.9204 60.4237 56.1204 67.2237 56.9204ZM38.9237 78.6204C42.0237 69.3204 50.8237 64.9204 56.6237 63.4204C56.5237 63.3204 44.4237 71.3204 38.9237 78.6204ZM54.0237 77.5204C54.0237 77.5204 58.3237 72.2204 67.2237 67.6204L64.9238 74.1204C58.9238 77.0204 54.0237 77.5204 54.0237 77.5204ZM68.1237 72.5204C67.4237 72.9204 66.7237 73.3204 66.0237 73.6204L68.3237 67.1204C68.9237 66.8204 69.6237 66.5204 70.3237 66.2204L68.1237 72.5204ZM69.2237 71.8204L71.3237 65.8204C72.0237 65.5204 72.6237 65.3204 73.3237 65.0204L71.5237 70.3204C70.7237 70.8204 69.9237 71.4204 69.2237 71.8204ZM72.6237 69.4204L74.2237 64.7204C75.6237 64.2204 77.1237 63.8204 78.7237 63.4204C76.8237 65.7204 74.7237 67.7204 72.6237 69.4204ZM97.5237 35.2204C94.4237 37.1204 82.3237 41.9204 82.3237 41.9204C82.3237 41.9204 85.5237 41.4204 86.8237 40.8204C88.1237 40.3204 89.9237 41.0204 87.7237 42.3204C87.7237 42.3204 87.6237 42.3204 87.6237 42.4204C85.2237 43.7204 74.2237 47.5204 74.2237 47.5204L79.5237 46.8204C70.0237 51.7204 61.1237 55.5204 61.1237 55.5204C61.1237 55.5204 78.0237 44.0204 87.1237 36.3204C88.0237 36.1204 89.0237 35.7204 90.2237 35.3204C93.7237 33.8204 100.724 33.3204 97.5237 35.2204ZM101.024 31.2204C98.8237 32.5204 92.5238 34.1204 88.4238 35.1204C90.1238 33.6204 91.4237 32.3204 92.2237 31.3204C93.7237 30.7204 95.7237 29.8204 98.2237 28.7204C104.324 26.0204 104.424 29.2204 101.024 31.2204ZM106.924 24.6204L92.7237 29.8204C92.5237 29.5204 92.2237 29.4204 91.8237 29.3204L103.224 23.3204L105.924 21.2204C107.024 21.7204 107.424 22.9204 106.924 24.6204ZM16.2237 109.32L49.2237 90.8204C37.6237 99.5204 16.2237 109.32 16.2237 109.32ZM136.524 16.8204C135.124 16.8204 134.024 15.7204 134.024 14.3204C134.024 12.9204 135.124 11.8204 136.524 11.8204C137.924 11.8204 139.024 12.9204 139.024 14.3204C139.024 15.7204 137.924 16.8204 136.524 16.8204Z",
        "M176.224 146.42C179.724 146.92 181.624 146.72 173.324 144.92C172.724 144.82 172.124 144.62 171.424 144.52C165.124 143.42 158.724 142.12 152.424 141.42C139.724 139.52 126.924 138.82 114.124 138.42C101.324 138.12 88.5237 138.72 75.7237 140.02C63.4237 141.32 51.3237 143.12 39.0237 146.42C38.1237 146.62 37.5237 147.92 37.7237 149.12L38.7237 154.22C38.9237 155.42 39.8237 156.12 40.7237 155.82C52.2237 152.02 64.3237 149.32 76.2237 147.32C88.8237 145.22 101.424 143.82 114.124 143.32C126.824 142.82 139.524 142.82 152.224 143.82C158.624 144.12 164.924 145.02 171.324 145.72C172.924 145.92 174.524 146.22 176.224 146.42Z",
      ]}
    />
  );
};

export const TvSymbol = (props: any) => {
  const prefix = useMemo(() => uuidv4(), []);

  return (
    <Icon {...props} viewBox="0 0 180 180">
      <rect width="180" height="180" fill="black" />
      <g clipPath={`url(#${prefix}clip0_4807_10016)`}>
        <path d="M10 10H170V170H10V10Z" fill="black" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M115.055 72.5C115.055 79.8638 109.086 85.8333 101.722 85.8333C94.3583 85.8333 88.3888 79.8638 88.3888 72.5C88.3888 65.1362 94.3583 59.1667 101.722 59.1667C109.086 59.1667 115.055 65.1362 115.055 72.5ZM81.9999 59.7778H28.6667L28.6665 86.4444H55.3332V125.556H81.9999V59.7778ZM128.755 59.7778H159.333L131.778 125.556H101.111L128.755 59.7778Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id={`${prefix}clip0_4807_10016`}>
          <rect
            width="160"
            height="160"
            fill="white"
            transform="translate(10 10)"
          />
        </clipPath>
      </defs>
    </Icon>
  );
};

export const TvSymbolDarkMode = (props: any) => {
  const prefix = useMemo(() => uuidv4(), []);

  return (
    <Icon {...props} viewBox="0 0 180 180">
      <rect width="180" height="180" fill="white" />
      <g clipPath={`url(#${prefix}clip0_4807_10018)`}>
        <path d="M10 10H170V170H10V10Z" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M115.055 72.5C115.055 79.8638 109.086 85.8333 101.722 85.8333C94.3583 85.8333 88.3888 79.8638 88.3888 72.5C88.3888 65.1362 94.3583 59.1667 101.722 59.1667C109.086 59.1667 115.055 65.1362 115.055 72.5ZM81.9999 59.7778H28.6667L28.6665 86.4444H55.3332V125.556H81.9999V59.7778ZM128.755 59.7778H159.333L131.778 125.556H101.111L128.755 59.7778Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id={`${prefix}clip0_4807_10018`}>
          <rect
            width="160"
            height="160"
            fill="white"
            transform="translate(10 10)"
          />
        </clipPath>
      </defs>
    </Icon>
  );
};

export const InvoicesEmptyState = (props: any) => {
  return (
    <Icon {...props} viewBox="0 0 229 198" fill="none">
      <path
        d="M113.502 197.333C171.837 197.333 219.126 185.637 219.126 171.21C219.126 156.784 171.837 145.088 113.502 145.088C55.1674 145.088 7.87793 156.784 7.87793 171.21C7.87793 185.637 55.1674 197.333 113.502 197.333Z"
        fill="url(#paint0_linear_565_236)"
      />
      <path
        d="M154.807 39.0477L156.368 146.348C156.391 147.818 156.127 149.278 155.592 150.645C155.057 152.012 154.261 153.258 153.249 154.313C152.237 155.367 151.03 156.209 149.696 156.79C148.363 157.371 146.929 157.68 145.477 157.698L48.9506 159.166C46.0147 159.209 43.182 158.07 41.0744 156C38.9668 153.929 37.7565 151.096 37.7093 148.123L35.9074 24.0961C35.8673 21.129 36.9917 18.267 39.0336 16.1388C41.0755 14.0106 43.868 12.7901 46.7977 12.7455L127.014 11.5471L154.807 39.0477Z"
        fill="url(#paint1_linear_565_236)"
      />
      <g filter="url(#filter0_f_565_236)">
        <path
          d="M169.002 58.3064L150.77 157.344C150.522 158.701 150.018 159.991 149.287 161.14C148.557 162.289 147.614 163.274 146.513 164.039C145.412 164.804 144.174 165.333 142.87 165.597C141.567 165.861 140.223 165.854 138.916 165.577L51.9923 147.343C49.3488 146.787 47.0142 145.164 45.5009 142.832C43.9877 140.499 43.4195 137.648 43.9212 134.902L64.9971 20.4269C65.504 17.6888 67.0371 15.2838 69.2596 13.7401C71.4821 12.1963 74.2123 11.64 76.8506 12.1934L149.083 27.3658L169.002 58.3064Z"
          fill="url(#paint2_linear_565_236)"
        />
      </g>
      <path
        d="M181.895 48.6411L161.434 153.933C161.156 155.376 160.599 156.749 159.795 157.974C158.991 159.198 157.957 160.25 156.751 161.069C155.546 161.888 154.192 162.458 152.768 162.746C151.345 163.034 149.879 163.035 148.455 162.748L53.7291 143.896C50.8483 143.32 48.3107 141.611 46.6732 139.143C45.0358 136.674 44.4324 133.649 44.9954 130.73L68.6478 9.02476C69.2166 6.11376 70.903 3.55043 73.3365 1.89772C75.7701 0.245011 78.7518 -0.361946 81.6269 0.210174L160.343 15.8977L181.895 48.6411Z"
        fill="url(#paint3_linear_565_236)"
      />
      <path
        d="M181.894 48.6406L155.012 43.2904L160.316 15.9022L181.894 48.6406Z"
        fill="url(#paint4_linear_565_236)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M147.655 76.1084C139.887 81.895 133.497 90.8993 129.661 101.463C125.825 112.026 124.97 122.973 127.253 132.287C129.623 141.951 135.075 148.729 142.606 151.372L153.559 155.216C161.082 157.856 169.633 155.99 177.638 149.962C185.328 144.172 191.678 135.156 195.52 124.576C199.362 113.997 200.255 103.066 198.034 93.7975C195.722 84.1482 190.306 77.3801 182.784 74.7401L171.831 70.8962C164.3 68.2533 155.714 70.1042 147.655 76.1084ZM133.694 102.878C130.076 112.84 129.255 123.102 131.381 131.773C133.409 140.047 137.846 145.768 143.873 147.883C149.867 149.987 156.907 148.299 163.696 143.131C170.786 137.734 176.692 129.251 180.326 119.244C183.96 109.237 184.854 98.9952 182.843 90.4046C180.918 82.178 176.557 76.4891 170.564 74.3857C164.536 72.2703 157.417 73.936 150.517 79.0763C143.286 84.4633 137.311 92.9165 133.694 102.878Z"
        fill="url(#paint5_linear_565_236)"
      />
      <foreignObject
        x="33.7431"
        y="1.98438"
        width="145.259"
        height="173.806"
      ></foreignObject>
      <path
        data-figma-bg-blur-radius="1.27803"
        d="M172.237 71.1575C179.448 73.7056 184.916 80.1318 187.581 89.348C190.364 98.9731 189.723 110.341 185.746 121.357C181.768 132.373 174.984 141.571 166.666 147.273C158.701 152.734 150.354 154.278 143.144 151.73C135.889 149.166 130.326 142.699 127.534 133.423C124.608 123.703 125.161 112.31 129.119 101.348C133.077 90.3855 139.945 81.2248 148.435 75.5381C156.536 70.1114 164.982 68.5937 172.237 71.1575Z"
        stroke="url(#paint6_linear_565_236)"
      />
      <mask
        id="mask0_565_236"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="127"
        y="71"
        width="58"
        height="80"
      >
        <foreignObject
          x="33.7431"
          y="1.98438"
          width="145.259"
          height="173.806"
        ></foreignObject>
        <path
          data-figma-bg-blur-radius="1.27803"
          d="M128.924 132.401C126.635 123.363 127.444 112.684 131.204 102.333C134.963 91.9814 141.215 83.213 148.809 77.6433C156.054 72.3287 163.55 70.6323 169.917 72.8666C176.246 75.0881 180.875 81.0337 182.95 89.608C185.117 98.5619 184.23 109.219 180.454 119.618C176.678 130.016 170.499 138.816 163.054 144.396C155.925 149.74 148.512 151.46 142.182 149.239C135.816 147.004 131.107 141.025 128.924 132.401Z"
          fill="#797BF6"
        />
      </mask>
      <g mask="url(#mask0_565_236)">
        <foreignObject
          x="-818.398"
          y="-626.752"
          width="1953"
          height="1507.13"
        ></foreignObject>
        <g filter="url(#filter1_i_565_236)" data-figma-bg-blur-radius="3.44504">
          <path
            d="M-758.525 267.21C-669.843 62.7977 -488.611 -141.58 -248.202 -308.273C-7.79312 -474.967 262.61 -583.748 513.196 -614.568C752.299 -643.981 941.411 -598.596 1045.71 -486.771C1149.42 -375.584 1159.04 -208.112 1072.81 -15.209C982.765 186.231 800.181 389.387 558.686 556.834C317.19 724.28 47.8934 834.453 -199.622 867.064C-436.645 898.296 -624.29 854.264 -727.999 743.074C-832.295 631.253 -843.14 462.256 -758.525 267.21Z"
            fill="url(#paint7_linear_565_236)"
          />
        </g>
        <foreignObject
          x="-818.398"
          y="-626.752"
          width="1953"
          height="1507.13"
        ></foreignObject>
        <g filter="url(#filter2_i_565_236)" data-figma-bg-blur-radius="3.44504">
          <path
            d="M-758.525 267.21C-669.843 62.7977 -488.611 -141.58 -248.202 -308.273C-7.79312 -474.967 262.61 -583.748 513.196 -614.568C752.299 -643.981 941.411 -598.596 1045.71 -486.771C1149.42 -375.584 1159.04 -208.112 1072.81 -15.209C982.765 186.231 800.181 389.387 558.686 556.834C317.19 724.28 47.8934 834.453 -199.622 867.064C-436.645 898.296 -624.29 854.264 -727.999 743.074C-832.295 631.253 -843.14 462.256 -758.525 267.21Z"
            fill="url(#paint8_linear_565_236)"
          />
        </g>
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M147.654 76.1084C139.887 81.895 133.496 90.8994 129.66 101.463C125.824 112.026 124.969 122.973 127.253 132.287C129.622 141.951 135.075 148.729 142.606 151.372L153.558 155.216C161.081 157.856 169.633 155.99 177.638 149.962C185.327 144.172 191.678 135.156 195.52 124.576C199.362 113.997 200.254 103.066 198.034 93.7975C195.722 84.1482 190.305 77.3801 182.783 74.7401L171.83 70.8962C164.299 68.2533 155.713 70.1042 147.654 76.1084ZM133.693 102.878C130.076 112.84 129.254 123.102 131.38 131.773C133.409 140.047 137.845 145.768 143.873 147.883C149.866 149.987 156.906 148.299 163.696 143.131C170.786 137.734 176.691 129.251 180.325 119.244C183.959 109.237 184.853 98.9952 182.843 90.4046C180.918 82.178 176.557 76.4891 170.563 74.3857C164.535 72.2703 157.416 73.936 150.517 79.0763C143.285 84.4633 137.311 92.9165 133.693 102.878Z"
        fill="url(#paint9_linear_565_236)"
      />
      <foreignObject
        x="-818.398"
        y="-626.752"
        width="1953"
        height="1507.13"
      ></foreignObject>
      <path
        data-figma-bg-blur-radius="1.27803"
        d="M172.237 71.1575C179.447 73.7056 184.915 80.1318 187.58 89.348C190.363 98.9731 189.722 110.341 185.745 121.357C181.768 132.373 174.983 141.571 166.665 147.273C158.701 152.734 150.354 154.278 143.143 151.73C135.888 149.166 130.326 142.698 127.534 133.422C124.608 123.702 125.16 112.31 129.119 101.348C133.077 90.3855 139.945 81.2248 148.434 75.5381C156.535 70.1114 164.981 68.5937 172.237 71.1575Z"
        stroke="url(#paint10_linear_565_236)"
      />
      <mask
        id="mask1_565_236"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="127"
        y="71"
        width="58"
        height="80"
      >
        <foreignObject
          x="-818.398"
          y="-626.752"
          width="1953"
          height="1507.13"
        ></foreignObject>
        <path
          data-figma-bg-blur-radius="1.27803"
          d="M128.923 132.401C126.634 123.363 127.444 112.684 131.203 102.333C134.962 91.9814 141.214 83.213 148.808 77.6433C156.054 72.3287 163.55 70.6323 169.916 72.8666C176.246 75.0881 180.875 81.0337 182.95 89.608C185.116 98.5619 184.23 109.219 180.454 119.618C176.678 130.016 170.498 138.816 163.053 144.396C155.924 149.74 148.512 151.46 142.182 149.239C135.816 147.004 131.107 141.025 128.923 132.401Z"
          fill="#797BF6"
        />
      </mask>
      <g mask="url(#mask1_565_236)">
        <foreignObject
          x="-818.398"
          y="-626.752"
          width="1953"
          height="1507.13"
        ></foreignObject>
        <g filter="url(#filter3_i_565_236)" data-figma-bg-blur-radius="3.44504">
          <path
            d="M-758.525 267.211C-669.844 62.7982 -488.611 -141.58 -248.202 -308.273C-7.7933 -474.966 262.61 -583.747 513.196 -614.568C752.299 -643.98 941.411 -598.595 1045.71 -486.771C1149.42 -375.584 1159.04 -208.112 1072.81 -15.2085C982.765 186.232 800.181 389.387 558.686 556.834C317.19 724.281 47.8932 834.454 -199.622 867.065C-436.645 898.297 -624.291 854.265 -727.999 743.074C-832.296 631.253 -843.14 462.256 -758.525 267.211Z"
            fill="url(#paint11_linear_565_236)"
          />
        </g>
        <foreignObject
          x="-818.398"
          y="-626.752"
          width="1953"
          height="1507.13"
        ></foreignObject>
        <g filter="url(#filter4_i_565_236)" data-figma-bg-blur-radius="3.44504">
          <path
            d="M-758.525 267.211C-669.844 62.7982 -488.611 -141.58 -248.202 -308.273C-7.7933 -474.966 262.61 -583.747 513.196 -614.568C752.299 -643.98 941.411 -598.595 1045.71 -486.771C1149.42 -375.584 1159.04 -208.112 1072.81 -15.2085C982.765 186.232 800.181 389.387 558.686 556.834C317.19 724.281 47.8932 834.454 -199.622 867.065C-436.645 898.297 -624.291 854.265 -727.999 743.074C-832.296 631.253 -843.14 462.256 -758.525 267.211Z"
            fill="url(#paint12_linear_565_236)"
          />
        </g>
      </g>
      <path
        d="M160.609 89.7271L162.941 82.7635L168.417 84.5664L166.085 91.53L160.609 89.7271ZM145.079 136.092L147.452 129.009L152.928 130.812L150.556 137.894L145.079 136.092ZM149.772 131.887C147.533 131.15 145.814 129.879 144.613 128.075C143.413 126.27 142.765 124.052 142.67 121.421C142.575 118.791 143.065 115.869 144.142 112.655L149.858 114.536C148.941 117.274 148.663 119.518 149.024 121.266C149.412 123.024 150.458 124.184 152.164 124.745C153.523 125.193 154.749 125.111 155.841 124.502C156.972 123.861 157.817 122.707 158.376 121.041C158.774 119.851 158.827 118.811 158.533 117.921C158.239 117.031 157.712 116.219 156.952 115.484C156.232 114.719 155.406 113.962 154.473 113.214C153.566 112.475 152.673 111.653 151.793 110.746C150.913 109.84 150.166 108.801 149.553 107.63C148.966 106.467 148.645 105.084 148.59 103.48C148.549 101.837 148.9 99.9039 149.645 97.6819C150.415 95.3806 151.52 93.4533 152.957 91.9C154.435 90.3159 156.112 89.2381 157.99 88.6669C159.868 88.0956 161.833 88.1477 163.885 88.8233C165.777 89.4461 167.33 90.552 168.543 92.141C169.784 93.7387 170.558 95.7116 170.866 98.0598C171.174 100.408 170.87 103.039 169.953 105.953L164.117 104.032C164.569 102.595 164.714 101.321 164.553 100.211C164.419 99.1095 164.072 98.2022 163.512 97.4892C162.992 96.7453 162.319 96.2374 161.493 95.9654C160.293 95.5706 159.155 95.6583 158.076 96.2283C157.024 96.8072 156.239 97.8703 155.721 99.4178C155.349 100.529 155.316 101.509 155.623 102.359C155.93 103.209 156.45 103.997 157.184 104.723C157.957 105.418 158.81 106.14 159.743 106.887C160.689 107.595 161.589 108.398 162.443 109.296C163.336 110.163 164.063 111.217 164.623 112.459C165.224 113.67 165.531 115.136 165.546 116.859C165.56 118.582 165.169 120.634 164.372 123.015C163.561 125.435 162.39 127.429 160.86 128.995C159.329 130.562 157.605 131.602 155.687 132.116C153.769 132.63 151.797 132.554 149.772 131.887Z"
        fill="url(#paint13_linear_565_236)"
      />
      <defs>
        <filter
          id="filter0_f_565_236"
          x="33.7431"
          y="1.98438"
          width="145.259"
          height="173.806"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="5"
            result="effect1_foregroundBlur_565_236"
          />
        </filter>
        <clipPath
          id="bgblur_0_565_236_clip_path"
          transform="translate(-33.7431 -1.98438)"
        >
          <path d="M172.237 71.1575C179.448 73.7056 184.916 80.1318 187.581 89.348C190.364 98.9731 189.723 110.341 185.746 121.357C181.768 132.373 174.984 141.571 166.666 147.273C158.701 152.734 150.354 154.278 143.144 151.73C135.889 149.166 130.326 142.699 127.534 133.423C124.608 123.703 125.161 112.31 129.119 101.348C133.077 90.3855 139.945 81.2248 148.435 75.5381C156.536 70.1114 164.982 68.5937 172.237 71.1575Z" />
        </clipPath>
        <clipPath
          id="bgblur_1_565_236_clip_path"
          transform="translate(-33.7431 -1.98438)"
        >
          <path d="M128.924 132.401C126.635 123.363 127.444 112.684 131.204 102.333C134.963 91.9814 141.215 83.213 148.809 77.6433C156.054 72.3287 163.55 70.6323 169.917 72.8666C176.246 75.0881 180.875 81.0337 182.95 89.608C185.117 98.5619 184.23 109.219 180.454 119.618C176.678 130.016 170.499 138.816 163.054 144.396C155.925 149.74 148.512 151.46 142.182 149.239C135.816 147.004 131.107 141.025 128.924 132.401Z" />
        </clipPath>
        <filter
          id="filter1_i_565_236"
          x="-818.398"
          y="-626.752"
          width="1953"
          height="1507.13"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.52284" />
          <feGaussianBlur stdDeviation="23.4856" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.560784 0 0 0 0 0.607843 0 0 0 0 1 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_565_236"
          />
        </filter>
        <clipPath
          id="bgblur_2_565_236_clip_path"
          transform="translate(818.398 626.752)"
        >
          <path d="M-758.525 267.21C-669.843 62.7977 -488.611 -141.58 -248.202 -308.273C-7.79312 -474.967 262.61 -583.748 513.196 -614.568C752.299 -643.981 941.411 -598.596 1045.71 -486.771C1149.42 -375.584 1159.04 -208.112 1072.81 -15.209C982.765 186.231 800.181 389.387 558.686 556.834C317.19 724.28 47.8934 834.453 -199.622 867.064C-436.645 898.296 -624.29 854.264 -727.999 743.074C-832.295 631.253 -843.14 462.256 -758.525 267.21Z" />
        </clipPath>
        <filter
          id="filter2_i_565_236"
          x="-818.398"
          y="-626.752"
          width="1953"
          height="1507.13"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.52284" />
          <feGaussianBlur stdDeviation="23.4856" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.560784 0 0 0 0 0.607843 0 0 0 0 1 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_565_236"
          />
        </filter>
        <clipPath
          id="bgblur_3_565_236_clip_path"
          transform="translate(818.398 626.752)"
        >
          <path d="M-758.525 267.21C-669.843 62.7977 -488.611 -141.58 -248.202 -308.273C-7.79312 -474.967 262.61 -583.748 513.196 -614.568C752.299 -643.981 941.411 -598.596 1045.71 -486.771C1149.42 -375.584 1159.04 -208.112 1072.81 -15.209C982.765 186.231 800.181 389.387 558.686 556.834C317.19 724.28 47.8934 834.453 -199.622 867.064C-436.645 898.296 -624.29 854.264 -727.999 743.074C-832.295 631.253 -843.14 462.256 -758.525 267.21Z" />
        </clipPath>
        <clipPath
          id="bgblur_4_565_236_clip_path"
          transform="translate(818.398 626.752)"
        >
          <path d="M172.237 71.1575C179.447 73.7056 184.915 80.1318 187.58 89.348C190.363 98.9731 189.722 110.341 185.745 121.357C181.768 132.373 174.983 141.571 166.665 147.273C158.701 152.734 150.354 154.278 143.143 151.73C135.888 149.166 130.326 142.698 127.534 133.422C124.608 123.702 125.16 112.31 129.119 101.348C133.077 90.3855 139.945 81.2248 148.434 75.5381C156.535 70.1114 164.981 68.5937 172.237 71.1575Z" />
        </clipPath>
        <clipPath
          id="bgblur_5_565_236_clip_path"
          transform="translate(818.398 626.752)"
        >
          <path d="M128.923 132.401C126.634 123.363 127.444 112.684 131.203 102.333C134.962 91.9814 141.214 83.213 148.808 77.6433C156.054 72.3287 163.55 70.6323 169.916 72.8666C176.246 75.0881 180.875 81.0337 182.95 89.608C185.116 98.5619 184.23 109.219 180.454 119.618C176.678 130.016 170.498 138.816 163.053 144.396C155.924 149.74 148.512 151.46 142.182 149.239C135.816 147.004 131.107 141.025 128.923 132.401Z" />
        </clipPath>
        <filter
          id="filter3_i_565_236"
          x="-818.398"
          y="-626.752"
          width="1953"
          height="1507.13"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.52284" />
          <feGaussianBlur stdDeviation="23.4856" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.560784 0 0 0 0 0.607843 0 0 0 0 1 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_565_236"
          />
        </filter>
        <clipPath
          id="bgblur_6_565_236_clip_path"
          transform="translate(818.398 626.752)"
        >
          <path d="M-758.525 267.211C-669.844 62.7982 -488.611 -141.58 -248.202 -308.273C-7.7933 -474.966 262.61 -583.747 513.196 -614.568C752.299 -643.98 941.411 -598.595 1045.71 -486.771C1149.42 -375.584 1159.04 -208.112 1072.81 -15.2085C982.765 186.232 800.181 389.387 558.686 556.834C317.19 724.281 47.8932 834.454 -199.622 867.065C-436.645 898.297 -624.291 854.265 -727.999 743.074C-832.296 631.253 -843.14 462.256 -758.525 267.211Z" />
        </clipPath>
        <filter
          id="filter4_i_565_236"
          x="-818.398"
          y="-626.752"
          width="1953"
          height="1507.13"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.52284" />
          <feGaussianBlur stdDeviation="23.4856" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.560784 0 0 0 0 0.607843 0 0 0 0 1 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_565_236"
          />
        </filter>
        <clipPath
          id="bgblur_7_565_236_clip_path"
          transform="translate(818.398 626.752)"
        >
          <path d="M-758.525 267.211C-669.844 62.7982 -488.611 -141.58 -248.202 -308.273C-7.7933 -474.966 262.61 -583.747 513.196 -614.568C752.299 -643.98 941.411 -598.595 1045.71 -486.771C1149.42 -375.584 1159.04 -208.112 1072.81 -15.2085C982.765 186.232 800.181 389.387 558.686 556.834C317.19 724.281 47.8932 834.454 -199.622 867.065C-436.645 898.297 -624.291 854.265 -727.999 743.074C-832.296 631.253 -843.14 462.256 -758.525 267.211Z" />
        </clipPath>
        <linearGradient
          id="paint0_linear_565_236"
          x1="123.156"
          y1="217.776"
          x2="132.81"
          y2="89.437"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDEAFF" />
          <stop offset="1" stopColor="#F0F6FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_565_236"
          x1="3.7411"
          y1="265.033"
          x2="193.409"
          y2="69.5617"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_565_236"
          x1="130.516"
          y1="-48.5347"
          x2="50.1614"
          y2="160.017"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.760417" stopColor="#B3D2FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_565_236"
          x1="20.7801"
          y1="177.082"
          x2="310.753"
          y2="-20.8908"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#C6DDFF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_565_236"
          x1="162.6"
          y1="15.4528"
          x2="169.605"
          y2="51.0582"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDF4FF" />
          <stop offset="1" stopColor="#ABCCFF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_565_236"
          x1="165.071"
          y1="68.5238"
          x2="208.813"
          y2="110.834"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_565_236"
          x1="191.547"
          y1="192.938"
          x2="105.357"
          y2="120.424"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_565_236"
          x1="893.461"
          y1="-650.005"
          x2="1226.22"
          y2="330.227"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_565_236"
          x1="2529.11"
          y1="-465.996"
          x2="-828.968"
          y2="-610.027"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_565_236"
          x1="165.07"
          y1="68.5238"
          x2="208.812"
          y2="110.834"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_565_236"
          x1="191.546"
          y1="192.938"
          x2="105.357"
          y2="120.424"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_565_236"
          x1="893.46"
          y1="-650.005"
          x2="1226.22"
          y2="330.227"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD6FF" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_565_236"
          x1="2529.11"
          y1="-465.996"
          x2="-828.968"
          y2="-610.027"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCDFF" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_565_236"
          x1="170.732"
          y1="104.026"
          x2="140.444"
          y2="113.592"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6FA5F9" />
          <stop offset="1" stopColor="#5597FD" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const DarkInvoicesEmptyState = (props: any) => {
  return (
    <Icon {...props} viewBox="0 0 229 198" fill="none">
      <path
        d="M113.624 197.513C171.959 197.513 219.248 185.818 219.248 171.391C219.248 156.964 171.959 145.269 113.624 145.269C55.2895 145.269 8 156.964 8 171.391C8 185.818 55.2895 197.513 113.624 197.513Z"
        fill="url(#paint0_linear_568_358)"
      />
      <path
        d="M154.807 39.0477L156.368 146.348C156.391 147.818 156.127 149.278 155.592 150.645C155.057 152.012 154.261 153.258 153.249 154.313C152.237 155.367 151.03 156.209 149.696 156.79C148.363 157.371 146.929 157.68 145.477 157.699L48.9506 159.166C46.0147 159.209 43.182 158.07 41.0744 156C38.9668 153.929 37.7565 151.096 37.7093 148.123L35.9074 24.0961C35.8673 21.129 36.9917 18.267 39.0336 16.1388C41.0756 14.0106 43.868 12.7901 46.7977 12.7455L127.014 11.5471L154.807 39.0477Z"
        fill="url(#paint1_linear_568_358)"
      />
      <g filter="url(#filter0_f_568_358)">
        <path
          d="M169.002 58.3062L150.77 157.343C150.522 158.701 150.018 159.991 149.287 161.14C148.557 162.289 141.101 143.924 140 144.689C138.899 145.454 126.804 153.925 125.5 154.189C124.196 154.453 102.807 157.621 101.5 157.343L51.9923 147.343C49.3488 146.787 47.0142 145.164 45.5009 142.832C43.9877 140.499 43.4195 137.647 43.9212 134.902L64.9971 20.4267C65.504 17.6886 67.0371 15.2836 69.2596 13.7398C71.4821 12.1961 74.2123 11.6398 76.8506 12.1931L149.083 27.3656L169.002 58.3062Z"
          fill="url(#paint2_linear_568_358)"
          fillOpacity="0.6"
        />
      </g>
      <path
        d="M181.895 48.6411L161.434 153.933C161.156 155.376 160.599 156.749 159.795 157.974C158.992 159.198 157.957 160.25 156.751 161.069C155.546 161.888 154.192 162.458 152.768 162.746C151.345 163.034 149.879 163.035 148.455 162.748L53.7292 143.896C50.8484 143.32 48.3107 141.611 46.6733 139.143C45.0358 136.674 44.4324 133.649 44.9955 130.73L68.6478 9.02476C69.2167 6.11376 70.903 3.55043 73.3366 1.89772C75.7701 0.245011 78.7519 -0.361946 81.627 0.210174L160.343 15.8977L181.895 48.6411Z"
        fill="url(#paint3_linear_568_358)"
      />
      <path
        d="M181.894 48.6406L155.012 43.2904L160.316 15.9022L181.894 48.6406Z"
        fill="url(#paint4_linear_568_358)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M149.289 74.3434C141.503 79.9439 135.039 88.8508 131.087 99.4236C127.136 109.996 126.138 121.058 128.275 130.572C130.493 140.443 135.81 147.494 143.246 150.426L154.06 154.69C161.487 157.619 169.997 156.017 178.023 150.18C185.731 144.573 192.156 135.653 196.113 125.064C200.07 114.475 201.106 103.431 199.03 93.9657C196.869 84.1116 191.588 77.0717 184.161 74.1431L173.347 69.8789C165.911 66.947 157.367 68.5324 149.289 74.3434ZM135.069 100.994C131.343 110.965 130.387 121.333 132.377 130.19C134.276 138.641 138.599 144.587 144.551 146.934C150.468 149.267 157.476 147.795 164.283 142.788C171.392 137.56 177.368 129.165 181.111 119.149C184.854 109.133 185.882 98.7869 184.005 90.0154C182.208 81.6158 177.959 75.7048 172.042 73.3715C166.09 71.0247 159.004 72.4721 152.088 77.447C144.839 82.6607 138.795 91.0233 135.069 100.994Z"
        fill="url(#paint5_linear_568_358)"
      />
      <foreignObject
        x="36.7431"
        y="4.98413"
        width="139.259"
        height="163.207"
      ></foreignObject>
      <path
        data-figma-bg-blur-radius="1.27803"
        d="M174.303 70.3419C181.436 73.1746 186.793 79.8608 189.334 89.2616C191.988 99.0796 191.222 110.534 187.147 121.512C183.072 132.491 176.231 141.533 167.906 146.991C159.935 152.217 151.628 153.476 144.496 150.643C137.32 147.793 131.869 141.062 129.202 131.597C126.408 121.677 127.087 110.196 131.142 99.2707C135.198 88.3457 142.12 79.3433 150.615 73.9075C158.721 68.7202 167.127 67.4918 174.303 70.3419Z"
        stroke="url(#paint6_linear_568_358)"
      />
      <mask
        id="mask0_568_358"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="128"
        y="70"
        width="58"
        height="80"
      >
        <foreignObject
          x="36.7431"
          y="4.98413"
          width="139.259"
          height="163.207"
        ></foreignObject>
        <path
          data-figma-bg-blur-radius="1.27803"
          d="M129.912 130.69C127.751 121.46 128.689 110.677 132.552 100.328C136.416 89.9791 142.737 81.3202 150.35 75.9466C157.614 70.8191 165.082 69.3636 171.379 71.8481C177.639 74.3185 182.163 80.4997 184.117 89.2532C186.158 98.3941 185.144 109.153 181.263 119.549C177.382 129.944 171.133 138.637 163.668 144.027C156.519 149.189 149.134 150.671 142.873 148.201C136.577 145.716 131.974 139.498 129.912 130.69Z"
          fill="#797BF6"
        />
      </mask>
      <g mask="url(#mask0_568_358)">
        <foreignObject
          x="119.857"
          y="58.8091"
          width="79.6955"
          height="97.1764"
        ></foreignObject>
        <g filter="url(#filter1_i_568_358)" data-figma-bg-blur-radius="3.44504">
          <path
            d="M123.316 127.914C123.043 116.829 126.733 104.343 133.707 92.7547C140.681 81.1665 150.093 71.8829 160.208 66.6145C169.86 61.5873 178.86 60.8821 185.553 64.6288C192.207 68.3541 195.954 76.1879 196.103 86.6871C196.258 97.6509 192.486 110.1 185.48 121.74C178.475 133.381 169.138 142.714 159.19 148.021C149.664 153.103 140.753 153.851 134.098 150.125C127.406 146.379 123.577 138.491 123.316 127.914Z"
            fill="url(#paint7_linear_568_358)"
          />
        </g>
      </g>
      <path
        d="M159.818 88.3323L161.84 81.2722L167.316 83.0747L165.294 90.1347L159.818 88.3323ZM146.357 135.339L148.413 128.158L153.889 129.961L151.833 137.141L146.357 135.339ZM150.818 131.063C148.58 130.326 146.832 129.046 145.575 127.224C144.319 125.402 143.591 123.159 143.391 120.496C143.191 117.833 143.558 114.873 144.491 111.614L150.207 113.496C149.412 116.271 149.228 118.544 149.654 120.313C150.107 122.091 151.186 123.26 152.892 123.822C154.251 124.269 155.456 124.182 156.509 123.56C157.6 122.906 158.388 121.735 158.872 120.045C159.217 118.839 159.227 117.785 158.902 116.886C158.576 115.986 158.024 115.166 157.244 114.425C156.503 113.653 155.658 112.891 154.707 112.138C153.783 111.393 152.869 110.564 151.964 109.65C151.06 108.736 150.281 107.687 149.629 106.504C149.003 105.33 148.631 103.93 148.512 102.307C148.406 100.643 148.675 98.6847 149.32 96.4319C149.988 94.0987 151 92.1428 152.356 90.5642C153.75 88.9541 155.362 87.856 157.192 87.2698C159.022 86.6836 160.963 86.7281 163.015 87.4035C164.907 88.0263 166.483 89.1395 167.744 90.7431C169.032 92.3555 169.875 94.3498 170.273 96.726C170.672 99.1022 170.477 101.767 169.689 104.722L163.854 102.801C164.242 101.344 164.334 100.054 164.131 98.9302C163.955 97.8156 163.576 96.8985 162.995 96.179C162.452 95.4279 161.767 94.9165 160.941 94.6446C159.742 94.2499 158.622 94.3434 157.581 94.925C156.566 95.5155 155.834 96.5951 155.385 98.164C155.062 99.2904 155.069 100.283 155.406 101.143C155.743 102.002 156.288 102.797 157.041 103.529C157.832 104.23 158.702 104.957 159.653 105.71C160.615 106.423 161.535 107.232 162.413 108.137C163.329 109.011 164.089 110.075 164.691 111.33C165.332 112.554 165.695 114.038 165.778 115.782C165.862 117.526 165.558 119.605 164.867 122.019C164.164 124.473 163.089 126.496 161.642 128.089C160.194 129.681 158.535 130.742 156.663 131.27C154.791 131.798 152.843 131.729 150.818 131.063Z"
        fill="url(#paint8_linear_568_358)"
      />
      <defs>
        <filter
          id="filter0_f_568_358"
          x="36.7431"
          y="4.98413"
          width="139.259"
          height="163.207"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="3.5"
            result="effect1_foregroundBlur_568_358"
          />
        </filter>
        <clipPath
          id="bgblur_0_568_358_clip_path"
          transform="translate(-36.7431 -4.98413)"
        >
          <path d="M174.303 70.3419C181.436 73.1746 186.793 79.8608 189.334 89.2616C191.988 99.0796 191.222 110.534 187.147 121.512C183.072 132.491 176.231 141.533 167.906 146.991C159.935 152.217 151.628 153.476 144.496 150.643C137.32 147.793 131.869 141.062 129.202 131.597C126.408 121.677 127.087 110.196 131.142 99.2707C135.198 88.3457 142.12 79.3433 150.615 73.9075C158.721 68.7202 167.127 67.4918 174.303 70.3419Z" />
        </clipPath>
        <clipPath
          id="bgblur_1_568_358_clip_path"
          transform="translate(-36.7431 -4.98413)"
        >
          <path d="M129.912 130.69C127.751 121.46 128.689 110.677 132.552 100.328C136.416 89.9791 142.737 81.3202 150.35 75.9466C157.614 70.8191 165.082 69.3636 171.379 71.8481C177.639 74.3185 182.163 80.4997 184.117 89.2532C186.158 98.3941 185.144 109.153 181.263 119.549C177.382 129.944 171.133 138.637 163.668 144.027C156.519 149.189 149.134 150.671 142.873 148.201C136.577 145.716 131.974 139.498 129.912 130.69Z" />
        </clipPath>
        <filter
          id="filter1_i_568_358"
          x="119.857"
          y="58.8091"
          width="79.6955"
          height="97.1764"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.52284" />
          <feGaussianBlur stdDeviation="23.4856" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.560784 0 0 0 0 0.607843 0 0 0 0 1 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_568_358"
          />
        </filter>
        <clipPath
          id="bgblur_2_568_358_clip_path"
          transform="translate(-119.857 -58.8091)"
        >
          <path d="M123.316 127.914C123.043 116.829 126.733 104.343 133.707 92.7547C140.681 81.1665 150.093 71.8829 160.208 66.6145C169.86 61.5873 178.86 60.8821 185.553 64.6288C192.207 68.3541 195.954 76.1879 196.103 86.6871C196.258 97.6509 192.486 110.1 185.48 121.74C178.475 133.381 169.138 142.714 159.19 148.021C149.664 153.103 140.753 153.851 134.098 150.125C127.406 146.379 123.577 138.491 123.316 127.914Z" />
        </clipPath>
        <linearGradient
          id="paint0_linear_568_358"
          x1="125.5"
          y1="285.359"
          x2="123"
          y2="101.859"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0CFFF" />
          <stop offset="1" stopColor="#70A8FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_568_358"
          x1="51.5"
          y1="162.692"
          x2="210.94"
          y2="-151.992"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#83AEEB" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_568_358"
          x1="158"
          y1="-24.8083"
          x2="72.8894"
          y2="129.207"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.781197" stopColor="#B3D2FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_568_358"
          x1="59.0001"
          y1="119.692"
          x2="224.771"
          y2="13.3967"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D6E7FF" />
          <stop offset="1" stopColor="#ABCEFF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_568_358"
          x1="162.5"
          y1="38.6887"
          x2="193.909"
          y2="19.5396"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E3EEFE" />
          <stop offset="1" stopColor="#ABCCFF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_568_358"
          x1="190.7"
          y1="81.0726"
          x2="212.211"
          y2="145.008"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8AB2EF" />
          <stop offset="1" stopColor="#3E73C5" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_568_358"
          x1="179.615"
          y1="137.193"
          x2="90.584"
          y2="86.1691"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#81ADEA" />
          <stop offset="0.9999" stopColor="#EAF2FF" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_568_358"
          x1="198.878"
          y1="70.9738"
          x2="115.251"
          y2="109.926"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0CCF2" />
          <stop offset="1" stopColor="#E0EAFA" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_568_358"
          x1="167.354"
          y1="94.7809"
          x2="135.251"
          y2="109.339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70A8FF" />
          <stop offset="1" stopColor="#5A86CC" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const RowCryptoCoins = (props: any) => {
  return (
    <Icon {...props} viewBox="0 0 62 24" fill="none">
      <rect x="38" width="24" height="24" rx="12" fill="#55C6A6" />
      <path
        d="M51.4644 10.4325V8.67613H55.4999V6H44.5112V8.67613H48.5471V10.4311C45.2671 10.581 42.8008 11.2276 42.8008 12.0021C42.8008 12.7766 45.2682 13.4232 48.5471 13.5741V19.2H51.4654V13.5736C54.7395 13.4232 57.2008 12.7771 57.2008 12.0033C57.2008 11.2295 54.7395 10.5834 51.4654 10.433L51.4644 10.4325ZM51.4654 13.0971V13.0956C51.383 13.1008 50.96 13.1261 50.0181 13.1261C49.2651 13.1261 48.7353 13.1049 48.5485 13.0952V13.0975C45.6507 12.9698 43.4876 12.4675 43.4876 11.8666C43.4876 11.2656 45.6509 10.764 48.5485 10.6361V12.5972C48.7383 12.6102 49.2812 12.642 50.0304 12.642C50.9303 12.642 51.3828 12.6047 51.4658 12.5972V10.6361C54.358 10.7643 56.5161 11.267 56.5161 11.8659C56.5161 12.4647 54.357 12.9677 51.4658 13.0959"
        fill="url(#paint0_linear_5977_15538)"
      />
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#6697FF"
      />
      <path
        d="M12.373 2.99805V9.65086L17.9958 12.1637L12.373 2.99805Z"
        fill="#F0F4FF"
      />
      <path
        d="M12.3747 2.99805L6.75195 12.1637L12.3747 9.65086V2.99805Z"
        fill="white"
      />
      <path
        d="M12.373 16.475V20.9955L17.9991 13.2109L12.373 16.475Z"
        fill="#F0F4FF"
      />
      <path
        d="M12.3747 20.9955V16.475L6.75195 13.2109L12.3747 20.9955Z"
        fill="white"
      />
      <path
        d="M12.373 15.4283L17.9958 12.1642L12.373 9.65137V15.4283Z"
        fill="#DCDFE8"
      />
      <path
        d="M6.75195 12.1642L12.3747 15.4283V9.65137L6.75195 12.1642Z"
        fill="#F0F4FF"
      />
      <g clipPath="url(#clip0_5977_15538)">
        <path
          d="M42.6403 14.9031C41.0375 21.3317 34.5264 25.2441 28.097 23.641C21.6703 22.0382 17.7579 15.5267 19.3614 9.09847C20.9634 2.6691 27.4745 -1.24365 33.902 0.359098C40.331 1.96185 44.243 8.4741 42.6403 14.9031Z"
          fill="#F7931A"
        />
        <path
          d="M36.292 10.2908C36.5309 8.69402 35.3152 7.83564 33.6528 7.26302L34.192 5.10002L32.8754 4.77189L32.3504 6.87789C32.0043 6.79164 31.6488 6.71027 31.2955 6.62964L31.8243 4.50977L30.5084 4.18164L29.9688 6.34389C29.6823 6.27864 29.401 6.21414 29.128 6.14627L29.1295 6.13952L27.3138 5.68614L26.9635 7.09239C26.9635 7.09239 27.9404 7.31627 27.9198 7.33014C28.453 7.46327 28.5494 7.81614 28.5333 8.09589L27.919 10.56C27.9558 10.5694 28.0034 10.5829 28.0559 10.6039C28.012 10.593 27.9652 10.581 27.9168 10.5694L27.0558 14.0213C26.9905 14.1833 26.8252 14.4263 26.4524 14.334C26.4655 14.3531 25.4954 14.0951 25.4954 14.0951L24.8418 15.6023L26.5552 16.0294C26.8739 16.1093 27.1863 16.1929 27.4938 16.2716L26.9489 18.4594L28.264 18.7875L28.8037 16.623C29.1629 16.7205 29.5117 16.8105 29.8529 16.8953L29.3152 19.0496L30.6318 19.3778L31.1767 17.1941C33.4218 17.619 35.11 17.4476 35.8207 15.417C36.3933 13.782 35.7922 12.8389 34.6109 12.2239C35.4712 12.0255 36.1192 11.4596 36.292 10.2908ZM33.2838 14.5091C32.8769 16.1441 30.124 15.2603 29.2315 15.0386L29.9545 12.1403C30.847 12.363 33.709 12.804 33.2838 14.5091ZM33.691 10.2671C33.3198 11.7544 31.0285 10.9988 30.2853 10.8135L30.9408 8.18477C31.684 8.37002 34.0777 8.71577 33.691 10.2671Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_5977_15538"
          x1="45.0508"
          y1="22.72"
          x2="56.8406"
          y2="5.74978"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <clipPath id="clip0_5977_15538">
          <rect width="24" height="24" fill="white" transform="translate(19)" />
        </clipPath>
      </defs>
    </Icon>
  );
};

export const CryptoCoins = (props) => {
  return (
    <Icon {...props} viewBox="0 0 45 40" fill="none">
      <rect x="21" width="24" height="24" rx="12" fill="#55C6A6" />
      <path
        d="M34.4644 10.4325V8.67613H38.4999V6H27.5112V8.67613H31.5471V10.4311C28.2671 10.581 25.8008 11.2276 25.8008 12.0021C25.8008 12.7766 28.2682 13.4232 31.5471 13.5741V19.2H34.4654V13.5736C37.7395 13.4232 40.2008 12.7771 40.2008 12.0033C40.2008 11.2295 37.7395 10.5834 34.4654 10.433L34.4644 10.4325ZM34.4654 13.0971V13.0956C34.383 13.1008 33.96 13.1261 33.0181 13.1261C32.2651 13.1261 31.7353 13.1049 31.5485 13.0952V13.0975C28.6507 12.9698 26.4876 12.4675 26.4876 11.8666C26.4876 11.2656 28.6509 10.764 31.5485 10.6361V12.5972C31.7383 12.6102 32.2812 12.642 33.0304 12.642C33.9303 12.642 34.3828 12.6047 34.4658 12.5972V10.6361C37.358 10.7643 39.5161 11.267 39.5161 11.8659C39.5161 12.4647 37.357 12.9677 34.4658 13.0959"
        fill="url(#paint0_linear_5980_15589)"
      />
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#6697FF"
      />
      <path
        d="M12.373 2.99805V9.65086L17.9958 12.1637L12.373 2.99805Z"
        fill="#F0F4FF"
      />
      <path
        d="M12.3747 2.99805L6.75195 12.1637L12.3747 9.65086V2.99805Z"
        fill="white"
      />
      <path
        d="M12.373 16.475V20.9955L17.9991 13.2109L12.373 16.475Z"
        fill="#F0F4FF"
      />
      <path
        d="M12.3747 20.9955V16.475L6.75195 13.2109L12.3747 20.9955Z"
        fill="white"
      />
      <path
        d="M12.373 15.4283L17.9958 12.1642L12.373 9.65137V15.4283Z"
        fill="#DCDFE8"
      />
      <path
        d="M6.75195 12.1642L12.3747 15.4283V9.65137L6.75195 12.1642Z"
        fill="#F0F4FF"
      />
      <g clipPath="url(#clip0_5980_15589)">
        <path
          d="M34.6403 30.9031C33.0375 37.3317 26.5264 41.2441 20.097 39.641C13.6703 38.0382 9.75788 31.5267 11.3614 25.0985C12.9634 18.6691 19.4745 14.7563 25.902 16.3591C32.331 17.9618 36.243 24.4741 34.6403 30.9031Z"
          fill="#F7931A"
        />
        <path
          d="M28.292 26.2908C28.5309 24.694 27.3152 23.8356 25.6528 23.263L26.192 21.1L24.8754 20.7719L24.3504 22.8779C24.0043 22.7916 23.6488 22.7103 23.2955 22.6296L23.8243 20.5098L22.5084 20.1816L21.9688 22.3439C21.6823 22.2786 21.401 22.2141 21.128 22.1463L21.1295 22.1395L19.3138 21.6861L18.9635 23.0924C18.9635 23.0924 19.9404 23.3163 19.9198 23.3301C20.453 23.4633 20.5494 23.8161 20.5333 24.0959L19.919 26.56C19.9558 26.5694 20.0034 26.5829 20.0559 26.6039C20.012 26.593 19.9652 26.581 19.9168 26.5694L19.0558 30.0213C18.9905 30.1833 18.8252 30.4263 18.4524 30.334C18.4655 30.3531 17.4954 30.0951 17.4954 30.0951L16.8418 31.6023L18.5552 32.0294C18.8739 32.1093 19.1863 32.1929 19.4938 32.2716L18.9489 34.4594L20.264 34.7875L20.8037 32.623C21.1629 32.7205 21.5117 32.8105 21.8529 32.8953L21.3152 35.0496L22.6318 35.3778L23.1767 33.1941C25.4218 33.619 27.11 33.4476 27.8207 31.417C28.3933 29.782 27.7922 28.8389 26.6109 28.2239C27.4712 28.0255 28.1192 27.4596 28.292 26.2908ZM25.2838 30.5091C24.8769 32.1441 22.124 31.2603 21.2315 31.0386L21.9545 28.1403C22.847 28.363 25.709 28.804 25.2838 30.5091ZM25.691 26.2671C25.3198 27.7544 23.0285 26.9988 22.2853 26.8135L22.9408 24.1848C23.684 24.37 26.0777 24.7158 25.691 26.2671Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_5980_15589"
          x1="28.0508"
          y1="22.72"
          x2="39.8406"
          y2="5.74978"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <clipPath id="clip0_5980_15589">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(11 16)"
          />
        </clipPath>
      </defs>
    </Icon>
  );
};
